var Z9 = Object.defineProperty;
var X9 = (e, t, r) => t in e ? Z9(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Jg = (e, t, r) => X9(e, typeof t != "symbol" ? t + "" : t, r);
import { jsx as D, jsxs as le, Fragment as Fr } from "react/jsx-runtime";
import * as ao from "react";
import na, { forwardRef as eb, createElement as b2, useMemo as ta, useContext as tx, useState as Gn, useEffect as En, createContext as nx, useCallback as b0, useRef as Wa, useImperativeHandle as Q9, useSyncExternalStore as J9 } from "react";
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $9 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), rx = (...e) => e.filter((t, r, o) => !!t && t.trim() !== "" && o.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var e7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t7 = eb(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: o,
    className: l = "",
    children: u,
    iconNode: d,
    ...f
  }, g) => b2(
    "svg",
    {
      ref: g,
      ...e7,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: o ? Number(r) * 24 / Number(t) : r,
      className: rx("lucide", l),
      ...f
    },
    [
      ...d.map(([h, v]) => b2(h, v)),
      ...Array.isArray(u) ? u : [u]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sn = (e, t) => {
  const r = eb(
    ({ className: o, ...l }, u) => b2(t7, {
      ref: u,
      iconNode: t,
      className: rx(`lucide-${$9(e)}`, o),
      ...l
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n7 = sn("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const r7 = sn("ArrowLeftRight", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const a7 = sn("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const i7 = sn("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o7 = sn("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ax = sn("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s7 = sn("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l7 = sn("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u7 = sn("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hS = sn("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pS = sn("Cylinder", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ix = sn("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tb = sn("FileDown", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c7 = sn("FileJson", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d7 = sn("FlagTriangleRight", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f7 = sn("Flag", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h7 = sn("FolderOpen", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const p7 = sn("House", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mS = sn("ImageDown", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _0 = sn("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m7 = sn("LayoutTemplate", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gS = sn("LockOpen", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vS = sn("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g7 = sn("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v7 = sn("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ox = sn("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const y7 = sn("MousePointer2", [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b7 = sn("MoveRight", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _7 = sn("Move", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S7 = sn("Pause", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const w7 = sn("Pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const H0 = sn("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nb = sn("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yS = sn("Redo2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const x7 = sn("Rows3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k7 = sn("Sailboat", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sx = sn("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C7 = sn("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E7 = sn("SkipBack", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R7 = sn("SkipForward", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T7 = sn("Square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lx = sn("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const N7 = sn("TextCursorInput", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const S0 = sn("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bS = sn("Undo2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A7 = sn("View", [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const M7 = sn("Wind", [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jc = sn("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const P7 = sn("ZoomIn", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]), Hc = (e) => `/${e}`, ux = {
  branding: {
    appName: "Sailing Plot Editor",
    shortName: "SailPlot",
    logo: Hc("icons/sailplot-logo-on-light.svg"),
    logoDark: Hc("icons/sailplot-logo-on-dark.svg"),
    compactLogo: Hc("icons/sailplot-icon.svg"),
    logoAlt: "SailPlot",
    favicon: "./icons/sailplot-icon.svg",
    logoAccentColor: null,
    partnerName: "Heisel Analytics",
    partnerLabel: "Powered by",
    partnerLogo: Hc("assets/heisel-analytics-logo-on-dark.png"),
    partnerLinks: null,
    exportWatermarkLogo: Hc("assets/heisel-analytics-logo-on-light.png"),
    exportWatermarkQr: Hc("assets/heiselanalytics-website-qr.svg"),
    exportProductLogo: Hc("icons/sailplot-logo-on-light.svg")
  },
  theme: {
    mode: "dark",
    usePrimaryForBrandAccents: !1,
    qrFinderColor: "#FFAA00",
    light: {
      primary: "#171717",
      primaryText: "#fafafa",
      accent: "#ffaa00",
      background: "#ffffff",
      surface: "#ffffff",
      sidebar: "#fafafa",
      secondary: "#f5f5f5",
      text: "#171717",
      muted: "#737373",
      border: "#e5e5e5",
      focusRing: "#a3a3a3"
    },
    dark: {
      primary: "#fafafa",
      primaryText: "#262626",
      accent: "#ffaa00",
      background: "#171717",
      surface: "#262626",
      sidebar: "#262626",
      secondary: "#404040",
      text: "#fafafa",
      muted: "#a3a3a3",
      border: "rgba(255, 255, 255, 0.1)",
      focusRing: "#737373"
    },
    fontFamily: null,
    headingFontFamily: null,
    borderRadius: null
  },
  texts: {
    welcomeTitle: "Sailing Plot Editor",
    welcomeText: "Create and share static sailing plots without a backend.",
    footerText: "Powered by Heisel Analytics",
    helpText: "Add boats, marks, lines and notes from the tool panel. Select an object to edit its properties. Use Player mode to replay numbered boat positions.",
    aboutText: "A new web-based implementation for creating static sailing and racing-rule diagrams. It is inspired by the historical BOATS application but is implemented from scratch and does not use the old application as a runtime dependency.",
    poweredByText: "Powered by SailPlot",
    exportPngDescription: "Exports the complete plot in high quality with a QR code that reopens this editable plot.",
    exportTransparentPngDescription: "Exports in high quality without the plot background while keeping the branding and plot QR code."
  },
  links: {
    app: "https://sailplot.app/",
    qrCode: null,
    support: null,
    website: "https://heiselanalytics.one/",
    privacy: null,
    imprint: "https://heiselanalytics.one/impressum",
    documentation: null
  },
  ui: {
    headerLogo: !0,
    footer: !0,
    canvasBrandingLinks: !0,
    poweredBySailPlot: !1,
    help: !0,
    about: !0,
    home: !1,
    newPlot: !0,
    openProjects: !0,
    export: !0
  },
  defaults: {
    language: "auto",
    startPage: "editor"
  },
  localization: {
    languageMode: "both",
    locales: { de: "de-CH", en: "en-GB" }
  },
  objectColors: {
    markColorMode: "sailplot",
    markCustomColor: null,
    startLineFlagColor: "#FF5E00"
  },
  pageTitle: "SailPlot.app",
  storageNamespace: "",
  routerBasename: ""
};
function Uf(e, t) {
  const r = e.trim().replace(/:+$/u, "");
  return r ? `${r}:${t}` : t;
}
const D7 = /#ffaa00/giu, cx = /^#[0-9a-f]{6}$/iu;
function L7(e, t) {
  return cx.test(t) ? e.replace(D7, t) : e;
}
async function O7(e, t, r) {
  if (!cx.test(t)) return e;
  const o = await fetch(e, { signal: r });
  if (!o.ok) throw new Error(`Could not load SailPlot logo: ${o.status}`);
  const l = await o.text();
  if (!/<svg(?:\s|>)/iu.test(l)) return e;
  const u = L7(l, t);
  return u === l ? e : `data:image/svg+xml;charset=utf-8,${encodeURIComponent(u)}`;
}
const _S = (e) => !!e && typeof e == "object" && !Array.isArray(e), dx = (e, t) => {
  const r = { ...e };
  for (const o of Object.keys(t)) {
    const l = t[o];
    if (l === void 0) continue;
    const u = e[o];
    r[o] = _S(u) && _S(l) ? dx(u, l) : l;
  }
  return r;
};
function F7(e = {}) {
  return dx(
    ux,
    e
  );
}
const fx = nx(null), _2 = ["logo", "logoDark", "compactLogo", "favicon", "exportProductLogo"], z7 = "data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22/%3E", B7 = Object.fromEntries(
  _2.map((e) => [e, z7])
);
function U7(e) {
  const t = e.theme.usePrimaryForBrandAccents ? e.theme.light.primary : e.branding.logoAccentColor, r = _2.map((d) => e.branding[d]), o = JSON.stringify([t, ...r]), [l, u] = Gn(null);
  return En(() => {
    if (!t) return;
    const d = new AbortController(), f = /* @__PURE__ */ new Map(), g = (h) => {
      const v = f.get(h);
      if (v) return v;
      const E = O7(h, t, d.signal).catch(
        () => h
      );
      return f.set(h, E), E;
    };
    return Promise.all(
      _2.map(async (h) => [h, await g(e.branding[h])])
    ).then((h) => {
      d.signal.aborted || u({ requestKey: o, assets: Object.fromEntries(h) });
    }), () => d.abort();
  }, [e, t, o]), ta(() => t ? {
    ...e,
    branding: {
      ...e.branding,
      ...(l == null ? void 0 : l.assets) ?? B7
    }
  } : e, [e, t, l]);
}
function I7({
  config: e,
  children: t
}) {
  const r = ta(() => F7(e), [e]), o = U7(r);
  return /* @__PURE__ */ D(fx.Provider, { value: o, children: t });
}
function Zo() {
  const e = tx(fx);
  if (!e)
    throw new Error("useSailPlotConfig must be used inside SailPlotConfigProvider");
  return e;
}
const H7 = {
  "Sailing Plot Editor": "Segelplot-Editor",
  Language: "Sprache",
  Menu: "Menü",
  "Licenses & Branding": "Lizenzen & Branding",
  "Suggest an improvement": "Verbesserungsvorschlag",
  "Suggest an Improvement": "Verbesserungsvorschlag",
  "Make your own SailPlot": "Dein eigenes SailPlot",
  "Make Your Own SailPlot": "Dein eigenes SailPlot",
  Instructions: "Anleitung",
  Changelog: "Changelog",
  "Open Source": "Open Source",
  English: "Englisch",
  German: "Deutsch",
  Scene: "Szene",
  "Show grid": "Raster anzeigen",
  "Show laylines": "Laylines anzeigen",
  Laylines: "Laylines",
  "Layline area": "Layline-Fläche",
  "Layline area color": "Farbe der Layline-Fläche",
  On: "An",
  Off: "Aus",
  "Show wind": "Wind anzeigen",
  "Show zones": "Zonen anzeigen",
  "Show boat numbers": "Bootsnummern anzeigen",
  "Boat legend": "Bootslegende",
  "Endless plot": "Endlos-Plot",
  "About Endless plot": "Informationen zum Endlos-Plot",
  "Return to the central plot position": "Zur zentralen Plot-Position zurückkehren",
  "Removes fixed plot edges. When enabled, the wind indicator and boat legend can be moved freely.": "Entfernt feste Plot-Ränder. Wenn aktiviert, lassen sich Windanzeige und Bootslegende frei verschieben.",
  "Plot background": "Plot-Hintergrund",
  Light: "Hell",
  Dark: "Dunkel",
  "Grid size": "Rastergröße",
  "Grid spacing": "Rasterabstand",
  "1 BL · {boatClass}": "1 BL · {boatClass}",
  "Grid visibility": "Rastersichtbarkeit",
  "Wind direction": "Windrichtung",
  "Layline angle": "Layline-Winkel",
  "Boat-length basis": "Bootslängen-Basis",
  "How BL is calculated": "So wird BL berechnet",
  Default: "Standard",
  "Default uses the longest sailing boat class in the plot. Committee, umpire and coach boats are excluded. Current basis: {boatClass}.": "Standard verwendet die längste Segelbootklasse im Plot. Committee-, Umpire- und Coachboote werden nicht berücksichtigt. Aktuelle Basis: {boatClass}.",
  "Largest boat class in plot": "Grösste Bootsklasse im Plot",
  "Selected basis": "Gewählte Basis",
  "Additional information": "Zusätzliche Informationen",
  "Wind strength": "Windstärke",
  "Wind strength (general)": "Windstärke (allgemein)",
  "Optional, e.g. 12 kn": "Optional, z. B. 12 kn",
  Value: "Wert",
  "Information name {number}": "Name der Information {number}",
  "Information value {number}": "Wert der Information {number}",
  "Remove information {number}": "Information {number} entfernen",
  "Add information": "Information hinzufügen",
  "No additional information.": "Keine zusätzlichen Informationen.",
  "{count} of 10": "{count} von 10",
  "Powered by Heisel Analytics": "Powered by Heisel Analytics",
  "Heisel Analytics links": "Links von Heisel Analytics",
  Information: "Information",
  Website: "Webseite",
  Imprint: "Impressum",
  "Legal Notice": "Impressum",
  "Operator Legal Notice": "Impressum des Betreibers",
  "Operator privacy": "Datenschutz des Betreibers",
  "Operator Privacy": "Datenschutz des Betreibers",
  "Open this plot": "Diesen Plot öffnen",
  "QR code for this plot": "QR-Code für diesen Plot",
  "Open menu": "Menü öffnen",
  "Duplicate into new tab": "In neuem Tab duplizieren",
  "Close dialog": "Dialog schließen",
  "{label} value": "Wert für {label}",
  "{label} slider": "Regler für {label}",
  "{label} degrees": "{label} in Grad",
  Projects: "Projekte",
  "Projects & templates": "Projekte & Vorlagen",
  New: "Neu",
  "Empty plot": "Leerer Plot",
  "Start with a clean canvas.": "Mit einer leeren Zeichenfläche beginnen.",
  "Port–starboard": "Backbord–Steuerbord",
  "Opposite-tack crossing under RRS 10.": "Kreuzung auf entgegengesetzten Schlägen nach RRS 10.",
  "Windward–leeward": "Luv–Lee",
  "Same-tack overlap under RRS 11.": "Überlappung auf gleichem Schlag nach RRS 11.",
  "Clear ahead/astern": "Klar voraus/achteraus",
  "Same-tack positions under RRS 12.": "Positionen auf gleichem Schlag nach RRS 12.",
  "Windward mark": "Luvmarke",
  "Static Rule 18 discussion example.": "Statisches Diskussionsbeispiel zu Regel 18.",
  "Start line": "Startlinie",
  "Finish line": "Ziellinie",
  Gate: "Gate",
  Buoy: "Tonne",
  Flag: "Flagge",
  Coachboat: "Coachboat",
  "Coachboat (reversed)": "Coachboat (rückwärts)",
  "Start-boat end": "Startschiff-Seite",
  "Pin end": "Pin-Ende",
  "{label} flag color": "{label}: Flaggenfarbe",
  "Sailing signal flag palette": "Signalflaggen-Palette",
  "Starting-line orange": "Startlinien-Orange",
  "Finishing-line blue": "Ziellinien-Blau",
  "Signal red": "Signalrot",
  "Signal yellow": "Signalgelb",
  "Signal green": "Signalgrün",
  "Signal black": "Signalschwarz",
  "Signal white": "Signalweiß",
  "Finish-boat end": "Zielschiff-Seite",
  "Outer end": "Äusseres Ende",
  Length: "Länge",
  "Angle to wind": "Winkel zum Wind",
  "Gate width": "Gate-Breite",
  "Start-line width": "Startlinienbreite",
  "Boats approaching a start line.": "Boote bei der Annäherung an eine Startlinie.",
  "Recent local projects": "Letzte lokale Projekte",
  "No saved projects yet. Create a plot above.": "Noch keine Projekte gespeichert. Oben kann ein Plot erstellt werden.",
  Duplicate: "Duplizieren",
  "{title} copy": "{title} – Kopie",
  Delete: "Löschen",
  "Delete “{title}” from this browser?": "„{title}“ aus diesem Browser löschen?",
  "Plot details": "Plotdetails",
  "Rename plot": "Plot umbenennen",
  "Saved in browser": "Im Browser gespeichert",
  Downloaded: "Heruntergeladen",
  "Not saved": "Nicht gespeichert",
  "Untitled plot": "Unbenannter Plot",
  Title: "Titel",
  "Clear title": "Titel leeren",
  Description: "Beschreibung",
  "Rule references": "Regelverweise",
  "For example 18 or 18.2(a)": "Zum Beispiel 18 oder 18.2(a)",
  "Remove rule reference {reference}": "Regelverweis {reference} entfernen",
  "{count} more rule references": "{count} weitere Regelverweise",
  "Separate references with commas, for example “RRS 10, RRS 18”.": "Regelverweise mit Kommas trennen, zum Beispiel „RRS 10, RRS 18“.",
  Done: "Fertig",
  "Help & information": "Hilfe und Informationen",
  Help: "Hilfe",
  Privacy: "Datenschutz",
  Terms: "Nutzungsbedingungen",
  "Terms of service": "Nutzungsbedingungen",
  "Terms of Service": "Nutzungsbedingungen",
  "Subscription & invoices": "Abonnement & Rechnungen",
  "Subscription & Invoices": "Abonnement & Rechnungen",
  "Cancel Contract": "Vertrag kündigen",
  "Withdraw from Contract": "Vertrag widerrufen",
  "SailPlot privacy": "SailPlot-Datenschutz",
  "SailPlot Privacy": "SailPlot-Datenschutz",
  "Refund Policy": "Rückerstattungsrichtlinie",
  "SailPlot Legal Notice": "SailPlot-Impressum",
  About: "Über",
  License: "Lizenz",
  "Build a static sailing explanation": "Eine statische Segelerklärung erstellen",
  "Add boats, marks, lines and notes from the tool panel. Select an object to edit its properties. Use Player mode to replay numbered boat positions.": "Füge Boote, Marken, Linien und Notizen über die Werkzeugleiste hinzu. Wähle ein Objekt aus, um seine Eigenschaften zu bearbeiten. Im Player-Modus werden nummerierte Bootspositionen wiedergegeben.",
  "The Boat tool stays active: each tap adds the next numbered position to the current boat chain. To continue an existing chain, select one of its boats and then choose Boat. Choose Select or another tool when the chain is complete.": "Das Boot-Werkzeug bleibt aktiv: Jede Berührung fügt der aktuellen Bootskette die nächste nummerierte Position hinzu. Um eine bestehende Kette fortzusetzen, wähle eines ihrer Boote und danach „Boot“. Wähle „Auswählen“ oder ein anderes Werkzeug, wenn die Kette vollständig ist.",
  "Mouse and keyboard": "Maus und Tastatur",
  "Scroll to zoom. Choose Pan or hold Space to move the view. Shift-click adds objects to a selection. Use Delete, arrow keys, ⌘/Ctrl+Z, ⌘/Ctrl+Shift+Z and ⌘/Ctrl+D.": "Scrolle zum Zoomen. Wähle „Verschieben“ oder halte die Leertaste gedrückt, um die Ansicht zu bewegen. Umschalt-Klick erweitert die Auswahl. Verwende Löschen, die Pfeiltasten, ⌘/Strg+Z, ⌘/Strg+Umschalt+Z und ⌘/Strg+D.",
  "Touch and stylus": "Touch und Stift",
  "Tap to select and drag objects to move them. Drag drawing tools directly, or click twice to set start and end. Rectangle uses opposite corners; circle uses a centre and outer point. Drawing tools accept mouse, finger and stylus input.": "Tippe zum Auswählen und ziehe Objekte, um sie zu verschieben. Ziehe Zeichenwerkzeuge direkt auf oder klicke zweimal für Start und Ende. Das Rechteck verwendet gegenüberliegende Ecken; der Kreis verwendet Mittelpunkt und Aussenpunkt. Zeichenwerkzeuge unterstützen Maus, Finger und Stift.",
  Sharing: "Teilen",
  "Share links contain a compressed copy of the complete project in the URL fragment. For large projects, export a JSON file instead.": "Freigabelinks enthalten eine komprimierte Kopie des vollständigen Projekts im URL-Fragment. Exportiere bei großen Projekten stattdessen eine JSON-Datei.",
  "Local-first privacy": "Lokaler Datenschutz",
  "Projects and preferences are stored locally in this browser using IndexedDB. JSON and image exports are created on your device. No project data is uploaded to a server.": "Projekte und Einstellungen werden mit IndexedDB lokal in diesem Browser gespeichert. JSON- und Bildexporte entstehen auf deinem Gerät. Es werden keine Projektdaten auf einen Server hochgeladen.",
  "A share link contains the project data itself. Anyone who receives that link can access the plot embedded in it.": "Ein Freigabelink enthält die Projektdaten selbst. Jede Person mit diesem Link kann auf den darin eingebetteten Plot zugreifen.",
  "A new web-based implementation for creating static sailing and racing-rule diagrams. It is inspired by the historical BOATS application but is implemented from scratch and does not use the old application as a runtime dependency.": "Eine neue webbasierte Anwendung zum Erstellen statischer Segel- und Regeldiagramme. Sie ist von der historischen BOATS-Anwendung inspiriert, wurde jedoch vollständig neu entwickelt und verwendet die alte Anwendung nicht als Laufzeitabhängigkeit.",
  "Powered by Heisel Analytics.": "Powered by Heisel Analytics.",
  "GNU General Public License v3": "GNU General Public License v3",
  "This project is free software distributed under the GNU GPL v3. See the repository’s LICENSE file for the complete terms.": "Dieses Projekt ist freie Software unter der GNU GPL v3. Die vollständigen Bedingungen stehen in der LICENSE-Datei des Repositorys.",
  "Export & share": "Exportieren und teilen",
  "Export / Share": "Exportieren / Teilen",
  "Plot JSON": "Plot-JSON",
  "About Plot JSON": "Informationen zu Plot-JSON",
  "Best for editing later or transferring a plot between browsers.": "Ideal zur späteren Bearbeitung oder zum Übertragen eines Plots zwischen Browsern.",
  "Editable, validated project file": "Bearbeitbare, validierte Projektdatei",
  "Download JSON": "JSON herunterladen",
  "PNG image": "PNG-Bild",
  "About PNG image": "Informationen zum PNG-Bild",
  "Download PNG": "PNG herunterladen",
  "Exports the complete plot in high quality with a QR code that reopens this editable plot.": "Exportiert den vollständigen Plot in hoher Qualität mit einem QR-Code, der diesen bearbeitbaren Plot wieder öffnet.",
  "Static image without editor handles": "Statisches Bild ohne Editor-Griffe",
  "Transparent PNG": "Transparentes PNG",
  "About Transparent PNG": "Informationen zum transparenten PNG",
  "Download transparent PNG": "Transparentes PNG herunterladen",
  "Exports in high quality without the plot background while keeping the branding and plot QR code.": "Exportiert in hoher Qualität ohne Plot-Hintergrund und behält Branding und Plot-QR-Code bei.",
  "Canvas objects without a background": "Objekte der Zeichenfläche ohne Hintergrund",
  "Animated GIF": "Animiertes GIF",
  "Dynamic exports": "Dynamische Exporte",
  "GIF and MP4 use the speed and boat-tail setting from the Player.": "GIF und MP4 verwenden die Geschwindigkeit und Bootsspuren-Einstellung aus dem Player.",
  "Open Player exports": "Player-Exporte öffnen",
  "Export animation": "Animation exportieren",
  "Player exports": "Player-Exporte",
  "Speed {speed}× · Boat tails {tails}": "Geschwindigkeit {speed}× · Bootsspuren {tails}",
  "About animated GIF": "Informationen zum animierten GIF",
  "Exports the complete Player sequence as a looping GIF. The transparent variant omits the plot background.": "Exportiert den vollständigen Player-Ablauf als wiederholtes GIF. Bei der transparenten Variante entfällt der Plot-Hintergrund.",
  "Looping animation · standard or transparent": "Wiederholte Animation · normal oder transparent",
  "Add at least two positions to a boat first": "Füge einem Boot zuerst mindestens zwei Positionen hinzu",
  "GIF format": "GIF-Format",
  "Download GIF": "GIF herunterladen",
  "Transparent GIF": "Transparentes GIF",
  "MP4 video": "MP4-Video",
  "About MP4 video": "Informationen zum MP4-Video",
  "Exports the complete Player sequence as a high-quality MP4 video.": "Exportiert den vollständigen Player-Ablauf als hochwertiges MP4-Video.",
  "Smooth video with plot background": "Flüssiges Video mit Plot-Hintergrund",
  "Download MP4": "MP4 herunterladen",
  "Exporting {progress}%": "Export wird erstellt: {progress} %",
  "MP4 export is not supported by this browser": "Dieser Browser unterstützt den MP4-Export nicht",
  "Exported MP4 video": "MP4-Video exportiert",
  "Exported animated GIF": "Animiertes GIF exportiert",
  "Could not export animation": "Animation konnte nicht exportiert werden",
  "Could not render an animation frame": "Animationsframe konnte nicht gerendert werden",
  "Could not prepare the animation export": "Animationsexport konnte nicht vorbereitet werden",
  "Could not finalize the MP4 export": "MP4-Export konnte nicht abgeschlossen werden",
  "Share link": "Freigabelink",
  "About Share link": "Informationen zum Freigabelink",
  "Copies a URL containing the complete editable plot. No upload is required.": "Kopiert eine URL mit dem vollständigen bearbeitbaren Plot. Es ist kein Upload erforderlich.",
  "Copy URL with project": "URL mit Projekt kopieren",
  Copied: "Kopiert",
  "{count} characters · project stays in the URL": "{count} Zeichen · das Projekt bleibt in der URL",
  "PDF document": "PDF-Dokument",
  "About PDF document": "Informationen zum PDF-Dokument",
  "Downloads the plot directly as an A4 landscape PDF.": "Lädt den Plot direkt als PDF im A4-Querformat herunter.",
  "Download PDF": "PDF herunterladen",
  "A4 landscape with a clickable plot QR watermark": "A4-Querformat mit klickbarem Plot-QR-Wasserzeichen",
  "Unavailable with Endless plot. Turn it off in Scene settings to export an A4 PDF.": "Mit Endlos-Plot nicht verfügbar. Deaktiviere ihn in den Szenen-Einstellungen, um ein A4-PDF zu exportieren.",
  "PDF export is unavailable while Endless plot is enabled": "Der PDF-Export ist nicht verfügbar, solange Endlos-Plot aktiviert ist",
  "This link is long and may not work in every app. Prefer JSON export for this project.": "Dieser Link ist lang und funktioniert möglicherweise nicht in jeder App. Für dieses Projekt ist der JSON-Export vorzuziehen.",
  "Open projects": "Projekte öffnen",
  "Open projects & templates": "Projekte & Vorlagen öffnen",
  "Back to editor": "Zurück zum Editor",
  Download: "Herunterladen",
  Share: "Teilen",
  "Import JSON": "JSON importieren",
  "Delete all": "Alle löschen",
  "Export and share": "Exportieren und teilen",
  Undo: "Rückgängig",
  Redo: "Wiederholen",
  "Fit canvas": "Zeichenfläche einpassen",
  "Use light mode": "Hellen Modus verwenden",
  "Use dark mode": "Dunklen Modus verwenden",
  "Layout preference": "Layout-Einstellung",
  View: "Ansicht",
  "Auto layout": "Automatisches Layout",
  "Compact layout": "Kompaktes Layout",
  "Desktop layout": "Desktop-Layout",
  Create: "Erstellen",
  Tools: "Werkzeuge",
  "Return to Select": "Zu „Auswählen“ zurückkehren",
  "Delete selection": "Auswahl löschen",
  "Scene settings": "Szenen-Einstellungen",
  "History controls": "Verlaufssteuerung",
  "Player mode": "Player-Modus",
  Player: "Player",
  "Player controls": "Player-Steuerung",
  "Playback controls": "Wiedergabesteuerung",
  "Previous position": "Vorherige Position",
  "Next position": "Nächste Position",
  Play: "Abspielen",
  Pause: "Pause",
  "Playback timeline": "Wiedergabe-Zeitleiste",
  Speed: "Geschwindigkeit",
  "Playback speed": "Wiedergabegeschwindigkeit",
  "Boat tails": "Bootsspuren",
  "Position {position} of {count}": "Position {position} von {count}",
  "Position {from} → {to} of {count}": "Position {from} → {to} von {count}",
  "{count} objects · {zoom}%": "{count} Objekte · {zoom} %",
  Select: "Auswählen",
  Pan: "Verschieben",
  Boat: "Boot",
  Mark: "Marke",
  Line: "Linie",
  Arrow: "Pfeil",
  Freehand: "Freihand",
  Text: "Text",
  Rectangle: "Rechteck",
  Circle: "Kreis",
  "Editor tools": "Editor-Werkzeuge",
  "Boat class": "Bootsklasse",
  Name: "Name",
  "Sail no.": "Segelnummer",
  Heading: "Kurs",
  "Heading slider": "Kursregler",
  "Hull color": "Rumpffarbe",
  Fixed: "Fest",
  Sails: "Segel",
  Mainsail: "Großsegel",
  Jib: "Fock",
  Genoa: "Genua",
  Spinnaker: "Spinnaker",
  Gennaker: "Gennaker",
  Luffing: "Flattert",
  "No sails for this boat class.": "Diese Bootsklasse hat keine Segel.",
  Positioning: "Positionierung",
  "Automatic with trim": "Automatisch mit Trimm",
  "Manual mainsail angle": "Manueller Großsegelwinkel",
  "Mark number": "Markennummer",
  "Mark type": "Markentyp",
  "Racing mark": "Bahnmarke",
  "Starting mark": "Startmarke",
  "Finish mark": "Zielmarke",
  Shape: "Form",
  "Round buoy": "Runde Boje",
  "Cylindrical buoy": "Zylindrische Boje",
  "Inflatable buoy": "Aufblasbare Boje",
  "Flag buoy": "Flaggenboje",
  "Gate mark": "Tormarke",
  "Pin-end mark": "Pin-End-Marke",
  "Mark color": "Markenfarbe",
  "Zone radius": "Zonenradius",
  "Zone radius in boat lengths": "Zonenradius in Bootslängen",
  "Default basis": "Standardbasis",
  "Longest class": "Längste Klasse",
  "Show zone": "Zone anzeigen",
  "Hide zone": "Zone ausblenden",
  Zone: "Zone",
  "Mark orientation": "Markenausrichtung",
  Windward: "Luv",
  Neutral: "Neutral",
  Leeward: "Lee",
  "Neutral without laylines": "Neutral ohne Laylines",
  "Leeward mark": "Leemarke",
  "Downwind mark": "Leemarke",
  "Lee mark": "Leemarke",
  "No selection": "Keine Auswahl",
  "Select an object on the canvas to edit its properties.": "Wähle ein Objekt auf der Zeichenfläche aus, um seine Eigenschaften zu bearbeiten.",
  Selection: "Auswahl",
  "{count} objects": "{count} Objekte",
  "Move, duplicate, layer, lock or remove the selection together.": "Die Auswahl gemeinsam verschieben, duplizieren, anordnen, sperren oder entfernen.",
  Unlock: "Entsperren",
  Lock: "Sperren",
  Forward: "Nach vorne",
  Backward: "Nach hinten",
  "Layer order": "Ebenenreihenfolge",
  Properties: "Eigenschaften",
  "Expand properties": "Eigenschaften öffnen",
  "Collapse properties": "Eigenschaften schließen",
  "Mark {number}": "Marke {number}",
  "Object information": "Objektinformationen",
  Position: "Position",
  Tack: "Bug",
  Port: "Backbord",
  None: "Keine",
  Starboard: "Steuerbord",
  "Overlap line": "Überlappungslinie",
  "Red protest flag": "Rote Protestflagge",
  "Yes left": "Ja links",
  No: "Nein",
  "Yes right": "Ja rechts",
  "Font size": "Schriftgröße",
  "Text color": "Textfarbe",
  "Stroke width": "Linienstärke",
  "Stroke color": "Linienfarbe",
  "Fill color": "Füllfarbe",
  "No fill": "Keine Füllung",
  Opacity: "Deckkraft",
  Palette: "Palette",
  Recent: "Zuletzt verwendet",
  "Custom color": "Eigene Farbe",
  "Open {label} selector": "{label}-Farbauswahl öffnen",
  "{label} colors": "Farben für {label}",
  "Heisel sailing palette": "Heisel-Segelpalette",
  "Heisel dark sailing palette": "Heisel-Segelpalette für dunklen Plot",
  "Recently used colors": "Zuletzt verwendete Farben",
  "{label} custom color": "Eigene Farbe für {label}",
  "Use {source} color {description}": "Farbe {description} aus {source} verwenden",
  palette: "der Palette",
  recent: "den zuletzt verwendeten Farben",
  "custom color": "eigene Farbe",
  "palette color": "Palettenfarbe",
  "recent color": "zuletzt verwendete Farbe",
  "Sailing plot canvas": "Zeichenfläche für Segelplots",
  "BOAT LEGEND": "BOOTLEGENDE",
  "WIND FROM": "WIND AUS",
  Annotation: "Beschriftung",
  "Generic keelboat": "Allgemeines Kielboot",
  "Generic dinghy": "Allgemeine Jolle",
  "Generic catamaran": "Allgemeiner Katamaran",
  "Generic skiff": "Allgemeiner Skiff",
  Windsurf: "Windsurf",
  "Manual primary sail angle": "Manueller Winkel des Hauptsegels",
  "Fixed support boat hull color": "Feste Rumpffarbe des Begleitboots",
  "Committee boat": "Startschiff",
  "Umpire boat": "Umpireboot",
  "Committee boat (reversed)": "Startschiff (umgekehrt)",
  "Umpire flags": "Umpire-Flaggen",
  "Boat identification flag": "Bootskennflagge",
  "Umpire signal": "Umpire-Signal",
  "No flag": "Keine Flagge",
  "Protest flag (Y)": "Protestflagge (Y)",
  "Red (penalty)": "Rot (Strafe)",
  "Green and white (no penalty)": "Grün-Weiß (keine Strafe)",
  Yellow: "Gelb",
  Blue: "Blau",
  "Black (DSQ)": "Schwarz (DSQ)",
  "Stored boat color": "Gespeicherte Bootsfarbe",
  "Windward mark rounding": "Rundung der Luvmarke",
  "A static visual example for discussing Rule 18.": "Ein statisches Beispiel zur Besprechung von Regel 18.",
  "A static visual example for discussing a mark-rounding situation.": "Ein statisches Beispiel zur Besprechung einer Markenrundung.",
  "Start-line situation": "Startliniensituation",
  "Static positions for discussing a start-line situation.": "Statische Positionen zur Besprechung einer Startliniensituation.",
  "Port–starboard crossing": "Backbord–Steuerbord-Kreuzung",
  "Two boats on opposite tacks approaching a crossing situation.": "Zwei Boote auf entgegengesetzten Schlägen vor einer Kreuzungssituation.",
  "Windward–leeward overlap": "Luv–Lee-Überlappung",
  "Two overlapped boats on the same tack.": "Zwei überlappende Boote auf gleichem Schlag.",
  "Clear ahead and clear astern": "Klar voraus und klar achteraus",
  "Two boats on the same tack, one clear ahead of the other.": "Zwei Boote auf gleichem Schlag, eines klar voraus.",
  "Static positions approaching a start line. No rule decision is implied.": "Statische Positionen bei der Annäherung an eine Startlinie. Es wird keine Regelentscheidung vorweggenommen.",
  "Midnight navy": "Mitternachtsblau",
  "Glacier blue": "Gletscherblau",
  "Clear blue": "Klarblau",
  "Sea glass": "Meerglas",
  Sage: "Salbeigrün",
  "Dusty rose": "Altrosa",
  "Warm copper": "Warmes Kupfer",
  Silver: "Silber",
  "Alpine blue": "Alpenblau",
  "Deep teal": "Dunkles Türkis",
  "Forest green": "Waldgrün",
  Burgundy: "Burgunder",
  Copper: "Kupfer",
  Slate: "Schiefer",
  "Heisel amber": "Heisel-Orange",
  Ready: "Bereit",
  "Plot opened": "Plot geöffnet",
  "Opened shared plot": "Geteilten Plot geöffnet",
  "Could not open the shared plot": "Der geteilte Plot konnte nicht geöffnet werden",
  "Created plot": "Plot erstellt",
  "Added boat": "Boot hinzugefügt",
  "Added mark": "Marke hinzugefügt",
  "Added downwind mark": "Leemarke hinzugefügt",
  "Added gate": "Gate hinzugefügt",
  "Added start line": "Startlinie hinzugefügt",
  "Added finish line": "Ziellinie hinzugefügt",
  "Added text": "Text hinzugefügt",
  "Added line": "Linie hinzugefügt",
  "Added arrow": "Pfeil hinzugefügt",
  "Added freehand": "Freihandzeichnung hinzugefügt",
  "Added rectangle": "Rechteck hinzugefügt",
  "Added circle": "Kreis hinzugefügt",
  "Moved boat": "Boot verschoben",
  "Moved mark": "Marke verschoben",
  "Moved gate": "Gate verschoben",
  "Moved start-line": "Startlinie verschoben",
  "Moved finish-line": "Ziellinie verschoben",
  "Moved finish-line endpoint": "Endpunkt der Ziellinie verschoben",
  "Moved text": "Text verschoben",
  "Moved rectangle": "Rechteck verschoben",
  "Resized rectangle": "Rechteckgröße geändert",
  "Moved circle": "Kreis verschoben",
  "Resized circle": "Kreisgröße geändert",
  "Transformed boat": "Boot gedreht",
  "Transformed mark": "Marke gedreht",
  "Transformed gate": "Gate gedreht",
  "Transformed start-line": "Startlinie gedreht",
  "Transformed finish-line": "Ziellinie gedreht",
  "Transformed text": "Text gedreht",
  "Updated boat": "Boot aktualisiert",
  "Updated mark": "Marke aktualisiert",
  "Updated start-line": "Startlinie aktualisiert",
  "Updated finish-line": "Ziellinie aktualisiert",
  "Updated text": "Text aktualisiert",
  "Updated line": "Linie aktualisiert",
  "Updated arrow": "Pfeil aktualisiert",
  "Updated freehand": "Freihandzeichnung aktualisiert",
  "Updated rectangle": "Rechteck aktualisiert",
  "Updated circle": "Kreis aktualisiert",
  "Updated objects": "Objekte aktualisiert",
  "Duplicated selection": "Auswahl dupliziert",
  "Added static boat position": "Statische Bootsposition hinzugefügt",
  "Changed layer order": "Ebenenreihenfolge geändert",
  "Unlocked selection": "Auswahl entsperrt",
  "Locked selection": "Auswahl gesperrt",
  "Nudged selection": "Auswahl verschoben",
  "Exported plot JSON": "Plot-JSON exportiert",
  "Exported PNG image": "PNG-Bild exportiert",
  "Could not export PNG image": "PNG-Bild konnte nicht exportiert werden",
  "Static sailing plot": "Statischer Segelplot",
  "Opened share sheet": "Teilen-Dialog geöffnet",
  "Share link copied": "Freigabelink kopiert",
  "Downloaded PDF": "PDF heruntergeladen",
  "Could not export PDF": "PDF konnte nicht exportiert werden",
  "Could not prepare the PDF download": "PDF-Download konnte nicht vorbereitet werden",
  "Could not share; copy the address from your browser.": "Teilen fehlgeschlagen; kopiere die Adresse aus dem Browser.",
  "Unsupported file type. Choose a plot JSON file.": "Nicht unterstützter Dateityp. Wähle eine Plot-JSON-Datei.",
  "Imported plot JSON": "Plot-JSON importiert",
  "Could not import this file": "Diese Datei konnte nicht importiert werden",
  "Restored local work": "Lokalen Arbeitsstand wiederhergestellt",
  "Local storage is unavailable; work remains in this tab.": "Der lokale Speicher ist nicht verfügbar; die Arbeit bleibt in diesem Tab erhalten.",
  "Saved locally": "Lokal gespeichert",
  "Could not autosave locally": "Lokales automatisches Speichern fehlgeschlagen",
  "The share link contains invalid characters.": "Der Freigabelink enthält ungültige Zeichen.",
  "The share link is invalid or damaged.": "Der Freigabelink ist ungültig oder beschädigt.",
  "This file does not contain valid JSON.": "Diese Datei enthält kein gültiges JSON.",
  "The plot format version is missing.": "Die Version des Plotformats fehlt."
};
function S2(e, t, r = {}) {
  const o = e === "de" ? H7[t] ?? t : t;
  return Object.entries(r).reduce(
    (l, [u, d]) => l.replaceAll(`{${u}}`, String(d)),
    o
  );
}
function w2(e, t) {
  if (e === "en") return t;
  if (t.startsWith("Undid: "))
    return `Rückgängig: ${w2(e, t.slice(7))}`;
  if (t.startsWith("Redid: "))
    return `Wiederholt: ${w2(e, t.slice(7))}`;
  const r = /^Deleted (\d+) objects?$/.exec(t);
  return r ? `${r[1]} ${r[1] === "1" ? "Objekt" : "Objekte"} gelöscht` : S2(e, t);
}
const hx = nx(null), px = "sailing-language";
function G7(e, t, r) {
  return e.localization.languageMode !== "both" ? e.localization.languageMode : t === "de" || t === "en" ? t : "en";
}
const V7 = (e) => {
  const t = window.localStorage.getItem(
    Uf(e.storageNamespace, px)
  );
  return G7(e, t);
};
function q7({ children: e }) {
  const t = Zo(), [r, o] = Gn(() => V7(t)), l = t.localization.languageMode, u = b0(
    (f) => o(l === "both" ? f : l),
    [l]
  );
  En(() => {
    l !== "both" && o(l);
  }, [l]), En(() => {
    window.localStorage.setItem(
      Uf(t.storageNamespace, px),
      r
    ), document.documentElement.lang = r, document.title = t.pageTitle === ux.pageTitle ? S2(r, t.pageTitle) : t.pageTitle;
  }, [t.pageTitle, t.storageNamespace, r]);
  const d = ta(
    () => ({
      language: r,
      setLanguage: u,
      t: (f, g) => S2(r, f, g),
      status: (f) => w2(r, f),
      locale: t.localization.locales[r]
    }),
    [t.localization.locales, r, u]
  );
  return /* @__PURE__ */ D(hx.Provider, { value: d, children: e });
}
function jn() {
  const e = tx(hx);
  if (!e) throw new Error("useI18n must be used inside I18nProvider");
  return e;
}
function mx({
  items: e,
  context: t
}) {
  const { language: r, setLanguage: o, t: l } = jn(), [u, d] = Gn(!1), f = Wa(null), g = t.config.localization.languageMode === "both";
  return En(() => d(!1), [t.currentPath]), En(() => {
    if (!u) return;
    const h = (E) => {
      var S;
      (S = f.current) != null && S.contains(E.target) || d(!1);
    }, v = (E) => {
      E.key === "Escape" && d(!1);
    };
    return document.addEventListener("pointerdown", h), document.addEventListener("keydown", v), () => {
      document.removeEventListener("pointerdown", h), document.removeEventListener("keydown", v);
    };
  }, [u]), !e.length && !g ? null : /* @__PURE__ */ le(
    "nav",
    {
      ref: f,
      className: `sailplot-navigation sailplot-menu ${e.length ? "" : "sailplot-menu--language-only"}`,
      "aria-label": l("Navigation"),
      children: [
        /* @__PURE__ */ le(
          "button",
          {
            type: "button",
            className: "sailplot-menu-trigger",
            "aria-haspopup": "menu",
            "aria-expanded": u,
            "aria-label": l("Menu"),
            onClick: () => d((h) => !h),
            children: [
              /* @__PURE__ */ D(g7, { "aria-hidden": "true" }),
              /* @__PURE__ */ D("span", { children: l("Menu") })
            ]
          }
        ),
        u && /* @__PURE__ */ le("div", { className: "sailplot-menu-popover", role: "menu", children: [
          e.map((h) => {
            const v = [
              h.separatorBefore ? "sailplot-menu-item--separator" : "",
              h.muted ? "sailplot-menu-item--muted" : "",
              h.version ? "sailplot-menu-item--version" : ""
            ].filter(Boolean).join(" ");
            return h.href ? /* @__PURE__ */ D(
              "a",
              {
                className: v || void 0,
                href: h.href,
                target: h.external ? "_blank" : void 0,
                rel: h.external ? "noopener noreferrer" : void 0,
                role: "menuitem",
                onClick: () => d(!1),
                children: l(h.label)
              },
              h.id
            ) : /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                className: v || void 0,
                role: "menuitem",
                onClick: () => {
                  d(!1), t.navigate(h.path ?? "/");
                },
                children: l(h.label)
              },
              h.id
            );
          }),
          g && /* @__PURE__ */ le("div", { className: "sailplot-menu-language", role: "group", "aria-label": l("Language"), children: [
            /* @__PURE__ */ D("span", { children: l("Language") }),
            /* @__PURE__ */ D("div", { className: "sailplot-menu-language-options", children: ["de", "en"].map((h) => /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                role: "menuitemradio",
                "aria-checked": r === h,
                className: r === h ? "is-active" : "",
                "aria-label": h === "de" ? "Deutsch" : "English",
                onClick: () => {
                  o(h), d(!1);
                },
                children: h.toUpperCase()
              },
              h
            )) })
          ] })
        ] })
      ]
    }
  );
}
function pr({
  icon: e,
  label: t,
  compact: r,
  active: o,
  className: l = "",
  ...u
}) {
  return /* @__PURE__ */ le(
    "button",
    {
      type: "button",
      className: `icon-button ${r ? "icon-button--compact" : ""} ${o ? "is-active" : ""} ${l}`,
      "aria-label": t,
      title: t,
      "aria-pressed": o === void 0 ? void 0 : o,
      ...u,
      children: [
        e,
        !r && /* @__PURE__ */ D("span", { children: t })
      ]
    }
  );
}
function W7(e) {
  return e.theme.usePrimaryForBrandAccents ? e.theme.light.primary : e.theme.light.accent;
}
function rb(e) {
  return e.theme.qrFinderColor ?? e.theme.light.primary;
}
function gx(e, t) {
  const r = t.theme.usePrimaryForBrandAccents ? e.primary : e.accent, o = t.theme.usePrimaryForBrandAccents ? e.primaryText : "#171717", l = `color-mix(in srgb, ${r} 78%, ${o})`;
  return {
    "--background": e.background,
    "--foreground": e.text,
    "--panel": e.surface,
    "--sidebar": e.sidebar,
    "--secondary": e.secondary,
    "--muted": e.muted,
    "--border": e.border,
    "--ring": e.focusRing,
    "--highlight": r,
    "--highlight-text": o,
    "--highlight-hover": l,
    "--interactive-accent": l,
    "--interactive-hover": `color-mix(in srgb, ${l}, transparent 72%)`,
    "--interactive-hover-strong": `color-mix(in srgb, ${l}, transparent 62%)`,
    "--interactive-hover-subtle": `color-mix(in srgb, ${l}, transparent 78%)`,
    "--button": e.primary,
    "--button-text": e.primaryText,
    "--button-hover": `color-mix(in srgb, ${e.primary} 70%, ${e.primaryText})`,
    ...t.theme.fontFamily ? { "--font-body": t.theme.fontFamily } : {},
    ...t.theme.headingFontFamily ? { "--font-heading": t.theme.headingFontFamily } : {},
    ...t.theme.borderRadius ? { "--radius": t.theme.borderRadius } : {}
  };
}
/*! pako 2.2.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
const K7 = 4, SS = 0, wS = 1, j7 = 2;
function If(e) {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}
const Y7 = 0, vx = 1, Z7 = 2, X7 = 3, Q7 = 258, ab = 29, hm = 256, em = hm + 1 + ab, Tf = 30, ib = 19, yx = 2 * em + 1, Zc = 15, hy = 16, J7 = 7, ob = 256, bx = 16, _x = 17, Sx = 18, x2 = (
  /* extra bits for each length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0])
), f0 = (
  /* extra bits for each distance code */
  new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13])
), $7 = (
  /* extra bits for each bit length code */
  new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7])
), wx = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), eE = 512, Yl = new Array((em + 2) * 2);
If(Yl);
const Kp = new Array(Tf * 2);
If(Kp);
const tm = new Array(eE);
If(tm);
const nm = new Array(Q7 - X7 + 1);
If(nm);
const sb = new Array(ab);
If(sb);
const w0 = new Array(Tf);
If(w0);
function py(e, t, r, o, l) {
  this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = o, this.max_length = l, this.has_stree = e && e.length;
}
let xx, kx, Cx;
function my(e, t) {
  this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
const Ex = (e) => e < 256 ? tm[e] : tm[256 + (e >>> 7)], rm = (e, t) => {
  e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, io = (e, t, r) => {
  e.bi_valid > hy - r ? (e.bi_buf |= t << e.bi_valid & 65535, rm(e, e.bi_buf), e.bi_buf = t >> hy - e.bi_valid, e.bi_valid += r - hy) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
}, ul = (e, t, r) => {
  io(
    e,
    r[t * 2],
    r[t * 2 + 1]
    /*.Len*/
  );
}, Rx = (e, t) => {
  let r = 0;
  do
    r |= e & 1, e >>>= 1, r <<= 1;
  while (--t > 0);
  return r >>> 1;
}, tE = (e) => {
  e.bi_valid === 16 ? (rm(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, nE = (e, t) => {
  const r = t.dyn_tree, o = t.max_code, l = t.stat_desc.static_tree, u = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, f = t.stat_desc.extra_base, g = t.stat_desc.max_length;
  let h, v, E, S, w, T, P = 0;
  for (S = 0; S <= Zc; S++)
    e.bl_count[S] = 0;
  for (r[e.heap[e.heap_max] * 2 + 1] = 0, h = e.heap_max + 1; h < yx; h++)
    v = e.heap[h], S = r[r[v * 2 + 1] * 2 + 1] + 1, S > g && (S = g, P++), r[v * 2 + 1] = S, !(v > o) && (e.bl_count[S]++, w = 0, v >= f && (w = d[v - f]), T = r[v * 2], e.opt_len += T * (S + w), u && (e.static_len += T * (l[v * 2 + 1] + w)));
  if (P !== 0) {
    do {
      for (S = g - 1; e.bl_count[S] === 0; )
        S--;
      e.bl_count[S]--, e.bl_count[S + 1] += 2, e.bl_count[g]--, P -= 2;
    } while (P > 0);
    for (S = g; S !== 0; S--)
      for (v = e.bl_count[S]; v !== 0; )
        E = e.heap[--h], !(E > o) && (r[E * 2 + 1] !== S && (e.opt_len += (S - r[E * 2 + 1]) * r[E * 2], r[E * 2 + 1] = S), v--);
  }
}, Tx = (e, t, r) => {
  const o = new Array(Zc + 1);
  let l = 0, u, d;
  for (u = 1; u <= Zc; u++)
    l = l + r[u - 1] << 1, o[u] = l;
  for (d = 0; d <= t; d++) {
    let f = e[d * 2 + 1];
    f !== 0 && (e[d * 2] = Rx(o[f]++, f));
  }
}, rE = () => {
  let e, t, r, o, l;
  const u = new Array(Zc + 1);
  for (r = 0, o = 0; o < ab - 1; o++)
    for (sb[o] = r, e = 0; e < 1 << x2[o]; e++)
      nm[r++] = o;
  for (nm[r - 1] = o, l = 0, o = 0; o < 16; o++)
    for (w0[o] = l, e = 0; e < 1 << f0[o]; e++)
      tm[l++] = o;
  for (l >>= 7; o < Tf; o++)
    for (w0[o] = l << 7, e = 0; e < 1 << f0[o] - 7; e++)
      tm[256 + l++] = o;
  for (t = 0; t <= Zc; t++)
    u[t] = 0;
  for (e = 0; e <= 143; )
    Yl[e * 2 + 1] = 8, e++, u[8]++;
  for (; e <= 255; )
    Yl[e * 2 + 1] = 9, e++, u[9]++;
  for (; e <= 279; )
    Yl[e * 2 + 1] = 7, e++, u[7]++;
  for (; e <= 287; )
    Yl[e * 2 + 1] = 8, e++, u[8]++;
  for (Tx(Yl, em + 1, u), e = 0; e < Tf; e++)
    Kp[e * 2 + 1] = 5, Kp[e * 2] = Rx(e, 5);
  xx = new py(Yl, x2, hm + 1, em, Zc), kx = new py(Kp, f0, 0, Tf, Zc), Cx = new py(new Array(0), $7, 0, ib, J7);
}, Nx = (e) => {
  let t;
  for (t = 0; t < em; t++)
    e.dyn_ltree[t * 2] = 0;
  for (t = 0; t < Tf; t++)
    e.dyn_dtree[t * 2] = 0;
  for (t = 0; t < ib; t++)
    e.bl_tree[t * 2] = 0;
  e.dyn_ltree[ob * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, Ax = (e) => {
  e.bi_valid > 8 ? rm(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, xS = (e, t, r, o) => {
  const l = t * 2, u = r * 2;
  return e[l] < e[u] || e[l] === e[u] && o[t] <= o[r];
}, gy = (e, t, r) => {
  const o = e.heap[r];
  let l = r << 1;
  for (; l <= e.heap_len && (l < e.heap_len && xS(t, e.heap[l + 1], e.heap[l], e.depth) && l++, !xS(t, o, e.heap[l], e.depth)); )
    e.heap[r] = e.heap[l], r = l, l <<= 1;
  e.heap[r] = o;
}, kS = (e, t, r) => {
  let o, l, u = 0, d, f;
  if (e.sym_next !== 0)
    do
      o = e.pending_buf[e.sym_buf + u++] & 255, o += (e.pending_buf[e.sym_buf + u++] & 255) << 8, l = e.pending_buf[e.sym_buf + u++], o === 0 ? ul(e, l, t) : (d = nm[l], ul(e, d + hm + 1, t), f = x2[d], f !== 0 && (l -= sb[d], io(e, l, f)), o--, d = Ex(o), ul(e, d, r), f = f0[d], f !== 0 && (o -= w0[d], io(e, o, f)));
    while (u < e.sym_next);
  ul(e, ob, t);
}, k2 = (e, t) => {
  const r = t.dyn_tree, o = t.stat_desc.static_tree, l = t.stat_desc.has_stree, u = t.stat_desc.elems;
  let d, f, g = -1, h;
  for (e.heap_len = 0, e.heap_max = yx, d = 0; d < u; d++)
    r[d * 2] !== 0 ? (e.heap[++e.heap_len] = g = d, e.depth[d] = 0) : r[d * 2 + 1] = 0;
  for (; e.heap_len < 2; )
    h = e.heap[++e.heap_len] = g < 2 ? ++g : 0, r[h * 2] = 1, e.depth[h] = 0, e.opt_len--, l && (e.static_len -= o[h * 2 + 1]);
  for (t.max_code = g, d = e.heap_len >> 1; d >= 1; d--)
    gy(e, r, d);
  h = u;
  do
    d = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[
      1
      /*SMALLEST*/
    ] = e.heap[e.heap_len--], gy(
      e,
      r,
      1
      /*SMALLEST*/
    ), f = e.heap[
      1
      /*SMALLEST*/
    ], e.heap[--e.heap_max] = d, e.heap[--e.heap_max] = f, r[h * 2] = r[d * 2] + r[f * 2], e.depth[h] = (e.depth[d] >= e.depth[f] ? e.depth[d] : e.depth[f]) + 1, r[d * 2 + 1] = r[f * 2 + 1] = h, e.heap[
      1
      /*SMALLEST*/
    ] = h++, gy(
      e,
      r,
      1
      /*SMALLEST*/
    );
  while (e.heap_len >= 2);
  e.heap[--e.heap_max] = e.heap[
    1
    /*SMALLEST*/
  ], nE(e, t), Tx(r, g, e.bl_count);
}, CS = (e, t, r) => {
  let o, l = -1, u, d = t[1], f = 0, g = 7, h = 4;
  for (d === 0 && (g = 138, h = 3), t[(r + 1) * 2 + 1] = 65535, o = 0; o <= r; o++)
    u = d, d = t[(o + 1) * 2 + 1], !(++f < g && u === d) && (f < h ? e.bl_tree[u * 2] += f : u !== 0 ? (u !== l && e.bl_tree[u * 2]++, e.bl_tree[bx * 2]++) : f <= 10 ? e.bl_tree[_x * 2]++ : e.bl_tree[Sx * 2]++, f = 0, l = u, d === 0 ? (g = 138, h = 3) : u === d ? (g = 6, h = 3) : (g = 7, h = 4));
}, ES = (e, t, r) => {
  let o, l = -1, u, d = t[1], f = 0, g = 7, h = 4;
  for (d === 0 && (g = 138, h = 3), o = 0; o <= r; o++)
    if (u = d, d = t[(o + 1) * 2 + 1], !(++f < g && u === d)) {
      if (f < h)
        do
          ul(e, u, e.bl_tree);
        while (--f !== 0);
      else u !== 0 ? (u !== l && (ul(e, u, e.bl_tree), f--), ul(e, bx, e.bl_tree), io(e, f - 3, 2)) : f <= 10 ? (ul(e, _x, e.bl_tree), io(e, f - 3, 3)) : (ul(e, Sx, e.bl_tree), io(e, f - 11, 7));
      f = 0, l = u, d === 0 ? (g = 138, h = 3) : u === d ? (g = 6, h = 3) : (g = 7, h = 4);
    }
}, aE = (e) => {
  let t;
  for (CS(e, e.dyn_ltree, e.l_desc.max_code), CS(e, e.dyn_dtree, e.d_desc.max_code), k2(e, e.bl_desc), t = ib - 1; t >= 3 && e.bl_tree[wx[t] * 2 + 1] === 0; t--)
    ;
  return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, iE = (e, t, r, o) => {
  let l;
  for (io(e, t - 257, 5), io(e, r - 1, 5), io(e, o - 4, 4), l = 0; l < o; l++)
    io(e, e.bl_tree[wx[l] * 2 + 1], 3);
  ES(e, e.dyn_ltree, t - 1), ES(e, e.dyn_dtree, r - 1);
}, oE = (e) => {
  let t = 4093624447, r;
  for (r = 0; r <= 31; r++, t >>>= 1)
    if (t & 1 && e.dyn_ltree[r * 2] !== 0)
      return SS;
  if (e.dyn_ltree[18] !== 0 || e.dyn_ltree[20] !== 0 || e.dyn_ltree[26] !== 0)
    return wS;
  for (r = 32; r < hm; r++)
    if (e.dyn_ltree[r * 2] !== 0)
      return wS;
  return SS;
};
let RS = !1;
const sE = (e) => {
  RS || (rE(), RS = !0), e.l_desc = new my(e.dyn_ltree, xx), e.d_desc = new my(e.dyn_dtree, kx), e.bl_desc = new my(e.bl_tree, Cx), e.bi_buf = 0, e.bi_valid = 0, Nx(e);
}, Mx = (e, t, r, o) => {
  io(e, (Y7 << 1) + (o ? 1 : 0), 3), Ax(e), rm(e, r), rm(e, ~r), r && e.pending_buf.set(e.window.subarray(t, t + r), e.pending), e.pending += r;
}, lE = (e) => {
  io(e, vx << 1, 3), ul(e, ob, Yl), tE(e);
}, uE = (e, t, r, o) => {
  let l, u, d = 0;
  e.level > 0 ? (e.strm.data_type === j7 && (e.strm.data_type = oE(e)), k2(e, e.l_desc), k2(e, e.d_desc), d = aE(e), l = e.opt_len + 3 + 7 >>> 3, u = e.static_len + 3 + 7 >>> 3, u <= l && (l = u)) : l = u = r + 5, r + 4 <= l && t !== -1 ? Mx(e, t, r, o) : e.strategy === K7 || u === l ? (io(e, (vx << 1) + (o ? 1 : 0), 3), kS(e, Yl, Kp)) : (io(e, (Z7 << 1) + (o ? 1 : 0), 3), iE(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, d + 1), kS(e, e.dyn_ltree, e.dyn_dtree)), Nx(e), o && Ax(e);
}, cE = (e, t, r) => (e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = r, t === 0 ? e.dyn_ltree[r * 2]++ : (e.matches++, t--, e.dyn_ltree[(nm[r] + hm + 1) * 2]++, e.dyn_dtree[Ex(t) * 2]++), e.sym_next === e.sym_end);
var dE = sE, fE = Mx, hE = uE, pE = cE, mE = lE, gE = {
  _tr_init: dE,
  _tr_stored_block: fE,
  _tr_flush_block: hE,
  _tr_tally: pE,
  _tr_align: mE
};
const vE = (e, t, r, o) => {
  let l = e & 65535 | 0, u = e >>> 16 & 65535 | 0, d = 0;
  for (; r !== 0; ) {
    d = r > 2e3 ? 2e3 : r, r -= d;
    do
      l = l + t[o++] | 0, u = u + l | 0;
    while (--d);
    l %= 65521, u %= 65521;
  }
  return l | u << 16 | 0;
};
var am = vE;
const yE = () => {
  let e, t = [];
  for (var r = 0; r < 256; r++) {
    e = r;
    for (var o = 0; o < 8; o++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    t[r] = e;
  }
  return t;
}, bE = new Uint32Array(yE()), _E = (e, t, r, o) => {
  const l = bE, u = o + r;
  e ^= -1;
  for (let d = o; d < u; d++)
    e = e >>> 8 ^ l[(e ^ t[d]) & 255];
  return e ^ -1;
};
var qa = _E, nd = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, G0 = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_PARTIAL_FLUSH: 1,
  Z_SYNC_FLUSH: 2,
  Z_FULL_FLUSH: 3,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  Z_DEFAULT_COMPRESSION: -1,
  Z_FILTERED: 1,
  Z_HUFFMAN_ONLY: 2,
  Z_RLE: 3,
  Z_FIXED: 4,
  Z_DEFAULT_STRATEGY: 0,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN: 2,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const { _tr_init: SE, _tr_stored_block: C2, _tr_flush_block: wE, _tr_tally: Zu, _tr_align: xE } = gE, {
  Z_NO_FLUSH: Xu,
  Z_PARTIAL_FLUSH: kE,
  Z_FULL_FLUSH: CE,
  Z_FINISH: qo,
  Z_BLOCK: TS,
  Z_OK: oi,
  Z_STREAM_END: NS,
  Z_STREAM_ERROR: cl,
  Z_DATA_ERROR: EE,
  Z_BUF_ERROR: vy,
  Z_DEFAULT_COMPRESSION: RE,
  Z_FILTERED: TE,
  Z_HUFFMAN_ONLY: $g,
  Z_RLE: NE,
  Z_FIXED: AE,
  Z_DEFAULT_STRATEGY: ME,
  Z_UNKNOWN: PE,
  Z_DEFLATED: V0
} = G0, DE = 9, LE = 15, OE = 8, FE = 29, zE = 256, E2 = zE + 1 + FE, BE = 30, UE = 19, IE = 2 * E2 + 1, HE = 15, Jn = 3, Wu = 258, dl = Wu + Jn + 1, GE = 32, Mf = 42, lb = 57, R2 = 69, T2 = 73, N2 = 91, A2 = 103, Xc = 113, Gp = 666, Vi = 1, Hf = 2, rd = 3, Gf = 4, VE = 3, Qc = (e, t) => (e.msg = nd[t], t), AS = (e) => e * 2 - (e > 4 ? 9 : 0), Vu = (e) => {
  let t = e.length;
  for (; --t >= 0; )
    e[t] = 0;
}, qE = (e) => {
  let t, r, o, l = e.w_size;
  t = e.hash_size, o = t;
  do
    r = e.head[--o], e.head[o] = r >= l ? r - l : 0;
  while (--t);
  t = l, o = t;
  do
    r = e.prev[--o], e.prev[o] = r >= l ? r - l : 0;
  while (--t);
};
let ub = (e, t, r) => (t << e.hash_shift ^ r) & e.hash_mask;
const ad = (e, t) => {
  let r;
  if (e.legacy_hash)
    r = e.ins_h = ub(e, e.ins_h, e.window[t + Jn - 1]);
  else {
    const l = e.window, u = l[t] | l[t + 1] << 8 | l[t + 2] << 16 | l[t + 3] << 24;
    r = e.ins_h = Math.imul(u, 66521) + 66521 >>> 16 & e.hash_mask;
  }
  const o = e.prev[t & e.w_mask] = e.head[r];
  return e.head[r] = t, o;
}, So = (e) => {
  const t = e.state;
  let r = t.pending;
  r > e.avail_out && (r = e.avail_out), r !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + r), e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, t.pending === 0 && (t.pending_out = 0));
}, xo = (e, t) => {
  wE(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, So(e.strm);
}, ar = (e, t) => {
  e.pending_buf[e.pending++] = t;
}, Xh = (e, t) => {
  e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}, M2 = (e, t, r, o) => {
  let l = e.avail_in;
  return l > o && (l = o), l === 0 ? 0 : (e.avail_in -= l, t.set(e.input.subarray(e.next_in, e.next_in + l), r), e.state.wrap === 1 ? e.adler = am(e.adler, t, l, r) : e.state.wrap === 2 && (e.adler = qa(e.adler, t, l, r)), e.next_in += l, e.total_in += l, l);
}, Px = (e, t) => {
  let r = e.max_chain_length, o = e.strstart, l, u, d = e.prev_length, f = e.nice_match;
  const g = e.strstart > e.w_size - dl ? e.strstart - (e.w_size - dl) : 0, h = e.window, v = e.w_mask, E = e.prev, S = e.strstart + Wu;
  let w = h[o + d - 1], T = h[o + d];
  e.prev_length >= e.good_match && (r >>= 2), f > e.lookahead && (f = e.lookahead);
  do
    if (l = t, !(h[l + d] !== T || h[l + d - 1] !== w || h[l] !== h[o] || h[++l] !== h[o + 1])) {
      o += 2, l++;
      do
        ;
      while (h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && h[++o] === h[++l] && o < S);
      if (u = Wu - (S - o), o = S - Wu, u > d) {
        if (e.match_start = t, d = u, u >= f)
          break;
        w = h[o + d - 1], T = h[o + d];
      }
    }
  while ((t = E[t & v]) > g && --r !== 0);
  return d <= e.lookahead ? d : e.lookahead;
}, Pf = (e) => {
  const t = e.w_size;
  let r, o, l;
  do {
    if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - dl) && (e.window.set(e.window.subarray(t, t + t - o), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), qE(e), o += t), e.strm.avail_in === 0)
      break;
    if (r = M2(e.strm, e.window, e.strstart + e.lookahead, o), e.lookahead += r, e.legacy_hash) {
      if (e.lookahead + e.insert >= Jn)
        for (l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = ub(e, e.ins_h, e.window[l + 1]); e.insert && (ad(e, l), l++, e.insert--, !(e.lookahead + e.insert < Jn)); )
          ;
    } else if (e.lookahead + e.insert > Jn)
      for (l = e.strstart - e.insert; e.insert && (ad(e, l), l++, e.insert--, !(e.lookahead + e.insert <= Jn)); )
        ;
  } while (e.lookahead < dl && e.strm.avail_in !== 0);
}, Dx = (e, t) => {
  let r = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, o, l, u, d = 0, f = e.strm.avail_in;
  do {
    if (o = 65535, u = e.bi_valid + 42 >> 3, e.strm.avail_out < u || (u = e.strm.avail_out - u, l = e.strstart - e.block_start, o > l + e.strm.avail_in && (o = l + e.strm.avail_in), o > u && (o = u), o < r && (o === 0 && t !== qo || t === Xu || o !== l + e.strm.avail_in)))
      break;
    d = t === qo && o === l + e.strm.avail_in ? 1 : 0, C2(e, 0, 0, d), e.pending_buf[e.pending - 4] = o, e.pending_buf[e.pending - 3] = o >> 8, e.pending_buf[e.pending - 2] = ~o, e.pending_buf[e.pending - 1] = ~o >> 8, So(e.strm), l && (l > o && (l = o), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + l), e.strm.next_out), e.strm.next_out += l, e.strm.avail_out -= l, e.strm.total_out += l, e.block_start += l, o -= l), o && (M2(e.strm, e.strm.output, e.strm.next_out, o), e.strm.next_out += o, e.strm.avail_out -= o, e.strm.total_out += o);
  } while (d === 0);
  return f -= e.strm.avail_in, f && (f >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= f && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - f, e.strm.next_in), e.strstart), e.strstart += f, e.insert += f > e.w_size - e.insert ? e.w_size - e.insert : f), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), d ? Gf : t !== Xu && t !== qo && e.strm.avail_in === 0 && e.strstart === e.block_start ? Hf : (u = e.window_size - e.strstart, e.strm.avail_in > u && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, u += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), u > e.strm.avail_in && (u = e.strm.avail_in), u && (M2(e.strm, e.window, e.strstart, u), e.strstart += u, e.insert += u > e.w_size - e.insert ? e.w_size - e.insert : u), e.high_water < e.strstart && (e.high_water = e.strstart), u = e.bi_valid + 42 >> 3, u = e.pending_buf_size - u > 65535 ? 65535 : e.pending_buf_size - u, r = u > e.w_size ? e.w_size : u, l = e.strstart - e.block_start, (l >= r || (l || t === qo) && t !== Xu && e.strm.avail_in === 0 && l <= u) && (o = l > u ? u : l, d = t === qo && e.strm.avail_in === 0 && o === l ? 1 : 0, C2(e, e.block_start, o, d), e.block_start += o, So(e.strm)), d ? rd : Vi);
}, yy = (e, t) => {
  let r, o;
  for (; ; ) {
    if (e.lookahead < dl) {
      if (Pf(e), e.lookahead < dl && t === Xu)
        return Vi;
      if (e.lookahead === 0)
        break;
    }
    if (r = 0, e.lookahead >= Jn && (r = ad(e, e.strstart)), r !== 0 && e.strstart - r <= e.w_size - dl && (e.match_length = Px(e, r)), e.match_length >= Jn)
      if (o = Zu(e, e.strstart - e.match_start, e.match_length - Jn), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= Jn) {
        e.match_length--;
        do
          e.strstart++, r = ad(e, e.strstart);
        while (--e.match_length !== 0);
        e.strstart++;
      } else
        e.strstart += e.match_length, e.match_length = 0, e.legacy_hash && (e.ins_h = e.window[e.strstart], e.ins_h = ub(e, e.ins_h, e.window[e.strstart + 1]));
    else
      o = Zu(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
    if (o && (xo(e, !1), e.strm.avail_out === 0))
      return Vi;
  }
  return e.insert = e.strstart < Jn - 1 ? e.strstart : Jn - 1, t === qo ? (xo(e, !0), e.strm.avail_out === 0 ? rd : Gf) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? Vi : Hf;
}, yf = (e, t) => {
  let r, o, l;
  for (; ; ) {
    if (e.lookahead < dl) {
      if (Pf(e), e.lookahead < dl && t === Xu)
        return Vi;
      if (e.lookahead === 0)
        break;
    }
    if (r = 0, e.lookahead >= Jn && (r = ad(e, e.strstart)), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = Jn - 1, r !== 0 && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - dl && (e.match_length = Px(e, r), e.match_length <= 5 && (e.strategy === TE || e.match_length === Jn && e.strstart - e.match_start > 4096) && (e.match_length = Jn - 1)), e.prev_length >= Jn && e.match_length <= e.prev_length) {
      l = e.strstart + e.lookahead - Jn, o = Zu(e, e.strstart - 1 - e.prev_match, e.prev_length - Jn), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
      do
        ++e.strstart <= l && (r = ad(e, e.strstart));
      while (--e.prev_length !== 0);
      if (e.match_available = 0, e.match_length = Jn - 1, e.strstart++, o && (xo(e, !1), e.strm.avail_out === 0))
        return Vi;
    } else if (e.match_available) {
      if (o = Zu(e, 0, e.window[e.strstart - 1]), o && xo(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0)
        return Vi;
    } else
      e.match_available = 1, e.strstart++, e.lookahead--;
  }
  return e.match_available && (o = Zu(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < Jn - 1 ? e.strstart : Jn - 1, t === qo ? (xo(e, !0), e.strm.avail_out === 0 ? rd : Gf) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? Vi : Hf;
}, WE = (e, t) => {
  let r, o, l, u;
  const d = e.window;
  for (; ; ) {
    if (e.lookahead <= Wu) {
      if (Pf(e), e.lookahead <= Wu && t === Xu)
        return Vi;
      if (e.lookahead === 0)
        break;
    }
    if (e.match_length = 0, e.lookahead >= Jn && e.strstart > 0 && (l = e.strstart - 1, o = d[l], o === d[++l] && o === d[++l] && o === d[++l])) {
      u = e.strstart + Wu;
      do
        ;
      while (o === d[++l] && o === d[++l] && o === d[++l] && o === d[++l] && o === d[++l] && o === d[++l] && o === d[++l] && o === d[++l] && l < u);
      e.match_length = Wu - (u - l), e.match_length > e.lookahead && (e.match_length = e.lookahead);
    }
    if (e.match_length >= Jn ? (r = Zu(e, 1, e.match_length - Jn), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = Zu(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (xo(e, !1), e.strm.avail_out === 0))
      return Vi;
  }
  return e.insert = 0, t === qo ? (xo(e, !0), e.strm.avail_out === 0 ? rd : Gf) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? Vi : Hf;
}, KE = (e, t) => {
  let r;
  for (; ; ) {
    if (e.lookahead === 0 && (Pf(e), e.lookahead === 0)) {
      if (t === Xu)
        return Vi;
      break;
    }
    if (e.match_length = 0, r = Zu(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (xo(e, !1), e.strm.avail_out === 0))
      return Vi;
  }
  return e.insert = 0, t === qo ? (xo(e, !0), e.strm.avail_out === 0 ? rd : Gf) : e.sym_next && (xo(e, !1), e.strm.avail_out === 0) ? Vi : Hf;
};
function al(e, t, r, o, l) {
  this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = o, this.func = l;
}
const Vp = [
  /*      good lazy nice chain */
  new al(0, 0, 0, 0, Dx),
  /* 0 store only */
  new al(4, 4, 8, 4, yy),
  /* 1 max speed, no lazy matches */
  new al(4, 5, 16, 8, yy),
  /* 2 */
  new al(4, 6, 32, 32, yy),
  /* 3 */
  new al(4, 4, 16, 16, yf),
  /* 4 lazy matches */
  new al(8, 16, 32, 32, yf),
  /* 5 */
  new al(8, 16, 128, 128, yf),
  /* 6 */
  new al(8, 32, 128, 256, yf),
  /* 7 */
  new al(32, 128, 258, 1024, yf),
  /* 8 */
  new al(32, 258, 258, 4096, yf)
  /* 9 max compression */
], jE = (e) => {
  e.window_size = 2 * e.w_size, Vu(e.head), e.max_lazy_match = Vp[e.level].max_lazy, e.good_match = Vp[e.level].good_length, e.nice_match = Vp[e.level].nice_length, e.max_chain_length = Vp[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = Jn - 1, e.match_available = 0, e.ins_h = 0;
};
function YE() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = V0, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.legacy_hash = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(IE * 2), this.dyn_dtree = new Uint16Array((2 * BE + 1) * 2), this.bl_tree = new Uint16Array((2 * UE + 1) * 2), Vu(this.dyn_ltree), Vu(this.dyn_dtree), Vu(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new Uint16Array(HE + 1), this.heap = new Uint16Array(2 * E2 + 1), Vu(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new Uint16Array(2 * E2 + 1), Vu(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
const pm = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.status !== Mf && //#ifdef GZIP
  t.status !== lb && //#endif
  t.status !== R2 && t.status !== T2 && t.status !== N2 && t.status !== A2 && t.status !== Xc && t.status !== Gp ? 1 : 0;
}, Lx = (e) => {
  if (pm(e))
    return Qc(e, cl);
  e.total_in = e.total_out = 0, e.data_type = PE;
  const t = e.state;
  return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = //#ifdef GZIP
  t.wrap === 2 ? lb : (
    //#endif
    t.wrap ? Mf : Xc
  ), e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, SE(t), oi;
}, Ox = (e) => {
  const t = Lx(e);
  return t === oi && jE(e.state), t;
}, ZE = (e, t) => pm(e) || e.state.wrap !== 2 ? cl : (e.state.gzhead = t, oi), Fx = (e, t, r, o, l, u, d) => {
  if (!e)
    return cl;
  let f = 1;
  if (t === RE && (t = 6), o < 0 ? (f = 0, o = -o) : o > 15 && (f = 2, o -= 16), l < 1 || l > DE || r !== V0 || o < 8 || o > 15 || t < 0 || t > 9 || u < 0 || u > AE || o === 8 && f !== 1)
    return Qc(e, cl);
  o === 8 && (o = 9);
  const g = new YE();
  return e.state = g, g.strm = e, g.status = Mf, g.wrap = f, g.gzhead = null, g.w_bits = o, g.w_size = 1 << g.w_bits, g.w_mask = g.w_size - 1, g.legacy_hash = d ? 1 : 0, g.hash_bits = l + 7, !g.legacy_hash && g.hash_bits < 15 && (g.hash_bits = 15), g.hash_size = 1 << g.hash_bits, g.hash_mask = g.hash_size - 1, g.hash_shift = ~~((g.hash_bits + Jn - 1) / Jn), g.window = new Uint8Array(g.w_size * 2), g.head = new Uint16Array(g.hash_size), g.prev = new Uint16Array(g.w_size), g.lit_bufsize = 1 << l + 6, g.pending_buf_size = g.lit_bufsize * 4, g.pending_buf = new Uint8Array(g.pending_buf_size), g.sym_buf = g.lit_bufsize, g.sym_end = (g.lit_bufsize - 1) * 3, g.level = t, g.strategy = u, g.method = r, Ox(e);
}, XE = (e, t) => Fx(e, t, V0, LE, OE, ME), QE = (e, t) => {
  if (pm(e) || t > TS || t < 0)
    return e ? Qc(e, cl) : cl;
  const r = e.state;
  if (!e.output || e.avail_in !== 0 && !e.input || r.status === Gp && t !== qo)
    return Qc(e, e.avail_out === 0 ? vy : cl);
  const o = r.last_flush;
  if (r.last_flush = t, r.pending !== 0) {
    if (So(e), e.avail_out === 0)
      return r.last_flush = -1, oi;
  } else if (e.avail_in === 0 && AS(t) <= AS(o) && t !== qo)
    return Qc(e, vy);
  if (r.status === Gp && e.avail_in !== 0)
    return Qc(e, vy);
  if (r.status === Mf && r.wrap === 0 && (r.status = Xc), r.status === Mf) {
    let l = V0 + (r.w_bits - 8 << 4) << 8, u = -1;
    if (r.strategy >= $g || r.level < 2 ? u = 0 : r.level < 6 ? u = 1 : r.level === 6 ? u = 2 : u = 3, l |= u << 6, r.strstart !== 0 && (l |= GE), l += 31 - l % 31, Xh(r, l), r.strstart !== 0 && (Xh(r, e.adler >>> 16), Xh(r, e.adler & 65535)), e.adler = 1, r.status = Xc, So(e), r.pending !== 0)
      return r.last_flush = -1, oi;
  }
  if (r.status === lb) {
    if (e.adler = 0, ar(r, 31), ar(r, 139), ar(r, 8), r.gzhead)
      ar(
        r,
        (r.gzhead.text ? 1 : 0) + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)
      ), ar(r, r.gzhead.time & 255), ar(r, r.gzhead.time >> 8 & 255), ar(r, r.gzhead.time >> 16 & 255), ar(r, r.gzhead.time >> 24 & 255), ar(r, r.level === 9 ? 2 : r.strategy >= $g || r.level < 2 ? 4 : 0), ar(r, r.gzhead.os & 255), r.gzhead.extra && r.gzhead.extra.length && (ar(r, r.gzhead.extra.length & 255), ar(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (e.adler = qa(e.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = R2;
    else if (ar(r, 0), ar(r, 0), ar(r, 0), ar(r, 0), ar(r, 0), ar(r, r.level === 9 ? 2 : r.strategy >= $g || r.level < 2 ? 4 : 0), ar(r, VE), r.status = Xc, So(e), r.pending !== 0)
      return r.last_flush = -1, oi;
  }
  if (r.status === R2) {
    if (r.gzhead.extra) {
      let l = r.pending, u = (r.gzhead.extra.length & 65535) - r.gzindex;
      for (; r.pending + u > r.pending_buf_size; ) {
        let f = r.pending_buf_size - r.pending;
        if (r.pending_buf.set(r.gzhead.extra.subarray(r.gzindex, r.gzindex + f), r.pending), r.pending = r.pending_buf_size, r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l)), r.gzindex += f, So(e), r.pending !== 0)
          return r.last_flush = -1, oi;
        l = 0, u -= f;
      }
      let d = new Uint8Array(r.gzhead.extra);
      r.pending_buf.set(d.subarray(r.gzindex, r.gzindex + u), r.pending), r.pending += u, r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l)), r.gzindex = 0;
    }
    r.status = T2;
  }
  if (r.status === T2) {
    if (r.gzhead.name) {
      let l = r.pending, u;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l)), So(e), r.pending !== 0)
            return r.last_flush = -1, oi;
          l = 0;
        }
        r.gzindex < r.gzhead.name.length ? u = r.gzhead.name.charCodeAt(r.gzindex++) & 255 : u = 0, ar(r, u);
      } while (u !== 0);
      r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l)), r.gzindex = 0;
    }
    r.status = N2;
  }
  if (r.status === N2) {
    if (r.gzhead.comment) {
      let l = r.pending, u;
      do {
        if (r.pending === r.pending_buf_size) {
          if (r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l)), So(e), r.pending !== 0)
            return r.last_flush = -1, oi;
          l = 0;
        }
        r.gzindex < r.gzhead.comment.length ? u = r.gzhead.comment.charCodeAt(r.gzindex++) & 255 : u = 0, ar(r, u);
      } while (u !== 0);
      r.gzhead.hcrc && r.pending > l && (e.adler = qa(e.adler, r.pending_buf, r.pending - l, l));
    }
    r.status = A2;
  }
  if (r.status === A2) {
    if (r.gzhead.hcrc) {
      if (r.pending + 2 > r.pending_buf_size && (So(e), r.pending !== 0))
        return r.last_flush = -1, oi;
      ar(r, e.adler & 255), ar(r, e.adler >> 8 & 255), e.adler = 0;
    }
    if (r.status = Xc, So(e), r.pending !== 0)
      return r.last_flush = -1, oi;
  }
  if (e.avail_in !== 0 || r.lookahead !== 0 || t !== Xu && r.status !== Gp) {
    let l = r.level === 0 ? Dx(r, t) : r.strategy === $g ? KE(r, t) : r.strategy === NE ? WE(r, t) : Vp[r.level].func(r, t);
    if ((l === rd || l === Gf) && (r.status = Gp), l === Vi || l === rd)
      return e.avail_out === 0 && (r.last_flush = -1), oi;
    if (l === Hf && (t === kE ? xE(r) : t !== TS && (C2(r, 0, 0, !1), t === CE && (Vu(r.head), r.lookahead === 0 && (r.strstart = 0, r.block_start = 0, r.insert = 0))), So(e), e.avail_out === 0))
      return r.last_flush = -1, oi;
  }
  return t !== qo ? oi : r.wrap <= 0 ? NS : (r.wrap === 2 ? (ar(r, e.adler & 255), ar(r, e.adler >> 8 & 255), ar(r, e.adler >> 16 & 255), ar(r, e.adler >> 24 & 255), ar(r, e.total_in & 255), ar(r, e.total_in >> 8 & 255), ar(r, e.total_in >> 16 & 255), ar(r, e.total_in >> 24 & 255)) : (Xh(r, e.adler >>> 16), Xh(r, e.adler & 65535)), So(e), r.wrap > 0 && (r.wrap = -r.wrap), r.pending !== 0 ? oi : NS);
}, JE = (e) => {
  if (pm(e))
    return cl;
  const t = e.state.status;
  return e.state = null, t === Xc ? Qc(e, EE) : oi;
}, $E = (e, t) => {
  let r = t.length;
  if (pm(e))
    return cl;
  const o = e.state, l = o.wrap;
  if (l === 2 || l === 1 && o.status !== Mf || o.lookahead)
    return cl;
  if (l === 1 && (e.adler = am(e.adler, t, r, 0)), o.wrap = 0, r >= o.w_size) {
    l === 0 && (Vu(o.head), o.strstart = 0, o.block_start = 0, o.insert = 0);
    let g = new Uint8Array(o.w_size);
    g.set(t.subarray(r - o.w_size, r), 0), t = g, r = o.w_size;
  }
  const u = e.avail_in, d = e.next_in, f = e.input;
  for (e.avail_in = r, e.next_in = 0, e.input = t, Pf(o); o.lookahead >= Jn; ) {
    let g = o.strstart, h = o.lookahead - (Jn - 1);
    do
      ad(o, g), g++;
    while (--h);
    o.strstart = g, o.lookahead = Jn - 1, Pf(o);
  }
  return o.strstart += o.lookahead, o.block_start = o.strstart, o.insert = o.lookahead, o.lookahead = 0, o.match_length = o.prev_length = Jn - 1, o.match_available = 0, e.next_in = d, e.input = f, e.avail_in = u, o.wrap = l, oi;
};
var eR = XE, tR = Fx, nR = Ox, rR = Lx, aR = ZE, iR = QE, oR = JE, sR = $E, lR = "pako deflate (from Nodeca project)", jp = {
  deflateInit: eR,
  deflateInit2: tR,
  deflateReset: nR,
  deflateResetKeep: rR,
  deflateSetHeader: aR,
  deflate: iR,
  deflateEnd: oR,
  deflateSetDictionary: sR,
  deflateInfo: lR
};
const uR = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
var cR = function(e) {
  const t = Array.prototype.slice.call(arguments, 1);
  for (; t.length; ) {
    const r = t.shift();
    if (r) {
      if (typeof r != "object")
        throw new TypeError(r + "must be non-object");
      for (const o in r)
        uR(r, o) && (e[o] = r[o]);
    }
  }
  return e;
}, dR = (e) => {
  let t = 0;
  for (let o = 0, l = e.length; o < l; o++)
    t += e[o].length;
  const r = new Uint8Array(t);
  for (let o = 0, l = 0, u = e.length; o < u; o++) {
    let d = e[o];
    r.set(d, l), l += d.length;
  }
  return r;
}, q0 = {
  assign: cR,
  flattenChunks: dR
};
let zx = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch {
  zx = !1;
}
const im = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  im[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
im[254] = im[255] = 1;
var fR = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let t, r, o, l, u, d = e.length, f = 0;
  for (l = 0; l < d; l++)
    r = e.charCodeAt(l), (r & 64512) === 55296 && l + 1 < d && (o = e.charCodeAt(l + 1), (o & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (o - 56320), l++)), f += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
  for (t = new Uint8Array(f), u = 0, l = 0; u < f; l++)
    r = e.charCodeAt(l), (r & 64512) === 55296 && l + 1 < d && (o = e.charCodeAt(l + 1), (o & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (o - 56320), l++)), r < 128 ? t[u++] = r : r < 2048 ? (t[u++] = 192 | r >>> 6, t[u++] = 128 | r & 63) : r < 65536 ? (t[u++] = 224 | r >>> 12, t[u++] = 128 | r >>> 6 & 63, t[u++] = 128 | r & 63) : (t[u++] = 240 | r >>> 18, t[u++] = 128 | r >>> 12 & 63, t[u++] = 128 | r >>> 6 & 63, t[u++] = 128 | r & 63);
  return t;
};
const hR = (e, t) => {
  if (t < 65534 && e.subarray && zx)
    return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
  let r = "";
  for (let o = 0; o < t; o++)
    r += String.fromCharCode(e[o]);
  return r;
};
var pR = (e, t) => {
  const r = t || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, t));
  let o, l;
  const u = new Array(r * 2);
  for (l = 0, o = 0; o < r; ) {
    let d = e[o++];
    if (d < 128) {
      u[l++] = d;
      continue;
    }
    let f = im[d];
    if (f > 4) {
      u[l++] = 65533, o += f - 1;
      continue;
    }
    for (d &= f === 2 ? 31 : f === 3 ? 15 : 7; f > 1 && o < r; )
      d = d << 6 | e[o++] & 63, f--;
    if (f > 1) {
      u[l++] = 65533;
      continue;
    }
    d < 65536 ? u[l++] = d : (d -= 65536, u[l++] = 55296 | d >> 10 & 1023, u[l++] = 56320 | d & 1023);
  }
  return hR(u, l);
}, mR = (e, t) => {
  t = t || e.length, t > e.length && (t = e.length);
  let r = t - 1;
  for (; r >= 0 && (e[r] & 192) === 128; )
    r--;
  return r < 0 || r === 0 ? t : r + im[e[r]] > t ? r : t;
}, om = {
  string2buf: fR,
  buf2string: pR,
  utf8border: mR
};
function gR() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var Bx = gR;
const Ux = Object.prototype.toString, {
  Z_NO_FLUSH: vR,
  Z_SYNC_FLUSH: yR,
  Z_FULL_FLUSH: bR,
  Z_FINISH: _R,
  Z_OK: x0,
  Z_STREAM_END: SR,
  Z_DEFAULT_COMPRESSION: wR,
  Z_DEFAULT_STRATEGY: xR,
  Z_DEFLATED: kR
} = G0, CR = {
  level: wR,
  method: kR,
  chunkSize: 16384,
  windowBits: 15,
  memLevel: 8,
  strategy: xR,
  legacyHash: !0
};
function W0(e) {
  this.options = q0.assign({}, CR, e || {});
  let t = this.options;
  t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Bx(), this.strm.avail_out = 0;
  let r = jp.deflateInit2(
    this.strm,
    t.level,
    t.method,
    t.windowBits,
    t.memLevel,
    t.strategy,
    t.legacyHash
  );
  if (r !== x0)
    throw new Error(nd[r]);
  if (t.header && jp.deflateSetHeader(this.strm, t.header), t.dictionary) {
    let o;
    if (typeof t.dictionary == "string" ? o = om.string2buf(t.dictionary) : Ux.call(t.dictionary) === "[object ArrayBuffer]" ? o = new Uint8Array(t.dictionary) : o = t.dictionary, r = jp.deflateSetDictionary(this.strm, o), r !== x0)
      throw new Error(nd[r]);
    this._dict_set = !0;
  }
}
W0.prototype.push = function(e, t) {
  const r = this.strm, o = this.options.chunkSize;
  let l, u;
  if (this.ended)
    return !1;
  for (t === ~~t ? u = t : u = t === !0 ? _R : vR, typeof e == "string" ? r.input = om.string2buf(e) : Ux.call(e) === "[object ArrayBuffer]" ? r.input = new Uint8Array(e) : r.input = e, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    if (r.avail_out === 0 && (r.output = new Uint8Array(o), r.next_out = 0, r.avail_out = o), (u === yR || u === bR) && r.avail_out <= 6) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (l = jp.deflate(r, u), l === SR)
      return r.next_out > 0 && this.onData(r.output.subarray(0, r.next_out)), l = jp.deflateEnd(this.strm), this.onEnd(l), this.ended = !0, l === x0;
    if (r.avail_out === 0) {
      this.onData(r.output);
      continue;
    }
    if (u > 0 && r.next_out > 0) {
      this.onData(r.output.subarray(0, r.next_out)), r.avail_out = 0;
      continue;
    }
    if (r.avail_in === 0) break;
  }
  return !0;
};
W0.prototype.onData = function(e) {
  this.chunks.push(e);
};
W0.prototype.onEnd = function(e) {
  e === x0 && (this.result = q0.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function ER(e, t) {
  const r = new W0(t);
  if (r.push(e, !0), r.err)
    throw r.msg || nd[r.err];
  return r.result;
}
function RR(e, t) {
  return t = t || {}, t.raw = !0, ER(e, t);
}
var TR = RR, NR = {
  deflateRaw: TR
};
const e0 = 16209, AR = 16191;
var MR = function(t, r) {
  let o, l, u, d, f, g, h, v, E, S, w, T, P, z, L, x, k, R, B, q, X, I, U, F;
  const Z = t.state;
  o = t.next_in, U = t.input, l = o + (t.avail_in - 5), u = t.next_out, F = t.output, d = u - (r - t.avail_out), f = u + (t.avail_out - 257), g = Z.dmax, h = Z.wsize, v = Z.whave, E = Z.wnext, S = Z.window, w = Z.hold, T = Z.bits, P = Z.lencode, z = Z.distcode, L = (1 << Z.lenbits) - 1, x = (1 << Z.distbits) - 1;
  e:
    do {
      T < 15 && (w += U[o++] << T, T += 8, w += U[o++] << T, T += 8), k = P[w & L];
      t:
        for (; ; ) {
          if (R = k >>> 24, w >>>= R, T -= R, R = k >>> 16 & 255, R === 0)
            F[u++] = k & 65535;
          else if (R & 16) {
            B = k & 65535, R &= 15, R && (T < R && (w += U[o++] << T, T += 8), B += w & (1 << R) - 1, w >>>= R, T -= R), T < 15 && (w += U[o++] << T, T += 8, w += U[o++] << T, T += 8), k = z[w & x];
            n:
              for (; ; ) {
                if (R = k >>> 24, w >>>= R, T -= R, R = k >>> 16 & 255, R & 16) {
                  if (q = k & 65535, R &= 15, T < R && (w += U[o++] << T, T += 8, T < R && (w += U[o++] << T, T += 8)), q += w & (1 << R) - 1, q > g) {
                    t.msg = "invalid distance too far back", Z.mode = e0;
                    break e;
                  }
                  if (w >>>= R, T -= R, R = u - d, q > R) {
                    if (R = q - R, R > v && Z.sane) {
                      t.msg = "invalid distance too far back", Z.mode = e0;
                      break e;
                    }
                    if (X = 0, I = S, E === 0) {
                      if (X += h - R, R < B) {
                        B -= R;
                        do
                          F[u++] = S[X++];
                        while (--R);
                        X = u - q, I = F;
                      }
                    } else if (E < R) {
                      if (X += h + E - R, R -= E, R < B) {
                        B -= R;
                        do
                          F[u++] = S[X++];
                        while (--R);
                        if (X = 0, E < B) {
                          R = E, B -= R;
                          do
                            F[u++] = S[X++];
                          while (--R);
                          X = u - q, I = F;
                        }
                      }
                    } else if (X += E - R, R < B) {
                      B -= R;
                      do
                        F[u++] = S[X++];
                      while (--R);
                      X = u - q, I = F;
                    }
                    for (; B > 2; )
                      F[u++] = I[X++], F[u++] = I[X++], F[u++] = I[X++], B -= 3;
                    B && (F[u++] = I[X++], B > 1 && (F[u++] = I[X++]));
                  } else {
                    X = u - q;
                    do
                      F[u++] = F[X++], F[u++] = F[X++], F[u++] = F[X++], B -= 3;
                    while (B > 2);
                    B && (F[u++] = F[X++], B > 1 && (F[u++] = F[X++]));
                  }
                } else if ((R & 64) === 0) {
                  k = z[(k & 65535) + (w & (1 << R) - 1)];
                  continue n;
                } else {
                  t.msg = "invalid distance code", Z.mode = e0;
                  break e;
                }
                break;
              }
          } else if ((R & 64) === 0) {
            k = P[(k & 65535) + (w & (1 << R) - 1)];
            continue t;
          } else if (R & 32) {
            Z.mode = AR;
            break e;
          } else {
            t.msg = "invalid literal/length code", Z.mode = e0;
            break e;
          }
          break;
        }
    } while (o < l && u < f);
  B = T >> 3, o -= B, T -= B << 3, w &= (1 << T) - 1, t.next_in = o, t.next_out = u, t.avail_in = o < l ? 5 + (l - o) : 5 - (o - l), t.avail_out = u < f ? 257 + (f - u) : 257 - (u - f), Z.hold = w, Z.bits = T;
};
const bf = 15, MS = 852, PS = 592, DS = 0, by = 1, LS = 2, PR = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), DR = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  199,
  75
]), LR = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), OR = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), FR = (e, t, r, o, l, u, d, f) => {
  const g = f.bits;
  let h = 0, v = 0, E = 0, S = 0, w = 0, T = 0, P = 0, z = 0, L = 0, x = 0, k, R, B, q, X, I = null, U;
  const F = new Uint16Array(bf + 1), Z = new Uint16Array(bf + 1);
  let te = null, ie, ue, ce;
  for (h = 0; h <= bf; h++)
    F[h] = 0;
  for (v = 0; v < o; v++)
    F[t[r + v]]++;
  for (w = g, S = bf; S >= 1 && F[S] === 0; S--)
    ;
  if (w > S && (w = S), S === 0)
    return l[u++] = 1 << 24 | 64 << 16 | 0, l[u++] = 1 << 24 | 64 << 16 | 0, f.bits = 1, 0;
  for (E = 1; E < S && F[E] === 0; E++)
    ;
  for (w < E && (w = E), z = 1, h = 1; h <= bf; h++)
    if (z <<= 1, z -= F[h], z < 0)
      return -1;
  if (z > 0 && (e === DS || S !== 1))
    return -1;
  for (Z[1] = 0, h = 1; h < bf; h++)
    Z[h + 1] = Z[h] + F[h];
  for (v = 0; v < o; v++)
    t[r + v] !== 0 && (d[Z[t[r + v]]++] = v);
  if (e === DS ? (I = te = d, U = 20) : e === by ? (I = PR, te = DR, U = 257) : (I = LR, te = OR, U = 0), x = 0, v = 0, h = E, X = u, T = w, P = 0, B = -1, L = 1 << w, q = L - 1, e === by && L > MS || e === LS && L > PS)
    return 1;
  for (; ; ) {
    ie = h - P, d[v] + 1 < U ? (ue = 0, ce = d[v]) : d[v] >= U ? (ue = te[d[v] - U], ce = I[d[v] - U]) : (ue = 96, ce = 0), k = 1 << h - P, R = 1 << T, E = R;
    do
      R -= k, l[X + (x >> P) + R] = ie << 24 | ue << 16 | ce | 0;
    while (R !== 0);
    for (k = 1 << h - 1; x & k; )
      k >>= 1;
    if (k !== 0 ? (x &= k - 1, x += k) : x = 0, v++, --F[h] === 0) {
      if (h === S)
        break;
      h = t[r + d[v]];
    }
    if (h > w && (x & q) !== B) {
      for (P === 0 && (P = w), X += E, T = h - P, z = 1 << T; T + P < S && (z -= F[T + P], !(z <= 0)); )
        T++, z <<= 1;
      if (L += 1 << T, e === by && L > MS || e === LS && L > PS)
        return 1;
      B = x & q, l[B] = w << 24 | T << 16 | X - u | 0;
    }
  }
  return x !== 0 && (l[X + x] = h - P << 24 | 64 << 16 | 0), f.bits = w, 0;
};
var Yp = FR;
const zR = 0, Ix = 1, Hx = 2, {
  Z_FINISH: OS,
  Z_BLOCK: BR,
  Z_TREES: t0,
  Z_OK: id,
  Z_STREAM_END: UR,
  Z_NEED_DICT: IR,
  Z_STREAM_ERROR: Yo,
  Z_DATA_ERROR: Gx,
  Z_MEM_ERROR: Vx,
  Z_BUF_ERROR: HR,
  Z_DEFLATED: FS
} = G0, K0 = 16180, zS = 16181, BS = 16182, US = 16183, IS = 16184, HS = 16185, GS = 16186, VS = 16187, qS = 16188, WS = 16189, k0 = 16190, Wl = 16191, _y = 16192, KS = 16193, Sy = 16194, jS = 16195, YS = 16196, ZS = 16197, XS = 16198, n0 = 16199, r0 = 16200, QS = 16201, JS = 16202, $S = 16203, e3 = 16204, t3 = 16205, wy = 16206, n3 = 16207, r3 = 16208, Rr = 16209, qx = 16210, Wx = 16211, GR = 852, VR = 592, qR = 15, WR = qR, a3 = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function KR() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const ud = (e) => {
  if (!e)
    return 1;
  const t = e.state;
  return !t || t.strm !== e || t.mode < K0 || t.mode > Wx ? 1 : 0;
}, Kx = (e) => {
  if (ud(e))
    return Yo;
  const t = e.state;
  return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = K0, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(GR), t.distcode = t.distdyn = new Int32Array(VR), t.sane = 1, t.back = -1, id;
}, jx = (e) => {
  if (ud(e))
    return Yo;
  const t = e.state;
  return t.wsize = 0, t.whave = 0, t.wnext = 0, Kx(e);
}, Yx = (e, t) => {
  let r;
  if (ud(e))
    return Yo;
  const o = e.state;
  return t < 0 ? (r = 0, t = -t) : (r = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? Yo : (o.window !== null && o.wbits !== t && (o.window = null), o.wrap = r, o.wbits = t, jx(e));
}, Zx = (e, t) => {
  if (!e)
    return Yo;
  const r = new KR();
  e.state = r, r.strm = e, r.window = null, r.mode = K0;
  const o = Yx(e, t);
  return o !== id && (e.state = null), o;
}, jR = (e) => Zx(e, WR);
let i3 = !0, xy, ky;
const YR = (e) => {
  if (i3) {
    xy = new Int32Array(512), ky = new Int32Array(32);
    let t = 0;
    for (; t < 144; )
      e.lens[t++] = 8;
    for (; t < 256; )
      e.lens[t++] = 9;
    for (; t < 280; )
      e.lens[t++] = 7;
    for (; t < 288; )
      e.lens[t++] = 8;
    for (Yp(Ix, e.lens, 0, 288, xy, 0, e.work, { bits: 9 }), t = 0; t < 32; )
      e.lens[t++] = 5;
    Yp(Hx, e.lens, 0, 32, ky, 0, e.work, { bits: 5 }), i3 = !1;
  }
  e.lencode = xy, e.lenbits = 9, e.distcode = ky, e.distbits = 5;
}, Xx = (e, t, r, o) => {
  let l;
  const u = e.state;
  return u.window === null && (u.window = new Uint8Array(1 << u.wbits)), u.wsize === 0 && (u.wsize = 1 << u.wbits, u.wnext = 0, u.whave = 0), o >= u.wsize ? (u.window.set(t.subarray(r - u.wsize, r), 0), u.wnext = 0, u.whave = u.wsize) : (l = u.wsize - u.wnext, l > o && (l = o), u.window.set(t.subarray(r - o, r - o + l), u.wnext), o -= l, o ? (u.window.set(t.subarray(r - o, r), 0), u.wnext = o, u.whave = u.wsize) : (u.wnext += l, u.wnext === u.wsize && (u.wnext = 0), u.whave < u.wsize && (u.whave += l))), 0;
}, ZR = (e, t) => {
  let r, o, l, u, d, f, g, h, v, E, S, w, T, P, z = 0, L, x, k, R, B, q, X, I;
  const U = new Uint8Array(4);
  let F, Z;
  const te = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (ud(e) || !e.output || !e.input && e.avail_in !== 0)
    return Yo;
  r = e.state, r.mode === Wl && (r.mode = _y), d = e.next_out, l = e.output, g = e.avail_out, u = e.next_in, o = e.input, f = e.avail_in, h = r.hold, v = r.bits, E = f, S = g, I = id;
  e:
    for (; ; )
      switch (r.mode) {
        case K0:
          if (r.wrap === 0) {
            r.mode = _y;
            break;
          }
          for (; v < 16; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if (r.wrap & 2 && h === 35615) {
            r.wbits === 0 && (r.wbits = 15), r.check = 0, U[0] = h & 255, U[1] = h >>> 8 & 255, r.check = qa(r.check, U, 2, 0), h = 0, v = 0, r.mode = zS;
            break;
          }
          if (r.head && (r.head.done = !1), !(r.wrap & 1) || /* check if zlib header allowed */
          (((h & 255) << 8) + (h >> 8)) % 31) {
            e.msg = "incorrect header check", r.mode = Rr;
            break;
          }
          if ((h & 15) !== FS) {
            e.msg = "unknown compression method", r.mode = Rr;
            break;
          }
          if (h >>>= 4, v -= 4, X = (h & 15) + 8, r.wbits === 0 && (r.wbits = X), X > 15 || X > r.wbits) {
            e.msg = "invalid window size", r.mode = Rr;
            break;
          }
          r.dmax = 1 << r.wbits, r.flags = 0, e.adler = r.check = 1, r.mode = h & 512 ? WS : Wl, h = 0, v = 0;
          break;
        case zS:
          for (; v < 16; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if (r.flags = h, (r.flags & 255) !== FS) {
            e.msg = "unknown compression method", r.mode = Rr;
            break;
          }
          if (r.flags & 57344) {
            e.msg = "unknown header flags set", r.mode = Rr;
            break;
          }
          r.head && (r.head.text = h >> 8 & 1), r.flags & 512 && r.wrap & 4 && (U[0] = h & 255, U[1] = h >>> 8 & 255, r.check = qa(r.check, U, 2, 0)), h = 0, v = 0, r.mode = BS;
        /* falls through */
        case BS:
          for (; v < 32; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          r.head && (r.head.time = h), r.flags & 512 && r.wrap & 4 && (U[0] = h & 255, U[1] = h >>> 8 & 255, U[2] = h >>> 16 & 255, U[3] = h >>> 24 & 255, r.check = qa(r.check, U, 4, 0)), h = 0, v = 0, r.mode = US;
        /* falls through */
        case US:
          for (; v < 16; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          r.head && (r.head.xflags = h & 255, r.head.os = h >> 8), r.flags & 512 && r.wrap & 4 && (U[0] = h & 255, U[1] = h >>> 8 & 255, r.check = qa(r.check, U, 2, 0)), h = 0, v = 0, r.mode = IS;
        /* falls through */
        case IS:
          if (r.flags & 1024) {
            for (; v < 16; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            r.length = h, r.head && (r.head.extra_len = h), r.flags & 512 && r.wrap & 4 && (U[0] = h & 255, U[1] = h >>> 8 & 255, r.check = qa(r.check, U, 2, 0)), h = 0, v = 0;
          } else r.head && (r.head.extra = null);
          r.mode = HS;
        /* falls through */
        case HS:
          if (r.flags & 1024 && (w = r.length, w > f && (w = f), w && (r.head && (X = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Uint8Array(r.head.extra_len)), r.head.extra.set(
            o.subarray(
              u,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              u + w
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            X
          )), r.flags & 512 && r.wrap & 4 && (r.check = qa(r.check, o, w, u)), f -= w, u += w, r.length -= w), r.length))
            break e;
          r.length = 0, r.mode = GS;
        /* falls through */
        case GS:
          if (r.flags & 2048) {
            if (f === 0)
              break e;
            w = 0;
            do
              X = o[u + w++], r.head && X && r.length < 65536 && (r.head.name += String.fromCharCode(X));
            while (X && w < f);
            if (r.flags & 512 && r.wrap & 4 && (r.check = qa(r.check, o, w, u)), f -= w, u += w, X)
              break e;
          } else r.head && (r.head.name = null);
          r.length = 0, r.mode = VS;
        /* falls through */
        case VS:
          if (r.flags & 4096) {
            if (f === 0)
              break e;
            w = 0;
            do
              X = o[u + w++], r.head && X && r.length < 65536 && (r.head.comment += String.fromCharCode(X));
            while (X && w < f);
            if (r.flags & 512 && r.wrap & 4 && (r.check = qa(r.check, o, w, u)), f -= w, u += w, X)
              break e;
          } else r.head && (r.head.comment = null);
          r.mode = qS;
        /* falls through */
        case qS:
          if (r.flags & 512) {
            for (; v < 16; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            if (r.wrap & 4 && h !== (r.check & 65535)) {
              e.msg = "header crc mismatch", r.mode = Rr;
              break;
            }
            h = 0, v = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = Wl;
          break;
        case WS:
          for (; v < 32; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          e.adler = r.check = a3(h), h = 0, v = 0, r.mode = k0;
        /* falls through */
        case k0:
          if (r.havedict === 0)
            return e.next_out = d, e.avail_out = g, e.next_in = u, e.avail_in = f, r.hold = h, r.bits = v, IR;
          e.adler = r.check = 1, r.mode = Wl;
        /* falls through */
        case Wl:
          if (t === BR || t === t0)
            break e;
        /* falls through */
        case _y:
          if (r.last) {
            h >>>= v & 7, v -= v & 7, r.mode = wy;
            break;
          }
          for (; v < 3; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          switch (r.last = h & 1, h >>>= 1, v -= 1, h & 3) {
            case 0:
              r.mode = KS;
              break;
            case 1:
              if (YR(r), r.mode = n0, t === t0) {
                h >>>= 2, v -= 2;
                break e;
              }
              break;
            case 2:
              r.mode = YS;
              break;
            case 3:
              e.msg = "invalid block type", r.mode = Rr;
          }
          h >>>= 2, v -= 2;
          break;
        case KS:
          for (h >>>= v & 7, v -= v & 7; v < 32; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if ((h & 65535) !== (h >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", r.mode = Rr;
            break;
          }
          if (r.length = h & 65535, h = 0, v = 0, r.mode = Sy, t === t0)
            break e;
        /* falls through */
        case Sy:
          r.mode = jS;
        /* falls through */
        case jS:
          if (w = r.length, w) {
            if (w > f && (w = f), w > g && (w = g), w === 0)
              break e;
            l.set(o.subarray(u, u + w), d), f -= w, u += w, g -= w, d += w, r.length -= w;
            break;
          }
          r.mode = Wl;
          break;
        case YS:
          for (; v < 14; ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if (r.nlen = (h & 31) + 257, h >>>= 5, v -= 5, r.ndist = (h & 31) + 1, h >>>= 5, v -= 5, r.ncode = (h & 15) + 4, h >>>= 4, v -= 4, r.nlen > 286 || r.ndist > 30) {
            e.msg = "too many length or distance symbols", r.mode = Rr;
            break;
          }
          r.have = 0, r.mode = ZS;
        /* falls through */
        case ZS:
          for (; r.have < r.ncode; ) {
            for (; v < 3; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            r.lens[te[r.have++]] = h & 7, h >>>= 3, v -= 3;
          }
          for (; r.have < 19; )
            r.lens[te[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, F = { bits: r.lenbits }, I = Yp(zR, r.lens, 0, 19, r.lencode, 0, r.work, F), r.lenbits = F.bits, I) {
            e.msg = "invalid code lengths set", r.mode = Rr;
            break;
          }
          r.have = 0, r.mode = XS;
        /* falls through */
        case XS:
          for (; r.have < r.nlen + r.ndist; ) {
            for (; z = r.lencode[h & (1 << r.lenbits) - 1], L = z >>> 24, x = z >>> 16 & 255, k = z & 65535, !(L <= v); ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            if (k < 16)
              h >>>= L, v -= L, r.lens[r.have++] = k;
            else {
              if (k === 16) {
                for (Z = L + 2; v < Z; ) {
                  if (f === 0)
                    break e;
                  f--, h += o[u++] << v, v += 8;
                }
                if (h >>>= L, v -= L, r.have === 0) {
                  e.msg = "invalid bit length repeat", r.mode = Rr;
                  break;
                }
                X = r.lens[r.have - 1], w = 3 + (h & 3), h >>>= 2, v -= 2;
              } else if (k === 17) {
                for (Z = L + 3; v < Z; ) {
                  if (f === 0)
                    break e;
                  f--, h += o[u++] << v, v += 8;
                }
                h >>>= L, v -= L, X = 0, w = 3 + (h & 7), h >>>= 3, v -= 3;
              } else {
                for (Z = L + 7; v < Z; ) {
                  if (f === 0)
                    break e;
                  f--, h += o[u++] << v, v += 8;
                }
                h >>>= L, v -= L, X = 0, w = 11 + (h & 127), h >>>= 7, v -= 7;
              }
              if (r.have + w > r.nlen + r.ndist) {
                e.msg = "invalid bit length repeat", r.mode = Rr;
                break;
              }
              for (; w--; )
                r.lens[r.have++] = X;
            }
          }
          if (r.mode === Rr)
            break;
          if (r.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", r.mode = Rr;
            break;
          }
          if (r.lenbits = 9, F = { bits: r.lenbits }, I = Yp(Ix, r.lens, 0, r.nlen, r.lencode, 0, r.work, F), r.lenbits = F.bits, I) {
            e.msg = "invalid literal/lengths set", r.mode = Rr;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, F = { bits: r.distbits }, I = Yp(Hx, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, F), r.distbits = F.bits, I) {
            e.msg = "invalid distances set", r.mode = Rr;
            break;
          }
          if (r.mode = n0, t === t0)
            break e;
        /* falls through */
        case n0:
          r.mode = r0;
        /* falls through */
        case r0:
          if (f >= 6 && g >= 258) {
            e.next_out = d, e.avail_out = g, e.next_in = u, e.avail_in = f, r.hold = h, r.bits = v, MR(e, S), d = e.next_out, l = e.output, g = e.avail_out, u = e.next_in, o = e.input, f = e.avail_in, h = r.hold, v = r.bits, r.mode === Wl && (r.back = -1);
            break;
          }
          for (r.back = 0; z = r.lencode[h & (1 << r.lenbits) - 1], L = z >>> 24, x = z >>> 16 & 255, k = z & 65535, !(L <= v); ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if (x && (x & 240) === 0) {
            for (R = L, B = x, q = k; z = r.lencode[q + ((h & (1 << R + B) - 1) >> R)], L = z >>> 24, x = z >>> 16 & 255, k = z & 65535, !(R + L <= v); ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            h >>>= R, v -= R, r.back += R;
          }
          if (h >>>= L, v -= L, r.back += L, r.length = k, x === 0) {
            r.mode = t3;
            break;
          }
          if (x & 32) {
            r.back = -1, r.mode = Wl;
            break;
          }
          if (x & 64) {
            e.msg = "invalid literal/length code", r.mode = Rr;
            break;
          }
          r.extra = x & 15, r.mode = QS;
        /* falls through */
        case QS:
          if (r.extra) {
            for (Z = r.extra; v < Z; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            r.length += h & (1 << r.extra) - 1, h >>>= r.extra, v -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = JS;
        /* falls through */
        case JS:
          for (; z = r.distcode[h & (1 << r.distbits) - 1], L = z >>> 24, x = z >>> 16 & 255, k = z & 65535, !(L <= v); ) {
            if (f === 0)
              break e;
            f--, h += o[u++] << v, v += 8;
          }
          if ((x & 240) === 0) {
            for (R = L, B = x, q = k; z = r.distcode[q + ((h & (1 << R + B) - 1) >> R)], L = z >>> 24, x = z >>> 16 & 255, k = z & 65535, !(R + L <= v); ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            h >>>= R, v -= R, r.back += R;
          }
          if (h >>>= L, v -= L, r.back += L, x & 64) {
            e.msg = "invalid distance code", r.mode = Rr;
            break;
          }
          r.offset = k, r.extra = x & 15, r.mode = $S;
        /* falls through */
        case $S:
          if (r.extra) {
            for (Z = r.extra; v < Z; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            r.offset += h & (1 << r.extra) - 1, h >>>= r.extra, v -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            e.msg = "invalid distance too far back", r.mode = Rr;
            break;
          }
          r.mode = e3;
        /* falls through */
        case e3:
          if (g === 0)
            break e;
          if (w = S - g, r.offset > w) {
            if (w = r.offset - w, w > r.whave && r.sane) {
              e.msg = "invalid distance too far back", r.mode = Rr;
              break;
            }
            w > r.wnext ? (w -= r.wnext, T = r.wsize - w) : T = r.wnext - w, w > r.length && (w = r.length), P = r.window;
          } else
            P = l, T = d - r.offset, w = r.length;
          w > g && (w = g), g -= w, r.length -= w;
          do
            l[d++] = P[T++];
          while (--w);
          r.length === 0 && (r.mode = r0);
          break;
        case t3:
          if (g === 0)
            break e;
          l[d++] = r.length, g--, r.mode = r0;
          break;
        case wy:
          if (r.wrap) {
            for (; v < 32; ) {
              if (f === 0)
                break e;
              f--, h |= o[u++] << v, v += 8;
            }
            if (S -= g, e.total_out += S, r.total += S, r.wrap & 4 && S && (e.adler = r.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            r.flags ? qa(r.check, l, S, d - S) : am(r.check, l, S, d - S)), S = g, r.wrap & 4 && (r.flags ? h : a3(h)) !== r.check) {
              e.msg = "incorrect data check", r.mode = Rr;
              break;
            }
            h = 0, v = 0;
          }
          r.mode = n3;
        /* falls through */
        case n3:
          if (r.wrap && r.flags) {
            for (; v < 32; ) {
              if (f === 0)
                break e;
              f--, h += o[u++] << v, v += 8;
            }
            if (r.wrap & 4 && h !== (r.total & 4294967295)) {
              e.msg = "incorrect length check", r.mode = Rr;
              break;
            }
            h = 0, v = 0;
          }
          r.mode = r3;
        /* falls through */
        case r3:
          I = UR;
          break e;
        case Rr:
          I = Gx;
          break e;
        case qx:
          return Vx;
        case Wx:
        /* falls through */
        default:
          return Yo;
      }
  return e.next_out = d, e.avail_out = g, e.next_in = u, e.avail_in = f, r.hold = h, r.bits = v, (r.wsize || S !== e.avail_out && r.mode < Rr && (r.mode < wy || t !== OS)) && Xx(e, e.output, e.next_out, S - e.avail_out), E -= e.avail_in, S -= e.avail_out, e.total_in += E, e.total_out += S, r.total += S, r.wrap & 4 && S && (e.adler = r.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  r.flags ? qa(r.check, l, S, e.next_out - S) : am(r.check, l, S, e.next_out - S)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Wl ? 128 : 0) + (r.mode === n0 || r.mode === Sy ? 256 : 0), (E === 0 && S === 0 || t === OS) && I === id && (I = HR), I;
}, XR = (e) => {
  if (ud(e))
    return Yo;
  let t = e.state;
  return t.window && (t.window = null), e.state = null, id;
}, QR = (e, t) => {
  if (ud(e))
    return Yo;
  const r = e.state;
  return (r.wrap & 2) === 0 ? Yo : (r.head = t, t.done = !1, id);
}, JR = (e, t) => {
  const r = t.length;
  let o, l, u;
  return ud(e) || (o = e.state, o.wrap !== 0 && o.mode !== k0) ? Yo : o.mode === k0 && (l = 1, l = am(l, t, r, 0), l !== o.check) ? Gx : (u = Xx(e, t, r, r), u ? (o.mode = qx, Vx) : (o.havedict = 1, id));
};
var $R = jx, eT = Yx, tT = Kx, nT = jR, rT = Zx, aT = ZR, iT = XR, oT = QR, sT = JR, lT = "pako inflate (from Nodeca project)", ll = {
  inflateReset: $R,
  inflateReset2: eT,
  inflateResetKeep: tT,
  inflateInit: nT,
  inflateInit2: rT,
  inflate: aT,
  inflateEnd: iT,
  inflateGetHeader: oT,
  inflateSetDictionary: sT,
  inflateInfo: lT
};
function uT() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var cT = uT;
const Qx = Object.prototype.toString, {
  Z_NO_FLUSH: dT,
  Z_FINISH: o3,
  Z_OK: Nf,
  Z_STREAM_END: Cy,
  Z_NEED_DICT: Ey,
  Z_STREAM_ERROR: fT,
  Z_DATA_ERROR: s3,
  Z_MEM_ERROR: hT,
  Z_BUF_ERROR: l3
} = G0, pT = {
  chunkSize: 1024 * 64,
  windowBits: 15,
  to: ""
};
function mm(e) {
  this.options = q0.assign({}, pT, e || {});
  const t = this.options;
  t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(e && e.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15) === 0 && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Bx(), this.strm.avail_out = 0;
  let r = ll.inflateInit2(
    this.strm,
    t.windowBits
  );
  if (r !== Nf)
    throw new Error(nd[r]);
  if (this.header = new cT(), ll.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = om.string2buf(t.dictionary) : Qx.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (r = ll.inflateSetDictionary(this.strm, t.dictionary), r !== Nf)))
    throw new Error(nd[r]);
}
mm.prototype.push = function(e, t) {
  const r = this.strm, o = this.options.chunkSize, l = this.options.dictionary;
  let u, d, f;
  if (this.ended) return !1;
  for (t === ~~t ? d = t : d = t === !0 ? o3 : dT, Qx.call(e) === "[object ArrayBuffer]" ? r.input = new Uint8Array(e) : r.input = e, r.next_in = 0, r.avail_in = r.input.length; ; ) {
    for (r.avail_out === 0 && (r.output = new Uint8Array(o), r.next_out = 0, r.avail_out = o), u = ll.inflate(r, d), u === Ey && l && (u = ll.inflateSetDictionary(r, l), u === Nf ? u = ll.inflate(r, d) : u === s3 && (u = Ey)); r.avail_in > 0 && u === Cy && r.state.wrap & 2 && r.state.flags !== 0 && r.input[r.next_in] !== 0; )
      ll.inflateReset(r), u = ll.inflate(r, d);
    switch (u) {
      case fT:
      case s3:
      case Ey:
      case hT:
        return this.onEnd(u), this.ended = !0, !1;
    }
    if (f = r.avail_out, r.next_out && (r.avail_out === 0 || u === Cy || d > 0))
      if (this.options.to === "string") {
        let g = om.utf8border(r.output, r.next_out), h = r.next_out - g, v = om.buf2string(r.output, g);
        r.next_out = h, r.avail_out = o - h, h && r.output.set(r.output.subarray(g, g + h), 0), this.onData(v);
      } else
        this.onData(r.output.length === r.next_out ? r.output : r.output.subarray(0, r.next_out)), r.avail_out = 0, r.next_out = 0;
    if (!((u === Nf || u === l3) && f === 0)) {
      if (u === Cy)
        return u = ll.inflateEnd(this.strm), this.onEnd(u), this.ended = !0, !0;
      if (r.avail_in === 0) {
        if (d === o3)
          return u = ll.inflateEnd(this.strm), this.onEnd(u === Nf ? l3 : u), this.ended = !0, !1;
        break;
      }
    }
  }
  return !0;
};
mm.prototype.onData = function(e) {
  this.chunks.push(e);
};
mm.prototype.onEnd = function(e) {
  e === Nf && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = q0.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function Jx(e, t) {
  const r = new mm(t);
  if (r.push(e, !0), r.err) throw r.msg || nd[r.err];
  return r.result;
}
function mT(e, t) {
  return t = t || {}, t.raw = !0, Jx(e, t);
}
var gT = mm, vT = Jx, yT = mT, bT = {
  Inflate: gT,
  inflate: vT,
  inflateRaw: yT
};
const { deflateRaw: _T } = NR, { Inflate: ST, inflate: wT, inflateRaw: xT } = bT;
var $x = _T, ML = ST, PL = wT, kT = xT;
const j0 = [
  "Optimist",
  "ILCA",
  "Generic keelboat",
  "Lacustre",
  "Tornado",
  "420",
  "470",
  "29er",
  "49er",
  "Windsurf",
  "Coachboat",
  "Committee boat",
  "Umpire boat"
], CT = [
  "Coachboat",
  "Committee boat",
  "Umpire boat"
], Zl = (e) => CT.some((t) => t === e), P2 = j0.filter(
  (e) => !Zl(e)
), ET = ["port", "none", "starboard"], cb = [
  "none",
  "protest",
  "red",
  "green-white",
  "yellow",
  "blue",
  "black"
], od = {
  light: "#F8FBFC",
  dark: "#262626"
}, _f = {
  light: 1,
  dark: 0.4
}, RT = (e) => e.toUpperCase() === "#20262B" ? od.dark : e, Qu = (e) => {
  const t = /^#([0-9a-f]{6})$/i.exec(e);
  if (!t) return !1;
  const r = Number.parseInt(t[1], 16), o = r >> 16 & 255, l = r >> 8 & 255, u = r & 255;
  return o * 0.299 + l * 0.587 + u * 0.114 < 128;
};
function TT(e, t, r) {
  const o = Qu(t) ? _f.dark : _f.light, l = Qu(r) ? _f.dark : _f.light;
  return t === r ? Qu(r) && e === _f.light ? _f.dark : e : e === o ? l : e;
}
const C0 = "#168DDD", E0 = "#4B5563";
function Ju(e, t) {
  return e === "Coachboat" ? C0 : e === "Umpire boat" ? E0 : t;
}
const fl = "#FFAA00", db = [
  { name: "Heisel amber", value: "#FFAA00" },
  { name: "Midnight navy", value: "#18324A" },
  { name: "Alpine blue", value: "#2F5D78" },
  { name: "Deep teal", value: "#1F6D68" },
  { name: "Forest green", value: "#4F6B52" },
  { name: "Burgundy", value: "#884454" },
  { name: "Copper", value: "#B46632" },
  { name: "Slate", value: "#5B6572" }
], NT = [
  { name: "Heisel amber", value: "#FFAA00" },
  { name: "Glacier blue", value: "#79B8D1" },
  { name: "Clear blue", value: "#5F9FC2" },
  { name: "Sea glass", value: "#55B5AA" },
  { name: "Sage", value: "#89AA8C" },
  { name: "Dusty rose", value: "#D2879E" },
  { name: "Warm copper", value: "#D99A68" },
  { name: "Silver", value: "#B8C1C9" }
], $c = (e) => e.toUpperCase();
function AT(e, t = fl) {
  return $c(t) === fl ? e : e.map(
    (r) => $c(r.value) === fl ? { name: "Brand primary", value: t } : r
  );
}
const Df = (e, t = fl) => {
  const r = Qu(e) ? NT : db;
  return AT(r, t);
};
function MT(e, t, r) {
  const o = Df(t), l = Df(r), u = o.findIndex(({ value: d }) => $c(d) === $c(e));
  return u >= 0 ? l[u].value : e;
}
function u3(e, t = db) {
  const r = /* @__PURE__ */ new Set(), o = [];
  for (const f of e)
    f.type !== "boat" || r.has(f.sequenceId) || (r.add(f.sequenceId), o.push($c(f.color)));
  const l = t.find(({ value: f }) => !o.includes($c(f)));
  if (l) return l.value;
  const u = o.at(-1), d = t.findIndex(({ value: f }) => $c(f) === u);
  return t[(d + 1) % t.length].value;
}
const Ka = () => {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function")
    return e.randomUUID();
  const t = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function")
    e.getRandomValues(t);
  else
    for (let o = 0; o < t.length; o += 1)
      t[o] = Math.floor(Math.random() * 256);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const r = Array.from(t, (o) => o.toString(16).padStart(2, "0"));
  return `${r.slice(0, 4).join("")}-${r.slice(4, 6).join("")}-${r.slice(6, 8).join("")}-${r.slice(8, 10).join("")}-${r.slice(10).join("")}`;
}, e6 = (e) => (e % 360 + 360) % 360, Vf = "#FF5E00", Zp = "#168DDD", PT = (e) => {
  const t = e6(e);
  return t > 180 ? t - 360 : t;
}, D2 = (e) => {
  const t = /^([1-9]\d*)/.exec(String(e ?? ""));
  return t ? Number(t[1]) : 0;
}, h0 = (e) => e.reduce(
  (t, r) => r.type === "mark" || r.type === "gate" ? Math.max(t, D2(r.markNumber)) : t,
  0
) + 1, sm = () => (/* @__PURE__ */ new Date()).toISOString(), gm = (e, t, r, o) => ({
  id: Ka(),
  type: e,
  x: t,
  y: r,
  rotation: 0,
  scaleX: 1,
  scaleY: 1,
  visible: !0,
  locked: !1,
  zIndex: o,
  opacity: 1
});
function Ko(e, t, r = 1, o = "ILCA", l = fl) {
  return {
    ...gm("boat", e, t, r),
    type: "boat",
    boatClass: o,
    name: "",
    sailNumber: "",
    label: "",
    color: Ju(o, l),
    heading: 0,
    tack: "starboard",
    mainsailVisible: !0,
    jibVisible: !1,
    genoaVisible: !1,
    spinnakerVisible: !1,
    gennakerVisible: !1,
    mainsailTrim: 0,
    jibTrim: 0,
    spinnakerTrim: 0,
    gennakerTrim: 0,
    sailMode: "automatic",
    sailAngle: 32,
    sequenceId: Ka(),
    positionNumber: 1,
    overlapIndicator: "none",
    protestFlagSide: "none",
    boatFlagColor: null,
    umpireSignalFlag: "none",
    stateMarker: "none"
  };
}
function fb(e, t, r = 1, o = fl) {
  return {
    ...gm("mark", e, t, r),
    type: "mark",
    markType: "racing",
    shape: "round",
    color: o,
    label: "",
    markNumber: "1",
    downwind: !1,
    laylinesVisible: !1,
    zoneVisible: !0,
    zoneRadius: 3,
    zoneRadiusUnit: "boat-lengths"
  };
}
function t6(e, t, r, o, l = 1, u = 1, d = 3, f = fl) {
  const g = (e + r) / 2, h = (t + o) / 2;
  return {
    ...gm("gate", g, h, l),
    type: "gate",
    endAX: e - g,
    endAY: t - h,
    endBX: r - g,
    endBY: o - h,
    markNumber: u,
    color: f,
    zoneVisible: !0,
    zoneRadius: d,
    zoneRadiusUnit: "boat-lengths"
  };
}
function hb(e, t, r, o, l = 1, u = Vf) {
  const d = (e + r) / 2, f = (t + o) / 2;
  return {
    ...gm("start-line", d, f, l),
    type: "start-line",
    endAX: e - d,
    endAY: t - f,
    endBX: r - d,
    endBY: o - f,
    color: "#A3A3A3",
    startEndType: "committee-boat",
    pinEndType: "flag",
    startEndFlagColor: u,
    pinEndFlagColor: u,
    laylinesVisible: !1,
    laylineAreaVisible: !1,
    laylineAreaColor: fl
  };
}
function n6(e, t, r, o, l = 1) {
  const u = (e + r) / 2, d = (t + o) / 2;
  return {
    ...gm("finish-line", u, d, l),
    type: "finish-line",
    endAX: e - u,
    endAY: t - d,
    endBX: r - u,
    endBY: o - d,
    color: "#A3A3A3",
    startEndType: "committee-boat",
    pinEndType: "flag",
    startEndFlagColor: Zp,
    pinEndFlagColor: Zp,
    laylinesVisible: !1,
    laylineAreaVisible: !1,
    laylineAreaColor: Zp
  };
}
function Ql(e = "Untitled plot") {
  const t = sm();
  return {
    format: "sailplot",
    version: 1,
    metadata: {
      id: Ka(),
      title: e,
      description: "",
      ruleReferences: [],
      additionalInformation: [{ id: Ka(), name: "", value: "" }],
      createdAt: t,
      updatedAt: t
    },
    canvas: {
      width: 1920,
      height: 1080,
      infinite: !1,
      background: od.light,
      boatNumbersVisible: !0,
      boatLegendVisible: !1,
      windIndicatorPosition: null,
      boatLegendPosition: null,
      grid: { visible: !0, size: 40, opacity: 1 },
      view: { x: 0, y: 0, scale: 1 }
    },
    environment: {
      windDirection: 0,
      windStrength: null,
      windVisible: !0,
      laylineAngle: 45,
      laylinesVisible: !0,
      zonesVisible: !0,
      zoneRadiusBoatLengths: 3,
      measurementBoatClass: null
    },
    objects: []
  };
}
function r6(e, t) {
  const r = /* @__PURE__ */ new Set([e, "Untitled plot", "Unbenannter Plot"]);
  let o = 0;
  for (const l of t)
    for (const u of r) {
      if (l === u) {
        o = Math.max(o, 0);
        continue;
      }
      if (!l.startsWith(`${u} `)) continue;
      const d = l.slice(u.length + 1);
      /^\d+$/.test(d) && (o = Math.max(o, Number(d)));
    }
  return `${e} ${o + 1}`;
}
function DT(e, t = 24) {
  return {
    ...structuredClone(e),
    id: Ka(),
    x: e.x + t,
    y: e.y + t,
    zIndex: e.zIndex + 1
  };
}
function a0(e) {
  return e.toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "sailplot";
}
var $n;
(function(e) {
  e.assertEqual = (l) => {
  };
  function t(l) {
  }
  e.assertIs = t;
  function r(l) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (l) => {
    const u = {};
    for (const d of l)
      u[d] = d;
    return u;
  }, e.getValidEnumValues = (l) => {
    const u = e.objectKeys(l).filter((f) => typeof l[l[f]] != "number"), d = {};
    for (const f of u)
      d[f] = l[f];
    return e.objectValues(d);
  }, e.objectValues = (l) => e.objectKeys(l).map(function(u) {
    return l[u];
  }), e.objectKeys = typeof Object.keys == "function" ? (l) => Object.keys(l) : (l) => {
    const u = [];
    for (const d in l)
      Object.prototype.hasOwnProperty.call(l, d) && u.push(d);
    return u;
  }, e.find = (l, u) => {
    for (const d of l)
      if (u(d))
        return d;
  }, e.isInteger = typeof Number.isInteger == "function" ? (l) => Number.isInteger(l) : (l) => typeof l == "number" && Number.isFinite(l) && Math.floor(l) === l;
  function o(l, u = " | ") {
    return l.map((d) => typeof d == "string" ? `'${d}'` : d).join(u);
  }
  e.joinValues = o, e.jsonStringifyReplacer = (l, u) => typeof u == "bigint" ? u.toString() : u;
})($n || ($n = {}));
var c3;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(c3 || (c3 = {}));
const Gt = $n.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Hu = (e) => {
  switch (typeof e) {
    case "undefined":
      return Gt.undefined;
    case "string":
      return Gt.string;
    case "number":
      return Number.isNaN(e) ? Gt.nan : Gt.number;
    case "boolean":
      return Gt.boolean;
    case "function":
      return Gt.function;
    case "bigint":
      return Gt.bigint;
    case "symbol":
      return Gt.symbol;
    case "object":
      return Array.isArray(e) ? Gt.array : e === null ? Gt.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Gt.promise : typeof Map < "u" && e instanceof Map ? Gt.map : typeof Set < "u" && e instanceof Set ? Gt.set : typeof Date < "u" && e instanceof Date ? Gt.date : Gt.object;
    default:
      return Gt.unknown;
  }
}, ft = $n.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Xl extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (o) => {
      this.issues = [...this.issues, o];
    }, this.addIssues = (o = []) => {
      this.issues = [...this.issues, ...o];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(u) {
      return u.message;
    }, o = { _errors: [] }, l = (u) => {
      for (const d of u.issues)
        if (d.code === "invalid_union")
          d.unionErrors.map(l);
        else if (d.code === "invalid_return_type")
          l(d.returnTypeError);
        else if (d.code === "invalid_arguments")
          l(d.argumentsError);
        else if (d.path.length === 0)
          o._errors.push(r(d));
        else {
          let f = o, g = 0;
          for (; g < d.path.length; ) {
            const h = d.path[g];
            g === d.path.length - 1 ? (f[h] = f[h] || { _errors: [] }, f[h]._errors.push(r(d))) : f[h] = f[h] || { _errors: [] }, f = f[h], g++;
          }
        }
    };
    return l(this), o;
  }
  static assert(t) {
    if (!(t instanceof Xl))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, $n.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, o = [];
    for (const l of this.issues)
      if (l.path.length > 0) {
        const u = l.path[0];
        r[u] = r[u] || [], r[u].push(t(l));
      } else
        o.push(t(l));
    return { formErrors: o, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Xl.create = (e) => new Xl(e);
const L2 = (e, t) => {
  let r;
  switch (e.code) {
    case ft.invalid_type:
      e.received === Gt.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case ft.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, $n.jsonStringifyReplacer)}`;
      break;
    case ft.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${$n.joinValues(e.keys, ", ")}`;
      break;
    case ft.invalid_union:
      r = "Invalid input";
      break;
    case ft.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${$n.joinValues(e.options)}`;
      break;
    case ft.invalid_enum_value:
      r = `Invalid enum value. Expected ${$n.joinValues(e.options)}, received '${e.received}'`;
      break;
    case ft.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case ft.invalid_return_type:
      r = "Invalid function return type";
      break;
    case ft.invalid_date:
      r = "Invalid date";
      break;
    case ft.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : $n.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case ft.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "bigint" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case ft.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case ft.custom:
      r = "Invalid input";
      break;
    case ft.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case ft.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case ft.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, $n.assertNever(e);
  }
  return { message: r };
};
let LT = L2;
function OT() {
  return LT;
}
const FT = (e) => {
  const { data: t, path: r, errorMaps: o, issueData: l } = e, u = [...r, ...l.path || []], d = {
    ...l,
    path: u
  };
  if (l.message !== void 0)
    return {
      ...l,
      path: u,
      message: l.message
    };
  let f = "";
  const g = o.filter((h) => !!h).slice().reverse();
  for (const h of g)
    f = h(d, { data: t, defaultError: f }).message;
  return {
    ...l,
    path: u,
    message: f
  };
};
function Dt(e, t) {
  const r = OT(), o = FT({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === L2 ? void 0 : L2
      // then global default map
    ].filter((l) => !!l)
  });
  e.common.issues.push(o);
}
class ko {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const o = [];
    for (const l of r) {
      if (l.status === "aborted")
        return hn;
      l.status === "dirty" && t.dirty(), o.push(l.value);
    }
    return { status: t.value, value: o };
  }
  static async mergeObjectAsync(t, r) {
    const o = [];
    for (const l of r) {
      const u = await l.key, d = await l.value;
      o.push({
        key: u,
        value: d
      });
    }
    return ko.mergeObjectSync(t, o);
  }
  static mergeObjectSync(t, r) {
    const o = {};
    for (const l of r) {
      const { key: u, value: d } = l;
      if (u.status === "aborted" || d.status === "aborted")
        return hn;
      u.status === "dirty" && t.dirty(), d.status === "dirty" && t.dirty(), u.value !== "__proto__" && (typeof d.value < "u" || l.alwaysSet) && (o[u.value] = d.value);
    }
    return { status: t.value, value: o };
  }
}
const hn = Object.freeze({
  status: "aborted"
}), qp = (e) => ({ status: "dirty", value: e }), Xo = (e) => ({ status: "valid", value: e }), d3 = (e) => e.status === "aborted", f3 = (e) => e.status === "dirty", Lf = (e) => e.status === "valid", R0 = (e) => typeof Promise < "u" && e instanceof Promise;
var Kt;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Kt || (Kt = {}));
class rc {
  constructor(t, r, o, l) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = o, this._key = l;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const h3 = (e, t) => {
  if (Lf(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Xl(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function Mn(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: o, description: l } = e;
  if (t && (r || o))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: l } : { errorMap: (d, f) => {
    const { message: g } = e;
    return d.code === "invalid_enum_value" ? { message: g ?? f.defaultError } : typeof f.data > "u" ? { message: g ?? o ?? f.defaultError } : d.code !== "invalid_type" ? { message: f.defaultError } : { message: g ?? r ?? f.defaultError };
  }, description: l };
}
class Zn {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Hu(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: Hu(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new ko(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Hu(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (R0(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const o = this.safeParse(t, r);
    if (o.success)
      return o.data;
    throw o.error;
  }
  safeParse(t, r) {
    const o = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Hu(t)
    }, l = this._parseSync({ data: t, path: o.path, parent: o });
    return h3(o, l);
  }
  "~validate"(t) {
    var o, l;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Hu(t)
    };
    if (!this["~standard"].async)
      try {
        const u = this._parseSync({ data: t, path: [], parent: r });
        return Lf(u) ? {
          value: u.value
        } : {
          issues: r.common.issues
        };
      } catch (u) {
        (l = (o = u == null ? void 0 : u.message) == null ? void 0 : o.toLowerCase()) != null && l.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((u) => Lf(u) ? {
      value: u.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const o = await this.safeParseAsync(t, r);
    if (o.success)
      return o.data;
    throw o.error;
  }
  async safeParseAsync(t, r) {
    const o = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Hu(t)
    }, l = this._parse({ data: t, path: o.path, parent: o }), u = await (R0(l) ? l : Promise.resolve(l));
    return h3(o, u);
  }
  refine(t, r) {
    const o = (l) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(l) : r;
    return this._refinement((l, u) => {
      const d = t(l), f = () => u.addIssue({
        code: ft.custom,
        ...o(l)
      });
      return typeof Promise < "u" && d instanceof Promise ? d.then((g) => g ? !0 : (f(), !1)) : d ? !0 : (f(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((o, l) => t(o) ? !0 : (l.addIssue(typeof r == "function" ? r(o, l) : r), !1));
  }
  _refinement(t) {
    return new ld({
      schema: this,
      typeName: pn.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return $u.create(this, this._def);
  }
  nullable() {
    return zf.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return hl.create(this);
  }
  promise() {
    return M0.create(this, this._def);
  }
  or(t) {
    return N0.create([this, t], this._def);
  }
  and(t) {
    return A0.create(this, t, this._def);
  }
  transform(t) {
    return new ld({
      ...Mn(this._def),
      schema: this,
      typeName: pn.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new B2({
      ...Mn(this._def),
      innerType: this,
      defaultValue: r,
      typeName: pn.ZodDefault
    });
  }
  brand() {
    return new iN({
      typeName: pn.ZodBranded,
      type: this,
      ...Mn(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new U2({
      ...Mn(this._def),
      innerType: this,
      catchValue: r,
      typeName: pn.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return pb.create(this, t);
  }
  readonly() {
    return I2.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const zT = /^c[^\s-]{8,}$/i, BT = /^[0-9a-z]+$/, UT = /^[0-9A-HJKMNP-TV-Z]{26}$/i, IT = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, HT = /^[a-z0-9_-]{21}$/i, GT = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, VT = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, qT = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, WT = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ry;
const KT = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, jT = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, YT = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ZT = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, XT = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, QT = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, a6 = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", JT = new RegExp(`^${a6}$`);
function i6(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function $T(e) {
  return new RegExp(`^${i6(e)}$`);
}
function eN(e) {
  let t = `${a6}T${i6(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function tN(e, t) {
  return !!((t === "v4" || !t) && KT.test(e) || (t === "v6" || !t) && YT.test(e));
}
function nN(e, t) {
  if (!GT.test(e))
    return !1;
  try {
    const [r] = e.split(".");
    if (!r)
      return !1;
    const o = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), l = JSON.parse(atob(o));
    return !(typeof l != "object" || l === null || "typ" in l && (l == null ? void 0 : l.typ) !== "JWT" || !l.alg || t && l.alg !== t);
  } catch {
    return !1;
  }
}
function rN(e, t) {
  return !!((t === "v4" || !t) && jT.test(e) || (t === "v6" || !t) && ZT.test(e));
}
class Ku extends Zn {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Gt.string) {
      const u = this._getOrReturnCtx(t);
      return Dt(u, {
        code: ft.invalid_type,
        expected: Gt.string,
        received: u.parsedType
      }), hn;
    }
    const o = new ko();
    let l;
    for (const u of this._def.checks)
      if (u.kind === "min")
        t.data.length < u.value && (l = this._getOrReturnCtx(t, l), Dt(l, {
          code: ft.too_small,
          minimum: u.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: u.message
        }), o.dirty());
      else if (u.kind === "max")
        t.data.length > u.value && (l = this._getOrReturnCtx(t, l), Dt(l, {
          code: ft.too_big,
          maximum: u.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: u.message
        }), o.dirty());
      else if (u.kind === "length") {
        const d = t.data.length > u.value, f = t.data.length < u.value;
        (d || f) && (l = this._getOrReturnCtx(t, l), d ? Dt(l, {
          code: ft.too_big,
          maximum: u.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: u.message
        }) : f && Dt(l, {
          code: ft.too_small,
          minimum: u.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: u.message
        }), o.dirty());
      } else if (u.kind === "email")
        qT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "email",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "emoji")
        Ry || (Ry = new RegExp(WT, "u")), Ry.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "emoji",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "uuid")
        IT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "uuid",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "nanoid")
        HT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "nanoid",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "cuid")
        zT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "cuid",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "cuid2")
        BT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "cuid2",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "ulid")
        UT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
          validation: "ulid",
          code: ft.invalid_string,
          message: u.message
        }), o.dirty());
      else if (u.kind === "url")
        try {
          new URL(t.data);
        } catch {
          l = this._getOrReturnCtx(t, l), Dt(l, {
            validation: "url",
            code: ft.invalid_string,
            message: u.message
          }), o.dirty();
        }
      else u.kind === "regex" ? (u.regex.lastIndex = 0, u.regex.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "regex",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty())) : u.kind === "trim" ? t.data = t.data.trim() : u.kind === "includes" ? t.data.includes(u.value, u.position) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: { includes: u.value, position: u.position },
        message: u.message
      }), o.dirty()) : u.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : u.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : u.kind === "startsWith" ? t.data.startsWith(u.value) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: { startsWith: u.value },
        message: u.message
      }), o.dirty()) : u.kind === "endsWith" ? t.data.endsWith(u.value) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: { endsWith: u.value },
        message: u.message
      }), o.dirty()) : u.kind === "datetime" ? eN(u).test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: "datetime",
        message: u.message
      }), o.dirty()) : u.kind === "date" ? JT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: "date",
        message: u.message
      }), o.dirty()) : u.kind === "time" ? $T(u).test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.invalid_string,
        validation: "time",
        message: u.message
      }), o.dirty()) : u.kind === "duration" ? VT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "duration",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : u.kind === "ip" ? tN(t.data, u.version) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "ip",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : u.kind === "jwt" ? nN(t.data, u.alg) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "jwt",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : u.kind === "cidr" ? rN(t.data, u.version) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "cidr",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : u.kind === "base64" ? XT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "base64",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : u.kind === "base64url" ? QT.test(t.data) || (l = this._getOrReturnCtx(t, l), Dt(l, {
        validation: "base64url",
        code: ft.invalid_string,
        message: u.message
      }), o.dirty()) : $n.assertNever(u);
    return { status: o.value, value: t.data };
  }
  _regex(t, r, o) {
    return this.refinement((l) => t.test(l), {
      validation: r,
      code: ft.invalid_string,
      ...Kt.errToObj(o)
    });
  }
  _addCheck(t) {
    return new Ku({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Kt.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Kt.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Kt.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Kt.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Kt.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Kt.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Kt.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Kt.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Kt.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...Kt.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...Kt.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Kt.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...Kt.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...Kt.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Kt.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Kt.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Kt.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...Kt.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Kt.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Kt.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Kt.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Kt.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Kt.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, Kt.errToObj(t));
  }
  trim() {
    return new Ku({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ku({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ku({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
Ku.create = (e) => new Ku({
  checks: [],
  typeName: pn.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Mn(e)
});
function aN(e, t) {
  const r = (e.toString().split(".")[1] || "").length, o = (t.toString().split(".")[1] || "").length, l = r > o ? r : o, u = Number.parseInt(e.toFixed(l).replace(".", "")), d = Number.parseInt(t.toFixed(l).replace(".", ""));
  return u % d / 10 ** l;
}
class Of extends Zn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Gt.number) {
      const u = this._getOrReturnCtx(t);
      return Dt(u, {
        code: ft.invalid_type,
        expected: Gt.number,
        received: u.parsedType
      }), hn;
    }
    let o;
    const l = new ko();
    for (const u of this._def.checks)
      u.kind === "int" ? $n.isInteger(t.data) || (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.invalid_type,
        expected: "integer",
        received: "float",
        message: u.message
      }), l.dirty()) : u.kind === "min" ? (u.inclusive ? t.data < u.value : t.data <= u.value) && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.too_small,
        minimum: u.value,
        type: "number",
        inclusive: u.inclusive,
        exact: !1,
        message: u.message
      }), l.dirty()) : u.kind === "max" ? (u.inclusive ? t.data > u.value : t.data >= u.value) && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.too_big,
        maximum: u.value,
        type: "number",
        inclusive: u.inclusive,
        exact: !1,
        message: u.message
      }), l.dirty()) : u.kind === "multipleOf" ? aN(t.data, u.value) !== 0 && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.not_multiple_of,
        multipleOf: u.value,
        message: u.message
      }), l.dirty()) : u.kind === "finite" ? Number.isFinite(t.data) || (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.not_finite,
        message: u.message
      }), l.dirty()) : $n.assertNever(u);
    return { status: l.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Kt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Kt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Kt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Kt.toString(r));
  }
  setLimit(t, r, o, l) {
    return new Of({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: o,
          message: Kt.toString(l)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Of({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Kt.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Kt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Kt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Kt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Kt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Kt.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Kt.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Kt.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Kt.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && $n.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const o of this._def.checks) {
      if (o.kind === "finite" || o.kind === "int" || o.kind === "multipleOf")
        return !0;
      o.kind === "min" ? (r === null || o.value > r) && (r = o.value) : o.kind === "max" && (t === null || o.value < t) && (t = o.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
Of.create = (e) => new Of({
  checks: [],
  typeName: pn.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Mn(e)
});
class lm extends Zn {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Gt.bigint)
      return this._getInvalidInput(t);
    let o;
    const l = new ko();
    for (const u of this._def.checks)
      u.kind === "min" ? (u.inclusive ? t.data < u.value : t.data <= u.value) && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.too_small,
        type: "bigint",
        minimum: u.value,
        inclusive: u.inclusive,
        message: u.message
      }), l.dirty()) : u.kind === "max" ? (u.inclusive ? t.data > u.value : t.data >= u.value) && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.too_big,
        type: "bigint",
        maximum: u.value,
        inclusive: u.inclusive,
        message: u.message
      }), l.dirty()) : u.kind === "multipleOf" ? t.data % u.value !== BigInt(0) && (o = this._getOrReturnCtx(t, o), Dt(o, {
        code: ft.not_multiple_of,
        multipleOf: u.value,
        message: u.message
      }), l.dirty()) : $n.assertNever(u);
    return { status: l.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return Dt(r, {
      code: ft.invalid_type,
      expected: Gt.bigint,
      received: r.parsedType
    }), hn;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, Kt.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, Kt.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, Kt.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, Kt.toString(r));
  }
  setLimit(t, r, o, l) {
    return new lm({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: o,
          message: Kt.toString(l)
        }
      ]
    });
  }
  _addCheck(t) {
    return new lm({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Kt.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Kt.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Kt.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Kt.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Kt.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
lm.create = (e) => new lm({
  checks: [],
  typeName: pn.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...Mn(e)
});
class O2 extends Zn {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Gt.boolean) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.boolean,
        received: o.parsedType
      }), hn;
    }
    return Xo(t.data);
  }
}
O2.create = (e) => new O2({
  typeName: pn.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Mn(e)
});
class T0 extends Zn {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Gt.date) {
      const u = this._getOrReturnCtx(t);
      return Dt(u, {
        code: ft.invalid_type,
        expected: Gt.date,
        received: u.parsedType
      }), hn;
    }
    if (Number.isNaN(t.data.getTime())) {
      const u = this._getOrReturnCtx(t);
      return Dt(u, {
        code: ft.invalid_date
      }), hn;
    }
    const o = new ko();
    let l;
    for (const u of this._def.checks)
      u.kind === "min" ? t.data.getTime() < u.value && (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.too_small,
        message: u.message,
        inclusive: !0,
        exact: !1,
        minimum: u.value,
        type: "date"
      }), o.dirty()) : u.kind === "max" ? t.data.getTime() > u.value && (l = this._getOrReturnCtx(t, l), Dt(l, {
        code: ft.too_big,
        message: u.message,
        inclusive: !0,
        exact: !1,
        maximum: u.value,
        type: "date"
      }), o.dirty()) : $n.assertNever(u);
    return {
      status: o.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new T0({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Kt.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Kt.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
T0.create = (e) => new T0({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: pn.ZodDate,
  ...Mn(e)
});
class p3 extends Zn {
  _parse(t) {
    if (this._getType(t) !== Gt.symbol) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.symbol,
        received: o.parsedType
      }), hn;
    }
    return Xo(t.data);
  }
}
p3.create = (e) => new p3({
  typeName: pn.ZodSymbol,
  ...Mn(e)
});
class m3 extends Zn {
  _parse(t) {
    if (this._getType(t) !== Gt.undefined) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.undefined,
        received: o.parsedType
      }), hn;
    }
    return Xo(t.data);
  }
}
m3.create = (e) => new m3({
  typeName: pn.ZodUndefined,
  ...Mn(e)
});
class g3 extends Zn {
  _parse(t) {
    if (this._getType(t) !== Gt.null) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.null,
        received: o.parsedType
      }), hn;
    }
    return Xo(t.data);
  }
}
g3.create = (e) => new g3({
  typeName: pn.ZodNull,
  ...Mn(e)
});
class v3 extends Zn {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Xo(t.data);
  }
}
v3.create = (e) => new v3({
  typeName: pn.ZodAny,
  ...Mn(e)
});
class y3 extends Zn {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Xo(t.data);
  }
}
y3.create = (e) => new y3({
  typeName: pn.ZodUnknown,
  ...Mn(e)
});
class ac extends Zn {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return Dt(r, {
      code: ft.invalid_type,
      expected: Gt.never,
      received: r.parsedType
    }), hn;
  }
}
ac.create = (e) => new ac({
  typeName: pn.ZodNever,
  ...Mn(e)
});
class b3 extends Zn {
  _parse(t) {
    if (this._getType(t) !== Gt.undefined) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.void,
        received: o.parsedType
      }), hn;
    }
    return Xo(t.data);
  }
}
b3.create = (e) => new b3({
  typeName: pn.ZodVoid,
  ...Mn(e)
});
class hl extends Zn {
  _parse(t) {
    const { ctx: r, status: o } = this._processInputParams(t), l = this._def;
    if (r.parsedType !== Gt.array)
      return Dt(r, {
        code: ft.invalid_type,
        expected: Gt.array,
        received: r.parsedType
      }), hn;
    if (l.exactLength !== null) {
      const d = r.data.length > l.exactLength.value, f = r.data.length < l.exactLength.value;
      (d || f) && (Dt(r, {
        code: d ? ft.too_big : ft.too_small,
        minimum: f ? l.exactLength.value : void 0,
        maximum: d ? l.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: l.exactLength.message
      }), o.dirty());
    }
    if (l.minLength !== null && r.data.length < l.minLength.value && (Dt(r, {
      code: ft.too_small,
      minimum: l.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: l.minLength.message
    }), o.dirty()), l.maxLength !== null && r.data.length > l.maxLength.value && (Dt(r, {
      code: ft.too_big,
      maximum: l.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: l.maxLength.message
    }), o.dirty()), r.common.async)
      return Promise.all([...r.data].map((d, f) => l.type._parseAsync(new rc(r, d, r.path, f)))).then((d) => ko.mergeArray(o, d));
    const u = [...r.data].map((d, f) => l.type._parseSync(new rc(r, d, r.path, f)));
    return ko.mergeArray(o, u);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new hl({
      ...this._def,
      minLength: { value: t, message: Kt.toString(r) }
    });
  }
  max(t, r) {
    return new hl({
      ...this._def,
      maxLength: { value: t, message: Kt.toString(r) }
    });
  }
  length(t, r) {
    return new hl({
      ...this._def,
      exactLength: { value: t, message: Kt.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
hl.create = (e, t) => new hl({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: pn.ZodArray,
  ...Mn(t)
});
function Cf(e) {
  if (e instanceof pa) {
    const t = {};
    for (const r in e.shape) {
      const o = e.shape[r];
      t[r] = $u.create(Cf(o));
    }
    return new pa({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof hl ? new hl({
    ...e._def,
    type: Cf(e.element)
  }) : e instanceof $u ? $u.create(Cf(e.unwrap())) : e instanceof zf ? zf.create(Cf(e.unwrap())) : e instanceof sd ? sd.create(e.items.map((t) => Cf(t))) : e;
}
class pa extends Zn {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = $n.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== Gt.object) {
      const h = this._getOrReturnCtx(t);
      return Dt(h, {
        code: ft.invalid_type,
        expected: Gt.object,
        received: h.parsedType
      }), hn;
    }
    const { status: o, ctx: l } = this._processInputParams(t), { shape: u, keys: d } = this._getCached(), f = [];
    if (!(this._def.catchall instanceof ac && this._def.unknownKeys === "strip"))
      for (const h in l.data)
        d.includes(h) || f.push(h);
    const g = [];
    for (const h of d) {
      const v = u[h], E = l.data[h];
      g.push({
        key: { status: "valid", value: h },
        value: v._parse(new rc(l, E, l.path, h)),
        alwaysSet: h in l.data
      });
    }
    if (this._def.catchall instanceof ac) {
      const h = this._def.unknownKeys;
      if (h === "passthrough")
        for (const v of f)
          g.push({
            key: { status: "valid", value: v },
            value: { status: "valid", value: l.data[v] }
          });
      else if (h === "strict")
        f.length > 0 && (Dt(l, {
          code: ft.unrecognized_keys,
          keys: f
        }), o.dirty());
      else if (h !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const h = this._def.catchall;
      for (const v of f) {
        const E = l.data[v];
        g.push({
          key: { status: "valid", value: v },
          value: h._parse(
            new rc(l, E, l.path, v)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: v in l.data
        });
      }
    }
    return l.common.async ? Promise.resolve().then(async () => {
      const h = [];
      for (const v of g) {
        const E = await v.key, S = await v.value;
        h.push({
          key: E,
          value: S,
          alwaysSet: v.alwaysSet
        });
      }
      return h;
    }).then((h) => ko.mergeObjectSync(o, h)) : ko.mergeObjectSync(o, g);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Kt.errToObj, new pa({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, o) => {
          var u, d;
          const l = ((d = (u = this._def).errorMap) == null ? void 0 : d.call(u, r, o).message) ?? o.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: Kt.errToObj(t).message ?? l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new pa({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new pa({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new pa({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new pa({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: pn.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new pa({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const o of $n.objectKeys(t))
      t[o] && this.shape[o] && (r[o] = this.shape[o]);
    return new pa({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const o of $n.objectKeys(this.shape))
      t[o] || (r[o] = this.shape[o]);
    return new pa({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Cf(this);
  }
  partial(t) {
    const r = {};
    for (const o of $n.objectKeys(this.shape)) {
      const l = this.shape[o];
      t && !t[o] ? r[o] = l : r[o] = l.optional();
    }
    return new pa({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const o of $n.objectKeys(this.shape))
      if (t && !t[o])
        r[o] = this.shape[o];
      else {
        let u = this.shape[o];
        for (; u instanceof $u; )
          u = u._def.innerType;
        r[o] = u;
      }
    return new pa({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return o6($n.objectKeys(this.shape));
  }
}
pa.create = (e, t) => new pa({
  shape: () => e,
  unknownKeys: "strip",
  catchall: ac.create(),
  typeName: pn.ZodObject,
  ...Mn(t)
});
pa.strictCreate = (e, t) => new pa({
  shape: () => e,
  unknownKeys: "strict",
  catchall: ac.create(),
  typeName: pn.ZodObject,
  ...Mn(t)
});
pa.lazycreate = (e, t) => new pa({
  shape: e,
  unknownKeys: "strip",
  catchall: ac.create(),
  typeName: pn.ZodObject,
  ...Mn(t)
});
class N0 extends Zn {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = this._def.options;
    function l(u) {
      for (const f of u)
        if (f.result.status === "valid")
          return f.result;
      for (const f of u)
        if (f.result.status === "dirty")
          return r.common.issues.push(...f.ctx.common.issues), f.result;
      const d = u.map((f) => new Xl(f.ctx.common.issues));
      return Dt(r, {
        code: ft.invalid_union,
        unionErrors: d
      }), hn;
    }
    if (r.common.async)
      return Promise.all(o.map(async (u) => {
        const d = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await u._parseAsync({
            data: r.data,
            path: r.path,
            parent: d
          }),
          ctx: d
        };
      })).then(l);
    {
      let u;
      const d = [];
      for (const g of o) {
        const h = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, v = g._parseSync({
          data: r.data,
          path: r.path,
          parent: h
        });
        if (v.status === "valid")
          return v;
        v.status === "dirty" && !u && (u = { result: v, ctx: h }), h.common.issues.length && d.push(h.common.issues);
      }
      if (u)
        return r.common.issues.push(...u.ctx.common.issues), u.result;
      const f = d.map((g) => new Xl(g));
      return Dt(r, {
        code: ft.invalid_union,
        unionErrors: f
      }), hn;
    }
  }
  get options() {
    return this._def.options;
  }
}
N0.create = (e, t) => new N0({
  options: e,
  typeName: pn.ZodUnion,
  ...Mn(t)
});
function F2(e, t) {
  const r = Hu(e), o = Hu(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === Gt.object && o === Gt.object) {
    const l = $n.objectKeys(t), u = $n.objectKeys(e).filter((f) => l.indexOf(f) !== -1), d = { ...e, ...t };
    for (const f of u) {
      const g = F2(e[f], t[f]);
      if (!g.valid)
        return { valid: !1 };
      d[f] = g.data;
    }
    return { valid: !0, data: d };
  } else if (r === Gt.array && o === Gt.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const l = [];
    for (let u = 0; u < e.length; u++) {
      const d = e[u], f = t[u], g = F2(d, f);
      if (!g.valid)
        return { valid: !1 };
      l.push(g.data);
    }
    return { valid: !0, data: l };
  } else return r === Gt.date && o === Gt.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class A0 extends Zn {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t), l = (u, d) => {
      if (d3(u) || d3(d))
        return hn;
      const f = F2(u.value, d.value);
      return f.valid ? ((f3(u) || f3(d)) && r.dirty(), { status: r.value, value: f.data }) : (Dt(o, {
        code: ft.invalid_intersection_types
      }), hn);
    };
    return o.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      }),
      this._def.right._parseAsync({
        data: o.data,
        path: o.path,
        parent: o
      })
    ]).then(([u, d]) => l(u, d)) : l(this._def.left._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }), this._def.right._parseSync({
      data: o.data,
      path: o.path,
      parent: o
    }));
  }
}
A0.create = (e, t, r) => new A0({
  left: e,
  right: t,
  typeName: pn.ZodIntersection,
  ...Mn(r)
});
class sd extends Zn {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Gt.array)
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.array,
        received: o.parsedType
      }), hn;
    if (o.data.length < this._def.items.length)
      return Dt(o, {
        code: ft.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), hn;
    !this._def.rest && o.data.length > this._def.items.length && (Dt(o, {
      code: ft.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const u = [...o.data].map((d, f) => {
      const g = this._def.items[f] || this._def.rest;
      return g ? g._parse(new rc(o, d, o.path, f)) : null;
    }).filter((d) => !!d);
    return o.common.async ? Promise.all(u).then((d) => ko.mergeArray(r, d)) : ko.mergeArray(r, u);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new sd({
      ...this._def,
      rest: t
    });
  }
}
sd.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new sd({
    items: e,
    typeName: pn.ZodTuple,
    rest: null,
    ...Mn(t)
  });
};
class _3 extends Zn {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Gt.map)
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.map,
        received: o.parsedType
      }), hn;
    const l = this._def.keyType, u = this._def.valueType, d = [...o.data.entries()].map(([f, g], h) => ({
      key: l._parse(new rc(o, f, o.path, [h, "key"])),
      value: u._parse(new rc(o, g, o.path, [h, "value"]))
    }));
    if (o.common.async) {
      const f = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const g of d) {
          const h = await g.key, v = await g.value;
          if (h.status === "aborted" || v.status === "aborted")
            return hn;
          (h.status === "dirty" || v.status === "dirty") && r.dirty(), f.set(h.value, v.value);
        }
        return { status: r.value, value: f };
      });
    } else {
      const f = /* @__PURE__ */ new Map();
      for (const g of d) {
        const h = g.key, v = g.value;
        if (h.status === "aborted" || v.status === "aborted")
          return hn;
        (h.status === "dirty" || v.status === "dirty") && r.dirty(), f.set(h.value, v.value);
      }
      return { status: r.value, value: f };
    }
  }
}
_3.create = (e, t, r) => new _3({
  valueType: t,
  keyType: e,
  typeName: pn.ZodMap,
  ...Mn(r)
});
class um extends Zn {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.parsedType !== Gt.set)
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.set,
        received: o.parsedType
      }), hn;
    const l = this._def;
    l.minSize !== null && o.data.size < l.minSize.value && (Dt(o, {
      code: ft.too_small,
      minimum: l.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: l.minSize.message
    }), r.dirty()), l.maxSize !== null && o.data.size > l.maxSize.value && (Dt(o, {
      code: ft.too_big,
      maximum: l.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: l.maxSize.message
    }), r.dirty());
    const u = this._def.valueType;
    function d(g) {
      const h = /* @__PURE__ */ new Set();
      for (const v of g) {
        if (v.status === "aborted")
          return hn;
        v.status === "dirty" && r.dirty(), h.add(v.value);
      }
      return { status: r.value, value: h };
    }
    const f = [...o.data.values()].map((g, h) => u._parse(new rc(o, g, o.path, h)));
    return o.common.async ? Promise.all(f).then((g) => d(g)) : d(f);
  }
  min(t, r) {
    return new um({
      ...this._def,
      minSize: { value: t, message: Kt.toString(r) }
    });
  }
  max(t, r) {
    return new um({
      ...this._def,
      maxSize: { value: t, message: Kt.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
um.create = (e, t) => new um({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: pn.ZodSet,
  ...Mn(t)
});
class S3 extends Zn {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
S3.create = (e, t) => new S3({
  getter: e,
  typeName: pn.ZodLazy,
  ...Mn(t)
});
class z2 extends Zn {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return Dt(r, {
        received: r.data,
        code: ft.invalid_literal,
        expected: this._def.value
      }), hn;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
z2.create = (e, t) => new z2({
  value: e,
  typeName: pn.ZodLiteral,
  ...Mn(t)
});
function o6(e, t) {
  return new Ff({
    values: e,
    typeName: pn.ZodEnum,
    ...Mn(t)
  });
}
class Ff extends Zn {
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), o = this._def.values;
      return Dt(r, {
        expected: $n.joinValues(o),
        received: r.parsedType,
        code: ft.invalid_type
      }), hn;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(t.data)) {
      const r = this._getOrReturnCtx(t), o = this._def.values;
      return Dt(r, {
        received: r.data,
        code: ft.invalid_enum_value,
        options: o
      }), hn;
    }
    return Xo(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Ff.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Ff.create(this.options.filter((o) => !t.includes(o)), {
      ...this._def,
      ...r
    });
  }
}
Ff.create = o6;
class w3 extends Zn {
  _parse(t) {
    const r = $n.getValidEnumValues(this._def.values), o = this._getOrReturnCtx(t);
    if (o.parsedType !== Gt.string && o.parsedType !== Gt.number) {
      const l = $n.objectValues(r);
      return Dt(o, {
        expected: $n.joinValues(l),
        received: o.parsedType,
        code: ft.invalid_type
      }), hn;
    }
    if (this._cache || (this._cache = new Set($n.getValidEnumValues(this._def.values))), !this._cache.has(t.data)) {
      const l = $n.objectValues(r);
      return Dt(o, {
        received: o.data,
        code: ft.invalid_enum_value,
        options: l
      }), hn;
    }
    return Xo(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
w3.create = (e, t) => new w3({
  values: e,
  typeName: pn.ZodNativeEnum,
  ...Mn(t)
});
class M0 extends Zn {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Gt.promise && r.common.async === !1)
      return Dt(r, {
        code: ft.invalid_type,
        expected: Gt.promise,
        received: r.parsedType
      }), hn;
    const o = r.parsedType === Gt.promise ? r.data : Promise.resolve(r.data);
    return Xo(o.then((l) => this._def.type.parseAsync(l, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
M0.create = (e, t) => new M0({
  type: e,
  typeName: pn.ZodPromise,
  ...Mn(t)
});
class ld extends Zn {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === pn.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t), l = this._def.effect || null, u = {
      addIssue: (d) => {
        Dt(o, d), d.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return o.path;
      }
    };
    if (u.addIssue = u.addIssue.bind(u), l.type === "preprocess") {
      const d = l.transform(o.data, u);
      if (o.common.async)
        return Promise.resolve(d).then(async (f) => {
          if (r.value === "aborted")
            return hn;
          const g = await this._def.schema._parseAsync({
            data: f,
            path: o.path,
            parent: o
          });
          return g.status === "aborted" ? hn : g.status === "dirty" || r.value === "dirty" ? qp(g.value) : g;
        });
      {
        if (r.value === "aborted")
          return hn;
        const f = this._def.schema._parseSync({
          data: d,
          path: o.path,
          parent: o
        });
        return f.status === "aborted" ? hn : f.status === "dirty" || r.value === "dirty" ? qp(f.value) : f;
      }
    }
    if (l.type === "refinement") {
      const d = (f) => {
        const g = l.refinement(f, u);
        if (o.common.async)
          return Promise.resolve(g);
        if (g instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return f;
      };
      if (o.common.async === !1) {
        const f = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return f.status === "aborted" ? hn : (f.status === "dirty" && r.dirty(), d(f.value), { status: r.value, value: f.value });
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((f) => f.status === "aborted" ? hn : (f.status === "dirty" && r.dirty(), d(f.value).then(() => ({ status: r.value, value: f.value }))));
    }
    if (l.type === "transform")
      if (o.common.async === !1) {
        const d = this._def.schema._parseSync({
          data: o.data,
          path: o.path,
          parent: o
        });
        if (!Lf(d))
          return hn;
        const f = l.transform(d.value, u);
        if (f instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: f };
      } else
        return this._def.schema._parseAsync({ data: o.data, path: o.path, parent: o }).then((d) => Lf(d) ? Promise.resolve(l.transform(d.value, u)).then((f) => ({
          status: r.value,
          value: f
        })) : hn);
    $n.assertNever(l);
  }
}
ld.create = (e, t, r) => new ld({
  schema: e,
  typeName: pn.ZodEffects,
  effect: t,
  ...Mn(r)
});
ld.createWithPreprocess = (e, t, r) => new ld({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: pn.ZodEffects,
  ...Mn(r)
});
class $u extends Zn {
  _parse(t) {
    return this._getType(t) === Gt.undefined ? Xo(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
$u.create = (e, t) => new $u({
  innerType: e,
  typeName: pn.ZodOptional,
  ...Mn(t)
});
class zf extends Zn {
  _parse(t) {
    return this._getType(t) === Gt.null ? Xo(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
zf.create = (e, t) => new zf({
  innerType: e,
  typeName: pn.ZodNullable,
  ...Mn(t)
});
class B2 extends Zn {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let o = r.data;
    return r.parsedType === Gt.undefined && (o = this._def.defaultValue()), this._def.innerType._parse({
      data: o,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
B2.create = (e, t) => new B2({
  innerType: e,
  typeName: pn.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Mn(t)
});
class U2 extends Zn {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, l = this._def.innerType._parse({
      data: o.data,
      path: o.path,
      parent: {
        ...o
      }
    });
    return R0(l) ? l.then((u) => ({
      status: "valid",
      value: u.status === "valid" ? u.value : this._def.catchValue({
        get error() {
          return new Xl(o.common.issues);
        },
        input: o.data
      })
    })) : {
      status: "valid",
      value: l.status === "valid" ? l.value : this._def.catchValue({
        get error() {
          return new Xl(o.common.issues);
        },
        input: o.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
U2.create = (e, t) => new U2({
  innerType: e,
  typeName: pn.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Mn(t)
});
class x3 extends Zn {
  _parse(t) {
    if (this._getType(t) !== Gt.nan) {
      const o = this._getOrReturnCtx(t);
      return Dt(o, {
        code: ft.invalid_type,
        expected: Gt.nan,
        received: o.parsedType
      }), hn;
    }
    return { status: "valid", value: t.data };
  }
}
x3.create = (e) => new x3({
  typeName: pn.ZodNaN,
  ...Mn(e)
});
class iN extends Zn {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), o = r.data;
    return this._def.type._parse({
      data: o,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class pb extends Zn {
  _parse(t) {
    const { status: r, ctx: o } = this._processInputParams(t);
    if (o.common.async)
      return (async () => {
        const u = await this._def.in._parseAsync({
          data: o.data,
          path: o.path,
          parent: o
        });
        return u.status === "aborted" ? hn : u.status === "dirty" ? (r.dirty(), qp(u.value)) : this._def.out._parseAsync({
          data: u.value,
          path: o.path,
          parent: o
        });
      })();
    {
      const l = this._def.in._parseSync({
        data: o.data,
        path: o.path,
        parent: o
      });
      return l.status === "aborted" ? hn : l.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: l.value
      }) : this._def.out._parseSync({
        data: l.value,
        path: o.path,
        parent: o
      });
    }
  }
  static create(t, r) {
    return new pb({
      in: t,
      out: r,
      typeName: pn.ZodPipeline
    });
  }
}
class I2 extends Zn {
  _parse(t) {
    const r = this._def.innerType._parse(t), o = (l) => (Lf(l) && (l.value = Object.freeze(l.value)), l);
    return R0(r) ? r.then((l) => o(l)) : o(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
I2.create = (e, t) => new I2({
  innerType: e,
  typeName: pn.ZodReadonly,
  ...Mn(t)
});
var pn;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(pn || (pn = {}));
const Hn = Ku.create, $t = Of.create, Or = O2.create;
ac.create;
const Xp = hl.create, ol = pa.create, s6 = N0.create;
A0.create;
sd.create;
const pl = z2.create, Ri = Ff.create;
M0.create;
$u.create;
zf.create;
const Y0 = ld.createWithPreprocess, oN = {
  "ILCA / Laser": "ILCA",
  Firefly: "420",
  Topper: "ILCA",
  "Generic dinghy": "420",
  "Generic catamaran": "Tornado",
  "Generic skiff": "49er",
  Windsurfer: "Windsurf",
  "Wingfoil board": "Windsurf",
  Wingfoil: "Windsurf",
  kitefoil: "Windsurf",
  "Coach boat": "Coachboat",
  "Slim coachboat": "Coachboat",
  "VSR Coachboat": "Coachboat",
  "Jury boat": "Umpire boat"
}, l6 = (e) => typeof e == "string" ? oN[e] ?? e : e, ic = ol({
  id: Hn().min(1),
  x: $t().finite(),
  y: $t().finite(),
  rotation: $t().finite(),
  scaleX: $t().finite(),
  scaleY: $t().finite(),
  visible: Or(),
  locked: Or(),
  zIndex: $t().int(),
  opacity: $t().min(0).max(1)
}), sN = ic.extend({
  type: pl("boat"),
  boatClass: Y0(l6, Ri(j0)),
  name: Hn(),
  sailNumber: Hn(),
  label: Hn(),
  color: Hn(),
  heading: $t().finite(),
  tack: Ri(["port", "starboard"]),
  mainsailVisible: Or(),
  jibVisible: Or(),
  genoaVisible: Or().default(!1),
  spinnakerVisible: Or().default(!1),
  gennakerVisible: Or(),
  mainsailTrim: $t().min(-180).max(180).default(0),
  jibTrim: $t().min(-180).max(180),
  spinnakerTrim: $t().min(-180).max(180).default(0),
  gennakerTrim: $t().min(-180).max(180),
  sailMode: Ri(["automatic", "manual"]),
  sailAngle: $t().finite(),
  sequenceId: Hn().optional(),
  positionNumber: $t().int().positive().optional(),
  overlapIndicator: Ri(["port", "none", "starboard"]).default("none"),
  protestFlagSide: Ri(ET).optional(),
  protestFlagVisible: Or().optional(),
  boatFlagColor: Hn().nullable().default(null),
  umpireSignalFlag: Ri(cb).default("none"),
  stateMarker: Ri(["none", "tack", "gybe", "head-to-wind", "reverse", "drift"]).optional()
}), lN = ic.extend({
  type: pl("mark"),
  markType: Ri(["racing", "starting", "finish"]),
  shape: Ri(["round", "cylindrical", "inflatable", "flag", "gate", "pin"]),
  color: Hn(),
  label: Hn(),
  markNumber: Y0(
    (e) => typeof e == "number" ? String(e) : e,
    Hn().regex(/^[1-9]\d*[a-z]?$/i).max(6).optional()
  ),
  downwind: Or().default(!1),
  laylinesVisible: Or().default(!0),
  zoneVisible: Or(),
  zoneRadius: $t().positive(),
  zoneRadiusUnit: Ri(["pixels", "boat-lengths"]).default("pixels")
}), uN = (e) => e === "slim-coach-boat" ? "coach-boat" : e === "slim-coach-boat-reversed" ? "coach-boat-reversed" : e, P0 = Y0(
  uN,
  Ri([
    "committee-boat",
    "committee-boat-reversed",
    "buoy",
    "flag",
    "coach-boat",
    "coach-boat-reversed"
  ])
), cN = ic.extend({
  type: pl("gate"),
  width: $t().positive().optional(),
  endAX: $t().finite().optional(),
  endAY: $t().finite().optional(),
  endBX: $t().finite().optional(),
  endBY: $t().finite().optional(),
  markNumber: $t().int().positive().optional(),
  color: Hn(),
  zoneVisible: Or(),
  zoneRadius: $t().positive(),
  zoneRadiusUnit: pl("boat-lengths")
}), dN = ic.extend({
  type: pl("start-line"),
  width: $t().positive().optional(),
  endAX: $t().finite().optional(),
  endAY: $t().finite().optional(),
  endBX: $t().finite().optional(),
  endBY: $t().finite().optional(),
  color: Hn(),
  startEndType: P0,
  pinEndType: P0,
  startEndFlagColor: Hn().optional(),
  pinEndFlagColor: Hn().optional(),
  laylinesVisible: Or().optional(),
  laylineAreaVisible: Or().optional(),
  laylineAreaColor: Hn().optional()
}), fN = ic.extend({
  type: pl("finish-line"),
  width: $t().positive().optional(),
  endAX: $t().finite().optional(),
  endAY: $t().finite().optional(),
  endBX: $t().finite().optional(),
  endBY: $t().finite().optional(),
  color: Hn(),
  startEndType: P0,
  pinEndType: P0,
  startEndFlagColor: Hn().optional(),
  pinEndFlagColor: Hn().optional(),
  laylinesVisible: Or().optional(),
  laylineAreaVisible: Or().optional(),
  laylineAreaColor: Hn().optional()
}), hN = ic.extend({
  type: Ri(["line", "arrow", "freehand"]),
  points: Xp($t().finite()).min(4),
  stroke: Hn(),
  strokeWidth: $t().positive(),
  dash: Xp($t().nonnegative())
}), pN = ic.extend({
  type: pl("text"),
  text: Hn(),
  color: Hn(),
  fontSize: $t().min(8).max(200),
  fontWeight: Ri(["normal", "bold"]),
  align: Ri(["left", "center", "right"]),
  background: Hn()
}), mN = ic.extend({
  type: Ri(["rectangle", "circle"]),
  width: $t().positive(),
  height: $t().positive(),
  stroke: Hn(),
  strokeWidth: $t().positive(),
  fill: Hn()
}), gN = s6([
  sN,
  lN,
  cN,
  dN,
  fN,
  hN,
  pN,
  mN
]), u6 = ol({
  format: s6([pl("sailplot"), pl("sailing-scenario")]),
  version: pl(1),
  metadata: ol({
    id: Hn().min(1),
    title: Hn().min(1),
    description: Hn(),
    ruleReferences: Xp(Hn()),
    additionalInformation: Xp(
      ol({
        id: Hn().min(1),
        name: Hn(),
        value: Hn()
      })
    ).max(10).default([]),
    createdAt: Hn(),
    updatedAt: Hn()
  }).passthrough(),
  canvas: ol({
    width: $t().positive(),
    height: $t().positive(),
    infinite: Or().default(!1),
    background: Hn(),
    boatNumbersVisible: Or().default(!0),
    boatLegendVisible: Or().default(!1),
    windIndicatorPosition: ol({ x: $t().finite(), y: $t().finite() }).nullable().default(null),
    boatLegendPosition: ol({ x: $t().finite(), y: $t().finite() }).nullable().default(null),
    grid: ol({
      visible: Or(),
      size: $t().positive(),
      opacity: $t().min(0).max(1).default(1)
    }),
    view: ol({ x: $t(), y: $t(), scale: $t().positive() })
  }),
  environment: ol({
    windDirection: $t(),
    windStrength: Hn().nullable(),
    windVisible: Or(),
    laylineAngle: $t().min(0).max(90),
    laylinesVisible: Or(),
    zonesVisible: Or(),
    zoneRadiusBoatLengths: $t().positive(),
    measurementBoatClass: Y0((e) => {
      const t = l6(e);
      return t == null || Zl(t) ? null : t;
    }, Ri(j0).nullable())
  }),
  objects: Xp(gN)
}).passthrough(), vN = 1;
function mb(e) {
  var u;
  const t = e == null ? void 0 : e.version, r = Array.isArray(
    (u = e == null ? void 0 : e.metadata) == null ? void 0 : u.additionalInformation
  );
  if (typeof t != "number") throw new Error("The plot format version is missing.");
  if (t > vN)
    throw new Error(`Format version ${t} is newer than this app supports.`);
  const o = u6.parse(e);
  let l = o.objects.reduce(
    (d, f) => f.type === "mark" || f.type === "gate" ? Math.max(d, D2(f.markNumber)) : d,
    0
  ) + 1;
  return {
    ...o,
    format: "sailplot",
    metadata: {
      ...o.metadata,
      additionalInformation: r ? o.metadata.additionalInformation : [
        {
          id: Ka(),
          name: o.environment.windStrength ? "Wind strength" : "",
          value: o.environment.windStrength ?? ""
        }
      ]
    },
    canvas: {
      ...o.canvas,
      background: RT(o.canvas.background),
      view: { ...o.canvas.view, scale: Math.max(1, o.canvas.view.scale) }
    },
    objects: o.objects.map((d) => {
      if (d.type === "boat") {
        const { protestFlagVisible: f, ...g } = d;
        return {
          ...g,
          color: Ju(d.boatClass, d.color),
          sequenceId: d.sequenceId ?? Ka(),
          positionNumber: d.positionNumber ?? 1,
          overlapIndicator: d.overlapIndicator ?? "none",
          protestFlagSide: Zl(d.boatClass) ? "none" : d.protestFlagSide ?? (f ? "port" : "none")
        };
      }
      if (d.type === "mark") {
        const f = d.markNumber ?? String(l);
        return l = Math.max(l, D2(f) + 1), {
          ...d,
          rotation: 0,
          shape: d.shape === "pin" ? "flag" : d.shape,
          markNumber: f,
          zoneRadius: d.zoneRadiusUnit === "boat-lengths" ? d.zoneRadius : Math.max(0.25, d.zoneRadius / 36),
          zoneRadiusUnit: "boat-lengths"
        };
      }
      if (d.type === "gate" || d.type === "start-line" || d.type === "finish-line") {
        const f = d.width ?? (d.type === "gate" ? 240 : 400), g = d.rotation * Math.PI / 180, h = d.endAX ?? -Math.cos(g) * (f / 2), v = d.endAY ?? -Math.sin(g) * (f / 2), E = d.endBX ?? Math.cos(g) * (f / 2), S = d.endBY ?? Math.sin(g) * (f / 2);
        if (d.type === "gate") {
          const T = d.markNumber ?? l;
          return l = Math.max(l, T + 1), {
            ...d,
            rotation: 0,
            endAX: h,
            endAY: v,
            endBX: E,
            endBY: S,
            markNumber: T
          };
        }
        const w = d.type === "finish-line" ? Zp : Vf;
        return {
          ...d,
          rotation: 0,
          endAX: h,
          endAY: v,
          endBX: E,
          endBY: S,
          startEndFlagColor: d.startEndFlagColor ?? w,
          pinEndFlagColor: d.pinEndFlagColor ?? w,
          laylinesVisible: d.laylinesVisible ?? !1,
          laylineAreaVisible: d.laylineAreaVisible ?? !1,
          laylineAreaColor: d.laylineAreaColor ?? w
        };
      }
      return d;
    })
  };
}
const c6 = [
  "boat",
  "mark",
  "gate",
  "start-line",
  "finish-line",
  "line",
  "arrow",
  "freehand",
  "text",
  "rectangle",
  "circle"
], d6 = [
  "Optimist",
  "ILCA",
  "Generic keelboat",
  "Lacustre",
  "Tornado",
  "420",
  "470",
  "29er",
  "49er",
  "Windsurf",
  "Coachboat",
  null,
  "Committee boat",
  "Umpire boat"
], f6 = [
  "#FFAA00",
  "#171717",
  "transparent",
  "#A3A3A3",
  "#168DDD",
  od.light,
  od.dark,
  "#18324A",
  "#2F5D78",
  "#1F6D68",
  "#4F6B52",
  "#884454",
  "#B46632",
  "#5B6572",
  "#79B8D1",
  "#5F9FC2",
  "#55B5AA",
  "#89AA8C",
  "#D2879E",
  "#D99A68",
  "#B8C1C9",
  "#D72638",
  "#FFD100",
  "#00843D",
  "#FFFFFF",
  "#4B5563"
], h6 = ["racing", "starting", "finish"], p6 = ["round", "cylindrical", "inflatable", "flag", "gate", "pin"], D0 = [
  "committee-boat",
  "buoy",
  "flag",
  "coach-boat",
  "coach-boat-reversed",
  "committee-boat-reversed"
], m6 = ["none", "port", "starboard"], g6 = ["none", "tack", "gybe", "head-to-wind", "reverse", "drift"], v6 = ["left", "center", "right"], ct = (e, t) => Math.floor(e / 2 ** t) % 2 === 1;
function Es(e) {
  let t = 0;
  const r = [];
  return e.forEach((o, l) => {
    o.changed && (t += 2 ** l, "value" in o && r.push(o.value ?? null));
  }), [t, ...r];
}
class Z0 {
  constructor(t) {
    Jg(this, "index", 0);
    this.values = t;
  }
  take() {
    if (this.index >= this.values.length) throw new Error("The compact plot data is incomplete.");
    return this.values[this.index++];
  }
  finish() {
    if (this.index !== this.values.length) throw new Error("The compact plot data is damaged.");
  }
}
const Wo = (e, t) => {
  if (!Array.isArray(e)) throw new Error(`The compact ${t} data is damaged.`);
  return e;
}, qt = (e, t) => {
  if (typeof e != "number" || !Number.isFinite(e))
    throw new Error(`The compact ${t} data is damaged.`);
  return e;
}, wo = (e, t) => {
  if (typeof e != "string") throw new Error(`The compact ${t} data is damaged.`);
  return e;
}, y6 = (e) => {
  const t = d6.indexOf(e);
  if (t < 0) throw new Error("The boat class cannot be encoded.");
  return t;
}, b6 = (e, t) => {
  const r = qt(e, t), o = d6[r];
  if (o === void 0) throw new Error(`The compact ${t} data is damaged.`);
  return o ?? "Umpire boat";
}, sl = (e, t, r) => {
  const o = e[qt(t, r)];
  if (o === void 0) throw new Error(`The compact ${r} data is damaged.`);
  return o;
}, no = (e) => {
  const t = f6.findIndex((r) => r === e);
  return t >= 0 ? t : e;
}, ro = (e) => typeof e == "number" ? sl(f6, e, "colour") : wo(e, "colour"), yN = (e) => /^[1-9]\d*$/.test(e) && Number.isSafeInteger(Number(e)) ? Number(e) : e;
function bN(e) {
  const t = e.metadata.additionalInformation.length === 1 && e.metadata.additionalInformation[0].name === "" && e.metadata.additionalInformation[0].value === "";
  return Es([
    { changed: e.metadata.title !== "Untitled plot", value: e.metadata.title },
    { changed: e.metadata.description !== "", value: e.metadata.description },
    {
      changed: e.metadata.ruleReferences.length > 0,
      value: e.metadata.ruleReferences
    },
    {
      changed: !t,
      value: e.metadata.additionalInformation.map(({ name: r, value: o }) => [r, o])
    }
  ]);
}
function _N(e, t) {
  const [r, ...o] = Wo(e, "metadata"), l = qt(r, "metadata mask"), u = new Z0(o);
  ct(l, 0) && (t.metadata.title = wo(u.take(), "title")), ct(l, 1) && (t.metadata.description = wo(u.take(), "description")), ct(l, 2) && (t.metadata.ruleReferences = Wo(u.take(), "rule references").map(
    (d) => wo(d, "rule reference")
  )), ct(l, 3) && (t.metadata.additionalInformation = Wo(u.take(), "additional information").map(
    (d) => {
      const [f, g] = Wo(d, "additional information entry");
      return {
        id: Ka(),
        name: wo(f, "additional information name"),
        value: wo(g, "additional information value")
      };
    }
  )), u.finish();
}
function SN(e) {
  const { canvas: t } = e;
  return Es([
    { changed: t.width !== 1920, value: t.width },
    { changed: t.height !== 1080, value: t.height },
    {
      changed: t.background !== od.light,
      value: no(t.background)
    },
    { changed: !t.boatNumbersVisible },
    { changed: !t.grid.visible },
    { changed: t.grid.size !== 40, value: t.grid.size },
    // Bit 6 was the retired snap-to-grid setting.
    { changed: !1 },
    { changed: t.grid.opacity !== 1, value: t.grid.opacity },
    // Bits 8–10 stay reserved so the following fields keep their positions.
    // Pan and zoom are editor state, not plot content, and never belong in a share link.
    { changed: !1 },
    { changed: !1 },
    { changed: !1 },
    { changed: !t.boatLegendVisible },
    { changed: t.infinite },
    {
      changed: t.windIndicatorPosition !== null,
      value: t.windIndicatorPosition ? [t.windIndicatorPosition.x, t.windIndicatorPosition.y] : void 0
    },
    {
      changed: t.boatLegendPosition !== null,
      value: t.boatLegendPosition ? [t.boatLegendPosition.x, t.boatLegendPosition.y] : void 0
    }
  ]);
}
function wN(e, t) {
  const [r, ...o] = Wo(e, "canvas"), l = qt(r, "canvas mask"), u = new Z0(o);
  if (ct(l, 0) && (t.canvas.width = qt(u.take(), "canvas width")), ct(l, 1) && (t.canvas.height = qt(u.take(), "canvas height")), ct(l, 2) && (t.canvas.background = ro(u.take())), ct(l, 3) && (t.canvas.boatNumbersVisible = !1), ct(l, 4) && (t.canvas.grid.visible = !1), ct(l, 5) && (t.canvas.grid.size = qt(u.take(), "grid size")), ct(l, 7) && (t.canvas.grid.opacity = qt(u.take(), "grid opacity")), ct(l, 8) && qt(u.take(), "view x"), ct(l, 9) && qt(u.take(), "view y"), ct(l, 10) && qt(u.take(), "view scale"), ct(l, 11) && (t.canvas.boatLegendVisible = !1), ct(l, 12) && (t.canvas.infinite = !0), ct(l, 13)) {
    const [d, f] = Wo(u.take(), "wind indicator position");
    t.canvas.windIndicatorPosition = {
      x: qt(d, "wind indicator x"),
      y: qt(f, "wind indicator y")
    };
  }
  if (ct(l, 14)) {
    const [d, f] = Wo(u.take(), "boat legend position");
    t.canvas.boatLegendPosition = {
      x: qt(d, "boat legend x"),
      y: qt(f, "boat legend y")
    };
  }
  u.finish();
}
function xN(e) {
  const { environment: t } = e;
  return Es([
    { changed: t.windDirection !== 0, value: t.windDirection },
    { changed: t.windStrength !== null, value: t.windStrength },
    { changed: !t.windVisible },
    { changed: t.laylineAngle !== 45, value: t.laylineAngle },
    { changed: !t.laylinesVisible },
    { changed: !t.zonesVisible },
    {
      changed: t.zoneRadiusBoatLengths !== 3,
      value: t.zoneRadiusBoatLengths
    },
    {
      changed: t.measurementBoatClass !== null,
      value: t.measurementBoatClass === null ? 0 : y6(t.measurementBoatClass)
    }
  ]);
}
function kN(e, t) {
  const [r, ...o] = Wo(e, "environment"), l = qt(r, "environment mask"), u = new Z0(o);
  ct(l, 0) && (t.environment.windDirection = qt(u.take(), "wind direction")), ct(l, 1) && (t.environment.windStrength = wo(u.take(), "wind strength")), ct(l, 2) && (t.environment.windVisible = !1), ct(l, 3) && (t.environment.laylineAngle = qt(u.take(), "layline angle")), ct(l, 4) && (t.environment.laylinesVisible = !1), ct(l, 5) && (t.environment.zonesVisible = !1), ct(l, 6) && (t.environment.zoneRadiusBoatLengths = qt(u.take(), "zone radius")), ct(l, 7) && (t.environment.measurementBoatClass = b6(
    u.take(),
    "measurement boat class"
  )), u.finish();
}
function CN(e, t) {
  const r = e.type === "boat" ? e.heading : 0;
  return Es([
    { changed: e.rotation !== r, value: e.rotation },
    { changed: e.scaleX !== 1, value: e.scaleX },
    { changed: e.scaleY !== 1, value: e.scaleY },
    { changed: !e.visible },
    { changed: e.locked },
    { changed: e.zIndex !== t + 1, value: e.zIndex },
    { changed: e.opacity !== 1, value: e.opacity }
  ]);
}
function EN(e, t, r) {
  return {
    rotation: ct(e, 0) ? qt(t.take(), "rotation") : 0,
    scaleX: ct(e, 1) ? qt(t.take(), "horizontal scale") : 1,
    scaleY: ct(e, 2) ? qt(t.take(), "vertical scale") : 1,
    visible: !ct(e, 3),
    locked: ct(e, 4),
    zIndex: ct(e, 5) ? qt(t.take(), "layer index") : r + 1,
    opacity: ct(e, 6) ? qt(t.take(), "opacity") : 1
  };
}
function RN(e) {
  const t = e.filter((l) => l.type === "boat"), r = /* @__PURE__ */ new Map();
  t.forEach((l) => r.set(l.sequenceId, (r.get(l.sequenceId) ?? 0) + 1));
  const o = /* @__PURE__ */ new Map();
  return t.forEach((l) => {
    (r.get(l.sequenceId) ?? 0) <= 1 && l.positionNumber === 1 || o.has(l.sequenceId) || o.set(l.sequenceId, o.size);
  }), o;
}
function TN(e, t, r) {
  const o = c6.indexOf(e.type), l = CN(e, t), u = [o, e.x, e.y, ...l];
  if (e.type === "boat") {
    const d = Ju(e.boatClass, "#FFAA00"), f = r.get(e.sequenceId);
    return [
      ...u,
      ...Es([
        { changed: e.boatClass !== "ILCA", value: y6(e.boatClass) },
        { changed: e.name !== "", value: e.name },
        { changed: e.sailNumber !== "", value: e.sailNumber },
        { changed: e.label !== "", value: e.label },
        { changed: e.color !== d, value: no(e.color) },
        { changed: e.heading !== 0, value: e.heading },
        { changed: e.tack === "port" },
        { changed: !e.mainsailVisible },
        { changed: e.jibVisible },
        { changed: e.genoaVisible },
        { changed: e.spinnakerVisible },
        { changed: e.gennakerVisible },
        { changed: e.mainsailTrim !== 0, value: e.mainsailTrim },
        { changed: e.jibTrim !== 0, value: e.jibTrim },
        { changed: e.spinnakerTrim !== 0, value: e.spinnakerTrim },
        { changed: e.gennakerTrim !== 0, value: e.gennakerTrim },
        { changed: e.sailMode === "manual" },
        { changed: e.sailAngle !== 32, value: e.sailAngle },
        { changed: f !== void 0, value: f ?? 0 },
        { changed: e.positionNumber !== 1, value: e.positionNumber },
        {
          changed: e.overlapIndicator !== "none",
          value: m6.indexOf(e.overlapIndicator)
        },
        {
          changed: e.stateMarker !== void 0 && e.stateMarker !== "none",
          value: g6.indexOf(e.stateMarker ?? "none")
        },
        {
          changed: e.boatFlagColor !== null,
          value: no(e.boatFlagColor ?? "#FFFFFF")
        },
        {
          changed: e.umpireSignalFlag !== "none",
          value: cb.indexOf(e.umpireSignalFlag)
        },
        { changed: e.protestFlagSide !== "none" },
        { changed: e.protestFlagSide === "starboard" }
      ])
    ];
  }
  if (e.type === "mark")
    return [
      ...u,
      ...Es([
        { changed: e.markType !== "racing", value: h6.indexOf(e.markType) },
        { changed: e.shape !== "round", value: p6.indexOf(e.shape) },
        { changed: e.color !== "#FFAA00", value: no(e.color) },
        { changed: e.label !== "", value: e.label },
        { changed: e.markNumber !== "1", value: yN(e.markNumber) },
        { changed: e.downwind },
        { changed: !e.zoneVisible },
        { changed: e.zoneRadius !== 3, value: e.zoneRadius },
        { changed: !e.laylinesVisible }
      ])
    ];
  if (e.type === "gate")
    return [
      ...u,
      e.endAX,
      e.endAY,
      e.endBX,
      e.endBY,
      e.markNumber,
      ...Es([
        { changed: e.color !== "#FFAA00", value: no(e.color) },
        { changed: !e.zoneVisible },
        { changed: e.zoneRadius !== 3, value: e.zoneRadius }
      ])
    ];
  if (e.type === "start-line" || e.type === "finish-line") {
    const d = e.type === "start-line" ? Vf : Zp;
    return [
      ...u,
      e.endAX,
      e.endAY,
      e.endBX,
      e.endBY,
      ...Es([
        { changed: e.color !== "#A3A3A3", value: no(e.color) },
        {
          changed: e.startEndType !== "committee-boat",
          value: D0.indexOf(e.startEndType)
        },
        {
          changed: e.pinEndType !== "flag",
          value: D0.indexOf(e.pinEndType)
        },
        {
          changed: e.startEndFlagColor !== d,
          value: no(e.startEndFlagColor)
        },
        {
          changed: e.pinEndFlagColor !== d,
          value: no(e.pinEndFlagColor)
        },
        { changed: e.laylinesVisible },
        { changed: e.laylineAreaVisible },
        {
          changed: e.laylineAreaColor !== d,
          value: no(e.laylineAreaColor)
        }
      ])
    ];
  }
  if (e.type === "line" || e.type === "arrow" || e.type === "freehand")
    return [
      ...u,
      e.points,
      ...Es([
        { changed: e.stroke !== "#171717", value: no(e.stroke) },
        { changed: e.strokeWidth !== 3, value: e.strokeWidth },
        { changed: e.dash.length > 0, value: e.dash }
      ])
    ];
  if (e.type === "text")
    return [
      ...u,
      ...Es([
        { changed: e.text !== "Annotation", value: e.text },
        { changed: e.color !== "#171717", value: no(e.color) },
        { changed: e.fontSize !== 28, value: e.fontSize },
        { changed: e.fontWeight === "bold" },
        { changed: e.align !== "left", value: v6.indexOf(e.align) },
        { changed: e.background !== "transparent", value: no(e.background) }
      ])
    ];
  if (e.type !== "rectangle" && e.type !== "circle")
    throw new Error(`Unsupported compact object type: ${e.type}`);
  return [
    ...u,
    e.width,
    e.height,
    ...Es([
      { changed: e.stroke !== "#171717", value: no(e.stroke) },
      { changed: e.strokeWidth !== 3, value: e.strokeWidth },
      { changed: e.fill !== "transparent", value: no(e.fill) }
    ])
  ];
}
function NN(e, t, r) {
  const [o, l, u, d, ...f] = Wo(e, "object"), g = sl(c6, o, "object type"), h = qt(l, "object x"), v = qt(u, "object y"), E = qt(d, "object mask"), S = new Z0(f), w = EN(E, S, t);
  if (g === "boat") {
    const x = qt(S.take(), "boat mask"), k = ct(x, 0) ? b6(S.take(), "boat class") : "ILCA", R = { ...Ko(h, v, t + 1, k), ...w };
    if (ct(x, 1) && (R.name = wo(S.take(), "boat name")), ct(x, 2) && (R.sailNumber = wo(S.take(), "sail number")), ct(x, 3) && (R.label = wo(S.take(), "boat label")), ct(x, 4) && (R.color = ro(S.take())), ct(x, 5) && (R.heading = qt(S.take(), "boat heading")), R.tack = ct(x, 6) ? "port" : "starboard", R.mainsailVisible = !ct(x, 7), R.jibVisible = ct(x, 8), R.genoaVisible = ct(x, 9), R.spinnakerVisible = ct(x, 10), R.gennakerVisible = ct(x, 11), ct(x, 12) && (R.mainsailTrim = qt(S.take(), "mainsail trim")), ct(x, 13) && (R.jibTrim = qt(S.take(), "jib trim")), ct(x, 14) && (R.spinnakerTrim = qt(S.take(), "spinnaker trim")), ct(x, 15) && (R.gennakerTrim = qt(S.take(), "gennaker trim")), R.sailMode = ct(x, 16) ? "manual" : "automatic", ct(x, 17) && (R.sailAngle = qt(S.take(), "sail angle")), ct(x, 18)) {
      const B = qt(S.take(), "boat sequence");
      r.has(B) || r.set(B, Ka()), R.sequenceId = r.get(B);
    }
    return ct(x, 19) && (R.positionNumber = qt(S.take(), "boat position")), ct(x, 20) && (R.overlapIndicator = sl(m6, S.take(), "overlap indicator")), ct(x, 21) && (R.stateMarker = sl(g6, S.take(), "state marker")), ct(x, 22) && (R.boatFlagColor = ro(S.take())), ct(x, 23) && (R.umpireSignalFlag = sl(cb, S.take(), "umpire signal flag")), R.protestFlagSide = ct(x, 24) ? ct(x, 25) ? "starboard" : "port" : "none", ct(E, 0) || (R.rotation = R.heading), S.finish(), R;
  }
  if (g === "mark") {
    const x = qt(S.take(), "mark mask"), k = { ...fb(h, v, t + 1), ...w };
    if (ct(x, 0) && (k.markType = sl(h6, S.take(), "mark type")), ct(x, 1) && (k.shape = sl(p6, S.take(), "mark shape")), ct(x, 2) && (k.color = ro(S.take())), ct(x, 3) && (k.label = wo(S.take(), "mark label")), ct(x, 4)) {
      const R = S.take();
      k.markNumber = typeof R == "number" ? String(qt(R, "mark number")) : wo(R, "mark number");
    }
    return k.downwind = ct(x, 5), k.zoneVisible = !ct(x, 6), ct(x, 7) && (k.zoneRadius = qt(S.take(), "mark zone radius")), k.laylinesVisible = !ct(x, 8), S.finish(), k;
  }
  if (g === "gate") {
    const x = qt(S.take(), "gate endpoint"), k = qt(S.take(), "gate endpoint"), R = qt(S.take(), "gate endpoint"), B = qt(S.take(), "gate endpoint"), q = qt(S.take(), "gate number"), X = qt(S.take(), "gate mask"), I = {
      ...t6(h + x, v + k, h + R, v + B, t + 1, q),
      ...w
    };
    return ct(X, 0) && (I.color = ro(S.take())), I.zoneVisible = !ct(X, 1), ct(X, 2) && (I.zoneRadius = qt(S.take(), "gate zone radius")), S.finish(), I;
  }
  if (g === "start-line" || g === "finish-line") {
    const x = qt(S.take(), "line endpoint"), k = qt(S.take(), "line endpoint"), R = qt(S.take(), "line endpoint"), B = qt(S.take(), "line endpoint"), q = qt(S.take(), "course line mask"), X = {
      ...g === "start-line" ? hb(h + x, v + k, h + R, v + B, t + 1) : n6(h + x, v + k, h + R, v + B, t + 1),
      ...w
    };
    return ct(q, 0) && (X.color = ro(S.take())), ct(q, 1) && (X.startEndType = sl(D0, S.take(), "course start endpoint")), ct(q, 2) && (X.pinEndType = sl(D0, S.take(), "course pin endpoint")), ct(q, 3) && (X.startEndFlagColor = ro(S.take())), ct(q, 4) && (X.pinEndFlagColor = ro(S.take())), X.laylinesVisible = ct(q, 5), X.laylineAreaVisible = ct(q, 6), ct(q, 7) && (X.laylineAreaColor = ro(S.take())), S.finish(), X;
  }
  if (g === "line" || g === "arrow" || g === "freehand") {
    const x = Wo(S.take(), "line points").map(
      (B) => qt(B, "line point")
    ), k = qt(S.take(), "line mask"), R = {
      id: Ka(),
      type: g,
      x: h,
      y: v,
      ...w,
      points: x,
      stroke: ct(k, 0) ? ro(S.take()) : "#171717",
      strokeWidth: ct(k, 1) ? qt(S.take(), "stroke width") : 3,
      dash: ct(k, 2) ? Wo(S.take(), "line dash").map((B) => qt(B, "dash value")) : []
    };
    return S.finish(), R;
  }
  if (g === "text") {
    const x = qt(S.take(), "text mask"), k = {
      id: Ka(),
      type: g,
      x: h,
      y: v,
      ...w,
      text: ct(x, 0) ? wo(S.take(), "annotation") : "Annotation",
      color: ct(x, 1) ? ro(S.take()) : "#171717",
      fontSize: ct(x, 2) ? qt(S.take(), "font size") : 28,
      fontWeight: ct(x, 3) ? "bold" : "normal",
      align: ct(x, 4) ? sl(v6, S.take(), "text alignment") : "left",
      background: ct(x, 5) ? ro(S.take()) : "transparent"
    };
    return S.finish(), k;
  }
  const T = qt(S.take(), "shape width"), P = qt(S.take(), "shape height"), z = qt(S.take(), "shape mask"), L = {
    id: Ka(),
    type: g,
    x: h,
    y: v,
    ...w,
    width: T,
    height: P,
    stroke: ct(z, 0) ? ro(S.take()) : "#171717",
    strokeWidth: ct(z, 1) ? qt(S.take(), "stroke width") : 3,
    fill: ct(z, 2) ? ro(S.take()) : "transparent"
  };
  return S.finish(), L;
}
function _6(e) {
  const t = RN(e.objects);
  return [
    bN(e),
    SN(e),
    xN(e),
    e.objects.map((r, o) => TN(r, o, t))
  ];
}
function AN(e) {
  if (!Array.isArray(e) || e.length !== 4)
    throw new Error("The compact plot data is damaged.");
  const t = Ql();
  t.canvas.boatLegendVisible = !0, _N(e[0], t), wN(e[1], t), kN(e[2], t);
  const r = /* @__PURE__ */ new Map();
  return t.objects = Wo(e[3], "objects").map(
    (o, l) => NN(o, l, r)
  ), mb(t);
}
const H2 = 2, S6 = 1, Af = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ*-./:", MN = (e) => {
  let t = "";
  for (let o = 0; o < e.length; o += 32768)
    t += String.fromCharCode(...e.subarray(o, o + 32768));
  return btoa(t).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/u, "");
}, PN = (e) => {
  if (!e || !/^[A-Za-z0-9_-]+$/u.test(e) || e.length % 4 === 1)
    throw new Error("The share link contains invalid characters.");
  const t = "=".repeat((4 - e.length % 4) % 4), r = atob(e.replaceAll("-", "+").replaceAll("_", "/") + t);
  return Uint8Array.from(r, (o) => o.charCodeAt(0));
}, DN = (e) => {
  let t = "";
  for (let r = 0; r < e.length; r += 2) {
    let o = r + 1 < e.length ? e[r] * 256 + e[r + 1] : e[r];
    t += Af[o % 41], o = Math.floor(o / 41), t += Af[o % 41], r + 1 < e.length && (t += Af[Math.floor(o / 41)]);
  }
  return t;
}, LN = (e) => {
  if (!e || e.length % 3 === 1)
    throw new Error("The share link contains invalid compact data.");
  const t = [];
  for (let r = 0; r < e.length; r += 3) {
    const o = Af.indexOf(e[r]), l = Af.indexOf(e[r + 1]), u = r + 2 < e.length, d = u ? Af.indexOf(e[r + 2]) : 0;
    if (o < 0 || l < 0 || d < 0)
      throw new Error("The share link contains invalid characters.");
    const f = o + l * 41 + d * 41 * 41;
    if (u && f > 65535 || !u && f > 255)
      throw new Error("The share link contains invalid compact data.");
    u && t.push(Math.floor(f / 256)), t.push(f % 256);
  }
  return Uint8Array.from(t);
};
function ON(e) {
  return MN($x(JSON.stringify(_6(e)), { level: 9 }));
}
const w6 = (e) => {
  try {
    const t = JSON.parse(kT(e, { to: "string" }));
    return AN(t);
  } catch (t) {
    throw t instanceof Error && t.message.startsWith("This plot") ? t : new Error("The share link is invalid or damaged.");
  }
};
function FN(e) {
  try {
    return w6(PN(e));
  } catch (t) {
    throw t instanceof Error && t.message.startsWith("This plot") ? t : new Error("The share link is invalid or damaged.");
  }
}
function zN(e) {
  const t = e.replace(/^#/, "");
  if (!t) return null;
  const r = Number(t[0]);
  if (!Number.isInteger(r)) return null;
  if (r > H2)
    throw new Error(`This plot uses unsupported future share format version ${r}.`);
  if (r === S6)
    try {
      return w6(LN(t.slice(1)));
    } catch (o) {
      throw o instanceof Error && o.message.startsWith("This plot") ? o : new Error("The share link is invalid or damaged.");
    }
  return r === H2 ? FN(t.slice(1)) : null;
}
function gb(e, t = window.location) {
  return `${t.origin}${t.pathname}#${H2}${ON(e)}`;
}
function Qp(e, t = window.location) {
  const r = DN($x(JSON.stringify(_6(e)), { level: 9 }));
  return `${t.origin}${t.pathname}#${S6}${r}`;
}
const k3 = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), o = (h, v) => {
    const E = typeof h == "function" ? h(t) : h;
    if (!Object.is(E, t)) {
      const S = t;
      t = v ?? (typeof E != "object" || E === null) ? E : Object.assign({}, t, E), r.forEach((w) => w(t, S));
    }
  }, l = () => t, f = { setState: o, getState: l, getInitialState: () => g, subscribe: (h) => (r.add(h), () => r.delete(h)) }, g = t = e(o, l, f);
  return f;
}, BN = ((e) => e ? k3(e) : k3), UN = (e) => e;
function IN(e, t = UN) {
  const r = na.useSyncExternalStore(
    e.subscribe,
    na.useCallback(() => t(e.getState()), [e, t]),
    na.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return na.useDebugValue(r), r;
}
const C3 = (e) => {
  const t = BN(e), r = (o) => IN(t, o);
  return Object.assign(r, t), r;
}, HN = ((e) => e ? C3(e) : C3), G2 = Vf, GN = "#FFAA00", VN = "#9A031E", x6 = /^#[0-9a-f]{6}$/iu;
function qN(e) {
  switch (e.objectColors.markColorMode) {
    case "primary":
      return e.theme.light.primary;
    case "yellow":
      return GN;
    case "red":
      return VN;
    case "custom":
      return e.objectColors.markCustomColor && x6.test(e.objectColors.markCustomColor) ? e.objectColors.markCustomColor : G2;
    case "sailplot":
    default:
      return G2;
  }
}
function WN(e) {
  return x6.test(e.objectColors.startLineFlagColor) ? e.objectColors.startLineFlagColor : Vf;
}
function E3(e, t, r) {
  return {
    ...e,
    objects: e.objects.map((o) => o.type === "mark" || o.type === "gate" ? { ...o, color: t } : o.type === "start-line" ? {
      ...o,
      startEndFlagColor: r,
      pinEndFlagColor: r
    } : o)
  };
}
function Ty(e, t, r) {
  const o = new Set(t);
  return [...e.filter((u) => !o.has(u.id)), ...structuredClone(r)].sort((u, d) => u.zIndex - d.zIndex);
}
const Jp = (e) => (e % 360 + 360) % 360;
function vb(e, t) {
  const r = t.x - e.x, o = t.y - e.y, l = Math.hypot(r, o), u = Jp(Math.atan2(r, -o) * 180 / Math.PI), d = l * 2 / 5, f = Jp(u - e.heading), g = Jp(u - t.heading), h = e.heading * Math.PI / 180, v = t.heading * Math.PI / 180;
  return {
    start: { x: e.x, y: e.y },
    firstControl: f >= 90 && f <= 270 ? { x: e.x, y: e.y } : {
      x: e.x + d * Math.sin(h),
      y: e.y - d * Math.cos(h)
    },
    secondControl: g >= 90 && g <= 270 ? { x: t.x, y: t.y } : {
      x: t.x - d * Math.sin(v),
      y: t.y + d * Math.cos(v)
    },
    end: { x: t.x, y: t.y }
  };
}
function k6(e, t) {
  const r = 1 - t;
  return {
    x: r ** 3 * e.start.x + 3 * r ** 2 * t * e.firstControl.x + 3 * r * t ** 2 * e.secondControl.x + t ** 3 * e.end.x,
    y: r ** 3 * e.start.y + 3 * r ** 2 * t * e.firstControl.y + 3 * r * t ** 2 * e.secondControl.y + t ** 3 * e.end.y
  };
}
const Sf = (e, t, r) => ({
  x: e.x + (t.x - e.x) * r,
  y: e.y + (t.y - e.y) * r
});
function KN(e, t) {
  const r = Math.min(1, Math.max(0, t)), o = Sf(e.start, e.firstControl, r), l = Sf(
    e.firstControl,
    e.secondControl,
    r
  ), u = Sf(e.secondControl, e.end, r), d = Sf(o, l, r), f = Sf(l, u, r);
  return {
    start: e.start,
    firstControl: o,
    secondControl: d,
    end: Sf(d, f, r)
  };
}
function jN(e, t) {
  const r = 1 - t;
  return {
    x: 3 * r ** 2 * (e.firstControl.x - e.start.x) + 6 * r * t * (e.secondControl.x - e.firstControl.x) + 3 * t ** 2 * (e.end.x - e.secondControl.x),
    y: 3 * r ** 2 * (e.firstControl.y - e.start.y) + 6 * r * t * (e.secondControl.y - e.firstControl.y) + 3 * t ** 2 * (e.end.y - e.secondControl.y)
  };
}
const R3 = 32;
function C6(e, t) {
  if (t <= 0 || t >= 1) return t;
  const r = [
    { curveProgress: 0, length: 0 }
  ];
  let o = e.start, l = 0;
  for (let E = 1; E <= R3; E += 1) {
    const S = E / R3, w = k6(e, S);
    l += Math.hypot(w.x - o.x, w.y - o.y), r.push({ curveProgress: S, length: l }), o = w;
  }
  if (l === 0) return t;
  const u = l * t, d = r.findIndex((E) => E.length >= u), f = r[Math.max(1, d)], g = r[Math.max(0, d - 1)], h = f.length - g.length, v = h === 0 ? 0 : (u - g.length) / h;
  return g.curveProgress + (f.curveProgress - g.curveProgress) * v;
}
function YN(e, t) {
  return Math.hypot(e.x, e.y) < 1e-6 ? Jp(t) : Jp(Math.atan2(e.x, -e.y) * 180 / Math.PI);
}
const _o = {
  keelboat: {
    hullPath: "M 0 -50 C 20 0 18 13 10 50 L -10 50 C -18 13 -20 0 0 -50 Z",
    displayScale: 0.88,
    length: 100,
    drawingLength: 100,
    sternPort: [-10, 50],
    mast: [0, -8.7],
    mainsailSize: 41.5,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 65,
    jibTack: [0, -50],
    jibSize: 40,
    genoaSize: 58,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 35,
    spinnakerSize: 45.65,
    gennakerTack: [0, -80],
    gennakerSize: 70,
    poleLength: 30,
    numberPos: [0, 25],
    numberSize: 12,
    kind: "monohull",
    closeHauledHeadsailAngle: 15
  },
  laser: {
    hullPath: "M 0 -20 C .3 -19.7 .3 -20 .7 -19.7 C 3.3 -14.3 6.7 -3.3 6.7 4.7 C 6.7 11 6.7 14.3 5 20 L -5 20 C -6.7 14.3 -6.7 11 -6.7 4.7 C -6.7 -3.3 -3.3 -14.3 -.7 -19.7 C -.3 -20 -.3 -19.7 0 -20 Z",
    displayScale: 1.72,
    length: 42.3,
    drawingLength: 40,
    sternPort: [-5, 20],
    mast: [0, -8.7],
    mainsailSize: 24.2,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 90,
    jibTack: null,
    jibSize: 0,
    jibMaxAngle: 0,
    jibSpinMaxAngle: 0,
    spinnakerSize: 0,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 10],
    numberSize: 7,
    kind: "monohull",
    closeHauledMainsailAngle: 11,
    sailAreas: { mainsail: 7.06 }
  },
  optimist: {
    hullPath: "M 0 -11.5 C 1.5 -11.5 1.7 -11.3 2.9 -11.1 C 3.6 -9.4 5.6 -4 5.6 1.5 C 5.6 5.4 5 9 4.6 11.5 L -4.6 11.5 C -5 9 -5.6 5.4 -5.6 1.5 C -5.6 -4 -3.6 -9.4 -2.9 -11.1 C -1.7 -11.3 -1.5 -11.5 0 -11.5 Z",
    displayScale: 2.5,
    length: 23,
    drawingLength: 23,
    sternPort: [-4.6, 11.5],
    mast: [0, -6.9],
    mainsailSize: 16.5,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 90,
    jibTack: null,
    jibSize: 0,
    jibMaxAngle: 0,
    jibSpinMaxAngle: 0,
    spinnakerSize: 0,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 3],
    numberSize: 6,
    kind: "monohull",
    sailAreas: { mainsail: 3.3 }
  },
  int420: {
    hullPath: "M 0 -21 C 1.5 -21 8.15 -12.5 8.15 3.3 Q 8.15 11.5 5.7 20 Q 2.8 21 0 21 Q -2.8 21 -5.7 20 Q -8.15 11.5 -8.15 3.3 C -8.15 -12.5 -1.5 -21 0 -21 Z",
    displayScale: 1.58,
    length: 42,
    drawingLength: 42,
    sternPort: [-5.7, 20],
    mast: [0, -7.1],
    mainsailSize: 24,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 90,
    jibTack: [0, -21],
    jibSize: 14.4,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 45,
    spinnakerSize: 27.3,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 9],
    numberSize: 7,
    kind: "monohull",
    closeHauledMainsailAngle: 7,
    closeHauledHeadsailAngle: 10,
    sailAreas: { mainsail: 10.25, jib: 2.8, spinnaker: 9 }
  },
  int470: {
    hullPath: "M 0 -23.5 C .8 -23.5 8.5 -15 8.5 3.5 Q 8.5 12.5 5.8 23.5 L -5.8 23.5 Q -8.5 12.5 -8.5 3.5 C -8.5 -15 -.8 -23.5 0 -23.5 Z",
    displayScale: 1.48,
    length: 47,
    drawingLength: 47,
    sternPort: [-5.8, 23.5],
    mast: [0, -7.5],
    mainsailSize: 26.5,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 90,
    jibTack: [0, -23.5],
    jibSize: 15.9,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 45,
    spinnakerSize: 32.8,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 9],
    numberSize: 7,
    kind: "monohull",
    closeHauledMainsailAngle: 7,
    closeHauledHeadsailAngle: 10,
    sailAreas: { mainsail: 9.12, jib: 3.58, spinnaker: 13 }
  },
  int29er: {
    hullPath: "M 0 -20.5 L -.5 -20.5 C -3.5 -10.25 -6.6 -1.1 -8.3 -.5 L -8.8 18 L -4.4 20.5 L 4.4 20.5 L 8.8 18 L 8.3 -.5 C 6.6 -1.1 3.5 -10.25 .5 -20.5 Z",
    displayScale: 1.62,
    length: 44.5,
    drawingLength: 41,
    sternPort: [-8.8, 18],
    mast: [0, -3.4],
    mainsailSize: 20.5,
    mainsailMaxAngle: 85,
    mainsailSpinMaxAngle: 40,
    jibTack: [0, -20.5],
    jibSize: 17,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 35,
    spinnakerSize: 0,
    gennakerTack: [0, -34.2],
    gennakerSize: 35.2,
    poleLength: 13.7,
    numberPos: [0, 9],
    numberSize: 7,
    kind: "skiff",
    closeHauledMainsailAngle: 6,
    closeHauledHeadsailAngle: 8,
    sailAreas: { upwindTotal: 12.5, gennaker: 15 }
  },
  int49er: {
    hullPath: "M 0 -24 L -.5 -24 C -1.5 -23 -6.5 -5.5 -7.5 1.5 L -13.5 2.4 Q -14 2.5 -14 3 L -14 24 L -13.5 24 L -12.5 21 L -7.5 19 L -5 22 L 5 22 L 7.5 19 L 12.5 21 L 13.5 24 L 14 24 L 14 3 Q 14 2.5 13.5 2.4 L 7.5 1.5 C 6.5 -5.5 1.5 -23 .5 -24 Z",
    displayScale: 1.48,
    length: 49.9,
    drawingLength: 48,
    sternPort: [-14, 24],
    mast: [0, -2.5],
    mainsailSize: 26.5,
    mainsailMaxAngle: 85,
    mainsailSpinMaxAngle: 40,
    jibTack: [0, -22.5],
    jibSize: 19,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 35,
    spinnakerSize: 0,
    gennakerTack: [0, -42.5],
    gennakerSize: 41.8,
    poleLength: 18.5,
    numberPos: [0, 9],
    numberSize: 7,
    kind: "skiff",
    closeHauledMainsailAngle: 6,
    closeHauledHeadsailAngle: 8,
    sailAreas: { mainsail: 16.1, jib: 5.1, gennaker: 21.2 }
  },
  tornado: {
    hullPath: "M 0 0 L 10.7 0 C 11.2 -11.7 12.2 -19.8 13.2 -30.5 C 14.7 -20.3 15.3 -6.1 15.3 6.1 C 15.3 13.7 14.7 20.8 14.7 30 C 13.7 30.5 12.7 30.5 10.7 30 L 10.7 23.9 L -10.7 23.9 L -10.7 30 C -12.7 30.5 -13.7 30.5 -14.7 30 C -14.7 20.8 -15.3 13.7 -15.3 6.1 C -15.3 -6.1 -14.7 -20.3 -13.2 -30.5 C -12.2 -19.8 -11.2 -11.7 -10.7 0 Z",
    displayScale: 1.25,
    length: 61,
    drawingLength: 61,
    sternPort: [-14.7, 30],
    mast: [0, 0],
    mainsailSize: 30,
    mainsailMaxAngle: 80,
    mainsailSpinMaxAngle: 30,
    jibTack: [0, -20],
    jibSize: 21,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 35,
    spinnakerSize: 0,
    gennakerTack: [0, -40],
    gennakerSize: 45.5,
    poleLength: 40,
    numberPos: [0, 17],
    numberSize: 10,
    kind: "catamaran",
    closeHauledMainsailAngle: 3
  },
  vsr: {
    hullPath: "M 0 -46 C 3 -44 5.5 -40 7.5 -35 C 10 -29 11.5 -22 12 -14 L 13 31 C 13 35 11.5 38 8.5 39 L 5.5 40 L -5.5 40 L -8.5 39 C -11.5 38 -13 35 -13 31 L -12 -14 C -11.5 -22 -10 -29 -7.5 -35 C -5.5 -40 -3 -44 0 -46 Z",
    displayScale: 0.9,
    length: 57.5,
    drawingLength: 86,
    sternPort: [-13, 36],
    mast: null,
    mainsailSize: 0,
    mainsailMaxAngle: 0,
    mainsailSpinMaxAngle: 0,
    jibTack: null,
    jibSize: 0,
    jibMaxAngle: 0,
    jibSpinMaxAngle: 0,
    spinnakerSize: 0,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 23],
    numberSize: 10,
    kind: "vsr"
  },
  committee: {
    hullPath: "M 0 -50 C 30 -20 20 30 17 50 L -17 50 C -20 30 -30 -20 0 -50 Z",
    displayScale: 0.92,
    length: 100,
    drawingLength: 100,
    sternPort: [-17, 50],
    mast: null,
    mainsailSize: 0,
    mainsailMaxAngle: 0,
    mainsailSpinMaxAngle: 0,
    jibTack: null,
    jibSize: 0,
    jibMaxAngle: 0,
    jibSpinMaxAngle: 0,
    spinnakerSize: 0,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 18],
    numberSize: 12,
    kind: "motor"
  },
  board: {
    hullPath: "M 0 -11 C 2.7 -10.9 4.4 -9.2 4.7 -6 L 4.75 7.5 Q 4.7 9.6 4.28 11 L -4.28 11 Q -4.7 9.6 -4.75 7.5 L -4.7 -6 C -4.4 -9.2 -2.7 -10.9 0 -11 Z",
    displayScale: 1.6,
    length: 22,
    drawingLength: 22,
    sternPort: [-4.28, 11],
    mast: [0, -4.5],
    mainsailSize: 15,
    mainsailMaxAngle: 85,
    mainsailSpinMaxAngle: 85,
    jibTack: null,
    jibSize: 0,
    jibMaxAngle: 0,
    jibSpinMaxAngle: 0,
    spinnakerSize: 0,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 6],
    numberSize: 5.5,
    kind: "board",
    sailAreas: { mainsail: 8 }
  },
  lacustre: {
    hullPath: "M 0 -47.5 C 4 -46 9.05 -26 9.05 -2 C 9.05 21 6.5 40 4.5 47.5 L -4.5 47.5 C -6.5 40 -9.05 21 -9.05 -2 C -9.05 -26 -4 -46 0 -47.5 Z",
    displayScale: 0.94,
    length: 95,
    drawingLength: 95,
    sternPort: [-4.5, 47.5],
    mast: [0, -7],
    mainsailSize: 36,
    mainsailMaxAngle: 90,
    mainsailSpinMaxAngle: 65,
    jibTack: [0, -47.5],
    jibSize: 28,
    genoaSize: 52,
    jibMaxAngle: 45,
    jibSpinMaxAngle: 35,
    spinnakerSize: 60,
    gennakerTack: null,
    gennakerSize: 0,
    poleLength: 0,
    numberPos: [0, 34],
    numberSize: 11,
    kind: "monohull",
    closeHauledMainsailAngle: 6,
    closeHauledHeadsailAngle: 9,
    sailAreas: { upwindTotal: 40, genoa: 22, spinnaker: 65 }
  }
}, ml = {
  Optimist: _o.optimist,
  ILCA: _o.laser,
  "Generic keelboat": _o.keelboat,
  Lacustre: _o.lacustre,
  Tornado: _o.tornado,
  420: _o.int420,
  470: _o.int470,
  "29er": _o.int29er,
  "49er": _o.int49er,
  Windsurf: _o.board,
  Coachboat: _o.vsr,
  "Committee boat": _o.committee,
  "Umpire boat": _o.vsr
}, V2 = (e, t) => {
  const r = ml[e];
  return {
    boatClass: e,
    length: r.drawingLength * r.displayScale,
    hullLength: r.length,
    usesDefault: t
  };
};
function ZN(e) {
  const t = e.filter(
    (o) => o.type === "boat" && !Zl(o.boatClass)
  );
  if (!t.length)
    return V2("ILCA", !0);
  const r = t.reduce(
    (o, l) => ml[l.boatClass].length > ml[o.boatClass].length ? l : o
  );
  return V2(r.boatClass, !1);
}
function X0(e, t) {
  return !t || Zl(t) ? ZN(e) : V2(t, !1);
}
const gl = (e, t) => ((e - t) % 360 + 360) % 360, jo = (e, t, r = "starboard") => {
  const o = gl(e, t);
  return Math.abs(o - 180) < 1e-4 ? r : o > 180 ? "port" : "starboard";
};
function E6(e, t, r) {
  return jo(e, t, r) === "port" ? { min: -100, max: 0 } : { min: 0, max: 100 };
}
function ju(e, t, r, o) {
  const { min: l, max: u } = E6(t, r, o);
  return Math.min(u, Math.max(l, e));
}
function T3(e) {
  const t = ml[e], r = !!(t.jibTack && t.genoaSize);
  return {
    mainsailVisible: !!(t.mast && t.mainsailSize),
    jibVisible: !r && !!(t.jibTack && t.jibSize),
    genoaVisible: r,
    spinnakerVisible: !1,
    gennakerVisible: !1
  };
}
function XN(e, t, r, o, l) {
  const u = gl(e, t);
  if (u < r - 10) return Math.min(r - 20, u);
  if (u > 360 - (r - 10)) return Math.max(-(r - 20), u - 360);
  const d = Math.max(16, o);
  if (Math.abs(u - 180) < 1e-4)
    return jo(e, t, l) === "port" ? -d : d;
  const f = (180 - r) / Math.max(1, d - 15), g = r / f - 15;
  return u < 180 ? u / f - g : u / f - g - 2 * d;
}
function R6(e, t, r, o, l, u) {
  const f = ml[e].closeHauledMainsailAngle, g = XN(t, r, o, l, u);
  return f == null ? g : N6(f, g, t, r, o);
}
function QN(e, t, r, o, l) {
  const u = gl(e, t);
  if (u < r - 10) return Math.min(r - 20, u);
  if (u > 360 - (r - 10)) return Math.max(-(r - 20), u - 360);
  const d = Math.max(25, o);
  if (Math.abs(u - 180) < 1e-4)
    return jo(e, t, l) === "port" ? -d : d;
  const f = (180 - r) / Math.max(1, d - 20), g = r / f - 20;
  return u < 180 ? u / f - g : u / f - g - 2 * d;
}
function T6(e, t, r, o, l, u) {
  const f = ml[e].closeHauledHeadsailAngle, g = QN(t, r, o, l, u);
  return f == null ? g : N6(f, g, t, r, o);
}
function N6(e, t, r, o, l) {
  const u = gl(r, o), d = u <= 180 ? u : u - 360, f = Math.abs(d), g = Math.max(1, l), h = Math.sign(d);
  if (f <= g)
    return h * e * (f / g);
  const v = 20;
  if (f >= g + v) return t;
  const E = (f - g) / v, S = E * E * (3 - 2 * E), w = e + (Math.abs(t) - e) * S;
  return h * w;
}
function A6(e, t, r) {
  const o = gl(e, t);
  if (o < 80) return o / 80 * 20;
  if (o > 280) return -((360 - o) / 80) * 20;
  const l = 10, u = -12;
  return Math.abs(o - 180) < 1e-4 ? jo(e, t, r) === "port" ? -30 : 30 : o < 180 ? o / l - u : o / l - u - 60;
}
function M6(e, t, r) {
  const o = gl(e, t), l = o <= 180 ? o : o - 360, u = Math.abs(o - 180) < 1e-4 ? jo(e, t, r) === "port" ? -1 : 1 : l < 0 ? -1 : 1, d = Math.abs(l);
  return d < 80 ? l : u * Math.min(100, d - 20);
}
const yb = (e, t, r) => ((gl(e, t) - r) % 360 + 360) % 360;
function qu(e, t, r) {
  const o = gl(e, t);
  if (o >= 150 && o <= 210) return !1;
  const l = yb(e, t, r);
  return l < 10 || l > 350 || l > 170 && l < 190;
}
function P6(e, t, r) {
  const o = gl(e, t);
  if (o >= 150 && o <= 210) return !1;
  const l = yb(e, t, r);
  return l < 55 || l > 305 || l > 170 && l < 190;
}
const Qh = (e, t, r) => yb(e, t, r) < 180 ? 1 : -1;
function L0(e, t, r) {
  return r ? `M 0 0 C ${0.1 * e} ${0.2 * e} ${0.1 * e} ${0.2 * e} 0 ${0.3 * e} C ${-0.1 * e} ${0.4 * e} ${-0.1 * e} ${0.4 * e} 0 ${0.5 * e} C ${0.1 * e} ${0.6 * e} ${0.1 * e} ${0.6 * e} 0 ${0.7 * e} C ${-0.1 * e} ${0.8 * e} ${-0.1 * e} ${0.8 * e} 0 ${e} Z` : `M 0 0 C ${t * 0.1 * e} ${0.4 * e} ${t * 0.1 * e} ${0.6 * e} 0 ${e} Z`;
}
function JN(e, t, r) {
  if (r) return L0(e, t, !0);
  const o = Number((t * 0.07 * e).toFixed(3)), l = Number((t * 0.08 * e).toFixed(3)), u = Number((0.35 * e).toFixed(3)), d = Number((0.65 * e).toFixed(3));
  return `M 0 0 C ${o} ${u} ${l} ${d} 0 ${e} Z`;
}
function $N(e, t, r) {
  return r ? L0(e, t, !0) : `M 0 0 C ${t * 0.35 * e} ${0.3 * e} ${t * 0.28 * e} ${0.6 * e} 0 ${e} C ${t * 0.2 * e} ${0.6 * e} ${t * 0.25 * e} ${0.3 * e} 0 0 Z`;
}
const i0 = (e) => Number(e.toFixed(3));
function eA(e, t, r, o = e) {
  const l = (v) => v * Math.PI / 180, u = (v, E) => ({
    x: i0(Math.sin(l(E)) * v),
    y: i0(-Math.cos(l(E)) * v)
  }), d = u(e, t), f = u(1, r), g = { x: -f.y, y: f.x }, h = (v, E = 0) => `${i0(d.x + f.x * o * v + g.x * o * 0.1 * E)} ${i0(d.y + f.y * o * v + g.y * o * 0.1 * E)}`;
  return `M ${h(0)} C ${h(0.2, 1)} ${h(0.2, 1)} ${h(0.3)} C ${h(0.4, -1)} ${h(0.4, -1)} ${h(0.5)} C ${h(0.6, 1)} ${h(0.6, 1)} ${h(0.7)} C ${h(0.8, -1)} ${h(0.8, -1)} ${h(1)} Z`;
}
function tA(e, t, r) {
  return `M 0 0 C ${t * 0.4 * e} ${0.2 * e} ${t * 0.6 * e} ${0.2 * e} ${t * e} 0 A ${e} ${e} 0 0 ${t === 1 ? 1 : 0} ${t * -0.5 * e} ${0.866 * e} C ${t * -0.12 * e} ${0.62 * e} ${t * -0.03 * e} ${0.44 * e} 0 0 Z`;
}
function nA(e, t, r) {
  const l = 50 / ml[e.boatClass].displayScale, u = e.heading * Math.PI / 180, d = e.x + l * Math.sin(u), f = e.y - l * Math.cos(u);
  return (Math.atan2(t - d, -(r - f)) * 180 / Math.PI % 360 + 360) % 360;
}
function rA(e) {
  const t = [...e].sort(
    (o, l) => (o.positionNumber ?? 1) - (l.positionNumber ?? 1)
  );
  if (t.length < 2) return "";
  let r = `M ${t[0].x} ${t[0].y}`;
  for (let o = 1; o < t.length; o += 1) {
    const l = t[o - 1], u = t[o], d = vb(l, u);
    r += ` C ${d.firstControl.x} ${d.firstControl.y} ${d.secondControl.x} ${d.secondControl.y} ${d.end.x} ${d.end.y}`;
  }
  return r;
}
const aA = ["boatClass", "color", "name", "sailNumber"], N3 = /* @__PURE__ */ new Set([
  "boat",
  "mark",
  "downwind-mark",
  "gate",
  "start-line",
  "finish-line",
  "line",
  "arrow",
  "freehand",
  "text",
  "rectangle",
  "circle"
]), Gc = (e) => e === "downloaded" ? "unsaved" : e, Ny = (e, t) => ({
  ...e,
  metadata: { ...e.metadata, updatedAt: sm() },
  objects: t.map(
    (r) => r.type === "boat" ? { ...r, color: Ju(r.boatClass, r.color) } : r
  ).sort((r, o) => r.zIndex - o.zIndex)
}), yt = HN((e, t) => {
  const r = (o) => {
    e((l) => ({
      scenario: Ny(
        l.scenario,
        Ty(l.scenario.objects, o.affectedIds, o.after)
      ),
      history: [...l.history.slice(-99), o],
      future: [],
      status: o.label,
      documentStatus: Gc(l.documentStatus)
    }));
  };
  return {
    scenario: Ql(),
    dragPreview: null,
    selectedIds: [],
    activeTool: "select",
    layoutPreference: "auto",
    defaultBoatClass: "ILCA",
    brandAccentColor: fl,
    markColor: G2,
    startLineFlagColor: Vf,
    history: [],
    future: [],
    status: "Ready",
    documentStatus: "unsaved",
    hydrated: !1,
    setHydrated: (o) => e({ hydrated: o }),
    setStatus: (o) => e({ status: o }),
    setDocumentStatus: (o) => e({ documentStatus: o }),
    setDragPreview: (o) => e({ dragPreview: o }),
    setTool: (o) => e((l) => {
      const u = l.activeTool === o && N3.has(o), d = N3.has(o) && l.activeTool !== o, f = o === "boat" && l.activeTool !== "boat" && l.selectedIds.length === 1 && l.scenario.objects.some(
        (g) => g.id === l.selectedIds[0] && g.type === "boat"
      );
      return {
        activeTool: o,
        selectedIds: (u || d) && !f ? [] : l.selectedIds
      };
    }),
    setLayoutPreference: (o) => e({ layoutPreference: o }),
    setBrandAccentColor: (o) => e({ brandAccentColor: o }),
    setObjectColors: (o, l) => e((u) => ({
      markColor: o,
      startLineFlagColor: l,
      scenario: E3(u.scenario, o, l)
    })),
    setScenario: (o, l = "Plot opened") => {
      const u = mb(structuredClone(o)), d = [...u.objects].reverse().find((f) => f.type === "boat");
      e((f) => ({
        scenario: E3(u, f.markColor, f.startLineFlagColor),
        dragPreview: null,
        selectedIds: [],
        history: [],
        future: [],
        status: l,
        documentStatus: "unsaved",
        defaultBoatClass: (d == null ? void 0 : d.boatClass) ?? f.defaultBoatClass
      }));
    },
    patchScenario: (o) => e((l) => ({
      scenario: { ...l.scenario, ...o },
      documentStatus: Gc(l.documentStatus)
    })),
    updateMetadata: (o) => e((l) => ({
      scenario: {
        ...l.scenario,
        metadata: { ...l.scenario.metadata, ...o, updatedAt: sm() }
      },
      documentStatus: Gc(l.documentStatus)
    })),
    updateCanvas: (o) => e((l) => ({
      scenario: { ...l.scenario, canvas: { ...l.scenario.canvas, ...o } },
      documentStatus: Gc(l.documentStatus)
    })),
    updateEnvironment: (o) => e((l) => {
      const u = { ...l.scenario.environment, ...o }, d = o.windDirection === void 0 ? l.scenario.objects : l.scenario.objects.map(
        (f) => f.type === "boat" ? {
          ...f,
          tack: jo(f.heading, u.windDirection, f.tack)
        } : f
      );
      return {
        scenario: {
          ...l.scenario,
          environment: u,
          objects: d,
          metadata: { ...l.scenario.metadata, updatedAt: sm() }
        },
        documentStatus: Gc(l.documentStatus)
      };
    }),
    select: (o, l = !1) => e((u) => o ? l ? {
      selectedIds: u.selectedIds.includes(o) ? u.selectedIds.filter((d) => d !== o) : [...u.selectedIds, o]
    } : { selectedIds: [o] } : { selectedIds: [] }),
    selectIds: (o) => e({ selectedIds: o }),
    addAt: (o, l, u) => {
      const d = t(), f = Math.max(0, ...d.scenario.objects.map((h) => h.zIndex)) + 1;
      let g = null;
      if (o === "boat") {
        const h = d.scenario.objects.find(
          (v) => v.type === "boat" && d.selectedIds.length === 1 && v.id === d.selectedIds[0]
        );
        if ((h == null ? void 0 : h.type) === "boat") {
          const v = d.scenario.objects.filter(
            (S) => S.type === "boat" && S.sequenceId === h.sequenceId
          ), E = nA(h, l, u);
          g = {
            ...structuredClone(h),
            id: Ka(),
            x: l,
            y: u,
            heading: E,
            rotation: E,
            tack: jo(E, d.scenario.environment.windDirection, h.tack),
            opacity: 1,
            locked: !1,
            visible: !0,
            zIndex: f,
            overlapIndicator: "none",
            positionNumber: Math.max(
              h.positionNumber,
              ...v.map(
                (S) => S.type === "boat" ? S.positionNumber : 1
              )
            ) + 1
          };
        } else
          g = {
            ...Ko(l, u, f, d.defaultBoatClass, d.brandAccentColor),
            ...T3(d.defaultBoatClass),
            color: Ju(
              d.defaultBoatClass,
              u3(
                d.scenario.objects,
                Df(
                  d.scenario.canvas.background,
                  d.brandAccentColor
                )
              )
            )
          };
      } else (o === "mark" || o === "downwind-mark") && (g = {
        ...fb(l, u, f, d.markColor),
        markNumber: String(h0(d.scenario.objects)),
        downwind: o === "downwind-mark",
        laylinesVisible: o === "downwind-mark",
        zoneRadius: d.scenario.environment.zoneRadiusBoatLengths
      });
      return g && (t().addObject(g, o === "downwind-mark" ? "Added downwind mark" : `Added ${o}`), e({ selectedIds: [g.id], activeTool: o === "boat" ? "boat" : "select" })), g;
    },
    addObject: (o, l = "Added object") => {
      r({ label: l, affectedIds: [o.id], before: [], after: [o] }), e({ selectedIds: [o.id] });
    },
    addObjects: (o, l = "Added objects") => {
      o.length && (r({ label: l, affectedIds: o.map(({ id: u }) => u), before: [], after: o }), e({ selectedIds: o.map(({ id: u }) => u) }));
    },
    updateObject: (o, l, u = "Updated object") => {
      const d = t().scenario.objects.find((g) => g.id === o);
      if (!d) return;
      if (d.type === "boat") {
        const g = l, h = Object.fromEntries(
          aA.filter((v) => v in g).map((v) => [
            v,
            g[v]
          ])
        );
        if (g.boatClass && !g.color && (h.color = Ju(g.boatClass, d.color)), g.boatClass && Zl(g.boatClass) && (h.protestFlagSide = "none"), Object.keys(h).length) {
          const v = g.boatClass ? T3(g.boatClass) : {}, E = t().scenario.objects.filter(
            (S) => S.type === "boat" && S.sequenceId === d.sequenceId
          );
          r({
            label: u,
            affectedIds: E.map(({ id: S }) => S),
            before: E,
            after: E.map(
              (S) => ({ ...S, ...h, ...v })
            )
          }), g.boatClass && e({ defaultBoatClass: g.boatClass });
          return;
        }
      }
      const f = { ...d, ...l };
      r({ label: u, affectedIds: [o], before: [d], after: [f] });
    },
    updateObjects: (o, l = "Updated objects") => {
      const u = t().scenario.objects, d = o.map(({ id: g }) => u.find((h) => h.id === g)).filter((g) => !!g), f = d.map((g) => {
        var h;
        return {
          ...g,
          ...(h = o.find((v) => v.id === g.id)) == null ? void 0 : h.patch
        };
      });
      d.length && r({ label: l, affectedIds: d.map(({ id: g }) => g), before: d, after: f });
    },
    deleteSelected: () => {
      const { scenario: o, selectedIds: l } = t(), u = o.objects.filter((v) => l.includes(v.id));
      if (!u.length) return;
      const d = new Set(
        u.filter((v) => v.type === "boat").map((v) => v.sequenceId)
      ), f = o.objects.filter(
        (v) => v.type === "boat" && d.has(v.sequenceId) && !l.includes(v.id)
      ), g = f.map((v) => {
        if (v.type !== "boat") return v;
        const E = f.filter(
          (S) => S.type === "boat" && S.sequenceId === v.sequenceId
        ).sort(
          (S, w) => S.type === "boat" && w.type === "boat" ? S.positionNumber - w.positionNumber : 0
        );
        return { ...v, positionNumber: E.findIndex(({ id: S }) => S === v.id) + 1 };
      }), h = [...u, ...f];
      r({
        label: `Deleted ${u.length} object${u.length === 1 ? "" : "s"}`,
        affectedIds: h.map(({ id: v }) => v),
        before: h,
        after: g
      }), e({ selectedIds: [] });
    },
    duplicateSelected: () => {
      const { scenario: o, selectedIds: l } = t(), u = [], d = [], f = [...o.objects];
      for (const g of o.objects.filter(
        (h) => l.includes(h.id)
      )) {
        const h = DT(g);
        if (h.type === "boat") {
          const v = {
            ...h,
            sequenceId: Ka(),
            positionNumber: 1,
            color: Ju(
              h.boatClass,
              u3(
                f,
                Df(o.canvas.background)
              )
            )
          };
          d.push(v), f.push(v);
        } else h.type === "mark" ? d.push({
          ...h,
          markNumber: String(h0([...o.objects, ...d]))
        }) : h.type === "gate" ? d.push({
          ...h,
          markNumber: h0([...o.objects, ...d])
        }) : d.push(h);
      }
      d.length && (r({
        label: "Duplicated selection",
        affectedIds: d.map(({ id: g }) => g),
        before: u,
        after: d
      }), e({ selectedIds: d.map(({ id: g }) => g) }));
    },
    setLayer: (o) => {
      const { scenario: l, selectedIds: u } = t(), d = l.objects.filter((v) => u.includes(v.id));
      if (!d.length) return;
      const f = Math.min(...l.objects.map((v) => v.zIndex)), g = Math.max(...l.objects.map((v) => v.zIndex)), h = o === "forward" ? 1 : o === "backward" ? -1 : 0;
      t().updateObjects(
        d.map((v, E) => ({
          id: v.id,
          patch: {
            zIndex: o === "front" ? g + E + 1 : o === "back" ? f - d.length + E : v.zIndex + h
          }
        })),
        "Changed layer order"
      );
    },
    undo: () => {
      const o = t(), l = o.history.at(-1);
      l && e({
        scenario: Ny(
          o.scenario,
          Ty(o.scenario.objects, l.affectedIds, l.before)
        ),
        history: o.history.slice(0, -1),
        future: [l, ...o.future],
        selectedIds: l.before.map(({ id: u }) => u),
        status: `Undid: ${l.label}`,
        documentStatus: Gc(o.documentStatus)
      });
    },
    redo: () => {
      const o = t(), l = o.future[0];
      l && e({
        scenario: Ny(
          o.scenario,
          Ty(o.scenario.objects, l.affectedIds, l.after)
        ),
        history: [...o.history, l],
        future: o.future.slice(1),
        selectedIds: l.after.map(({ id: u }) => u),
        status: `Redid: ${l.label}`,
        documentStatus: Gc(o.documentStatus)
      });
    }
  };
});
function D6(e) {
  return e.branding.partnerLinks !== null ? e.branding.partnerLinks : [
    ...e.links.website ? [{ label: "Website", url: e.links.website }] : [],
    ...e.links.imprint ? [{ label: "Legal Notice", url: e.links.imprint }] : []
  ];
}
var q2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function vm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var p0 = { exports: {} }, Jh = {}, Ay = {}, My = {}, A3;
function Rn() {
  return A3 || (A3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e._registerNode = e.Konva = e.glob = void 0;
    const t = Math.PI / 180;
    function r() {
      return typeof window < "u" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
    }
    e.glob = typeof q2 < "u" ? q2 : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, e.Konva = {
      _global: e.glob,
      version: "9.3.22",
      isBrowser: r(),
      isUnminified: /param/.test((function(l) {
      }).toString()),
      dblClickWindow: 400,
      getAngle(l) {
        return e.Konva.angleDeg ? l * t : l;
      },
      enableTrace: !1,
      pointerEventsEnabled: !0,
      autoDrawEnabled: !0,
      hitOnDragEnabled: !1,
      capturePointerEventsEnabled: !1,
      _mouseListenClick: !1,
      _touchListenClick: !1,
      _pointerListenClick: !1,
      _mouseInDblClickWindow: !1,
      _touchInDblClickWindow: !1,
      _pointerInDblClickWindow: !1,
      _mouseDblClickPointerId: null,
      _touchDblClickPointerId: null,
      _pointerDblClickPointerId: null,
      _fixTextRendering: !1,
      pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
      dragDistance: 3,
      angleDeg: !0,
      showWarnings: !0,
      dragButtons: [0, 1],
      isDragging() {
        return e.Konva.DD.isDragging;
      },
      isTransforming() {
        var l;
        return (l = e.Konva.Transformer) === null || l === void 0 ? void 0 : l.isTransforming();
      },
      isDragReady() {
        return !!e.Konva.DD.node;
      },
      releaseCanvasOnDestroy: !0,
      document: e.glob.document,
      _injectGlobal(l) {
        e.glob.Konva = l;
      }
    };
    const o = (l) => {
      e.Konva[l.prototype.getClassName()] = l;
    };
    e._registerNode = o, e.Konva._injectGlobal(e.Konva);
  })(My)), My;
}
var Py = {}, M3;
function jr() {
  return M3 || (M3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Util = e.Transform = void 0;
    const t = Rn();
    class r {
      constructor(R = [1, 0, 0, 1, 0, 0]) {
        this.dirty = !1, this.m = R && R.slice() || [1, 0, 0, 1, 0, 0];
      }
      reset() {
        this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
      }
      copy() {
        return new r(this.m);
      }
      copyInto(R) {
        R.m[0] = this.m[0], R.m[1] = this.m[1], R.m[2] = this.m[2], R.m[3] = this.m[3], R.m[4] = this.m[4], R.m[5] = this.m[5];
      }
      point(R) {
        const B = this.m;
        return {
          x: B[0] * R.x + B[2] * R.y + B[4],
          y: B[1] * R.x + B[3] * R.y + B[5]
        };
      }
      translate(R, B) {
        return this.m[4] += this.m[0] * R + this.m[2] * B, this.m[5] += this.m[1] * R + this.m[3] * B, this;
      }
      scale(R, B) {
        return this.m[0] *= R, this.m[1] *= R, this.m[2] *= B, this.m[3] *= B, this;
      }
      rotate(R) {
        const B = Math.cos(R), q = Math.sin(R), X = this.m[0] * B + this.m[2] * q, I = this.m[1] * B + this.m[3] * q, U = this.m[0] * -q + this.m[2] * B, F = this.m[1] * -q + this.m[3] * B;
        return this.m[0] = X, this.m[1] = I, this.m[2] = U, this.m[3] = F, this;
      }
      getTranslation() {
        return {
          x: this.m[4],
          y: this.m[5]
        };
      }
      skew(R, B) {
        const q = this.m[0] + this.m[2] * B, X = this.m[1] + this.m[3] * B, I = this.m[2] + this.m[0] * R, U = this.m[3] + this.m[1] * R;
        return this.m[0] = q, this.m[1] = X, this.m[2] = I, this.m[3] = U, this;
      }
      multiply(R) {
        const B = this.m[0] * R.m[0] + this.m[2] * R.m[1], q = this.m[1] * R.m[0] + this.m[3] * R.m[1], X = this.m[0] * R.m[2] + this.m[2] * R.m[3], I = this.m[1] * R.m[2] + this.m[3] * R.m[3], U = this.m[0] * R.m[4] + this.m[2] * R.m[5] + this.m[4], F = this.m[1] * R.m[4] + this.m[3] * R.m[5] + this.m[5];
        return this.m[0] = B, this.m[1] = q, this.m[2] = X, this.m[3] = I, this.m[4] = U, this.m[5] = F, this;
      }
      invert() {
        const R = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), B = this.m[3] * R, q = -this.m[1] * R, X = -this.m[2] * R, I = this.m[0] * R, U = R * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), F = R * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        return this.m[0] = B, this.m[1] = q, this.m[2] = X, this.m[3] = I, this.m[4] = U, this.m[5] = F, this;
      }
      getMatrix() {
        return this.m;
      }
      decompose() {
        const R = this.m[0], B = this.m[1], q = this.m[2], X = this.m[3], I = this.m[4], U = this.m[5], F = R * X - B * q, Z = {
          x: I,
          y: U,
          rotation: 0,
          scaleX: 0,
          scaleY: 0,
          skewX: 0,
          skewY: 0
        };
        if (R != 0 || B != 0) {
          const te = Math.sqrt(R * R + B * B);
          Z.rotation = B > 0 ? Math.acos(R / te) : -Math.acos(R / te), Z.scaleX = te, Z.scaleY = F / te, Z.skewX = (R * q + B * X) / F, Z.skewY = 0;
        } else if (q != 0 || X != 0) {
          const te = Math.sqrt(q * q + X * X);
          Z.rotation = Math.PI / 2 - (X > 0 ? Math.acos(-q / te) : -Math.acos(q / te)), Z.scaleX = F / te, Z.scaleY = te, Z.skewX = 0, Z.skewY = (R * q + B * X) / F;
        }
        return Z.rotation = e.Util._getRotation(Z.rotation), Z;
      }
    }
    e.Transform = r;
    const o = "[object Array]", l = "[object Number]", u = "[object String]", d = "[object Boolean]", f = Math.PI / 180, g = 180 / Math.PI, h = "#", v = "", E = "0", S = "Konva warning: ", w = "Konva error: ", T = "rgb(", P = {
      aliceblue: [240, 248, 255],
      antiquewhite: [250, 235, 215],
      aqua: [0, 255, 255],
      aquamarine: [127, 255, 212],
      azure: [240, 255, 255],
      beige: [245, 245, 220],
      bisque: [255, 228, 196],
      black: [0, 0, 0],
      blanchedalmond: [255, 235, 205],
      blue: [0, 0, 255],
      blueviolet: [138, 43, 226],
      brown: [165, 42, 42],
      burlywood: [222, 184, 135],
      cadetblue: [95, 158, 160],
      chartreuse: [127, 255, 0],
      chocolate: [210, 105, 30],
      coral: [255, 127, 80],
      cornflowerblue: [100, 149, 237],
      cornsilk: [255, 248, 220],
      crimson: [220, 20, 60],
      cyan: [0, 255, 255],
      darkblue: [0, 0, 139],
      darkcyan: [0, 139, 139],
      darkgoldenrod: [184, 132, 11],
      darkgray: [169, 169, 169],
      darkgreen: [0, 100, 0],
      darkgrey: [169, 169, 169],
      darkkhaki: [189, 183, 107],
      darkmagenta: [139, 0, 139],
      darkolivegreen: [85, 107, 47],
      darkorange: [255, 140, 0],
      darkorchid: [153, 50, 204],
      darkred: [139, 0, 0],
      darksalmon: [233, 150, 122],
      darkseagreen: [143, 188, 143],
      darkslateblue: [72, 61, 139],
      darkslategray: [47, 79, 79],
      darkslategrey: [47, 79, 79],
      darkturquoise: [0, 206, 209],
      darkviolet: [148, 0, 211],
      deeppink: [255, 20, 147],
      deepskyblue: [0, 191, 255],
      dimgray: [105, 105, 105],
      dimgrey: [105, 105, 105],
      dodgerblue: [30, 144, 255],
      firebrick: [178, 34, 34],
      floralwhite: [255, 255, 240],
      forestgreen: [34, 139, 34],
      fuchsia: [255, 0, 255],
      gainsboro: [220, 220, 220],
      ghostwhite: [248, 248, 255],
      gold: [255, 215, 0],
      goldenrod: [218, 165, 32],
      gray: [128, 128, 128],
      green: [0, 128, 0],
      greenyellow: [173, 255, 47],
      grey: [128, 128, 128],
      honeydew: [240, 255, 240],
      hotpink: [255, 105, 180],
      indianred: [205, 92, 92],
      indigo: [75, 0, 130],
      ivory: [255, 255, 240],
      khaki: [240, 230, 140],
      lavender: [230, 230, 250],
      lavenderblush: [255, 240, 245],
      lawngreen: [124, 252, 0],
      lemonchiffon: [255, 250, 205],
      lightblue: [173, 216, 230],
      lightcoral: [240, 128, 128],
      lightcyan: [224, 255, 255],
      lightgoldenrodyellow: [250, 250, 210],
      lightgray: [211, 211, 211],
      lightgreen: [144, 238, 144],
      lightgrey: [211, 211, 211],
      lightpink: [255, 182, 193],
      lightsalmon: [255, 160, 122],
      lightseagreen: [32, 178, 170],
      lightskyblue: [135, 206, 250],
      lightslategray: [119, 136, 153],
      lightslategrey: [119, 136, 153],
      lightsteelblue: [176, 196, 222],
      lightyellow: [255, 255, 224],
      lime: [0, 255, 0],
      limegreen: [50, 205, 50],
      linen: [250, 240, 230],
      magenta: [255, 0, 255],
      maroon: [128, 0, 0],
      mediumaquamarine: [102, 205, 170],
      mediumblue: [0, 0, 205],
      mediumorchid: [186, 85, 211],
      mediumpurple: [147, 112, 219],
      mediumseagreen: [60, 179, 113],
      mediumslateblue: [123, 104, 238],
      mediumspringgreen: [0, 250, 154],
      mediumturquoise: [72, 209, 204],
      mediumvioletred: [199, 21, 133],
      midnightblue: [25, 25, 112],
      mintcream: [245, 255, 250],
      mistyrose: [255, 228, 225],
      moccasin: [255, 228, 181],
      navajowhite: [255, 222, 173],
      navy: [0, 0, 128],
      oldlace: [253, 245, 230],
      olive: [128, 128, 0],
      olivedrab: [107, 142, 35],
      orange: [255, 165, 0],
      orangered: [255, 69, 0],
      orchid: [218, 112, 214],
      palegoldenrod: [238, 232, 170],
      palegreen: [152, 251, 152],
      paleturquoise: [175, 238, 238],
      palevioletred: [219, 112, 147],
      papayawhip: [255, 239, 213],
      peachpuff: [255, 218, 185],
      peru: [205, 133, 63],
      pink: [255, 192, 203],
      plum: [221, 160, 203],
      powderblue: [176, 224, 230],
      purple: [128, 0, 128],
      rebeccapurple: [102, 51, 153],
      red: [255, 0, 0],
      rosybrown: [188, 143, 143],
      royalblue: [65, 105, 225],
      saddlebrown: [139, 69, 19],
      salmon: [250, 128, 114],
      sandybrown: [244, 164, 96],
      seagreen: [46, 139, 87],
      seashell: [255, 245, 238],
      sienna: [160, 82, 45],
      silver: [192, 192, 192],
      skyblue: [135, 206, 235],
      slateblue: [106, 90, 205],
      slategray: [119, 128, 144],
      slategrey: [119, 128, 144],
      snow: [255, 255, 250],
      springgreen: [0, 255, 127],
      steelblue: [70, 130, 180],
      tan: [210, 180, 140],
      teal: [0, 128, 128],
      thistle: [216, 191, 216],
      transparent: [255, 255, 255, 0],
      tomato: [255, 99, 71],
      turquoise: [64, 224, 208],
      violet: [238, 130, 238],
      wheat: [245, 222, 179],
      white: [255, 255, 255],
      whitesmoke: [245, 245, 245],
      yellow: [255, 255, 0],
      yellowgreen: [154, 205, 5]
    }, z = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
    let L = [];
    const x = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(k) {
      setTimeout(k, 60);
    };
    e.Util = {
      _isElement(k) {
        return !!(k && k.nodeType == 1);
      },
      _isFunction(k) {
        return !!(k && k.constructor && k.call && k.apply);
      },
      _isPlainObject(k) {
        return !!k && k.constructor === Object;
      },
      _isArray(k) {
        return Object.prototype.toString.call(k) === o;
      },
      _isNumber(k) {
        return Object.prototype.toString.call(k) === l && !isNaN(k) && isFinite(k);
      },
      _isString(k) {
        return Object.prototype.toString.call(k) === u;
      },
      _isBoolean(k) {
        return Object.prototype.toString.call(k) === d;
      },
      isObject(k) {
        return k instanceof Object;
      },
      isValidSelector(k) {
        if (typeof k != "string")
          return !1;
        const R = k[0];
        return R === "#" || R === "." || R === R.toUpperCase();
      },
      _sign(k) {
        return k === 0 || k > 0 ? 1 : -1;
      },
      requestAnimFrame(k) {
        L.push(k), L.length === 1 && x(function() {
          const R = L;
          L = [], R.forEach(function(B) {
            B();
          });
        });
      },
      createCanvasElement() {
        const k = document.createElement("canvas");
        try {
          k.style = k.style || {};
        } catch {
        }
        return k;
      },
      createImageElement() {
        return document.createElement("img");
      },
      _isInDocument(k) {
        for (; k = k.parentNode; )
          if (k == document)
            return !0;
        return !1;
      },
      _urlToImage(k, R) {
        const B = e.Util.createImageElement();
        B.onload = function() {
          R(B);
        }, B.src = k;
      },
      _rgbToHex(k, R, B) {
        return ((1 << 24) + (k << 16) + (R << 8) + B).toString(16).slice(1);
      },
      _hexToRgb(k) {
        k = k.replace(h, v);
        const R = parseInt(k, 16);
        return {
          r: R >> 16 & 255,
          g: R >> 8 & 255,
          b: R & 255
        };
      },
      getRandomColor() {
        let k = (Math.random() * 16777215 << 0).toString(16);
        for (; k.length < 6; )
          k = E + k;
        return h + k;
      },
      getRGB(k) {
        let R;
        return k in P ? (R = P[k], {
          r: R[0],
          g: R[1],
          b: R[2]
        }) : k[0] === h ? this._hexToRgb(k.substring(1)) : k.substr(0, 4) === T ? (R = z.exec(k.replace(/ /g, "")), {
          r: parseInt(R[1], 10),
          g: parseInt(R[2], 10),
          b: parseInt(R[3], 10)
        }) : {
          r: 0,
          g: 0,
          b: 0
        };
      },
      colorToRGBA(k) {
        return k = k || "black", e.Util._namedColorToRBA(k) || e.Util._hex3ColorToRGBA(k) || e.Util._hex4ColorToRGBA(k) || e.Util._hex6ColorToRGBA(k) || e.Util._hex8ColorToRGBA(k) || e.Util._rgbColorToRGBA(k) || e.Util._rgbaColorToRGBA(k) || e.Util._hslColorToRGBA(k);
      },
      _namedColorToRBA(k) {
        const R = P[k.toLowerCase()];
        return R ? {
          r: R[0],
          g: R[1],
          b: R[2],
          a: 1
        } : null;
      },
      _rgbColorToRGBA(k) {
        if (k.indexOf("rgb(") === 0) {
          k = k.match(/rgb\(([^)]+)\)/)[1];
          const R = k.split(/ *, */).map(Number);
          return {
            r: R[0],
            g: R[1],
            b: R[2],
            a: 1
          };
        }
      },
      _rgbaColorToRGBA(k) {
        if (k.indexOf("rgba(") === 0) {
          k = k.match(/rgba\(([^)]+)\)/)[1];
          const R = k.split(/ *, */).map((B, q) => B.slice(-1) === "%" ? q === 3 ? parseInt(B) / 100 : parseInt(B) / 100 * 255 : Number(B));
          return {
            r: R[0],
            g: R[1],
            b: R[2],
            a: R[3]
          };
        }
      },
      _hex8ColorToRGBA(k) {
        if (k[0] === "#" && k.length === 9)
          return {
            r: parseInt(k.slice(1, 3), 16),
            g: parseInt(k.slice(3, 5), 16),
            b: parseInt(k.slice(5, 7), 16),
            a: parseInt(k.slice(7, 9), 16) / 255
          };
      },
      _hex6ColorToRGBA(k) {
        if (k[0] === "#" && k.length === 7)
          return {
            r: parseInt(k.slice(1, 3), 16),
            g: parseInt(k.slice(3, 5), 16),
            b: parseInt(k.slice(5, 7), 16),
            a: 1
          };
      },
      _hex4ColorToRGBA(k) {
        if (k[0] === "#" && k.length === 5)
          return {
            r: parseInt(k[1] + k[1], 16),
            g: parseInt(k[2] + k[2], 16),
            b: parseInt(k[3] + k[3], 16),
            a: parseInt(k[4] + k[4], 16) / 255
          };
      },
      _hex3ColorToRGBA(k) {
        if (k[0] === "#" && k.length === 4)
          return {
            r: parseInt(k[1] + k[1], 16),
            g: parseInt(k[2] + k[2], 16),
            b: parseInt(k[3] + k[3], 16),
            a: 1
          };
      },
      _hslColorToRGBA(k) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(k)) {
          const [R, ...B] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(k), q = Number(B[0]) / 360, X = Number(B[1]) / 100, I = Number(B[2]) / 100;
          let U, F, Z;
          if (X === 0)
            return Z = I * 255, {
              r: Math.round(Z),
              g: Math.round(Z),
              b: Math.round(Z),
              a: 1
            };
          I < 0.5 ? U = I * (1 + X) : U = I + X - I * X;
          const te = 2 * I - U, ie = [0, 0, 0];
          for (let ue = 0; ue < 3; ue++)
            F = q + 1 / 3 * -(ue - 1), F < 0 && F++, F > 1 && F--, 6 * F < 1 ? Z = te + (U - te) * 6 * F : 2 * F < 1 ? Z = U : 3 * F < 2 ? Z = te + (U - te) * (2 / 3 - F) * 6 : Z = te, ie[ue] = Z * 255;
          return {
            r: Math.round(ie[0]),
            g: Math.round(ie[1]),
            b: Math.round(ie[2]),
            a: 1
          };
        }
      },
      haveIntersection(k, R) {
        return !(R.x > k.x + k.width || R.x + R.width < k.x || R.y > k.y + k.height || R.y + R.height < k.y);
      },
      cloneObject(k) {
        const R = {};
        for (const B in k)
          this._isPlainObject(k[B]) ? R[B] = this.cloneObject(k[B]) : this._isArray(k[B]) ? R[B] = this.cloneArray(k[B]) : R[B] = k[B];
        return R;
      },
      cloneArray(k) {
        return k.slice(0);
      },
      degToRad(k) {
        return k * f;
      },
      radToDeg(k) {
        return k * g;
      },
      _degToRad(k) {
        return e.Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), e.Util.degToRad(k);
      },
      _radToDeg(k) {
        return e.Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), e.Util.radToDeg(k);
      },
      _getRotation(k) {
        return t.Konva.angleDeg ? e.Util.radToDeg(k) : k;
      },
      _capitalize(k) {
        return k.charAt(0).toUpperCase() + k.slice(1);
      },
      throw(k) {
        throw new Error(w + k);
      },
      error(k) {
        console.error(w + k);
      },
      warn(k) {
        t.Konva.showWarnings && console.warn(S + k);
      },
      each(k, R) {
        for (const B in k)
          R(B, k[B]);
      },
      _inRange(k, R, B) {
        return R <= k && k < B;
      },
      _getProjectionToSegment(k, R, B, q, X, I) {
        let U, F, Z;
        const te = (k - B) * (k - B) + (R - q) * (R - q);
        if (te == 0)
          U = k, F = R, Z = (X - B) * (X - B) + (I - q) * (I - q);
        else {
          const ie = ((X - k) * (B - k) + (I - R) * (q - R)) / te;
          ie < 0 ? (U = k, F = R, Z = (k - X) * (k - X) + (R - I) * (R - I)) : ie > 1 ? (U = B, F = q, Z = (B - X) * (B - X) + (q - I) * (q - I)) : (U = k + ie * (B - k), F = R + ie * (q - R), Z = (U - X) * (U - X) + (F - I) * (F - I));
        }
        return [U, F, Z];
      },
      _getProjectionToLine(k, R, B) {
        const q = e.Util.cloneObject(k);
        let X = Number.MAX_VALUE;
        return R.forEach(function(I, U) {
          if (!B && U === R.length - 1)
            return;
          const F = R[(U + 1) % R.length], Z = e.Util._getProjectionToSegment(I.x, I.y, F.x, F.y, k.x, k.y), te = Z[0], ie = Z[1], ue = Z[2];
          ue < X && (q.x = te, q.y = ie, X = ue);
        }), q;
      },
      _prepareArrayForTween(k, R, B) {
        const q = [], X = [];
        if (k.length > R.length) {
          const U = R;
          R = k, k = U;
        }
        for (let U = 0; U < k.length; U += 2)
          q.push({
            x: k[U],
            y: k[U + 1]
          });
        for (let U = 0; U < R.length; U += 2)
          X.push({
            x: R[U],
            y: R[U + 1]
          });
        const I = [];
        return X.forEach(function(U) {
          const F = e.Util._getProjectionToLine(U, q, B);
          I.push(F.x), I.push(F.y);
        }), I;
      },
      _prepareToStringify(k) {
        let R;
        k.visitedByCircularReferenceRemoval = !0;
        for (const B in k)
          if (k.hasOwnProperty(B) && k[B] && typeof k[B] == "object") {
            if (R = Object.getOwnPropertyDescriptor(k, B), k[B].visitedByCircularReferenceRemoval || e.Util._isElement(k[B]))
              if (R.configurable)
                delete k[B];
              else
                return null;
            else if (e.Util._prepareToStringify(k[B]) === null)
              if (R.configurable)
                delete k[B];
              else
                return null;
          }
        return delete k.visitedByCircularReferenceRemoval, k;
      },
      _assign(k, R) {
        for (const B in R)
          k[B] = R[B];
        return k;
      },
      _getFirstPointerId(k) {
        return k.touches ? k.changedTouches[0].identifier : k.pointerId || 999;
      },
      releaseCanvas(...k) {
        t.Konva.releaseCanvasOnDestroy && k.forEach((R) => {
          R.width = 0, R.height = 0;
        });
      },
      drawRoundedRectPath(k, R, B, q) {
        let X = 0, I = 0, U = 0, F = 0;
        typeof q == "number" ? X = I = U = F = Math.min(q, R / 2, B / 2) : (X = Math.min(q[0] || 0, R / 2, B / 2), I = Math.min(q[1] || 0, R / 2, B / 2), F = Math.min(q[2] || 0, R / 2, B / 2), U = Math.min(q[3] || 0, R / 2, B / 2)), k.moveTo(X, 0), k.lineTo(R - I, 0), k.arc(R - I, I, I, Math.PI * 3 / 2, 0, !1), k.lineTo(R, B - F), k.arc(R - F, B - F, F, 0, Math.PI / 2, !1), k.lineTo(U, B), k.arc(U, B - U, U, Math.PI / 2, Math.PI, !1), k.lineTo(0, X), k.arc(X, X, X, Math.PI, Math.PI * 3 / 2, !1);
      }
    };
  })(Py)), Py;
}
var $h = {}, Kl = {}, jl = {}, P3;
function L6() {
  if (P3) return jl;
  P3 = 1, Object.defineProperty(jl, "__esModule", { value: !0 }), jl.HitContext = jl.SceneContext = jl.Context = void 0;
  const e = jr(), t = Rn();
  function r(L) {
    const x = [], k = L.length, R = e.Util;
    for (let B = 0; B < k; B++) {
      let q = L[B];
      R._isNumber(q) ? q = Math.round(q * 1e3) / 1e3 : R._isString(q) || (q = q + ""), x.push(q);
    }
    return x;
  }
  const o = ",", l = "(", u = ")", d = "([", f = "])", g = ";", h = "()", v = "=", E = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
  ], S = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled"
  ], w = 100;
  let T = class {
    constructor(x) {
      this.canvas = x, t.Konva.enableTrace && (this.traceArr = [], this._enableTrace());
    }
    fillShape(x) {
      x.fillEnabled() && this._fill(x);
    }
    _fill(x) {
    }
    strokeShape(x) {
      x.hasStroke() && this._stroke(x);
    }
    _stroke(x) {
    }
    fillStrokeShape(x) {
      x.attrs.fillAfterStrokeEnabled ? (this.strokeShape(x), this.fillShape(x)) : (this.fillShape(x), this.strokeShape(x));
    }
    getTrace(x, k) {
      let R = this.traceArr, B = R.length, q = "", X, I, U, F;
      for (X = 0; X < B; X++)
        I = R[X], U = I.method, U ? (F = I.args, q += U, x ? q += h : e.Util._isArray(F[0]) ? q += d + F.join(o) + f : (k && (F = F.map((Z) => typeof Z == "number" ? Math.floor(Z) : Z)), q += l + F.join(o) + u)) : (q += I.property, x || (q += v + I.val)), q += g;
      return q;
    }
    clearTrace() {
      this.traceArr = [];
    }
    _trace(x) {
      let k = this.traceArr, R;
      k.push(x), R = k.length, R >= w && k.shift();
    }
    reset() {
      const x = this.getCanvas().getPixelRatio();
      this.setTransform(1 * x, 0, 0, 1 * x, 0, 0);
    }
    getCanvas() {
      return this.canvas;
    }
    clear(x) {
      const k = this.getCanvas();
      x ? this.clearRect(x.x || 0, x.y || 0, x.width || 0, x.height || 0) : this.clearRect(0, 0, k.getWidth() / k.pixelRatio, k.getHeight() / k.pixelRatio);
    }
    _applyLineCap(x) {
      const k = x.attrs.lineCap;
      k && this.setAttr("lineCap", k);
    }
    _applyOpacity(x) {
      const k = x.getAbsoluteOpacity();
      k !== 1 && this.setAttr("globalAlpha", k);
    }
    _applyLineJoin(x) {
      const k = x.attrs.lineJoin;
      k && this.setAttr("lineJoin", k);
    }
    setAttr(x, k) {
      this._context[x] = k;
    }
    arc(x, k, R, B, q, X) {
      this._context.arc(x, k, R, B, q, X);
    }
    arcTo(x, k, R, B, q) {
      this._context.arcTo(x, k, R, B, q);
    }
    beginPath() {
      this._context.beginPath();
    }
    bezierCurveTo(x, k, R, B, q, X) {
      this._context.bezierCurveTo(x, k, R, B, q, X);
    }
    clearRect(x, k, R, B) {
      this._context.clearRect(x, k, R, B);
    }
    clip(...x) {
      this._context.clip.apply(this._context, x);
    }
    closePath() {
      this._context.closePath();
    }
    createImageData(x, k) {
      const R = arguments;
      if (R.length === 2)
        return this._context.createImageData(x, k);
      if (R.length === 1)
        return this._context.createImageData(x);
    }
    createLinearGradient(x, k, R, B) {
      return this._context.createLinearGradient(x, k, R, B);
    }
    createPattern(x, k) {
      return this._context.createPattern(x, k);
    }
    createRadialGradient(x, k, R, B, q, X) {
      return this._context.createRadialGradient(x, k, R, B, q, X);
    }
    drawImage(x, k, R, B, q, X, I, U, F) {
      const Z = arguments, te = this._context;
      Z.length === 3 ? te.drawImage(x, k, R) : Z.length === 5 ? te.drawImage(x, k, R, B, q) : Z.length === 9 && te.drawImage(x, k, R, B, q, X, I, U, F);
    }
    ellipse(x, k, R, B, q, X, I, U) {
      this._context.ellipse(x, k, R, B, q, X, I, U);
    }
    isPointInPath(x, k, R, B) {
      return R ? this._context.isPointInPath(R, x, k, B) : this._context.isPointInPath(x, k, B);
    }
    fill(...x) {
      this._context.fill.apply(this._context, x);
    }
    fillRect(x, k, R, B) {
      this._context.fillRect(x, k, R, B);
    }
    strokeRect(x, k, R, B) {
      this._context.strokeRect(x, k, R, B);
    }
    fillText(x, k, R, B) {
      B ? this._context.fillText(x, k, R, B) : this._context.fillText(x, k, R);
    }
    measureText(x) {
      return this._context.measureText(x);
    }
    getImageData(x, k, R, B) {
      return this._context.getImageData(x, k, R, B);
    }
    lineTo(x, k) {
      this._context.lineTo(x, k);
    }
    moveTo(x, k) {
      this._context.moveTo(x, k);
    }
    rect(x, k, R, B) {
      this._context.rect(x, k, R, B);
    }
    roundRect(x, k, R, B, q) {
      this._context.roundRect(x, k, R, B, q);
    }
    putImageData(x, k, R) {
      this._context.putImageData(x, k, R);
    }
    quadraticCurveTo(x, k, R, B) {
      this._context.quadraticCurveTo(x, k, R, B);
    }
    restore() {
      this._context.restore();
    }
    rotate(x) {
      this._context.rotate(x);
    }
    save() {
      this._context.save();
    }
    scale(x, k) {
      this._context.scale(x, k);
    }
    setLineDash(x) {
      this._context.setLineDash ? this._context.setLineDash(x) : "mozDash" in this._context ? this._context.mozDash = x : "webkitLineDash" in this._context && (this._context.webkitLineDash = x);
    }
    getLineDash() {
      return this._context.getLineDash();
    }
    setTransform(x, k, R, B, q, X) {
      this._context.setTransform(x, k, R, B, q, X);
    }
    stroke(x) {
      x ? this._context.stroke(x) : this._context.stroke();
    }
    strokeText(x, k, R, B) {
      this._context.strokeText(x, k, R, B);
    }
    transform(x, k, R, B, q, X) {
      this._context.transform(x, k, R, B, q, X);
    }
    translate(x, k) {
      this._context.translate(x, k);
    }
    _enableTrace() {
      let x = this, k = E.length, R = this.setAttr, B, q;
      const X = function(I) {
        let U = x[I], F;
        x[I] = function() {
          return q = r(Array.prototype.slice.call(arguments, 0)), F = U.apply(x, arguments), x._trace({
            method: I,
            args: q
          }), F;
        };
      };
      for (B = 0; B < k; B++)
        X(E[B]);
      x.setAttr = function() {
        R.apply(x, arguments);
        const I = arguments[0];
        let U = arguments[1];
        (I === "shadowOffsetX" || I === "shadowOffsetY" || I === "shadowBlur") && (U = U / this.canvas.getPixelRatio()), x._trace({
          property: I,
          val: U
        });
      };
    }
    _applyGlobalCompositeOperation(x) {
      const k = x.attrs.globalCompositeOperation;
      !k || k === "source-over" || this.setAttr("globalCompositeOperation", k);
    }
  };
  jl.Context = T, S.forEach(function(L) {
    Object.defineProperty(T.prototype, L, {
      get() {
        return this._context[L];
      },
      set(x) {
        this._context[L] = x;
      }
    });
  });
  class P extends T {
    constructor(x, { willReadFrequently: k = !1 } = {}) {
      super(x), this._context = x._canvas.getContext("2d", {
        willReadFrequently: k
      });
    }
    _fillColor(x) {
      const k = x.fill();
      this.setAttr("fillStyle", k), x._fillFunc(this);
    }
    _fillPattern(x) {
      this.setAttr("fillStyle", x._getFillPattern()), x._fillFunc(this);
    }
    _fillLinearGradient(x) {
      const k = x._getLinearGradient();
      k && (this.setAttr("fillStyle", k), x._fillFunc(this));
    }
    _fillRadialGradient(x) {
      const k = x._getRadialGradient();
      k && (this.setAttr("fillStyle", k), x._fillFunc(this));
    }
    _fill(x) {
      const k = x.fill(), R = x.getFillPriority();
      if (k && R === "color") {
        this._fillColor(x);
        return;
      }
      const B = x.getFillPatternImage();
      if (B && R === "pattern") {
        this._fillPattern(x);
        return;
      }
      const q = x.getFillLinearGradientColorStops();
      if (q && R === "linear-gradient") {
        this._fillLinearGradient(x);
        return;
      }
      const X = x.getFillRadialGradientColorStops();
      if (X && R === "radial-gradient") {
        this._fillRadialGradient(x);
        return;
      }
      k ? this._fillColor(x) : B ? this._fillPattern(x) : q ? this._fillLinearGradient(x) : X && this._fillRadialGradient(x);
    }
    _strokeLinearGradient(x) {
      const k = x.getStrokeLinearGradientStartPoint(), R = x.getStrokeLinearGradientEndPoint(), B = x.getStrokeLinearGradientColorStops(), q = this.createLinearGradient(k.x, k.y, R.x, R.y);
      if (B) {
        for (let X = 0; X < B.length; X += 2)
          q.addColorStop(B[X], B[X + 1]);
        this.setAttr("strokeStyle", q);
      }
    }
    _stroke(x) {
      const k = x.dash(), R = x.getStrokeScaleEnabled();
      if (x.hasStroke()) {
        if (!R) {
          this.save();
          const q = this.getCanvas().getPixelRatio();
          this.setTransform(q, 0, 0, q, 0, 0);
        }
        this._applyLineCap(x), k && x.dashEnabled() && (this.setLineDash(k), this.setAttr("lineDashOffset", x.dashOffset())), this.setAttr("lineWidth", x.strokeWidth()), x.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)"), x.getStrokeLinearGradientColorStops() ? this._strokeLinearGradient(x) : this.setAttr("strokeStyle", x.stroke()), x._strokeFunc(this), R || this.restore();
      }
    }
    _applyShadow(x) {
      var k, R, B;
      const q = (k = x.getShadowRGBA()) !== null && k !== void 0 ? k : "black", X = (R = x.getShadowBlur()) !== null && R !== void 0 ? R : 5, I = (B = x.getShadowOffset()) !== null && B !== void 0 ? B : {
        x: 0,
        y: 0
      }, U = x.getAbsoluteScale(), F = this.canvas.getPixelRatio(), Z = U.x * F, te = U.y * F;
      this.setAttr("shadowColor", q), this.setAttr("shadowBlur", X * Math.min(Math.abs(Z), Math.abs(te))), this.setAttr("shadowOffsetX", I.x * Z), this.setAttr("shadowOffsetY", I.y * te);
    }
  }
  jl.SceneContext = P;
  class z extends T {
    constructor(x) {
      super(x), this._context = x._canvas.getContext("2d", {
        willReadFrequently: !0
      });
    }
    _fill(x) {
      this.save(), this.setAttr("fillStyle", x.colorKey), x._fillFuncHit(this), this.restore();
    }
    strokeShape(x) {
      x.hasHitStroke() && this._stroke(x);
    }
    _stroke(x) {
      if (x.hasHitStroke()) {
        const k = x.getStrokeScaleEnabled();
        if (!k) {
          this.save();
          const q = this.getCanvas().getPixelRatio();
          this.setTransform(q, 0, 0, q, 0, 0);
        }
        this._applyLineCap(x);
        const R = x.hitStrokeWidth(), B = R === "auto" ? x.strokeWidth() : R;
        this.setAttr("lineWidth", B), this.setAttr("strokeStyle", x.colorKey), x._strokeFuncHit(this), k || this.restore();
      }
    }
  }
  return jl.HitContext = z, jl;
}
var D3;
function Q0() {
  if (D3) return Kl;
  D3 = 1, Object.defineProperty(Kl, "__esModule", { value: !0 }), Kl.HitCanvas = Kl.SceneCanvas = Kl.Canvas = void 0;
  const e = jr(), t = L6(), r = Rn();
  let o;
  function l() {
    if (o)
      return o;
    const g = e.Util.createCanvasElement(), h = g.getContext("2d");
    return o = (function() {
      const v = r.Konva._global.devicePixelRatio || 1, E = h.webkitBackingStorePixelRatio || h.mozBackingStorePixelRatio || h.msBackingStorePixelRatio || h.oBackingStorePixelRatio || h.backingStorePixelRatio || 1;
      return v / E;
    })(), e.Util.releaseCanvas(g), o;
  }
  let u = class {
    constructor(h) {
      this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
      const E = (h || {}).pixelRatio || r.Konva.pixelRatio || l();
      this.pixelRatio = E, this._canvas = e.Util.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
    }
    getContext() {
      return this.context;
    }
    getPixelRatio() {
      return this.pixelRatio;
    }
    setPixelRatio(h) {
      const v = this.pixelRatio;
      this.pixelRatio = h, this.setSize(this.getWidth() / v, this.getHeight() / v);
    }
    setWidth(h) {
      this.width = this._canvas.width = h * this.pixelRatio, this._canvas.style.width = h + "px";
      const v = this.pixelRatio;
      this.getContext()._context.scale(v, v);
    }
    setHeight(h) {
      this.height = this._canvas.height = h * this.pixelRatio, this._canvas.style.height = h + "px";
      const v = this.pixelRatio;
      this.getContext()._context.scale(v, v);
    }
    getWidth() {
      return this.width;
    }
    getHeight() {
      return this.height;
    }
    setSize(h, v) {
      this.setWidth(h || 0), this.setHeight(v || 0);
    }
    toDataURL(h, v) {
      try {
        return this._canvas.toDataURL(h, v);
      } catch {
        try {
          return this._canvas.toDataURL();
        } catch (S) {
          return e.Util.error("Unable to get data URL. " + S.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
        }
      }
    }
  };
  Kl.Canvas = u;
  class d extends u {
    constructor(h = { width: 0, height: 0, willReadFrequently: !1 }) {
      super(h), this.context = new t.SceneContext(this, {
        willReadFrequently: h.willReadFrequently
      }), this.setSize(h.width, h.height);
    }
  }
  Kl.SceneCanvas = d;
  class f extends u {
    constructor(h = { width: 0, height: 0 }) {
      super(h), this.hitCanvas = !0, this.context = new t.HitContext(this), this.setSize(h.width, h.height);
    }
  }
  return Kl.HitCanvas = f, Kl;
}
var Dy = {}, L3;
function bb() {
  return L3 || (L3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.DD = void 0;
    const t = Rn(), r = jr();
    e.DD = {
      get isDragging() {
        let o = !1;
        return e.DD._dragElements.forEach((l) => {
          l.dragStatus === "dragging" && (o = !0);
        }), o;
      },
      justDragged: !1,
      get node() {
        let o;
        return e.DD._dragElements.forEach((l) => {
          o = l.node;
        }), o;
      },
      _dragElements: /* @__PURE__ */ new Map(),
      _drag(o) {
        const l = [];
        e.DD._dragElements.forEach((u, d) => {
          const { node: f } = u, g = f.getStage();
          g.setPointersPositions(o), u.pointerId === void 0 && (u.pointerId = r.Util._getFirstPointerId(o));
          const h = g._changedPointerPositions.find((v) => v.id === u.pointerId);
          if (h) {
            if (u.dragStatus !== "dragging") {
              const v = f.dragDistance();
              if (Math.max(Math.abs(h.x - u.startPointerPos.x), Math.abs(h.y - u.startPointerPos.y)) < v || (f.startDrag({ evt: o }), !f.isDragging()))
                return;
            }
            f._setDragPosition(o, u), l.push(f);
          }
        }), l.forEach((u) => {
          u.fire("dragmove", {
            type: "dragmove",
            target: u,
            evt: o
          }, !0);
        });
      },
      _endDragBefore(o) {
        const l = [];
        e.DD._dragElements.forEach((u) => {
          const { node: d } = u, f = d.getStage();
          if (o && f.setPointersPositions(o), !f._changedPointerPositions.find((v) => v.id === u.pointerId))
            return;
          (u.dragStatus === "dragging" || u.dragStatus === "stopped") && (e.DD.justDragged = !0, t.Konva._mouseListenClick = !1, t.Konva._touchListenClick = !1, t.Konva._pointerListenClick = !1, u.dragStatus = "stopped");
          const h = u.node.getLayer() || u.node instanceof t.Konva.Stage && u.node;
          h && l.indexOf(h) === -1 && l.push(h);
        }), l.forEach((u) => {
          u.draw();
        });
      },
      _endDragAfter(o) {
        e.DD._dragElements.forEach((l, u) => {
          l.dragStatus === "stopped" && l.node.fire("dragend", {
            type: "dragend",
            target: l.node,
            evt: o
          }, !0), l.dragStatus !== "dragging" && e.DD._dragElements.delete(u);
        });
      }
    }, t.Konva.isBrowser && (window.addEventListener("mouseup", e.DD._endDragBefore, !0), window.addEventListener("touchend", e.DD._endDragBefore, !0), window.addEventListener("touchcancel", e.DD._endDragBefore, !0), window.addEventListener("mousemove", e.DD._drag), window.addEventListener("touchmove", e.DD._drag), window.addEventListener("mouseup", e.DD._endDragAfter, !1), window.addEventListener("touchend", e.DD._endDragAfter, !1), window.addEventListener("touchcancel", e.DD._endDragAfter, !1));
  })(Dy)), Dy;
}
var Ly = {}, to = {}, O3;
function Vn() {
  if (O3) return to;
  O3 = 1, Object.defineProperty(to, "__esModule", { value: !0 }), to.RGBComponent = o, to.alphaComponent = l, to.getNumberValidator = u, to.getNumberOrArrayOfNumbersValidator = d, to.getNumberOrAutoValidator = f, to.getStringValidator = g, to.getStringOrGradientValidator = h, to.getFunctionValidator = v, to.getNumberArrayValidator = E, to.getBooleanValidator = S, to.getComponentValidator = w;
  const e = Rn(), t = jr();
  function r(T) {
    return t.Util._isString(T) ? '"' + T + '"' : Object.prototype.toString.call(T) === "[object Number]" || t.Util._isBoolean(T) ? T : Object.prototype.toString.call(T);
  }
  function o(T) {
    return T > 255 ? 255 : T < 0 ? 0 : Math.round(T);
  }
  function l(T) {
    return T > 1 ? 1 : T < 1e-4 ? 1e-4 : T;
  }
  function u() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        return t.Util._isNumber(T) || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a number.'), T;
      };
  }
  function d(T) {
    if (e.Konva.isUnminified)
      return function(P, z) {
        let L = t.Util._isNumber(P), x = t.Util._isArray(P) && P.length == T;
        return !L && !x && t.Util.warn(r(P) + ' is a not valid value for "' + z + '" attribute. The value should be a number or Array<number>(' + T + ")"), P;
      };
  }
  function f() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        return t.Util._isNumber(T) || T === "auto" || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a number or "auto".'), T;
      };
  }
  function g() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        return t.Util._isString(T) || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a string.'), T;
      };
  }
  function h() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        const z = t.Util._isString(T), L = Object.prototype.toString.call(T) === "[object CanvasGradient]" || T && T.addColorStop;
        return z || L || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a string or a native gradient.'), T;
      };
  }
  function v() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        return t.Util._isFunction(T) || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a function.'), T;
      };
  }
  function E() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        const z = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        return z && T instanceof z || (t.Util._isArray(T) ? T.forEach(function(L) {
          t.Util._isNumber(L) || t.Util.warn('"' + P + '" attribute has non numeric element ' + L + ". Make sure that all elements are numbers.");
        }) : t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a array of numbers.')), T;
      };
  }
  function S() {
    if (e.Konva.isUnminified)
      return function(T, P) {
        return T === !0 || T === !1 || t.Util.warn(r(T) + ' is a not valid value for "' + P + '" attribute. The value should be a boolean.'), T;
      };
  }
  function w(T) {
    if (e.Konva.isUnminified)
      return function(P, z) {
        return P == null || t.Util.isObject(P) || t.Util.warn(r(P) + ' is a not valid value for "' + z + '" attribute. The value should be an object with properties ' + T), P;
      };
  }
  return to;
}
var F3;
function On() {
  return F3 || (F3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Factory = void 0;
    const t = jr(), r = Vn(), o = "get", l = "set";
    e.Factory = {
      addGetterSetter(u, d, f, g, h) {
        e.Factory.addGetter(u, d, f), e.Factory.addSetter(u, d, g, h), e.Factory.addOverloadedGetterSetter(u, d);
      },
      addGetter(u, d, f) {
        const g = o + t.Util._capitalize(d);
        u.prototype[g] = u.prototype[g] || function() {
          const h = this.attrs[d];
          return h === void 0 ? f : h;
        };
      },
      addSetter(u, d, f, g) {
        const h = l + t.Util._capitalize(d);
        u.prototype[h] || e.Factory.overWriteSetter(u, d, f, g);
      },
      overWriteSetter(u, d, f, g) {
        const h = l + t.Util._capitalize(d);
        u.prototype[h] = function(v) {
          return f && v !== void 0 && v !== null && (v = f.call(this, v, d)), this._setAttr(d, v), g && g.call(this), this;
        };
      },
      addComponentsGetterSetter(u, d, f, g, h) {
        const v = f.length, E = t.Util._capitalize, S = o + E(d), w = l + E(d);
        u.prototype[S] = function() {
          const P = {};
          for (let z = 0; z < v; z++) {
            const L = f[z];
            P[L] = this.getAttr(d + E(L));
          }
          return P;
        };
        const T = (0, r.getComponentValidator)(f);
        u.prototype[w] = function(P) {
          const z = this.attrs[d];
          g && (P = g.call(this, P, d)), T && T.call(this, P, d);
          for (const L in P)
            P.hasOwnProperty(L) && this._setAttr(d + E(L), P[L]);
          return P || f.forEach((L) => {
            this._setAttr(d + E(L), void 0);
          }), this._fireChangeEvent(d, z, P), h && h.call(this), this;
        }, e.Factory.addOverloadedGetterSetter(u, d);
      },
      addOverloadedGetterSetter(u, d) {
        const f = t.Util._capitalize(d), g = l + f, h = o + f;
        u.prototype[d] = function() {
          return arguments.length ? (this[g](arguments[0]), this) : this[h]();
        };
      },
      addDeprecatedGetterSetter(u, d, f, g) {
        t.Util.error("Adding deprecated " + d);
        const h = o + t.Util._capitalize(d), v = d + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        u.prototype[h] = function() {
          t.Util.error(v);
          const E = this.attrs[d];
          return E === void 0 ? f : E;
        }, e.Factory.addSetter(u, d, g, function() {
          t.Util.error(v);
        }), e.Factory.addOverloadedGetterSetter(u, d);
      },
      backCompat(u, d) {
        t.Util.each(d, function(f, g) {
          const h = u.prototype[g], v = o + t.Util._capitalize(f), E = l + t.Util._capitalize(f);
          function S() {
            h.apply(this, arguments), t.Util.error('"' + f + '" method is deprecated and will be removed soon. Use ""' + g + '" instead.');
          }
          u.prototype[f] = S, u.prototype[v] = S, u.prototype[E] = S;
        });
      },
      afterSetFilter() {
        this._filterUpToDate = !1;
      }
    };
  })(Ly)), Ly;
}
var z3;
function ra() {
  if (z3) return $h;
  z3 = 1, Object.defineProperty($h, "__esModule", { value: !0 }), $h.Node = void 0;
  const e = Q0(), t = bb(), r = On(), o = Rn(), l = jr(), u = Vn(), d = "absoluteOpacity", f = "allEventListeners", g = "absoluteTransform", h = "absoluteScale", v = "canvas", E = "Change", S = "children", w = "konva", T = "listening", P = "mouseenter", z = "mouseleave", L = "pointerenter", x = "pointerleave", k = "touchenter", R = "touchleave", B = "set", q = "Shape", X = " ", I = "stage", U = "transform", F = "Stage", Z = "visible", te = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
  ].join(X);
  let ie = 1, ue = class W2 {
    constructor(W) {
      this._id = ie++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(W), this._shouldFireChangeEvents = !0;
    }
    hasChildren() {
      return !1;
    }
    _clearCache(W) {
      (W === U || W === g) && this._cache.get(W) ? this._cache.get(W).dirty = !0 : W ? this._cache.delete(W) : this._cache.clear();
    }
    _getCache(W, j) {
      let ee = this._cache.get(W);
      return (ee === void 0 || (W === U || W === g) && ee.dirty === !0) && (ee = j.call(this), this._cache.set(W, ee)), ee;
    }
    _calculate(W, j, ee) {
      if (!this._attachedDepsListeners.get(W)) {
        const Q = j.map((oe) => oe + "Change.konva").join(X);
        this.on(Q, () => {
          this._clearCache(W);
        }), this._attachedDepsListeners.set(W, !0);
      }
      return this._getCache(W, ee);
    }
    _getCanvasCache() {
      return this._cache.get(v);
    }
    _clearSelfAndDescendantCache(W) {
      this._clearCache(W), W === g && this.fire("absoluteTransformChange");
    }
    clearCache() {
      if (this._cache.has(v)) {
        const { scene: W, filter: j, hit: ee, buffer: Q } = this._cache.get(v);
        l.Util.releaseCanvas(W, j, ee, Q), this._cache.delete(v);
      }
      return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
    }
    cache(W) {
      const j = W || {};
      let ee = {};
      (j.x === void 0 || j.y === void 0 || j.width === void 0 || j.height === void 0) && (ee = this.getClientRect({
        skipTransform: !0,
        relativeTo: this.getParent() || void 0
      }));
      let Q = Math.ceil(j.width || ee.width), oe = Math.ceil(j.height || ee.height), ye = j.pixelRatio, pe = j.x === void 0 ? Math.floor(ee.x) : j.x, Me = j.y === void 0 ? Math.floor(ee.y) : j.y, We = j.offset || 0, Ee = j.drawBorder || !1, ae = j.hitCanvasPixelRatio || 1;
      if (!Q || !oe) {
        l.Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
        return;
      }
      const Re = Math.abs(Math.round(ee.x) - pe) > 0.5 ? 1 : 0, Qe = Math.abs(Math.round(ee.y) - Me) > 0.5 ? 1 : 0;
      Q += We * 2 + Re, oe += We * 2 + Qe, pe -= We, Me -= We;
      const Pe = new e.SceneCanvas({
        pixelRatio: ye,
        width: Q,
        height: oe
      }), rt = new e.SceneCanvas({
        pixelRatio: ye,
        width: 0,
        height: 0,
        willReadFrequently: !0
      }), st = new e.HitCanvas({
        pixelRatio: ae,
        width: Q,
        height: oe
      }), bt = Pe.getContext(), Xt = st.getContext(), Lt = new e.SceneCanvas({
        width: Pe.width / Pe.pixelRatio + Math.abs(pe),
        height: Pe.height / Pe.pixelRatio + Math.abs(Me),
        pixelRatio: Pe.pixelRatio
      }), qn = Lt.getContext();
      return st.isCache = !0, Pe.isCache = !0, this._cache.delete(v), this._filterUpToDate = !1, j.imageSmoothingEnabled === !1 && (Pe.getContext()._context.imageSmoothingEnabled = !1, rt.getContext()._context.imageSmoothingEnabled = !1), bt.save(), Xt.save(), qn.save(), bt.translate(-pe, -Me), Xt.translate(-pe, -Me), qn.translate(-pe, -Me), Lt.x = pe, Lt.y = Me, this._isUnderCache = !0, this._clearSelfAndDescendantCache(d), this._clearSelfAndDescendantCache(h), this.drawScene(Pe, this, Lt), this.drawHit(st, this), this._isUnderCache = !1, bt.restore(), Xt.restore(), Ee && (bt.save(), bt.beginPath(), bt.rect(0, 0, Q, oe), bt.closePath(), bt.setAttr("strokeStyle", "red"), bt.setAttr("lineWidth", 5), bt.stroke(), bt.restore()), this._cache.set(v, {
        scene: Pe,
        filter: rt,
        hit: st,
        buffer: Lt,
        x: pe,
        y: Me
      }), this._requestDraw(), this;
    }
    isCached() {
      return this._cache.has(v);
    }
    getClientRect(W) {
      throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(W, j) {
      const ee = [
        { x: W.x, y: W.y },
        { x: W.x + W.width, y: W.y },
        { x: W.x + W.width, y: W.y + W.height },
        { x: W.x, y: W.y + W.height }
      ];
      let Q = 1 / 0, oe = 1 / 0, ye = -1 / 0, pe = -1 / 0;
      const Me = this.getAbsoluteTransform(j);
      return ee.forEach(function(We) {
        const Ee = Me.point(We);
        Q === void 0 && (Q = ye = Ee.x, oe = pe = Ee.y), Q = Math.min(Q, Ee.x), oe = Math.min(oe, Ee.y), ye = Math.max(ye, Ee.x), pe = Math.max(pe, Ee.y);
      }), {
        x: Q,
        y: oe,
        width: ye - Q,
        height: pe - oe
      };
    }
    _drawCachedSceneCanvas(W) {
      W.save(), W._applyOpacity(this), W._applyGlobalCompositeOperation(this);
      const j = this._getCanvasCache();
      W.translate(j.x, j.y);
      const ee = this._getCachedSceneCanvas(), Q = ee.pixelRatio;
      W.drawImage(ee._canvas, 0, 0, ee.width / Q, ee.height / Q), W.restore();
    }
    _drawCachedHitCanvas(W) {
      const j = this._getCanvasCache(), ee = j.hit;
      W.save(), W.translate(j.x, j.y), W.drawImage(ee._canvas, 0, 0, ee.width / ee.pixelRatio, ee.height / ee.pixelRatio), W.restore();
    }
    _getCachedSceneCanvas() {
      let W = this.filters(), j = this._getCanvasCache(), ee = j.scene, Q = j.filter, oe = Q.getContext(), ye, pe, Me, We;
      if (W) {
        if (!this._filterUpToDate) {
          const Ee = ee.pixelRatio;
          Q.setSize(ee.width / ee.pixelRatio, ee.height / ee.pixelRatio);
          try {
            for (ye = W.length, oe.clear(), oe.drawImage(ee._canvas, 0, 0, ee.getWidth() / Ee, ee.getHeight() / Ee), pe = oe.getImageData(0, 0, Q.getWidth(), Q.getHeight()), Me = 0; Me < ye; Me++) {
              if (We = W[Me], typeof We != "function") {
                l.Util.error("Filter should be type of function, but got " + typeof We + " instead. Please check correct filters");
                continue;
              }
              We.call(this, pe), oe.putImageData(pe, 0, 0);
            }
          } catch (ae) {
            l.Util.error("Unable to apply filter. " + ae.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
          }
          this._filterUpToDate = !0;
        }
        return Q;
      }
      return ee;
    }
    on(W, j) {
      if (this._cache && this._cache.delete(f), arguments.length === 3)
        return this._delegate.apply(this, arguments);
      const ee = W.split(X);
      for (let Q = 0; Q < ee.length; Q++) {
        const ye = ee[Q].split("."), pe = ye[0], Me = ye[1] || "";
        this.eventListeners[pe] || (this.eventListeners[pe] = []), this.eventListeners[pe].push({ name: Me, handler: j });
      }
      return this;
    }
    off(W, j) {
      let ee = (W || "").split(X), Q = ee.length, oe, ye, pe, Me, We, Ee;
      if (this._cache && this._cache.delete(f), !W)
        for (ye in this.eventListeners)
          this._off(ye);
      for (oe = 0; oe < Q; oe++)
        if (pe = ee[oe], Me = pe.split("."), We = Me[0], Ee = Me[1], We)
          this.eventListeners[We] && this._off(We, Ee, j);
        else
          for (ye in this.eventListeners)
            this._off(ye, Ee, j);
      return this;
    }
    dispatchEvent(W) {
      const j = {
        target: this,
        type: W.type,
        evt: W
      };
      return this.fire(W.type, j), this;
    }
    addEventListener(W, j) {
      return this.on(W, function(ee) {
        j.call(this, ee.evt);
      }), this;
    }
    removeEventListener(W) {
      return this.off(W), this;
    }
    _delegate(W, j, ee) {
      const Q = this;
      this.on(W, function(oe) {
        const ye = oe.target.findAncestors(j, !0, Q);
        for (let pe = 0; pe < ye.length; pe++)
          oe = l.Util.cloneObject(oe), oe.currentTarget = ye[pe], ee.call(ye[pe], oe);
      });
    }
    remove() {
      return this.isDragging() && this.stopDrag(), t.DD._dragElements.delete(this._id), this._remove(), this;
    }
    _clearCaches() {
      this._clearSelfAndDescendantCache(g), this._clearSelfAndDescendantCache(d), this._clearSelfAndDescendantCache(h), this._clearSelfAndDescendantCache(I), this._clearSelfAndDescendantCache(Z), this._clearSelfAndDescendantCache(T);
    }
    _remove() {
      this._clearCaches();
      const W = this.getParent();
      W && W.children && (W.children.splice(this.index, 1), W._setChildrenIndices(), this.parent = null);
    }
    destroy() {
      return this.remove(), this.clearCache(), this;
    }
    getAttr(W) {
      const j = "get" + l.Util._capitalize(W);
      return l.Util._isFunction(this[j]) ? this[j]() : this.attrs[W];
    }
    getAncestors() {
      let W = this.getParent(), j = [];
      for (; W; )
        j.push(W), W = W.getParent();
      return j;
    }
    getAttrs() {
      return this.attrs || {};
    }
    setAttrs(W) {
      return this._batchTransformChanges(() => {
        let j, ee;
        if (!W)
          return this;
        for (j in W)
          j !== S && (ee = B + l.Util._capitalize(j), l.Util._isFunction(this[ee]) ? this[ee](W[j]) : this._setAttr(j, W[j]));
      }), this;
    }
    isListening() {
      return this._getCache(T, this._isListening);
    }
    _isListening(W) {
      if (!this.listening())
        return !1;
      const ee = this.getParent();
      return ee && ee !== W && this !== W ? ee._isListening(W) : !0;
    }
    isVisible() {
      return this._getCache(Z, this._isVisible);
    }
    _isVisible(W) {
      if (!this.visible())
        return !1;
      const ee = this.getParent();
      return ee && ee !== W && this !== W ? ee._isVisible(W) : !0;
    }
    shouldDrawHit(W, j = !1) {
      if (W)
        return this._isVisible(W) && this._isListening(W);
      const ee = this.getLayer();
      let Q = !1;
      t.DD._dragElements.forEach((ye) => {
        ye.dragStatus === "dragging" && (ye.node.nodeType === "Stage" || ye.node.getLayer() === ee) && (Q = !0);
      });
      const oe = !j && !o.Konva.hitOnDragEnabled && (Q || o.Konva.isTransforming());
      return this.isListening() && this.isVisible() && !oe;
    }
    show() {
      return this.visible(!0), this;
    }
    hide() {
      return this.visible(!1), this;
    }
    getZIndex() {
      return this.index || 0;
    }
    getAbsoluteZIndex() {
      let W = this.getDepth(), j = this, ee = 0, Q, oe, ye, pe;
      function Me(Ee) {
        for (Q = [], oe = Ee.length, ye = 0; ye < oe; ye++)
          pe = Ee[ye], ee++, pe.nodeType !== q && (Q = Q.concat(pe.getChildren().slice())), pe._id === j._id && (ye = oe);
        Q.length > 0 && Q[0].getDepth() <= W && Me(Q);
      }
      const We = this.getStage();
      return j.nodeType !== F && We && Me(We.getChildren()), ee;
    }
    getDepth() {
      let W = 0, j = this.parent;
      for (; j; )
        W++, j = j.parent;
      return W;
    }
    _batchTransformChanges(W) {
      this._batchingTransformChange = !0, W(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(U), this._clearSelfAndDescendantCache(g)), this._needClearTransformCache = !1;
    }
    setPosition(W) {
      return this._batchTransformChanges(() => {
        this.x(W.x), this.y(W.y);
      }), this;
    }
    getPosition() {
      return {
        x: this.x(),
        y: this.y()
      };
    }
    getRelativePointerPosition() {
      const W = this.getStage();
      if (!W)
        return null;
      const j = W.getPointerPosition();
      if (!j)
        return null;
      const ee = this.getAbsoluteTransform().copy();
      return ee.invert(), ee.point(j);
    }
    getAbsolutePosition(W) {
      let j = !1, ee = this.parent;
      for (; ee; ) {
        if (ee.isCached()) {
          j = !0;
          break;
        }
        ee = ee.parent;
      }
      j && !W && (W = !0);
      const Q = this.getAbsoluteTransform(W).getMatrix(), oe = new l.Transform(), ye = this.offset();
      return oe.m = Q.slice(), oe.translate(ye.x, ye.y), oe.getTranslation();
    }
    setAbsolutePosition(W) {
      const { x: j, y: ee, ...Q } = this._clearTransform();
      this.attrs.x = j, this.attrs.y = ee, this._clearCache(U);
      const oe = this._getAbsoluteTransform().copy();
      return oe.invert(), oe.translate(W.x, W.y), W = {
        x: this.attrs.x + oe.getTranslation().x,
        y: this.attrs.y + oe.getTranslation().y
      }, this._setTransform(Q), this.setPosition({ x: W.x, y: W.y }), this._clearCache(U), this._clearSelfAndDescendantCache(g), this;
    }
    _setTransform(W) {
      let j;
      for (j in W)
        this.attrs[j] = W[j];
    }
    _clearTransform() {
      const W = {
        x: this.x(),
        y: this.y(),
        rotation: this.rotation(),
        scaleX: this.scaleX(),
        scaleY: this.scaleY(),
        offsetX: this.offsetX(),
        offsetY: this.offsetY(),
        skewX: this.skewX(),
        skewY: this.skewY()
      };
      return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, W;
    }
    move(W) {
      let j = W.x, ee = W.y, Q = this.x(), oe = this.y();
      return j !== void 0 && (Q += j), ee !== void 0 && (oe += ee), this.setPosition({ x: Q, y: oe }), this;
    }
    _eachAncestorReverse(W, j) {
      let ee = [], Q = this.getParent(), oe, ye;
      if (!(j && j._id === this._id)) {
        for (ee.unshift(this); Q && (!j || Q._id !== j._id); )
          ee.unshift(Q), Q = Q.parent;
        for (oe = ee.length, ye = 0; ye < oe; ye++)
          W(ee[ye]);
      }
    }
    rotate(W) {
      return this.rotation(this.rotation() + W), this;
    }
    moveToTop() {
      if (!this.parent)
        return l.Util.warn("Node has no parent. moveToTop function is ignored."), !1;
      const W = this.index, j = this.parent.getChildren().length;
      return W < j - 1 ? (this.parent.children.splice(W, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveUp() {
      if (!this.parent)
        return l.Util.warn("Node has no parent. moveUp function is ignored."), !1;
      const W = this.index, j = this.parent.getChildren().length;
      return W < j - 1 ? (this.parent.children.splice(W, 1), this.parent.children.splice(W + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveDown() {
      if (!this.parent)
        return l.Util.warn("Node has no parent. moveDown function is ignored."), !1;
      const W = this.index;
      return W > 0 ? (this.parent.children.splice(W, 1), this.parent.children.splice(W - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
    }
    moveToBottom() {
      if (!this.parent)
        return l.Util.warn("Node has no parent. moveToBottom function is ignored."), !1;
      const W = this.index;
      return W > 0 ? (this.parent.children.splice(W, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
    }
    setZIndex(W) {
      if (!this.parent)
        return l.Util.warn("Node has no parent. zIndex parameter is ignored."), this;
      (W < 0 || W >= this.parent.children.length) && l.Util.warn("Unexpected value " + W + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
      const j = this.index;
      return this.parent.children.splice(j, 1), this.parent.children.splice(W, 0, this), this.parent._setChildrenIndices(), this;
    }
    getAbsoluteOpacity() {
      return this._getCache(d, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
      let W = this.opacity();
      const j = this.getParent();
      return j && !j._isUnderCache && (W *= j.getAbsoluteOpacity()), W;
    }
    moveTo(W) {
      return this.getParent() !== W && (this._remove(), W.add(this)), this;
    }
    toObject() {
      let W = this.getAttrs(), j, ee, Q, oe, ye;
      const pe = {
        attrs: {},
        className: this.getClassName()
      };
      for (j in W)
        ee = W[j], ye = l.Util.isObject(ee) && !l.Util._isPlainObject(ee) && !l.Util._isArray(ee), !ye && (Q = typeof this[j] == "function" && this[j], delete W[j], oe = Q ? Q.call(this) : null, W[j] = ee, oe !== ee && (pe.attrs[j] = ee));
      return l.Util._prepareToStringify(pe);
    }
    toJSON() {
      return JSON.stringify(this.toObject());
    }
    getParent() {
      return this.parent;
    }
    findAncestors(W, j, ee) {
      const Q = [];
      j && this._isMatch(W) && Q.push(this);
      let oe = this.parent;
      for (; oe; ) {
        if (oe === ee)
          return Q;
        oe._isMatch(W) && Q.push(oe), oe = oe.parent;
      }
      return Q;
    }
    isAncestorOf(W) {
      return !1;
    }
    findAncestor(W, j, ee) {
      return this.findAncestors(W, j, ee)[0];
    }
    _isMatch(W) {
      if (!W)
        return !1;
      if (typeof W == "function")
        return W(this);
      let j = W.replace(/ /g, "").split(","), ee = j.length, Q, oe;
      for (Q = 0; Q < ee; Q++)
        if (oe = j[Q], l.Util.isValidSelector(oe) || (l.Util.warn('Selector "' + oe + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), l.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), l.Util.warn("Konva is awesome, right?")), oe.charAt(0) === "#") {
          if (this.id() === oe.slice(1))
            return !0;
        } else if (oe.charAt(0) === ".") {
          if (this.hasName(oe.slice(1)))
            return !0;
        } else if (this.className === oe || this.nodeType === oe)
          return !0;
      return !1;
    }
    getLayer() {
      const W = this.getParent();
      return W ? W.getLayer() : null;
    }
    getStage() {
      return this._getCache(I, this._getStage);
    }
    _getStage() {
      const W = this.getParent();
      return W ? W.getStage() : null;
    }
    fire(W, j = {}, ee) {
      return j.target = j.target || this, ee ? this._fireAndBubble(W, j) : this._fire(W, j), this;
    }
    getAbsoluteTransform(W) {
      return W ? this._getAbsoluteTransform(W) : this._getCache(g, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(W) {
      let j;
      if (W)
        return j = new l.Transform(), this._eachAncestorReverse(function(ee) {
          const Q = ee.transformsEnabled();
          Q === "all" ? j.multiply(ee.getTransform()) : Q === "position" && j.translate(ee.x() - ee.offsetX(), ee.y() - ee.offsetY());
        }, W), j;
      {
        j = this._cache.get(g) || new l.Transform(), this.parent ? this.parent.getAbsoluteTransform().copyInto(j) : j.reset();
        const ee = this.transformsEnabled();
        if (ee === "all")
          j.multiply(this.getTransform());
        else if (ee === "position") {
          const Q = this.attrs.x || 0, oe = this.attrs.y || 0, ye = this.attrs.offsetX || 0, pe = this.attrs.offsetY || 0;
          j.translate(Q - ye, oe - pe);
        }
        return j.dirty = !1, j;
      }
    }
    getAbsoluteScale(W) {
      let j = this;
      for (; j; )
        j._isUnderCache && (W = j), j = j.getParent();
      const Q = this.getAbsoluteTransform(W).decompose();
      return {
        x: Q.scaleX,
        y: Q.scaleY
      };
    }
    getAbsoluteRotation() {
      return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
      return this._getCache(U, this._getTransform);
    }
    _getTransform() {
      var W, j;
      const ee = this._cache.get(U) || new l.Transform();
      ee.reset();
      const Q = this.x(), oe = this.y(), ye = o.Konva.getAngle(this.rotation()), pe = (W = this.attrs.scaleX) !== null && W !== void 0 ? W : 1, Me = (j = this.attrs.scaleY) !== null && j !== void 0 ? j : 1, We = this.attrs.skewX || 0, Ee = this.attrs.skewY || 0, ae = this.attrs.offsetX || 0, Re = this.attrs.offsetY || 0;
      return (Q !== 0 || oe !== 0) && ee.translate(Q, oe), ye !== 0 && ee.rotate(ye), (We !== 0 || Ee !== 0) && ee.skew(We, Ee), (pe !== 1 || Me !== 1) && ee.scale(pe, Me), (ae !== 0 || Re !== 0) && ee.translate(-1 * ae, -1 * Re), ee.dirty = !1, ee;
    }
    clone(W) {
      let j = l.Util.cloneObject(this.attrs), ee, Q, oe, ye, pe;
      for (ee in W)
        j[ee] = W[ee];
      const Me = new this.constructor(j);
      for (ee in this.eventListeners)
        for (Q = this.eventListeners[ee], oe = Q.length, ye = 0; ye < oe; ye++)
          pe = Q[ye], pe.name.indexOf(w) < 0 && (Me.eventListeners[ee] || (Me.eventListeners[ee] = []), Me.eventListeners[ee].push(pe));
      return Me;
    }
    _toKonvaCanvas(W) {
      W = W || {};
      const j = this.getClientRect(), ee = this.getStage(), Q = W.x !== void 0 ? W.x : Math.floor(j.x), oe = W.y !== void 0 ? W.y : Math.floor(j.y), ye = W.pixelRatio || 1, pe = new e.SceneCanvas({
        width: W.width || Math.ceil(j.width) || (ee ? ee.width() : 0),
        height: W.height || Math.ceil(j.height) || (ee ? ee.height() : 0),
        pixelRatio: ye
      }), Me = pe.getContext(), We = new e.SceneCanvas({
        width: pe.width / pe.pixelRatio + Math.abs(Q),
        height: pe.height / pe.pixelRatio + Math.abs(oe),
        pixelRatio: pe.pixelRatio
      });
      return W.imageSmoothingEnabled === !1 && (Me._context.imageSmoothingEnabled = !1), Me.save(), (Q || oe) && Me.translate(-1 * Q, -1 * oe), this.drawScene(pe, void 0, We), Me.restore(), pe;
    }
    toCanvas(W) {
      return this._toKonvaCanvas(W)._canvas;
    }
    toDataURL(W) {
      W = W || {};
      const j = W.mimeType || null, ee = W.quality || null, Q = this._toKonvaCanvas(W).toDataURL(j, ee);
      return W.callback && W.callback(Q), Q;
    }
    toImage(W) {
      return new Promise((j, ee) => {
        try {
          const Q = W == null ? void 0 : W.callback;
          Q && delete W.callback, l.Util._urlToImage(this.toDataURL(W), function(oe) {
            j(oe), Q == null || Q(oe);
          });
        } catch (Q) {
          ee(Q);
        }
      });
    }
    toBlob(W) {
      return new Promise((j, ee) => {
        try {
          const Q = W == null ? void 0 : W.callback;
          Q && delete W.callback, this.toCanvas(W).toBlob((oe) => {
            j(oe), Q == null || Q(oe);
          }, W == null ? void 0 : W.mimeType, W == null ? void 0 : W.quality);
        } catch (Q) {
          ee(Q);
        }
      });
    }
    setSize(W) {
      return this.width(W.width), this.height(W.height), this;
    }
    getSize() {
      return {
        width: this.width(),
        height: this.height()
      };
    }
    getClassName() {
      return this.className || this.nodeType;
    }
    getType() {
      return this.nodeType;
    }
    getDragDistance() {
      return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : o.Konva.dragDistance;
    }
    _off(W, j, ee) {
      let Q = this.eventListeners[W], oe, ye, pe;
      for (oe = 0; oe < Q.length; oe++)
        if (ye = Q[oe].name, pe = Q[oe].handler, (ye !== "konva" || j === "konva") && (!j || ye === j) && (!ee || ee === pe)) {
          if (Q.splice(oe, 1), Q.length === 0) {
            delete this.eventListeners[W];
            break;
          }
          oe--;
        }
    }
    _fireChangeEvent(W, j, ee) {
      this._fire(W + E, {
        oldVal: j,
        newVal: ee
      });
    }
    addName(W) {
      if (!this.hasName(W)) {
        const j = this.name(), ee = j ? j + " " + W : W;
        this.name(ee);
      }
      return this;
    }
    hasName(W) {
      if (!W)
        return !1;
      const j = this.name();
      return j ? (j || "").split(/\s/g).indexOf(W) !== -1 : !1;
    }
    removeName(W) {
      const j = (this.name() || "").split(/\s/g), ee = j.indexOf(W);
      return ee !== -1 && (j.splice(ee, 1), this.name(j.join(" "))), this;
    }
    setAttr(W, j) {
      const ee = this[B + l.Util._capitalize(W)];
      return l.Util._isFunction(ee) ? ee.call(this, j) : this._setAttr(W, j), this;
    }
    _requestDraw() {
      if (o.Konva.autoDrawEnabled) {
        const W = this.getLayer() || this.getStage();
        W == null || W.batchDraw();
      }
    }
    _setAttr(W, j) {
      const ee = this.attrs[W];
      ee === j && !l.Util.isObject(j) || (j == null ? delete this.attrs[W] : this.attrs[W] = j, this._shouldFireChangeEvents && this._fireChangeEvent(W, ee, j), this._requestDraw());
    }
    _setComponentAttr(W, j, ee) {
      let Q;
      ee !== void 0 && (Q = this.attrs[W], Q || (this.attrs[W] = this.getAttr(W)), this.attrs[W][j] = ee, this._fireChangeEvent(W, Q, ee));
    }
    _fireAndBubble(W, j, ee) {
      j && this.nodeType === q && (j.target = this);
      const Q = [
        P,
        z,
        L,
        x,
        k,
        R
      ];
      if (!(Q.indexOf(W) !== -1 && (ee && (this === ee || this.isAncestorOf && this.isAncestorOf(ee)) || this.nodeType === "Stage" && !ee))) {
        this._fire(W, j);
        const ye = Q.indexOf(W) !== -1 && ee && ee.isAncestorOf && ee.isAncestorOf(this) && !ee.isAncestorOf(this.parent);
        (j && !j.cancelBubble || !j) && this.parent && this.parent.isListening() && !ye && (ee && ee.parent ? this._fireAndBubble.call(this.parent, W, j, ee) : this._fireAndBubble.call(this.parent, W, j));
      }
    }
    _getProtoListeners(W) {
      var j, ee, Q;
      const oe = (j = this._cache.get(f)) !== null && j !== void 0 ? j : {};
      let ye = oe == null ? void 0 : oe[W];
      if (ye === void 0) {
        ye = [];
        let pe = Object.getPrototypeOf(this);
        for (; pe; ) {
          const Me = (Q = (ee = pe.eventListeners) === null || ee === void 0 ? void 0 : ee[W]) !== null && Q !== void 0 ? Q : [];
          ye.push(...Me), pe = Object.getPrototypeOf(pe);
        }
        oe[W] = ye, this._cache.set(f, oe);
      }
      return ye;
    }
    _fire(W, j) {
      j = j || {}, j.currentTarget = this, j.type = W;
      const ee = this._getProtoListeners(W);
      if (ee)
        for (let oe = 0; oe < ee.length; oe++)
          ee[oe].handler.call(this, j);
      const Q = this.eventListeners[W];
      if (Q)
        for (let oe = 0; oe < Q.length; oe++)
          Q[oe].handler.call(this, j);
    }
    draw() {
      return this.drawScene(), this.drawHit(), this;
    }
    _createDragElement(W) {
      const j = W ? W.pointerId : void 0, ee = this.getStage(), Q = this.getAbsolutePosition();
      if (!ee)
        return;
      const oe = ee._getPointerById(j) || ee._changedPointerPositions[0] || Q;
      t.DD._dragElements.set(this._id, {
        node: this,
        startPointerPos: oe,
        offset: {
          x: oe.x - Q.x,
          y: oe.y - Q.y
        },
        dragStatus: "ready",
        pointerId: j
      });
    }
    startDrag(W, j = !0) {
      t.DD._dragElements.has(this._id) || this._createDragElement(W);
      const ee = t.DD._dragElements.get(this._id);
      ee.dragStatus = "dragging", this.fire("dragstart", {
        type: "dragstart",
        target: this,
        evt: W && W.evt
      }, j);
    }
    _setDragPosition(W, j) {
      const ee = this.getStage()._getPointerById(j.pointerId);
      if (!ee)
        return;
      let Q = {
        x: ee.x - j.offset.x,
        y: ee.y - j.offset.y
      };
      const oe = this.dragBoundFunc();
      if (oe !== void 0) {
        const ye = oe.call(this, Q, W);
        ye ? Q = ye : l.Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== Q.x || this._lastPos.y !== Q.y) && (this.setAbsolutePosition(Q), this._requestDraw()), this._lastPos = Q;
    }
    stopDrag(W) {
      const j = t.DD._dragElements.get(this._id);
      j && (j.dragStatus = "stopped"), t.DD._endDragBefore(W), t.DD._endDragAfter(W);
    }
    setDraggable(W) {
      this._setAttr("draggable", W), this._dragChange();
    }
    isDragging() {
      const W = t.DD._dragElements.get(this._id);
      return W ? W.dragStatus === "dragging" : !1;
    }
    _listenDrag() {
      this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(W) {
        if (!(!(W.evt.button !== void 0) || o.Konva.dragButtons.indexOf(W.evt.button) >= 0) || this.isDragging())
          return;
        let Q = !1;
        t.DD._dragElements.forEach((oe) => {
          this.isAncestorOf(oe.node) && (Q = !0);
        }), Q || this._createDragElement(W);
      });
    }
    _dragChange() {
      if (this.attrs.draggable)
        this._listenDrag();
      else {
        if (this._dragCleanup(), !this.getStage())
          return;
        const j = t.DD._dragElements.get(this._id), ee = j && j.dragStatus === "dragging", Q = j && j.dragStatus === "ready";
        ee ? this.stopDrag() : Q && t.DD._dragElements.delete(this._id);
      }
    }
    _dragCleanup() {
      this.off("mousedown.konva"), this.off("touchstart.konva");
    }
    isClientRectOnScreen(W = { x: 0, y: 0 }) {
      const j = this.getStage();
      if (!j)
        return !1;
      const ee = {
        x: -W.x,
        y: -W.y,
        width: j.width() + 2 * W.x,
        height: j.height() + 2 * W.y
      };
      return l.Util.haveIntersection(ee, this.getClientRect());
    }
    static create(W, j) {
      return l.Util._isString(W) && (W = JSON.parse(W)), this._createNode(W, j);
    }
    static _createNode(W, j) {
      let ee = W2.prototype.getClassName.call(W), Q = W.children, oe, ye, pe;
      j && (W.attrs.container = j), o.Konva[ee] || (l.Util.warn('Can not find a node with class name "' + ee + '". Fallback to "Shape".'), ee = "Shape");
      const Me = o.Konva[ee];
      if (oe = new Me(W.attrs), Q)
        for (ye = Q.length, pe = 0; pe < ye; pe++)
          oe.add(W2._createNode(Q[pe]));
      return oe;
    }
  };
  $h.Node = ue, ue.prototype.nodeType = "Node", ue.prototype._attrsAffectingSize = [], ue.prototype.eventListeners = {}, ue.prototype.on.call(ue.prototype, te, function() {
    if (this._batchingTransformChange) {
      this._needClearTransformCache = !0;
      return;
    }
    this._clearCache(U), this._clearSelfAndDescendantCache(g);
  }), ue.prototype.on.call(ue.prototype, "visibleChange.konva", function() {
    this._clearSelfAndDescendantCache(Z);
  }), ue.prototype.on.call(ue.prototype, "listeningChange.konva", function() {
    this._clearSelfAndDescendantCache(T);
  }), ue.prototype.on.call(ue.prototype, "opacityChange.konva", function() {
    this._clearSelfAndDescendantCache(d);
  });
  const ce = r.Factory.addGetterSetter;
  return ce(ue, "zIndex"), ce(ue, "absolutePosition"), ce(ue, "position"), ce(ue, "x", 0, (0, u.getNumberValidator)()), ce(ue, "y", 0, (0, u.getNumberValidator)()), ce(ue, "globalCompositeOperation", "source-over", (0, u.getStringValidator)()), ce(ue, "opacity", 1, (0, u.getNumberValidator)()), ce(ue, "name", "", (0, u.getStringValidator)()), ce(ue, "id", "", (0, u.getStringValidator)()), ce(ue, "rotation", 0, (0, u.getNumberValidator)()), r.Factory.addComponentsGetterSetter(ue, "scale", ["x", "y"]), ce(ue, "scaleX", 1, (0, u.getNumberValidator)()), ce(ue, "scaleY", 1, (0, u.getNumberValidator)()), r.Factory.addComponentsGetterSetter(ue, "skew", ["x", "y"]), ce(ue, "skewX", 0, (0, u.getNumberValidator)()), ce(ue, "skewY", 0, (0, u.getNumberValidator)()), r.Factory.addComponentsGetterSetter(ue, "offset", ["x", "y"]), ce(ue, "offsetX", 0, (0, u.getNumberValidator)()), ce(ue, "offsetY", 0, (0, u.getNumberValidator)()), ce(ue, "dragDistance", void 0, (0, u.getNumberValidator)()), ce(ue, "width", 0, (0, u.getNumberValidator)()), ce(ue, "height", 0, (0, u.getNumberValidator)()), ce(ue, "listening", !0, (0, u.getBooleanValidator)()), ce(ue, "preventDefault", !0, (0, u.getBooleanValidator)()), ce(ue, "filters", void 0, function(ze) {
    return this._filterUpToDate = !1, ze;
  }), ce(ue, "visible", !0, (0, u.getBooleanValidator)()), ce(ue, "transformsEnabled", "all", (0, u.getStringValidator)()), ce(ue, "size"), ce(ue, "dragBoundFunc"), ce(ue, "draggable", !1, (0, u.getBooleanValidator)()), r.Factory.backCompat(ue, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
  }), $h;
}
var ep = {}, B3;
function J0() {
  if (B3) return ep;
  B3 = 1, Object.defineProperty(ep, "__esModule", { value: !0 }), ep.Container = void 0;
  const e = On(), t = ra(), r = Vn();
  let o = class extends t.Node {
    constructor() {
      super(...arguments), this.children = [];
    }
    getChildren(u) {
      const d = this.children || [];
      return u ? d.filter(u) : d;
    }
    hasChildren() {
      return this.getChildren().length > 0;
    }
    removeChildren() {
      return this.getChildren().forEach((u) => {
        u.parent = null, u.index = 0, u.remove();
      }), this.children = [], this._requestDraw(), this;
    }
    destroyChildren() {
      return this.getChildren().forEach((u) => {
        u.parent = null, u.index = 0, u.destroy();
      }), this.children = [], this._requestDraw(), this;
    }
    add(...u) {
      if (u.length === 0)
        return this;
      if (u.length > 1) {
        for (let f = 0; f < u.length; f++)
          this.add(u[f]);
        return this;
      }
      const d = u[0];
      return d.getParent() ? (d.moveTo(this), this) : (this._validateAdd(d), d.index = this.getChildren().length, d.parent = this, d._clearCaches(), this.getChildren().push(d), this._fire("add", {
        child: d
      }), this._requestDraw(), this);
    }
    destroy() {
      return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
    }
    find(u) {
      return this._generalFind(u, !1);
    }
    findOne(u) {
      const d = this._generalFind(u, !0);
      return d.length > 0 ? d[0] : void 0;
    }
    _generalFind(u, d) {
      const f = [];
      return this._descendants((g) => {
        const h = g._isMatch(u);
        return h && f.push(g), !!(h && d);
      }), f;
    }
    _descendants(u) {
      let d = !1;
      const f = this.getChildren();
      for (const g of f) {
        if (d = u(g), d)
          return !0;
        if (g.hasChildren() && (d = g._descendants(u), d))
          return !0;
      }
      return !1;
    }
    toObject() {
      const u = t.Node.prototype.toObject.call(this);
      return u.children = [], this.getChildren().forEach((d) => {
        u.children.push(d.toObject());
      }), u;
    }
    isAncestorOf(u) {
      let d = u.getParent();
      for (; d; ) {
        if (d._id === this._id)
          return !0;
        d = d.getParent();
      }
      return !1;
    }
    clone(u) {
      const d = t.Node.prototype.clone.call(this, u);
      return this.getChildren().forEach(function(f) {
        d.add(f.clone());
      }), d;
    }
    getAllIntersections(u) {
      const d = [];
      return this.find("Shape").forEach((f) => {
        f.isVisible() && f.intersects(u) && d.push(f);
      }), d;
    }
    _clearSelfAndDescendantCache(u) {
      var d;
      super._clearSelfAndDescendantCache(u), !this.isCached() && ((d = this.children) === null || d === void 0 || d.forEach(function(f) {
        f._clearSelfAndDescendantCache(u);
      }));
    }
    _setChildrenIndices() {
      var u;
      (u = this.children) === null || u === void 0 || u.forEach(function(d, f) {
        d.index = f;
      }), this._requestDraw();
    }
    drawScene(u, d, f) {
      const g = this.getLayer(), h = u || g && g.getCanvas(), v = h && h.getContext(), E = this._getCanvasCache(), S = E && E.scene, w = h && h.isCache;
      if (!this.isVisible() && !w)
        return this;
      if (S) {
        v.save();
        const T = this.getAbsoluteTransform(d).getMatrix();
        v.transform(T[0], T[1], T[2], T[3], T[4], T[5]), this._drawCachedSceneCanvas(v), v.restore();
      } else
        this._drawChildren("drawScene", h, d, f);
      return this;
    }
    drawHit(u, d) {
      if (!this.shouldDrawHit(d))
        return this;
      const f = this.getLayer(), g = u || f && f.hitCanvas, h = g && g.getContext(), v = this._getCanvasCache();
      if (v && v.hit) {
        h.save();
        const S = this.getAbsoluteTransform(d).getMatrix();
        h.transform(S[0], S[1], S[2], S[3], S[4], S[5]), this._drawCachedHitCanvas(h), h.restore();
      } else
        this._drawChildren("drawHit", g, d);
      return this;
    }
    _drawChildren(u, d, f, g) {
      var h;
      const v = d && d.getContext(), E = this.clipWidth(), S = this.clipHeight(), w = this.clipFunc(), T = typeof E == "number" && typeof S == "number" || w, P = f === this;
      if (T) {
        v.save();
        const L = this.getAbsoluteTransform(f);
        let x = L.getMatrix();
        v.transform(x[0], x[1], x[2], x[3], x[4], x[5]), v.beginPath();
        let k;
        if (w)
          k = w.call(this, v, this);
        else {
          const R = this.clipX(), B = this.clipY();
          v.rect(R || 0, B || 0, E, S);
        }
        v.clip.apply(v, k), x = L.copy().invert().getMatrix(), v.transform(x[0], x[1], x[2], x[3], x[4], x[5]);
      }
      const z = !P && this.globalCompositeOperation() !== "source-over" && u === "drawScene";
      z && (v.save(), v._applyGlobalCompositeOperation(this)), (h = this.children) === null || h === void 0 || h.forEach(function(L) {
        L[u](d, f, g);
      }), z && v.restore(), T && v.restore();
    }
    getClientRect(u = {}) {
      var d;
      const f = u.skipTransform, g = u.relativeTo;
      let h, v, E, S, w = {
        x: 1 / 0,
        y: 1 / 0,
        width: 0,
        height: 0
      };
      const T = this;
      (d = this.children) === null || d === void 0 || d.forEach(function(L) {
        if (!L.visible())
          return;
        const x = L.getClientRect({
          relativeTo: T,
          skipShadow: u.skipShadow,
          skipStroke: u.skipStroke
        });
        x.width === 0 && x.height === 0 || (h === void 0 ? (h = x.x, v = x.y, E = x.x + x.width, S = x.y + x.height) : (h = Math.min(h, x.x), v = Math.min(v, x.y), E = Math.max(E, x.x + x.width), S = Math.max(S, x.y + x.height)));
      });
      const P = this.find("Shape");
      let z = !1;
      for (let L = 0; L < P.length; L++)
        if (P[L]._isVisible(this)) {
          z = !0;
          break;
        }
      return z && h !== void 0 ? w = {
        x: h,
        y: v,
        width: E - h,
        height: S - v
      } : w = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, f ? w : this._transformedRect(w, g);
    }
  };
  return ep.Container = o, e.Factory.addComponentsGetterSetter(o, "clip", [
    "x",
    "y",
    "width",
    "height"
  ]), e.Factory.addGetterSetter(o, "clipX", void 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(o, "clipY", void 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(o, "clipWidth", void 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(o, "clipHeight", void 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(o, "clipFunc"), ep;
}
var Oy = {}, zu = {}, U3;
function O6() {
  if (U3) return zu;
  U3 = 1, Object.defineProperty(zu, "__esModule", { value: !0 }), zu.getCapturedShape = o, zu.createEvent = l, zu.hasPointerCapture = u, zu.setPointerCapture = d, zu.releaseCapture = f;
  const e = Rn(), t = /* @__PURE__ */ new Map(), r = e.Konva._global.PointerEvent !== void 0;
  function o(g) {
    return t.get(g);
  }
  function l(g) {
    return {
      evt: g,
      pointerId: g.pointerId
    };
  }
  function u(g, h) {
    return t.get(g) === h;
  }
  function d(g, h) {
    f(g), h.getStage() && (t.set(g, h), r && h._fire("gotpointercapture", l(new PointerEvent("gotpointercapture"))));
  }
  function f(g, h) {
    const v = t.get(g);
    if (!v)
      return;
    const E = v.getStage();
    E && E.content, t.delete(g), r && v._fire("lostpointercapture", l(new PointerEvent("lostpointercapture")));
  }
  return zu;
}
var I3;
function iA() {
  return I3 || (I3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Stage = e.stages = void 0;
    const t = jr(), r = On(), o = J0(), l = Rn(), u = Q0(), d = bb(), f = Rn(), g = O6(), h = "Stage", v = "string", E = "px", S = "mouseout", w = "mouseleave", T = "mouseover", P = "mouseenter", z = "mousemove", L = "mousedown", x = "mouseup", k = "pointermove", R = "pointerdown", B = "pointerup", q = "pointercancel", X = "lostpointercapture", I = "pointerout", U = "pointerleave", F = "pointerover", Z = "pointerenter", te = "contextmenu", ie = "touchstart", ue = "touchend", ce = "touchmove", ze = "touchcancel", W = "wheel", j = 5, ee = [
      [P, "_pointerenter"],
      [L, "_pointerdown"],
      [z, "_pointermove"],
      [x, "_pointerup"],
      [w, "_pointerleave"],
      [ie, "_pointerdown"],
      [ce, "_pointermove"],
      [ue, "_pointerup"],
      [ze, "_pointercancel"],
      [T, "_pointerover"],
      [W, "_wheel"],
      [te, "_contextmenu"],
      [R, "_pointerdown"],
      [k, "_pointermove"],
      [B, "_pointerup"],
      [q, "_pointercancel"],
      [U, "_pointerleave"],
      [X, "_lostpointercapture"]
    ], Q = {
      mouse: {
        [I]: S,
        [U]: w,
        [F]: T,
        [Z]: P,
        [k]: z,
        [R]: L,
        [B]: x,
        [q]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
      },
      touch: {
        [I]: "touchout",
        [U]: "touchleave",
        [F]: "touchover",
        [Z]: "touchenter",
        [k]: ce,
        [R]: ie,
        [B]: ue,
        [q]: ze,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
      },
      pointer: {
        [I]: I,
        [U]: U,
        [F]: F,
        [Z]: Z,
        [k]: k,
        [R]: R,
        [B]: B,
        [q]: q,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
      }
    }, oe = (Ee) => Ee.indexOf("pointer") >= 0 ? "pointer" : Ee.indexOf("touch") >= 0 ? "touch" : "mouse", ye = (Ee) => {
      const ae = oe(Ee);
      if (ae === "pointer")
        return l.Konva.pointerEventsEnabled && Q.pointer;
      if (ae === "touch")
        return Q.touch;
      if (ae === "mouse")
        return Q.mouse;
    };
    function pe(Ee = {}) {
      return (Ee.clipFunc || Ee.clipWidth || Ee.clipHeight) && t.Util.warn("Stage does not support clipping. Please use clip for Layers or Groups."), Ee;
    }
    const Me = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
    e.stages = [];
    class We extends o.Container {
      constructor(ae) {
        super(pe(ae)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), e.stages.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
          pe(this.attrs);
        }), this._checkVisibility();
      }
      _validateAdd(ae) {
        const Re = ae.getType() === "Layer", Qe = ae.getType() === "FastLayer";
        Re || Qe || t.Util.throw("You may only add layers to the stage.");
      }
      _checkVisibility() {
        if (!this.content)
          return;
        const ae = this.visible() ? "" : "none";
        this.content.style.display = ae;
      }
      setContainer(ae) {
        if (typeof ae === v) {
          let Re;
          if (ae.charAt(0) === ".") {
            const Qe = ae.slice(1);
            ae = document.getElementsByClassName(Qe)[0];
          } else
            ae.charAt(0) !== "#" ? Re = ae : Re = ae.slice(1), ae = document.getElementById(Re);
          if (!ae)
            throw "Can not find container in document with id " + Re;
        }
        return this._setAttr("container", ae), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), ae.appendChild(this.content)), this;
      }
      shouldDrawHit() {
        return !0;
      }
      clear() {
        const ae = this.children, Re = ae.length;
        for (let Qe = 0; Qe < Re; Qe++)
          ae[Qe].clear();
        return this;
      }
      clone(ae) {
        return ae || (ae = {}), ae.container = typeof document < "u" && document.createElement("div"), o.Container.prototype.clone.call(this, ae);
      }
      destroy() {
        super.destroy();
        const ae = this.content;
        ae && t.Util._isInDocument(ae) && this.container().removeChild(ae);
        const Re = e.stages.indexOf(this);
        return Re > -1 && e.stages.splice(Re, 1), t.Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
      }
      getPointerPosition() {
        const ae = this._pointerPositions[0] || this._changedPointerPositions[0];
        return ae ? {
          x: ae.x,
          y: ae.y
        } : (t.Util.warn(Me), null);
      }
      _getPointerById(ae) {
        return this._pointerPositions.find((Re) => Re.id === ae);
      }
      getPointersPositions() {
        return this._pointerPositions;
      }
      getStage() {
        return this;
      }
      getContent() {
        return this.content;
      }
      _toKonvaCanvas(ae) {
        ae = ae || {}, ae.x = ae.x || 0, ae.y = ae.y || 0, ae.width = ae.width || this.width(), ae.height = ae.height || this.height();
        const Re = new u.SceneCanvas({
          width: ae.width,
          height: ae.height,
          pixelRatio: ae.pixelRatio || 1
        }), Qe = Re.getContext()._context, Pe = this.children;
        return (ae.x || ae.y) && Qe.translate(-1 * ae.x, -1 * ae.y), Pe.forEach(function(rt) {
          if (!rt.isVisible())
            return;
          const st = rt._toKonvaCanvas(ae);
          Qe.drawImage(st._canvas, ae.x, ae.y, st.getWidth() / st.getPixelRatio(), st.getHeight() / st.getPixelRatio());
        }), Re;
      }
      getIntersection(ae) {
        if (!ae)
          return null;
        const Re = this.children, Qe = Re.length, Pe = Qe - 1;
        for (let rt = Pe; rt >= 0; rt--) {
          const st = Re[rt].getIntersection(ae);
          if (st)
            return st;
        }
        return null;
      }
      _resizeDOM() {
        const ae = this.width(), Re = this.height();
        this.content && (this.content.style.width = ae + E, this.content.style.height = Re + E), this.bufferCanvas.setSize(ae, Re), this.bufferHitCanvas.setSize(ae, Re), this.children.forEach((Qe) => {
          Qe.setSize({ width: ae, height: Re }), Qe.draw();
        });
      }
      add(ae, ...Re) {
        if (arguments.length > 1) {
          for (let Pe = 0; Pe < arguments.length; Pe++)
            this.add(arguments[Pe]);
          return this;
        }
        super.add(ae);
        const Qe = this.children.length;
        return Qe > j && t.Util.warn("The stage has " + Qe + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), ae.setSize({ width: this.width(), height: this.height() }), ae.draw(), l.Konva.isBrowser && this.content.appendChild(ae.canvas._canvas), this;
      }
      getParent() {
        return null;
      }
      getLayer() {
        return null;
      }
      hasPointerCapture(ae) {
        return g.hasPointerCapture(ae, this);
      }
      setPointerCapture(ae) {
        g.setPointerCapture(ae, this);
      }
      releaseCapture(ae) {
        g.releaseCapture(ae, this);
      }
      getLayers() {
        return this.children;
      }
      _bindContentEvents() {
        l.Konva.isBrowser && ee.forEach(([ae, Re]) => {
          this.content.addEventListener(ae, (Qe) => {
            this[Re](Qe);
          }, { passive: !1 });
        });
      }
      _pointerenter(ae) {
        this.setPointersPositions(ae);
        const Re = ye(ae.type);
        Re && this._fire(Re.pointerenter, {
          evt: ae,
          target: this,
          currentTarget: this
        });
      }
      _pointerover(ae) {
        this.setPointersPositions(ae);
        const Re = ye(ae.type);
        Re && this._fire(Re.pointerover, {
          evt: ae,
          target: this,
          currentTarget: this
        });
      }
      _getTargetShape(ae) {
        let Re = this[ae + "targetShape"];
        return Re && !Re.getStage() && (Re = null), Re;
      }
      _pointerleave(ae) {
        const Re = ye(ae.type), Qe = oe(ae.type);
        if (!Re)
          return;
        this.setPointersPositions(ae);
        const Pe = this._getTargetShape(Qe), rt = !(l.Konva.isDragging() || l.Konva.isTransforming()) || l.Konva.hitOnDragEnabled;
        Pe && rt ? (Pe._fireAndBubble(Re.pointerout, { evt: ae }), Pe._fireAndBubble(Re.pointerleave, { evt: ae }), this._fire(Re.pointerleave, {
          evt: ae,
          target: this,
          currentTarget: this
        }), this[Qe + "targetShape"] = null) : rt && (this._fire(Re.pointerleave, {
          evt: ae,
          target: this,
          currentTarget: this
        }), this._fire(Re.pointerout, {
          evt: ae,
          target: this,
          currentTarget: this
        })), this.pointerPos = null, this._pointerPositions = [];
      }
      _pointerdown(ae) {
        const Re = ye(ae.type), Qe = oe(ae.type);
        if (!Re)
          return;
        this.setPointersPositions(ae);
        let Pe = !1;
        this._changedPointerPositions.forEach((rt) => {
          const st = this.getIntersection(rt);
          if (d.DD.justDragged = !1, l.Konva["_" + Qe + "ListenClick"] = !0, !st || !st.isListening()) {
            this[Qe + "ClickStartShape"] = void 0;
            return;
          }
          l.Konva.capturePointerEventsEnabled && st.setPointerCapture(rt.id), this[Qe + "ClickStartShape"] = st, st._fireAndBubble(Re.pointerdown, {
            evt: ae,
            pointerId: rt.id
          }), Pe = !0;
          const bt = ae.type.indexOf("touch") >= 0;
          st.preventDefault() && ae.cancelable && bt && ae.preventDefault();
        }), Pe || this._fire(Re.pointerdown, {
          evt: ae,
          target: this,
          currentTarget: this,
          pointerId: this._pointerPositions[0].id
        });
      }
      _pointermove(ae) {
        const Re = ye(ae.type), Qe = oe(ae.type);
        if (!Re || (l.Konva.isDragging() && d.DD.node.preventDefault() && ae.cancelable && ae.preventDefault(), this.setPointersPositions(ae), !(!(l.Konva.isDragging() || l.Konva.isTransforming()) || l.Konva.hitOnDragEnabled)))
          return;
        const rt = {};
        let st = !1;
        const bt = this._getTargetShape(Qe);
        this._changedPointerPositions.forEach((Xt) => {
          const Lt = g.getCapturedShape(Xt.id) || this.getIntersection(Xt), qn = Xt.id, Wt = { evt: ae, pointerId: qn }, bn = bt !== Lt;
          if (bn && bt && (bt._fireAndBubble(Re.pointerout, { ...Wt }, Lt), bt._fireAndBubble(Re.pointerleave, { ...Wt }, Lt)), Lt) {
            if (rt[Lt._id])
              return;
            rt[Lt._id] = !0;
          }
          Lt && Lt.isListening() ? (st = !0, bn && (Lt._fireAndBubble(Re.pointerover, { ...Wt }, bt), Lt._fireAndBubble(Re.pointerenter, { ...Wt }, bt), this[Qe + "targetShape"] = Lt), Lt._fireAndBubble(Re.pointermove, { ...Wt })) : bt && (this._fire(Re.pointerover, {
            evt: ae,
            target: this,
            currentTarget: this,
            pointerId: qn
          }), this[Qe + "targetShape"] = null);
        }), st || this._fire(Re.pointermove, {
          evt: ae,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        });
      }
      _pointerup(ae) {
        const Re = ye(ae.type), Qe = oe(ae.type);
        if (!Re)
          return;
        this.setPointersPositions(ae);
        const Pe = this[Qe + "ClickStartShape"], rt = this[Qe + "ClickEndShape"], st = {};
        let bt = !1;
        this._changedPointerPositions.forEach((Xt) => {
          const Lt = g.getCapturedShape(Xt.id) || this.getIntersection(Xt);
          if (Lt) {
            if (Lt.releaseCapture(Xt.id), st[Lt._id])
              return;
            st[Lt._id] = !0;
          }
          const qn = Xt.id, Wt = { evt: ae, pointerId: qn };
          let bn = !1;
          l.Konva["_" + Qe + "InDblClickWindow"] ? (bn = !0, clearTimeout(this[Qe + "DblTimeout"])) : d.DD.justDragged || (l.Konva["_" + Qe + "InDblClickWindow"] = !0, clearTimeout(this[Qe + "DblTimeout"])), this[Qe + "DblTimeout"] = setTimeout(function() {
            l.Konva["_" + Qe + "InDblClickWindow"] = !1;
          }, l.Konva.dblClickWindow), Lt && Lt.isListening() ? (bt = !0, this[Qe + "ClickEndShape"] = Lt, Lt._fireAndBubble(Re.pointerup, { ...Wt }), l.Konva["_" + Qe + "ListenClick"] && Pe && Pe === Lt && (Lt._fireAndBubble(Re.pointerclick, { ...Wt }), bn && rt && rt === Lt && Lt._fireAndBubble(Re.pointerdblclick, { ...Wt }))) : (this[Qe + "ClickEndShape"] = null, l.Konva["_" + Qe + "ListenClick"] && this._fire(Re.pointerclick, {
            evt: ae,
            target: this,
            currentTarget: this,
            pointerId: qn
          }), bn && this._fire(Re.pointerdblclick, {
            evt: ae,
            target: this,
            currentTarget: this,
            pointerId: qn
          }));
        }), bt || this._fire(Re.pointerup, {
          evt: ae,
          target: this,
          currentTarget: this,
          pointerId: this._changedPointerPositions[0].id
        }), l.Konva["_" + Qe + "ListenClick"] = !1, ae.cancelable && Qe !== "touch" && Qe !== "pointer" && ae.preventDefault();
      }
      _contextmenu(ae) {
        this.setPointersPositions(ae);
        const Re = this.getIntersection(this.getPointerPosition());
        Re && Re.isListening() ? Re._fireAndBubble(te, { evt: ae }) : this._fire(te, {
          evt: ae,
          target: this,
          currentTarget: this
        });
      }
      _wheel(ae) {
        this.setPointersPositions(ae);
        const Re = this.getIntersection(this.getPointerPosition());
        Re && Re.isListening() ? Re._fireAndBubble(W, { evt: ae }) : this._fire(W, {
          evt: ae,
          target: this,
          currentTarget: this
        });
      }
      _pointercancel(ae) {
        this.setPointersPositions(ae);
        const Re = g.getCapturedShape(ae.pointerId) || this.getIntersection(this.getPointerPosition());
        Re && Re._fireAndBubble(B, g.createEvent(ae)), g.releaseCapture(ae.pointerId);
      }
      _lostpointercapture(ae) {
        g.releaseCapture(ae.pointerId);
      }
      setPointersPositions(ae) {
        const Re = this._getContentPosition();
        let Qe = null, Pe = null;
        ae = ae || window.event, ae.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(ae.touches, (rt) => {
          this._pointerPositions.push({
            id: rt.identifier,
            x: (rt.clientX - Re.left) / Re.scaleX,
            y: (rt.clientY - Re.top) / Re.scaleY
          });
        }), Array.prototype.forEach.call(ae.changedTouches || ae.touches, (rt) => {
          this._changedPointerPositions.push({
            id: rt.identifier,
            x: (rt.clientX - Re.left) / Re.scaleX,
            y: (rt.clientY - Re.top) / Re.scaleY
          });
        })) : (Qe = (ae.clientX - Re.left) / Re.scaleX, Pe = (ae.clientY - Re.top) / Re.scaleY, this.pointerPos = {
          x: Qe,
          y: Pe
        }, this._pointerPositions = [{ x: Qe, y: Pe, id: t.Util._getFirstPointerId(ae) }], this._changedPointerPositions = [
          { x: Qe, y: Pe, id: t.Util._getFirstPointerId(ae) }
        ]);
      }
      _setPointerPosition(ae) {
        t.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(ae);
      }
      _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect)
          return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
          };
        const ae = this.content.getBoundingClientRect();
        return {
          top: ae.top,
          left: ae.left,
          scaleX: ae.width / this.content.clientWidth || 1,
          scaleY: ae.height / this.content.clientHeight || 1
        };
      }
      _buildDOM() {
        if (this.bufferCanvas = new u.SceneCanvas({
          width: this.width(),
          height: this.height()
        }), this.bufferHitCanvas = new u.HitCanvas({
          pixelRatio: 1,
          width: this.width(),
          height: this.height()
        }), !l.Konva.isBrowser)
          return;
        const ae = this.container();
        if (!ae)
          throw "Stage has no container. A container is required.";
        ae.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), ae.appendChild(this.content), this._resizeDOM();
      }
      cache() {
        return t.Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
      }
      clearCache() {
        return this;
      }
      batchDraw() {
        return this.getChildren().forEach(function(ae) {
          ae.batchDraw();
        }), this;
      }
    }
    e.Stage = We, We.prototype.nodeType = h, (0, f._registerNode)(We), r.Factory.addGetterSetter(We, "container"), l.Konva.isBrowser && document.addEventListener("visibilitychange", () => {
      e.stages.forEach((Ee) => {
        Ee.batchDraw();
      });
    });
  })(Oy)), Oy;
}
var tp = {}, Fy = {}, H3;
function ja() {
  return H3 || (H3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Shape = e.shapes = void 0;
    const t = Rn(), r = jr(), o = On(), l = ra(), u = Vn(), d = Rn(), f = O6(), g = "hasShadow", h = "shadowRGBA", v = "patternImage", E = "linearGradient", S = "radialGradient";
    let w;
    function T() {
      return w || (w = r.Util.createCanvasElement().getContext("2d"), w);
    }
    e.shapes = {};
    function P(U) {
      const F = this.attrs.fillRule;
      F ? U.fill(F) : U.fill();
    }
    function z(U) {
      U.stroke();
    }
    function L(U) {
      const F = this.attrs.fillRule;
      F ? U.fill(F) : U.fill();
    }
    function x(U) {
      U.stroke();
    }
    function k() {
      this._clearCache(g);
    }
    function R() {
      this._clearCache(h);
    }
    function B() {
      this._clearCache(v);
    }
    function q() {
      this._clearCache(E);
    }
    function X() {
      this._clearCache(S);
    }
    class I extends l.Node {
      constructor(F) {
        super(F);
        let Z;
        for (; Z = r.Util.getRandomColor(), !(Z && !(Z in e.shapes)); )
          ;
        this.colorKey = Z, e.shapes[Z] = this;
      }
      getContext() {
        return r.Util.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
      }
      getCanvas() {
        return r.Util.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
      }
      getSceneFunc() {
        return this.attrs.sceneFunc || this._sceneFunc;
      }
      getHitFunc() {
        return this.attrs.hitFunc || this._hitFunc;
      }
      hasShadow() {
        return this._getCache(g, this._hasShadow);
      }
      _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
      }
      _getFillPattern() {
        return this._getCache(v, this.__getFillPattern);
      }
      __getFillPattern() {
        if (this.fillPatternImage()) {
          const Z = T().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
          if (Z && Z.setTransform) {
            const te = new r.Transform();
            te.translate(this.fillPatternX(), this.fillPatternY()), te.rotate(t.Konva.getAngle(this.fillPatternRotation())), te.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), te.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const ie = te.getMatrix(), ue = typeof DOMMatrix > "u" ? {
              a: ie[0],
              b: ie[1],
              c: ie[2],
              d: ie[3],
              e: ie[4],
              f: ie[5]
            } : new DOMMatrix(ie);
            Z.setTransform(ue);
          }
          return Z;
        }
      }
      _getLinearGradient() {
        return this._getCache(E, this.__getLinearGradient);
      }
      __getLinearGradient() {
        const F = this.fillLinearGradientColorStops();
        if (F) {
          const Z = T(), te = this.fillLinearGradientStartPoint(), ie = this.fillLinearGradientEndPoint(), ue = Z.createLinearGradient(te.x, te.y, ie.x, ie.y);
          for (let ce = 0; ce < F.length; ce += 2)
            ue.addColorStop(F[ce], F[ce + 1]);
          return ue;
        }
      }
      _getRadialGradient() {
        return this._getCache(S, this.__getRadialGradient);
      }
      __getRadialGradient() {
        const F = this.fillRadialGradientColorStops();
        if (F) {
          const Z = T(), te = this.fillRadialGradientStartPoint(), ie = this.fillRadialGradientEndPoint(), ue = Z.createRadialGradient(te.x, te.y, this.fillRadialGradientStartRadius(), ie.x, ie.y, this.fillRadialGradientEndRadius());
          for (let ce = 0; ce < F.length; ce += 2)
            ue.addColorStop(F[ce], F[ce + 1]);
          return ue;
        }
      }
      getShadowRGBA() {
        return this._getCache(h, this._getShadowRGBA);
      }
      _getShadowRGBA() {
        if (!this.hasShadow())
          return;
        const F = r.Util.colorToRGBA(this.shadowColor());
        if (F)
          return "rgba(" + F.r + "," + F.g + "," + F.b + "," + F.a * (this.shadowOpacity() || 1) + ")";
      }
      hasFill() {
        return this._calculate("hasFill", [
          "fillEnabled",
          "fill",
          "fillPatternImage",
          "fillLinearGradientColorStops",
          "fillRadialGradientColorStops"
        ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
      }
      hasStroke() {
        return this._calculate("hasStroke", [
          "strokeEnabled",
          "strokeWidth",
          "stroke",
          "strokeLinearGradientColorStops"
        ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
      }
      hasHitStroke() {
        const F = this.hitStrokeWidth();
        return F === "auto" ? this.hasStroke() : this.strokeEnabled() && !!F;
      }
      intersects(F) {
        const Z = this.getStage();
        if (!Z)
          return !1;
        const te = Z.bufferHitCanvas;
        return te.getContext().clear(), this.drawHit(te, void 0, !0), te.context.getImageData(Math.round(F.x), Math.round(F.y), 1, 1).data[3] > 0;
      }
      destroy() {
        return l.Node.prototype.destroy.call(this), delete e.shapes[this.colorKey], delete this.colorKey, this;
      }
      _useBufferCanvas(F) {
        var Z;
        if (!((Z = this.attrs.perfectDrawEnabled) !== null && Z !== void 0 ? Z : !0))
          return !1;
        const ie = F || this.hasFill(), ue = this.hasStroke(), ce = this.getAbsoluteOpacity() !== 1;
        if (ie && ue && ce)
          return !0;
        const ze = this.hasShadow(), W = this.shadowForStrokeEnabled();
        return !!(ie && ue && ze && W);
      }
      setStrokeHitEnabled(F) {
        r.Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), F ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
      }
      getStrokeHitEnabled() {
        return this.hitStrokeWidth() !== 0;
      }
      getSelfRect() {
        const F = this.size();
        return {
          x: this._centroid ? -F.width / 2 : 0,
          y: this._centroid ? -F.height / 2 : 0,
          width: F.width,
          height: F.height
        };
      }
      getClientRect(F = {}) {
        let Z = !1, te = this.getParent();
        for (; te; ) {
          if (te.isCached()) {
            Z = !0;
            break;
          }
          te = te.getParent();
        }
        const ie = F.skipTransform, ue = F.relativeTo || Z && this.getStage() || void 0, ce = this.getSelfRect(), W = !F.skipStroke && this.hasStroke() && this.strokeWidth() || 0, j = ce.width + W, ee = ce.height + W, Q = !F.skipShadow && this.hasShadow(), oe = Q ? this.shadowOffsetX() : 0, ye = Q ? this.shadowOffsetY() : 0, pe = j + Math.abs(oe), Me = ee + Math.abs(ye), We = Q && this.shadowBlur() || 0, Ee = pe + We * 2, ae = Me + We * 2, Re = {
          width: Ee,
          height: ae,
          x: -(W / 2 + We) + Math.min(oe, 0) + ce.x,
          y: -(W / 2 + We) + Math.min(ye, 0) + ce.y
        };
        return ie ? Re : this._transformedRect(Re, ue);
      }
      drawScene(F, Z, te) {
        const ie = this.getLayer(), ue = F || ie.getCanvas(), ce = ue.getContext(), ze = this._getCanvasCache(), W = this.getSceneFunc(), j = this.hasShadow();
        let ee;
        const Q = Z === this;
        if (!this.isVisible() && !Q)
          return this;
        if (ze) {
          ce.save();
          const oe = this.getAbsoluteTransform(Z).getMatrix();
          return ce.transform(oe[0], oe[1], oe[2], oe[3], oe[4], oe[5]), this._drawCachedSceneCanvas(ce), ce.restore(), this;
        }
        if (!W)
          return this;
        if (ce.save(), this._useBufferCanvas()) {
          ee = this.getStage();
          const oe = te || ee.bufferCanvas, ye = oe.getContext();
          ye.clear(), ye.save(), ye._applyLineJoin(this);
          const pe = this.getAbsoluteTransform(Z).getMatrix();
          ye.transform(pe[0], pe[1], pe[2], pe[3], pe[4], pe[5]), W.call(this, ye, this), ye.restore();
          const Me = oe.pixelRatio;
          j && ce._applyShadow(this), ce._applyOpacity(this), ce._applyGlobalCompositeOperation(this), ce.drawImage(oe._canvas, oe.x || 0, oe.y || 0, oe.width / Me, oe.height / Me);
        } else {
          if (ce._applyLineJoin(this), !Q) {
            const oe = this.getAbsoluteTransform(Z).getMatrix();
            ce.transform(oe[0], oe[1], oe[2], oe[3], oe[4], oe[5]), ce._applyOpacity(this), ce._applyGlobalCompositeOperation(this);
          }
          j && ce._applyShadow(this), W.call(this, ce, this);
        }
        return ce.restore(), this;
      }
      drawHit(F, Z, te = !1) {
        if (!this.shouldDrawHit(Z, te))
          return this;
        const ie = this.getLayer(), ue = F || ie.hitCanvas, ce = ue && ue.getContext(), ze = this.hitFunc() || this.sceneFunc(), W = this._getCanvasCache(), j = W && W.hit;
        if (this.colorKey || r.Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), j) {
          ce.save();
          const Q = this.getAbsoluteTransform(Z).getMatrix();
          return ce.transform(Q[0], Q[1], Q[2], Q[3], Q[4], Q[5]), this._drawCachedHitCanvas(ce), ce.restore(), this;
        }
        if (!ze)
          return this;
        if (ce.save(), ce._applyLineJoin(this), !(this === Z)) {
          const Q = this.getAbsoluteTransform(Z).getMatrix();
          ce.transform(Q[0], Q[1], Q[2], Q[3], Q[4], Q[5]);
        }
        return ze.call(this, ce, this), ce.restore(), this;
      }
      drawHitFromCache(F = 0) {
        const Z = this._getCanvasCache(), te = this._getCachedSceneCanvas(), ie = Z.hit, ue = ie.getContext(), ce = ie.getWidth(), ze = ie.getHeight();
        ue.clear(), ue.drawImage(te._canvas, 0, 0, ce, ze);
        try {
          const W = ue.getImageData(0, 0, ce, ze), j = W.data, ee = j.length, Q = r.Util._hexToRgb(this.colorKey);
          for (let oe = 0; oe < ee; oe += 4)
            j[oe + 3] > F ? (j[oe] = Q.r, j[oe + 1] = Q.g, j[oe + 2] = Q.b, j[oe + 3] = 255) : j[oe + 3] = 0;
          ue.putImageData(W, 0, 0);
        } catch (W) {
          r.Util.error("Unable to draw hit graph from cached scene canvas. " + W.message);
        }
        return this;
      }
      hasPointerCapture(F) {
        return f.hasPointerCapture(F, this);
      }
      setPointerCapture(F) {
        f.setPointerCapture(F, this);
      }
      releaseCapture(F) {
        f.releaseCapture(F, this);
      }
    }
    e.Shape = I, I.prototype._fillFunc = P, I.prototype._strokeFunc = z, I.prototype._fillFuncHit = L, I.prototype._strokeFuncHit = x, I.prototype._centroid = !1, I.prototype.nodeType = "Shape", (0, d._registerNode)(I), I.prototype.eventListeners = {}, I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", k), I.prototype.on.call(I.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", R), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", B), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", q), I.prototype.on.call(I.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", X), o.Factory.addGetterSetter(I, "stroke", void 0, (0, u.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "strokeWidth", 2, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillAfterStrokeEnabled", !1), o.Factory.addGetterSetter(I, "hitStrokeWidth", "auto", (0, u.getNumberOrAutoValidator)()), o.Factory.addGetterSetter(I, "strokeHitEnabled", !0, (0, u.getBooleanValidator)()), o.Factory.addGetterSetter(I, "perfectDrawEnabled", !0, (0, u.getBooleanValidator)()), o.Factory.addGetterSetter(I, "shadowForStrokeEnabled", !0, (0, u.getBooleanValidator)()), o.Factory.addGetterSetter(I, "lineJoin"), o.Factory.addGetterSetter(I, "lineCap"), o.Factory.addGetterSetter(I, "sceneFunc"), o.Factory.addGetterSetter(I, "hitFunc"), o.Factory.addGetterSetter(I, "dash"), o.Factory.addGetterSetter(I, "dashOffset", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowColor", void 0, (0, u.getStringValidator)()), o.Factory.addGetterSetter(I, "shadowBlur", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOpacity", 1, (0, u.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "shadowOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "shadowOffsetX", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "shadowOffsetY", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternImage"), o.Factory.addGetterSetter(I, "fill", void 0, (0, u.getStringOrGradientValidator)()), o.Factory.addGetterSetter(I, "fillPatternX", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternY", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillLinearGradientColorStops"), o.Factory.addGetterSetter(I, "strokeLinearGradientColorStops"), o.Factory.addGetterSetter(I, "fillRadialGradientStartRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndRadius", 0), o.Factory.addGetterSetter(I, "fillRadialGradientColorStops"), o.Factory.addGetterSetter(I, "fillPatternRepeat", "repeat"), o.Factory.addGetterSetter(I, "fillEnabled", !0), o.Factory.addGetterSetter(I, "strokeEnabled", !0), o.Factory.addGetterSetter(I, "shadowEnabled", !0), o.Factory.addGetterSetter(I, "dashEnabled", !0), o.Factory.addGetterSetter(I, "strokeScaleEnabled", !0), o.Factory.addGetterSetter(I, "fillPriority", "color"), o.Factory.addComponentsGetterSetter(I, "fillPatternOffset", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternOffsetX", 0, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternOffsetY", 0, (0, u.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillPatternScale", ["x", "y"]), o.Factory.addGetterSetter(I, "fillPatternScaleX", 1, (0, u.getNumberValidator)()), o.Factory.addGetterSetter(I, "fillPatternScaleY", 1, (0, u.getNumberValidator)()), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientStartPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addComponentsGetterSetter(I, "strokeLinearGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillLinearGradientEndPointY", 0), o.Factory.addGetterSetter(I, "strokeLinearGradientEndPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientStartPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientStartPointY", 0), o.Factory.addComponentsGetterSetter(I, "fillRadialGradientEndPoint", [
      "x",
      "y"
    ]), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointX", 0), o.Factory.addGetterSetter(I, "fillRadialGradientEndPointY", 0), o.Factory.addGetterSetter(I, "fillPatternRotation", 0), o.Factory.addGetterSetter(I, "fillRule", void 0, (0, u.getStringValidator)()), o.Factory.backCompat(I, {
      dashArray: "dash",
      getDashArray: "getDash",
      setDashArray: "getDash",
      drawFunc: "sceneFunc",
      getDrawFunc: "getSceneFunc",
      setDrawFunc: "setSceneFunc",
      drawHitFunc: "hitFunc",
      getDrawHitFunc: "getHitFunc",
      setDrawHitFunc: "setHitFunc"
    });
  })(Fy)), Fy;
}
var G3;
function F6() {
  if (G3) return tp;
  G3 = 1, Object.defineProperty(tp, "__esModule", { value: !0 }), tp.Layer = void 0;
  const e = jr(), t = J0(), r = ra(), o = On(), l = Q0(), u = Vn(), d = ja(), f = Rn(), g = "#", h = "beforeDraw", v = "draw", E = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 }
  ], S = E.length;
  class w extends t.Container {
    constructor(P) {
      super(P), this.canvas = new l.SceneCanvas(), this.hitCanvas = new l.HitCanvas({
        pixelRatio: 1
      }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
    }
    createPNGStream() {
      return this.canvas._canvas.createPNGStream();
    }
    getCanvas() {
      return this.canvas;
    }
    getNativeCanvasElement() {
      return this.canvas._canvas;
    }
    getHitCanvas() {
      return this.hitCanvas;
    }
    getContext() {
      return this.getCanvas().getContext();
    }
    clear(P) {
      return this.getContext().clear(P), this.getHitCanvas().getContext().clear(P), this;
    }
    setZIndex(P) {
      super.setZIndex(P);
      const z = this.getStage();
      return z && z.content && (z.content.removeChild(this.getNativeCanvasElement()), P < z.children.length - 1 ? z.content.insertBefore(this.getNativeCanvasElement(), z.children[P + 1].getCanvas()._canvas) : z.content.appendChild(this.getNativeCanvasElement())), this;
    }
    moveToTop() {
      r.Node.prototype.moveToTop.call(this);
      const P = this.getStage();
      return P && P.content && (P.content.removeChild(this.getNativeCanvasElement()), P.content.appendChild(this.getNativeCanvasElement())), !0;
    }
    moveUp() {
      if (!r.Node.prototype.moveUp.call(this))
        return !1;
      const z = this.getStage();
      return !z || !z.content ? !1 : (z.content.removeChild(this.getNativeCanvasElement()), this.index < z.children.length - 1 ? z.content.insertBefore(this.getNativeCanvasElement(), z.children[this.index + 1].getCanvas()._canvas) : z.content.appendChild(this.getNativeCanvasElement()), !0);
    }
    moveDown() {
      if (r.Node.prototype.moveDown.call(this)) {
        const P = this.getStage();
        if (P) {
          const z = P.children;
          P.content && (P.content.removeChild(this.getNativeCanvasElement()), P.content.insertBefore(this.getNativeCanvasElement(), z[this.index + 1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    moveToBottom() {
      if (r.Node.prototype.moveToBottom.call(this)) {
        const P = this.getStage();
        if (P) {
          const z = P.children;
          P.content && (P.content.removeChild(this.getNativeCanvasElement()), P.content.insertBefore(this.getNativeCanvasElement(), z[1].getCanvas()._canvas));
        }
        return !0;
      }
      return !1;
    }
    getLayer() {
      return this;
    }
    remove() {
      const P = this.getNativeCanvasElement();
      return r.Node.prototype.remove.call(this), P && P.parentNode && e.Util._isInDocument(P) && P.parentNode.removeChild(P), this;
    }
    getStage() {
      return this.parent;
    }
    setSize({ width: P, height: z }) {
      return this.canvas.setSize(P, z), this.hitCanvas.setSize(P, z), this._setSmoothEnabled(), this;
    }
    _validateAdd(P) {
      const z = P.getType();
      z !== "Group" && z !== "Shape" && e.Util.throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(P) {
      return P = P || {}, P.width = P.width || this.getWidth(), P.height = P.height || this.getHeight(), P.x = P.x !== void 0 ? P.x : this.x(), P.y = P.y !== void 0 ? P.y : this.y(), r.Node.prototype._toKonvaCanvas.call(this, P);
    }
    _checkVisibility() {
      this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
      this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
      if (this.parent)
        return this.parent.width();
    }
    setWidth() {
      e.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
      if (this.parent)
        return this.parent.height();
    }
    setHeight() {
      e.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
      return this._waitingForDraw || (this._waitingForDraw = !0, e.Util.requestAnimFrame(() => {
        this.draw(), this._waitingForDraw = !1;
      })), this;
    }
    getIntersection(P) {
      if (!this.isListening() || !this.isVisible())
        return null;
      let z = 1, L = !1;
      for (; ; ) {
        for (let x = 0; x < S; x++) {
          const k = E[x], R = this._getIntersection({
            x: P.x + k.x * z,
            y: P.y + k.y * z
          }), B = R.shape;
          if (B)
            return B;
          if (L = !!R.antialiased, !R.antialiased)
            break;
        }
        if (L)
          z += 1;
        else
          return null;
      }
    }
    _getIntersection(P) {
      const z = this.hitCanvas.pixelRatio, L = this.hitCanvas.context.getImageData(Math.round(P.x * z), Math.round(P.y * z), 1, 1).data, x = L[3];
      if (x === 255) {
        const k = e.Util._rgbToHex(L[0], L[1], L[2]), R = d.shapes[g + k];
        return R ? {
          shape: R
        } : {
          antialiased: !0
        };
      } else if (x > 0)
        return {
          antialiased: !0
        };
      return {};
    }
    drawScene(P, z, L) {
      const x = this.getLayer(), k = P || x && x.getCanvas();
      return this._fire(h, {
        node: this
      }), this.clearBeforeDraw() && k.getContext().clear(), t.Container.prototype.drawScene.call(this, k, z, L), this._fire(v, {
        node: this
      }), this;
    }
    drawHit(P, z) {
      const L = this.getLayer(), x = P || L && L.hitCanvas;
      return L && L.clearBeforeDraw() && L.getHitCanvas().getContext().clear(), t.Container.prototype.drawHit.call(this, x, z), this;
    }
    enableHitGraph() {
      return this.hitGraphEnabled(!0), this;
    }
    disableHitGraph() {
      return this.hitGraphEnabled(!1), this;
    }
    setHitGraphEnabled(P) {
      e.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(P);
    }
    getHitGraphEnabled(P) {
      return e.Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
    }
    toggleHitCanvas() {
      if (!this.parent || !this.parent.content)
        return;
      const P = this.parent;
      !!this.hitCanvas._canvas.parentNode ? P.content.removeChild(this.hitCanvas._canvas) : P.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
      return e.Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
    }
  }
  return tp.Layer = w, w.prototype.nodeType = "Layer", (0, f._registerNode)(w), o.Factory.addGetterSetter(w, "imageSmoothingEnabled", !0), o.Factory.addGetterSetter(w, "clearBeforeDraw", !0), o.Factory.addGetterSetter(w, "hitGraphEnabled", !0, (0, u.getBooleanValidator)()), tp;
}
var np = {}, V3;
function oA() {
  if (V3) return np;
  V3 = 1, Object.defineProperty(np, "__esModule", { value: !0 }), np.FastLayer = void 0;
  const e = jr(), t = F6(), r = Rn();
  let o = class extends t.Layer {
    constructor(u) {
      super(u), this.listening(!1), e.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
  };
  return np.FastLayer = o, o.prototype.nodeType = "FastLayer", (0, r._registerNode)(o), np;
}
var rp = {}, q3;
function _b() {
  if (q3) return rp;
  q3 = 1, Object.defineProperty(rp, "__esModule", { value: !0 }), rp.Group = void 0;
  const e = jr(), t = J0(), r = Rn();
  class o extends t.Container {
    _validateAdd(u) {
      const d = u.getType();
      d !== "Group" && d !== "Shape" && e.Util.throw("You may only add groups and shapes to groups.");
    }
  }
  return rp.Group = o, o.prototype.nodeType = "Group", (0, r._registerNode)(o), rp;
}
var ap = {}, W3;
function Sb() {
  if (W3) return ap;
  W3 = 1, Object.defineProperty(ap, "__esModule", { value: !0 }), ap.Animation = void 0;
  const e = Rn(), t = jr(), r = (function() {
    return e.glob.performance && e.glob.performance.now ? function() {
      return e.glob.performance.now();
    } : function() {
      return (/* @__PURE__ */ new Date()).getTime();
    };
  })();
  let o = class Ef {
    constructor(u, d) {
      this.id = Ef.animIdCounter++, this.frame = {
        time: 0,
        timeDiff: 0,
        lastTime: r(),
        frameRate: 0
      }, this.func = u, this.setLayers(d);
    }
    setLayers(u) {
      let d = [];
      return u && (d = Array.isArray(u) ? u : [u]), this.layers = d, this;
    }
    getLayers() {
      return this.layers;
    }
    addLayer(u) {
      const d = this.layers, f = d.length;
      for (let g = 0; g < f; g++)
        if (d[g]._id === u._id)
          return !1;
      return this.layers.push(u), !0;
    }
    isRunning() {
      const d = Ef.animations, f = d.length;
      for (let g = 0; g < f; g++)
        if (d[g].id === this.id)
          return !0;
      return !1;
    }
    start() {
      return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = r(), Ef._addAnimation(this), this;
    }
    stop() {
      return Ef._removeAnimation(this), this;
    }
    _updateFrameObject(u) {
      this.frame.timeDiff = u - this.frame.lastTime, this.frame.lastTime = u, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
    }
    static _addAnimation(u) {
      this.animations.push(u), this._handleAnimation();
    }
    static _removeAnimation(u) {
      const d = u.id, f = this.animations, g = f.length;
      for (let h = 0; h < g; h++)
        if (f[h].id === d) {
          this.animations.splice(h, 1);
          break;
        }
    }
    static _runFrames() {
      const u = {}, d = this.animations;
      for (let f = 0; f < d.length; f++) {
        const g = d[f], h = g.layers, v = g.func;
        g._updateFrameObject(r());
        const E = h.length;
        let S;
        if (v ? S = v.call(g, g.frame) !== !1 : S = !0, !!S)
          for (let w = 0; w < E; w++) {
            const T = h[w];
            T._id !== void 0 && (u[T._id] = T);
          }
      }
      for (const f in u)
        u.hasOwnProperty(f) && u[f].batchDraw();
    }
    static _animationLoop() {
      const u = Ef;
      u.animations.length ? (u._runFrames(), t.Util.requestAnimFrame(u._animationLoop)) : u.animRunning = !1;
    }
    static _handleAnimation() {
      this.animRunning || (this.animRunning = !0, t.Util.requestAnimFrame(this._animationLoop));
    }
  };
  return ap.Animation = o, o.animations = [], o.animIdCounter = 0, o.animRunning = !1, ap;
}
var zy = {}, K3;
function sA() {
  return K3 || (K3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Easings = e.Tween = void 0;
    const t = jr(), r = Sb(), o = ra(), l = Rn(), u = {
      node: 1,
      duration: 1,
      easing: 1,
      onFinish: 1,
      yoyo: 1
    }, d = 1, f = 2, g = 3, h = ["fill", "stroke", "shadowColor"];
    let v = 0;
    class E {
      constructor(T, P, z, L, x, k, R) {
        this.prop = T, this.propFunc = P, this.begin = L, this._pos = L, this.duration = k, this._change = 0, this.prevPos = 0, this.yoyo = R, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = z, this._change = x - this.begin, this.pause();
      }
      fire(T) {
        const P = this[T];
        P && P();
      }
      setTime(T) {
        T > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : T < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = T, this.update());
      }
      getTime() {
        return this._time;
      }
      setPosition(T) {
        this.prevPos = this._pos, this.propFunc(T), this._pos = T;
      }
      getPosition(T) {
        return T === void 0 && (T = this._time), this.func(T, this.begin, this._change, this.duration);
      }
      play() {
        this.state = f, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
      }
      reverse() {
        this.state = g, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
      }
      seek(T) {
        this.pause(), this._time = T, this.update(), this.fire("onSeek");
      }
      reset() {
        this.pause(), this._time = 0, this.update(), this.fire("onReset");
      }
      finish() {
        this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
      }
      update() {
        this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
      }
      onEnterFrame() {
        const T = this.getTimer() - this._startTime;
        this.state === f ? this.setTime(T) : this.state === g && this.setTime(this.duration - T);
      }
      pause() {
        this.state = d, this.fire("onPause");
      }
      getTimer() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
    }
    class S {
      constructor(T) {
        const P = this, z = T.node, L = z._id, x = T.easing || e.Easings.Linear, k = !!T.yoyo;
        let R, B;
        typeof T.duration > "u" ? R = 0.3 : T.duration === 0 ? R = 1e-3 : R = T.duration, this.node = z, this._id = v++;
        const q = z.getLayer() || (z instanceof l.Konva.Stage ? z.getLayers() : null);
        q || t.Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new r.Animation(function() {
          P.tween.onEnterFrame();
        }, q), this.tween = new E(B, function(X) {
          P._tweenFunc(X);
        }, x, 0, 1, R * 1e3, k), this._addListeners(), S.attrs[L] || (S.attrs[L] = {}), S.attrs[L][this._id] || (S.attrs[L][this._id] = {}), S.tweens[L] || (S.tweens[L] = {});
        for (B in T)
          u[B] === void 0 && this._addAttr(B, T[B]);
        this.reset(), this.onFinish = T.onFinish, this.onReset = T.onReset, this.onUpdate = T.onUpdate;
      }
      _addAttr(T, P) {
        const z = this.node, L = z._id;
        let x, k, R, B, q;
        const X = S.tweens[L][T];
        X && delete S.attrs[L][X][T];
        let I = z.getAttr(T);
        if (t.Util._isArray(P))
          if (x = [], k = Math.max(P.length, I.length), T === "points" && P.length !== I.length && (P.length > I.length ? (B = I, I = t.Util._prepareArrayForTween(I, P, z.closed())) : (R = P, P = t.Util._prepareArrayForTween(P, I, z.closed()))), T.indexOf("fill") === 0)
            for (let U = 0; U < k; U++)
              if (U % 2 === 0)
                x.push(P[U] - I[U]);
              else {
                const F = t.Util.colorToRGBA(I[U]);
                q = t.Util.colorToRGBA(P[U]), I[U] = F, x.push({
                  r: q.r - F.r,
                  g: q.g - F.g,
                  b: q.b - F.b,
                  a: q.a - F.a
                });
              }
          else
            for (let U = 0; U < k; U++)
              x.push(P[U] - I[U]);
        else h.indexOf(T) !== -1 ? (I = t.Util.colorToRGBA(I), q = t.Util.colorToRGBA(P), x = {
          r: q.r - I.r,
          g: q.g - I.g,
          b: q.b - I.b,
          a: q.a - I.a
        }) : x = P - I;
        S.attrs[L][this._id][T] = {
          start: I,
          diff: x,
          end: P,
          trueEnd: R,
          trueStart: B
        }, S.tweens[L][T] = this._id;
      }
      _tweenFunc(T) {
        const P = this.node, z = S.attrs[P._id][this._id];
        let L, x, k, R, B, q, X, I;
        for (L in z) {
          if (x = z[L], k = x.start, R = x.diff, I = x.end, t.Util._isArray(k))
            if (B = [], X = Math.max(k.length, I.length), L.indexOf("fill") === 0)
              for (q = 0; q < X; q++)
                q % 2 === 0 ? B.push((k[q] || 0) + R[q] * T) : B.push("rgba(" + Math.round(k[q].r + R[q].r * T) + "," + Math.round(k[q].g + R[q].g * T) + "," + Math.round(k[q].b + R[q].b * T) + "," + (k[q].a + R[q].a * T) + ")");
            else
              for (q = 0; q < X; q++)
                B.push((k[q] || 0) + R[q] * T);
          else h.indexOf(L) !== -1 ? B = "rgba(" + Math.round(k.r + R.r * T) + "," + Math.round(k.g + R.g * T) + "," + Math.round(k.b + R.b * T) + "," + (k.a + R.a * T) + ")" : B = k + R * T;
          P.setAttr(L, B);
        }
      }
      _addListeners() {
        this.tween.onPlay = () => {
          this.anim.start();
        }, this.tween.onReverse = () => {
          this.anim.start();
        }, this.tween.onPause = () => {
          this.anim.stop();
        }, this.tween.onFinish = () => {
          const T = this.node, P = S.attrs[T._id][this._id];
          P.points && P.points.trueEnd && T.setAttr("points", P.points.trueEnd), this.onFinish && this.onFinish.call(this);
        }, this.tween.onReset = () => {
          const T = this.node, P = S.attrs[T._id][this._id];
          P.points && P.points.trueStart && T.points(P.points.trueStart), this.onReset && this.onReset();
        }, this.tween.onUpdate = () => {
          this.onUpdate && this.onUpdate.call(this);
        };
      }
      play() {
        return this.tween.play(), this;
      }
      reverse() {
        return this.tween.reverse(), this;
      }
      reset() {
        return this.tween.reset(), this;
      }
      seek(T) {
        return this.tween.seek(T * 1e3), this;
      }
      pause() {
        return this.tween.pause(), this;
      }
      finish() {
        return this.tween.finish(), this;
      }
      destroy() {
        const T = this.node._id, P = this._id, z = S.tweens[T];
        this.pause(), this.anim && this.anim.stop();
        for (const L in z)
          delete S.tweens[T][L];
        delete S.attrs[T][P], S.tweens[T] && (Object.keys(S.tweens[T]).length === 0 && delete S.tweens[T], Object.keys(S.attrs[T]).length === 0 && delete S.attrs[T]);
      }
    }
    e.Tween = S, S.attrs = {}, S.tweens = {}, o.Node.prototype.to = function(w) {
      const T = w.onFinish;
      w.node = this, w.onFinish = function() {
        this.destroy(), T && T();
      }, new S(w).play();
    }, e.Easings = {
      BackEaseIn(w, T, P, z) {
        return P * (w /= z) * w * ((1.70158 + 1) * w - 1.70158) + T;
      },
      BackEaseOut(w, T, P, z) {
        return P * ((w = w / z - 1) * w * ((1.70158 + 1) * w + 1.70158) + 1) + T;
      },
      BackEaseInOut(w, T, P, z) {
        let L = 1.70158;
        return (w /= z / 2) < 1 ? P / 2 * (w * w * (((L *= 1.525) + 1) * w - L)) + T : P / 2 * ((w -= 2) * w * (((L *= 1.525) + 1) * w + L) + 2) + T;
      },
      ElasticEaseIn(w, T, P, z, L, x) {
        let k = 0;
        return w === 0 ? T : (w /= z) === 1 ? T + P : (x || (x = z * 0.3), !L || L < Math.abs(P) ? (L = P, k = x / 4) : k = x / (2 * Math.PI) * Math.asin(P / L), -(L * Math.pow(2, 10 * (w -= 1)) * Math.sin((w * z - k) * (2 * Math.PI) / x)) + T);
      },
      ElasticEaseOut(w, T, P, z, L, x) {
        let k = 0;
        return w === 0 ? T : (w /= z) === 1 ? T + P : (x || (x = z * 0.3), !L || L < Math.abs(P) ? (L = P, k = x / 4) : k = x / (2 * Math.PI) * Math.asin(P / L), L * Math.pow(2, -10 * w) * Math.sin((w * z - k) * (2 * Math.PI) / x) + P + T);
      },
      ElasticEaseInOut(w, T, P, z, L, x) {
        let k = 0;
        return w === 0 ? T : (w /= z / 2) === 2 ? T + P : (x || (x = z * (0.3 * 1.5)), !L || L < Math.abs(P) ? (L = P, k = x / 4) : k = x / (2 * Math.PI) * Math.asin(P / L), w < 1 ? -0.5 * (L * Math.pow(2, 10 * (w -= 1)) * Math.sin((w * z - k) * (2 * Math.PI) / x)) + T : L * Math.pow(2, -10 * (w -= 1)) * Math.sin((w * z - k) * (2 * Math.PI) / x) * 0.5 + P + T);
      },
      BounceEaseOut(w, T, P, z) {
        return (w /= z) < 1 / 2.75 ? P * (7.5625 * w * w) + T : w < 2 / 2.75 ? P * (7.5625 * (w -= 1.5 / 2.75) * w + 0.75) + T : w < 2.5 / 2.75 ? P * (7.5625 * (w -= 2.25 / 2.75) * w + 0.9375) + T : P * (7.5625 * (w -= 2.625 / 2.75) * w + 0.984375) + T;
      },
      BounceEaseIn(w, T, P, z) {
        return P - e.Easings.BounceEaseOut(z - w, 0, P, z) + T;
      },
      BounceEaseInOut(w, T, P, z) {
        return w < z / 2 ? e.Easings.BounceEaseIn(w * 2, 0, P, z) * 0.5 + T : e.Easings.BounceEaseOut(w * 2 - z, 0, P, z) * 0.5 + P * 0.5 + T;
      },
      EaseIn(w, T, P, z) {
        return P * (w /= z) * w + T;
      },
      EaseOut(w, T, P, z) {
        return -P * (w /= z) * (w - 2) + T;
      },
      EaseInOut(w, T, P, z) {
        return (w /= z / 2) < 1 ? P / 2 * w * w + T : -P / 2 * (--w * (w - 2) - 1) + T;
      },
      StrongEaseIn(w, T, P, z) {
        return P * (w /= z) * w * w * w * w + T;
      },
      StrongEaseOut(w, T, P, z) {
        return P * ((w = w / z - 1) * w * w * w * w + 1) + T;
      },
      StrongEaseInOut(w, T, P, z) {
        return (w /= z / 2) < 1 ? P / 2 * w * w * w * w * w + T : P / 2 * ((w -= 2) * w * w * w * w + 2) + T;
      },
      Linear(w, T, P, z) {
        return P * w / z + T;
      }
    };
  })(zy)), zy;
}
var j3;
function K2() {
  return j3 || (j3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.Konva = void 0;
    const t = Rn(), r = jr(), o = ra(), l = J0(), u = iA(), d = F6(), f = oA(), g = _b(), h = bb(), v = ja(), E = Sb(), S = sA(), w = L6(), T = Q0();
    e.Konva = r.Util._assign(t.Konva, {
      Util: r.Util,
      Transform: r.Transform,
      Node: o.Node,
      Container: l.Container,
      Stage: u.Stage,
      stages: u.stages,
      Layer: d.Layer,
      FastLayer: f.FastLayer,
      Group: g.Group,
      DD: h.DD,
      Shape: v.Shape,
      shapes: v.shapes,
      Animation: E.Animation,
      Tween: S.Tween,
      Easings: S.Easings,
      Context: w.Context,
      Canvas: T.Canvas
    }), e.default = e.Konva;
  })(Ay)), Ay;
}
var ip = {}, Y3;
function lA() {
  if (Y3) return ip;
  Y3 = 1, Object.defineProperty(ip, "__esModule", { value: !0 }), ip.Arc = void 0;
  const e = On(), t = ja(), r = Rn(), o = Vn(), l = Rn();
  let u = class extends t.Shape {
    _sceneFunc(f) {
      const g = r.Konva.getAngle(this.angle()), h = this.clockwise();
      f.beginPath(), f.arc(0, 0, this.outerRadius(), 0, g, h), f.arc(0, 0, this.innerRadius(), g, 0, !h), f.closePath(), f.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(f) {
      this.outerRadius(f / 2);
    }
    setHeight(f) {
      this.outerRadius(f / 2);
    }
    getSelfRect() {
      const f = this.innerRadius(), g = this.outerRadius(), h = this.clockwise(), v = r.Konva.getAngle(h ? 360 - this.angle() : this.angle()), E = Math.cos(Math.min(v, Math.PI)), S = 1, w = Math.sin(Math.min(Math.max(Math.PI, v), 3 * Math.PI / 2)), T = Math.sin(Math.min(v, Math.PI / 2)), P = E * (E > 0 ? f : g), z = S * g, L = w * (w > 0 ? f : g), x = T * (T > 0 ? g : f);
      return {
        x: P,
        y: h ? -1 * x : L,
        width: z - P,
        height: x - L
      };
    }
  };
  return ip.Arc = u, u.prototype._centroid = !0, u.prototype.className = "Arc", u.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius",
    "angle",
    "clockwise"
  ], (0, l._registerNode)(u), e.Factory.addGetterSetter(u, "innerRadius", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "outerRadius", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "angle", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "clockwise", !1, (0, o.getBooleanValidator)()), ip;
}
var op = {}, sp = {}, Z3;
function z6() {
  if (Z3) return sp;
  Z3 = 1, Object.defineProperty(sp, "__esModule", { value: !0 }), sp.Line = void 0;
  const e = On(), t = Rn(), r = ja(), o = Vn();
  function l(f, g, h, v, E, S, w) {
    const T = Math.sqrt(Math.pow(h - f, 2) + Math.pow(v - g, 2)), P = Math.sqrt(Math.pow(E - h, 2) + Math.pow(S - v, 2)), z = w * T / (T + P), L = w * P / (T + P), x = h - z * (E - f), k = v - z * (S - g), R = h + L * (E - f), B = v + L * (S - g);
    return [x, k, R, B];
  }
  function u(f, g) {
    const h = f.length, v = [];
    for (let E = 2; E < h - 2; E += 2) {
      const S = l(f[E - 2], f[E - 1], f[E], f[E + 1], f[E + 2], f[E + 3], g);
      isNaN(S[0]) || (v.push(S[0]), v.push(S[1]), v.push(f[E]), v.push(f[E + 1]), v.push(S[2]), v.push(S[3]));
    }
    return v;
  }
  class d extends r.Shape {
    constructor(g) {
      super(g), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
        this._clearCache("tensionPoints");
      });
    }
    _sceneFunc(g) {
      const h = this.points(), v = h.length, E = this.tension(), S = this.closed(), w = this.bezier();
      if (!v)
        return;
      let T = 0;
      if (g.beginPath(), g.moveTo(h[0], h[1]), E !== 0 && v > 4) {
        const P = this.getTensionPoints(), z = P.length;
        for (T = S ? 0 : 4, S || g.quadraticCurveTo(P[0], P[1], P[2], P[3]); T < z - 2; )
          g.bezierCurveTo(P[T++], P[T++], P[T++], P[T++], P[T++], P[T++]);
        S || g.quadraticCurveTo(P[z - 2], P[z - 1], h[v - 2], h[v - 1]);
      } else if (w)
        for (T = 2; T < v; )
          g.bezierCurveTo(h[T++], h[T++], h[T++], h[T++], h[T++], h[T++]);
      else
        for (T = 2; T < v; T += 2)
          g.lineTo(h[T], h[T + 1]);
      S ? (g.closePath(), g.fillStrokeShape(this)) : g.strokeShape(this);
    }
    getTensionPoints() {
      return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
      return this.closed() ? this._getTensionPointsClosed() : u(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
      const g = this.points(), h = g.length, v = this.tension(), E = l(g[h - 2], g[h - 1], g[0], g[1], g[2], g[3], v), S = l(g[h - 4], g[h - 3], g[h - 2], g[h - 1], g[0], g[1], v), w = u(g, v);
      return [E[2], E[3]].concat(w).concat([
        S[0],
        S[1],
        g[h - 2],
        g[h - 1],
        S[2],
        S[3],
        E[0],
        E[1],
        g[0],
        g[1]
      ]);
    }
    getWidth() {
      return this.getSelfRect().width;
    }
    getHeight() {
      return this.getSelfRect().height;
    }
    getSelfRect() {
      let g = this.points();
      if (g.length < 4)
        return {
          x: g[0] || 0,
          y: g[1] || 0,
          width: 0,
          height: 0
        };
      this.tension() !== 0 ? g = [
        g[0],
        g[1],
        ...this._getTensionPoints(),
        g[g.length - 2],
        g[g.length - 1]
      ] : g = this.points();
      let h = g[0], v = g[0], E = g[1], S = g[1], w, T;
      for (let P = 0; P < g.length / 2; P++)
        w = g[P * 2], T = g[P * 2 + 1], h = Math.min(h, w), v = Math.max(v, w), E = Math.min(E, T), S = Math.max(S, T);
      return {
        x: h,
        y: E,
        width: v - h,
        height: S - E
      };
    }
  }
  return sp.Line = d, d.prototype.className = "Line", d.prototype._attrsAffectingSize = ["points", "bezier", "tension"], (0, t._registerNode)(d), e.Factory.addGetterSetter(d, "closed", !1), e.Factory.addGetterSetter(d, "bezier", !1), e.Factory.addGetterSetter(d, "tension", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(d, "points", [], (0, o.getNumberArrayValidator)()), sp;
}
var lp = {}, By = {}, X3;
function uA() {
  return X3 || (X3 = 1, (function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.t2length = e.getQuadraticArcLength = e.getCubicArcLength = e.binomialCoefficients = e.cValues = e.tValues = void 0, e.tValues = [
      [],
      [],
      [
        -0.5773502691896257,
        0.5773502691896257
      ],
      [
        0,
        -0.7745966692414834,
        0.7745966692414834
      ],
      [
        -0.33998104358485626,
        0.33998104358485626,
        -0.8611363115940526,
        0.8611363115940526
      ],
      [
        0,
        -0.5384693101056831,
        0.5384693101056831,
        -0.906179845938664,
        0.906179845938664
      ],
      [
        0.6612093864662645,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969,
        -0.932469514203152,
        0.932469514203152
      ],
      [
        0,
        0.4058451513773972,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993945,
        -0.9491079123427585,
        0.9491079123427585
      ],
      [
        -0.1834346424956498,
        0.1834346424956498,
        -0.525532409916329,
        0.525532409916329,
        -0.7966664774136267,
        0.7966664774136267,
        -0.9602898564975363,
        0.9602898564975363
      ],
      [
        0,
        -0.8360311073266358,
        0.8360311073266358,
        -0.9681602395076261,
        0.9681602395076261,
        -0.3242534234038089,
        0.3242534234038089,
        -0.6133714327005904,
        0.6133714327005904
      ],
      [
        -0.14887433898163122,
        0.14887433898163122,
        -0.4333953941292472,
        0.4333953941292472,
        -0.6794095682990244,
        0.6794095682990244,
        -0.8650633666889845,
        0.8650633666889845,
        -0.9739065285171717,
        0.9739065285171717
      ],
      [
        0,
        -0.26954315595234496,
        0.26954315595234496,
        -0.5190961292068118,
        0.5190961292068118,
        -0.7301520055740494,
        0.7301520055740494,
        -0.8870625997680953,
        0.8870625997680953,
        -0.978228658146057,
        0.978228658146057
      ],
      [
        -0.1252334085114689,
        0.1252334085114689,
        -0.3678314989981802,
        0.3678314989981802,
        -0.5873179542866175,
        0.5873179542866175,
        -0.7699026741943047,
        0.7699026741943047,
        -0.9041172563704749,
        0.9041172563704749,
        -0.9815606342467192,
        0.9815606342467192
      ],
      [
        0,
        -0.2304583159551348,
        0.2304583159551348,
        -0.44849275103644687,
        0.44849275103644687,
        -0.6423493394403402,
        0.6423493394403402,
        -0.8015780907333099,
        0.8015780907333099,
        -0.9175983992229779,
        0.9175983992229779,
        -0.9841830547185881,
        0.9841830547185881
      ],
      [
        -0.10805494870734367,
        0.10805494870734367,
        -0.31911236892788974,
        0.31911236892788974,
        -0.5152486363581541,
        0.5152486363581541,
        -0.6872929048116855,
        0.6872929048116855,
        -0.827201315069765,
        0.827201315069765,
        -0.9284348836635735,
        0.9284348836635735,
        -0.9862838086968123,
        0.9862838086968123
      ],
      [
        0,
        -0.20119409399743451,
        0.20119409399743451,
        -0.3941513470775634,
        0.3941513470775634,
        -0.5709721726085388,
        0.5709721726085388,
        -0.7244177313601701,
        0.7244177313601701,
        -0.8482065834104272,
        0.8482065834104272,
        -0.937273392400706,
        0.937273392400706,
        -0.9879925180204854,
        0.9879925180204854
      ],
      [
        -0.09501250983763744,
        0.09501250983763744,
        -0.2816035507792589,
        0.2816035507792589,
        -0.45801677765722737,
        0.45801677765722737,
        -0.6178762444026438,
        0.6178762444026438,
        -0.755404408355003,
        0.755404408355003,
        -0.8656312023878318,
        0.8656312023878318,
        -0.9445750230732326,
        0.9445750230732326,
        -0.9894009349916499,
        0.9894009349916499
      ],
      [
        0,
        -0.17848418149584785,
        0.17848418149584785,
        -0.3512317634538763,
        0.3512317634538763,
        -0.5126905370864769,
        0.5126905370864769,
        -0.6576711592166907,
        0.6576711592166907,
        -0.7815140038968014,
        0.7815140038968014,
        -0.8802391537269859,
        0.8802391537269859,
        -0.9506755217687678,
        0.9506755217687678,
        -0.9905754753144174,
        0.9905754753144174
      ],
      [
        -0.0847750130417353,
        0.0847750130417353,
        -0.2518862256915055,
        0.2518862256915055,
        -0.41175116146284263,
        0.41175116146284263,
        -0.5597708310739475,
        0.5597708310739475,
        -0.6916870430603532,
        0.6916870430603532,
        -0.8037049589725231,
        0.8037049589725231,
        -0.8926024664975557,
        0.8926024664975557,
        -0.9558239495713977,
        0.9558239495713977,
        -0.9915651684209309,
        0.9915651684209309
      ],
      [
        0,
        -0.16035864564022537,
        0.16035864564022537,
        -0.31656409996362983,
        0.31656409996362983,
        -0.46457074137596094,
        0.46457074137596094,
        -0.600545304661681,
        0.600545304661681,
        -0.7209661773352294,
        0.7209661773352294,
        -0.8227146565371428,
        0.8227146565371428,
        -0.9031559036148179,
        0.9031559036148179,
        -0.96020815213483,
        0.96020815213483,
        -0.9924068438435844,
        0.9924068438435844
      ],
      [
        -0.07652652113349734,
        0.07652652113349734,
        -0.22778585114164507,
        0.22778585114164507,
        -0.37370608871541955,
        0.37370608871541955,
        -0.5108670019508271,
        0.5108670019508271,
        -0.636053680726515,
        0.636053680726515,
        -0.7463319064601508,
        0.7463319064601508,
        -0.8391169718222188,
        0.8391169718222188,
        -0.912234428251326,
        0.912234428251326,
        -0.9639719272779138,
        0.9639719272779138,
        -0.9931285991850949,
        0.9931285991850949
      ],
      [
        0,
        -0.1455618541608951,
        0.1455618541608951,
        -0.2880213168024011,
        0.2880213168024011,
        -0.4243421202074388,
        0.4243421202074388,
        -0.5516188358872198,
        0.5516188358872198,
        -0.6671388041974123,
        0.6671388041974123,
        -0.7684399634756779,
        0.7684399634756779,
        -0.8533633645833173,
        0.8533633645833173,
        -0.9200993341504008,
        0.9200993341504008,
        -0.9672268385663063,
        0.9672268385663063,
        -0.9937521706203895,
        0.9937521706203895
      ],
      [
        -0.06973927331972223,
        0.06973927331972223,
        -0.20786042668822127,
        0.20786042668822127,
        -0.34193582089208424,
        0.34193582089208424,
        -0.469355837986757,
        0.469355837986757,
        -0.5876404035069116,
        0.5876404035069116,
        -0.6944872631866827,
        0.6944872631866827,
        -0.7878168059792081,
        0.7878168059792081,
        -0.8658125777203002,
        0.8658125777203002,
        -0.926956772187174,
        0.926956772187174,
        -0.9700604978354287,
        0.9700604978354287,
        -0.9942945854823992,
        0.9942945854823992
      ],
      [
        0,
        -0.1332568242984661,
        0.1332568242984661,
        -0.26413568097034495,
        0.26413568097034495,
        -0.3903010380302908,
        0.3903010380302908,
        -0.5095014778460075,
        0.5095014778460075,
        -0.6196098757636461,
        0.6196098757636461,
        -0.7186613631319502,
        0.7186613631319502,
        -0.8048884016188399,
        0.8048884016188399,
        -0.8767523582704416,
        0.8767523582704416,
        -0.9329710868260161,
        0.9329710868260161,
        -0.9725424712181152,
        0.9725424712181152,
        -0.9947693349975522,
        0.9947693349975522
      ],
      [
        -0.06405689286260563,
        0.06405689286260563,
        -0.1911188674736163,
        0.1911188674736163,
        -0.3150426796961634,
        0.3150426796961634,
        -0.4337935076260451,
        0.4337935076260451,
        -0.5454214713888396,
        0.5454214713888396,
        -0.6480936519369755,
        0.6480936519369755,
        -0.7401241915785544,
        0.7401241915785544,
        -0.820001985973903,
        0.820001985973903,
        -0.8864155270044011,
        0.8864155270044011,
        -0.9382745520027328,
        0.9382745520027328,
        -0.9747285559713095,
        0.9747285559713095,
        -0.9951872199970213,
        0.9951872199970213
      ]
    ], e.cValues = [
      [],
      [],
      [1, 1],
      [
        0.8888888888888888,
        0.5555555555555556,
        0.5555555555555556
      ],
      [
        0.6521451548625461,
        0.6521451548625461,
        0.34785484513745385,
        0.34785484513745385
      ],
      [
        0.5688888888888889,
        0.47862867049936647,
        0.47862867049936647,
        0.23692688505618908,
        0.23692688505618908
      ],
      [
        0.3607615730481386,
        0.3607615730481386,
        0.46791393457269104,
        0.46791393457269104,
        0.17132449237917036,
        0.17132449237917036
      ],
      [
        0.4179591836734694,
        0.3818300505051189,
        0.3818300505051189,
        0.27970539148927664,
        0.27970539148927664,
        0.1294849661688697,
        0.1294849661688697
      ],
      [
        0.362683783378362,
        0.362683783378362,
        0.31370664587788727,
        0.31370664587788727,
        0.22238103445337448,
        0.22238103445337448,
        0.10122853629037626,
        0.10122853629037626
      ],
      [
        0.3302393550012598,
        0.1806481606948574,
        0.1806481606948574,
        0.08127438836157441,
        0.08127438836157441,
        0.31234707704000286,
        0.31234707704000286,
        0.26061069640293544,
        0.26061069640293544
      ],
      [
        0.29552422471475287,
        0.29552422471475287,
        0.26926671930999635,
        0.26926671930999635,
        0.21908636251598204,
        0.21908636251598204,
        0.1494513491505806,
        0.1494513491505806,
        0.06667134430868814,
        0.06667134430868814
      ],
      [
        0.2729250867779006,
        0.26280454451024665,
        0.26280454451024665,
        0.23319376459199048,
        0.23319376459199048,
        0.18629021092773426,
        0.18629021092773426,
        0.1255803694649046,
        0.1255803694649046,
        0.05566856711617366,
        0.05566856711617366
      ],
      [
        0.24914704581340277,
        0.24914704581340277,
        0.2334925365383548,
        0.2334925365383548,
        0.20316742672306592,
        0.20316742672306592,
        0.16007832854334622,
        0.16007832854334622,
        0.10693932599531843,
        0.10693932599531843,
        0.04717533638651183,
        0.04717533638651183
      ],
      [
        0.2325515532308739,
        0.22628318026289723,
        0.22628318026289723,
        0.2078160475368885,
        0.2078160475368885,
        0.17814598076194574,
        0.17814598076194574,
        0.13887351021978725,
        0.13887351021978725,
        0.09212149983772845,
        0.09212149983772845,
        0.04048400476531588,
        0.04048400476531588
      ],
      [
        0.2152638534631578,
        0.2152638534631578,
        0.2051984637212956,
        0.2051984637212956,
        0.18553839747793782,
        0.18553839747793782,
        0.15720316715819355,
        0.15720316715819355,
        0.12151857068790319,
        0.12151857068790319,
        0.08015808715976021,
        0.08015808715976021,
        0.03511946033175186,
        0.03511946033175186
      ],
      [
        0.2025782419255613,
        0.19843148532711158,
        0.19843148532711158,
        0.1861610000155622,
        0.1861610000155622,
        0.16626920581699392,
        0.16626920581699392,
        0.13957067792615432,
        0.13957067792615432,
        0.10715922046717194,
        0.10715922046717194,
        0.07036604748810812,
        0.07036604748810812,
        0.03075324199611727,
        0.03075324199611727
      ],
      [
        0.1894506104550685,
        0.1894506104550685,
        0.18260341504492358,
        0.18260341504492358,
        0.16915651939500254,
        0.16915651939500254,
        0.14959598881657674,
        0.14959598881657674,
        0.12462897125553388,
        0.12462897125553388,
        0.09515851168249279,
        0.09515851168249279,
        0.062253523938647894,
        0.062253523938647894,
        0.027152459411754096,
        0.027152459411754096
      ],
      [
        0.17944647035620653,
        0.17656270536699264,
        0.17656270536699264,
        0.16800410215645004,
        0.16800410215645004,
        0.15404576107681028,
        0.15404576107681028,
        0.13513636846852548,
        0.13513636846852548,
        0.11188384719340397,
        0.11188384719340397,
        0.08503614831717918,
        0.08503614831717918,
        0.0554595293739872,
        0.0554595293739872,
        0.02414830286854793,
        0.02414830286854793
      ],
      [
        0.1691423829631436,
        0.1691423829631436,
        0.16427648374583273,
        0.16427648374583273,
        0.15468467512626524,
        0.15468467512626524,
        0.14064291467065065,
        0.14064291467065065,
        0.12255520671147846,
        0.12255520671147846,
        0.10094204410628717,
        0.10094204410628717,
        0.07642573025488905,
        0.07642573025488905,
        0.0497145488949698,
        0.0497145488949698,
        0.02161601352648331,
        0.02161601352648331
      ],
      [
        0.1610544498487837,
        0.15896884339395434,
        0.15896884339395434,
        0.15276604206585967,
        0.15276604206585967,
        0.1426067021736066,
        0.1426067021736066,
        0.12875396253933621,
        0.12875396253933621,
        0.11156664554733399,
        0.11156664554733399,
        0.09149002162245,
        0.09149002162245,
        0.06904454273764123,
        0.06904454273764123,
        0.0448142267656996,
        0.0448142267656996,
        0.019461788229726478,
        0.019461788229726478
      ],
      [
        0.15275338713072584,
        0.15275338713072584,
        0.14917298647260374,
        0.14917298647260374,
        0.14209610931838204,
        0.14209610931838204,
        0.13168863844917664,
        0.13168863844917664,
        0.11819453196151841,
        0.11819453196151841,
        0.10193011981724044,
        0.10193011981724044,
        0.08327674157670475,
        0.08327674157670475,
        0.06267204833410907,
        0.06267204833410907,
        0.04060142980038694,
        0.04060142980038694,
        0.017614007139152118,
        0.017614007139152118
      ],
      [
        0.14608113364969041,
        0.14452440398997005,
        0.14452440398997005,
        0.13988739479107315,
        0.13988739479107315,
        0.13226893863333747,
        0.13226893863333747,
        0.12183141605372853,
        0.12183141605372853,
        0.10879729916714838,
        0.10879729916714838,
        0.09344442345603386,
        0.09344442345603386,
        0.0761001136283793,
        0.0761001136283793,
        0.057134425426857205,
        0.057134425426857205,
        0.036953789770852494,
        0.036953789770852494,
        0.016017228257774335,
        0.016017228257774335
      ],
      [
        0.13925187285563198,
        0.13925187285563198,
        0.13654149834601517,
        0.13654149834601517,
        0.13117350478706238,
        0.13117350478706238,
        0.12325237681051242,
        0.12325237681051242,
        0.11293229608053922,
        0.11293229608053922,
        0.10041414444288096,
        0.10041414444288096,
        0.08594160621706773,
        0.08594160621706773,
        0.06979646842452049,
        0.06979646842452049,
        0.052293335152683286,
        0.052293335152683286,
        0.03377490158481415,
        0.03377490158481415,
        0.0146279952982722,
        0.0146279952982722
      ],
      [
        0.13365457218610619,
        0.1324620394046966,
        0.1324620394046966,
        0.12890572218808216,
        0.12890572218808216,
        0.12304908430672953,
        0.12304908430672953,
        0.11499664022241136,
        0.11499664022241136,
        0.10489209146454141,
        0.10489209146454141,
        0.09291576606003515,
        0.09291576606003515,
        0.07928141177671895,
        0.07928141177671895,
        0.06423242140852585,
        0.06423242140852585,
        0.04803767173108467,
        0.04803767173108467,
        0.030988005856979445,
        0.030988005856979445,
        0.013411859487141771,
        0.013411859487141771
      ],
      [
        0.12793819534675216,
        0.12793819534675216,
        0.1258374563468283,
        0.1258374563468283,
        0.12167047292780339,
        0.12167047292780339,
        0.1155056680537256,
        0.1155056680537256,
        0.10744427011596563,
        0.10744427011596563,
        0.09761865210411388,
        0.09761865210411388,
        0.08619016153195327,
        0.08619016153195327,
        0.0733464814110803,
        0.0733464814110803,
        0.05929858491543678,
        0.05929858491543678,
        0.04427743881741981,
        0.04427743881741981,
        0.028531388628933663,
        0.028531388628933663,
        0.0123412297999872,
        0.0123412297999872
      ]
    ], e.binomialCoefficients = [[1], [1, 1], [1, 2, 1], [1, 3, 3, 1]];
    const t = (d, f, g) => {
      let h, v;
      const S = g / 2;
      h = 0;
      for (let w = 0; w < 20; w++)
        v = S * e.tValues[20][w] + S, h += e.cValues[20][w] * o(d, f, v);
      return S * h;
    };
    e.getCubicArcLength = t;
    const r = (d, f, g) => {
      g === void 0 && (g = 1);
      const h = d[0] - 2 * d[1] + d[2], v = f[0] - 2 * f[1] + f[2], E = 2 * d[1] - 2 * d[0], S = 2 * f[1] - 2 * f[0], w = 4 * (h * h + v * v), T = 4 * (h * E + v * S), P = E * E + S * S;
      if (w === 0)
        return g * Math.sqrt(Math.pow(d[2] - d[0], 2) + Math.pow(f[2] - f[0], 2));
      const z = T / (2 * w), L = P / w, x = g + z, k = L - z * z, R = x * x + k > 0 ? Math.sqrt(x * x + k) : 0, B = z * z + k > 0 ? Math.sqrt(z * z + k) : 0, q = z + Math.sqrt(z * z + k) !== 0 ? k * Math.log(Math.abs((x + R) / (z + B))) : 0;
      return Math.sqrt(w) / 2 * (x * R - z * B + q);
    };
    e.getQuadraticArcLength = r;
    function o(d, f, g) {
      const h = l(1, g, d), v = l(1, g, f), E = h * h + v * v;
      return Math.sqrt(E);
    }
    const l = (d, f, g) => {
      const h = g.length - 1;
      let v, E;
      if (h === 0)
        return 0;
      if (d === 0) {
        E = 0;
        for (let S = 0; S <= h; S++)
          E += e.binomialCoefficients[h][S] * Math.pow(1 - f, h - S) * Math.pow(f, S) * g[S];
        return E;
      } else {
        v = new Array(h);
        for (let S = 0; S < h; S++)
          v[S] = h * (g[S + 1] - g[S]);
        return l(d - 1, f, v);
      }
    }, u = (d, f, g) => {
      let h = 1, v = d / f, E = (d - g(v)) / f, S = 0;
      for (; h > 1e-3; ) {
        const w = g(v + E), T = Math.abs(d - w) / f;
        if (T < h)
          h = T, v += E;
        else {
          const P = g(v - E), z = Math.abs(d - P) / f;
          z < h ? (h = z, v -= E) : E /= 2;
        }
        if (S++, S > 500)
          break;
      }
      return v;
    };
    e.t2length = u;
  })(By)), By;
}
var Q3;
function wb() {
  if (Q3) return lp;
  Q3 = 1, Object.defineProperty(lp, "__esModule", { value: !0 }), lp.Path = void 0;
  const e = On(), t = Rn(), r = ja(), o = uA();
  class l extends r.Shape {
    constructor(d) {
      super(d), this.dataArray = [], this.pathLength = 0, this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute();
      });
    }
    _readDataAttribute() {
      this.dataArray = l.parsePathData(this.data()), this.pathLength = l.getPathLength(this.dataArray);
    }
    _sceneFunc(d) {
      const f = this.dataArray;
      d.beginPath();
      let g = !1;
      for (let h = 0; h < f.length; h++) {
        const v = f[h].command, E = f[h].points;
        switch (v) {
          case "L":
            d.lineTo(E[0], E[1]);
            break;
          case "M":
            d.moveTo(E[0], E[1]);
            break;
          case "C":
            d.bezierCurveTo(E[0], E[1], E[2], E[3], E[4], E[5]);
            break;
          case "Q":
            d.quadraticCurveTo(E[0], E[1], E[2], E[3]);
            break;
          case "A":
            const S = E[0], w = E[1], T = E[2], P = E[3], z = E[4], L = E[5], x = E[6], k = E[7], R = T > P ? T : P, B = T > P ? 1 : T / P, q = T > P ? P / T : 1;
            d.translate(S, w), d.rotate(x), d.scale(B, q), d.arc(0, 0, R, z, z + L, 1 - k), d.scale(1 / B, 1 / q), d.rotate(-x), d.translate(-S, -w);
            break;
          case "z":
            g = !0, d.closePath();
            break;
        }
      }
      !g && !this.hasFill() ? d.strokeShape(this) : d.fillStrokeShape(this);
    }
    getSelfRect() {
      let d = [];
      this.dataArray.forEach(function(w) {
        if (w.command === "A") {
          const T = w.points[4], P = w.points[5], z = w.points[4] + P;
          let L = Math.PI / 180;
          if (Math.abs(T - z) < L && (L = Math.abs(T - z)), P < 0)
            for (let x = T - L; x > z; x -= L) {
              const k = l.getPointOnEllipticalArc(w.points[0], w.points[1], w.points[2], w.points[3], x, 0);
              d.push(k.x, k.y);
            }
          else
            for (let x = T + L; x < z; x += L) {
              const k = l.getPointOnEllipticalArc(w.points[0], w.points[1], w.points[2], w.points[3], x, 0);
              d.push(k.x, k.y);
            }
        } else if (w.command === "C")
          for (let T = 0; T <= 1; T += 0.01) {
            const P = l.getPointOnCubicBezier(T, w.start.x, w.start.y, w.points[0], w.points[1], w.points[2], w.points[3], w.points[4], w.points[5]);
            d.push(P.x, P.y);
          }
        else
          d = d.concat(w.points);
      });
      let f = d[0], g = d[0], h = d[1], v = d[1], E, S;
      for (let w = 0; w < d.length / 2; w++)
        E = d[w * 2], S = d[w * 2 + 1], isNaN(E) || (f = Math.min(f, E), g = Math.max(g, E)), isNaN(S) || (h = Math.min(h, S), v = Math.max(v, S));
      return {
        x: f,
        y: h,
        width: g - f,
        height: v - h
      };
    }
    getLength() {
      return this.pathLength;
    }
    getPointAtLength(d) {
      return l.getPointAtLengthOfDataArray(d, this.dataArray);
    }
    static getLineLength(d, f, g, h) {
      return Math.sqrt((g - d) * (g - d) + (h - f) * (h - f));
    }
    static getPathLength(d) {
      let f = 0;
      for (let g = 0; g < d.length; ++g)
        f += d[g].pathLength;
      return f;
    }
    static getPointAtLengthOfDataArray(d, f) {
      let g, h = 0, v = f.length;
      if (!v)
        return null;
      for (; h < v && d > f[h].pathLength; )
        d -= f[h].pathLength, ++h;
      if (h === v)
        return g = f[h - 1].points.slice(-2), {
          x: g[0],
          y: g[1]
        };
      if (d < 0.01)
        return f[h].command === "M" ? (g = f[h].points.slice(0, 2), {
          x: g[0],
          y: g[1]
        }) : {
          x: f[h].start.x,
          y: f[h].start.y
        };
      const E = f[h], S = E.points;
      switch (E.command) {
        case "L":
          return l.getPointOnLine(d, E.start.x, E.start.y, S[0], S[1]);
        case "C":
          return l.getPointOnCubicBezier((0, o.t2length)(d, l.getPathLength(f), (R) => (0, o.getCubicArcLength)([E.start.x, S[0], S[2], S[4]], [E.start.y, S[1], S[3], S[5]], R)), E.start.x, E.start.y, S[0], S[1], S[2], S[3], S[4], S[5]);
        case "Q":
          return l.getPointOnQuadraticBezier((0, o.t2length)(d, l.getPathLength(f), (R) => (0, o.getQuadraticArcLength)([E.start.x, S[0], S[2]], [E.start.y, S[1], S[3]], R)), E.start.x, E.start.y, S[0], S[1], S[2], S[3]);
        case "A":
          const w = S[0], T = S[1], P = S[2], z = S[3], L = S[5], x = S[6];
          let k = S[4];
          return k += L * d / E.pathLength, l.getPointOnEllipticalArc(w, T, P, z, k, x);
      }
      return null;
    }
    static getPointOnLine(d, f, g, h, v, E, S) {
      E = E ?? f, S = S ?? g;
      const w = this.getLineLength(f, g, h, v);
      if (w < 1e-10)
        return { x: f, y: g };
      if (h === f)
        return { x: E, y: S + (v > g ? d : -d) };
      const T = (v - g) / (h - f), P = Math.sqrt(d * d / (1 + T * T)) * (h < f ? -1 : 1), z = T * P;
      if (Math.abs(S - g - T * (E - f)) < 1e-10)
        return { x: E + P, y: S + z };
      const L = ((E - f) * (h - f) + (S - g) * (v - g)) / (w * w), x = f + L * (h - f), k = g + L * (v - g), R = this.getLineLength(E, S, x, k), B = Math.sqrt(d * d - R * R), q = Math.sqrt(B * B / (1 + T * T)) * (h < f ? -1 : 1), X = T * q;
      return { x: x + q, y: k + X };
    }
    static getPointOnCubicBezier(d, f, g, h, v, E, S, w, T) {
      function P(B) {
        return B * B * B;
      }
      function z(B) {
        return 3 * B * B * (1 - B);
      }
      function L(B) {
        return 3 * B * (1 - B) * (1 - B);
      }
      function x(B) {
        return (1 - B) * (1 - B) * (1 - B);
      }
      const k = w * P(d) + E * z(d) + h * L(d) + f * x(d), R = T * P(d) + S * z(d) + v * L(d) + g * x(d);
      return { x: k, y: R };
    }
    static getPointOnQuadraticBezier(d, f, g, h, v, E, S) {
      function w(x) {
        return x * x;
      }
      function T(x) {
        return 2 * x * (1 - x);
      }
      function P(x) {
        return (1 - x) * (1 - x);
      }
      const z = E * w(d) + h * T(d) + f * P(d), L = S * w(d) + v * T(d) + g * P(d);
      return { x: z, y: L };
    }
    static getPointOnEllipticalArc(d, f, g, h, v, E) {
      const S = Math.cos(E), w = Math.sin(E), T = {
        x: g * Math.cos(v),
        y: h * Math.sin(v)
      };
      return {
        x: d + (T.x * S - T.y * w),
        y: f + (T.x * w + T.y * S)
      };
    }
    static parsePathData(d) {
      if (!d)
        return [];
      let f = d;
      const g = [
        "m",
        "M",
        "l",
        "L",
        "v",
        "V",
        "h",
        "H",
        "z",
        "Z",
        "c",
        "C",
        "q",
        "Q",
        "t",
        "T",
        "s",
        "S",
        "a",
        "A"
      ];
      f = f.replace(new RegExp(" ", "g"), ",");
      for (let z = 0; z < g.length; z++)
        f = f.replace(new RegExp(g[z], "g"), "|" + g[z]);
      const h = f.split("|"), v = [], E = [];
      let S = 0, w = 0;
      const T = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
      let P;
      for (let z = 1; z < h.length; z++) {
        let L = h[z], x = L.charAt(0);
        for (L = L.slice(1), E.length = 0; P = T.exec(L); )
          E.push(P[0]);
        const k = [];
        for (let R = 0, B = E.length; R < B; R++) {
          if (E[R] === "00") {
            k.push(0, 0);
            continue;
          }
          const q = parseFloat(E[R]);
          isNaN(q) ? k.push(0) : k.push(q);
        }
        for (; k.length > 0 && !isNaN(k[0]); ) {
          let R = "", B = [];
          const q = S, X = w;
          let I, U, F, Z, te, ie, ue, ce, ze, W;
          switch (x) {
            case "l":
              S += k.shift(), w += k.shift(), R = "L", B.push(S, w);
              break;
            case "L":
              S = k.shift(), w = k.shift(), B.push(S, w);
              break;
            case "m":
              const j = k.shift(), ee = k.shift();
              if (S += j, w += ee, R = "M", v.length > 2 && v[v.length - 1].command === "z") {
                for (let Q = v.length - 2; Q >= 0; Q--)
                  if (v[Q].command === "M") {
                    S = v[Q].points[0] + j, w = v[Q].points[1] + ee;
                    break;
                  }
              }
              B.push(S, w), x = "l";
              break;
            case "M":
              S = k.shift(), w = k.shift(), R = "M", B.push(S, w), x = "L";
              break;
            case "h":
              S += k.shift(), R = "L", B.push(S, w);
              break;
            case "H":
              S = k.shift(), R = "L", B.push(S, w);
              break;
            case "v":
              w += k.shift(), R = "L", B.push(S, w);
              break;
            case "V":
              w = k.shift(), R = "L", B.push(S, w);
              break;
            case "C":
              B.push(k.shift(), k.shift(), k.shift(), k.shift()), S = k.shift(), w = k.shift(), B.push(S, w);
              break;
            case "c":
              B.push(S + k.shift(), w + k.shift(), S + k.shift(), w + k.shift()), S += k.shift(), w += k.shift(), R = "C", B.push(S, w);
              break;
            case "S":
              U = S, F = w, I = v[v.length - 1], I.command === "C" && (U = S + (S - I.points[2]), F = w + (w - I.points[3])), B.push(U, F, k.shift(), k.shift()), S = k.shift(), w = k.shift(), R = "C", B.push(S, w);
              break;
            case "s":
              U = S, F = w, I = v[v.length - 1], I.command === "C" && (U = S + (S - I.points[2]), F = w + (w - I.points[3])), B.push(U, F, S + k.shift(), w + k.shift()), S += k.shift(), w += k.shift(), R = "C", B.push(S, w);
              break;
            case "Q":
              B.push(k.shift(), k.shift()), S = k.shift(), w = k.shift(), B.push(S, w);
              break;
            case "q":
              B.push(S + k.shift(), w + k.shift()), S += k.shift(), w += k.shift(), R = "Q", B.push(S, w);
              break;
            case "T":
              U = S, F = w, I = v[v.length - 1], I.command === "Q" && (U = S + (S - I.points[0]), F = w + (w - I.points[1])), S = k.shift(), w = k.shift(), R = "Q", B.push(U, F, S, w);
              break;
            case "t":
              U = S, F = w, I = v[v.length - 1], I.command === "Q" && (U = S + (S - I.points[0]), F = w + (w - I.points[1])), S += k.shift(), w += k.shift(), R = "Q", B.push(U, F, S, w);
              break;
            case "A":
              Z = k.shift(), te = k.shift(), ie = k.shift(), ue = k.shift(), ce = k.shift(), ze = S, W = w, S = k.shift(), w = k.shift(), R = "A", B = this.convertEndpointToCenterParameterization(ze, W, S, w, ue, ce, Z, te, ie);
              break;
            case "a":
              Z = k.shift(), te = k.shift(), ie = k.shift(), ue = k.shift(), ce = k.shift(), ze = S, W = w, S += k.shift(), w += k.shift(), R = "A", B = this.convertEndpointToCenterParameterization(ze, W, S, w, ue, ce, Z, te, ie);
              break;
          }
          v.push({
            command: R || x,
            points: B,
            start: {
              x: q,
              y: X
            },
            pathLength: this.calcLength(q, X, R || x, B)
          });
        }
        (x === "z" || x === "Z") && v.push({
          command: "z",
          points: [],
          start: void 0,
          pathLength: 0
        });
      }
      return v;
    }
    static calcLength(d, f, g, h) {
      let v, E, S, w;
      const T = l;
      switch (g) {
        case "L":
          return T.getLineLength(d, f, h[0], h[1]);
        case "C":
          return (0, o.getCubicArcLength)([d, h[0], h[2], h[4]], [f, h[1], h[3], h[5]], 1);
        case "Q":
          return (0, o.getQuadraticArcLength)([d, h[0], h[2]], [f, h[1], h[3]], 1);
        case "A":
          v = 0;
          const P = h[4], z = h[5], L = h[4] + z;
          let x = Math.PI / 180;
          if (Math.abs(P - L) < x && (x = Math.abs(P - L)), E = T.getPointOnEllipticalArc(h[0], h[1], h[2], h[3], P, 0), z < 0)
            for (w = P - x; w > L; w -= x)
              S = T.getPointOnEllipticalArc(h[0], h[1], h[2], h[3], w, 0), v += T.getLineLength(E.x, E.y, S.x, S.y), E = S;
          else
            for (w = P + x; w < L; w += x)
              S = T.getPointOnEllipticalArc(h[0], h[1], h[2], h[3], w, 0), v += T.getLineLength(E.x, E.y, S.x, S.y), E = S;
          return S = T.getPointOnEllipticalArc(h[0], h[1], h[2], h[3], L, 0), v += T.getLineLength(E.x, E.y, S.x, S.y), v;
      }
      return 0;
    }
    static convertEndpointToCenterParameterization(d, f, g, h, v, E, S, w, T) {
      const P = T * (Math.PI / 180), z = Math.cos(P) * (d - g) / 2 + Math.sin(P) * (f - h) / 2, L = -1 * Math.sin(P) * (d - g) / 2 + Math.cos(P) * (f - h) / 2, x = z * z / (S * S) + L * L / (w * w);
      x > 1 && (S *= Math.sqrt(x), w *= Math.sqrt(x));
      let k = Math.sqrt((S * S * (w * w) - S * S * (L * L) - w * w * (z * z)) / (S * S * (L * L) + w * w * (z * z)));
      v === E && (k *= -1), isNaN(k) && (k = 0);
      const R = k * S * L / w, B = k * -w * z / S, q = (d + g) / 2 + Math.cos(P) * R - Math.sin(P) * B, X = (f + h) / 2 + Math.sin(P) * R + Math.cos(P) * B, I = function(ce) {
        return Math.sqrt(ce[0] * ce[0] + ce[1] * ce[1]);
      }, U = function(ce, ze) {
        return (ce[0] * ze[0] + ce[1] * ze[1]) / (I(ce) * I(ze));
      }, F = function(ce, ze) {
        return (ce[0] * ze[1] < ce[1] * ze[0] ? -1 : 1) * Math.acos(U(ce, ze));
      }, Z = F([1, 0], [(z - R) / S, (L - B) / w]), te = [(z - R) / S, (L - B) / w], ie = [(-1 * z - R) / S, (-1 * L - B) / w];
      let ue = F(te, ie);
      return U(te, ie) <= -1 && (ue = Math.PI), U(te, ie) >= 1 && (ue = 0), E === 0 && ue > 0 && (ue = ue - 2 * Math.PI), E === 1 && ue < 0 && (ue = ue + 2 * Math.PI), [q, X, S, w, Z, ue, P, E];
    }
  }
  return lp.Path = l, l.prototype.className = "Path", l.prototype._attrsAffectingSize = ["data"], (0, t._registerNode)(l), e.Factory.addGetterSetter(l, "data"), lp;
}
var J3;
function cA() {
  if (J3) return op;
  J3 = 1, Object.defineProperty(op, "__esModule", { value: !0 }), op.Arrow = void 0;
  const e = On(), t = z6(), r = Vn(), o = Rn(), l = wb();
  class u extends t.Line {
    _sceneFunc(f) {
      super._sceneFunc(f);
      const g = Math.PI * 2, h = this.points();
      let v = h;
      const E = this.tension() !== 0 && h.length > 4;
      E && (v = this.getTensionPoints());
      const S = this.pointerLength(), w = h.length;
      let T, P;
      if (E) {
        const x = [
          v[v.length - 4],
          v[v.length - 3],
          v[v.length - 2],
          v[v.length - 1],
          h[w - 2],
          h[w - 1]
        ], k = l.Path.calcLength(v[v.length - 4], v[v.length - 3], "C", x), R = l.Path.getPointOnQuadraticBezier(Math.min(1, 1 - S / k), x[0], x[1], x[2], x[3], x[4], x[5]);
        T = h[w - 2] - R.x, P = h[w - 1] - R.y;
      } else
        T = h[w - 2] - h[w - 4], P = h[w - 1] - h[w - 3];
      const z = (Math.atan2(P, T) + g) % g, L = this.pointerWidth();
      this.pointerAtEnding() && (f.save(), f.beginPath(), f.translate(h[w - 2], h[w - 1]), f.rotate(z), f.moveTo(0, 0), f.lineTo(-S, L / 2), f.lineTo(-S, -L / 2), f.closePath(), f.restore(), this.__fillStroke(f)), this.pointerAtBeginning() && (f.save(), f.beginPath(), f.translate(h[0], h[1]), E ? (T = (v[0] + v[2]) / 2 - h[0], P = (v[1] + v[3]) / 2 - h[1]) : (T = h[2] - h[0], P = h[3] - h[1]), f.rotate((Math.atan2(-P, -T) + g) % g), f.moveTo(0, 0), f.lineTo(-S, L / 2), f.lineTo(-S, -L / 2), f.closePath(), f.restore(), this.__fillStroke(f));
    }
    __fillStroke(f) {
      const g = this.dashEnabled();
      g && (this.attrs.dashEnabled = !1, f.setLineDash([])), f.fillStrokeShape(this), g && (this.attrs.dashEnabled = !0);
    }
    getSelfRect() {
      const f = super.getSelfRect(), g = this.pointerWidth() / 2;
      return {
        x: f.x,
        y: f.y - g,
        width: f.width,
        height: f.height + g * 2
      };
    }
  }
  return op.Arrow = u, u.prototype.className = "Arrow", (0, o._registerNode)(u), e.Factory.addGetterSetter(u, "pointerLength", 10, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(u, "pointerWidth", 10, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(u, "pointerAtBeginning", !1), e.Factory.addGetterSetter(u, "pointerAtEnding", !0), op;
}
var up = {}, $3;
function dA() {
  if ($3) return up;
  $3 = 1, Object.defineProperty(up, "__esModule", { value: !0 }), up.Circle = void 0;
  const e = On(), t = ja(), r = Vn(), o = Rn();
  class l extends t.Shape {
    _sceneFunc(d) {
      d.beginPath(), d.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), d.closePath(), d.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(d) {
      this.radius() !== d / 2 && this.radius(d / 2);
    }
    setHeight(d) {
      this.radius() !== d / 2 && this.radius(d / 2);
    }
  }
  return up.Circle = l, l.prototype._centroid = !0, l.prototype.className = "Circle", l.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(l), e.Factory.addGetterSetter(l, "radius", 0, (0, r.getNumberValidator)()), up;
}
var cp = {}, e4;
function fA() {
  if (e4) return cp;
  e4 = 1, Object.defineProperty(cp, "__esModule", { value: !0 }), cp.Ellipse = void 0;
  const e = On(), t = ja(), r = Vn(), o = Rn();
  let l = class extends t.Shape {
    _sceneFunc(d) {
      const f = this.radiusX(), g = this.radiusY();
      d.beginPath(), d.save(), f !== g && d.scale(1, g / f), d.arc(0, 0, f, 0, Math.PI * 2, !1), d.restore(), d.closePath(), d.fillStrokeShape(this);
    }
    getWidth() {
      return this.radiusX() * 2;
    }
    getHeight() {
      return this.radiusY() * 2;
    }
    setWidth(d) {
      this.radiusX(d / 2);
    }
    setHeight(d) {
      this.radiusY(d / 2);
    }
  };
  return cp.Ellipse = l, l.prototype.className = "Ellipse", l.prototype._centroid = !0, l.prototype._attrsAffectingSize = ["radiusX", "radiusY"], (0, o._registerNode)(l), e.Factory.addComponentsGetterSetter(l, "radius", ["x", "y"]), e.Factory.addGetterSetter(l, "radiusX", 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(l, "radiusY", 0, (0, r.getNumberValidator)()), cp;
}
var dp = {}, t4;
function hA() {
  if (t4) return dp;
  t4 = 1, Object.defineProperty(dp, "__esModule", { value: !0 }), dp.Image = void 0;
  const e = jr(), t = On(), r = ja(), o = Rn(), l = Vn();
  class u extends r.Shape {
    constructor(f) {
      super(f), this._loadListener = () => {
        this._requestDraw();
      }, this.on("imageChange.konva", (g) => {
        this._removeImageLoad(g.oldVal), this._setImageLoad();
      }), this._setImageLoad();
    }
    _setImageLoad() {
      const f = this.image();
      f && f.complete || f && f.readyState === 4 || f && f.addEventListener && f.addEventListener("load", this._loadListener);
    }
    _removeImageLoad(f) {
      f && f.removeEventListener && f.removeEventListener("load", this._loadListener);
    }
    destroy() {
      return this._removeImageLoad(this.image()), super.destroy(), this;
    }
    _useBufferCanvas() {
      const f = !!this.cornerRadius(), g = this.hasShadow();
      return f && g ? !0 : super._useBufferCanvas(!0);
    }
    _sceneFunc(f) {
      const g = this.getWidth(), h = this.getHeight(), v = this.cornerRadius(), E = this.attrs.image;
      let S;
      if (E) {
        const w = this.attrs.cropWidth, T = this.attrs.cropHeight;
        w && T ? S = [
          E,
          this.cropX(),
          this.cropY(),
          w,
          T,
          0,
          0,
          g,
          h
        ] : S = [E, 0, 0, g, h];
      }
      (this.hasFill() || this.hasStroke() || v) && (f.beginPath(), v ? e.Util.drawRoundedRectPath(f, g, h, v) : f.rect(0, 0, g, h), f.closePath(), f.fillStrokeShape(this)), E && (v && f.clip(), f.drawImage.apply(f, S));
    }
    _hitFunc(f) {
      const g = this.width(), h = this.height(), v = this.cornerRadius();
      f.beginPath(), v ? e.Util.drawRoundedRectPath(f, g, h, v) : f.rect(0, 0, g, h), f.closePath(), f.fillStrokeShape(this);
    }
    getWidth() {
      var f, g;
      return (f = this.attrs.width) !== null && f !== void 0 ? f : (g = this.image()) === null || g === void 0 ? void 0 : g.width;
    }
    getHeight() {
      var f, g;
      return (f = this.attrs.height) !== null && f !== void 0 ? f : (g = this.image()) === null || g === void 0 ? void 0 : g.height;
    }
    static fromURL(f, g, h = null) {
      const v = e.Util.createImageElement();
      v.onload = function() {
        const E = new u({
          image: v
        });
        g(E);
      }, v.onerror = h, v.crossOrigin = "Anonymous", v.src = f;
    }
  }
  return dp.Image = u, u.prototype.className = "Image", (0, o._registerNode)(u), t.Factory.addGetterSetter(u, "cornerRadius", 0, (0, l.getNumberOrArrayOfNumbersValidator)(4)), t.Factory.addGetterSetter(u, "image"), t.Factory.addComponentsGetterSetter(u, "crop", ["x", "y", "width", "height"]), t.Factory.addGetterSetter(u, "cropX", 0, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(u, "cropY", 0, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(u, "cropWidth", 0, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(u, "cropHeight", 0, (0, l.getNumberValidator)()), dp;
}
var Vc = {}, n4;
function pA() {
  if (n4) return Vc;
  n4 = 1, Object.defineProperty(Vc, "__esModule", { value: !0 }), Vc.Tag = Vc.Label = void 0;
  const e = On(), t = ja(), r = _b(), o = Vn(), l = Rn(), u = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
  ], d = "Change.konva", f = "none", g = "up", h = "right", v = "down", E = "left", S = u.length;
  let w = class extends r.Group {
    constructor(z) {
      super(z), this.on("add.konva", function(L) {
        this._addListeners(L.child), this._sync();
      });
    }
    getText() {
      return this.find("Text")[0];
    }
    getTag() {
      return this.find("Tag")[0];
    }
    _addListeners(z) {
      let L = this, x;
      const k = function() {
        L._sync();
      };
      for (x = 0; x < S; x++)
        z.on(u[x] + d, k);
    }
    getWidth() {
      return this.getText().width();
    }
    getHeight() {
      return this.getText().height();
    }
    _sync() {
      let z = this.getText(), L = this.getTag(), x, k, R, B, q, X, I;
      if (z && L) {
        switch (x = z.width(), k = z.height(), R = L.pointerDirection(), B = L.pointerWidth(), I = L.pointerHeight(), q = 0, X = 0, R) {
          case g:
            q = x / 2, X = -1 * I;
            break;
          case h:
            q = x + B, X = k / 2;
            break;
          case v:
            q = x / 2, X = k + I;
            break;
          case E:
            q = -1 * B, X = k / 2;
            break;
        }
        L.setAttrs({
          x: -1 * q,
          y: -1 * X,
          width: x,
          height: k
        }), z.setAttrs({
          x: -1 * q,
          y: -1 * X
        });
      }
    }
  };
  Vc.Label = w, w.prototype.className = "Label", (0, l._registerNode)(w);
  class T extends t.Shape {
    _sceneFunc(z) {
      const L = this.width(), x = this.height(), k = this.pointerDirection(), R = this.pointerWidth(), B = this.pointerHeight(), q = this.cornerRadius();
      let X = 0, I = 0, U = 0, F = 0;
      typeof q == "number" ? X = I = U = F = Math.min(q, L / 2, x / 2) : (X = Math.min(q[0] || 0, L / 2, x / 2), I = Math.min(q[1] || 0, L / 2, x / 2), F = Math.min(q[2] || 0, L / 2, x / 2), U = Math.min(q[3] || 0, L / 2, x / 2)), z.beginPath(), z.moveTo(X, 0), k === g && (z.lineTo((L - R) / 2, 0), z.lineTo(L / 2, -1 * B), z.lineTo((L + R) / 2, 0)), z.lineTo(L - I, 0), z.arc(L - I, I, I, Math.PI * 3 / 2, 0, !1), k === h && (z.lineTo(L, (x - B) / 2), z.lineTo(L + R, x / 2), z.lineTo(L, (x + B) / 2)), z.lineTo(L, x - F), z.arc(L - F, x - F, F, 0, Math.PI / 2, !1), k === v && (z.lineTo((L + R) / 2, x), z.lineTo(L / 2, x + B), z.lineTo((L - R) / 2, x)), z.lineTo(U, x), z.arc(U, x - U, U, Math.PI / 2, Math.PI, !1), k === E && (z.lineTo(0, (x + B) / 2), z.lineTo(-1 * R, x / 2), z.lineTo(0, (x - B) / 2)), z.lineTo(0, X), z.arc(X, X, X, Math.PI, Math.PI * 3 / 2, !1), z.closePath(), z.fillStrokeShape(this);
    }
    getSelfRect() {
      let z = 0, L = 0, x = this.pointerWidth(), k = this.pointerHeight(), R = this.pointerDirection(), B = this.width(), q = this.height();
      return R === g ? (L -= k, q += k) : R === v ? q += k : R === E ? (z -= x * 1.5, B += x) : R === h && (B += x * 1.5), {
        x: z,
        y: L,
        width: B,
        height: q
      };
    }
  }
  return Vc.Tag = T, T.prototype.className = "Tag", (0, l._registerNode)(T), e.Factory.addGetterSetter(T, "pointerDirection", f), e.Factory.addGetterSetter(T, "pointerWidth", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(T, "pointerHeight", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(T, "cornerRadius", 0, (0, o.getNumberOrArrayOfNumbersValidator)(4)), Vc;
}
var fp = {}, r4;
function B6() {
  if (r4) return fp;
  r4 = 1, Object.defineProperty(fp, "__esModule", { value: !0 }), fp.Rect = void 0;
  const e = On(), t = ja(), r = Rn(), o = jr(), l = Vn();
  class u extends t.Shape {
    _sceneFunc(f) {
      const g = this.cornerRadius(), h = this.width(), v = this.height();
      f.beginPath(), g ? o.Util.drawRoundedRectPath(f, h, v, g) : f.rect(0, 0, h, v), f.closePath(), f.fillStrokeShape(this);
    }
  }
  return fp.Rect = u, u.prototype.className = "Rect", (0, r._registerNode)(u), e.Factory.addGetterSetter(u, "cornerRadius", 0, (0, l.getNumberOrArrayOfNumbersValidator)(4)), fp;
}
var hp = {}, a4;
function mA() {
  if (a4) return hp;
  a4 = 1, Object.defineProperty(hp, "__esModule", { value: !0 }), hp.RegularPolygon = void 0;
  const e = On(), t = ja(), r = Vn(), o = Rn();
  let l = class extends t.Shape {
    _sceneFunc(d) {
      const f = this._getPoints();
      d.beginPath(), d.moveTo(f[0].x, f[0].y);
      for (let g = 1; g < f.length; g++)
        d.lineTo(f[g].x, f[g].y);
      d.closePath(), d.fillStrokeShape(this);
    }
    _getPoints() {
      const d = this.attrs.sides, f = this.attrs.radius || 0, g = [];
      for (let h = 0; h < d; h++)
        g.push({
          x: f * Math.sin(h * 2 * Math.PI / d),
          y: -1 * f * Math.cos(h * 2 * Math.PI / d)
        });
      return g;
    }
    getSelfRect() {
      const d = this._getPoints();
      let f = d[0].x, g = d[0].y, h = d[0].x, v = d[0].y;
      return d.forEach((E) => {
        f = Math.min(f, E.x), g = Math.max(g, E.x), h = Math.min(h, E.y), v = Math.max(v, E.y);
      }), {
        x: f,
        y: h,
        width: g - f,
        height: v - h
      };
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(d) {
      this.radius(d / 2);
    }
    setHeight(d) {
      this.radius(d / 2);
    }
  };
  return hp.RegularPolygon = l, l.prototype.className = "RegularPolygon", l.prototype._centroid = !0, l.prototype._attrsAffectingSize = ["radius"], (0, o._registerNode)(l), e.Factory.addGetterSetter(l, "radius", 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(l, "sides", 0, (0, r.getNumberValidator)()), hp;
}
var pp = {}, i4;
function gA() {
  if (i4) return pp;
  i4 = 1, Object.defineProperty(pp, "__esModule", { value: !0 }), pp.Ring = void 0;
  const e = On(), t = ja(), r = Vn(), o = Rn(), l = Math.PI * 2;
  let u = class extends t.Shape {
    _sceneFunc(f) {
      f.beginPath(), f.arc(0, 0, this.innerRadius(), 0, l, !1), f.moveTo(this.outerRadius(), 0), f.arc(0, 0, this.outerRadius(), l, 0, !0), f.closePath(), f.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(f) {
      this.outerRadius(f / 2);
    }
    setHeight(f) {
      this.outerRadius(f / 2);
    }
  };
  return pp.Ring = u, u.prototype.className = "Ring", u.prototype._centroid = !0, u.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(u), e.Factory.addGetterSetter(u, "innerRadius", 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(u, "outerRadius", 0, (0, r.getNumberValidator)()), pp;
}
var mp = {}, o4;
function vA() {
  if (o4) return mp;
  o4 = 1, Object.defineProperty(mp, "__esModule", { value: !0 }), mp.Sprite = void 0;
  const e = On(), t = ja(), r = Sb(), o = Vn(), l = Rn();
  let u = class extends t.Shape {
    constructor(f) {
      super(f), this._updated = !0, this.anim = new r.Animation(() => {
        const g = this._updated;
        return this._updated = !1, g;
      }), this.on("animationChange.konva", function() {
        this.frameIndex(0);
      }), this.on("frameIndexChange.konva", function() {
        this._updated = !0;
      }), this.on("frameRateChange.konva", function() {
        this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
      });
    }
    _sceneFunc(f) {
      const g = this.animation(), h = this.frameIndex(), v = h * 4, E = this.animations()[g], S = this.frameOffsets(), w = E[v + 0], T = E[v + 1], P = E[v + 2], z = E[v + 3], L = this.image();
      if ((this.hasFill() || this.hasStroke()) && (f.beginPath(), f.rect(0, 0, P, z), f.closePath(), f.fillStrokeShape(this)), L)
        if (S) {
          const x = S[g], k = h * 2;
          f.drawImage(L, w, T, P, z, x[k + 0], x[k + 1], P, z);
        } else
          f.drawImage(L, w, T, P, z, 0, 0, P, z);
    }
    _hitFunc(f) {
      const g = this.animation(), h = this.frameIndex(), v = h * 4, E = this.animations()[g], S = this.frameOffsets(), w = E[v + 2], T = E[v + 3];
      if (f.beginPath(), S) {
        const P = S[g], z = h * 2;
        f.rect(P[z + 0], P[z + 1], w, T);
      } else
        f.rect(0, 0, w, T);
      f.closePath(), f.fillShape(this);
    }
    _useBufferCanvas() {
      return super._useBufferCanvas(!0);
    }
    _setInterval() {
      const f = this;
      this.interval = setInterval(function() {
        f._updateIndex();
      }, 1e3 / this.frameRate());
    }
    start() {
      if (this.isRunning())
        return;
      const f = this.getLayer();
      this.anim.setLayers(f), this._setInterval(), this.anim.start();
    }
    stop() {
      this.anim.stop(), clearInterval(this.interval);
    }
    isRunning() {
      return this.anim.isRunning();
    }
    _updateIndex() {
      const f = this.frameIndex(), g = this.animation(), h = this.animations(), v = h[g], E = v.length / 4;
      f < E - 1 ? this.frameIndex(f + 1) : this.frameIndex(0);
    }
  };
  return mp.Sprite = u, u.prototype.className = "Sprite", (0, l._registerNode)(u), e.Factory.addGetterSetter(u, "animation"), e.Factory.addGetterSetter(u, "animations"), e.Factory.addGetterSetter(u, "frameOffsets"), e.Factory.addGetterSetter(u, "image"), e.Factory.addGetterSetter(u, "frameIndex", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "frameRate", 17, (0, o.getNumberValidator)()), e.Factory.backCompat(u, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
  }), mp;
}
var gp = {}, s4;
function yA() {
  if (s4) return gp;
  s4 = 1, Object.defineProperty(gp, "__esModule", { value: !0 }), gp.Star = void 0;
  const e = On(), t = ja(), r = Vn(), o = Rn();
  let l = class extends t.Shape {
    _sceneFunc(d) {
      const f = this.innerRadius(), g = this.outerRadius(), h = this.numPoints();
      d.beginPath(), d.moveTo(0, 0 - g);
      for (let v = 1; v < h * 2; v++) {
        const E = v % 2 === 0 ? g : f, S = E * Math.sin(v * Math.PI / h), w = -1 * E * Math.cos(v * Math.PI / h);
        d.lineTo(S, w);
      }
      d.closePath(), d.fillStrokeShape(this);
    }
    getWidth() {
      return this.outerRadius() * 2;
    }
    getHeight() {
      return this.outerRadius() * 2;
    }
    setWidth(d) {
      this.outerRadius(d / 2);
    }
    setHeight(d) {
      this.outerRadius(d / 2);
    }
  };
  return gp.Star = l, l.prototype.className = "Star", l.prototype._centroid = !0, l.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"], (0, o._registerNode)(l), e.Factory.addGetterSetter(l, "numPoints", 5, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(l, "innerRadius", 0, (0, r.getNumberValidator)()), e.Factory.addGetterSetter(l, "outerRadius", 0, (0, r.getNumberValidator)()), gp;
}
var wf = {}, l4;
function U6() {
  if (l4) return wf;
  l4 = 1, Object.defineProperty(wf, "__esModule", { value: !0 }), wf.Text = void 0, wf.stringToArray = d;
  const e = jr(), t = On(), r = ja(), o = Rn(), l = Vn(), u = Rn();
  function d(ye) {
    return [...ye].reduce((pe, Me, We, Ee) => {
      if (new RegExp("\\p{Emoji}", "u").test(Me)) {
        const ae = Ee[We + 1];
        ae && new RegExp("\\p{Emoji_Modifier}|\\u200D", "u").test(ae) ? (pe.push(Me + ae), Ee[We + 1] = "") : pe.push(Me);
      } else new RegExp("\\p{Regional_Indicator}{2}", "u").test(Me + (Ee[We + 1] || "")) ? pe.push(Me + Ee[We + 1]) : We > 0 && new RegExp("\\p{Mn}|\\p{Me}|\\p{Mc}", "u").test(Me) ? pe[pe.length - 1] += Me : Me && pe.push(Me);
      return pe;
    }, []);
  }
  const f = "auto", g = "center", h = "inherit", v = "justify", E = "Change.konva", S = "2d", w = "-", T = "left", P = "text", z = "Text", L = "top", x = "bottom", k = "middle", R = "normal", B = "px ", q = " ", X = "right", I = "rtl", U = "word", F = "char", Z = "none", te = "…", ie = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
  ], ue = ie.length;
  function ce(ye) {
    return ye.split(",").map((pe) => {
      pe = pe.trim();
      const Me = pe.indexOf(" ") >= 0, We = pe.indexOf('"') >= 0 || pe.indexOf("'") >= 0;
      return Me && !We && (pe = `"${pe}"`), pe;
    }).join(", ");
  }
  let ze;
  function W() {
    return ze || (ze = e.Util.createCanvasElement().getContext(S), ze);
  }
  function j(ye) {
    ye.fillText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function ee(ye) {
    ye.setAttr("miterLimit", 2), ye.strokeText(this._partialText, this._partialTextX, this._partialTextY);
  }
  function Q(ye) {
    return ye = ye || {}, !ye.fillLinearGradientColorStops && !ye.fillRadialGradientColorStops && !ye.fillPatternImage && (ye.fill = ye.fill || "black"), ye;
  }
  class oe extends r.Shape {
    constructor(pe) {
      super(Q(pe)), this._partialTextX = 0, this._partialTextY = 0;
      for (let Me = 0; Me < ue; Me++)
        this.on(ie[Me] + E, this._setTextData);
      this._setTextData();
    }
    _sceneFunc(pe) {
      const Me = this.textArr, We = Me.length;
      if (!this.text())
        return;
      let Ee = this.padding(), ae = this.fontSize(), Re = this.lineHeight() * ae, Qe = this.verticalAlign(), Pe = this.direction(), rt = 0, st = this.align(), bt = this.getWidth(), Xt = this.letterSpacing(), Lt = this.fill(), qn = this.textDecoration(), Wt = qn.indexOf("underline") !== -1, bn = qn.indexOf("line-through") !== -1, Yr;
      Pe = Pe === h ? pe.direction : Pe;
      let Pn = Re / 2, gn = k;
      if (o.Konva._fixTextRendering) {
        const vn = this.measureSize("M");
        gn = "alphabetic", Pn = (vn.fontBoundingBoxAscent - vn.fontBoundingBoxDescent) / 2 + Re / 2;
      }
      for (Pe === I && pe.setAttr("direction", Pe), pe.setAttr("font", this._getContextFont()), pe.setAttr("textBaseline", gn), pe.setAttr("textAlign", T), Qe === k ? rt = (this.getHeight() - We * Re - Ee * 2) / 2 : Qe === x && (rt = this.getHeight() - We * Re - Ee * 2), pe.translate(Ee, rt + Ee), Yr = 0; Yr < We; Yr++) {
        let vn = 0, ir = 0;
        const cr = Me[Yr], er = cr.text, ln = cr.width, dr = cr.lastInParagraph;
        if (pe.save(), st === X ? vn += bt - ln - Ee * 2 : st === g && (vn += (bt - ln - Ee * 2) / 2), Wt) {
          pe.save(), pe.beginPath();
          const kn = o.Konva._fixTextRendering ? Math.round(ae / 4) : Math.round(ae / 2), tr = vn, ot = Pn + ir + kn;
          pe.moveTo(tr, ot);
          const Tt = st === v && !dr ? bt - Ee * 2 : ln;
          pe.lineTo(tr + Math.round(Tt), ot), pe.lineWidth = ae / 15;
          const Ut = this._getLinearGradient();
          pe.strokeStyle = Ut || Lt, pe.stroke(), pe.restore();
        }
        if (bn) {
          pe.save(), pe.beginPath();
          const kn = o.Konva._fixTextRendering ? -Math.round(ae / 4) : 0;
          pe.moveTo(vn, Pn + ir + kn);
          const tr = st === v && !dr ? bt - Ee * 2 : ln;
          pe.lineTo(vn + Math.round(tr), Pn + ir + kn), pe.lineWidth = ae / 15;
          const ot = this._getLinearGradient();
          pe.strokeStyle = ot || Lt, pe.stroke(), pe.restore();
        }
        if (Pe !== I && (Xt !== 0 || st === v)) {
          const kn = er.split(" ").length - 1, tr = d(er);
          for (let ot = 0; ot < tr.length; ot++) {
            const Tt = tr[ot];
            Tt === " " && !dr && st === v && (vn += (bt - Ee * 2 - ln) / kn), this._partialTextX = vn, this._partialTextY = Pn + ir, this._partialText = Tt, pe.fillStrokeShape(this), vn += this.measureSize(Tt).width + Xt;
          }
        } else
          Xt !== 0 && pe.setAttr("letterSpacing", `${Xt}px`), this._partialTextX = vn, this._partialTextY = Pn + ir, this._partialText = er, pe.fillStrokeShape(this);
        pe.restore(), We > 1 && (Pn += Re);
      }
    }
    _hitFunc(pe) {
      const Me = this.getWidth(), We = this.getHeight();
      pe.beginPath(), pe.rect(0, 0, Me, We), pe.closePath(), pe.fillStrokeShape(this);
    }
    setText(pe) {
      const Me = e.Util._isString(pe) ? pe : pe == null ? "" : pe + "";
      return this._setAttr(P, Me), this;
    }
    getWidth() {
      return this.attrs.width === f || this.attrs.width === void 0 ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
      return this.attrs.height === f || this.attrs.height === void 0 ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return e.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    measureSize(pe) {
      var Me, We, Ee, ae, Re, Qe, Pe, rt, st, bt, Xt;
      let Lt = W(), qn = this.fontSize(), Wt;
      Lt.save(), Lt.font = this._getContextFont(), Wt = Lt.measureText(pe), Lt.restore();
      const bn = qn / 100;
      return {
        actualBoundingBoxAscent: (Me = Wt.actualBoundingBoxAscent) !== null && Me !== void 0 ? Me : 71.58203125 * bn,
        actualBoundingBoxDescent: (We = Wt.actualBoundingBoxDescent) !== null && We !== void 0 ? We : 0,
        actualBoundingBoxLeft: (Ee = Wt.actualBoundingBoxLeft) !== null && Ee !== void 0 ? Ee : -7.421875 * bn,
        actualBoundingBoxRight: (ae = Wt.actualBoundingBoxRight) !== null && ae !== void 0 ? ae : 75.732421875 * bn,
        alphabeticBaseline: (Re = Wt.alphabeticBaseline) !== null && Re !== void 0 ? Re : 0,
        emHeightAscent: (Qe = Wt.emHeightAscent) !== null && Qe !== void 0 ? Qe : 100 * bn,
        emHeightDescent: (Pe = Wt.emHeightDescent) !== null && Pe !== void 0 ? Pe : -20 * bn,
        fontBoundingBoxAscent: (rt = Wt.fontBoundingBoxAscent) !== null && rt !== void 0 ? rt : 91 * bn,
        fontBoundingBoxDescent: (st = Wt.fontBoundingBoxDescent) !== null && st !== void 0 ? st : 21 * bn,
        hangingBaseline: (bt = Wt.hangingBaseline) !== null && bt !== void 0 ? bt : 72.80000305175781 * bn,
        ideographicBaseline: (Xt = Wt.ideographicBaseline) !== null && Xt !== void 0 ? Xt : -21 * bn,
        width: Wt.width,
        height: qn
      };
    }
    _getContextFont() {
      return this.fontStyle() + q + this.fontVariant() + q + (this.fontSize() + B) + ce(this.fontFamily());
    }
    _addTextLine(pe) {
      this.align() === v && (pe = pe.trim());
      const We = this._getTextWidth(pe);
      return this.textArr.push({
        text: pe,
        width: We,
        lastInParagraph: !1
      });
    }
    _getTextWidth(pe) {
      const Me = this.letterSpacing(), We = pe.length;
      return W().measureText(pe).width + Me * We;
    }
    _setTextData() {
      let pe = this.text().split(`
`), Me = +this.fontSize(), We = 0, Ee = this.lineHeight() * Me, ae = this.attrs.width, Re = this.attrs.height, Qe = ae !== f && ae !== void 0, Pe = Re !== f && Re !== void 0, rt = this.padding(), st = ae - rt * 2, bt = Re - rt * 2, Xt = 0, Lt = this.wrap(), qn = Lt !== Z, Wt = Lt !== F && qn, bn = this.ellipsis();
      this.textArr = [], W().font = this._getContextFont();
      const Yr = bn ? this._getTextWidth(te) : 0;
      for (let Pn = 0, gn = pe.length; Pn < gn; ++Pn) {
        let vn = pe[Pn], ir = this._getTextWidth(vn);
        if (Qe && ir > st)
          for (; vn.length > 0; ) {
            let cr = 0, er = d(vn).length, ln = "", dr = 0;
            for (; cr < er; ) {
              const kn = cr + er >>> 1, tr = d(vn), ot = tr.slice(0, kn + 1).join(""), Tt = this._getTextWidth(ot);
              (bn && Pe && Xt + Ee > bt ? Tt + Yr : Tt) <= st ? (cr = kn + 1, ln = ot, dr = Tt) : er = kn;
            }
            if (ln) {
              if (Wt) {
                const ot = d(vn), Tt = d(ln), Ut = ot[Tt.length], Ft = Ut === q || Ut === w;
                let Fn;
                if (Ft && dr <= st)
                  Fn = Tt.length;
                else {
                  const _n = Tt.lastIndexOf(q), qe = Tt.lastIndexOf(w);
                  Fn = Math.max(_n, qe) + 1;
                }
                Fn > 0 && (cr = Fn, ln = ot.slice(0, cr).join(""), dr = this._getTextWidth(ln));
              }
              if (ln = ln.trimRight(), this._addTextLine(ln), We = Math.max(We, dr), Xt += Ee, this._shouldHandleEllipsis(Xt)) {
                this._tryToAddEllipsisToLastLine();
                break;
              }
              if (vn = d(vn).slice(cr).join("").trimLeft(), vn.length > 0 && (ir = this._getTextWidth(vn), ir <= st)) {
                this._addTextLine(vn), Xt += Ee, We = Math.max(We, ir);
                break;
              }
            } else
              break;
          }
        else
          this._addTextLine(vn), Xt += Ee, We = Math.max(We, ir), this._shouldHandleEllipsis(Xt) && Pn < gn - 1 && this._tryToAddEllipsisToLastLine();
        if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), Pe && Xt + Ee > bt)
          break;
      }
      this.textHeight = Me, this.textWidth = We;
    }
    _shouldHandleEllipsis(pe) {
      const Me = +this.fontSize(), We = this.lineHeight() * Me, Ee = this.attrs.height, ae = Ee !== f && Ee !== void 0, Re = this.padding(), Qe = Ee - Re * 2;
      return !(this.wrap() !== Z) || ae && pe + We > Qe;
    }
    _tryToAddEllipsisToLastLine() {
      const pe = this.attrs.width, Me = pe !== f && pe !== void 0, We = this.padding(), Ee = pe - We * 2, ae = this.ellipsis(), Re = this.textArr[this.textArr.length - 1];
      !Re || !ae || (Me && (this._getTextWidth(Re.text + te) < Ee || (Re.text = Re.text.slice(0, Re.text.length - 3))), this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(Re.text + te));
    }
    getStrokeScaleEnabled() {
      return !0;
    }
    _useBufferCanvas() {
      const pe = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1, Me = this.hasShadow();
      return pe && Me ? !0 : super._useBufferCanvas();
    }
  }
  return wf.Text = oe, oe.prototype._fillFunc = j, oe.prototype._strokeFunc = ee, oe.prototype.className = z, oe.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
  ], (0, u._registerNode)(oe), t.Factory.overWriteSetter(oe, "width", (0, l.getNumberOrAutoValidator)()), t.Factory.overWriteSetter(oe, "height", (0, l.getNumberOrAutoValidator)()), t.Factory.addGetterSetter(oe, "direction", h), t.Factory.addGetterSetter(oe, "fontFamily", "Arial"), t.Factory.addGetterSetter(oe, "fontSize", 12, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(oe, "fontStyle", R), t.Factory.addGetterSetter(oe, "fontVariant", R), t.Factory.addGetterSetter(oe, "padding", 0, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(oe, "align", T), t.Factory.addGetterSetter(oe, "verticalAlign", L), t.Factory.addGetterSetter(oe, "lineHeight", 1, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(oe, "wrap", U), t.Factory.addGetterSetter(oe, "ellipsis", !1, (0, l.getBooleanValidator)()), t.Factory.addGetterSetter(oe, "letterSpacing", 0, (0, l.getNumberValidator)()), t.Factory.addGetterSetter(oe, "text", "", (0, l.getStringValidator)()), t.Factory.addGetterSetter(oe, "textDecoration", ""), wf;
}
var vp = {}, u4;
function bA() {
  if (u4) return vp;
  u4 = 1, Object.defineProperty(vp, "__esModule", { value: !0 }), vp.TextPath = void 0;
  const e = jr(), t = On(), r = ja(), o = wb(), l = U6(), u = Vn(), d = Rn(), f = "", g = "normal";
  function h(S) {
    S.fillText(this.partialText, 0, 0);
  }
  function v(S) {
    S.strokeText(this.partialText, 0, 0);
  }
  let E = class extends r.Shape {
    constructor(w) {
      super(w), this.dummyCanvas = e.Util.createCanvasElement(), this.dataArray = [], this._readDataAttribute(), this.on("dataChange.konva", function() {
        this._readDataAttribute(), this._setTextData();
      }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
    }
    _getTextPathLength() {
      return o.Path.getPathLength(this.dataArray);
    }
    _getPointAtLength(w) {
      if (!this.attrs.data)
        return null;
      const T = this.pathLength;
      return w - 1 > T ? null : o.Path.getPointAtLengthOfDataArray(w, this.dataArray);
    }
    _readDataAttribute() {
      this.dataArray = o.Path.parsePathData(this.attrs.data), this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(w) {
      w.setAttr("font", this._getContextFont()), w.setAttr("textBaseline", this.textBaseline()), w.setAttr("textAlign", "left"), w.save();
      const T = this.textDecoration(), P = this.fill(), z = this.fontSize(), L = this.glyphInfo;
      T === "underline" && w.beginPath();
      for (let x = 0; x < L.length; x++) {
        w.save();
        const k = L[x].p0;
        w.translate(k.x, k.y), w.rotate(L[x].rotation), this.partialText = L[x].text, w.fillStrokeShape(this), T === "underline" && (x === 0 && w.moveTo(0, z / 2 + 1), w.lineTo(z, z / 2 + 1)), w.restore();
      }
      T === "underline" && (w.strokeStyle = P, w.lineWidth = z / 20, w.stroke()), w.restore();
    }
    _hitFunc(w) {
      w.beginPath();
      const T = this.glyphInfo;
      if (T.length >= 1) {
        const P = T[0].p0;
        w.moveTo(P.x, P.y);
      }
      for (let P = 0; P < T.length; P++) {
        const z = T[P].p1;
        w.lineTo(z.x, z.y);
      }
      w.setAttr("lineWidth", this.fontSize()), w.setAttr("strokeStyle", this.colorKey), w.stroke();
    }
    getTextWidth() {
      return this.textWidth;
    }
    getTextHeight() {
      return e.Util.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
    }
    setText(w) {
      return l.Text.prototype.setText.call(this, w);
    }
    _getContextFont() {
      return l.Text.prototype._getContextFont.call(this);
    }
    _getTextSize(w) {
      const P = this.dummyCanvas.getContext("2d");
      P.save(), P.font = this._getContextFont();
      const z = P.measureText(w);
      return P.restore(), {
        width: z.width,
        height: parseInt(`${this.fontSize()}`, 10)
      };
    }
    _setTextData() {
      const { width: w, height: T } = this._getTextSize(this.attrs.text);
      if (this.textWidth = w, this.textHeight = T, this.glyphInfo = [], !this.attrs.data)
        return null;
      const P = this.letterSpacing(), z = this.align(), L = this.kerningFunc(), x = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * P, 0);
      let k = 0;
      z === "center" && (k = Math.max(0, this.pathLength / 2 - x / 2)), z === "right" && (k = Math.max(0, this.pathLength - x));
      const R = (0, l.stringToArray)(this.text());
      let B = k;
      for (let q = 0; q < R.length; q++) {
        const X = this._getPointAtLength(B);
        if (!X)
          return;
        let I = this._getTextSize(R[q]).width + P;
        if (R[q] === " " && z === "justify") {
          const ue = this.text().split(" ").length - 1;
          I += (this.pathLength - x) / ue;
        }
        const U = this._getPointAtLength(B + I);
        if (!U)
          return;
        const F = o.Path.getLineLength(X.x, X.y, U.x, U.y);
        let Z = 0;
        if (L)
          try {
            Z = L(R[q - 1], R[q]) * this.fontSize();
          } catch {
            Z = 0;
          }
        X.x += Z, U.x += Z, this.textWidth += Z;
        const te = o.Path.getPointOnLine(Z + F / 2, X.x, X.y, U.x, U.y), ie = Math.atan2(U.y - X.y, U.x - X.x);
        this.glyphInfo.push({
          transposeX: te.x,
          transposeY: te.y,
          text: R[q],
          rotation: ie,
          p0: X,
          p1: U
        }), B += I;
      }
    }
    getSelfRect() {
      if (!this.glyphInfo.length)
        return {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      const w = [];
      this.glyphInfo.forEach(function(B) {
        w.push(B.p0.x), w.push(B.p0.y), w.push(B.p1.x), w.push(B.p1.y);
      });
      let T = w[0] || 0, P = w[0] || 0, z = w[1] || 0, L = w[1] || 0, x, k;
      for (let B = 0; B < w.length / 2; B++)
        x = w[B * 2], k = w[B * 2 + 1], T = Math.min(T, x), P = Math.max(P, x), z = Math.min(z, k), L = Math.max(L, k);
      const R = this.fontSize();
      return {
        x: T - R / 2,
        y: z - R / 2,
        width: P - T + R,
        height: L - z + R
      };
    }
    destroy() {
      return e.Util.releaseCanvas(this.dummyCanvas), super.destroy();
    }
  };
  return vp.TextPath = E, E.prototype._fillFunc = h, E.prototype._strokeFunc = v, E.prototype._fillFuncHit = h, E.prototype._strokeFuncHit = v, E.prototype.className = "TextPath", E.prototype._attrsAffectingSize = ["text", "fontSize", "data"], (0, d._registerNode)(E), t.Factory.addGetterSetter(E, "data"), t.Factory.addGetterSetter(E, "fontFamily", "Arial"), t.Factory.addGetterSetter(E, "fontSize", 12, (0, u.getNumberValidator)()), t.Factory.addGetterSetter(E, "fontStyle", g), t.Factory.addGetterSetter(E, "align", "left"), t.Factory.addGetterSetter(E, "letterSpacing", 0, (0, u.getNumberValidator)()), t.Factory.addGetterSetter(E, "textBaseline", "middle"), t.Factory.addGetterSetter(E, "fontVariant", g), t.Factory.addGetterSetter(E, "text", f), t.Factory.addGetterSetter(E, "textDecoration", ""), t.Factory.addGetterSetter(E, "kerningFunc", void 0), vp;
}
var yp = {}, c4;
function _A() {
  if (c4) return yp;
  c4 = 1, Object.defineProperty(yp, "__esModule", { value: !0 }), yp.Transformer = void 0;
  const e = jr(), t = On(), r = ra(), o = ja(), l = B6(), u = _b(), d = Rn(), f = Vn(), g = Rn(), h = "tr-konva", v = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
  ].map((I) => I + `.${h}`).join(" "), E = "nodesRect", S = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange"
  ], w = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
  }, T = "ontouchstart" in d.Konva._global;
  function P(I, U, F) {
    if (I === "rotater")
      return F;
    U += e.Util.degToRad(w[I] || 0);
    const Z = (e.Util.radToDeg(U) % 360 + 360) % 360;
    return e.Util._inRange(Z, 315 + 22.5, 360) || e.Util._inRange(Z, 0, 22.5) ? "ns-resize" : e.Util._inRange(Z, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : e.Util._inRange(Z, 90 - 22.5, 90 + 22.5) ? "ew-resize" : e.Util._inRange(Z, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : e.Util._inRange(Z, 180 - 22.5, 180 + 22.5) ? "ns-resize" : e.Util._inRange(Z, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : e.Util._inRange(Z, 270 - 22.5, 270 + 22.5) ? "ew-resize" : e.Util._inRange(Z, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (e.Util.error("Transformer has unknown angle for cursor detection: " + Z), "pointer");
  }
  const z = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
  ];
  function L(I) {
    return {
      x: I.x + I.width / 2 * Math.cos(I.rotation) + I.height / 2 * Math.sin(-I.rotation),
      y: I.y + I.height / 2 * Math.cos(I.rotation) + I.width / 2 * Math.sin(I.rotation)
    };
  }
  function x(I, U, F) {
    const Z = F.x + (I.x - F.x) * Math.cos(U) - (I.y - F.y) * Math.sin(U), te = F.y + (I.x - F.x) * Math.sin(U) + (I.y - F.y) * Math.cos(U);
    return {
      ...I,
      rotation: I.rotation + U,
      x: Z,
      y: te
    };
  }
  function k(I, U) {
    const F = L(I);
    return x(I, U, F);
  }
  function R(I, U, F) {
    let Z = U;
    for (let te = 0; te < I.length; te++) {
      const ie = d.Konva.getAngle(I[te]), ue = Math.abs(ie - U) % (Math.PI * 2);
      Math.min(ue, Math.PI * 2 - ue) < F && (Z = ie);
    }
    return Z;
  }
  let B = 0;
  class q extends u.Group {
    constructor(U) {
      super(U), this._movingAnchorName = null, this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(v, this.update), this.getNode() && this.update();
    }
    attachTo(U) {
      return this.setNode(U), this;
    }
    setNode(U) {
      return e.Util.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([U]);
    }
    getNode() {
      return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
      return h + this._id;
    }
    setNodes(U = []) {
      this._nodes && this._nodes.length && this.detach();
      const F = U.filter((te) => te.isAncestorOf(this) ? (e.Util.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
      return this._nodes = U = F, U.length === 1 && this.useSingleNodeRotation() ? this.rotation(U[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((te) => {
        const ie = () => {
          this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
        };
        if (te._attrsAffectingSize.length) {
          const ue = te._attrsAffectingSize.map((ce) => ce + "Change." + this._getEventNamespace()).join(" ");
          te.on(ue, ie);
        }
        te.on(S.map((ue) => ue + `.${this._getEventNamespace()}`).join(" "), ie), te.on(`absoluteTransformChange.${this._getEventNamespace()}`, ie), this._proxyDrag(te);
      }), this._resetTransformCache(), !!this.findOne(".top-left") && this.update(), this;
    }
    _proxyDrag(U) {
      let F;
      U.on(`dragstart.${this._getEventNamespace()}`, (Z) => {
        F = U.getAbsolutePosition(), !this.isDragging() && U !== this.findOne(".back") && this.startDrag(Z, !1);
      }), U.on(`dragmove.${this._getEventNamespace()}`, (Z) => {
        if (!F)
          return;
        const te = U.getAbsolutePosition(), ie = te.x - F.x, ue = te.y - F.y;
        this.nodes().forEach((ce) => {
          if (ce === U || ce.isDragging())
            return;
          const ze = ce.getAbsolutePosition();
          ce.setAbsolutePosition({
            x: ze.x + ie,
            y: ze.y + ue
          }), ce.startDrag(Z);
        }), F = null;
      });
    }
    getNodes() {
      return this._nodes || [];
    }
    getActiveAnchor() {
      return this._movingAnchorName;
    }
    detach() {
      this._nodes && this._nodes.forEach((U) => {
        U.off("." + this._getEventNamespace());
      }), this._nodes = [], this._resetTransformCache();
    }
    _resetTransformCache() {
      this._clearCache(E), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
      return this._getCache(E, this.__getNodeRect);
    }
    __getNodeShape(U, F = this.rotation(), Z) {
      const te = U.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      }), ie = U.getAbsoluteScale(Z), ue = U.getAbsolutePosition(Z), ce = te.x * ie.x - U.offsetX() * ie.x, ze = te.y * ie.y - U.offsetY() * ie.y, W = (d.Konva.getAngle(U.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), j = {
        x: ue.x + ce * Math.cos(W) + ze * Math.sin(-W),
        y: ue.y + ze * Math.cos(W) + ce * Math.sin(W),
        width: te.width * ie.x,
        height: te.height * ie.y,
        rotation: W
      };
      return x(j, -d.Konva.getAngle(F), {
        x: 0,
        y: 0
      });
    }
    __getNodeRect() {
      if (!this.getNode())
        return {
          x: -1e8,
          y: -1e8,
          width: 0,
          height: 0,
          rotation: 0
        };
      const F = [];
      this.nodes().map((W) => {
        const j = W.getClientRect({
          skipTransform: !0,
          skipShadow: !0,
          skipStroke: this.ignoreStroke()
        }), ee = [
          { x: j.x, y: j.y },
          { x: j.x + j.width, y: j.y },
          { x: j.x + j.width, y: j.y + j.height },
          { x: j.x, y: j.y + j.height }
        ], Q = W.getAbsoluteTransform();
        ee.forEach(function(oe) {
          const ye = Q.point(oe);
          F.push(ye);
        });
      });
      const Z = new e.Transform();
      Z.rotate(-d.Konva.getAngle(this.rotation()));
      let te = 1 / 0, ie = 1 / 0, ue = -1 / 0, ce = -1 / 0;
      F.forEach(function(W) {
        const j = Z.point(W);
        te === void 0 && (te = ue = j.x, ie = ce = j.y), te = Math.min(te, j.x), ie = Math.min(ie, j.y), ue = Math.max(ue, j.x), ce = Math.max(ce, j.y);
      }), Z.invert();
      const ze = Z.point({ x: te, y: ie });
      return {
        x: ze.x,
        y: ze.y,
        width: ue - te,
        height: ce - ie,
        rotation: d.Konva.getAngle(this.rotation())
      };
    }
    getX() {
      return this._getNodeRect().x;
    }
    getY() {
      return this._getNodeRect().y;
    }
    getWidth() {
      return this._getNodeRect().width;
    }
    getHeight() {
      return this._getNodeRect().height;
    }
    _createElements() {
      this._createBack(), z.forEach((U) => {
        this._createAnchor(U);
      }), this._createAnchor("rotater");
    }
    _createAnchor(U) {
      const F = new l.Rect({
        stroke: "rgb(0, 161, 255)",
        fill: "white",
        strokeWidth: 1,
        name: U + " _anchor",
        dragDistance: 0,
        draggable: !0,
        hitStrokeWidth: T ? 10 : "auto"
      }), Z = this;
      F.on("mousedown touchstart", function(te) {
        Z._handleMouseDown(te);
      }), F.on("dragstart", (te) => {
        F.stopDrag(), te.cancelBubble = !0;
      }), F.on("dragend", (te) => {
        te.cancelBubble = !0;
      }), F.on("mouseenter", () => {
        const te = d.Konva.getAngle(this.rotation()), ie = this.rotateAnchorCursor(), ue = P(U, te, ie);
        F.getStage().content && (F.getStage().content.style.cursor = ue), this._cursorChange = !0;
      }), F.on("mouseout", () => {
        F.getStage().content && (F.getStage().content.style.cursor = ""), this._cursorChange = !1;
      }), this.add(F);
    }
    _createBack() {
      const U = new o.Shape({
        name: "back",
        width: 0,
        height: 0,
        draggable: !0,
        sceneFunc(F, Z) {
          const te = Z.getParent(), ie = te.padding();
          F.beginPath(), F.rect(-ie, -ie, Z.width() + ie * 2, Z.height() + ie * 2), F.moveTo(Z.width() / 2, -ie), te.rotateEnabled() && te.rotateLineVisible() && F.lineTo(Z.width() / 2, -te.rotateAnchorOffset() * e.Util._sign(Z.height()) - ie), F.fillStrokeShape(Z);
        },
        hitFunc: (F, Z) => {
          if (!this.shouldOverdrawWholeArea())
            return;
          const te = this.padding();
          F.beginPath(), F.rect(-te, -te, Z.width() + te * 2, Z.height() + te * 2), F.fillStrokeShape(Z);
        }
      });
      this.add(U), this._proxyDrag(U), U.on("dragstart", (F) => {
        F.cancelBubble = !0;
      }), U.on("dragmove", (F) => {
        F.cancelBubble = !0;
      }), U.on("dragend", (F) => {
        F.cancelBubble = !0;
      }), this.on("dragmove", (F) => {
        this.update();
      });
    }
    _handleMouseDown(U) {
      if (this._transforming)
        return;
      this._movingAnchorName = U.target.name().split(" ")[0];
      const F = this._getNodeRect(), Z = F.width, te = F.height, ie = Math.sqrt(Math.pow(Z, 2) + Math.pow(te, 2));
      this.sin = Math.abs(te / ie), this.cos = Math.abs(Z / ie), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
      const ue = U.target.getAbsolutePosition(), ce = U.target.getStage().getPointerPosition();
      this._anchorDragOffset = {
        x: ce.x - ue.x,
        y: ce.y - ue.y
      }, B++, this._fire("transformstart", { evt: U.evt, target: this.getNode() }), this._nodes.forEach((ze) => {
        ze._fire("transformstart", { evt: U.evt, target: ze });
      });
    }
    _handleMouseMove(U) {
      let F, Z, te;
      const ie = this.findOne("." + this._movingAnchorName), ue = ie.getStage();
      ue.setPointersPositions(U);
      const ce = ue.getPointerPosition();
      let ze = {
        x: ce.x - this._anchorDragOffset.x,
        y: ce.y - this._anchorDragOffset.y
      };
      const W = ie.getAbsolutePosition();
      this.anchorDragBoundFunc() && (ze = this.anchorDragBoundFunc()(W, ze, U)), ie.setAbsolutePosition(ze);
      const j = ie.getAbsolutePosition();
      if (W.x === j.x && W.y === j.y)
        return;
      if (this._movingAnchorName === "rotater") {
        const Ee = this._getNodeRect();
        F = ie.x() - Ee.width / 2, Z = -ie.y() + Ee.height / 2;
        let ae = Math.atan2(-Z, F) + Math.PI / 2;
        Ee.height < 0 && (ae -= Math.PI);
        const Qe = d.Konva.getAngle(this.rotation()) + ae, Pe = d.Konva.getAngle(this.rotationSnapTolerance()), st = R(this.rotationSnaps(), Qe, Pe) - Ee.rotation, bt = k(Ee, st);
        this._fitNodesInto(bt, U);
        return;
      }
      const ee = this.shiftBehavior();
      let Q;
      ee === "inverted" ? Q = this.keepRatio() && !U.shiftKey : ee === "none" ? Q = this.keepRatio() : Q = this.keepRatio() || U.shiftKey;
      let oe = this.centeredScaling() || U.altKey;
      if (this._movingAnchorName === "top-left") {
        if (Q) {
          const Ee = oe ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          te = Math.sqrt(Math.pow(Ee.x - ie.x(), 2) + Math.pow(Ee.y - ie.y(), 2));
          const ae = this.findOne(".top-left").x() > Ee.x ? -1 : 1, Re = this.findOne(".top-left").y() > Ee.y ? -1 : 1;
          F = te * this.cos * ae, Z = te * this.sin * Re, this.findOne(".top-left").x(Ee.x - F), this.findOne(".top-left").y(Ee.y - Z);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(ie.y());
      else if (this._movingAnchorName === "top-right") {
        if (Q) {
          const Ee = oe ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          te = Math.sqrt(Math.pow(ie.x() - Ee.x, 2) + Math.pow(Ee.y - ie.y(), 2));
          const ae = this.findOne(".top-right").x() < Ee.x ? -1 : 1, Re = this.findOne(".top-right").y() > Ee.y ? -1 : 1;
          F = te * this.cos * ae, Z = te * this.sin * Re, this.findOne(".top-right").x(Ee.x + F), this.findOne(".top-right").y(Ee.y - Z);
        }
        var ye = ie.position();
        this.findOne(".top-left").y(ye.y), this.findOne(".bottom-right").x(ye.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(ie.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(ie.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (Q) {
          const Ee = oe ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          te = Math.sqrt(Math.pow(Ee.x - ie.x(), 2) + Math.pow(ie.y() - Ee.y, 2));
          const ae = Ee.x < ie.x() ? -1 : 1, Re = ie.y() < Ee.y ? -1 : 1;
          F = te * this.cos * ae, Z = te * this.sin * Re, ie.x(Ee.x - F), ie.y(Ee.y + Z);
        }
        ye = ie.position(), this.findOne(".top-left").x(ye.x), this.findOne(".bottom-right").y(ye.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(ie.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (Q) {
          const Ee = oe ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          te = Math.sqrt(Math.pow(ie.x() - Ee.x, 2) + Math.pow(ie.y() - Ee.y, 2));
          const ae = this.findOne(".bottom-right").x() < Ee.x ? -1 : 1, Re = this.findOne(".bottom-right").y() < Ee.y ? -1 : 1;
          F = te * this.cos * ae, Z = te * this.sin * Re, this.findOne(".bottom-right").x(Ee.x + F), this.findOne(".bottom-right").y(Ee.y + Z);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      if (oe = this.centeredScaling() || U.altKey, oe) {
        const Ee = this.findOne(".top-left"), ae = this.findOne(".bottom-right"), Re = Ee.x(), Qe = Ee.y(), Pe = this.getWidth() - ae.x(), rt = this.getHeight() - ae.y();
        ae.move({
          x: -Re,
          y: -Qe
        }), Ee.move({
          x: Pe,
          y: rt
        });
      }
      const pe = this.findOne(".top-left").getAbsolutePosition();
      F = pe.x, Z = pe.y;
      const Me = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), We = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: F,
        y: Z,
        width: Me,
        height: We,
        rotation: d.Konva.getAngle(this.rotation())
      }, U);
    }
    _handleMouseUp(U) {
      this._removeEvents(U);
    }
    getAbsoluteTransform() {
      return this.getTransform();
    }
    _removeEvents(U) {
      var F;
      if (this._transforming) {
        this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
        const Z = this.getNode();
        B--, this._fire("transformend", { evt: U, target: Z }), (F = this.getLayer()) === null || F === void 0 || F.batchDraw(), Z && this._nodes.forEach((te) => {
          var ie;
          te._fire("transformend", { evt: U, target: te }), (ie = te.getLayer()) === null || ie === void 0 || ie.batchDraw();
        }), this._movingAnchorName = null;
      }
    }
    _fitNodesInto(U, F) {
      const Z = this._getNodeRect(), te = 1;
      if (e.Util._inRange(U.width, -this.padding() * 2 - te, te)) {
        this.update();
        return;
      }
      if (e.Util._inRange(U.height, -this.padding() * 2 - te, te)) {
        this.update();
        return;
      }
      const ie = new e.Transform();
      if (ie.rotate(d.Konva.getAngle(this.rotation())), this._movingAnchorName && U.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
        const Q = ie.point({
          x: -this.padding() * 2,
          y: 0
        });
        U.x += Q.x, U.y += Q.y, U.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= Q.x, this._anchorDragOffset.y -= Q.y;
      } else if (this._movingAnchorName && U.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
        const Q = ie.point({
          x: this.padding() * 2,
          y: 0
        });
        this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= Q.x, this._anchorDragOffset.y -= Q.y, U.width += this.padding() * 2;
      }
      if (this._movingAnchorName && U.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
        const Q = ie.point({
          x: 0,
          y: -this.padding() * 2
        });
        U.x += Q.x, U.y += Q.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= Q.x, this._anchorDragOffset.y -= Q.y, U.height += this.padding() * 2;
      } else if (this._movingAnchorName && U.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
        const Q = ie.point({
          x: 0,
          y: this.padding() * 2
        });
        this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= Q.x, this._anchorDragOffset.y -= Q.y, U.height += this.padding() * 2;
      }
      if (this.boundBoxFunc()) {
        const Q = this.boundBoxFunc()(Z, U);
        Q ? U = Q : e.Util.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
      }
      const ue = 1e7, ce = new e.Transform();
      ce.translate(Z.x, Z.y), ce.rotate(Z.rotation), ce.scale(Z.width / ue, Z.height / ue);
      const ze = new e.Transform(), W = U.width / ue, j = U.height / ue;
      this.flipEnabled() === !1 ? (ze.translate(U.x, U.y), ze.rotate(U.rotation), ze.translate(U.width < 0 ? U.width : 0, U.height < 0 ? U.height : 0), ze.scale(Math.abs(W), Math.abs(j))) : (ze.translate(U.x, U.y), ze.rotate(U.rotation), ze.scale(W, j));
      const ee = ze.multiply(ce.invert());
      this._nodes.forEach((Q) => {
        var oe;
        const ye = Q.getParent().getAbsoluteTransform(), pe = Q.getTransform().copy();
        pe.translate(Q.offsetX(), Q.offsetY());
        const Me = new e.Transform();
        Me.multiply(ye.copy().invert()).multiply(ee).multiply(ye).multiply(pe);
        const We = Me.decompose();
        Q.setAttrs(We), (oe = Q.getLayer()) === null || oe === void 0 || oe.batchDraw();
      }), this.rotation(e.Util._getRotation(U.rotation)), this._nodes.forEach((Q) => {
        this._fire("transform", { evt: F, target: Q }), Q._fire("transform", { evt: F, target: Q });
      }), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
    }
    forceUpdate() {
      this._resetTransformCache(), this.update();
    }
    _batchChangeChild(U, F) {
      this.findOne(U).setAttrs(F);
    }
    update() {
      var U;
      const F = this._getNodeRect();
      this.rotation(e.Util._getRotation(F.rotation));
      const Z = F.width, te = F.height, ie = this.enabledAnchors(), ue = this.resizeEnabled(), ce = this.padding(), ze = this.anchorSize(), W = this.find("._anchor");
      W.forEach((ee) => {
        ee.setAttrs({
          width: ze,
          height: ze,
          offsetX: ze / 2,
          offsetY: ze / 2,
          stroke: this.anchorStroke(),
          strokeWidth: this.anchorStrokeWidth(),
          fill: this.anchorFill(),
          cornerRadius: this.anchorCornerRadius()
        });
      }), this._batchChangeChild(".top-left", {
        x: 0,
        y: 0,
        offsetX: ze / 2 + ce,
        offsetY: ze / 2 + ce,
        visible: ue && ie.indexOf("top-left") >= 0
      }), this._batchChangeChild(".top-center", {
        x: Z / 2,
        y: 0,
        offsetY: ze / 2 + ce,
        visible: ue && ie.indexOf("top-center") >= 0
      }), this._batchChangeChild(".top-right", {
        x: Z,
        y: 0,
        offsetX: ze / 2 - ce,
        offsetY: ze / 2 + ce,
        visible: ue && ie.indexOf("top-right") >= 0
      }), this._batchChangeChild(".middle-left", {
        x: 0,
        y: te / 2,
        offsetX: ze / 2 + ce,
        visible: ue && ie.indexOf("middle-left") >= 0
      }), this._batchChangeChild(".middle-right", {
        x: Z,
        y: te / 2,
        offsetX: ze / 2 - ce,
        visible: ue && ie.indexOf("middle-right") >= 0
      }), this._batchChangeChild(".bottom-left", {
        x: 0,
        y: te,
        offsetX: ze / 2 + ce,
        offsetY: ze / 2 - ce,
        visible: ue && ie.indexOf("bottom-left") >= 0
      }), this._batchChangeChild(".bottom-center", {
        x: Z / 2,
        y: te,
        offsetY: ze / 2 - ce,
        visible: ue && ie.indexOf("bottom-center") >= 0
      }), this._batchChangeChild(".bottom-right", {
        x: Z,
        y: te,
        offsetX: ze / 2 - ce,
        offsetY: ze / 2 - ce,
        visible: ue && ie.indexOf("bottom-right") >= 0
      }), this._batchChangeChild(".rotater", {
        x: Z / 2,
        y: -this.rotateAnchorOffset() * e.Util._sign(te) - ce,
        visible: this.rotateEnabled()
      }), this._batchChangeChild(".back", {
        width: Z,
        height: te,
        visible: this.borderEnabled(),
        stroke: this.borderStroke(),
        strokeWidth: this.borderStrokeWidth(),
        dash: this.borderDash(),
        x: 0,
        y: 0
      });
      const j = this.anchorStyleFunc();
      j && W.forEach((ee) => {
        j(ee);
      }), (U = this.getLayer()) === null || U === void 0 || U.batchDraw();
    }
    isTransforming() {
      return this._transforming;
    }
    stopTransform() {
      if (this._transforming) {
        this._removeEvents();
        const U = this.findOne("." + this._movingAnchorName);
        U && U.stopDrag();
      }
    }
    destroy() {
      return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), u.Group.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
    }
    toObject() {
      return r.Node.prototype.toObject.call(this);
    }
    clone(U) {
      return r.Node.prototype.clone.call(this, U);
    }
    getClientRect() {
      return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
    }
  }
  yp.Transformer = q, q.isTransforming = () => B > 0;
  function X(I) {
    return I instanceof Array || e.Util.warn("enabledAnchors value should be an array"), I instanceof Array && I.forEach(function(U) {
      z.indexOf(U) === -1 && e.Util.warn("Unknown anchor name: " + U + ". Available names are: " + z.join(", "));
    }), I || [];
  }
  return q.prototype.className = "Transformer", (0, g._registerNode)(q), t.Factory.addGetterSetter(q, "enabledAnchors", z, X), t.Factory.addGetterSetter(q, "flipEnabled", !0, (0, f.getBooleanValidator)()), t.Factory.addGetterSetter(q, "resizeEnabled", !0), t.Factory.addGetterSetter(q, "anchorSize", 10, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "rotateEnabled", !0), t.Factory.addGetterSetter(q, "rotateLineVisible", !0), t.Factory.addGetterSetter(q, "rotationSnaps", []), t.Factory.addGetterSetter(q, "rotateAnchorOffset", 50, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "rotateAnchorCursor", "crosshair"), t.Factory.addGetterSetter(q, "rotationSnapTolerance", 5, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "borderEnabled", !0), t.Factory.addGetterSetter(q, "anchorStroke", "rgb(0, 161, 255)"), t.Factory.addGetterSetter(q, "anchorStrokeWidth", 1, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "anchorFill", "white"), t.Factory.addGetterSetter(q, "anchorCornerRadius", 0, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "borderStroke", "rgb(0, 161, 255)"), t.Factory.addGetterSetter(q, "borderStrokeWidth", 1, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "borderDash"), t.Factory.addGetterSetter(q, "keepRatio", !0), t.Factory.addGetterSetter(q, "shiftBehavior", "default"), t.Factory.addGetterSetter(q, "centeredScaling", !1), t.Factory.addGetterSetter(q, "ignoreStroke", !1), t.Factory.addGetterSetter(q, "padding", 0, (0, f.getNumberValidator)()), t.Factory.addGetterSetter(q, "nodes"), t.Factory.addGetterSetter(q, "node"), t.Factory.addGetterSetter(q, "boundBoxFunc"), t.Factory.addGetterSetter(q, "anchorDragBoundFunc"), t.Factory.addGetterSetter(q, "anchorStyleFunc"), t.Factory.addGetterSetter(q, "shouldOverdrawWholeArea", !1), t.Factory.addGetterSetter(q, "useSingleNodeRotation", !0), t.Factory.backCompat(q, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
  }), yp;
}
var bp = {}, d4;
function SA() {
  if (d4) return bp;
  d4 = 1, Object.defineProperty(bp, "__esModule", { value: !0 }), bp.Wedge = void 0;
  const e = On(), t = ja(), r = Rn(), o = Vn(), l = Rn();
  let u = class extends t.Shape {
    _sceneFunc(f) {
      f.beginPath(), f.arc(0, 0, this.radius(), 0, r.Konva.getAngle(this.angle()), this.clockwise()), f.lineTo(0, 0), f.closePath(), f.fillStrokeShape(this);
    }
    getWidth() {
      return this.radius() * 2;
    }
    getHeight() {
      return this.radius() * 2;
    }
    setWidth(f) {
      this.radius(f / 2);
    }
    setHeight(f) {
      this.radius(f / 2);
    }
  };
  return bp.Wedge = u, u.prototype.className = "Wedge", u.prototype._centroid = !0, u.prototype._attrsAffectingSize = ["radius"], (0, l._registerNode)(u), e.Factory.addGetterSetter(u, "radius", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "angle", 0, (0, o.getNumberValidator)()), e.Factory.addGetterSetter(u, "clockwise", !1), e.Factory.backCompat(u, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
  }), bp;
}
var _p = {}, f4;
function wA() {
  if (f4) return _p;
  f4 = 1, Object.defineProperty(_p, "__esModule", { value: !0 }), _p.Blur = void 0;
  const e = On(), t = ra(), r = Vn();
  function o() {
    this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
  const l = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
  ], u = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
  ];
  function d(g, h) {
    const v = g.data, E = g.width, S = g.height;
    let w, T, P, z, L, x, k, R, B, q, X, I, U, F, Z, te, ie, ue, ce, ze;
    const W = h + h + 1, j = E - 1, ee = S - 1, Q = h + 1, oe = Q * (Q + 1) / 2, ye = new o(), pe = l[h], Me = u[h];
    let We = null, Ee = ye, ae = null, Re = null;
    for (let Qe = 1; Qe < W; Qe++)
      Ee = Ee.next = new o(), Qe === Q && (We = Ee);
    Ee.next = ye, P = T = 0;
    for (let Qe = 0; Qe < S; Qe++) {
      I = U = F = Z = z = L = x = k = 0, R = Q * (te = v[T]), B = Q * (ie = v[T + 1]), q = Q * (ue = v[T + 2]), X = Q * (ce = v[T + 3]), z += oe * te, L += oe * ie, x += oe * ue, k += oe * ce, Ee = ye;
      for (let Pe = 0; Pe < Q; Pe++)
        Ee.r = te, Ee.g = ie, Ee.b = ue, Ee.a = ce, Ee = Ee.next;
      for (let Pe = 1; Pe < Q; Pe++)
        w = T + ((j < Pe ? j : Pe) << 2), z += (Ee.r = te = v[w]) * (ze = Q - Pe), L += (Ee.g = ie = v[w + 1]) * ze, x += (Ee.b = ue = v[w + 2]) * ze, k += (Ee.a = ce = v[w + 3]) * ze, I += te, U += ie, F += ue, Z += ce, Ee = Ee.next;
      ae = ye, Re = We;
      for (let Pe = 0; Pe < E; Pe++)
        v[T + 3] = ce = k * pe >> Me, ce !== 0 ? (ce = 255 / ce, v[T] = (z * pe >> Me) * ce, v[T + 1] = (L * pe >> Me) * ce, v[T + 2] = (x * pe >> Me) * ce) : v[T] = v[T + 1] = v[T + 2] = 0, z -= R, L -= B, x -= q, k -= X, R -= ae.r, B -= ae.g, q -= ae.b, X -= ae.a, w = P + ((w = Pe + h + 1) < j ? w : j) << 2, I += ae.r = v[w], U += ae.g = v[w + 1], F += ae.b = v[w + 2], Z += ae.a = v[w + 3], z += I, L += U, x += F, k += Z, ae = ae.next, R += te = Re.r, B += ie = Re.g, q += ue = Re.b, X += ce = Re.a, I -= te, U -= ie, F -= ue, Z -= ce, Re = Re.next, T += 4;
      P += E;
    }
    for (let Qe = 0; Qe < E; Qe++) {
      U = F = Z = I = L = x = k = z = 0, T = Qe << 2, R = Q * (te = v[T]), B = Q * (ie = v[T + 1]), q = Q * (ue = v[T + 2]), X = Q * (ce = v[T + 3]), z += oe * te, L += oe * ie, x += oe * ue, k += oe * ce, Ee = ye;
      for (let rt = 0; rt < Q; rt++)
        Ee.r = te, Ee.g = ie, Ee.b = ue, Ee.a = ce, Ee = Ee.next;
      let Pe = E;
      for (let rt = 1; rt <= h; rt++)
        T = Pe + Qe << 2, z += (Ee.r = te = v[T]) * (ze = Q - rt), L += (Ee.g = ie = v[T + 1]) * ze, x += (Ee.b = ue = v[T + 2]) * ze, k += (Ee.a = ce = v[T + 3]) * ze, I += te, U += ie, F += ue, Z += ce, Ee = Ee.next, rt < ee && (Pe += E);
      T = Qe, ae = ye, Re = We;
      for (let rt = 0; rt < S; rt++)
        w = T << 2, v[w + 3] = ce = k * pe >> Me, ce > 0 ? (ce = 255 / ce, v[w] = (z * pe >> Me) * ce, v[w + 1] = (L * pe >> Me) * ce, v[w + 2] = (x * pe >> Me) * ce) : v[w] = v[w + 1] = v[w + 2] = 0, z -= R, L -= B, x -= q, k -= X, R -= ae.r, B -= ae.g, q -= ae.b, X -= ae.a, w = Qe + ((w = rt + Q) < ee ? w : ee) * E << 2, z += I += ae.r = v[w], L += U += ae.g = v[w + 1], x += F += ae.b = v[w + 2], k += Z += ae.a = v[w + 3], ae = ae.next, R += te = Re.r, B += ie = Re.g, q += ue = Re.b, X += ce = Re.a, I -= te, U -= ie, F -= ue, Z -= ce, Re = Re.next, T += E;
    }
  }
  const f = function(h) {
    const v = Math.round(this.blurRadius());
    v > 0 && d(h, v);
  };
  return _p.Blur = f, e.Factory.addGetterSetter(t.Node, "blurRadius", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), _p;
}
var Sp = {}, h4;
function xA() {
  if (h4) return Sp;
  h4 = 1, Object.defineProperty(Sp, "__esModule", { value: !0 }), Sp.Brighten = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = this.brightness() * 255, d = l.data, f = d.length;
    for (let g = 0; g < f; g += 4)
      d[g] += u, d[g + 1] += u, d[g + 2] += u;
  };
  return Sp.Brighten = o, e.Factory.addGetterSetter(t.Node, "brightness", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Sp;
}
var wp = {}, p4;
function kA() {
  if (p4) return wp;
  p4 = 1, Object.defineProperty(wp, "__esModule", { value: !0 }), wp.Contrast = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = Math.pow((this.contrast() + 100) / 100, 2), d = l.data, f = d.length;
    let g = 150, h = 150, v = 150;
    for (let E = 0; E < f; E += 4)
      g = d[E], h = d[E + 1], v = d[E + 2], g /= 255, g -= 0.5, g *= u, g += 0.5, g *= 255, h /= 255, h -= 0.5, h *= u, h += 0.5, h *= 255, v /= 255, v -= 0.5, v *= u, v += 0.5, v *= 255, g = g < 0 ? 0 : g > 255 ? 255 : g, h = h < 0 ? 0 : h > 255 ? 255 : h, v = v < 0 ? 0 : v > 255 ? 255 : v, d[E] = g, d[E + 1] = h, d[E + 2] = v;
  };
  return wp.Contrast = o, e.Factory.addGetterSetter(t.Node, "contrast", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), wp;
}
var xp = {}, m4;
function CA() {
  if (m4) return xp;
  m4 = 1, Object.defineProperty(xp, "__esModule", { value: !0 }), xp.Emboss = void 0;
  const e = On(), t = ra(), r = jr(), o = Vn(), l = function(u) {
    const d = this.embossStrength() * 10, f = this.embossWhiteLevel() * 255, g = this.embossDirection(), h = this.embossBlend(), v = u.data, E = u.width, S = u.height, w = E * 4;
    let T = 0, P = 0, z = S;
    switch (g) {
      case "top-left":
        T = -1, P = -1;
        break;
      case "top":
        T = -1, P = 0;
        break;
      case "top-right":
        T = -1, P = 1;
        break;
      case "right":
        T = 0, P = 1;
        break;
      case "bottom-right":
        T = 1, P = 1;
        break;
      case "bottom":
        T = 1, P = 0;
        break;
      case "bottom-left":
        T = 1, P = -1;
        break;
      case "left":
        T = 0, P = -1;
        break;
      default:
        r.Util.error("Unknown emboss direction: " + g);
    }
    do {
      const L = (z - 1) * w;
      let x = T;
      z + x < 1 && (x = 0), z + x > S && (x = 0);
      const k = (z - 1 + x) * E * 4;
      let R = E;
      do {
        const B = L + (R - 1) * 4;
        let q = P;
        R + q < 1 && (q = 0), R + q > E && (q = 0);
        const X = k + (R - 1 + q) * 4, I = v[B] - v[X], U = v[B + 1] - v[X + 1], F = v[B + 2] - v[X + 2];
        let Z = I;
        const te = Z > 0 ? Z : -Z, ie = U > 0 ? U : -U, ue = F > 0 ? F : -F;
        if (ie > te && (Z = U), ue > te && (Z = F), Z *= d, h) {
          const ce = v[B] + Z, ze = v[B + 1] + Z, W = v[B + 2] + Z;
          v[B] = ce > 255 ? 255 : ce < 0 ? 0 : ce, v[B + 1] = ze > 255 ? 255 : ze < 0 ? 0 : ze, v[B + 2] = W > 255 ? 255 : W < 0 ? 0 : W;
        } else {
          let ce = f - Z;
          ce < 0 ? ce = 0 : ce > 255 && (ce = 255), v[B] = v[B + 1] = v[B + 2] = ce;
        }
      } while (--R);
    } while (--z);
  };
  return xp.Emboss = l, e.Factory.addGetterSetter(t.Node, "embossStrength", 0.5, (0, o.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "embossWhiteLevel", 0.5, (0, o.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "embossDirection", "top-left", void 0, e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "embossBlend", !1, void 0, e.Factory.afterSetFilter), xp;
}
var kp = {}, g4;
function EA() {
  if (g4) return kp;
  g4 = 1, Object.defineProperty(kp, "__esModule", { value: !0 }), kp.Enhance = void 0;
  const e = On(), t = ra(), r = Vn();
  function o(u, d, f, g, h) {
    const v = f - d, E = h - g;
    if (v === 0)
      return g + E / 2;
    if (E === 0)
      return g;
    let S = (u - d) / v;
    return S = E * S + g, S;
  }
  const l = function(u) {
    const d = u.data, f = d.length;
    let g = d[0], h = g, v, E = d[1], S = E, w, T = d[2], P = T, z;
    const L = this.enhance();
    if (L === 0)
      return;
    for (let I = 0; I < f; I += 4)
      v = d[I + 0], v < g ? g = v : v > h && (h = v), w = d[I + 1], w < E ? E = w : w > S && (S = w), z = d[I + 2], z < T ? T = z : z > P && (P = z);
    h === g && (h = 255, g = 0), S === E && (S = 255, E = 0), P === T && (P = 255, T = 0);
    let x, k, R, B, q, X;
    if (L > 0)
      x = h + L * (255 - h), k = g - L * (g - 0), R = S + L * (255 - S), B = E - L * (E - 0), q = P + L * (255 - P), X = T - L * (T - 0);
    else {
      const I = (h + g) * 0.5;
      x = h + L * (h - I), k = g + L * (g - I);
      const U = (S + E) * 0.5;
      R = S + L * (S - U), B = E + L * (E - U);
      const F = (P + T) * 0.5;
      q = P + L * (P - F), X = T + L * (T - F);
    }
    for (let I = 0; I < f; I += 4)
      d[I + 0] = o(d[I + 0], g, h, k, x), d[I + 1] = o(d[I + 1], E, S, B, R), d[I + 2] = o(d[I + 2], T, P, X, q);
  };
  return kp.Enhance = l, e.Factory.addGetterSetter(t.Node, "enhance", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), kp;
}
var Cp = {}, v4;
function RA() {
  if (v4) return Cp;
  v4 = 1, Object.defineProperty(Cp, "__esModule", { value: !0 }), Cp.Grayscale = void 0;
  const e = function(t) {
    const r = t.data, o = r.length;
    for (let l = 0; l < o; l += 4) {
      const u = 0.34 * r[l] + 0.5 * r[l + 1] + 0.16 * r[l + 2];
      r[l] = u, r[l + 1] = u, r[l + 2] = u;
    }
  };
  return Cp.Grayscale = e, Cp;
}
var Ep = {}, y4;
function TA() {
  if (y4) return Ep;
  y4 = 1, Object.defineProperty(Ep, "__esModule", { value: !0 }), Ep.HSL = void 0;
  const e = On(), t = ra(), r = Vn();
  e.Factory.addGetterSetter(t.Node, "hue", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "saturation", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "luminance", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter);
  const o = function(l) {
    const u = l.data, d = u.length, f = 1, g = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, v = this.luminance() * 127, E = f * g * Math.cos(h * Math.PI / 180), S = f * g * Math.sin(h * Math.PI / 180), w = 0.299 * f + 0.701 * E + 0.167 * S, T = 0.587 * f - 0.587 * E + 0.33 * S, P = 0.114 * f - 0.114 * E - 0.497 * S, z = 0.299 * f - 0.299 * E - 0.328 * S, L = 0.587 * f + 0.413 * E + 0.035 * S, x = 0.114 * f - 0.114 * E + 0.293 * S, k = 0.299 * f - 0.3 * E + 1.25 * S, R = 0.587 * f - 0.586 * E - 1.05 * S, B = 0.114 * f + 0.886 * E - 0.2 * S;
    let q, X, I, U;
    for (let F = 0; F < d; F += 4)
      q = u[F + 0], X = u[F + 1], I = u[F + 2], U = u[F + 3], u[F + 0] = w * q + T * X + P * I + v, u[F + 1] = z * q + L * X + x * I + v, u[F + 2] = k * q + R * X + B * I + v, u[F + 3] = U;
  };
  return Ep.HSL = o, Ep;
}
var Rp = {}, b4;
function NA() {
  if (b4) return Rp;
  b4 = 1, Object.defineProperty(Rp, "__esModule", { value: !0 }), Rp.HSV = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = l.data, d = u.length, f = Math.pow(2, this.value()), g = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, v = f * g * Math.cos(h * Math.PI / 180), E = f * g * Math.sin(h * Math.PI / 180), S = 0.299 * f + 0.701 * v + 0.167 * E, w = 0.587 * f - 0.587 * v + 0.33 * E, T = 0.114 * f - 0.114 * v - 0.497 * E, P = 0.299 * f - 0.299 * v - 0.328 * E, z = 0.587 * f + 0.413 * v + 0.035 * E, L = 0.114 * f - 0.114 * v + 0.293 * E, x = 0.299 * f - 0.3 * v + 1.25 * E, k = 0.587 * f - 0.586 * v - 1.05 * E, R = 0.114 * f + 0.886 * v - 0.2 * E;
    for (let B = 0; B < d; B += 4) {
      const q = u[B + 0], X = u[B + 1], I = u[B + 2], U = u[B + 3];
      u[B + 0] = S * q + w * X + T * I, u[B + 1] = P * q + z * X + L * I, u[B + 2] = x * q + k * X + R * I, u[B + 3] = U;
    }
  };
  return Rp.HSV = o, e.Factory.addGetterSetter(t.Node, "hue", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "saturation", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "value", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Rp;
}
var Tp = {}, _4;
function AA() {
  if (_4) return Tp;
  _4 = 1, Object.defineProperty(Tp, "__esModule", { value: !0 }), Tp.Invert = void 0;
  const e = function(t) {
    const r = t.data, o = r.length;
    for (let l = 0; l < o; l += 4)
      r[l] = 255 - r[l], r[l + 1] = 255 - r[l + 1], r[l + 2] = 255 - r[l + 2];
  };
  return Tp.Invert = e, Tp;
}
var Np = {}, S4;
function MA() {
  if (S4) return Np;
  S4 = 1, Object.defineProperty(Np, "__esModule", { value: !0 }), Np.Kaleidoscope = void 0;
  const e = On(), t = ra(), r = jr(), o = Vn(), l = function(f, g, h) {
    const v = f.data, E = g.data, S = f.width, w = f.height, T = h.polarCenterX || S / 2, P = h.polarCenterY || w / 2;
    let z = Math.sqrt(T * T + P * P), L = S - T, x = w - P;
    const k = Math.sqrt(L * L + x * x);
    z = k > z ? k : z;
    const R = w, B = S, q = 360 / B * Math.PI / 180;
    for (let X = 0; X < B; X += 1) {
      const I = Math.sin(X * q), U = Math.cos(X * q);
      for (let F = 0; F < R; F += 1) {
        L = Math.floor(T + z * F / R * U), x = Math.floor(P + z * F / R * I);
        let Z = (x * S + L) * 4;
        const te = v[Z + 0], ie = v[Z + 1], ue = v[Z + 2], ce = v[Z + 3];
        Z = (X + F * S) * 4, E[Z + 0] = te, E[Z + 1] = ie, E[Z + 2] = ue, E[Z + 3] = ce;
      }
    }
  }, u = function(f, g, h) {
    const v = f.data, E = g.data, S = f.width, w = f.height, T = h.polarCenterX || S / 2, P = h.polarCenterY || w / 2;
    let z = Math.sqrt(T * T + P * P), L = S - T, x = w - P;
    const k = Math.sqrt(L * L + x * x);
    z = k > z ? k : z;
    const R = w, B = S, q = 0;
    let X, I;
    for (L = 0; L < S; L += 1)
      for (x = 0; x < w; x += 1) {
        const U = L - T, F = x - P, Z = Math.sqrt(U * U + F * F) * R / z;
        let te = (Math.atan2(F, U) * 180 / Math.PI + 360 + q) % 360;
        te = te * B / 360, X = Math.floor(te), I = Math.floor(Z);
        let ie = (I * S + X) * 4;
        const ue = v[ie + 0], ce = v[ie + 1], ze = v[ie + 2], W = v[ie + 3];
        ie = (x * S + L) * 4, E[ie + 0] = ue, E[ie + 1] = ce, E[ie + 2] = ze, E[ie + 3] = W;
      }
  }, d = function(f) {
    const g = f.width, h = f.height;
    let v, E, S, w, T, P, z, L, x, k, R = Math.round(this.kaleidoscopePower());
    const B = Math.round(this.kaleidoscopeAngle()), q = Math.floor(g * (B % 360) / 360);
    if (R < 1)
      return;
    const X = r.Util.createCanvasElement();
    X.width = g, X.height = h;
    const I = X.getContext("2d").getImageData(0, 0, g, h);
    r.Util.releaseCanvas(X), l(f, I, {
      polarCenterX: g / 2,
      polarCenterY: h / 2
    });
    let U = g / Math.pow(2, R);
    for (; U <= 8; )
      U = U * 2, R -= 1;
    U = Math.ceil(U);
    let F = U, Z = 0, te = F, ie = 1;
    for (q + U > g && (Z = F, te = 0, ie = -1), E = 0; E < h; E += 1)
      for (v = Z; v !== te; v += ie)
        S = Math.round(v + q) % g, x = (g * E + S) * 4, T = I.data[x + 0], P = I.data[x + 1], z = I.data[x + 2], L = I.data[x + 3], k = (g * E + v) * 4, I.data[k + 0] = T, I.data[k + 1] = P, I.data[k + 2] = z, I.data[k + 3] = L;
    for (E = 0; E < h; E += 1)
      for (F = Math.floor(U), w = 0; w < R; w += 1) {
        for (v = 0; v < F + 1; v += 1)
          x = (g * E + v) * 4, T = I.data[x + 0], P = I.data[x + 1], z = I.data[x + 2], L = I.data[x + 3], k = (g * E + F * 2 - v - 1) * 4, I.data[k + 0] = T, I.data[k + 1] = P, I.data[k + 2] = z, I.data[k + 3] = L;
        F *= 2;
      }
    u(I, f, {});
  };
  return Np.Kaleidoscope = d, e.Factory.addGetterSetter(t.Node, "kaleidoscopePower", 2, (0, o.getNumberValidator)(), e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "kaleidoscopeAngle", 0, (0, o.getNumberValidator)(), e.Factory.afterSetFilter), Np;
}
var Ap = {}, w4;
function PA() {
  if (w4) return Ap;
  w4 = 1, Object.defineProperty(Ap, "__esModule", { value: !0 }), Ap.Mask = void 0;
  const e = On(), t = ra(), r = Vn();
  function o(S, w, T) {
    let P = (T * S.width + w) * 4;
    const z = [];
    return z.push(S.data[P++], S.data[P++], S.data[P++], S.data[P++]), z;
  }
  function l(S, w) {
    return Math.sqrt(Math.pow(S[0] - w[0], 2) + Math.pow(S[1] - w[1], 2) + Math.pow(S[2] - w[2], 2));
  }
  function u(S) {
    const w = [0, 0, 0];
    for (let T = 0; T < S.length; T++)
      w[0] += S[T][0], w[1] += S[T][1], w[2] += S[T][2];
    return w[0] /= S.length, w[1] /= S.length, w[2] /= S.length, w;
  }
  function d(S, w) {
    const T = o(S, 0, 0), P = o(S, S.width - 1, 0), z = o(S, 0, S.height - 1), L = o(S, S.width - 1, S.height - 1), x = w || 10;
    if (l(T, P) < x && l(P, L) < x && l(L, z) < x && l(z, T) < x) {
      const k = u([P, T, L, z]), R = [];
      for (let B = 0; B < S.width * S.height; B++) {
        const q = l(k, [
          S.data[B * 4],
          S.data[B * 4 + 1],
          S.data[B * 4 + 2]
        ]);
        R[B] = q < x ? 0 : 255;
      }
      return R;
    }
  }
  function f(S, w) {
    for (let T = 0; T < S.width * S.height; T++)
      S.data[4 * T + 3] = w[T];
  }
  function g(S, w, T) {
    const P = [1, 1, 1, 1, 0, 1, 1, 1, 1], z = Math.round(Math.sqrt(P.length)), L = Math.floor(z / 2), x = [];
    for (let k = 0; k < T; k++)
      for (let R = 0; R < w; R++) {
        const B = k * w + R;
        let q = 0;
        for (let X = 0; X < z; X++)
          for (let I = 0; I < z; I++) {
            const U = k + X - L, F = R + I - L;
            if (U >= 0 && U < T && F >= 0 && F < w) {
              const Z = U * w + F, te = P[X * z + I];
              q += S[Z] * te;
            }
          }
        x[B] = q === 2040 ? 255 : 0;
      }
    return x;
  }
  function h(S, w, T) {
    const P = [1, 1, 1, 1, 1, 1, 1, 1, 1], z = Math.round(Math.sqrt(P.length)), L = Math.floor(z / 2), x = [];
    for (let k = 0; k < T; k++)
      for (let R = 0; R < w; R++) {
        const B = k * w + R;
        let q = 0;
        for (let X = 0; X < z; X++)
          for (let I = 0; I < z; I++) {
            const U = k + X - L, F = R + I - L;
            if (U >= 0 && U < T && F >= 0 && F < w) {
              const Z = U * w + F, te = P[X * z + I];
              q += S[Z] * te;
            }
          }
        x[B] = q >= 1020 ? 255 : 0;
      }
    return x;
  }
  function v(S, w, T) {
    const P = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], z = Math.round(Math.sqrt(P.length)), L = Math.floor(z / 2), x = [];
    for (let k = 0; k < T; k++)
      for (let R = 0; R < w; R++) {
        const B = k * w + R;
        let q = 0;
        for (let X = 0; X < z; X++)
          for (let I = 0; I < z; I++) {
            const U = k + X - L, F = R + I - L;
            if (U >= 0 && U < T && F >= 0 && F < w) {
              const Z = U * w + F, te = P[X * z + I];
              q += S[Z] * te;
            }
          }
        x[B] = q;
      }
    return x;
  }
  const E = function(S) {
    const w = this.threshold();
    let T = d(S, w);
    return T && (T = g(T, S.width, S.height), T = h(T, S.width, S.height), T = v(T, S.width, S.height), f(S, T)), S;
  };
  return Ap.Mask = E, e.Factory.addGetterSetter(t.Node, "threshold", 0, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Ap;
}
var Mp = {}, x4;
function DA() {
  if (x4) return Mp;
  x4 = 1, Object.defineProperty(Mp, "__esModule", { value: !0 }), Mp.Noise = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = this.noise() * 255, d = l.data, f = d.length, g = u / 2;
    for (let h = 0; h < f; h += 4)
      d[h + 0] += g - 2 * g * Math.random(), d[h + 1] += g - 2 * g * Math.random(), d[h + 2] += g - 2 * g * Math.random();
  };
  return Mp.Noise = o, e.Factory.addGetterSetter(t.Node, "noise", 0.2, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Mp;
}
var Pp = {}, k4;
function LA() {
  if (k4) return Pp;
  k4 = 1, Object.defineProperty(Pp, "__esModule", { value: !0 }), Pp.Pixelate = void 0;
  const e = On(), t = jr(), r = ra(), o = Vn(), l = function(u) {
    let d = Math.ceil(this.pixelSize()), f = u.width, g = u.height, h = Math.ceil(f / d), v = Math.ceil(g / d), E = u.data;
    if (d <= 0) {
      t.Util.error("pixelSize value can not be <= 0");
      return;
    }
    for (let S = 0; S < h; S += 1)
      for (let w = 0; w < v; w += 1) {
        let T = 0, P = 0, z = 0, L = 0;
        const x = S * d, k = x + d, R = w * d, B = R + d;
        let q = 0;
        for (let X = x; X < k; X += 1)
          if (!(X >= f))
            for (let I = R; I < B; I += 1) {
              if (I >= g)
                continue;
              const U = (f * I + X) * 4;
              T += E[U + 0], P += E[U + 1], z += E[U + 2], L += E[U + 3], q += 1;
            }
        T = T / q, P = P / q, z = z / q, L = L / q;
        for (let X = x; X < k; X += 1)
          if (!(X >= f))
            for (let I = R; I < B; I += 1) {
              if (I >= g)
                continue;
              const U = (f * I + X) * 4;
              E[U + 0] = T, E[U + 1] = P, E[U + 2] = z, E[U + 3] = L;
            }
      }
  };
  return Pp.Pixelate = l, e.Factory.addGetterSetter(r.Node, "pixelSize", 8, (0, o.getNumberValidator)(), e.Factory.afterSetFilter), Pp;
}
var Dp = {}, C4;
function OA() {
  if (C4) return Dp;
  C4 = 1, Object.defineProperty(Dp, "__esModule", { value: !0 }), Dp.Posterize = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = Math.round(this.levels() * 254) + 1, d = l.data, f = d.length, g = 255 / u;
    for (let h = 0; h < f; h += 1)
      d[h] = Math.floor(d[h] / g) * g;
  };
  return Dp.Posterize = o, e.Factory.addGetterSetter(t.Node, "levels", 0.5, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Dp;
}
var Lp = {}, E4;
function FA() {
  if (E4) return Lp;
  E4 = 1, Object.defineProperty(Lp, "__esModule", { value: !0 }), Lp.RGB = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = l.data, d = u.length, f = this.red(), g = this.green(), h = this.blue();
    for (let v = 0; v < d; v += 4) {
      const E = (0.34 * u[v] + 0.5 * u[v + 1] + 0.16 * u[v + 2]) / 255;
      u[v] = E * f, u[v + 1] = E * g, u[v + 2] = E * h, u[v + 3] = u[v + 3];
    }
  };
  return Lp.RGB = o, e.Factory.addGetterSetter(t.Node, "red", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
  }), e.Factory.addGetterSetter(t.Node, "green", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
  }), e.Factory.addGetterSetter(t.Node, "blue", 0, r.RGBComponent, e.Factory.afterSetFilter), Lp;
}
var Op = {}, R4;
function zA() {
  if (R4) return Op;
  R4 = 1, Object.defineProperty(Op, "__esModule", { value: !0 }), Op.RGBA = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = l.data, d = u.length, f = this.red(), g = this.green(), h = this.blue(), v = this.alpha();
    for (let E = 0; E < d; E += 4) {
      const S = 1 - v;
      u[E] = f * v + u[E] * S, u[E + 1] = g * v + u[E + 1] * S, u[E + 2] = h * v + u[E + 2] * S;
    }
  };
  return Op.RGBA = o, e.Factory.addGetterSetter(t.Node, "red", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
  }), e.Factory.addGetterSetter(t.Node, "green", 0, function(l) {
    return this._filterUpToDate = !1, l > 255 ? 255 : l < 0 ? 0 : Math.round(l);
  }), e.Factory.addGetterSetter(t.Node, "blue", 0, r.RGBComponent, e.Factory.afterSetFilter), e.Factory.addGetterSetter(t.Node, "alpha", 1, function(l) {
    return this._filterUpToDate = !1, l > 1 ? 1 : l < 0 ? 0 : l;
  }), Op;
}
var Fp = {}, T4;
function BA() {
  if (T4) return Fp;
  T4 = 1, Object.defineProperty(Fp, "__esModule", { value: !0 }), Fp.Sepia = void 0;
  const e = function(t) {
    const r = t.data, o = r.length;
    for (let l = 0; l < o; l += 4) {
      const u = r[l + 0], d = r[l + 1], f = r[l + 2];
      r[l + 0] = Math.min(255, u * 0.393 + d * 0.769 + f * 0.189), r[l + 1] = Math.min(255, u * 0.349 + d * 0.686 + f * 0.168), r[l + 2] = Math.min(255, u * 0.272 + d * 0.534 + f * 0.131);
    }
  };
  return Fp.Sepia = e, Fp;
}
var zp = {}, N4;
function UA() {
  if (N4) return zp;
  N4 = 1, Object.defineProperty(zp, "__esModule", { value: !0 }), zp.Solarize = void 0;
  const e = function(t) {
    const r = t.data, o = t.width, l = t.height, u = o * 4;
    let d = l;
    do {
      const f = (d - 1) * u;
      let g = o;
      do {
        const h = f + (g - 1) * 4;
        let v = r[h], E = r[h + 1], S = r[h + 2];
        v > 127 && (v = 255 - v), E > 127 && (E = 255 - E), S > 127 && (S = 255 - S), r[h] = v, r[h + 1] = E, r[h + 2] = S;
      } while (--g);
    } while (--d);
  };
  return zp.Solarize = e, zp;
}
var Bp = {}, A4;
function IA() {
  if (A4) return Bp;
  A4 = 1, Object.defineProperty(Bp, "__esModule", { value: !0 }), Bp.Threshold = void 0;
  const e = On(), t = ra(), r = Vn(), o = function(l) {
    const u = this.threshold() * 255, d = l.data, f = d.length;
    for (let g = 0; g < f; g += 1)
      d[g] = d[g] < u ? 0 : 255;
  };
  return Bp.Threshold = o, e.Factory.addGetterSetter(t.Node, "threshold", 0.5, (0, r.getNumberValidator)(), e.Factory.afterSetFilter), Bp;
}
var M4;
function HA() {
  if (M4) return Jh;
  M4 = 1, Object.defineProperty(Jh, "__esModule", { value: !0 }), Jh.Konva = void 0;
  const e = K2(), t = lA(), r = cA(), o = dA(), l = fA(), u = hA(), d = pA(), f = z6(), g = wb(), h = B6(), v = mA(), E = gA(), S = vA(), w = yA(), T = U6(), P = bA(), z = _A(), L = SA(), x = wA(), k = xA(), R = kA(), B = CA(), q = EA(), X = RA(), I = TA(), U = NA(), F = AA(), Z = MA(), te = PA(), ie = DA(), ue = LA(), ce = OA(), ze = FA(), W = zA(), j = BA(), ee = UA(), Q = IA();
  return Jh.Konva = e.Konva.Util._assign(e.Konva, {
    Arc: t.Arc,
    Arrow: r.Arrow,
    Circle: o.Circle,
    Ellipse: l.Ellipse,
    Image: u.Image,
    Label: d.Label,
    Tag: d.Tag,
    Line: f.Line,
    Path: g.Path,
    Rect: h.Rect,
    RegularPolygon: v.RegularPolygon,
    Ring: E.Ring,
    Sprite: S.Sprite,
    Star: w.Star,
    Text: T.Text,
    TextPath: P.TextPath,
    Transformer: z.Transformer,
    Wedge: L.Wedge,
    Filters: {
      Blur: x.Blur,
      Brighten: k.Brighten,
      Contrast: R.Contrast,
      Emboss: B.Emboss,
      Enhance: q.Enhance,
      Grayscale: X.Grayscale,
      HSL: I.HSL,
      HSV: U.HSV,
      Invert: F.Invert,
      Kaleidoscope: Z.Kaleidoscope,
      Mask: te.Mask,
      Noise: ie.Noise,
      Pixelate: ue.Pixelate,
      Posterize: ce.Posterize,
      RGB: ze.RGB,
      RGBA: W.RGBA,
      Sepia: j.Sepia,
      Solarize: ee.Solarize,
      Threshold: Q.Threshold
    }
  }), Jh;
}
var GA = p0.exports, P4;
function VA() {
  if (P4) return p0.exports;
  P4 = 1, Object.defineProperty(GA, "__esModule", { value: !0 });
  const e = HA();
  return p0.exports = e.Konva, p0.exports;
}
var qA = VA();
const D4 = /* @__PURE__ */ vm(qA);
var o0 = { exports: {} }, L4;
function WA() {
  return L4 || (L4 = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Konva = void 0;
    var r = K2();
    Object.defineProperty(t, "Konva", { enumerable: !0, get: function() {
      return r.Konva;
    } });
    const o = K2();
    e.exports = o.Konva;
  })(o0, o0.exports)), o0.exports;
}
var KA = WA();
const cm = /* @__PURE__ */ vm(KA);
var s0 = { exports: {} }, l0 = { exports: {} }, Uy = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O4;
function jA() {
  return O4 || (O4 = 1, (function(e) {
    function t(j, ee) {
      var Q = j.length;
      j.push(ee);
      e: for (; 0 < Q; ) {
        var oe = Q - 1 >>> 1, ye = j[oe];
        if (0 < l(ye, ee)) j[oe] = ee, j[Q] = ye, Q = oe;
        else break e;
      }
    }
    function r(j) {
      return j.length === 0 ? null : j[0];
    }
    function o(j) {
      if (j.length === 0) return null;
      var ee = j[0], Q = j.pop();
      if (Q !== ee) {
        j[0] = Q;
        e: for (var oe = 0, ye = j.length, pe = ye >>> 1; oe < pe; ) {
          var Me = 2 * (oe + 1) - 1, We = j[Me], Ee = Me + 1, ae = j[Ee];
          if (0 > l(We, Q)) Ee < ye && 0 > l(ae, We) ? (j[oe] = ae, j[Ee] = Q, oe = Ee) : (j[oe] = We, j[Me] = Q, oe = Me);
          else if (Ee < ye && 0 > l(ae, Q)) j[oe] = ae, j[Ee] = Q, oe = Ee;
          else break e;
        }
      }
      return ee;
    }
    function l(j, ee) {
      var Q = j.sortIndex - ee.sortIndex;
      return Q !== 0 ? Q : j.id - ee.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var u = performance;
      e.unstable_now = function() {
        return u.now();
      };
    } else {
      var d = Date, f = d.now();
      e.unstable_now = function() {
        return d.now() - f;
      };
    }
    var g = [], h = [], v = 1, E = null, S = 3, w = !1, T = !1, P = !1, z = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, x = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function k(j) {
      for (var ee = r(h); ee !== null; ) {
        if (ee.callback === null) o(h);
        else if (ee.startTime <= j) o(h), ee.sortIndex = ee.expirationTime, t(g, ee);
        else break;
        ee = r(h);
      }
    }
    function R(j) {
      if (P = !1, k(j), !T) if (r(g) !== null) T = !0, ze(B);
      else {
        var ee = r(h);
        ee !== null && W(R, ee.startTime - j);
      }
    }
    function B(j, ee) {
      T = !1, P && (P = !1, L(I), I = -1), w = !0;
      var Q = S;
      try {
        for (k(ee), E = r(g); E !== null && (!(E.expirationTime > ee) || j && !Z()); ) {
          var oe = E.callback;
          if (typeof oe == "function") {
            E.callback = null, S = E.priorityLevel;
            var ye = oe(E.expirationTime <= ee);
            ee = e.unstable_now(), typeof ye == "function" ? E.callback = ye : E === r(g) && o(g), k(ee);
          } else o(g);
          E = r(g);
        }
        if (E !== null) var pe = !0;
        else {
          var Me = r(h);
          Me !== null && W(R, Me.startTime - ee), pe = !1;
        }
        return pe;
      } finally {
        E = null, S = Q, w = !1;
      }
    }
    var q = !1, X = null, I = -1, U = 5, F = -1;
    function Z() {
      return !(e.unstable_now() - F < U);
    }
    function te() {
      if (X !== null) {
        var j = e.unstable_now();
        F = j;
        var ee = !0;
        try {
          ee = X(!0, j);
        } finally {
          ee ? ie() : (q = !1, X = null);
        }
      } else q = !1;
    }
    var ie;
    if (typeof x == "function") ie = function() {
      x(te);
    };
    else if (typeof MessageChannel < "u") {
      var ue = new MessageChannel(), ce = ue.port2;
      ue.port1.onmessage = te, ie = function() {
        ce.postMessage(null);
      };
    } else ie = function() {
      z(te, 0);
    };
    function ze(j) {
      X = j, q || (q = !0, ie());
    }
    function W(j, ee) {
      I = z(function() {
        j(e.unstable_now());
      }, ee);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(j) {
      j.callback = null;
    }, e.unstable_continueExecution = function() {
      T || w || (T = !0, ze(B));
    }, e.unstable_forceFrameRate = function(j) {
      0 > j || 125 < j ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : U = 0 < j ? Math.floor(1e3 / j) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return S;
    }, e.unstable_getFirstCallbackNode = function() {
      return r(g);
    }, e.unstable_next = function(j) {
      switch (S) {
        case 1:
        case 2:
        case 3:
          var ee = 3;
          break;
        default:
          ee = S;
      }
      var Q = S;
      S = ee;
      try {
        return j();
      } finally {
        S = Q;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(j, ee) {
      switch (j) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          j = 3;
      }
      var Q = S;
      S = j;
      try {
        return ee();
      } finally {
        S = Q;
      }
    }, e.unstable_scheduleCallback = function(j, ee, Q) {
      var oe = e.unstable_now();
      switch (typeof Q == "object" && Q !== null ? (Q = Q.delay, Q = typeof Q == "number" && 0 < Q ? oe + Q : oe) : Q = oe, j) {
        case 1:
          var ye = -1;
          break;
        case 2:
          ye = 250;
          break;
        case 5:
          ye = 1073741823;
          break;
        case 4:
          ye = 1e4;
          break;
        default:
          ye = 5e3;
      }
      return ye = Q + ye, j = { id: v++, callback: ee, priorityLevel: j, startTime: Q, expirationTime: ye, sortIndex: -1 }, Q > oe ? (j.sortIndex = Q, t(h, j), r(g) === null && j === r(h) && (P ? (L(I), I = -1) : P = !0, W(R, Q - oe))) : (j.sortIndex = ye, t(g, j), T || w || (T = !0, ze(B))), j;
    }, e.unstable_shouldYield = Z, e.unstable_wrapCallback = function(j) {
      var ee = S;
      return function() {
        var Q = S;
        S = ee;
        try {
          return j.apply(this, arguments);
        } finally {
          S = Q;
        }
      };
    };
  })(Uy)), Uy;
}
var Iy = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F4;
function YA() {
  return F4 || (F4 = 1, (function(e) {
    process.env.NODE_ENV !== "production" && (function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, r = 5;
      function o(ot, Tt) {
        var Ut = ot.length;
        ot.push(Tt), d(ot, Tt, Ut);
      }
      function l(ot) {
        return ot.length === 0 ? null : ot[0];
      }
      function u(ot) {
        if (ot.length === 0)
          return null;
        var Tt = ot[0], Ut = ot.pop();
        return Ut !== Tt && (ot[0] = Ut, f(ot, Ut, 0)), Tt;
      }
      function d(ot, Tt, Ut) {
        for (var Ft = Ut; Ft > 0; ) {
          var Fn = Ft - 1 >>> 1, _n = ot[Fn];
          if (g(_n, Tt) > 0)
            ot[Fn] = Tt, ot[Ft] = _n, Ft = Fn;
          else
            return;
        }
      }
      function f(ot, Tt, Ut) {
        for (var Ft = Ut, Fn = ot.length, _n = Fn >>> 1; Ft < _n; ) {
          var qe = (Ft + 1) * 2 - 1, gt = ot[qe], Dn = qe + 1, Tn = ot[Dn];
          if (g(gt, Tt) < 0)
            Dn < Fn && g(Tn, gt) < 0 ? (ot[Ft] = Tn, ot[Dn] = Tt, Ft = Dn) : (ot[Ft] = gt, ot[qe] = Tt, Ft = qe);
          else if (Dn < Fn && g(Tn, Tt) < 0)
            ot[Ft] = Tn, ot[Dn] = Tt, Ft = Dn;
          else
            return;
        }
      }
      function g(ot, Tt) {
        var Ut = ot.sortIndex - Tt.sortIndex;
        return Ut !== 0 ? Ut : ot.id - Tt.id;
      }
      var h = 1, v = 2, E = 3, S = 4, w = 5;
      function T(ot, Tt) {
      }
      var P = typeof performance == "object" && typeof performance.now == "function";
      if (P) {
        var z = performance;
        e.unstable_now = function() {
          return z.now();
        };
      } else {
        var L = Date, x = L.now();
        e.unstable_now = function() {
          return L.now() - x;
        };
      }
      var k = 1073741823, R = -1, B = 250, q = 5e3, X = 1e4, I = k, U = [], F = [], Z = 1, te = null, ie = E, ue = !1, ce = !1, ze = !1, W = typeof setTimeout == "function" ? setTimeout : null, j = typeof clearTimeout == "function" ? clearTimeout : null, ee = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function Q(ot) {
        for (var Tt = l(F); Tt !== null; ) {
          if (Tt.callback === null)
            u(F);
          else if (Tt.startTime <= ot)
            u(F), Tt.sortIndex = Tt.expirationTime, o(U, Tt);
          else
            return;
          Tt = l(F);
        }
      }
      function oe(ot) {
        if (ze = !1, Q(ot), !ce)
          if (l(U) !== null)
            ce = !0, er(ye);
          else {
            var Tt = l(F);
            Tt !== null && ln(oe, Tt.startTime - ot);
          }
      }
      function ye(ot, Tt) {
        ce = !1, ze && (ze = !1, dr()), ue = !0;
        var Ut = ie;
        try {
          var Ft;
          if (!t) return pe(ot, Tt);
        } finally {
          te = null, ie = Ut, ue = !1;
        }
      }
      function pe(ot, Tt) {
        var Ut = Tt;
        for (Q(Ut), te = l(U); te !== null && !(te.expirationTime > Ut && (!ot || bn())); ) {
          var Ft = te.callback;
          if (typeof Ft == "function") {
            te.callback = null, ie = te.priorityLevel;
            var Fn = te.expirationTime <= Ut, _n = Ft(Fn);
            Ut = e.unstable_now(), typeof _n == "function" ? te.callback = _n : te === l(U) && u(U), Q(Ut);
          } else
            u(U);
          te = l(U);
        }
        if (te !== null)
          return !0;
        var qe = l(F);
        return qe !== null && ln(oe, qe.startTime - Ut), !1;
      }
      function Me(ot, Tt) {
        switch (ot) {
          case h:
          case v:
          case E:
          case S:
          case w:
            break;
          default:
            ot = E;
        }
        var Ut = ie;
        ie = ot;
        try {
          return Tt();
        } finally {
          ie = Ut;
        }
      }
      function We(ot) {
        var Tt;
        switch (ie) {
          case h:
          case v:
          case E:
            Tt = E;
            break;
          default:
            Tt = ie;
            break;
        }
        var Ut = ie;
        ie = Tt;
        try {
          return ot();
        } finally {
          ie = Ut;
        }
      }
      function Ee(ot) {
        var Tt = ie;
        return function() {
          var Ut = ie;
          ie = Tt;
          try {
            return ot.apply(this, arguments);
          } finally {
            ie = Ut;
          }
        };
      }
      function ae(ot, Tt, Ut) {
        var Ft = e.unstable_now(), Fn;
        if (typeof Ut == "object" && Ut !== null) {
          var _n = Ut.delay;
          typeof _n == "number" && _n > 0 ? Fn = Ft + _n : Fn = Ft;
        } else
          Fn = Ft;
        var qe;
        switch (ot) {
          case h:
            qe = R;
            break;
          case v:
            qe = B;
            break;
          case w:
            qe = I;
            break;
          case S:
            qe = X;
            break;
          case E:
          default:
            qe = q;
            break;
        }
        var gt = Fn + qe, Dn = {
          id: Z++,
          callback: Tt,
          priorityLevel: ot,
          startTime: Fn,
          expirationTime: gt,
          sortIndex: -1
        };
        return Fn > Ft ? (Dn.sortIndex = Fn, o(F, Dn), l(U) === null && Dn === l(F) && (ze ? dr() : ze = !0, ln(oe, Fn - Ft))) : (Dn.sortIndex = gt, o(U, Dn), !ce && !ue && (ce = !0, er(ye))), Dn;
      }
      function Re() {
      }
      function Qe() {
        !ce && !ue && (ce = !0, er(ye));
      }
      function Pe() {
        return l(U);
      }
      function rt(ot) {
        ot.callback = null;
      }
      function st() {
        return ie;
      }
      var bt = !1, Xt = null, Lt = -1, qn = r, Wt = -1;
      function bn() {
        var ot = e.unstable_now() - Wt;
        return !(ot < qn);
      }
      function Yr() {
      }
      function Pn(ot) {
        if (ot < 0 || ot > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        ot > 0 ? qn = Math.floor(1e3 / ot) : qn = r;
      }
      var gn = function() {
        if (Xt !== null) {
          var ot = e.unstable_now();
          Wt = ot;
          var Tt = !0, Ut = !0;
          try {
            Ut = Xt(Tt, ot);
          } finally {
            Ut ? vn() : (bt = !1, Xt = null);
          }
        } else
          bt = !1;
      }, vn;
      if (typeof ee == "function")
        vn = function() {
          ee(gn);
        };
      else if (typeof MessageChannel < "u") {
        var ir = new MessageChannel(), cr = ir.port2;
        ir.port1.onmessage = gn, vn = function() {
          cr.postMessage(null);
        };
      } else
        vn = function() {
          W(gn, 0);
        };
      function er(ot) {
        Xt = ot, bt || (bt = !0, vn());
      }
      function ln(ot, Tt) {
        Lt = W(function() {
          ot(e.unstable_now());
        }, Tt);
      }
      function dr() {
        j(Lt), Lt = -1;
      }
      var kn = Yr, tr = null;
      e.unstable_IdlePriority = w, e.unstable_ImmediatePriority = h, e.unstable_LowPriority = S, e.unstable_NormalPriority = E, e.unstable_Profiling = tr, e.unstable_UserBlockingPriority = v, e.unstable_cancelCallback = rt, e.unstable_continueExecution = Qe, e.unstable_forceFrameRate = Pn, e.unstable_getCurrentPriorityLevel = st, e.unstable_getFirstCallbackNode = Pe, e.unstable_next = We, e.unstable_pauseExecution = Re, e.unstable_requestPaint = kn, e.unstable_runWithPriority = Me, e.unstable_scheduleCallback = ae, e.unstable_shouldYield = bn, e.unstable_wrapCallback = Ee, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    })();
  })(Iy)), Iy;
}
var z4;
function xb() {
  return z4 || (z4 = 1, process.env.NODE_ENV === "production" ? l0.exports = jA() : l0.exports = YA()), l0.exports;
}
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hy, B4;
function ZA() {
  return B4 || (B4 = 1, Hy = function(t) {
    var r = {}, o = na, l = xb(), u = Object.assign;
    function d(i) {
      for (var s = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, y = 1; y < arguments.length; y++) s += "&args[]=" + encodeURIComponent(arguments[y]);
      return "Minified React error #" + i + "; visit " + s + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var f = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, g = Symbol.for("react.element"), h = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), S = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), T = Symbol.for("react.context"), P = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), L = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), k = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), B = Symbol.iterator;
    function q(i) {
      return i === null || typeof i != "object" ? null : (i = B && i[B] || i["@@iterator"], typeof i == "function" ? i : null);
    }
    function X(i) {
      if (i == null) return null;
      if (typeof i == "function") return i.displayName || i.name || null;
      if (typeof i == "string") return i;
      switch (i) {
        case v:
          return "Fragment";
        case h:
          return "Portal";
        case S:
          return "Profiler";
        case E:
          return "StrictMode";
        case z:
          return "Suspense";
        case L:
          return "SuspenseList";
      }
      if (typeof i == "object") switch (i.$$typeof) {
        case T:
          return (i.displayName || "Context") + ".Consumer";
        case w:
          return (i._context.displayName || "Context") + ".Provider";
        case P:
          var s = i.render;
          return i = i.displayName, i || (i = s.displayName || s.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
        case x:
          return s = i.displayName || null, s !== null ? s : X(i.type) || "Memo";
        case k:
          s = i._payload, i = i._init;
          try {
            return X(i(s));
          } catch {
          }
      }
      return null;
    }
    function I(i) {
      var s = i.type;
      switch (i.tag) {
        case 24:
          return "Cache";
        case 9:
          return (s.displayName || "Context") + ".Consumer";
        case 10:
          return (s._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return i = s.render, i = i.displayName || i.name || "", s.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return s;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return X(s);
        case 8:
          return s === E ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if (typeof s == "function") return s.displayName || s.name || null;
          if (typeof s == "string") return s;
      }
      return null;
    }
    function U(i) {
      var s = i, y = i;
      if (i.alternate) for (; s.return; ) s = s.return;
      else {
        i = s;
        do
          s = i, (s.flags & 4098) !== 0 && (y = s.return), i = s.return;
        while (i);
      }
      return s.tag === 3 ? y : null;
    }
    function F(i) {
      if (U(i) !== i) throw Error(d(188));
    }
    function Z(i) {
      var s = i.alternate;
      if (!s) {
        if (s = U(i), s === null) throw Error(d(188));
        return s !== i ? null : i;
      }
      for (var y = i, C = s; ; ) {
        var A = y.return;
        if (A === null) break;
        var H = A.alternate;
        if (H === null) {
          if (C = A.return, C !== null) {
            y = C;
            continue;
          }
          break;
        }
        if (A.child === H.child) {
          for (H = A.child; H; ) {
            if (H === y) return F(A), i;
            if (H === C) return F(A), s;
            H = H.sibling;
          }
          throw Error(d(188));
        }
        if (y.return !== C.return) y = A, C = H;
        else {
          for (var ne = !1, Ce = A.child; Ce; ) {
            if (Ce === y) {
              ne = !0, y = A, C = H;
              break;
            }
            if (Ce === C) {
              ne = !0, C = A, y = H;
              break;
            }
            Ce = Ce.sibling;
          }
          if (!ne) {
            for (Ce = H.child; Ce; ) {
              if (Ce === y) {
                ne = !0, y = H, C = A;
                break;
              }
              if (Ce === C) {
                ne = !0, C = H, y = A;
                break;
              }
              Ce = Ce.sibling;
            }
            if (!ne) throw Error(d(189));
          }
        }
        if (y.alternate !== C) throw Error(d(190));
      }
      if (y.tag !== 3) throw Error(d(188));
      return y.stateNode.current === y ? i : s;
    }
    function te(i) {
      return i = Z(i), i !== null ? ie(i) : null;
    }
    function ie(i) {
      if (i.tag === 5 || i.tag === 6) return i;
      for (i = i.child; i !== null; ) {
        var s = ie(i);
        if (s !== null) return s;
        i = i.sibling;
      }
      return null;
    }
    function ue(i) {
      if (i.tag === 5 || i.tag === 6) return i;
      for (i = i.child; i !== null; ) {
        if (i.tag !== 4) {
          var s = ue(i);
          if (s !== null) return s;
        }
        i = i.sibling;
      }
      return null;
    }
    var ce = Array.isArray, ze = t.getPublicInstance, W = t.getRootHostContext, j = t.getChildHostContext, ee = t.prepareForCommit, Q = t.resetAfterCommit, oe = t.createInstance, ye = t.appendInitialChild, pe = t.finalizeInitialChildren, Me = t.prepareUpdate, We = t.shouldSetTextContent, Ee = t.createTextInstance, ae = t.scheduleTimeout, Re = t.cancelTimeout, Qe = t.noTimeout, Pe = t.isPrimaryRenderer, rt = t.supportsMutation, st = t.supportsPersistence, bt = t.supportsHydration, Xt = t.getInstanceFromNode, Lt = t.preparePortalMount, qn = t.getCurrentEventPriority, Wt = t.detachDeletedInstance, bn = t.supportsMicrotasks, Yr = t.scheduleMicrotask, Pn = t.supportsTestSelectors, gn = t.findFiberRoot, vn = t.getBoundingRect, ir = t.getTextContent, cr = t.isHiddenSubtree, er = t.matchAccessibilityRole, ln = t.setFocusIfFocusable, dr = t.setupIntersectionObserver, kn = t.appendChild, tr = t.appendChildToContainer, ot = t.commitTextUpdate, Tt = t.commitMount, Ut = t.commitUpdate, Ft = t.insertBefore, Fn = t.insertInContainerBefore, _n = t.removeChild, qe = t.removeChildFromContainer, gt = t.resetTextContent, Dn = t.hideInstance, Tn = t.hideTextInstance, Xe = t.unhideInstance, Ue = t.unhideTextInstance, _t = t.clearContainer, or = t.cloneInstance, xt = t.createContainerChildSet, zn = t.appendChildToContainerChildSet, aa = t.finalizeContainerChildren, Zr = t.replaceContainerChildren, mr = t.cloneHiddenInstance, Xr = t.cloneHiddenTextInstance, de = t.canHydrateInstance, et = t.canHydrateTextInstance, Ge = t.canHydrateSuspenseInstance, kt = t.isSuspenseInstancePending, Et = t.isSuspenseInstanceFallback, Xn = t.getSuspenseInstanceFallbackErrorDetails, en = t.registerSuspenseInstanceRetry, Vt = t.getNextHydratableSibling, yn = t.getFirstHydratableChild, Tr = t.getFirstHydratableChildWithinContainer, Nr = t.getFirstHydratableChildWithinSuspenseInstance, vr = t.hydrateInstance, Ti = t.hydrateTextInstance, Qo = t.hydrateSuspenseInstance, ma = t.getNextHydratableInstanceAfterSuspenseInstance, ga = t.commitHydratedContainer, Qr = t.commitHydratedSuspenseInstance, Jo = t.clearSuspenseBoundary, Co = t.clearSuspenseBoundaryFromContainer, yr = t.shouldDeleteUnhydratedTailInstances, oo = t.didNotMatchHydratedContainerTextInstance, li = t.didNotMatchHydratedTextInstance, $o;
    function qi(i) {
      if ($o === void 0) try {
        throw Error();
      } catch (y) {
        var s = y.stack.trim().match(/\n( *(at )?)/);
        $o = s && s[1] || "";
      }
      return `
` + $o + i;
    }
    var Rs = !1;
    function vl(i, s) {
      if (!i || Rs) return "";
      Rs = !0;
      var y = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (s) if (s = function() {
          throw Error();
        }, Object.defineProperty(s.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(s, []);
          } catch (ut) {
            var C = ut;
          }
          Reflect.construct(i, [], s);
        } else {
          try {
            s.call();
          } catch (ut) {
            C = ut;
          }
          i.call(s.prototype);
        }
        else {
          try {
            throw Error();
          } catch (ut) {
            C = ut;
          }
          i();
        }
      } catch (ut) {
        if (ut && C && typeof ut.stack == "string") {
          for (var A = ut.stack.split(`
`), H = C.stack.split(`
`), ne = A.length - 1, Ce = H.length - 1; 1 <= ne && 0 <= Ce && A[ne] !== H[Ce]; ) Ce--;
          for (; 1 <= ne && 0 <= Ce; ne--, Ce--) if (A[ne] !== H[Ce]) {
            if (ne !== 1 || Ce !== 1)
              do
                if (ne--, Ce--, 0 > Ce || A[ne] !== H[Ce]) {
                  var Ie = `
` + A[ne].replace(" at new ", " at ");
                  return i.displayName && Ie.includes("<anonymous>") && (Ie = Ie.replace("<anonymous>", i.displayName)), Ie;
                }
              while (1 <= ne && 0 <= Ce);
            break;
          }
        }
      } finally {
        Rs = !1, Error.prepareStackTrace = y;
      }
      return (i = i ? i.displayName || i.name : "") ? qi(i) : "";
    }
    var Eo = Object.prototype.hasOwnProperty, Jl = [], wr = -1;
    function Ni(i) {
      return { current: i };
    }
    function It(i) {
      0 > wr || (i.current = Jl[wr], Jl[wr] = null, wr--);
    }
    function nr(i, s) {
      wr++, Jl[wr] = i.current, i.current = s;
    }
    var so = {}, Ar = Ni(so), zr = Ni(!1), Wi = so;
    function Ro(i, s) {
      var y = i.type.contextTypes;
      if (!y) return so;
      var C = i.stateNode;
      if (C && C.__reactInternalMemoizedUnmaskedChildContext === s) return C.__reactInternalMemoizedMaskedChildContext;
      var A = {}, H;
      for (H in y) A[H] = s[H];
      return C && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = s, i.__reactInternalMemoizedMaskedChildContext = A), A;
    }
    function ia(i) {
      return i = i.childContextTypes, i != null;
    }
    function Wn() {
      It(zr), It(Ar);
    }
    function es(i, s, y) {
      if (Ar.current !== so) throw Error(d(168));
      nr(Ar, s), nr(zr, y);
    }
    function ts(i, s, y) {
      var C = i.stateNode;
      if (s = s.childContextTypes, typeof C.getChildContext != "function") return y;
      C = C.getChildContext();
      for (var A in C) if (!(A in s)) throw Error(d(108, I(i) || "Unknown", A));
      return u({}, y, C);
    }
    function lo(i) {
      return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || so, Wi = Ar.current, nr(Ar, i), nr(zr, zr.current), !0;
    }
    function Ts(i, s, y) {
      var C = i.stateNode;
      if (!C) throw Error(d(169));
      y ? (i = ts(i, s, Wi), C.__reactInternalMemoizedMergedChildContext = i, It(zr), It(Ar), nr(Ar, i)) : It(zr), nr(zr, y);
    }
    var oa = Math.clz32 ? Math.clz32 : ns, $l = Math.log, Oa = Math.LN2;
    function ns(i) {
      return i >>>= 0, i === 0 ? 32 : 31 - ($l(i) / Oa | 0) | 0;
    }
    var sa = 64, eu = 4194304;
    function wn(i) {
      switch (i & -i) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return i & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return i & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return i;
      }
    }
    function yl(i, s) {
      var y = i.pendingLanes;
      if (y === 0) return 0;
      var C = 0, A = i.suspendedLanes, H = i.pingedLanes, ne = y & 268435455;
      if (ne !== 0) {
        var Ce = ne & ~A;
        Ce !== 0 ? C = wn(Ce) : (H &= ne, H !== 0 && (C = wn(H)));
      } else ne = y & ~A, ne !== 0 ? C = wn(ne) : H !== 0 && (C = wn(H));
      if (C === 0) return 0;
      if (s !== 0 && s !== C && (s & A) === 0 && (A = C & -C, H = s & -s, A >= H || A === 16 && (H & 4194240) !== 0)) return s;
      if ((C & 4) !== 0 && (C |= y & 16), s = i.entangledLanes, s !== 0) for (i = i.entanglements, s &= C; 0 < s; ) y = 31 - oa(s), A = 1 << y, C |= i[y], s &= ~A;
      return C;
    }
    function qf(i, s) {
      switch (i) {
        case 1:
        case 2:
        case 4:
          return s + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return s + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function Wf(i, s) {
      for (var y = i.suspendedLanes, C = i.pingedLanes, A = i.expirationTimes, H = i.pendingLanes; 0 < H; ) {
        var ne = 31 - oa(H), Ce = 1 << ne, Ie = A[ne];
        Ie === -1 ? ((Ce & y) === 0 || (Ce & C) !== 0) && (A[ne] = qf(Ce, s)) : Ie <= s && (i.expiredLanes |= Ce), H &= ~Ce;
      }
    }
    function va(i) {
      return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
    }
    function ui() {
      var i = sa;
      return sa <<= 1, (sa & 4194240) === 0 && (sa = 64), i;
    }
    function Ns(i) {
      for (var s = [], y = 0; 31 > y; y++) s.push(i);
      return s;
    }
    function ci(i, s, y) {
      i.pendingLanes |= s, s !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, s = 31 - oa(s), i[s] = y;
    }
    function hd(i, s) {
      var y = i.pendingLanes & ~s;
      i.pendingLanes = s, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= s, i.mutableReadLanes &= s, i.entangledLanes &= s, s = i.entanglements;
      var C = i.eventTimes;
      for (i = i.expirationTimes; 0 < y; ) {
        var A = 31 - oa(y), H = 1 << A;
        s[A] = 0, C[A] = -1, i[A] = -1, y &= ~H;
      }
    }
    function To(i, s) {
      var y = i.entangledLanes |= s;
      for (i = i.entanglements; y; ) {
        var C = 31 - oa(y), A = 1 << C;
        A & s | i[C] & s && (i[C] |= s), y &= ~A;
      }
    }
    var Jt = 0;
    function di(i) {
      return i &= -i, 1 < i ? 4 < i ? (i & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
    }
    var rs = l.unstable_scheduleCallback, bl = l.unstable_cancelCallback, lc = l.unstable_shouldYield, No = l.unstable_requestPaint, Br = l.unstable_now, fi = l.unstable_ImmediatePriority, uc = l.unstable_UserBlockingPriority, tu = l.unstable_NormalPriority, cc = l.unstable_IdlePriority, Ao = null, Ya = null;
    function pd(i) {
      if (Ya && typeof Ya.onCommitFiberRoot == "function") try {
        Ya.onCommitFiberRoot(Ao, i, void 0, (i.current.flags & 128) === 128);
      } catch {
      }
    }
    function Kf(i, s) {
      return i === s && (i !== 0 || 1 / i === 1 / s) || i !== i && s !== s;
    }
    var ya = typeof Object.is == "function" ? Object.is : Kf, uo = null, nu = !1, As = !1;
    function Ms(i) {
      uo === null ? uo = [i] : uo.push(i);
    }
    function ru(i) {
      nu = !0, Ms(i);
    }
    function Ki() {
      if (!As && uo !== null) {
        As = !0;
        var i = 0, s = Jt;
        try {
          var y = uo;
          for (Jt = 1; i < y.length; i++) {
            var C = y[i];
            do
              C = C(!0);
            while (C !== null);
          }
          uo = null, nu = !1;
        } catch (A) {
          throw uo !== null && (uo = uo.slice(i + 1)), rs(fi, Ki), A;
        } finally {
          Jt = s, As = !1;
        }
      }
      return null;
    }
    var Mo = [], as = 0, is = null, Ps = 0, Za = [], ba = 0, Ai = null, Fa = 1, ji = "";
    function os(i, s) {
      Mo[as++] = Ps, Mo[as++] = is, is = i, Ps = s;
    }
    function Yi(i, s, y) {
      Za[ba++] = Fa, Za[ba++] = ji, Za[ba++] = Ai, Ai = i;
      var C = Fa;
      i = ji;
      var A = 32 - oa(C) - 1;
      C &= ~(1 << A), y += 1;
      var H = 32 - oa(s) + A;
      if (30 < H) {
        var ne = A - A % 5;
        H = (C & (1 << ne) - 1).toString(32), C >>= ne, A -= ne, Fa = 1 << 32 - oa(s) + A | y << A | C, ji = H + i;
      } else Fa = 1 << H | y << A | C, ji = i;
    }
    function ss(i) {
      i.return !== null && (os(i, 1), Yi(i, 1, 0));
    }
    function _l(i) {
      for (; i === is; ) is = Mo[--as], Mo[as] = null, Ps = Mo[--as], Mo[as] = null;
      for (; i === Ai; ) Ai = Za[--ba], Za[ba] = null, ji = Za[--ba], Za[ba] = null, Fa = Za[--ba], Za[ba] = null;
    }
    var _a = null, za = null, sr = !1, Cr = !1, Sa = null;
    function Ds(i, s) {
      var y = zi(5, null, null, 0);
      y.elementType = "DELETED", y.stateNode = s, y.return = i, s = i.deletions, s === null ? (i.deletions = [y], i.flags |= 16) : s.push(y);
    }
    function dc(i, s) {
      switch (i.tag) {
        case 5:
          return s = de(s, i.type, i.pendingProps), s !== null ? (i.stateNode = s, _a = i, za = yn(s), !0) : !1;
        case 6:
          return s = et(s, i.pendingProps), s !== null ? (i.stateNode = s, _a = i, za = null, !0) : !1;
        case 13:
          if (s = Ge(s), s !== null) {
            var y = Ai !== null ? { id: Fa, overflow: ji } : null;
            return i.memoizedState = { dehydrated: s, treeContext: y, retryLane: 1073741824 }, y = zi(18, null, null, 0), y.stateNode = s, y.return = i, i.child = y, _a = i, za = null, !0;
          }
          return !1;
        default:
          return !1;
      }
    }
    function Ls(i) {
      return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
    }
    function au(i) {
      if (sr) {
        var s = za;
        if (s) {
          var y = s;
          if (!dc(i, s)) {
            if (Ls(i)) throw Error(d(418));
            s = Vt(y);
            var C = _a;
            s && dc(i, s) ? Ds(C, y) : (i.flags = i.flags & -4097 | 2, sr = !1, _a = i);
          }
        } else {
          if (Ls(i)) throw Error(d(418));
          i.flags = i.flags & -4097 | 2, sr = !1, _a = i;
        }
      }
    }
    function fc(i) {
      for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; ) i = i.return;
      _a = i;
    }
    function ls(i) {
      if (!bt || i !== _a) return !1;
      if (!sr) return fc(i), sr = !0, !1;
      if (i.tag !== 3 && (i.tag !== 5 || yr(i.type) && !We(i.type, i.memoizedProps))) {
        var s = za;
        if (s) {
          if (Ls(i)) throw iu(), Error(d(418));
          for (; s; ) Ds(i, s), s = Vt(s);
        }
      }
      if (fc(i), i.tag === 13) {
        if (!bt) throw Error(d(316));
        if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(d(317));
        za = ma(i);
      } else za = _a ? Vt(i.stateNode) : null;
      return !0;
    }
    function iu() {
      for (var i = za; i; ) i = Vt(i);
    }
    function hi() {
      bt && (za = _a = null, Cr = sr = !1);
    }
    function Sl(i) {
      Sa === null ? Sa = [i] : Sa.push(i);
    }
    var hc = f.ReactCurrentBatchConfig;
    function us(i, s) {
      if (ya(i, s)) return !0;
      if (typeof i != "object" || i === null || typeof s != "object" || s === null) return !1;
      var y = Object.keys(i), C = Object.keys(s);
      if (y.length !== C.length) return !1;
      for (C = 0; C < y.length; C++) {
        var A = y[C];
        if (!Eo.call(s, A) || !ya(i[A], s[A])) return !1;
      }
      return !0;
    }
    function pc(i) {
      switch (i.tag) {
        case 5:
          return qi(i.type);
        case 16:
          return qi("Lazy");
        case 13:
          return qi("Suspense");
        case 19:
          return qi("SuspenseList");
        case 0:
        case 2:
        case 15:
          return i = vl(i.type, !1), i;
        case 11:
          return i = vl(i.type.render, !1), i;
        case 1:
          return i = vl(i.type, !0), i;
        default:
          return "";
      }
    }
    function Os(i, s, y) {
      if (i = y.ref, i !== null && typeof i != "function" && typeof i != "object") {
        if (y._owner) {
          if (y = y._owner, y) {
            if (y.tag !== 1) throw Error(d(309));
            var C = y.stateNode;
          }
          if (!C) throw Error(d(147, i));
          var A = C, H = "" + i;
          return s !== null && s.ref !== null && typeof s.ref == "function" && s.ref._stringRef === H ? s.ref : (s = function(ne) {
            var Ce = A.refs;
            ne === null ? delete Ce[H] : Ce[H] = ne;
          }, s._stringRef = H, s);
        }
        if (typeof i != "string") throw Error(d(284));
        if (!y._owner) throw Error(d(290, i));
      }
      return i;
    }
    function ou(i, s) {
      throw i = Object.prototype.toString.call(s), Error(d(31, i === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : i));
    }
    function su(i) {
      var s = i._init;
      return s(i._payload);
    }
    function wl(i) {
      function s(Le, xe) {
        if (i) {
          var Ve = Le.deletions;
          Ve === null ? (Le.deletions = [xe], Le.flags |= 16) : Ve.push(xe);
        }
      }
      function y(Le, xe) {
        if (!i) return null;
        for (; xe !== null; ) s(Le, xe), xe = xe.sibling;
        return null;
      }
      function C(Le, xe) {
        for (Le = /* @__PURE__ */ new Map(); xe !== null; ) xe.key !== null ? Le.set(xe.key, xe) : Le.set(xe.index, xe), xe = xe.sibling;
        return Le;
      }
      function A(Le, xe) {
        return Le = ms(Le, xe), Le.index = 0, Le.sibling = null, Le;
      }
      function H(Le, xe, Ve) {
        return Le.index = Ve, i ? (Ve = Le.alternate, Ve !== null ? (Ve = Ve.index, Ve < xe ? (Le.flags |= 2, xe) : Ve) : (Le.flags |= 2, xe)) : (Le.flags |= 1048576, xe);
      }
      function ne(Le) {
        return i && Le.alternate === null && (Le.flags |= 2), Le;
      }
      function Ce(Le, xe, Ve, wt) {
        return xe === null || xe.tag !== 6 ? (xe = Ac(Ve, Le.mode, wt), xe.return = Le, xe) : (xe = A(xe, Ve), xe.return = Le, xe);
      }
      function Ie(Le, xe, Ve, wt) {
        var Yt = Ve.type;
        return Yt === v ? St(Le, xe, Ve.props.children, wt, Ve.key) : xe !== null && (xe.elementType === Yt || typeof Yt == "object" && Yt !== null && Yt.$$typeof === k && su(Yt) === xe.type) ? (wt = A(xe, Ve.props), wt.ref = Os(Le, xe, Ve), wt.return = Le, wt) : (wt = Nc(Ve.type, Ve.key, Ve.props, null, Le.mode, wt), wt.ref = Os(Le, xe, Ve), wt.return = Le, wt);
      }
      function ut(Le, xe, Ve, wt) {
        return xe === null || xe.tag !== 4 || xe.stateNode.containerInfo !== Ve.containerInfo || xe.stateNode.implementation !== Ve.implementation ? (xe = hh(Ve, Le.mode, wt), xe.return = Le, xe) : (xe = A(xe, Ve.children || []), xe.return = Le, xe);
      }
      function St(Le, xe, Ve, wt, Yt) {
        return xe === null || xe.tag !== 7 ? (xe = gs(Ve, Le.mode, wt, Yt), xe.return = Le, xe) : (xe = A(xe, Ve), xe.return = Le, xe);
      }
      function rn(Le, xe, Ve) {
        if (typeof xe == "string" && xe !== "" || typeof xe == "number") return xe = Ac("" + xe, Le.mode, Ve), xe.return = Le, xe;
        if (typeof xe == "object" && xe !== null) {
          switch (xe.$$typeof) {
            case g:
              return Ve = Nc(xe.type, xe.key, xe.props, null, Le.mode, Ve), Ve.ref = Os(Le, null, xe), Ve.return = Le, Ve;
            case h:
              return xe = hh(xe, Le.mode, Ve), xe.return = Le, xe;
            case k:
              var wt = xe._init;
              return rn(Le, wt(xe._payload), Ve);
          }
          if (ce(xe) || q(xe)) return xe = gs(xe, Le.mode, Ve, null), xe.return = Le, xe;
          ou(Le, xe);
        }
        return null;
      }
      function Nt(Le, xe, Ve, wt) {
        var Yt = xe !== null ? xe.key : null;
        if (typeof Ve == "string" && Ve !== "" || typeof Ve == "number") return Yt !== null ? null : Ce(Le, xe, "" + Ve, wt);
        if (typeof Ve == "object" && Ve !== null) {
          switch (Ve.$$typeof) {
            case g:
              return Ve.key === Yt ? Ie(Le, xe, Ve, wt) : null;
            case h:
              return Ve.key === Yt ? ut(Le, xe, Ve, wt) : null;
            case k:
              return Yt = Ve._init, Nt(
                Le,
                xe,
                Yt(Ve._payload),
                wt
              );
          }
          if (ce(Ve) || q(Ve)) return Yt !== null ? null : St(Le, xe, Ve, wt, null);
          ou(Le, Ve);
        }
        return null;
      }
      function _r(Le, xe, Ve, wt, Yt) {
        if (typeof wt == "string" && wt !== "" || typeof wt == "number") return Le = Le.get(Ve) || null, Ce(xe, Le, "" + wt, Yt);
        if (typeof wt == "object" && wt !== null) {
          switch (wt.$$typeof) {
            case g:
              return Le = Le.get(wt.key === null ? Ve : wt.key) || null, Ie(xe, Le, wt, Yt);
            case h:
              return Le = Le.get(wt.key === null ? Ve : wt.key) || null, ut(xe, Le, wt, Yt);
            case k:
              var dn = wt._init;
              return _r(Le, xe, Ve, dn(wt._payload), Yt);
          }
          if (ce(wt) || q(wt)) return Le = Le.get(Ve) || null, St(xe, Le, wt, Yt, null);
          ou(xe, wt);
        }
        return null;
      }
      function mn(Le, xe, Ve, wt) {
        for (var Yt = null, dn = null, an = xe, Nn = xe = 0, Er = null; an !== null && Nn < Ve.length; Nn++) {
          an.index > Nn ? (Er = an, an = null) : Er = an.sibling;
          var An = Nt(Le, an, Ve[Nn], wt);
          if (An === null) {
            an === null && (an = Er);
            break;
          }
          i && an && An.alternate === null && s(Le, an), xe = H(An, xe, Nn), dn === null ? Yt = An : dn.sibling = An, dn = An, an = Er;
        }
        if (Nn === Ve.length) return y(Le, an), sr && os(Le, Nn), Yt;
        if (an === null) {
          for (; Nn < Ve.length; Nn++) an = rn(Le, Ve[Nn], wt), an !== null && (xe = H(an, xe, Nn), dn === null ? Yt = an : dn.sibling = an, dn = an);
          return sr && os(Le, Nn), Yt;
        }
        for (an = C(Le, an); Nn < Ve.length; Nn++) Er = _r(an, Le, Nn, Ve[Nn], wt), Er !== null && (i && Er.alternate !== null && an.delete(Er.key === null ? Nn : Er.key), xe = H(Er, xe, Nn), dn === null ? Yt = Er : dn.sibling = Er, dn = Er);
        return i && an.forEach(function(Si) {
          return s(Le, Si);
        }), sr && os(Le, Nn), Yt;
      }
      function Un(Le, xe, Ve, wt) {
        var Yt = q(Ve);
        if (typeof Yt != "function") throw Error(d(150));
        if (Ve = Yt.call(Ve), Ve == null) throw Error(d(151));
        for (var dn = Yt = null, an = xe, Nn = xe = 0, Er = null, An = Ve.next(); an !== null && !An.done; Nn++, An = Ve.next()) {
          an.index > Nn ? (Er = an, an = null) : Er = an.sibling;
          var Si = Nt(Le, an, An.value, wt);
          if (Si === null) {
            an === null && (an = Er);
            break;
          }
          i && an && Si.alternate === null && s(Le, an), xe = H(Si, xe, Nn), dn === null ? Yt = Si : dn.sibling = Si, dn = Si, an = Er;
        }
        if (An.done) return y(
          Le,
          an
        ), sr && os(Le, Nn), Yt;
        if (an === null) {
          for (; !An.done; Nn++, An = Ve.next()) An = rn(Le, An.value, wt), An !== null && (xe = H(An, xe, Nn), dn === null ? Yt = An : dn.sibling = An, dn = An);
          return sr && os(Le, Nn), Yt;
        }
        for (an = C(Le, an); !An.done; Nn++, An = Ve.next()) An = _r(an, Le, Nn, An.value, wt), An !== null && (i && An.alternate !== null && an.delete(An.key === null ? Nn : An.key), xe = H(An, xe, Nn), dn === null ? Yt = An : dn.sibling = An, dn = An);
        return i && an.forEach(function(Qd) {
          return s(Le, Qd);
        }), sr && os(Le, Nn), Yt;
      }
      function vs(Le, xe, Ve, wt) {
        if (typeof Ve == "object" && Ve !== null && Ve.type === v && Ve.key === null && (Ve = Ve.props.children), typeof Ve == "object" && Ve !== null) {
          switch (Ve.$$typeof) {
            case g:
              e: {
                for (var Yt = Ve.key, dn = xe; dn !== null; ) {
                  if (dn.key === Yt) {
                    if (Yt = Ve.type, Yt === v) {
                      if (dn.tag === 7) {
                        y(Le, dn.sibling), xe = A(dn, Ve.props.children), xe.return = Le, Le = xe;
                        break e;
                      }
                    } else if (dn.elementType === Yt || typeof Yt == "object" && Yt !== null && Yt.$$typeof === k && su(Yt) === dn.type) {
                      y(Le, dn.sibling), xe = A(dn, Ve.props), xe.ref = Os(Le, dn, Ve), xe.return = Le, Le = xe;
                      break e;
                    }
                    y(Le, dn);
                    break;
                  } else s(Le, dn);
                  dn = dn.sibling;
                }
                Ve.type === v ? (xe = gs(Ve.props.children, Le.mode, wt, Ve.key), xe.return = Le, Le = xe) : (wt = Nc(Ve.type, Ve.key, Ve.props, null, Le.mode, wt), wt.ref = Os(Le, xe, Ve), wt.return = Le, Le = wt);
              }
              return ne(Le);
            case h:
              e: {
                for (dn = Ve.key; xe !== null; ) {
                  if (xe.key === dn) if (xe.tag === 4 && xe.stateNode.containerInfo === Ve.containerInfo && xe.stateNode.implementation === Ve.implementation) {
                    y(Le, xe.sibling), xe = A(xe, Ve.children || []), xe.return = Le, Le = xe;
                    break e;
                  } else {
                    y(Le, xe);
                    break;
                  }
                  else s(Le, xe);
                  xe = xe.sibling;
                }
                xe = hh(Ve, Le.mode, wt), xe.return = Le, Le = xe;
              }
              return ne(Le);
            case k:
              return dn = Ve._init, vs(Le, xe, dn(Ve._payload), wt);
          }
          if (ce(Ve)) return mn(Le, xe, Ve, wt);
          if (q(Ve)) return Un(Le, xe, Ve, wt);
          ou(Le, Ve);
        }
        return typeof Ve == "string" && Ve !== "" || typeof Ve == "number" ? (Ve = "" + Ve, xe !== null && xe.tag === 6 ? (y(Le, xe.sibling), xe = A(xe, Ve), xe.return = Le, Le = xe) : (y(Le, xe), xe = Ac(Ve, Le.mode, wt), xe.return = Le, Le = xe), ne(Le)) : y(Le, xe);
      }
      return vs;
    }
    var Fs = wl(!0), lu = wl(!1), zs = Ni(null), uu = null, Mi = null, cu = null;
    function xl() {
      cu = Mi = uu = null;
    }
    function du(i, s, y) {
      Pe ? (nr(zs, s._currentValue), s._currentValue = y) : (nr(zs, s._currentValue2), s._currentValue2 = y);
    }
    function fu(i) {
      var s = zs.current;
      It(zs), Pe ? i._currentValue = s : i._currentValue2 = s;
    }
    function kl(i, s, y) {
      for (; i !== null; ) {
        var C = i.alternate;
        if ((i.childLanes & s) !== s ? (i.childLanes |= s, C !== null && (C.childLanes |= s)) : C !== null && (C.childLanes & s) !== s && (C.childLanes |= s), i === y) break;
        i = i.return;
      }
    }
    function co(i, s) {
      uu = i, cu = Mi = null, i = i.dependencies, i !== null && i.firstContext !== null && ((i.lanes & s) !== 0 && (la = !0), i.firstContext = null);
    }
    function Ba(i) {
      var s = Pe ? i._currentValue : i._currentValue2;
      if (cu !== i) if (i = { context: i, memoizedValue: s, next: null }, Mi === null) {
        if (uu === null) throw Error(d(308));
        Mi = i, uu.dependencies = { lanes: 0, firstContext: i };
      } else Mi = Mi.next = i;
      return s;
    }
    var fo = null;
    function mc(i) {
      fo === null ? fo = [i] : fo.push(i);
    }
    function md(i, s, y, C) {
      var A = s.interleaved;
      return A === null ? (y.next = y, mc(s)) : (y.next = A.next, A.next = y), s.interleaved = y, pi(i, C);
    }
    function pi(i, s) {
      i.lanes |= s;
      var y = i.alternate;
      for (y !== null && (y.lanes |= s), y = i, i = i.return; i !== null; ) i.childLanes |= s, y = i.alternate, y !== null && (y.childLanes |= s), y = i, i = i.return;
      return y.tag === 3 ? y.stateNode : null;
    }
    var Xa = !1;
    function Ur(i) {
      i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function gr(i, s) {
      i = i.updateQueue, s.updateQueue === i && (s.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
    }
    function wa(i, s) {
      return { eventTime: i, lane: s, tag: 0, payload: null, callback: null, next: null };
    }
    function Qa(i, s, y) {
      var C = i.updateQueue;
      if (C === null) return null;
      if (C = C.shared, (xn & 2) !== 0) {
        var A = C.pending;
        return A === null ? s.next = s : (s.next = A.next, A.next = s), C.pending = s, pi(i, y);
      }
      return A = C.interleaved, A === null ? (s.next = s, mc(C)) : (s.next = A.next, A.next = s), C.interleaved = s, pi(i, y);
    }
    function Bs(i, s, y) {
      if (s = s.updateQueue, s !== null && (s = s.shared, (y & 4194240) !== 0)) {
        var C = s.lanes;
        C &= i.pendingLanes, y |= C, s.lanes = y, To(i, y);
      }
    }
    function hu(i, s) {
      var y = i.updateQueue, C = i.alternate;
      if (C !== null && (C = C.updateQueue, y === C)) {
        var A = null, H = null;
        if (y = y.firstBaseUpdate, y !== null) {
          do {
            var ne = { eventTime: y.eventTime, lane: y.lane, tag: y.tag, payload: y.payload, callback: y.callback, next: null };
            H === null ? A = H = ne : H = H.next = ne, y = y.next;
          } while (y !== null);
          H === null ? A = H = s : H = H.next = s;
        } else A = H = s;
        y = { baseState: C.baseState, firstBaseUpdate: A, lastBaseUpdate: H, shared: C.shared, effects: C.effects }, i.updateQueue = y;
        return;
      }
      i = y.lastBaseUpdate, i === null ? y.firstBaseUpdate = s : i.next = s, y.lastBaseUpdate = s;
    }
    function cs(i, s, y, C) {
      var A = i.updateQueue;
      Xa = !1;
      var H = A.firstBaseUpdate, ne = A.lastBaseUpdate, Ce = A.shared.pending;
      if (Ce !== null) {
        A.shared.pending = null;
        var Ie = Ce, ut = Ie.next;
        Ie.next = null, ne === null ? H = ut : ne.next = ut, ne = Ie;
        var St = i.alternate;
        St !== null && (St = St.updateQueue, Ce = St.lastBaseUpdate, Ce !== ne && (Ce === null ? St.firstBaseUpdate = ut : Ce.next = ut, St.lastBaseUpdate = Ie));
      }
      if (H !== null) {
        var rn = A.baseState;
        ne = 0, St = ut = Ie = null, Ce = H;
        do {
          var Nt = Ce.lane, _r = Ce.eventTime;
          if ((C & Nt) === Nt) {
            St !== null && (St = St.next = {
              eventTime: _r,
              lane: 0,
              tag: Ce.tag,
              payload: Ce.payload,
              callback: Ce.callback,
              next: null
            });
            e: {
              var mn = i, Un = Ce;
              switch (Nt = s, _r = y, Un.tag) {
                case 1:
                  if (mn = Un.payload, typeof mn == "function") {
                    rn = mn.call(_r, rn, Nt);
                    break e;
                  }
                  rn = mn;
                  break e;
                case 3:
                  mn.flags = mn.flags & -65537 | 128;
                case 0:
                  if (mn = Un.payload, Nt = typeof mn == "function" ? mn.call(_r, rn, Nt) : mn, Nt == null) break e;
                  rn = u({}, rn, Nt);
                  break e;
                case 2:
                  Xa = !0;
              }
            }
            Ce.callback !== null && Ce.lane !== 0 && (i.flags |= 64, Nt = A.effects, Nt === null ? A.effects = [Ce] : Nt.push(Ce));
          } else _r = { eventTime: _r, lane: Nt, tag: Ce.tag, payload: Ce.payload, callback: Ce.callback, next: null }, St === null ? (ut = St = _r, Ie = rn) : St = St.next = _r, ne |= Nt;
          if (Ce = Ce.next, Ce === null) {
            if (Ce = A.shared.pending, Ce === null) break;
            Nt = Ce, Ce = Nt.next, Nt.next = null, A.lastBaseUpdate = Nt, A.shared.pending = null;
          }
        } while (!0);
        if (St === null && (Ie = rn), A.baseState = Ie, A.firstBaseUpdate = ut, A.lastBaseUpdate = St, s = A.shared.interleaved, s !== null) {
          A = s;
          do
            ne |= A.lane, A = A.next;
          while (A !== s);
        } else H === null && (A.shared.lanes = 0);
        Ol |= ne, i.lanes = ne, i.memoizedState = rn;
      }
    }
    function Po(i, s, y) {
      if (i = s.effects, s.effects = null, i !== null) for (s = 0; s < i.length; s++) {
        var C = i[s], A = C.callback;
        if (A !== null) {
          if (C.callback = null, C = y, typeof A != "function") throw Error(d(191, A));
          A.call(C);
        }
      }
    }
    var ho = {}, Ir = Ni(ho), Ja = Ni(ho), Do = Ni(ho);
    function m(i) {
      if (i === ho) throw Error(d(174));
      return i;
    }
    function _(i, s) {
      nr(Do, s), nr(Ja, i), nr(Ir, ho), i = W(s), It(Ir), nr(Ir, i);
    }
    function M() {
      It(Ir), It(Ja), It(Do);
    }
    function O(i) {
      var s = m(Do.current), y = m(Ir.current);
      s = j(y, i.type, s), y !== s && (nr(Ja, i), nr(Ir, s));
    }
    function V(i) {
      Ja.current === i && (It(Ir), It(Ja));
    }
    var K = Ni(0);
    function J(i) {
      for (var s = i; s !== null; ) {
        if (s.tag === 13) {
          var y = s.memoizedState;
          if (y !== null && (y = y.dehydrated, y === null || kt(y) || Et(y))) return s;
        } else if (s.tag === 19 && s.memoizedProps.revealOrder !== void 0) {
          if ((s.flags & 128) !== 0) return s;
        } else if (s.child !== null) {
          s.child.return = s, s = s.child;
          continue;
        }
        if (s === i) break;
        for (; s.sibling === null; ) {
          if (s.return === null || s.return === i) return null;
          s = s.return;
        }
        s.sibling.return = s.return, s = s.sibling;
      }
      return null;
    }
    var re = [];
    function be() {
      for (var i = 0; i < re.length; i++) {
        var s = re[i];
        Pe ? s._workInProgressVersionPrimary = null : s._workInProgressVersionSecondary = null;
      }
      re.length = 0;
    }
    var ke = f.ReactCurrentDispatcher, _e = f.ReactCurrentBatchConfig, me = 0, fe = null, ve = null, ge = null, Se = !1, we = !1, Te = 0, Ne = 0;
    function Be() {
      throw Error(d(321));
    }
    function Je(i, s) {
      if (s === null) return !1;
      for (var y = 0; y < s.length && y < i.length; y++) if (!ya(i[y], s[y])) return !1;
      return !0;
    }
    function nt(i, s, y, C, A, H) {
      if (me = H, fe = s, s.memoizedState = null, s.updateQueue = null, s.lanes = 0, ke.current = i === null || i.memoizedState === null ? Xf : Qf, i = y(C, A), we) {
        H = 0;
        do {
          if (we = !1, Te = 0, 25 <= H) throw Error(d(301));
          H += 1, ge = ve = null, s.updateQueue = null, ke.current = Jf, i = y(C, A);
        } while (we);
      }
      if (ke.current = mu, s = ve !== null && ve.next !== null, me = 0, ge = ve = fe = null, Se = !1, s) throw Error(d(300));
      return i;
    }
    function lt() {
      var i = Te !== 0;
      return Te = 0, i;
    }
    function tt() {
      var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      return ge === null ? fe.memoizedState = ge = i : ge = ge.next = i, ge;
    }
    function pt() {
      if (ve === null) {
        var i = fe.alternate;
        i = i !== null ? i.memoizedState : null;
      } else i = ve.next;
      var s = ge === null ? fe.memoizedState : ge.next;
      if (s !== null) ge = s, ve = i;
      else {
        if (i === null) throw Error(d(310));
        ve = i, i = { memoizedState: ve.memoizedState, baseState: ve.baseState, baseQueue: ve.baseQueue, queue: ve.queue, next: null }, ge === null ? fe.memoizedState = ge = i : ge = ge.next = i;
      }
      return ge;
    }
    function it(i, s) {
      return typeof s == "function" ? s(i) : s;
    }
    function Mt(i) {
      var s = pt(), y = s.queue;
      if (y === null) throw Error(d(311));
      y.lastRenderedReducer = i;
      var C = ve, A = C.baseQueue, H = y.pending;
      if (H !== null) {
        if (A !== null) {
          var ne = A.next;
          A.next = H.next, H.next = ne;
        }
        C.baseQueue = A = H, y.pending = null;
      }
      if (A !== null) {
        H = A.next, C = C.baseState;
        var Ce = ne = null, Ie = null, ut = H;
        do {
          var St = ut.lane;
          if ((me & St) === St) Ie !== null && (Ie = Ie.next = { lane: 0, action: ut.action, hasEagerState: ut.hasEagerState, eagerState: ut.eagerState, next: null }), C = ut.hasEagerState ? ut.eagerState : i(C, ut.action);
          else {
            var rn = {
              lane: St,
              action: ut.action,
              hasEagerState: ut.hasEagerState,
              eagerState: ut.eagerState,
              next: null
            };
            Ie === null ? (Ce = Ie = rn, ne = C) : Ie = Ie.next = rn, fe.lanes |= St, Ol |= St;
          }
          ut = ut.next;
        } while (ut !== null && ut !== H);
        Ie === null ? ne = C : Ie.next = Ce, ya(C, s.memoizedState) || (la = !0), s.memoizedState = C, s.baseState = ne, s.baseQueue = Ie, y.lastRenderedState = C;
      }
      if (i = y.interleaved, i !== null) {
        A = i;
        do
          H = A.lane, fe.lanes |= H, Ol |= H, A = A.next;
        while (A !== i);
      } else A === null && (y.lanes = 0);
      return [s.memoizedState, y.dispatch];
    }
    function De(i) {
      var s = pt(), y = s.queue;
      if (y === null) throw Error(d(311));
      y.lastRenderedReducer = i;
      var C = y.dispatch, A = y.pending, H = s.memoizedState;
      if (A !== null) {
        y.pending = null;
        var ne = A = A.next;
        do
          H = i(H, ne.action), ne = ne.next;
        while (ne !== A);
        ya(H, s.memoizedState) || (la = !0), s.memoizedState = H, s.baseQueue === null && (s.baseState = H), y.lastRenderedState = H;
      }
      return [H, C];
    }
    function ht() {
    }
    function mt(i, s) {
      var y = fe, C = pt(), A = s(), H = !ya(C.memoizedState, A);
      if (H && (C.memoizedState = A, la = !0), C = C.queue, po(xa.bind(null, y, C, i), [i]), C.getSnapshot !== s || H || ge !== null && ge.memoizedState.tag & 1) {
        if (y.flags |= 2048, Zi(9, tn.bind(null, y, C, A, s), void 0, null), ca === null) throw Error(d(349));
        (me & 30) !== 0 || Ot(y, s, A);
      }
      return A;
    }
    function Ot(i, s, y) {
      i.flags |= 16384, i = { getSnapshot: s, value: y }, s = fe.updateQueue, s === null ? (s = { lastEffect: null, stores: null }, fe.updateQueue = s, s.stores = [i]) : (y = s.stores, y === null ? s.stores = [i] : y.push(i));
    }
    function tn(i, s, y, C) {
      s.value = y, s.getSnapshot = C, un(s) && Jr(i);
    }
    function xa(i, s, y) {
      return y(function() {
        un(s) && Jr(i);
      });
    }
    function un(i) {
      var s = i.getSnapshot;
      i = i.value;
      try {
        var y = s();
        return !ya(i, y);
      } catch {
        return !0;
      }
    }
    function Jr(i) {
      var s = pi(i, 1);
      s !== null && Ta(s, i, 1, -1);
    }
    function $r(i) {
      var s = tt();
      return typeof i == "function" && (i = i()), s.memoizedState = s.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: it, lastRenderedState: i }, s.queue = i, i = i.dispatch = Zf.bind(null, fe, i), [s.memoizedState, i];
    }
    function Zi(i, s, y, C) {
      return i = { tag: i, create: s, destroy: y, deps: C, next: null }, s = fe.updateQueue, s === null ? (s = { lastEffect: null, stores: null }, fe.updateQueue = s, s.lastEffect = i.next = i) : (y = s.lastEffect, y === null ? s.lastEffect = i.next = i : (C = y.next, y.next = i, i.next = C, s.lastEffect = i)), i;
    }
    function Ke() {
      return pt().memoizedState;
    }
    function rr(i, s, y, C) {
      var A = tt();
      fe.flags |= i, A.memoizedState = Zi(1 | s, y, void 0, C === void 0 ? null : C);
    }
    function jt(i, s, y, C) {
      var A = pt();
      C = C === void 0 ? null : C;
      var H = void 0;
      if (ve !== null) {
        var ne = ve.memoizedState;
        if (H = ne.destroy, C !== null && Je(C, ne.deps)) {
          A.memoizedState = Zi(s, y, H, C);
          return;
        }
      }
      fe.flags |= i, A.memoizedState = Zi(1 | s, y, H, C);
    }
    function Cl(i, s) {
      return rr(8390656, 8, i, s);
    }
    function po(i, s) {
      return jt(2048, 8, i, s);
    }
    function Us(i, s) {
      return jt(4, 2, i, s);
    }
    function mo(i, s) {
      return jt(4, 4, i, s);
    }
    function pu(i, s) {
      if (typeof s == "function") return i = i(), s(i), function() {
        s(null);
      };
      if (s != null) return i = i(), s.current = i, function() {
        s.current = null;
      };
    }
    function El(i, s, y) {
      return y = y != null ? y.concat([i]) : null, jt(4, 4, pu.bind(null, s, i), y);
    }
    function Rl() {
    }
    function gd(i, s) {
      var y = pt();
      s = s === void 0 ? null : s;
      var C = y.memoizedState;
      return C !== null && s !== null && Je(s, C[1]) ? C[0] : (y.memoizedState = [i, s], i);
    }
    function vd(i, s) {
      var y = pt();
      s = s === void 0 ? null : s;
      var C = y.memoizedState;
      return C !== null && s !== null && Je(s, C[1]) ? C[0] : (i = i(), y.memoizedState = [i, s], i);
    }
    function yd(i, s, y) {
      return (me & 21) === 0 ? (i.baseState && (i.baseState = !1, la = !0), i.memoizedState = y) : (ya(y, s) || (y = ui(), fe.lanes |= y, Ol |= y, i.baseState = !0), s);
    }
    function jf(i, s) {
      var y = Jt;
      Jt = y !== 0 && 4 > y ? y : 4, i(!0);
      var C = _e.transition;
      _e.transition = {};
      try {
        i(!1), s();
      } finally {
        Jt = y, _e.transition = C;
      }
    }
    function bd() {
      return pt().memoizedState;
    }
    function Yf(i, s, y) {
      var C = hs(i);
      if (y = { lane: C, action: y, hasEagerState: !1, eagerState: null, next: null }, _d(i)) Sd(s, y);
      else if (y = md(i, s, y, C), y !== null) {
        var A = br();
        Ta(y, i, C, A), wd(y, s, C);
      }
    }
    function Zf(i, s, y) {
      var C = hs(i), A = { lane: C, action: y, hasEagerState: !1, eagerState: null, next: null };
      if (_d(i)) Sd(s, A);
      else {
        var H = i.alternate;
        if (i.lanes === 0 && (H === null || H.lanes === 0) && (H = s.lastRenderedReducer, H !== null)) try {
          var ne = s.lastRenderedState, Ce = H(ne, y);
          if (A.hasEagerState = !0, A.eagerState = Ce, ya(Ce, ne)) {
            var Ie = s.interleaved;
            Ie === null ? (A.next = A, mc(s)) : (A.next = Ie.next, Ie.next = A), s.interleaved = A;
            return;
          }
        } catch {
        } finally {
        }
        y = md(i, s, A, C), y !== null && (A = br(), Ta(y, i, C, A), wd(y, s, C));
      }
    }
    function _d(i) {
      var s = i.alternate;
      return i === fe || s !== null && s === fe;
    }
    function Sd(i, s) {
      we = Se = !0;
      var y = i.pending;
      y === null ? s.next = s : (s.next = y.next, y.next = s), i.pending = s;
    }
    function wd(i, s, y) {
      if ((y & 4194240) !== 0) {
        var C = s.lanes;
        C &= i.pendingLanes, y |= C, s.lanes = y, To(i, y);
      }
    }
    var mu = { readContext: Ba, useCallback: Be, useContext: Be, useEffect: Be, useImperativeHandle: Be, useInsertionEffect: Be, useLayoutEffect: Be, useMemo: Be, useReducer: Be, useRef: Be, useState: Be, useDebugValue: Be, useDeferredValue: Be, useTransition: Be, useMutableSource: Be, useSyncExternalStore: Be, useId: Be, unstable_isNewReconciler: !1 }, Xf = { readContext: Ba, useCallback: function(i, s) {
      return tt().memoizedState = [i, s === void 0 ? null : s], i;
    }, useContext: Ba, useEffect: Cl, useImperativeHandle: function(i, s, y) {
      return y = y != null ? y.concat([i]) : null, rr(
        4194308,
        4,
        pu.bind(null, s, i),
        y
      );
    }, useLayoutEffect: function(i, s) {
      return rr(4194308, 4, i, s);
    }, useInsertionEffect: function(i, s) {
      return rr(4, 2, i, s);
    }, useMemo: function(i, s) {
      var y = tt();
      return s = s === void 0 ? null : s, i = i(), y.memoizedState = [i, s], i;
    }, useReducer: function(i, s, y) {
      var C = tt();
      return s = y !== void 0 ? y(s) : s, C.memoizedState = C.baseState = s, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: s }, C.queue = i, i = i.dispatch = Yf.bind(null, fe, i), [C.memoizedState, i];
    }, useRef: function(i) {
      var s = tt();
      return i = { current: i }, s.memoizedState = i;
    }, useState: $r, useDebugValue: Rl, useDeferredValue: function(i) {
      return tt().memoizedState = i;
    }, useTransition: function() {
      var i = $r(!1), s = i[0];
      return i = jf.bind(null, i[1]), tt().memoizedState = i, [s, i];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(i, s, y) {
      var C = fe, A = tt();
      if (sr) {
        if (y === void 0) throw Error(d(407));
        y = y();
      } else {
        if (y = s(), ca === null) throw Error(d(349));
        (me & 30) !== 0 || Ot(C, s, y);
      }
      A.memoizedState = y;
      var H = { value: y, getSnapshot: s };
      return A.queue = H, Cl(xa.bind(
        null,
        C,
        H,
        i
      ), [i]), C.flags |= 2048, Zi(9, tn.bind(null, C, H, y, s), void 0, null), y;
    }, useId: function() {
      var i = tt(), s = ca.identifierPrefix;
      if (sr) {
        var y = ji, C = Fa;
        y = (C & ~(1 << 32 - oa(C) - 1)).toString(32) + y, s = ":" + s + "R" + y, y = Te++, 0 < y && (s += "H" + y.toString(32)), s += ":";
      } else y = Ne++, s = ":" + s + "r" + y.toString(32) + ":";
      return i.memoizedState = s;
    }, unstable_isNewReconciler: !1 }, Qf = {
      readContext: Ba,
      useCallback: gd,
      useContext: Ba,
      useEffect: po,
      useImperativeHandle: El,
      useInsertionEffect: Us,
      useLayoutEffect: mo,
      useMemo: vd,
      useReducer: Mt,
      useRef: Ke,
      useState: function() {
        return Mt(it);
      },
      useDebugValue: Rl,
      useDeferredValue: function(i) {
        var s = pt();
        return yd(s, ve.memoizedState, i);
      },
      useTransition: function() {
        var i = Mt(it)[0], s = pt().memoizedState;
        return [i, s];
      },
      useMutableSource: ht,
      useSyncExternalStore: mt,
      useId: bd,
      unstable_isNewReconciler: !1
    }, Jf = { readContext: Ba, useCallback: gd, useContext: Ba, useEffect: po, useImperativeHandle: El, useInsertionEffect: Us, useLayoutEffect: mo, useMemo: vd, useReducer: De, useRef: Ke, useState: function() {
      return De(it);
    }, useDebugValue: Rl, useDeferredValue: function(i) {
      var s = pt();
      return ve === null ? s.memoizedState = i : yd(s, ve.memoizedState, i);
    }, useTransition: function() {
      var i = De(it)[0], s = pt().memoizedState;
      return [i, s];
    }, useMutableSource: ht, useSyncExternalStore: mt, useId: bd, unstable_isNewReconciler: !1 };
    function Pi(i, s) {
      if (i && i.defaultProps) {
        s = u({}, s), i = i.defaultProps;
        for (var y in i) s[y] === void 0 && (s[y] = i[y]);
        return s;
      }
      return s;
    }
    function gu(i, s, y, C) {
      s = i.memoizedState, y = y(C, s), y = y == null ? s : u({}, s, y), i.memoizedState = y, i.lanes === 0 && (i.updateQueue.baseState = y);
    }
    var ds = { isMounted: function(i) {
      return (i = i._reactInternals) ? U(i) === i : !1;
    }, enqueueSetState: function(i, s, y) {
      i = i._reactInternals;
      var C = br(), A = hs(i), H = wa(C, A);
      H.payload = s, y != null && (H.callback = y), s = Qa(i, H, A), s !== null && (Ta(s, i, A, C), Bs(s, i, A));
    }, enqueueReplaceState: function(i, s, y) {
      i = i._reactInternals;
      var C = br(), A = hs(i), H = wa(C, A);
      H.tag = 1, H.payload = s, y != null && (H.callback = y), s = Qa(i, H, A), s !== null && (Ta(s, i, A, C), Bs(s, i, A));
    }, enqueueForceUpdate: function(i, s) {
      i = i._reactInternals;
      var y = br(), C = hs(i), A = wa(y, C);
      A.tag = 2, s != null && (A.callback = s), s = Qa(i, A, C), s !== null && (Ta(s, i, C, y), Bs(s, i, C));
    } };
    function xd(i, s, y, C, A, H, ne) {
      return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(C, H, ne) : s.prototype && s.prototype.isPureReactComponent ? !us(y, C) || !us(A, H) : !0;
    }
    function kd(i, s, y) {
      var C = !1, A = so, H = s.contextType;
      return typeof H == "object" && H !== null ? H = Ba(H) : (A = ia(s) ? Wi : Ar.current, C = s.contextTypes, H = (C = C != null) ? Ro(i, A) : so), s = new s(y, H), i.memoizedState = s.state !== null && s.state !== void 0 ? s.state : null, s.updater = ds, i.stateNode = s, s._reactInternals = i, C && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = A, i.__reactInternalMemoizedMaskedChildContext = H), s;
    }
    function Cd(i, s, y, C) {
      i = s.state, typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps(y, C), typeof s.UNSAFE_componentWillReceiveProps == "function" && s.UNSAFE_componentWillReceiveProps(y, C), s.state !== i && ds.enqueueReplaceState(s, s.state, null);
    }
    function gc(i, s, y, C) {
      var A = i.stateNode;
      A.props = y, A.state = i.memoizedState, A.refs = {}, Ur(i);
      var H = s.contextType;
      typeof H == "object" && H !== null ? A.context = Ba(H) : (H = ia(s) ? Wi : Ar.current, A.context = Ro(i, H)), A.state = i.memoizedState, H = s.getDerivedStateFromProps, typeof H == "function" && (gu(i, s, H, y), A.state = i.memoizedState), typeof s.getDerivedStateFromProps == "function" || typeof A.getSnapshotBeforeUpdate == "function" || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (s = A.state, typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount(), s !== A.state && ds.enqueueReplaceState(A, A.state, null), cs(i, y, A, C), A.state = i.memoizedState), typeof A.componentDidMount == "function" && (i.flags |= 4194308);
    }
    function Tl(i, s) {
      try {
        var y = "", C = s;
        do
          y += pc(C), C = C.return;
        while (C);
        var A = y;
      } catch (H) {
        A = `
Error generating stack: ` + H.message + `
` + H.stack;
      }
      return { value: i, source: s, stack: A, digest: null };
    }
    function Nl(i, s, y) {
      return { value: i, source: null, stack: y ?? null, digest: s ?? null };
    }
    function Ed(i, s) {
      try {
        console.error(s.value);
      } catch (y) {
        setTimeout(function() {
          throw y;
        });
      }
    }
    var vc = typeof WeakMap == "function" ? WeakMap : Map;
    function Is(i, s, y) {
      y = wa(-1, y), y.tag = 3, y.payload = { element: null };
      var C = s.value;
      return y.callback = function() {
        Vd || (Vd = !0, Ec = C), Ed(i, s);
      }, y;
    }
    function mi(i, s, y) {
      y = wa(-1, y), y.tag = 3;
      var C = i.type.getDerivedStateFromError;
      if (typeof C == "function") {
        var A = s.value;
        y.payload = function() {
          return C(A);
        }, y.callback = function() {
          Ed(i, s);
        };
      }
      var H = i.stateNode;
      return H !== null && typeof H.componentDidCatch == "function" && (y.callback = function() {
        Ed(i, s), typeof C != "function" && (qs === null ? qs = /* @__PURE__ */ new Set([this]) : qs.add(this));
        var ne = s.stack;
        this.componentDidCatch(s.value, { componentStack: ne !== null ? ne : "" });
      }), y;
    }
    function ym(i, s, y) {
      var C = i.pingCache;
      if (C === null) {
        C = i.pingCache = new vc();
        var A = /* @__PURE__ */ new Set();
        C.set(s, A);
      } else A = C.get(s), A === void 0 && (A = /* @__PURE__ */ new Set(), C.set(s, A));
      A.has(y) || (A.add(y), i = Ks.bind(null, i, s, y), s.then(i, i));
    }
    function fr(i) {
      do {
        var s;
        if ((s = i.tag === 13) && (s = i.memoizedState, s = s !== null ? s.dehydrated !== null : !0), s) return i;
        i = i.return;
      } while (i !== null);
      return null;
    }
    function yc(i, s, y, C, A) {
      return (i.mode & 1) === 0 ? (i === s ? i.flags |= 65536 : (i.flags |= 128, y.flags |= 131072, y.flags &= -52805, y.tag === 1 && (y.alternate === null ? y.tag = 17 : (s = wa(-1, 1), s.tag = 2, Qa(y, s, 1))), y.lanes |= 1), i) : (i.flags |= 65536, i.lanes = A, i);
    }
    var Rd = f.ReactCurrentOwner, la = !1;
    function ua(i, s, y, C) {
      s.child = i === null ? lu(s, null, y, C) : Fs(s, i.child, y, C);
    }
    function bm(i, s, y, C, A) {
      y = y.render;
      var H = s.ref;
      return co(s, A), C = nt(i, s, y, C, H, A), y = lt(), i !== null && !la ? (s.updateQueue = i.updateQueue, s.flags &= -2053, i.lanes &= ~A, gi(i, s, A)) : (sr && y && ss(s), s.flags |= 1, ua(i, s, C, A), s.child);
    }
    function _m(i, s, y, C, A) {
      if (i === null) {
        var H = y.type;
        return typeof H == "function" && !Zd(H) && H.defaultProps === void 0 && y.compare === null && y.defaultProps === void 0 ? (s.tag = 15, s.type = H, Sm(i, s, H, C, A)) : (i = Nc(y.type, null, C, s, s.mode, A), i.ref = s.ref, i.return = s, s.child = i);
      }
      if (H = i.child, (i.lanes & A) === 0) {
        var ne = H.memoizedProps;
        if (y = y.compare, y = y !== null ? y : us, y(ne, C) && i.ref === s.ref) return gi(i, s, A);
      }
      return s.flags |= 1, i = ms(H, C), i.ref = s.ref, i.return = s, s.child = i;
    }
    function Sm(i, s, y, C, A) {
      if (i !== null) {
        var H = i.memoizedProps;
        if (us(H, C) && i.ref === s.ref) if (la = !1, s.pendingProps = C = H, (i.lanes & A) !== 0) (i.flags & 131072) !== 0 && (la = !0);
        else return s.lanes = i.lanes, gi(i, s, A);
      }
      return $f(i, s, y, C, A);
    }
    function wm(i, s, y) {
      var C = s.pendingProps, A = C.children, H = i !== null ? i.memoizedState : null;
      if (C.mode === "hidden") if ((s.mode & 1) === 0) s.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, nr(Ll, Oi), Oi |= y;
      else {
        if ((y & 1073741824) === 0) return i = H !== null ? H.baseLanes | y : y, s.lanes = s.childLanes = 1073741824, s.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, s.updateQueue = null, nr(Ll, Oi), Oi |= i, null;
        s.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, C = H !== null ? H.baseLanes : y, nr(Ll, Oi), Oi |= C;
      }
      else H !== null ? (C = H.baseLanes | y, s.memoizedState = null) : C = y, nr(Ll, Oi), Oi |= C;
      return ua(i, s, A, y), s.child;
    }
    function Td(i, s) {
      var y = s.ref;
      (i === null && y !== null || i !== null && i.ref !== y) && (s.flags |= 512, s.flags |= 2097152);
    }
    function $f(i, s, y, C, A) {
      var H = ia(y) ? Wi : Ar.current;
      return H = Ro(s, H), co(s, A), y = nt(i, s, y, C, H, A), C = lt(), i !== null && !la ? (s.updateQueue = i.updateQueue, s.flags &= -2053, i.lanes &= ~A, gi(i, s, A)) : (sr && C && ss(s), s.flags |= 1, ua(i, s, y, A), s.child);
    }
    function Nd(i, s, y, C, A) {
      if (ia(y)) {
        var H = !0;
        lo(s);
      } else H = !1;
      if (co(s, A), s.stateNode === null) Ua(i, s), kd(s, y, C), gc(s, y, C, A), C = !0;
      else if (i === null) {
        var ne = s.stateNode, Ce = s.memoizedProps;
        ne.props = Ce;
        var Ie = ne.context, ut = y.contextType;
        typeof ut == "object" && ut !== null ? ut = Ba(ut) : (ut = ia(y) ? Wi : Ar.current, ut = Ro(s, ut));
        var St = y.getDerivedStateFromProps, rn = typeof St == "function" || typeof ne.getSnapshotBeforeUpdate == "function";
        rn || typeof ne.UNSAFE_componentWillReceiveProps != "function" && typeof ne.componentWillReceiveProps != "function" || (Ce !== C || Ie !== ut) && Cd(s, ne, C, ut), Xa = !1;
        var Nt = s.memoizedState;
        ne.state = Nt, cs(s, C, ne, A), Ie = s.memoizedState, Ce !== C || Nt !== Ie || zr.current || Xa ? (typeof St == "function" && (gu(s, y, St, C), Ie = s.memoizedState), (Ce = Xa || xd(s, y, Ce, C, Nt, Ie, ut)) ? (rn || typeof ne.UNSAFE_componentWillMount != "function" && typeof ne.componentWillMount != "function" || (typeof ne.componentWillMount == "function" && ne.componentWillMount(), typeof ne.UNSAFE_componentWillMount == "function" && ne.UNSAFE_componentWillMount()), typeof ne.componentDidMount == "function" && (s.flags |= 4194308)) : (typeof ne.componentDidMount == "function" && (s.flags |= 4194308), s.memoizedProps = C, s.memoizedState = Ie), ne.props = C, ne.state = Ie, ne.context = ut, C = Ce) : (typeof ne.componentDidMount == "function" && (s.flags |= 4194308), C = !1);
      } else {
        ne = s.stateNode, gr(i, s), Ce = s.memoizedProps, ut = s.type === s.elementType ? Ce : Pi(s.type, Ce), ne.props = ut, rn = s.pendingProps, Nt = ne.context, Ie = y.contextType, typeof Ie == "object" && Ie !== null ? Ie = Ba(Ie) : (Ie = ia(y) ? Wi : Ar.current, Ie = Ro(s, Ie));
        var _r = y.getDerivedStateFromProps;
        (St = typeof _r == "function" || typeof ne.getSnapshotBeforeUpdate == "function") || typeof ne.UNSAFE_componentWillReceiveProps != "function" && typeof ne.componentWillReceiveProps != "function" || (Ce !== rn || Nt !== Ie) && Cd(s, ne, C, Ie), Xa = !1, Nt = s.memoizedState, ne.state = Nt, cs(s, C, ne, A);
        var mn = s.memoizedState;
        Ce !== rn || Nt !== mn || zr.current || Xa ? (typeof _r == "function" && (gu(s, y, _r, C), mn = s.memoizedState), (ut = Xa || xd(s, y, ut, C, Nt, mn, Ie) || !1) ? (St || typeof ne.UNSAFE_componentWillUpdate != "function" && typeof ne.componentWillUpdate != "function" || (typeof ne.componentWillUpdate == "function" && ne.componentWillUpdate(C, mn, Ie), typeof ne.UNSAFE_componentWillUpdate == "function" && ne.UNSAFE_componentWillUpdate(C, mn, Ie)), typeof ne.componentDidUpdate == "function" && (s.flags |= 4), typeof ne.getSnapshotBeforeUpdate == "function" && (s.flags |= 1024)) : (typeof ne.componentDidUpdate != "function" || Ce === i.memoizedProps && Nt === i.memoizedState || (s.flags |= 4), typeof ne.getSnapshotBeforeUpdate != "function" || Ce === i.memoizedProps && Nt === i.memoizedState || (s.flags |= 1024), s.memoizedProps = C, s.memoizedState = mn), ne.props = C, ne.state = mn, ne.context = Ie, C = ut) : (typeof ne.componentDidUpdate != "function" || Ce === i.memoizedProps && Nt === i.memoizedState || (s.flags |= 4), typeof ne.getSnapshotBeforeUpdate != "function" || Ce === i.memoizedProps && Nt === i.memoizedState || (s.flags |= 1024), C = !1);
      }
      return Ad(i, s, y, C, H, A);
    }
    function Ad(i, s, y, C, A, H) {
      Td(i, s);
      var ne = (s.flags & 128) !== 0;
      if (!C && !ne) return A && Ts(s, y, !1), gi(i, s, H);
      C = s.stateNode, Rd.current = s;
      var Ce = ne && typeof y.getDerivedStateFromError != "function" ? null : C.render();
      return s.flags |= 1, i !== null && ne ? (s.child = Fs(s, i.child, null, H), s.child = Fs(s, null, Ce, H)) : ua(i, s, Ce, H), s.memoizedState = C.state, A && Ts(s, y, !0), s.child;
    }
    function xm(i) {
      var s = i.stateNode;
      s.pendingContext ? es(i, s.pendingContext, s.pendingContext !== s.context) : s.context && es(i, s.context, !1), _(i, s.containerInfo);
    }
    function km(i, s, y, C, A) {
      return hi(), Sl(A), s.flags |= 256, ua(i, s, y, C), s.child;
    }
    var vu = { dehydrated: null, treeContext: null, retryLane: 0 };
    function eh(i) {
      return { baseLanes: i, cachePool: null, transitions: null };
    }
    function th(i, s, y) {
      var C = s.pendingProps, A = K.current, H = !1, ne = (s.flags & 128) !== 0, Ce;
      if ((Ce = ne) || (Ce = i !== null && i.memoizedState === null ? !1 : (A & 2) !== 0), Ce ? (H = !0, s.flags &= -129) : (i === null || i.memoizedState !== null) && (A |= 1), nr(K, A & 1), i === null)
        return au(s), i = s.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? ((s.mode & 1) === 0 ? s.lanes = 1 : Et(i) ? s.lanes = 8 : s.lanes = 1073741824, null) : (ne = C.children, i = C.fallback, H ? (C = s.mode, H = s.child, ne = { mode: "hidden", children: ne }, (C & 1) === 0 && H !== null ? (H.childLanes = 0, H.pendingProps = ne) : H = Cu(ne, C, 0, null), i = gs(i, C, y, null), H.return = s, i.return = s, H.sibling = i, s.child = H, s.child.memoizedState = eh(y), s.memoizedState = vu, i) : Md(s, ne));
      if (A = i.memoizedState, A !== null && (Ce = A.dehydrated, Ce !== null)) return Al(i, s, ne, C, Ce, A, y);
      if (H) {
        H = C.fallback, ne = s.mode, A = i.child, Ce = A.sibling;
        var Ie = { mode: "hidden", children: C.children };
        return (ne & 1) === 0 && s.child !== A ? (C = s.child, C.childLanes = 0, C.pendingProps = Ie, s.deletions = null) : (C = ms(A, Ie), C.subtreeFlags = A.subtreeFlags & 14680064), Ce !== null ? H = ms(Ce, H) : (H = gs(H, ne, y, null), H.flags |= 2), H.return = s, C.return = s, C.sibling = H, s.child = C, C = H, H = s.child, ne = i.child.memoizedState, ne = ne === null ? eh(y) : { baseLanes: ne.baseLanes | y, cachePool: null, transitions: ne.transitions }, H.memoizedState = ne, H.childLanes = i.childLanes & ~y, s.memoizedState = vu, C;
      }
      return H = i.child, i = H.sibling, C = ms(H, { mode: "visible", children: C.children }), (s.mode & 1) === 0 && (C.lanes = y), C.return = s, C.sibling = null, i !== null && (y = s.deletions, y === null ? (s.deletions = [i], s.flags |= 16) : y.push(i)), s.child = C, s.memoizedState = null, C;
    }
    function Md(i, s) {
      return s = Cu({ mode: "visible", children: s }, i.mode, 0, null), s.return = i, i.child = s;
    }
    function Pd(i, s, y, C) {
      return C !== null && Sl(C), Fs(s, i.child, null, y), i = Md(s, s.pendingProps.children), i.flags |= 2, s.memoizedState = null, i;
    }
    function Al(i, s, y, C, A, H, ne) {
      if (y)
        return s.flags & 256 ? (s.flags &= -257, C = Nl(Error(d(422))), Pd(i, s, ne, C)) : s.memoizedState !== null ? (s.child = i.child, s.flags |= 128, null) : (H = C.fallback, A = s.mode, C = Cu({ mode: "visible", children: C.children }, A, 0, null), H = gs(H, A, ne, null), H.flags |= 2, C.return = s, H.return = s, C.sibling = H, s.child = C, (s.mode & 1) !== 0 && Fs(s, i.child, null, ne), s.child.memoizedState = eh(ne), s.memoizedState = vu, H);
      if ((s.mode & 1) === 0) return Pd(i, s, ne, null);
      if (Et(A)) return C = Xn(A).digest, H = Error(d(419)), C = Nl(
        H,
        C,
        void 0
      ), Pd(i, s, ne, C);
      if (y = (ne & i.childLanes) !== 0, la || y) {
        if (C = ca, C !== null) {
          switch (ne & -ne) {
            case 4:
              A = 2;
              break;
            case 16:
              A = 8;
              break;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              A = 32;
              break;
            case 536870912:
              A = 268435456;
              break;
            default:
              A = 0;
          }
          A = (A & (C.suspendedLanes | ne)) !== 0 ? 0 : A, A !== 0 && A !== H.retryLane && (H.retryLane = A, pi(i, A), Ta(
            C,
            i,
            A,
            -1
          ));
        }
        return Kd(), C = Nl(Error(d(421))), Pd(i, s, ne, C);
      }
      return kt(A) ? (s.flags |= 128, s.child = i.child, s = av.bind(null, i), en(A, s), null) : (i = H.treeContext, bt && (za = Nr(A), _a = s, sr = !0, Sa = null, Cr = !1, i !== null && (Za[ba++] = Fa, Za[ba++] = ji, Za[ba++] = Ai, Fa = i.id, ji = i.overflow, Ai = s)), s = Md(s, C.children), s.flags |= 4096, s);
    }
    function yu(i, s, y) {
      i.lanes |= s;
      var C = i.alternate;
      C !== null && (C.lanes |= s), kl(i.return, s, y);
    }
    function fs(i, s, y, C, A) {
      var H = i.memoizedState;
      H === null ? i.memoizedState = { isBackwards: s, rendering: null, renderingStartTime: 0, last: C, tail: y, tailMode: A } : (H.isBackwards = s, H.rendering = null, H.renderingStartTime = 0, H.last = C, H.tail = y, H.tailMode = A);
    }
    function Dd(i, s, y) {
      var C = s.pendingProps, A = C.revealOrder, H = C.tail;
      if (ua(i, s, C.children, y), C = K.current, (C & 2) !== 0) C = C & 1 | 2, s.flags |= 128;
      else {
        if (i !== null && (i.flags & 128) !== 0) e: for (i = s.child; i !== null; ) {
          if (i.tag === 13) i.memoizedState !== null && yu(i, y, s);
          else if (i.tag === 19) yu(i, y, s);
          else if (i.child !== null) {
            i.child.return = i, i = i.child;
            continue;
          }
          if (i === s) break e;
          for (; i.sibling === null; ) {
            if (i.return === null || i.return === s) break e;
            i = i.return;
          }
          i.sibling.return = i.return, i = i.sibling;
        }
        C &= 1;
      }
      if (nr(K, C), (s.mode & 1) === 0) s.memoizedState = null;
      else switch (A) {
        case "forwards":
          for (y = s.child, A = null; y !== null; ) i = y.alternate, i !== null && J(i) === null && (A = y), y = y.sibling;
          y = A, y === null ? (A = s.child, s.child = null) : (A = y.sibling, y.sibling = null), fs(s, !1, A, y, H);
          break;
        case "backwards":
          for (y = null, A = s.child, s.child = null; A !== null; ) {
            if (i = A.alternate, i !== null && J(i) === null) {
              s.child = A;
              break;
            }
            i = A.sibling, A.sibling = y, y = A, A = i;
          }
          fs(s, !0, y, null, H);
          break;
        case "together":
          fs(s, !1, null, null, void 0);
          break;
        default:
          s.memoizedState = null;
      }
      return s.child;
    }
    function Ua(i, s) {
      (s.mode & 1) === 0 && i !== null && (i.alternate = null, s.alternate = null, s.flags |= 2);
    }
    function gi(i, s, y) {
      if (i !== null && (s.dependencies = i.dependencies), Ol |= s.lanes, (y & s.childLanes) === 0) return null;
      if (i !== null && s.child !== i.child) throw Error(d(153));
      if (s.child !== null) {
        for (i = s.child, y = ms(i, i.pendingProps), s.child = y, y.return = s; i.sibling !== null; ) i = i.sibling, y = y.sibling = ms(i, i.pendingProps), y.return = s;
        y.sibling = null;
      }
      return s.child;
    }
    function fn(i, s, y) {
      switch (s.tag) {
        case 3:
          xm(s), hi();
          break;
        case 5:
          O(s);
          break;
        case 1:
          ia(s.type) && lo(s);
          break;
        case 4:
          _(s, s.stateNode.containerInfo);
          break;
        case 10:
          du(s, s.type._context, s.memoizedProps.value);
          break;
        case 13:
          var C = s.memoizedState;
          if (C !== null)
            return C.dehydrated !== null ? (nr(K, K.current & 1), s.flags |= 128, null) : (y & s.child.childLanes) !== 0 ? th(i, s, y) : (nr(K, K.current & 1), i = gi(i, s, y), i !== null ? i.sibling : null);
          nr(K, K.current & 1);
          break;
        case 19:
          if (C = (y & s.childLanes) !== 0, (i.flags & 128) !== 0) {
            if (C) return Dd(
              i,
              s,
              y
            );
            s.flags |= 128;
          }
          var A = s.memoizedState;
          if (A !== null && (A.rendering = null, A.tail = null, A.lastEffect = null), nr(K, K.current), C) break;
          return null;
        case 22:
        case 23:
          return s.lanes = 0, wm(i, s, y);
      }
      return gi(i, s, y);
    }
    function Di(i) {
      i.flags |= 4;
    }
    function nh(i, s) {
      if (i !== null && i.child === s.child) return !0;
      if ((s.flags & 16) !== 0) return !1;
      for (i = s.child; i !== null; ) {
        if ((i.flags & 12854) !== 0 || (i.subtreeFlags & 12854) !== 0) return !1;
        i = i.sibling;
      }
      return !0;
    }
    var Ld, bc, bu, Hs;
    if (rt) Ld = function(i, s) {
      for (var y = s.child; y !== null; ) {
        if (y.tag === 5 || y.tag === 6) ye(i, y.stateNode);
        else if (y.tag !== 4 && y.child !== null) {
          y.child.return = y, y = y.child;
          continue;
        }
        if (y === s) break;
        for (; y.sibling === null; ) {
          if (y.return === null || y.return === s) return;
          y = y.return;
        }
        y.sibling.return = y.return, y = y.sibling;
      }
    }, bc = function() {
    }, bu = function(i, s, y, C, A) {
      if (i = i.memoizedProps, i !== C) {
        var H = s.stateNode, ne = m(Ir.current);
        y = Me(H, y, i, C, A, ne), (s.updateQueue = y) && Di(s);
      }
    }, Hs = function(i, s, y, C) {
      y !== C && Di(s);
    };
    else if (st) {
      Ld = function(i, s, y, C) {
        for (var A = s.child; A !== null; ) {
          if (A.tag === 5) {
            var H = A.stateNode;
            y && C && (H = mr(H, A.type, A.memoizedProps, A)), ye(i, H);
          } else if (A.tag === 6) H = A.stateNode, y && C && (H = Xr(H, A.memoizedProps, A)), ye(i, H);
          else if (A.tag !== 4) {
            if (A.tag === 22 && A.memoizedState !== null) H = A.child, H !== null && (H.return = A), Ld(i, A, !0, !0);
            else if (A.child !== null) {
              A.child.return = A, A = A.child;
              continue;
            }
          }
          if (A === s) break;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === s) return;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      };
      var Cm = function(i, s, y, C) {
        for (var A = s.child; A !== null; ) {
          if (A.tag === 5) {
            var H = A.stateNode;
            y && C && (H = mr(H, A.type, A.memoizedProps, A)), zn(i, H);
          } else if (A.tag === 6) H = A.stateNode, y && C && (H = Xr(H, A.memoizedProps, A)), zn(i, H);
          else if (A.tag !== 4) {
            if (A.tag === 22 && A.memoizedState !== null) H = A.child, H !== null && (H.return = A), Cm(i, A, !0, !0);
            else if (A.child !== null) {
              A.child.return = A, A = A.child;
              continue;
            }
          }
          if (A === s) break;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === s) return;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      };
      bc = function(i, s) {
        var y = s.stateNode;
        if (!nh(i, s)) {
          i = y.containerInfo;
          var C = xt(i);
          Cm(C, s, !1, !1), y.pendingChildren = C, Di(s), aa(i, C);
        }
      }, bu = function(i, s, y, C, A) {
        var H = i.stateNode, ne = i.memoizedProps;
        if ((i = nh(i, s)) && ne === C) s.stateNode = H;
        else {
          var Ce = s.stateNode, Ie = m(Ir.current), ut = null;
          ne !== C && (ut = Me(Ce, y, ne, C, A, Ie)), i && ut === null ? s.stateNode = H : (H = or(H, ut, y, ne, C, s, i, Ce), pe(H, y, C, A, Ie) && Di(s), s.stateNode = H, i ? Di(s) : Ld(H, s, !1, !1));
        }
      }, Hs = function(i, s, y, C) {
        y !== C ? (i = m(Do.current), y = m(Ir.current), s.stateNode = Ee(C, i, y, s), Di(s)) : s.stateNode = i.stateNode;
      };
    } else bc = function() {
    }, bu = function() {
    }, Hs = function() {
    };
    function _u(i, s) {
      if (!sr) switch (i.tailMode) {
        case "hidden":
          s = i.tail;
          for (var y = null; s !== null; ) s.alternate !== null && (y = s), s = s.sibling;
          y === null ? i.tail = null : y.sibling = null;
          break;
        case "collapsed":
          y = i.tail;
          for (var C = null; y !== null; ) y.alternate !== null && (C = y), y = y.sibling;
          C === null ? s || i.tail === null ? i.tail = null : i.tail.sibling = null : C.sibling = null;
      }
    }
    function Ia(i) {
      var s = i.alternate !== null && i.alternate.child === i.child, y = 0, C = 0;
      if (s) for (var A = i.child; A !== null; ) y |= A.lanes | A.childLanes, C |= A.subtreeFlags & 14680064, C |= A.flags & 14680064, A.return = i, A = A.sibling;
      else for (A = i.child; A !== null; ) y |= A.lanes | A.childLanes, C |= A.subtreeFlags, C |= A.flags, A.return = i, A = A.sibling;
      return i.subtreeFlags |= C, i.childLanes = y, s;
    }
    function rh(i, s, y) {
      var C = s.pendingProps;
      switch (_l(s), s.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return Ia(s), null;
        case 1:
          return ia(s.type) && Wn(), Ia(s), null;
        case 3:
          return y = s.stateNode, M(), It(zr), It(Ar), be(), y.pendingContext && (y.context = y.pendingContext, y.pendingContext = null), (i === null || i.child === null) && (ls(s) ? Di(s) : i === null || i.memoizedState.isDehydrated && (s.flags & 256) === 0 || (s.flags |= 1024, Sa !== null && (bi(Sa), Sa = null))), bc(i, s), Ia(s), null;
        case 5:
          V(s), y = m(Do.current);
          var A = s.type;
          if (i !== null && s.stateNode != null) bu(i, s, A, C, y), i.ref !== s.ref && (s.flags |= 512, s.flags |= 2097152);
          else {
            if (!C) {
              if (s.stateNode === null) throw Error(d(166));
              return Ia(s), null;
            }
            if (i = m(Ir.current), ls(s)) {
              if (!bt) throw Error(d(175));
              i = vr(s.stateNode, s.type, s.memoizedProps, y, i, s, !Cr), s.updateQueue = i, i !== null && Di(s);
            } else {
              var H = oe(A, C, y, i, s);
              Ld(H, s, !1, !1), s.stateNode = H, pe(H, A, C, y, i) && Di(s);
            }
            s.ref !== null && (s.flags |= 512, s.flags |= 2097152);
          }
          return Ia(s), null;
        case 6:
          if (i && s.stateNode != null) Hs(i, s, i.memoizedProps, C);
          else {
            if (typeof C != "string" && s.stateNode === null) throw Error(d(166));
            if (i = m(Do.current), y = m(Ir.current), ls(s)) {
              if (!bt) throw Error(d(176));
              if (i = s.stateNode, y = s.memoizedProps, (C = Ti(i, y, s, !Cr)) && (A = _a, A !== null)) switch (A.tag) {
                case 3:
                  oo(A.stateNode.containerInfo, i, y, (A.mode & 1) !== 0);
                  break;
                case 5:
                  li(A.type, A.memoizedProps, A.stateNode, i, y, (A.mode & 1) !== 0);
              }
              C && Di(s);
            } else s.stateNode = Ee(C, i, y, s);
          }
          return Ia(s), null;
        case 13:
          if (It(K), C = s.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
            if (sr && za !== null && (s.mode & 1) !== 0 && (s.flags & 128) === 0) iu(), hi(), s.flags |= 98560, A = !1;
            else if (A = ls(s), C !== null && C.dehydrated !== null) {
              if (i === null) {
                if (!A) throw Error(d(318));
                if (!bt) throw Error(d(344));
                if (A = s.memoizedState, A = A !== null ? A.dehydrated : null, !A) throw Error(d(317));
                Qo(A, s);
              } else hi(), (s.flags & 128) === 0 && (s.memoizedState = null), s.flags |= 4;
              Ia(s), A = !1;
            } else Sa !== null && (bi(Sa), Sa = null), A = !0;
            if (!A) return s.flags & 65536 ? s : null;
          }
          return (s.flags & 128) !== 0 ? (s.lanes = y, s) : (y = C !== null, y !== (i !== null && i.memoizedState !== null) && y && (s.child.flags |= 8192, (s.mode & 1) !== 0 && (i === null || (K.current & 1) !== 0 ? qr === 0 && (qr = 3) : Kd())), s.updateQueue !== null && (s.flags |= 4), Ia(s), null);
        case 4:
          return M(), bc(i, s), i === null && Lt(s.stateNode.containerInfo), Ia(s), null;
        case 10:
          return fu(s.type._context), Ia(s), null;
        case 17:
          return ia(s.type) && Wn(), Ia(s), null;
        case 19:
          if (It(K), A = s.memoizedState, A === null) return Ia(s), null;
          if (C = (s.flags & 128) !== 0, H = A.rendering, H === null) if (C) _u(A, !1);
          else {
            if (qr !== 0 || i !== null && (i.flags & 128) !== 0) for (i = s.child; i !== null; ) {
              if (H = J(i), H !== null) {
                for (s.flags |= 128, _u(A, !1), i = H.updateQueue, i !== null && (s.updateQueue = i, s.flags |= 4), s.subtreeFlags = 0, i = y, y = s.child; y !== null; ) C = y, A = i, C.flags &= 14680066, H = C.alternate, H === null ? (C.childLanes = 0, C.lanes = A, C.child = null, C.subtreeFlags = 0, C.memoizedProps = null, C.memoizedState = null, C.updateQueue = null, C.dependencies = null, C.stateNode = null) : (C.childLanes = H.childLanes, C.lanes = H.lanes, C.child = H.child, C.subtreeFlags = 0, C.deletions = null, C.memoizedProps = H.memoizedProps, C.memoizedState = H.memoizedState, C.updateQueue = H.updateQueue, C.type = H.type, A = H.dependencies, C.dependencies = A === null ? null : { lanes: A.lanes, firstContext: A.firstContext }), y = y.sibling;
                return nr(K, K.current & 1 | 2), s.child;
              }
              i = i.sibling;
            }
            A.tail !== null && Br() > ch && (s.flags |= 128, C = !0, _u(A, !1), s.lanes = 4194304);
          }
          else {
            if (!C) if (i = J(H), i !== null) {
              if (s.flags |= 128, C = !0, i = i.updateQueue, i !== null && (s.updateQueue = i, s.flags |= 4), _u(A, !0), A.tail === null && A.tailMode === "hidden" && !H.alternate && !sr) return Ia(s), null;
            } else 2 * Br() - A.renderingStartTime > ch && y !== 1073741824 && (s.flags |= 128, C = !0, _u(A, !1), s.lanes = 4194304);
            A.isBackwards ? (H.sibling = s.child, s.child = H) : (i = A.last, i !== null ? i.sibling = H : s.child = H, A.last = H);
          }
          return A.tail !== null ? (s = A.tail, A.rendering = s, A.tail = s.sibling, A.renderingStartTime = Br(), s.sibling = null, i = K.current, nr(K, C ? i & 1 | 2 : i & 1), s) : (Ia(s), null);
        case 22:
        case 23:
          return dh(), y = s.memoizedState !== null, i !== null && i.memoizedState !== null !== y && (s.flags |= 8192), y && (s.mode & 1) !== 0 ? (Oi & 1073741824) !== 0 && (Ia(s), rt && s.subtreeFlags & 6 && (s.flags |= 8192)) : Ia(s), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(d(
        156,
        s.tag
      ));
    }
    function tv(i, s) {
      switch (_l(s), s.tag) {
        case 1:
          return ia(s.type) && Wn(), i = s.flags, i & 65536 ? (s.flags = i & -65537 | 128, s) : null;
        case 3:
          return M(), It(zr), It(Ar), be(), i = s.flags, (i & 65536) !== 0 && (i & 128) === 0 ? (s.flags = i & -65537 | 128, s) : null;
        case 5:
          return V(s), null;
        case 13:
          if (It(K), i = s.memoizedState, i !== null && i.dehydrated !== null) {
            if (s.alternate === null) throw Error(d(340));
            hi();
          }
          return i = s.flags, i & 65536 ? (s.flags = i & -65537 | 128, s) : null;
        case 19:
          return It(K), null;
        case 4:
          return M(), null;
        case 10:
          return fu(s.type._context), null;
        case 22:
        case 23:
          return dh(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var _c = !1, ka = !1, Em = typeof WeakSet == "function" ? WeakSet : Set, Ct = null;
    function Lo(i, s) {
      var y = i.ref;
      if (y !== null) if (typeof y == "function") try {
        y(null);
      } catch (C) {
        Bn(i, s, C);
      }
      else y.current = null;
    }
    function Ml(i, s, y) {
      try {
        y();
      } catch (C) {
        Bn(i, s, C);
      }
    }
    var Od = !1;
    function Sc(i, s) {
      for (ee(i.containerInfo), Ct = s; Ct !== null; ) if (i = Ct, s = i.child, (i.subtreeFlags & 1028) !== 0 && s !== null) s.return = i, Ct = s;
      else for (; Ct !== null; ) {
        i = Ct;
        try {
          var y = i.alternate;
          if ((i.flags & 1024) !== 0) switch (i.tag) {
            case 0:
            case 11:
            case 15:
              break;
            case 1:
              if (y !== null) {
                var C = y.memoizedProps, A = y.memoizedState, H = i.stateNode, ne = H.getSnapshotBeforeUpdate(i.elementType === i.type ? C : Pi(i.type, C), A);
                H.__reactInternalSnapshotBeforeUpdate = ne;
              }
              break;
            case 3:
              rt && _t(i.stateNode.containerInfo);
              break;
            case 5:
            case 6:
            case 4:
            case 17:
              break;
            default:
              throw Error(d(163));
          }
        } catch (Ce) {
          Bn(i, i.return, Ce);
        }
        if (s = i.sibling, s !== null) {
          s.return = i.return, Ct = s;
          break;
        }
        Ct = i.return;
      }
      return y = Od, Od = !1, y;
    }
    function $a(i, s, y) {
      var C = s.updateQueue;
      if (C = C !== null ? C.lastEffect : null, C !== null) {
        var A = C = C.next;
        do {
          if ((A.tag & i) === i) {
            var H = A.destroy;
            A.destroy = void 0, H !== void 0 && Ml(s, y, H);
          }
          A = A.next;
        } while (A !== C);
      }
    }
    function Mr(i, s) {
      if (s = s.updateQueue, s = s !== null ? s.lastEffect : null, s !== null) {
        var y = s = s.next;
        do {
          if ((y.tag & i) === i) {
            var C = y.create;
            y.destroy = C();
          }
          y = y.next;
        } while (y !== s);
      }
    }
    function ah(i) {
      var s = i.ref;
      if (s !== null) {
        var y = i.stateNode;
        switch (i.tag) {
          case 5:
            i = ze(y);
            break;
          default:
            i = y;
        }
        typeof s == "function" ? s(i) : s.current = i;
      }
    }
    function Rm(i) {
      var s = i.alternate;
      s !== null && (i.alternate = null, Rm(s)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (s = i.stateNode, s !== null && Wt(s)), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
    }
    function Tm(i) {
      return i.tag === 5 || i.tag === 3 || i.tag === 4;
    }
    function ih(i) {
      e: for (; ; ) {
        for (; i.sibling === null; ) {
          if (i.return === null || Tm(i.return)) return null;
          i = i.return;
        }
        for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
          if (i.flags & 2 || i.child === null || i.tag === 4) continue e;
          i.child.return = i, i = i.child;
        }
        if (!(i.flags & 2)) return i.stateNode;
      }
    }
    function Fd(i, s, y) {
      var C = i.tag;
      if (C === 5 || C === 6) i = i.stateNode, s ? Fn(y, i, s) : tr(y, i);
      else if (C !== 4 && (i = i.child, i !== null)) for (Fd(i, s, y), i = i.sibling; i !== null; ) Fd(i, s, y), i = i.sibling;
    }
    function zd(i, s, y) {
      var C = i.tag;
      if (C === 5 || C === 6) i = i.stateNode, s ? Ft(y, i, s) : kn(y, i);
      else if (C !== 4 && (i = i.child, i !== null)) for (zd(i, s, y), i = i.sibling; i !== null; ) zd(i, s, y), i = i.sibling;
    }
    var Ca = null, go = !1;
    function Oo(i, s, y) {
      for (y = y.child; y !== null; ) Hr(i, s, y), y = y.sibling;
    }
    function Hr(i, s, y) {
      if (Ya && typeof Ya.onCommitFiberUnmount == "function") try {
        Ya.onCommitFiberUnmount(Ao, y);
      } catch {
      }
      switch (y.tag) {
        case 5:
          ka || Lo(y, s);
        case 6:
          if (rt) {
            var C = Ca, A = go;
            Ca = null, Oo(i, s, y), Ca = C, go = A, Ca !== null && (go ? qe(Ca, y.stateNode) : _n(Ca, y.stateNode));
          } else Oo(i, s, y);
          break;
        case 18:
          rt && Ca !== null && (go ? Co(Ca, y.stateNode) : Jo(Ca, y.stateNode));
          break;
        case 4:
          rt ? (C = Ca, A = go, Ca = y.stateNode.containerInfo, go = !0, Oo(i, s, y), Ca = C, go = A) : (st && (C = y.stateNode.containerInfo, A = xt(C), Zr(C, A)), Oo(i, s, y));
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          if (!ka && (C = y.updateQueue, C !== null && (C = C.lastEffect, C !== null))) {
            A = C = C.next;
            do {
              var H = A, ne = H.destroy;
              H = H.tag, ne !== void 0 && ((H & 2) !== 0 || (H & 4) !== 0) && Ml(y, s, ne), A = A.next;
            } while (A !== C);
          }
          Oo(i, s, y);
          break;
        case 1:
          if (!ka && (Lo(y, s), C = y.stateNode, typeof C.componentWillUnmount == "function")) try {
            C.props = y.memoizedProps, C.state = y.memoizedState, C.componentWillUnmount();
          } catch (Ce) {
            Bn(y, s, Ce);
          }
          Oo(i, s, y);
          break;
        case 21:
          Oo(i, s, y);
          break;
        case 22:
          y.mode & 1 ? (ka = (C = ka) || y.memoizedState !== null, Oo(i, s, y), ka = C) : Oo(i, s, y);
          break;
        default:
          Oo(
            i,
            s,
            y
          );
      }
    }
    function wc(i) {
      var s = i.updateQueue;
      if (s !== null) {
        i.updateQueue = null;
        var y = i.stateNode;
        y === null && (y = i.stateNode = new Em()), s.forEach(function(C) {
          var A = Lm.bind(null, i, C);
          y.has(C) || (y.add(C), C.then(A, A));
        });
      }
    }
    function Xi(i, s) {
      var y = s.deletions;
      if (y !== null) for (var C = 0; C < y.length; C++) {
        var A = y[C];
        try {
          var H = i, ne = s;
          if (rt) {
            var Ce = ne;
            e: for (; Ce !== null; ) {
              switch (Ce.tag) {
                case 5:
                  Ca = Ce.stateNode, go = !1;
                  break e;
                case 3:
                  Ca = Ce.stateNode.containerInfo, go = !0;
                  break e;
                case 4:
                  Ca = Ce.stateNode.containerInfo, go = !0;
                  break e;
              }
              Ce = Ce.return;
            }
            if (Ca === null) throw Error(d(160));
            Hr(H, ne, A), Ca = null, go = !1;
          } else Hr(H, ne, A);
          var Ie = A.alternate;
          Ie !== null && (Ie.return = null), A.return = null;
        } catch (ut) {
          Bn(A, s, ut);
        }
      }
      if (s.subtreeFlags & 12854) for (s = s.child; s !== null; ) Pl(s, i), s = s.sibling;
    }
    function Pl(i, s) {
      var y = i.alternate, C = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (Xi(s, i), vo(i), C & 4) {
            try {
              $a(3, i, i.return), Mr(3, i);
            } catch (Nt) {
              Bn(i, i.return, Nt);
            }
            try {
              $a(5, i, i.return);
            } catch (Nt) {
              Bn(i, i.return, Nt);
            }
          }
          break;
        case 1:
          Xi(s, i), vo(i), C & 512 && y !== null && Lo(y, y.return);
          break;
        case 5:
          if (Xi(s, i), vo(i), C & 512 && y !== null && Lo(y, y.return), rt) {
            if (i.flags & 32) {
              var A = i.stateNode;
              try {
                gt(A);
              } catch (Nt) {
                Bn(i, i.return, Nt);
              }
            }
            if (C & 4 && (A = i.stateNode, A != null)) {
              var H = i.memoizedProps;
              if (y = y !== null ? y.memoizedProps : H, C = i.type, s = i.updateQueue, i.updateQueue = null, s !== null) try {
                Ut(A, s, C, y, H, i);
              } catch (Nt) {
                Bn(i, i.return, Nt);
              }
            }
          }
          break;
        case 6:
          if (Xi(s, i), vo(i), C & 4 && rt) {
            if (i.stateNode === null) throw Error(d(162));
            A = i.stateNode, H = i.memoizedProps, y = y !== null ? y.memoizedProps : H;
            try {
              ot(A, y, H);
            } catch (Nt) {
              Bn(i, i.return, Nt);
            }
          }
          break;
        case 3:
          if (Xi(s, i), vo(i), C & 4) {
            if (rt && bt && y !== null && y.memoizedState.isDehydrated) try {
              ga(s.containerInfo);
            } catch (Nt) {
              Bn(i, i.return, Nt);
            }
            if (st) {
              A = s.containerInfo, H = s.pendingChildren;
              try {
                Zr(A, H);
              } catch (Nt) {
                Bn(i, i.return, Nt);
              }
            }
          }
          break;
        case 4:
          if (Xi(
            s,
            i
          ), vo(i), C & 4 && st) {
            H = i.stateNode, A = H.containerInfo, H = H.pendingChildren;
            try {
              Zr(A, H);
            } catch (Nt) {
              Bn(i, i.return, Nt);
            }
          }
          break;
        case 13:
          Xi(s, i), vo(i), A = i.child, A.flags & 8192 && (H = A.memoizedState !== null, A.stateNode.isHidden = H, !H || A.alternate !== null && A.alternate.memoizedState !== null || (Gd = Br())), C & 4 && wc(i);
          break;
        case 22:
          var ne = y !== null && y.memoizedState !== null;
          if (i.mode & 1 ? (ka = (y = ka) || ne, Xi(s, i), ka = y) : Xi(s, i), vo(i), C & 8192) {
            if (y = i.memoizedState !== null, (i.stateNode.isHidden = y) && !ne && (i.mode & 1) !== 0) for (Ct = i, C = i.child; C !== null; ) {
              for (s = Ct = C; Ct !== null; ) {
                ne = Ct;
                var Ce = ne.child;
                switch (ne.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    $a(4, ne, ne.return);
                    break;
                  case 1:
                    Lo(ne, ne.return);
                    var Ie = ne.stateNode;
                    if (typeof Ie.componentWillUnmount == "function") {
                      var ut = ne, St = ne.return;
                      try {
                        var rn = ut;
                        Ie.props = rn.memoizedProps, Ie.state = rn.memoizedState, Ie.componentWillUnmount();
                      } catch (Nt) {
                        Bn(ut, St, Nt);
                      }
                    }
                    break;
                  case 5:
                    Lo(ne, ne.return);
                    break;
                  case 22:
                    if (ne.memoizedState !== null) {
                      Ea(s);
                      continue;
                    }
                }
                Ce !== null ? (Ce.return = ne, Ct = Ce) : Ea(s);
              }
              C = C.sibling;
            }
            if (rt) {
              e: if (C = null, rt) for (s = i; ; ) {
                if (s.tag === 5) {
                  if (C === null) {
                    C = s;
                    try {
                      A = s.stateNode, y ? Dn(A) : Xe(s.stateNode, s.memoizedProps);
                    } catch (Nt) {
                      Bn(i, i.return, Nt);
                    }
                  }
                } else if (s.tag === 6) {
                  if (C === null) try {
                    H = s.stateNode, y ? Tn(H) : Ue(H, s.memoizedProps);
                  } catch (Nt) {
                    Bn(i, i.return, Nt);
                  }
                } else if ((s.tag !== 22 && s.tag !== 23 || s.memoizedState === null || s === i) && s.child !== null) {
                  s.child.return = s, s = s.child;
                  continue;
                }
                if (s === i) break e;
                for (; s.sibling === null; ) {
                  if (s.return === null || s.return === i) break e;
                  C === s && (C = null), s = s.return;
                }
                C === s && (C = null), s.sibling.return = s.return, s = s.sibling;
              }
            }
          }
          break;
        case 19:
          Xi(s, i), vo(i), C & 4 && wc(i);
          break;
        case 21:
          break;
        default:
          Xi(s, i), vo(i);
      }
    }
    function vo(i) {
      var s = i.flags;
      if (s & 2) {
        try {
          if (rt) {
            e: {
              for (var y = i.return; y !== null; ) {
                if (Tm(y)) {
                  var C = y;
                  break e;
                }
                y = y.return;
              }
              throw Error(d(160));
            }
            switch (C.tag) {
              case 5:
                var A = C.stateNode;
                C.flags & 32 && (gt(A), C.flags &= -33);
                var H = ih(i);
                zd(i, H, A);
                break;
              case 3:
              case 4:
                var ne = C.stateNode.containerInfo, Ce = ih(i);
                Fd(i, Ce, ne);
                break;
              default:
                throw Error(d(161));
            }
          }
        } catch (Ie) {
          Bn(i, i.return, Ie);
        }
        i.flags &= -3;
      }
      s & 4096 && (i.flags &= -4097);
    }
    function nv(i, s, y) {
      Ct = i, Nm(i);
    }
    function Nm(i, s, y) {
      for (var C = (i.mode & 1) !== 0; Ct !== null; ) {
        var A = Ct, H = A.child;
        if (A.tag === 22 && C) {
          var ne = A.memoizedState !== null || _c;
          if (!ne) {
            var Ce = A.alternate, Ie = Ce !== null && Ce.memoizedState !== null || ka;
            Ce = _c;
            var ut = ka;
            if (_c = ne, (ka = Ie) && !ut) for (Ct = A; Ct !== null; ) ne = Ct, Ie = ne.child, ne.tag === 22 && ne.memoizedState !== null ? Rt(A) : Ie !== null ? (Ie.return = ne, Ct = Ie) : Rt(A);
            for (; H !== null; ) Ct = H, Nm(H), H = H.sibling;
            Ct = A, _c = Ce, ka = ut;
          }
          Dl(i);
        } else (A.subtreeFlags & 8772) !== 0 && H !== null ? (H.return = A, Ct = H) : Dl(i);
      }
    }
    function Dl(i) {
      for (; Ct !== null; ) {
        var s = Ct;
        if ((s.flags & 8772) !== 0) {
          var y = s.alternate;
          try {
            if ((s.flags & 8772) !== 0) switch (s.tag) {
              case 0:
              case 11:
              case 15:
                ka || Mr(5, s);
                break;
              case 1:
                var C = s.stateNode;
                if (s.flags & 4 && !ka) if (y === null) C.componentDidMount();
                else {
                  var A = s.elementType === s.type ? y.memoizedProps : Pi(s.type, y.memoizedProps);
                  C.componentDidUpdate(A, y.memoizedState, C.__reactInternalSnapshotBeforeUpdate);
                }
                var H = s.updateQueue;
                H !== null && Po(s, H, C);
                break;
              case 3:
                var ne = s.updateQueue;
                if (ne !== null) {
                  if (y = null, s.child !== null) switch (s.child.tag) {
                    case 5:
                      y = ze(s.child.stateNode);
                      break;
                    case 1:
                      y = s.child.stateNode;
                  }
                  Po(s, ne, y);
                }
                break;
              case 5:
                var Ce = s.stateNode;
                y === null && s.flags & 4 && Tt(Ce, s.type, s.memoizedProps, s);
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (bt && s.memoizedState === null) {
                  var Ie = s.alternate;
                  if (Ie !== null) {
                    var ut = Ie.memoizedState;
                    if (ut !== null) {
                      var St = ut.dehydrated;
                      St !== null && Qr(St);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(d(163));
            }
            ka || s.flags & 512 && ah(s);
          } catch (rn) {
            Bn(s, s.return, rn);
          }
        }
        if (s === i) {
          Ct = null;
          break;
        }
        if (y = s.sibling, y !== null) {
          y.return = s.return, Ct = y;
          break;
        }
        Ct = s.return;
      }
    }
    function Ea(i) {
      for (; Ct !== null; ) {
        var s = Ct;
        if (s === i) {
          Ct = null;
          break;
        }
        var y = s.sibling;
        if (y !== null) {
          y.return = s.return, Ct = y;
          break;
        }
        Ct = s.return;
      }
    }
    function Rt(i) {
      for (; Ct !== null; ) {
        var s = Ct;
        try {
          switch (s.tag) {
            case 0:
            case 11:
            case 15:
              var y = s.return;
              try {
                Mr(4, s);
              } catch (Ie) {
                Bn(s, y, Ie);
              }
              break;
            case 1:
              var C = s.stateNode;
              if (typeof C.componentDidMount == "function") {
                var A = s.return;
                try {
                  C.componentDidMount();
                } catch (Ie) {
                  Bn(s, A, Ie);
                }
              }
              var H = s.return;
              try {
                ah(s);
              } catch (Ie) {
                Bn(s, H, Ie);
              }
              break;
            case 5:
              var ne = s.return;
              try {
                ah(s);
              } catch (Ie) {
                Bn(s, ne, Ie);
              }
          }
        } catch (Ie) {
          Bn(s, s.return, Ie);
        }
        if (s === i) {
          Ct = null;
          break;
        }
        var Ce = s.sibling;
        if (Ce !== null) {
          Ce.return = s.return, Ct = Ce;
          break;
        }
        Ct = s.return;
      }
    }
    var Li = 0, vi = 1, Bd = 2, Ud = 3, Id = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var xc = Symbol.for;
      Li = xc("selector.component"), vi = xc("selector.has_pseudo_class"), Bd = xc("selector.role"), Ud = xc("selector.test_id"), Id = xc("selector.text");
    }
    function oh(i) {
      var s = Xt(i);
      if (s != null) {
        if (typeof s.memoizedProps["data-testname"] != "string") throw Error(d(364));
        return s;
      }
      if (i = gn(i), i === null) throw Error(d(362));
      return i.stateNode.current;
    }
    function Gr(i, s) {
      switch (s.$$typeof) {
        case Li:
          if (i.type === s.value) return !0;
          break;
        case vi:
          e: {
            s = s.value, i = [i, 0];
            for (var y = 0; y < i.length; ) {
              var C = i[y++], A = i[y++], H = s[A];
              if (C.tag !== 5 || !cr(C)) {
                for (; H != null && Gr(C, H); ) A++, H = s[A];
                if (A === s.length) {
                  s = !0;
                  break e;
                } else for (C = C.child; C !== null; ) i.push(C, A), C = C.sibling;
              }
            }
            s = !1;
          }
          return s;
        case Bd:
          if (i.tag === 5 && er(i.stateNode, s.value)) return !0;
          break;
        case Id:
          if ((i.tag === 5 || i.tag === 6) && (i = ir(i), i !== null && 0 <= i.indexOf(s.value))) return !0;
          break;
        case Ud:
          if (i.tag === 5 && (i = i.memoizedProps["data-testname"], typeof i == "string" && i.toLowerCase() === s.value.toLowerCase())) return !0;
          break;
        default:
          throw Error(d(365));
      }
      return !1;
    }
    function sh(i) {
      switch (i.$$typeof) {
        case Li:
          return "<" + (X(i.value) || "Unknown") + ">";
        case vi:
          return ":has(" + (sh(i) || "") + ")";
        case Bd:
          return '[role="' + i.value + '"]';
        case Id:
          return '"' + i.value + '"';
        case Ud:
          return '[data-testname="' + i.value + '"]';
        default:
          throw Error(d(365));
      }
    }
    function Am(i, s) {
      var y = [];
      i = [i, 0];
      for (var C = 0; C < i.length; ) {
        var A = i[C++], H = i[C++], ne = s[H];
        if (A.tag !== 5 || !cr(A)) {
          for (; ne != null && Gr(A, ne); ) H++, ne = s[H];
          if (H === s.length) y.push(A);
          else for (A = A.child; A !== null; ) i.push(A, H), A = A.sibling;
        }
      }
      return y;
    }
    function lh(i, s) {
      if (!Pn) throw Error(d(363));
      i = oh(i), i = Am(i, s), s = [], i = Array.from(i);
      for (var y = 0; y < i.length; ) {
        var C = i[y++];
        if (C.tag === 5) cr(C) || s.push(C.stateNode);
        else for (C = C.child; C !== null; ) i.push(C), C = C.sibling;
      }
      return s;
    }
    var Mm = Math.ceil, Gs = f.ReactCurrentDispatcher, Vs = f.ReactCurrentOwner, Pr = f.ReactCurrentBatchConfig, xn = 0, ca = null, Vr = null, Ra = 0, Oi = 0, Ll = Ni(0), qr = 0, kc = null, Ol = 0, Hd = 0, uh = 0, Cc = null, yi = null, Gd = 0, ch = 1 / 0, Fo = null;
    function Su() {
      ch = Br() + 500;
    }
    var Vd = !1, Ec = null, qs = null, Ha = !1, Ga = null, wu = 0, Fl = 0, qd = null, Wd = -1, Rc = 0;
    function br() {
      return (xn & 6) !== 0 ? Br() : Wd !== -1 ? Wd : Wd = Br();
    }
    function hs(i) {
      return (i.mode & 1) === 0 ? 1 : (xn & 2) !== 0 && Ra !== 0 ? Ra & -Ra : hc.transition !== null ? (Rc === 0 && (Rc = ui()), Rc) : (i = Jt, i !== 0 ? i : qn());
    }
    function Ta(i, s, y, C) {
      if (50 < Fl) throw Fl = 0, qd = null, Error(d(185));
      ci(i, y, C), ((xn & 2) === 0 || i !== ca) && (i === ca && ((xn & 2) === 0 && (Hd |= y), qr === 4 && _i(i, Ra)), ea(i, C), y === 1 && xn === 0 && (s.mode & 1) === 0 && (Su(), nu && Ki()));
    }
    function ea(i, s) {
      var y = i.callbackNode;
      Wf(i, s);
      var C = yl(i, i === ca ? Ra : 0);
      if (C === 0) y !== null && bl(y), i.callbackNode = null, i.callbackPriority = 0;
      else if (s = C & -C, i.callbackPriority !== s) {
        if (y != null && bl(y), s === 1) i.tag === 0 ? ru(zo.bind(null, i)) : Ms(zo.bind(null, i)), bn ? Yr(function() {
          (xn & 6) === 0 && Ki();
        }) : rs(fi, Ki), y = null;
        else {
          switch (di(C)) {
            case 1:
              y = fi;
              break;
            case 4:
              y = uc;
              break;
            case 16:
              y = tu;
              break;
            case 536870912:
              y = cc;
              break;
            default:
              y = tu;
          }
          y = Fm(y, Tc.bind(null, i));
        }
        i.callbackPriority = s, i.callbackNode = y;
      }
    }
    function Tc(i, s) {
      if (Wd = -1, Rc = 0, (xn & 6) !== 0) throw Error(d(327));
      var y = i.callbackNode;
      if (xr() && i.callbackNode !== y) return null;
      var C = yl(i, i === ca ? Ra : 0);
      if (C === 0) return null;
      if ((C & 30) !== 0 || (C & i.expiredLanes) !== 0 || s) s = ku(i, C);
      else {
        s = C;
        var A = xn;
        xn |= 2;
        var H = Ws();
        (ca !== i || Ra !== s) && (Fo = null, Su(), zl(i, s));
        do
          try {
            rv();
            break;
          } catch (Ce) {
            Pm(i, Ce);
          }
        while (!0);
        xl(), Gs.current = H, xn = A, Vr !== null ? s = 0 : (ca = null, Ra = 0, s = qr);
      }
      if (s !== 0) {
        if (s === 2 && (A = va(i), A !== 0 && (C = A, s = xu(i, A))), s === 1) throw y = kc, zl(i, 0), _i(i, C), ea(i, Br()), y;
        if (s === 6) _i(i, C);
        else {
          if (A = i.current.alternate, (C & 30) === 0 && !Qi(A) && (s = ku(i, C), s === 2 && (H = va(i), H !== 0 && (C = H, s = xu(i, H))), s === 1)) throw y = kc, zl(i, 0), _i(i, C), ea(i, Br()), y;
          switch (i.finishedWork = A, i.finishedLanes = C, s) {
            case 0:
            case 1:
              throw Error(d(345));
            case 2:
              Bl(i, yi, Fo);
              break;
            case 3:
              if (_i(i, C), (C & 130023424) === C && (s = Gd + 500 - Br(), 10 < s)) {
                if (yl(i, 0) !== 0) break;
                if (A = i.suspendedLanes, (A & C) !== C) {
                  br(), i.pingedLanes |= i.suspendedLanes & A;
                  break;
                }
                i.timeoutHandle = ae(Bl.bind(null, i, yi, Fo), s);
                break;
              }
              Bl(i, yi, Fo);
              break;
            case 4:
              if (_i(i, C), (C & 4194240) === C) break;
              for (s = i.eventTimes, A = -1; 0 < C; ) {
                var ne = 31 - oa(C);
                H = 1 << ne, ne = s[ne], ne > A && (A = ne), C &= ~H;
              }
              if (C = A, C = Br() - C, C = (120 > C ? 120 : 480 > C ? 480 : 1080 > C ? 1080 : 1920 > C ? 1920 : 3e3 > C ? 3e3 : 4320 > C ? 4320 : 1960 * Mm(C / 1960)) - C, 10 < C) {
                i.timeoutHandle = ae(Bl.bind(null, i, yi, Fo), C);
                break;
              }
              Bl(i, yi, Fo);
              break;
            case 5:
              Bl(i, yi, Fo);
              break;
            default:
              throw Error(d(329));
          }
        }
      }
      return ea(i, Br()), i.callbackNode === y ? Tc.bind(null, i) : null;
    }
    function xu(i, s) {
      var y = Cc;
      return i.current.memoizedState.isDehydrated && (zl(i, s).flags |= 256), i = ku(i, s), i !== 2 && (s = yi, yi = y, s !== null && bi(s)), i;
    }
    function bi(i) {
      yi === null ? yi = i : yi.push.apply(yi, i);
    }
    function Qi(i) {
      for (var s = i; ; ) {
        if (s.flags & 16384) {
          var y = s.updateQueue;
          if (y !== null && (y = y.stores, y !== null)) for (var C = 0; C < y.length; C++) {
            var A = y[C], H = A.getSnapshot;
            A = A.value;
            try {
              if (!ya(H(), A)) return !1;
            } catch {
              return !1;
            }
          }
        }
        if (y = s.child, s.subtreeFlags & 16384 && y !== null) y.return = s, s = y;
        else {
          if (s === i) break;
          for (; s.sibling === null; ) {
            if (s.return === null || s.return === i) return !0;
            s = s.return;
          }
          s.sibling.return = s.return, s = s.sibling;
        }
      }
      return !0;
    }
    function _i(i, s) {
      for (s &= ~uh, s &= ~Hd, i.suspendedLanes |= s, i.pingedLanes &= ~s, i = i.expirationTimes; 0 < s; ) {
        var y = 31 - oa(s), C = 1 << y;
        i[y] = -1, s &= ~C;
      }
    }
    function zo(i) {
      if ((xn & 6) !== 0) throw Error(d(327));
      xr();
      var s = yl(i, 0);
      if ((s & 1) === 0) return ea(i, Br()), null;
      var y = ku(i, s);
      if (i.tag !== 0 && y === 2) {
        var C = va(i);
        C !== 0 && (s = C, y = xu(i, C));
      }
      if (y === 1) throw y = kc, zl(i, 0), _i(i, s), ea(i, Br()), y;
      if (y === 6) throw Error(d(345));
      return i.finishedWork = i.current.alternate, i.finishedLanes = s, Bl(i, yi, Fo), ea(i, Br()), null;
    }
    function Bo(i) {
      Ga !== null && Ga.tag === 0 && (xn & 6) === 0 && xr();
      var s = xn;
      xn |= 1;
      var y = Pr.transition, C = Jt;
      try {
        if (Pr.transition = null, Jt = 1, i) return i();
      } finally {
        Jt = C, Pr.transition = y, xn = s, (xn & 6) === 0 && Ki();
      }
    }
    function dh() {
      Oi = Ll.current, It(Ll);
    }
    function zl(i, s) {
      i.finishedWork = null, i.finishedLanes = 0;
      var y = i.timeoutHandle;
      if (y !== Qe && (i.timeoutHandle = Qe, Re(y)), Vr !== null) for (y = Vr.return; y !== null; ) {
        var C = y;
        switch (_l(C), C.tag) {
          case 1:
            C = C.type.childContextTypes, C != null && Wn();
            break;
          case 3:
            M(), It(zr), It(Ar), be();
            break;
          case 5:
            V(C);
            break;
          case 4:
            M();
            break;
          case 13:
            It(K);
            break;
          case 19:
            It(K);
            break;
          case 10:
            fu(C.type._context);
            break;
          case 22:
          case 23:
            dh();
        }
        y = y.return;
      }
      if (ca = i, Vr = i = ms(i.current, null), Ra = Oi = s, qr = 0, kc = null, uh = Hd = Ol = 0, yi = Cc = null, fo !== null) {
        for (s = 0; s < fo.length; s++) if (y = fo[s], C = y.interleaved, C !== null) {
          y.interleaved = null;
          var A = C.next, H = y.pending;
          if (H !== null) {
            var ne = H.next;
            H.next = A, C.next = ne;
          }
          y.pending = C;
        }
        fo = null;
      }
      return i;
    }
    function Pm(i, s) {
      do {
        var y = Vr;
        try {
          if (xl(), ke.current = mu, Se) {
            for (var C = fe.memoizedState; C !== null; ) {
              var A = C.queue;
              A !== null && (A.pending = null), C = C.next;
            }
            Se = !1;
          }
          if (me = 0, ge = ve = fe = null, we = !1, Te = 0, Vs.current = null, y === null || y.return === null) {
            qr = 1, kc = s, Vr = null;
            break;
          }
          e: {
            var H = i, ne = y.return, Ce = y, Ie = s;
            if (s = Ra, Ce.flags |= 32768, Ie !== null && typeof Ie == "object" && typeof Ie.then == "function") {
              var ut = Ie, St = Ce, rn = St.tag;
              if ((St.mode & 1) === 0 && (rn === 0 || rn === 11 || rn === 15)) {
                var Nt = St.alternate;
                Nt ? (St.updateQueue = Nt.updateQueue, St.memoizedState = Nt.memoizedState, St.lanes = Nt.lanes) : (St.updateQueue = null, St.memoizedState = null);
              }
              var _r = fr(ne);
              if (_r !== null) {
                _r.flags &= -257, yc(_r, ne, Ce, H, s), _r.mode & 1 && ym(H, ut, s), s = _r, Ie = ut;
                var mn = s.updateQueue;
                if (mn === null) {
                  var Un = /* @__PURE__ */ new Set();
                  Un.add(Ie), s.updateQueue = Un;
                } else mn.add(Ie);
                break e;
              } else {
                if ((s & 1) === 0) {
                  ym(H, ut, s), Kd();
                  break e;
                }
                Ie = Error(d(426));
              }
            } else if (sr && Ce.mode & 1) {
              var vs = fr(ne);
              if (vs !== null) {
                (vs.flags & 65536) === 0 && (vs.flags |= 256), yc(vs, ne, Ce, H, s), Sl(Tl(Ie, Ce));
                break e;
              }
            }
            H = Ie = Tl(Ie, Ce), qr !== 4 && (qr = 2), Cc === null ? Cc = [H] : Cc.push(H), H = ne;
            do {
              switch (H.tag) {
                case 3:
                  H.flags |= 65536, s &= -s, H.lanes |= s;
                  var Le = Is(H, Ie, s);
                  hu(H, Le);
                  break e;
                case 1:
                  Ce = Ie;
                  var xe = H.type, Ve = H.stateNode;
                  if ((H.flags & 128) === 0 && (typeof xe.getDerivedStateFromError == "function" || Ve !== null && typeof Ve.componentDidCatch == "function" && (qs === null || !qs.has(Ve)))) {
                    H.flags |= 65536, s &= -s, H.lanes |= s;
                    var wt = mi(H, Ce, s);
                    hu(H, wt);
                    break e;
                  }
              }
              H = H.return;
            } while (H !== null);
          }
          Dm(y);
        } catch (Yt) {
          s = Yt, Vr === y && y !== null && (Vr = y = y.return);
          continue;
        }
        break;
      } while (!0);
    }
    function Ws() {
      var i = Gs.current;
      return Gs.current = mu, i === null ? mu : i;
    }
    function Kd() {
      (qr === 0 || qr === 3 || qr === 2) && (qr = 4), ca === null || (Ol & 268435455) === 0 && (Hd & 268435455) === 0 || _i(ca, Ra);
    }
    function ku(i, s) {
      var y = xn;
      xn |= 2;
      var C = Ws();
      (ca !== i || Ra !== s) && (Fo = null, zl(i, s));
      do
        try {
          jd();
          break;
        } catch (A) {
          Pm(i, A);
        }
      while (!0);
      if (xl(), xn = y, Gs.current = C, Vr !== null) throw Error(d(261));
      return ca = null, Ra = 0, qr;
    }
    function jd() {
      for (; Vr !== null; ) Yd(Vr);
    }
    function rv() {
      for (; Vr !== null && !lc(); ) Yd(Vr);
    }
    function Yd(i) {
      var s = Om(i.alternate, i, Oi);
      i.memoizedProps = i.pendingProps, s === null ? Dm(i) : Vr = s, Vs.current = null;
    }
    function Dm(i) {
      var s = i;
      do {
        var y = s.alternate;
        if (i = s.return, (s.flags & 32768) === 0) {
          if (y = rh(y, s, Oi), y !== null) {
            Vr = y;
            return;
          }
        } else {
          if (y = tv(y, s), y !== null) {
            y.flags &= 32767, Vr = y;
            return;
          }
          if (i !== null) i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
          else {
            qr = 6, Vr = null;
            return;
          }
        }
        if (s = s.sibling, s !== null) {
          Vr = s;
          return;
        }
        Vr = s = i;
      } while (s !== null);
      qr === 0 && (qr = 5);
    }
    function Bl(i, s, y) {
      var C = Jt, A = Pr.transition;
      try {
        Pr.transition = null, Jt = 1, Ul(i, s, y, C);
      } finally {
        Pr.transition = A, Jt = C;
      }
      return null;
    }
    function Ul(i, s, y, C) {
      do
        xr();
      while (Ga !== null);
      if ((xn & 6) !== 0) throw Error(d(327));
      y = i.finishedWork;
      var A = i.finishedLanes;
      if (y === null) return null;
      if (i.finishedWork = null, i.finishedLanes = 0, y === i.current) throw Error(d(177));
      i.callbackNode = null, i.callbackPriority = 0;
      var H = y.lanes | y.childLanes;
      if (hd(i, H), i === ca && (Vr = ca = null, Ra = 0), (y.subtreeFlags & 2064) === 0 && (y.flags & 2064) === 0 || Ha || (Ha = !0, Fm(tu, function() {
        return xr(), null;
      })), H = (y.flags & 15990) !== 0, (y.subtreeFlags & 15990) !== 0 || H) {
        H = Pr.transition, Pr.transition = null;
        var ne = Jt;
        Jt = 1;
        var Ce = xn;
        xn |= 4, Vs.current = null, Sc(i, y), Pl(y, i), Q(i.containerInfo), i.current = y, nv(y), No(), xn = Ce, Jt = ne, Pr.transition = H;
      } else i.current = y;
      if (Ha && (Ha = !1, Ga = i, wu = A), H = i.pendingLanes, H === 0 && (qs = null), pd(y.stateNode), ea(i, Br()), s !== null) for (C = i.onRecoverableError, y = 0; y < s.length; y++) A = s[y], C(A.value, { componentStack: A.stack, digest: A.digest });
      if (Vd) throw Vd = !1, i = Ec, Ec = null, i;
      return (wu & 1) !== 0 && i.tag !== 0 && xr(), H = i.pendingLanes, (H & 1) !== 0 ? i === qd ? Fl++ : (Fl = 0, qd = i) : Fl = 0, Ki(), null;
    }
    function xr() {
      if (Ga !== null) {
        var i = di(wu), s = Pr.transition, y = Jt;
        try {
          if (Pr.transition = null, Jt = 16 > i ? 16 : i, Ga === null) var C = !1;
          else {
            if (i = Ga, Ga = null, wu = 0, (xn & 6) !== 0) throw Error(d(331));
            var A = xn;
            for (xn |= 4, Ct = i.current; Ct !== null; ) {
              var H = Ct, ne = H.child;
              if ((Ct.flags & 16) !== 0) {
                var Ce = H.deletions;
                if (Ce !== null) {
                  for (var Ie = 0; Ie < Ce.length; Ie++) {
                    var ut = Ce[Ie];
                    for (Ct = ut; Ct !== null; ) {
                      var St = Ct;
                      switch (St.tag) {
                        case 0:
                        case 11:
                        case 15:
                          $a(8, St, H);
                      }
                      var rn = St.child;
                      if (rn !== null) rn.return = St, Ct = rn;
                      else for (; Ct !== null; ) {
                        St = Ct;
                        var Nt = St.sibling, _r = St.return;
                        if (Rm(St), St === ut) {
                          Ct = null;
                          break;
                        }
                        if (Nt !== null) {
                          Nt.return = _r, Ct = Nt;
                          break;
                        }
                        Ct = _r;
                      }
                    }
                  }
                  var mn = H.alternate;
                  if (mn !== null) {
                    var Un = mn.child;
                    if (Un !== null) {
                      mn.child = null;
                      do {
                        var vs = Un.sibling;
                        Un.sibling = null, Un = vs;
                      } while (Un !== null);
                    }
                  }
                  Ct = H;
                }
              }
              if ((H.subtreeFlags & 2064) !== 0 && ne !== null) ne.return = H, Ct = ne;
              else e: for (; Ct !== null; ) {
                if (H = Ct, (H.flags & 2048) !== 0) switch (H.tag) {
                  case 0:
                  case 11:
                  case 15:
                    $a(9, H, H.return);
                }
                var Le = H.sibling;
                if (Le !== null) {
                  Le.return = H.return, Ct = Le;
                  break e;
                }
                Ct = H.return;
              }
            }
            var xe = i.current;
            for (Ct = xe; Ct !== null; ) {
              ne = Ct;
              var Ve = ne.child;
              if ((ne.subtreeFlags & 2064) !== 0 && Ve !== null) Ve.return = ne, Ct = Ve;
              else e: for (ne = xe; Ct !== null; ) {
                if (Ce = Ct, (Ce.flags & 2048) !== 0) try {
                  switch (Ce.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Mr(9, Ce);
                  }
                } catch (Yt) {
                  Bn(Ce, Ce.return, Yt);
                }
                if (Ce === ne) {
                  Ct = null;
                  break e;
                }
                var wt = Ce.sibling;
                if (wt !== null) {
                  wt.return = Ce.return, Ct = wt;
                  break e;
                }
                Ct = Ce.return;
              }
            }
            if (xn = A, Ki(), Ya && typeof Ya.onPostCommitFiberRoot == "function") try {
              Ya.onPostCommitFiberRoot(Ao, i);
            } catch {
            }
            C = !0;
          }
          return C;
        } finally {
          Jt = y, Pr.transition = s;
        }
      }
      return !1;
    }
    function Fi(i, s, y) {
      s = Tl(y, s), s = Is(i, s, 1), i = Qa(i, s, 1), s = br(), i !== null && (ci(i, 1, s), ea(i, s));
    }
    function Bn(i, s, y) {
      if (i.tag === 3) Fi(i, i, y);
      else for (; s !== null; ) {
        if (s.tag === 3) {
          Fi(s, i, y);
          break;
        } else if (s.tag === 1) {
          var C = s.stateNode;
          if (typeof s.type.getDerivedStateFromError == "function" || typeof C.componentDidCatch == "function" && (qs === null || !qs.has(C))) {
            i = Tl(y, i), i = mi(s, i, 1), s = Qa(s, i, 1), i = br(), s !== null && (ci(s, 1, i), ea(s, i));
            break;
          }
        }
        s = s.return;
      }
    }
    function Ks(i, s, y) {
      var C = i.pingCache;
      C !== null && C.delete(s), s = br(), i.pingedLanes |= i.suspendedLanes & y, ca === i && (Ra & y) === y && (qr === 4 || qr === 3 && (Ra & 130023424) === Ra && 500 > Br() - Gd ? zl(i, 0) : uh |= y), ea(i, s);
    }
    function ps(i, s) {
      s === 0 && ((i.mode & 1) === 0 ? s = 1 : (s = eu, eu <<= 1, (eu & 130023424) === 0 && (eu = 4194304)));
      var y = br();
      i = pi(i, s), i !== null && (ci(i, s, y), ea(i, y));
    }
    function av(i) {
      var s = i.memoizedState, y = 0;
      s !== null && (y = s.retryLane), ps(i, y);
    }
    function Lm(i, s) {
      var y = 0;
      switch (i.tag) {
        case 13:
          var C = i.stateNode, A = i.memoizedState;
          A !== null && (y = A.retryLane);
          break;
        case 19:
          C = i.stateNode;
          break;
        default:
          throw Error(d(314));
      }
      C !== null && C.delete(s), ps(i, y);
    }
    var Om;
    Om = function(i, s, y) {
      if (i !== null) if (i.memoizedProps !== s.pendingProps || zr.current) la = !0;
      else {
        if ((i.lanes & y) === 0 && (s.flags & 128) === 0) return la = !1, fn(i, s, y);
        la = (i.flags & 131072) !== 0;
      }
      else la = !1, sr && (s.flags & 1048576) !== 0 && Yi(s, Ps, s.index);
      switch (s.lanes = 0, s.tag) {
        case 2:
          var C = s.type;
          Ua(i, s), i = s.pendingProps;
          var A = Ro(s, Ar.current);
          co(s, y), A = nt(null, s, C, i, A, y);
          var H = lt();
          return s.flags |= 1, typeof A == "object" && A !== null && typeof A.render == "function" && A.$$typeof === void 0 ? (s.tag = 1, s.memoizedState = null, s.updateQueue = null, ia(C) ? (H = !0, lo(s)) : H = !1, s.memoizedState = A.state !== null && A.state !== void 0 ? A.state : null, Ur(s), A.updater = ds, s.stateNode = A, A._reactInternals = s, gc(s, C, i, y), s = Ad(null, s, C, !0, H, y)) : (s.tag = 0, sr && H && ss(s), ua(null, s, A, y), s = s.child), s;
        case 16:
          C = s.elementType;
          e: {
            switch (Ua(i, s), i = s.pendingProps, A = C._init, C = A(C._payload), s.type = C, A = s.tag = fh(C), i = Pi(C, i), A) {
              case 0:
                s = $f(null, s, C, i, y);
                break e;
              case 1:
                s = Nd(null, s, C, i, y);
                break e;
              case 11:
                s = bm(null, s, C, i, y);
                break e;
              case 14:
                s = _m(null, s, C, Pi(C.type, i), y);
                break e;
            }
            throw Error(d(
              306,
              C,
              ""
            ));
          }
          return s;
        case 0:
          return C = s.type, A = s.pendingProps, A = s.elementType === C ? A : Pi(C, A), $f(i, s, C, A, y);
        case 1:
          return C = s.type, A = s.pendingProps, A = s.elementType === C ? A : Pi(C, A), Nd(i, s, C, A, y);
        case 3:
          e: {
            if (xm(s), i === null) throw Error(d(387));
            C = s.pendingProps, H = s.memoizedState, A = H.element, gr(i, s), cs(s, C, null, y);
            var ne = s.memoizedState;
            if (C = ne.element, bt && H.isDehydrated) if (H = { element: C, isDehydrated: !1, cache: ne.cache, pendingSuspenseBoundaries: ne.pendingSuspenseBoundaries, transitions: ne.transitions }, s.updateQueue.baseState = H, s.memoizedState = H, s.flags & 256) {
              A = Tl(Error(d(423)), s), s = km(i, s, C, y, A);
              break e;
            } else if (C !== A) {
              A = Tl(Error(d(424)), s), s = km(i, s, C, y, A);
              break e;
            } else for (bt && (za = Tr(s.stateNode.containerInfo), _a = s, sr = !0, Sa = null, Cr = !1), y = lu(s, null, C, y), s.child = y; y; ) y.flags = y.flags & -3 | 4096, y = y.sibling;
            else {
              if (hi(), C === A) {
                s = gi(i, s, y);
                break e;
              }
              ua(i, s, C, y);
            }
            s = s.child;
          }
          return s;
        case 5:
          return O(s), i === null && au(s), C = s.type, A = s.pendingProps, H = i !== null ? i.memoizedProps : null, ne = A.children, We(C, A) ? ne = null : H !== null && We(C, H) && (s.flags |= 32), Td(i, s), ua(i, s, ne, y), s.child;
        case 6:
          return i === null && au(s), null;
        case 13:
          return th(i, s, y);
        case 4:
          return _(s, s.stateNode.containerInfo), C = s.pendingProps, i === null ? s.child = Fs(s, null, C, y) : ua(i, s, C, y), s.child;
        case 11:
          return C = s.type, A = s.pendingProps, A = s.elementType === C ? A : Pi(C, A), bm(i, s, C, A, y);
        case 7:
          return ua(i, s, s.pendingProps, y), s.child;
        case 8:
          return ua(i, s, s.pendingProps.children, y), s.child;
        case 12:
          return ua(i, s, s.pendingProps.children, y), s.child;
        case 10:
          e: {
            if (C = s.type._context, A = s.pendingProps, H = s.memoizedProps, ne = A.value, du(s, C, ne), H !== null) if (ya(H.value, ne)) {
              if (H.children === A.children && !zr.current) {
                s = gi(i, s, y);
                break e;
              }
            } else for (H = s.child, H !== null && (H.return = s); H !== null; ) {
              var Ce = H.dependencies;
              if (Ce !== null) {
                ne = H.child;
                for (var Ie = Ce.firstContext; Ie !== null; ) {
                  if (Ie.context === C) {
                    if (H.tag === 1) {
                      Ie = wa(-1, y & -y), Ie.tag = 2;
                      var ut = H.updateQueue;
                      if (ut !== null) {
                        ut = ut.shared;
                        var St = ut.pending;
                        St === null ? Ie.next = Ie : (Ie.next = St.next, St.next = Ie), ut.pending = Ie;
                      }
                    }
                    H.lanes |= y, Ie = H.alternate, Ie !== null && (Ie.lanes |= y), kl(H.return, y, s), Ce.lanes |= y;
                    break;
                  }
                  Ie = Ie.next;
                }
              } else if (H.tag === 10) ne = H.type === s.type ? null : H.child;
              else if (H.tag === 18) {
                if (ne = H.return, ne === null) throw Error(d(341));
                ne.lanes |= y, Ce = ne.alternate, Ce !== null && (Ce.lanes |= y), kl(ne, y, s), ne = H.sibling;
              } else ne = H.child;
              if (ne !== null) ne.return = H;
              else for (ne = H; ne !== null; ) {
                if (ne === s) {
                  ne = null;
                  break;
                }
                if (H = ne.sibling, H !== null) {
                  H.return = ne.return, ne = H;
                  break;
                }
                ne = ne.return;
              }
              H = ne;
            }
            ua(i, s, A.children, y), s = s.child;
          }
          return s;
        case 9:
          return A = s.type, C = s.pendingProps.children, co(s, y), A = Ba(A), C = C(A), s.flags |= 1, ua(i, s, C, y), s.child;
        case 14:
          return C = s.type, A = Pi(C, s.pendingProps), A = Pi(C.type, A), _m(i, s, C, A, y);
        case 15:
          return Sm(i, s, s.type, s.pendingProps, y);
        case 17:
          return C = s.type, A = s.pendingProps, A = s.elementType === C ? A : Pi(C, A), Ua(i, s), s.tag = 1, ia(C) ? (i = !0, lo(s)) : i = !1, co(s, y), kd(s, C, A), gc(s, C, A, y), Ad(null, s, C, !0, i, y);
        case 19:
          return Dd(i, s, y);
        case 22:
          return wm(i, s, y);
      }
      throw Error(d(156, s.tag));
    };
    function Fm(i, s) {
      return rs(i, s);
    }
    function iv(i, s, y, C) {
      this.tag = i, this.key = y, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = s, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = C, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function zi(i, s, y, C) {
      return new iv(i, s, y, C);
    }
    function Zd(i) {
      return i = i.prototype, !(!i || !i.isReactComponent);
    }
    function fh(i) {
      if (typeof i == "function") return Zd(i) ? 1 : 0;
      if (i != null) {
        if (i = i.$$typeof, i === P) return 11;
        if (i === x) return 14;
      }
      return 2;
    }
    function ms(i, s) {
      var y = i.alternate;
      return y === null ? (y = zi(i.tag, s, i.key, i.mode), y.elementType = i.elementType, y.type = i.type, y.stateNode = i.stateNode, y.alternate = i, i.alternate = y) : (y.pendingProps = s, y.type = i.type, y.flags = 0, y.subtreeFlags = 0, y.deletions = null), y.flags = i.flags & 14680064, y.childLanes = i.childLanes, y.lanes = i.lanes, y.child = i.child, y.memoizedProps = i.memoizedProps, y.memoizedState = i.memoizedState, y.updateQueue = i.updateQueue, s = i.dependencies, y.dependencies = s === null ? null : { lanes: s.lanes, firstContext: s.firstContext }, y.sibling = i.sibling, y.index = i.index, y.ref = i.ref, y;
    }
    function Nc(i, s, y, C, A, H) {
      var ne = 2;
      if (C = i, typeof i == "function") Zd(i) && (ne = 1);
      else if (typeof i == "string") ne = 5;
      else e: switch (i) {
        case v:
          return gs(y.children, A, H, s);
        case E:
          ne = 8, A |= 8;
          break;
        case S:
          return i = zi(12, y, s, A | 2), i.elementType = S, i.lanes = H, i;
        case z:
          return i = zi(13, y, s, A), i.elementType = z, i.lanes = H, i;
        case L:
          return i = zi(19, y, s, A), i.elementType = L, i.lanes = H, i;
        case R:
          return Cu(y, A, H, s);
        default:
          if (typeof i == "object" && i !== null) switch (i.$$typeof) {
            case w:
              ne = 10;
              break e;
            case T:
              ne = 9;
              break e;
            case P:
              ne = 11;
              break e;
            case x:
              ne = 14;
              break e;
            case k:
              ne = 16, C = null;
              break e;
          }
          throw Error(d(130, i == null ? i : typeof i, ""));
      }
      return s = zi(ne, y, s, A), s.elementType = i, s.type = C, s.lanes = H, s;
    }
    function gs(i, s, y, C) {
      return i = zi(7, i, C, s), i.lanes = y, i;
    }
    function Cu(i, s, y, C) {
      return i = zi(22, i, C, s), i.elementType = R, i.lanes = y, i.stateNode = { isHidden: !1 }, i;
    }
    function Ac(i, s, y) {
      return i = zi(6, i, null, s), i.lanes = y, i;
    }
    function hh(i, s, y) {
      return s = zi(4, i.children !== null ? i.children : [], i.key, s), s.lanes = y, s.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, s;
    }
    function ov(i, s, y, C, A) {
      this.tag = s, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = Qe, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Ns(0), this.expirationTimes = Ns(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ns(0), this.identifierPrefix = C, this.onRecoverableError = A, bt && (this.mutableSourceEagerHydrationData = null);
    }
    function zm(i, s, y, C, A, H, ne, Ce, Ie) {
      return i = new ov(i, s, y, Ce, Ie), s === 1 ? (s = 1, H === !0 && (s |= 8)) : s = 0, H = zi(3, null, null, s), i.current = H, H.stateNode = i, H.memoizedState = { element: C, isDehydrated: y, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Ur(H), i;
    }
    function Bm(i) {
      if (!i) return so;
      i = i._reactInternals;
      e: {
        if (U(i) !== i || i.tag !== 1) throw Error(d(170));
        var s = i;
        do {
          switch (s.tag) {
            case 3:
              s = s.stateNode.context;
              break e;
            case 1:
              if (ia(s.type)) {
                s = s.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }
          }
          s = s.return;
        } while (s !== null);
        throw Error(d(171));
      }
      if (i.tag === 1) {
        var y = i.type;
        if (ia(y)) return ts(i, y, s);
      }
      return s;
    }
    function ph(i) {
      var s = i._reactInternals;
      if (s === void 0)
        throw typeof i.render == "function" ? Error(d(188)) : (i = Object.keys(i).join(","), Error(d(268, i)));
      return i = te(s), i === null ? null : i.stateNode;
    }
    function Mc(i, s) {
      if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
        var y = i.retryLane;
        i.retryLane = y !== 0 && y < s ? y : s;
      }
    }
    function Xd(i, s) {
      Mc(i, s), (i = i.alternate) && Mc(i, s);
    }
    function Um(i) {
      return i = te(i), i === null ? null : i.stateNode;
    }
    function Eu() {
      return null;
    }
    return r.attemptContinuousHydration = function(i) {
      if (i.tag === 13) {
        var s = pi(i, 134217728);
        if (s !== null) {
          var y = br();
          Ta(s, i, 134217728, y);
        }
        Xd(i, 134217728);
      }
    }, r.attemptDiscreteHydration = function(i) {
      if (i.tag === 13) {
        var s = pi(i, 1);
        if (s !== null) {
          var y = br();
          Ta(s, i, 1, y);
        }
        Xd(i, 1);
      }
    }, r.attemptHydrationAtCurrentPriority = function(i) {
      if (i.tag === 13) {
        var s = hs(i), y = pi(i, s);
        if (y !== null) {
          var C = br();
          Ta(y, i, s, C);
        }
        Xd(i, s);
      }
    }, r.attemptSynchronousHydration = function(i) {
      switch (i.tag) {
        case 3:
          var s = i.stateNode;
          if (s.current.memoizedState.isDehydrated) {
            var y = wn(s.pendingLanes);
            y !== 0 && (To(s, y | 1), ea(s, Br()), (xn & 6) === 0 && (Su(), Ki()));
          }
          break;
        case 13:
          Bo(function() {
            var C = pi(i, 1);
            if (C !== null) {
              var A = br();
              Ta(C, i, 1, A);
            }
          }), Xd(i, 1);
      }
    }, r.batchedUpdates = function(i, s) {
      var y = xn;
      xn |= 1;
      try {
        return i(s);
      } finally {
        xn = y, xn === 0 && (Su(), nu && Ki());
      }
    }, r.createComponentSelector = function(i) {
      return { $$typeof: Li, value: i };
    }, r.createContainer = function(i, s, y, C, A, H, ne) {
      return zm(i, s, !1, null, y, C, A, H, ne);
    }, r.createHasPseudoClassSelector = function(i) {
      return { $$typeof: vi, value: i };
    }, r.createHydrationContainer = function(i, s, y, C, A, H, ne, Ce, Ie) {
      return i = zm(y, C, !0, i, A, H, ne, Ce, Ie), i.context = Bm(null), y = i.current, C = br(), A = hs(y), H = wa(C, A), H.callback = s ?? null, Qa(y, H, A), i.current.lanes = A, ci(i, A, C), ea(i, C), i;
    }, r.createPortal = function(i, s, y) {
      var C = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return { $$typeof: h, key: C == null ? null : "" + C, children: i, containerInfo: s, implementation: y };
    }, r.createRoleSelector = function(i) {
      return { $$typeof: Bd, value: i };
    }, r.createTestNameSelector = function(i) {
      return { $$typeof: Ud, value: i };
    }, r.createTextSelector = function(i) {
      return { $$typeof: Id, value: i };
    }, r.deferredUpdates = function(i) {
      var s = Jt, y = Pr.transition;
      try {
        return Pr.transition = null, Jt = 16, i();
      } finally {
        Jt = s, Pr.transition = y;
      }
    }, r.discreteUpdates = function(i, s, y, C, A) {
      var H = Jt, ne = Pr.transition;
      try {
        return Pr.transition = null, Jt = 1, i(s, y, C, A);
      } finally {
        Jt = H, Pr.transition = ne, xn === 0 && Su();
      }
    }, r.findAllNodes = lh, r.findBoundingRects = function(i, s) {
      if (!Pn) throw Error(d(363));
      s = lh(i, s), i = [];
      for (var y = 0; y < s.length; y++) i.push(vn(s[y]));
      for (s = i.length - 1; 0 < s; s--) {
        y = i[s];
        for (var C = y.x, A = C + y.width, H = y.y, ne = H + y.height, Ce = s - 1; 0 <= Ce; Ce--) if (s !== Ce) {
          var Ie = i[Ce], ut = Ie.x, St = ut + Ie.width, rn = Ie.y, Nt = rn + Ie.height;
          if (C >= ut && H >= rn && A <= St && ne <= Nt) {
            i.splice(s, 1);
            break;
          } else if (C !== ut || y.width !== Ie.width || Nt < H || rn > ne) {
            if (!(H !== rn || y.height !== Ie.height || St < C || ut > A)) {
              ut > C && (Ie.width += ut - C, Ie.x = C), St < A && (Ie.width = A - ut), i.splice(s, 1);
              break;
            }
          } else {
            rn > H && (Ie.height += rn - H, Ie.y = H), Nt < ne && (Ie.height = ne - rn), i.splice(s, 1);
            break;
          }
        }
      }
      return i;
    }, r.findHostInstance = ph, r.findHostInstanceWithNoPortals = function(i) {
      return i = Z(i), i = i !== null ? ue(i) : null, i === null ? null : i.stateNode;
    }, r.findHostInstanceWithWarning = function(i) {
      return ph(i);
    }, r.flushControlled = function(i) {
      var s = xn;
      xn |= 1;
      var y = Pr.transition, C = Jt;
      try {
        Pr.transition = null, Jt = 1, i();
      } finally {
        Jt = C, Pr.transition = y, xn = s, xn === 0 && (Su(), Ki());
      }
    }, r.flushPassiveEffects = xr, r.flushSync = Bo, r.focusWithin = function(i, s) {
      if (!Pn) throw Error(d(363));
      for (i = oh(i), s = Am(i, s), s = Array.from(s), i = 0; i < s.length; ) {
        var y = s[i++];
        if (!cr(y)) {
          if (y.tag === 5 && ln(y.stateNode)) return !0;
          for (y = y.child; y !== null; ) s.push(y), y = y.sibling;
        }
      }
      return !1;
    }, r.getCurrentUpdatePriority = function() {
      return Jt;
    }, r.getFindAllNodesFailureDescription = function(i, s) {
      if (!Pn) throw Error(d(363));
      var y = 0, C = [];
      i = [oh(i), 0];
      for (var A = 0; A < i.length; ) {
        var H = i[A++], ne = i[A++], Ce = s[ne];
        if ((H.tag !== 5 || !cr(H)) && (Gr(H, Ce) && (C.push(sh(Ce)), ne++, ne > y && (y = ne)), ne < s.length)) for (H = H.child; H !== null; ) i.push(H, ne), H = H.sibling;
      }
      if (y < s.length) {
        for (i = []; y < s.length; y++) i.push(sh(s[y]));
        return `findAllNodes was able to match part of the selector:
  ` + (C.join(" > ") + `

No matching component was found for:
  `) + i.join(" > ");
      }
      return null;
    }, r.getPublicRootInstance = function(i) {
      if (i = i.current, !i.child) return null;
      switch (i.child.tag) {
        case 5:
          return ze(i.child.stateNode);
        default:
          return i.child.stateNode;
      }
    }, r.injectIntoDevTools = function(i) {
      if (i = { bundleType: i.bundleType, version: i.version, rendererPackageName: i.rendererPackageName, rendererConfig: i.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: f.ReactCurrentDispatcher, findHostInstanceByFiber: Um, findFiberByHostInstance: i.findFiberByHostInstance || Eu, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1" }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") i = !1;
      else {
        var s = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (s.isDisabled || !s.supportsFiber) i = !0;
        else {
          try {
            Ao = s.inject(i), Ya = s;
          } catch {
          }
          i = !!s.checkDCE;
        }
      }
      return i;
    }, r.isAlreadyRendering = function() {
      return !1;
    }, r.observeVisibleRects = function(i, s, y, C) {
      if (!Pn) throw Error(d(363));
      i = lh(i, s);
      var A = dr(i, y, C).disconnect;
      return { disconnect: function() {
        A();
      } };
    }, r.registerMutableSourceForHydration = function(i, s) {
      var y = s._getVersion;
      y = y(s._source), i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [s, y] : i.mutableSourceEagerHydrationData.push(s, y);
    }, r.runWithPriority = function(i, s) {
      var y = Jt;
      try {
        return Jt = i, s();
      } finally {
        Jt = y;
      }
    }, r.shouldError = function() {
      return null;
    }, r.shouldSuspend = function() {
      return !1;
    }, r.updateContainer = function(i, s, y, C) {
      var A = s.current, H = br(), ne = hs(A);
      return y = Bm(y), s.context === null ? s.context = y : s.pendingContext = y, s = wa(H, ne), s.payload = { element: i }, C = C === void 0 ? null : C, C !== null && (s.callback = C), i = Qa(A, s, ne), i !== null && (Ta(i, A, ne, H), Bs(i, A, ne)), ne;
    }, r;
  }), Hy;
}
var Gy = { exports: {} };
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U4;
function XA() {
  return U4 || (U4 = 1, process.env.NODE_ENV !== "production" && (Gy.exports = function(t) {
    var r = {}, o = na, l = xb(), u = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, d = !1;
    function f(n) {
      d = n;
    }
    function g(n) {
      if (!d) {
        for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), p = 1; p < a; p++)
          c[p - 1] = arguments[p];
        v("warn", n, c);
      }
    }
    function h(n) {
      if (!d) {
        for (var a = arguments.length, c = new Array(a > 1 ? a - 1 : 0), p = 1; p < a; p++)
          c[p - 1] = arguments[p];
        v("error", n, c);
      }
    }
    function v(n, a, c) {
      {
        var p = u.ReactDebugCurrentFrame, b = p.getStackAddendum();
        b !== "" && (a += "%s", c = c.concat([b]));
        var N = c.map(function(G) {
          return String(G);
        });
        N.unshift("Warning: " + a), Function.prototype.apply.call(console[n], console, N);
      }
    }
    var E = Object.assign;
    function S(n) {
      return n._reactInternals;
    }
    function w(n, a) {
      n._reactInternals = a;
    }
    var T = !1, P = !1, z = !1, L = !0, x = !0, k = !0, R = !0, B = 0, q = 1, X = 2, I = 3, U = 4, F = 5, Z = 6, te = 7, ie = 8, ue = 9, ce = 10, ze = 11, W = 12, j = 13, ee = 14, Q = 15, oe = 16, ye = 17, pe = 18, Me = 19, We = 21, Ee = 22, ae = 23, Re = 24, Qe = 25, Pe = Symbol.for("react.element"), rt = Symbol.for("react.portal"), st = Symbol.for("react.fragment"), bt = Symbol.for("react.strict_mode"), Xt = Symbol.for("react.profiler"), Lt = Symbol.for("react.provider"), qn = Symbol.for("react.context"), Wt = Symbol.for("react.forward_ref"), bn = Symbol.for("react.suspense"), Yr = Symbol.for("react.suspense_list"), Pn = Symbol.for("react.memo"), gn = Symbol.for("react.lazy"), vn = Symbol.for("react.scope"), ir = Symbol.for("react.debug_trace_mode"), cr = Symbol.for("react.offscreen"), er = Symbol.for("react.legacy_hidden"), ln = Symbol.for("react.cache"), dr = Symbol.for("react.tracing_marker"), kn = Symbol.iterator, tr = "@@iterator";
    function ot(n) {
      if (n === null || typeof n != "object")
        return null;
      var a = kn && n[kn] || n[tr];
      return typeof a == "function" ? a : null;
    }
    function Tt(n, a, c) {
      var p = n.displayName;
      if (p)
        return p;
      var b = a.displayName || a.name || "";
      return b !== "" ? c + "(" + b + ")" : c;
    }
    function Ut(n) {
      return n.displayName || "Context";
    }
    function Ft(n) {
      if (n == null)
        return null;
      if (typeof n.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof n == "function")
        return n.displayName || n.name || null;
      if (typeof n == "string")
        return n;
      switch (n) {
        case st:
          return "Fragment";
        case rt:
          return "Portal";
        case Xt:
          return "Profiler";
        case bt:
          return "StrictMode";
        case bn:
          return "Suspense";
        case Yr:
          return "SuspenseList";
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case qn:
            var a = n;
            return Ut(a) + ".Consumer";
          case Lt:
            var c = n;
            return Ut(c._context) + ".Provider";
          case Wt:
            return Tt(n, n.render, "ForwardRef");
          case Pn:
            var p = n.displayName || null;
            return p !== null ? p : Ft(n.type) || "Memo";
          case gn: {
            var b = n, N = b._payload, G = b._init;
            try {
              return Ft(G(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Fn(n, a, c) {
      var p = a.displayName || a.name || "";
      return n.displayName || (p !== "" ? c + "(" + p + ")" : c);
    }
    function _n(n) {
      return n.displayName || "Context";
    }
    function qe(n) {
      var a = n.tag, c = n.type;
      switch (a) {
        case Re:
          return "Cache";
        case ue:
          var p = c;
          return _n(p) + ".Consumer";
        case ce:
          var b = c;
          return _n(b._context) + ".Provider";
        case pe:
          return "DehydratedFragment";
        case ze:
          return Fn(c, c.render, "ForwardRef");
        case te:
          return "Fragment";
        case F:
          return c;
        case U:
          return "Portal";
        case I:
          return "Root";
        case Z:
          return "Text";
        case oe:
          return Ft(c);
        case ie:
          return c === bt ? "StrictMode" : "Mode";
        case Ee:
          return "Offscreen";
        case W:
          return "Profiler";
        case We:
          return "Scope";
        case j:
          return "Suspense";
        case Me:
          return "SuspenseList";
        case Qe:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case q:
        case B:
        case ye:
        case X:
        case ee:
        case Q:
          if (typeof c == "function")
            return c.displayName || c.name || null;
          if (typeof c == "string")
            return c;
          break;
      }
      return null;
    }
    var gt = (
      /*                      */
      0
    ), Dn = (
      /*                */
      1
    ), Tn = (
      /*                    */
      2
    ), Xe = (
      /*                       */
      4
    ), Ue = (
      /*                */
      16
    ), _t = (
      /*                 */
      32
    ), or = (
      /*                     */
      64
    ), xt = (
      /*                   */
      128
    ), zn = (
      /*            */
      256
    ), aa = (
      /*                          */
      512
    ), Zr = (
      /*                     */
      1024
    ), mr = (
      /*                      */
      2048
    ), Xr = (
      /*                    */
      4096
    ), de = (
      /*                   */
      8192
    ), et = (
      /*             */
      16384
    ), Ge = (
      /*               */
      32767
    ), kt = (
      /*                   */
      32768
    ), Et = (
      /*                */
      65536
    ), Xn = (
      /* */
      131072
    ), en = (
      /*                       */
      1048576
    ), Vt = (
      /*                    */
      2097152
    ), yn = (
      /*                 */
      4194304
    ), Tr = (
      /*                */
      8388608
    ), Nr = (
      /*               */
      16777216
    ), vr = (
      /*              */
      33554432
    ), Ti = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Xe | Zr | 0
    ), Qo = Tn | Xe | Ue | _t | aa | Xr | de, ma = Xe | or | aa | de, ga = mr | Ue, Qr = yn | Tr | Vt, Jo = u.ReactCurrentOwner;
    function Co(n) {
      var a = n, c = n;
      if (n.alternate)
        for (; a.return; )
          a = a.return;
      else {
        var p = a;
        do
          a = p, (a.flags & (Tn | Xr)) !== gt && (c = a.return), p = a.return;
        while (p);
      }
      return a.tag === I ? c : null;
    }
    function yr(n) {
      return Co(n) === n;
    }
    function oo(n) {
      {
        var a = Jo.current;
        if (a !== null && a.tag === q) {
          var c = a, p = c.stateNode;
          p._warnedAboutRefsInRender || h("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", qe(c) || "A component"), p._warnedAboutRefsInRender = !0;
        }
      }
      var b = S(n);
      return b ? Co(b) === b : !1;
    }
    function li(n) {
      if (Co(n) !== n)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function $o(n) {
      var a = n.alternate;
      if (!a) {
        var c = Co(n);
        if (c === null)
          throw new Error("Unable to find node on an unmounted component.");
        return c !== n ? null : n;
      }
      for (var p = n, b = a; ; ) {
        var N = p.return;
        if (N === null)
          break;
        var G = N.alternate;
        if (G === null) {
          var Y = N.return;
          if (Y !== null) {
            p = b = Y;
            continue;
          }
          break;
        }
        if (N.child === G.child) {
          for (var $ = N.child; $; ) {
            if ($ === p)
              return li(N), n;
            if ($ === b)
              return li(N), a;
            $ = $.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (p.return !== b.return)
          p = N, b = G;
        else {
          for (var se = !1, he = N.child; he; ) {
            if (he === p) {
              se = !0, p = N, b = G;
              break;
            }
            if (he === b) {
              se = !0, b = N, p = G;
              break;
            }
            he = he.sibling;
          }
          if (!se) {
            for (he = G.child; he; ) {
              if (he === p) {
                se = !0, p = G, b = N;
                break;
              }
              if (he === b) {
                se = !0, b = G, p = N;
                break;
              }
              he = he.sibling;
            }
            if (!se)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (p.alternate !== b)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (p.tag !== I)
        throw new Error("Unable to find node on an unmounted component.");
      return p.stateNode.current === p ? n : a;
    }
    function qi(n) {
      var a = $o(n);
      return a !== null ? Rs(a) : null;
    }
    function Rs(n) {
      if (n.tag === F || n.tag === Z)
        return n;
      for (var a = n.child; a !== null; ) {
        var c = Rs(a);
        if (c !== null)
          return c;
        a = a.sibling;
      }
      return null;
    }
    function vl(n) {
      var a = $o(n);
      return a !== null ? Eo(a) : null;
    }
    function Eo(n) {
      if (n.tag === F || n.tag === Z)
        return n;
      for (var a = n.child; a !== null; ) {
        if (a.tag !== U) {
          var c = Eo(a);
          if (c !== null)
            return c;
        }
        a = a.sibling;
      }
      return null;
    }
    var Jl = Array.isArray;
    function wr(n) {
      return Jl(n);
    }
    var Ni = t.getPublicInstance, It = t.getRootHostContext, nr = t.getChildHostContext, so = t.prepareForCommit, Ar = t.resetAfterCommit, zr = t.createInstance, Wi = t.appendInitialChild, Ro = t.finalizeInitialChildren, ia = t.prepareUpdate, Wn = t.shouldSetTextContent, es = t.createTextInstance, ts = t.scheduleTimeout, lo = t.cancelTimeout, Ts = t.noTimeout, oa = t.isPrimaryRenderer, $l = t.warnsIfNotActing, Oa = t.supportsMutation, ns = t.supportsPersistence, sa = t.supportsHydration, eu = t.getInstanceFromNode;
    t.beforeActiveInstanceBlur, t.afterActiveInstanceBlur;
    var wn = t.preparePortalMount;
    t.prepareScopeUpdate, t.getInstanceFromScope;
    var yl = t.getCurrentEventPriority, qf = t.detachDeletedInstance, Wf = t.supportsMicrotasks, va = t.scheduleMicrotask, ui = t.supportsTestSelectors, Ns = t.findFiberRoot, ci = t.getBoundingRect, hd = t.getTextContent, To = t.isHiddenSubtree, Jt = t.matchAccessibilityRole, di = t.setFocusIfFocusable, rs = t.setupIntersectionObserver, bl = t.appendChild, lc = t.appendChildToContainer, No = t.commitTextUpdate, Br = t.commitMount, fi = t.commitUpdate, uc = t.insertBefore, tu = t.insertInContainerBefore, cc = t.removeChild, Ao = t.removeChildFromContainer, Ya = t.resetTextContent, pd = t.hideInstance, Kf = t.hideTextInstance, ya = t.unhideInstance, uo = t.unhideTextInstance, nu = t.clearContainer, As = t.cloneInstance, Ms = t.createContainerChildSet, ru = t.appendChildToContainerChildSet, Ki = t.finalizeContainerChildren, Mo = t.replaceContainerChildren, as = t.cloneHiddenInstance, is = t.cloneHiddenTextInstance, Ps = t.canHydrateInstance, Za = t.canHydrateTextInstance, ba = t.canHydrateSuspenseInstance, Ai = t.isSuspenseInstancePending, Fa = t.isSuspenseInstanceFallback, ji = t.getSuspenseInstanceFallbackErrorDetails, os = t.registerSuspenseInstanceRetry, Yi = t.getNextHydratableSibling, ss = t.getFirstHydratableChild, _l = t.getFirstHydratableChildWithinContainer, _a = t.getFirstHydratableChildWithinSuspenseInstance, za = t.hydrateInstance, sr = t.hydrateTextInstance, Cr = t.hydrateSuspenseInstance, Sa = t.getNextHydratableInstanceAfterSuspenseInstance, Ds = t.commitHydratedContainer, dc = t.commitHydratedSuspenseInstance, Ls = t.clearSuspenseBoundary, au = t.clearSuspenseBoundaryFromContainer, fc = t.shouldDeleteUnhydratedTailInstances, ls = t.didNotMatchHydratedContainerTextInstance, iu = t.didNotMatchHydratedTextInstance, hi = t.didNotHydrateInstanceWithinContainer, Sl = t.didNotHydrateInstanceWithinSuspenseInstance, hc = t.didNotHydrateInstance, us = t.didNotFindHydratableInstanceWithinContainer, pc = t.didNotFindHydratableTextInstanceWithinContainer, Os = t.didNotFindHydratableSuspenseInstanceWithinContainer, ou = t.didNotFindHydratableInstanceWithinSuspenseInstance, su = t.didNotFindHydratableTextInstanceWithinSuspenseInstance, wl = t.didNotFindHydratableSuspenseInstanceWithinSuspenseInstance, Fs = t.didNotFindHydratableInstance, lu = t.didNotFindHydratableTextInstance, zs = t.didNotFindHydratableSuspenseInstance, uu = t.errorHydratingContainer, Mi = 0, cu, xl, du, fu, kl, co, Ba;
    function fo() {
    }
    fo.__reactDisabledLog = !0;
    function mc() {
      {
        if (Mi === 0) {
          cu = console.log, xl = console.info, du = console.warn, fu = console.error, kl = console.group, co = console.groupCollapsed, Ba = console.groupEnd;
          var n = {
            configurable: !0,
            enumerable: !0,
            value: fo,
            writable: !0
          };
          Object.defineProperties(console, {
            info: n,
            log: n,
            warn: n,
            error: n,
            group: n,
            groupCollapsed: n,
            groupEnd: n
          });
        }
        Mi++;
      }
    }
    function md() {
      {
        if (Mi--, Mi === 0) {
          var n = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: E({}, n, {
              value: cu
            }),
            info: E({}, n, {
              value: xl
            }),
            warn: E({}, n, {
              value: du
            }),
            error: E({}, n, {
              value: fu
            }),
            group: E({}, n, {
              value: kl
            }),
            groupCollapsed: E({}, n, {
              value: co
            }),
            groupEnd: E({}, n, {
              value: Ba
            })
          });
        }
        Mi < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pi = u.ReactCurrentDispatcher, Xa;
    function Ur(n, a, c) {
      {
        if (Xa === void 0)
          try {
            throw Error();
          } catch (b) {
            var p = b.stack.trim().match(/\n( *(at )?)/);
            Xa = p && p[1] || "";
          }
        return `
` + Xa + n;
      }
    }
    var gr = !1, wa;
    {
      var Qa = typeof WeakMap == "function" ? WeakMap : Map;
      wa = new Qa();
    }
    function Bs(n, a) {
      if (!n || gr)
        return "";
      {
        var c = wa.get(n);
        if (c !== void 0)
          return c;
      }
      var p;
      gr = !0;
      var b = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = pi.current, pi.current = null, mc();
      try {
        if (a) {
          var G = function() {
            throw Error();
          };
          if (Object.defineProperty(G.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(G, []);
            } catch (at) {
              p = at;
            }
            Reflect.construct(n, [], G);
          } else {
            try {
              G.call();
            } catch (at) {
              p = at;
            }
            n.call(G.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (at) {
            p = at;
          }
          n();
        }
      } catch (at) {
        if (at && p && typeof at.stack == "string") {
          for (var Y = at.stack.split(`
`), $ = p.stack.split(`
`), se = Y.length - 1, he = $.length - 1; se >= 1 && he >= 0 && Y[se] !== $[he]; )
            he--;
          for (; se >= 1 && he >= 0; se--, he--)
            if (Y[se] !== $[he]) {
              if (se !== 1 || he !== 1)
                do
                  if (se--, he--, he < 0 || Y[se] !== $[he]) {
                    var Ae = `
` + Y[se].replace(" at new ", " at ");
                    return n.displayName && Ae.includes("<anonymous>") && (Ae = Ae.replace("<anonymous>", n.displayName)), typeof n == "function" && wa.set(n, Ae), Ae;
                  }
                while (se >= 1 && he >= 0);
              break;
            }
        }
      } finally {
        gr = !1, pi.current = N, md(), Error.prepareStackTrace = b;
      }
      var He = n ? n.displayName || n.name : "", Ze = He ? Ur(He) : "";
      return typeof n == "function" && wa.set(n, Ze), Ze;
    }
    function hu(n, a, c) {
      return Bs(n, !0);
    }
    function cs(n, a, c) {
      return Bs(n, !1);
    }
    function Po(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function ho(n, a, c) {
      if (n == null)
        return "";
      if (typeof n == "function")
        return Bs(n, Po(n));
      if (typeof n == "string")
        return Ur(n);
      switch (n) {
        case bn:
          return Ur("Suspense");
        case Yr:
          return Ur("SuspenseList");
      }
      if (typeof n == "object")
        switch (n.$$typeof) {
          case Wt:
            return cs(n.render);
          case Pn:
            return ho(n.type, a, c);
          case gn: {
            var p = n, b = p._payload, N = p._init;
            try {
              return ho(N(b), a, c);
            } catch {
            }
          }
        }
      return "";
    }
    var Ir = Object.prototype.hasOwnProperty, Ja = {}, Do = u.ReactDebugCurrentFrame;
    function m(n) {
      if (n) {
        var a = n._owner, c = ho(n.type, n._source, a ? a.type : null);
        Do.setExtraStackFrame(c);
      } else
        Do.setExtraStackFrame(null);
    }
    function _(n, a, c, p, b) {
      {
        var N = Function.call.bind(Ir);
        for (var G in n)
          if (N(n, G)) {
            var Y = void 0;
            try {
              if (typeof n[G] != "function") {
                var $ = Error((p || "React class") + ": " + c + " type `" + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[G] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw $.name = "Invariant Violation", $;
              }
              Y = n[G](a, G, p, c, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (se) {
              Y = se;
            }
            Y && !(Y instanceof Error) && (m(b), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", c, G, typeof Y), m(null)), Y instanceof Error && !(Y.message in Ja) && (Ja[Y.message] = !0, m(b), h("Failed %s type: %s", c, Y.message), m(null));
          }
      }
    }
    var M = [], O;
    O = [];
    var V = -1;
    function K(n) {
      return {
        current: n
      };
    }
    function J(n, a) {
      if (V < 0) {
        h("Unexpected pop.");
        return;
      }
      a !== O[V] && h("Unexpected Fiber popped."), n.current = M[V], M[V] = null, O[V] = null, V--;
    }
    function re(n, a, c) {
      V++, M[V] = n.current, O[V] = c, n.current = a;
    }
    var be;
    be = {};
    var ke = {};
    Object.freeze(ke);
    var _e = K(ke), me = K(!1), fe = ke;
    function ve(n, a, c) {
      return c && Te(a) ? fe : _e.current;
    }
    function ge(n, a, c) {
      {
        var p = n.stateNode;
        p.__reactInternalMemoizedUnmaskedChildContext = a, p.__reactInternalMemoizedMaskedChildContext = c;
      }
    }
    function Se(n, a) {
      {
        var c = n.type, p = c.contextTypes;
        if (!p)
          return ke;
        var b = n.stateNode;
        if (b && b.__reactInternalMemoizedUnmaskedChildContext === a)
          return b.__reactInternalMemoizedMaskedChildContext;
        var N = {};
        for (var G in p)
          N[G] = a[G];
        {
          var Y = qe(n) || "Unknown";
          _(p, N, "context", Y);
        }
        return b && ge(n, a, N), N;
      }
    }
    function we() {
      return me.current;
    }
    function Te(n) {
      {
        var a = n.childContextTypes;
        return a != null;
      }
    }
    function Ne(n) {
      J(me, n), J(_e, n);
    }
    function Be(n) {
      J(me, n), J(_e, n);
    }
    function Je(n, a, c) {
      {
        if (_e.current !== ke)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        re(_e, a, n), re(me, c, n);
      }
    }
    function nt(n, a, c) {
      {
        var p = n.stateNode, b = a.childContextTypes;
        if (typeof p.getChildContext != "function") {
          {
            var N = qe(n) || "Unknown";
            be[N] || (be[N] = !0, h("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", N, N));
          }
          return c;
        }
        var G = p.getChildContext();
        for (var Y in G)
          if (!(Y in b))
            throw new Error((qe(n) || "Unknown") + '.getChildContext(): key "' + Y + '" is not defined in childContextTypes.');
        {
          var $ = qe(n) || "Unknown";
          _(b, G, "child context", $);
        }
        return E({}, c, G);
      }
    }
    function lt(n) {
      {
        var a = n.stateNode, c = a && a.__reactInternalMemoizedMergedChildContext || ke;
        return fe = _e.current, re(_e, c, n), re(me, me.current, n), !0;
      }
    }
    function tt(n, a, c) {
      {
        var p = n.stateNode;
        if (!p)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (c) {
          var b = nt(n, a, fe);
          p.__reactInternalMemoizedMergedChildContext = b, J(me, n), J(_e, n), re(_e, b, n), re(me, c, n);
        } else
          J(me, n), re(me, c, n);
      }
    }
    function pt(n) {
      {
        if (!yr(n) || n.tag !== q)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var a = n;
        do {
          switch (a.tag) {
            case I:
              return a.stateNode.context;
            case q: {
              var c = a.type;
              if (Te(c))
                return a.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          a = a.return;
        } while (a !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var it = 0, Mt = 1, De = (
      /*                         */
      0
    ), ht = (
      /*                 */
      1
    ), mt = (
      /*                    */
      2
    ), Ot = (
      /*               */
      8
    ), tn = (
      /*              */
      16
    ), xa = Math.clz32 ? Math.clz32 : $r, un = Math.log, Jr = Math.LN2;
    function $r(n) {
      var a = n >>> 0;
      return a === 0 ? 32 : 31 - (un(a) / Jr | 0) | 0;
    }
    var Zi = 31, Ke = (
      /*                        */
      0
    ), rr = (
      /*                          */
      0
    ), jt = (
      /*                        */
      1
    ), Cl = (
      /*    */
      2
    ), po = (
      /*             */
      4
    ), Us = (
      /*            */
      8
    ), mo = (
      /*                     */
      16
    ), pu = (
      /*                */
      32
    ), El = (
      /*                       */
      4194240
    ), Rl = (
      /*                        */
      64
    ), gd = (
      /*                        */
      128
    ), vd = (
      /*                        */
      256
    ), yd = (
      /*                        */
      512
    ), jf = (
      /*                        */
      1024
    ), bd = (
      /*                        */
      2048
    ), Yf = (
      /*                        */
      4096
    ), Zf = (
      /*                        */
      8192
    ), _d = (
      /*                        */
      16384
    ), Sd = (
      /*                       */
      32768
    ), wd = (
      /*                       */
      65536
    ), mu = (
      /*                       */
      131072
    ), Xf = (
      /*                       */
      262144
    ), Qf = (
      /*                       */
      524288
    ), Jf = (
      /*                       */
      1048576
    ), Pi = (
      /*                       */
      2097152
    ), gu = (
      /*                            */
      130023424
    ), ds = (
      /*                             */
      4194304
    ), xd = (
      /*                             */
      8388608
    ), kd = (
      /*                             */
      16777216
    ), Cd = (
      /*                             */
      33554432
    ), gc = (
      /*                             */
      67108864
    ), Tl = ds, Nl = (
      /*          */
      134217728
    ), Ed = (
      /*                          */
      268435455
    ), vc = (
      /*               */
      268435456
    ), Is = (
      /*                        */
      536870912
    ), mi = (
      /*                   */
      1073741824
    );
    function ym(n) {
      {
        if (n & jt)
          return "Sync";
        if (n & Cl)
          return "InputContinuousHydration";
        if (n & po)
          return "InputContinuous";
        if (n & Us)
          return "DefaultHydration";
        if (n & mo)
          return "Default";
        if (n & pu)
          return "TransitionHydration";
        if (n & El)
          return "Transition";
        if (n & gu)
          return "Retry";
        if (n & Nl)
          return "SelectiveHydration";
        if (n & vc)
          return "IdleHydration";
        if (n & Is)
          return "Idle";
        if (n & mi)
          return "Offscreen";
      }
    }
    var fr = -1, yc = Rl, Rd = ds;
    function la(n) {
      switch (Al(n)) {
        case jt:
          return jt;
        case Cl:
          return Cl;
        case po:
          return po;
        case Us:
          return Us;
        case mo:
          return mo;
        case pu:
          return pu;
        case Rl:
        case gd:
        case vd:
        case yd:
        case jf:
        case bd:
        case Yf:
        case Zf:
        case _d:
        case Sd:
        case wd:
        case mu:
        case Xf:
        case Qf:
        case Jf:
        case Pi:
          return n & El;
        case ds:
        case xd:
        case kd:
        case Cd:
        case gc:
          return n & gu;
        case Nl:
          return Nl;
        case vc:
          return vc;
        case Is:
          return Is;
        case mi:
          return mi;
        default:
          return h("Should have found matching lanes. This is a bug in React."), n;
      }
    }
    function ua(n, a) {
      var c = n.pendingLanes;
      if (c === Ke)
        return Ke;
      var p = Ke, b = n.suspendedLanes, N = n.pingedLanes, G = c & Ed;
      if (G !== Ke) {
        var Y = G & ~b;
        if (Y !== Ke)
          p = la(Y);
        else {
          var $ = G & N;
          $ !== Ke && (p = la($));
        }
      } else {
        var se = c & ~b;
        se !== Ke ? p = la(se) : N !== Ke && (p = la(N));
      }
      if (p === Ke)
        return Ke;
      if (a !== Ke && a !== p && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (a & b) === Ke) {
        var he = Al(p), Ae = Al(a);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          he >= Ae || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          he === mo && (Ae & El) !== Ke
        )
          return a;
      }
      (p & po) !== Ke && (p |= c & mo);
      var He = n.entangledLanes;
      if (He !== Ke)
        for (var Ze = n.entanglements, at = p & He; at > 0; ) {
          var $e = fs(at), Bt = 1 << $e;
          p |= Ze[$e], at &= ~Bt;
        }
      return p;
    }
    function bm(n, a) {
      for (var c = n.eventTimes, p = fr; a > 0; ) {
        var b = fs(a), N = 1 << b, G = c[b];
        G > p && (p = G), a &= ~N;
      }
      return p;
    }
    function _m(n, a) {
      switch (n) {
        case jt:
        case Cl:
        case po:
          return a + 250;
        case Us:
        case mo:
        case pu:
        case Rl:
        case gd:
        case vd:
        case yd:
        case jf:
        case bd:
        case Yf:
        case Zf:
        case _d:
        case Sd:
        case wd:
        case mu:
        case Xf:
        case Qf:
        case Jf:
        case Pi:
          return a + 5e3;
        case ds:
        case xd:
        case kd:
        case Cd:
        case gc:
          return fr;
        case Nl:
        case vc:
        case Is:
        case mi:
          return fr;
        default:
          return h("Should have found matching lanes. This is a bug in React."), fr;
      }
    }
    function Sm(n, a) {
      for (var c = n.pendingLanes, p = n.suspendedLanes, b = n.pingedLanes, N = n.expirationTimes, G = c; G > 0; ) {
        var Y = fs(G), $ = 1 << Y, se = N[Y];
        se === fr ? (($ & p) === Ke || ($ & b) !== Ke) && (N[Y] = _m($, a)) : se <= a && (n.expiredLanes |= $), G &= ~$;
      }
    }
    function wm(n) {
      return la(n.pendingLanes);
    }
    function Td(n) {
      var a = n.pendingLanes & ~mi;
      return a !== Ke ? a : a & mi ? mi : Ke;
    }
    function $f(n) {
      return (n & jt) !== Ke;
    }
    function Nd(n) {
      return (n & Ed) !== Ke;
    }
    function Ad(n) {
      return (n & gu) === n;
    }
    function xm(n) {
      var a = jt | po | mo;
      return (n & a) === Ke;
    }
    function km(n) {
      return (n & El) === n;
    }
    function vu(n, a) {
      var c = Cl | po | Us | mo;
      return (a & c) !== Ke;
    }
    function eh(n, a) {
      return (a & n.expiredLanes) !== Ke;
    }
    function th(n) {
      return (n & El) !== Ke;
    }
    function Md() {
      var n = yc;
      return yc <<= 1, (yc & El) === Ke && (yc = Rl), n;
    }
    function Pd() {
      var n = Rd;
      return Rd <<= 1, (Rd & gu) === Ke && (Rd = ds), n;
    }
    function Al(n) {
      return n & -n;
    }
    function yu(n) {
      return Al(n);
    }
    function fs(n) {
      return 31 - xa(n);
    }
    function Dd(n) {
      return fs(n);
    }
    function Ua(n, a) {
      return (n & a) !== Ke;
    }
    function gi(n, a) {
      return (n & a) === a;
    }
    function fn(n, a) {
      return n | a;
    }
    function Di(n, a) {
      return n & ~a;
    }
    function nh(n, a) {
      return n & a;
    }
    function Ld(n) {
      return n;
    }
    function bc(n, a) {
      return n !== rr && n < a ? n : a;
    }
    function bu(n) {
      for (var a = [], c = 0; c < Zi; c++)
        a.push(n);
      return a;
    }
    function Hs(n, a, c) {
      n.pendingLanes |= a, a !== Is && (n.suspendedLanes = Ke, n.pingedLanes = Ke);
      var p = n.eventTimes, b = Dd(a);
      p[b] = c;
    }
    function Cm(n, a) {
      n.suspendedLanes |= a, n.pingedLanes &= ~a;
      for (var c = n.expirationTimes, p = a; p > 0; ) {
        var b = fs(p), N = 1 << b;
        c[b] = fr, p &= ~N;
      }
    }
    function _u(n, a, c) {
      n.pingedLanes |= n.suspendedLanes & a;
    }
    function Ia(n, a) {
      var c = n.pendingLanes & ~a;
      n.pendingLanes = a, n.suspendedLanes = Ke, n.pingedLanes = Ke, n.expiredLanes &= a, n.mutableReadLanes &= a, n.entangledLanes &= a;
      for (var p = n.entanglements, b = n.eventTimes, N = n.expirationTimes, G = c; G > 0; ) {
        var Y = fs(G), $ = 1 << Y;
        p[Y] = Ke, b[Y] = fr, N[Y] = fr, G &= ~$;
      }
    }
    function rh(n, a) {
      for (var c = n.entangledLanes |= a, p = n.entanglements, b = c; b; ) {
        var N = fs(b), G = 1 << N;
        // Is this one of the newly entangled lanes?
        G & a | // Is this lane transitively entangled with the newly entangled lanes?
        p[N] & a && (p[N] |= a), b &= ~G;
      }
    }
    function tv(n, a) {
      var c = Al(a), p;
      switch (c) {
        case po:
          p = Cl;
          break;
        case mo:
          p = Us;
          break;
        case Rl:
        case gd:
        case vd:
        case yd:
        case jf:
        case bd:
        case Yf:
        case Zf:
        case _d:
        case Sd:
        case wd:
        case mu:
        case Xf:
        case Qf:
        case Jf:
        case Pi:
        case ds:
        case xd:
        case kd:
        case Cd:
        case gc:
          p = pu;
          break;
        case Is:
          p = vc;
          break;
        default:
          p = rr;
          break;
      }
      return (p & (n.suspendedLanes | a)) !== rr ? rr : p;
    }
    function _c(n, a, c) {
      if (vi)
        for (var p = n.pendingUpdatersLaneMap; c > 0; ) {
          var b = Dd(c), N = 1 << b, G = p[b];
          G.add(a), c &= ~N;
        }
    }
    function ka(n, a) {
      if (vi)
        for (var c = n.pendingUpdatersLaneMap, p = n.memoizedUpdaters; a > 0; ) {
          var b = Dd(a), N = 1 << b, G = c[b];
          G.size > 0 && (G.forEach(function(Y) {
            var $ = Y.alternate;
            ($ === null || !p.has($)) && p.add(Y);
          }), G.clear()), a &= ~N;
        }
    }
    function Em(n, a) {
      return null;
    }
    var Ct = jt, Lo = po, Ml = mo, Od = Is, Sc = rr;
    function $a() {
      return Sc;
    }
    function Mr(n) {
      Sc = n;
    }
    function ah(n, a) {
      var c = Sc;
      try {
        return Sc = n, a();
      } finally {
        Sc = c;
      }
    }
    function Rm(n, a) {
      return n !== 0 && n < a ? n : a;
    }
    function Tm(n, a) {
      return n > a ? n : a;
    }
    function ih(n, a) {
      return n !== 0 && n < a;
    }
    function Fd(n) {
      var a = Al(n);
      return ih(Ct, a) ? ih(Lo, a) ? Nd(a) ? Ml : Od : Lo : Ct;
    }
    var zd = l.unstable_scheduleCallback, Ca = l.unstable_cancelCallback, go = l.unstable_shouldYield, Oo = l.unstable_requestPaint, Hr = l.unstable_now, wc = l.unstable_ImmediatePriority, Xi = l.unstable_UserBlockingPriority, Pl = l.unstable_NormalPriority, vo = l.unstable_IdlePriority, nv = l.unstable_yieldValue, Nm = l.unstable_setDisableYieldValue, Dl = null, Ea = null, Rt = null, Li = !1, vi = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Bd(n) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var a = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (a.isDisabled)
        return !0;
      if (!a.supportsFiber)
        return h("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        x && (n = E({}, n, {
          getLaneLabelMap: Am,
          injectProfilingHooks: sh
        })), Dl = a.inject(n), Ea = a;
      } catch (c) {
        h("React instrumentation encountered an error: %s.", c);
      }
      return !!a.checkDCE;
    }
    function Ud(n, a) {
      if (Ea && typeof Ea.onScheduleFiberRoot == "function")
        try {
          Ea.onScheduleFiberRoot(Dl, n, a);
        } catch (c) {
          Li || (Li = !0, h("React instrumentation encountered an error: %s", c));
        }
    }
    function Id(n, a) {
      if (Ea && typeof Ea.onCommitFiberRoot == "function")
        try {
          var c = (n.current.flags & xt) === xt;
          if (k) {
            var p;
            switch (a) {
              case Ct:
                p = wc;
                break;
              case Lo:
                p = Xi;
                break;
              case Ml:
                p = Pl;
                break;
              case Od:
                p = vo;
                break;
              default:
                p = Pl;
                break;
            }
            Ea.onCommitFiberRoot(Dl, n, p, c);
          }
        } catch (b) {
          Li || (Li = !0, h("React instrumentation encountered an error: %s", b));
        }
    }
    function xc(n) {
      if (Ea && typeof Ea.onPostCommitFiberRoot == "function")
        try {
          Ea.onPostCommitFiberRoot(Dl, n);
        } catch (a) {
          Li || (Li = !0, h("React instrumentation encountered an error: %s", a));
        }
    }
    function oh(n) {
      if (Ea && typeof Ea.onCommitFiberUnmount == "function")
        try {
          Ea.onCommitFiberUnmount(Dl, n);
        } catch (a) {
          Li || (Li = !0, h("React instrumentation encountered an error: %s", a));
        }
    }
    function Gr(n) {
      if (typeof nv == "function" && (Nm(n), f(n)), Ea && typeof Ea.setStrictMode == "function")
        try {
          Ea.setStrictMode(Dl, n);
        } catch (a) {
          Li || (Li = !0, h("React instrumentation encountered an error: %s", a));
        }
    }
    function sh(n) {
      Rt = n;
    }
    function Am() {
      {
        for (var n = /* @__PURE__ */ new Map(), a = 1, c = 0; c < Zi; c++) {
          var p = ym(a);
          n.set(a, p), a *= 2;
        }
        return n;
      }
    }
    function lh(n) {
      Rt !== null && typeof Rt.markCommitStarted == "function" && Rt.markCommitStarted(n);
    }
    function Mm() {
      Rt !== null && typeof Rt.markCommitStopped == "function" && Rt.markCommitStopped();
    }
    function Gs(n) {
      Rt !== null && typeof Rt.markComponentRenderStarted == "function" && Rt.markComponentRenderStarted(n);
    }
    function Vs() {
      Rt !== null && typeof Rt.markComponentRenderStopped == "function" && Rt.markComponentRenderStopped();
    }
    function Pr(n) {
      Rt !== null && typeof Rt.markComponentPassiveEffectMountStarted == "function" && Rt.markComponentPassiveEffectMountStarted(n);
    }
    function xn() {
      Rt !== null && typeof Rt.markComponentPassiveEffectMountStopped == "function" && Rt.markComponentPassiveEffectMountStopped();
    }
    function ca(n) {
      Rt !== null && typeof Rt.markComponentPassiveEffectUnmountStarted == "function" && Rt.markComponentPassiveEffectUnmountStarted(n);
    }
    function Vr() {
      Rt !== null && typeof Rt.markComponentPassiveEffectUnmountStopped == "function" && Rt.markComponentPassiveEffectUnmountStopped();
    }
    function Ra(n) {
      Rt !== null && typeof Rt.markComponentLayoutEffectMountStarted == "function" && Rt.markComponentLayoutEffectMountStarted(n);
    }
    function Oi() {
      Rt !== null && typeof Rt.markComponentLayoutEffectMountStopped == "function" && Rt.markComponentLayoutEffectMountStopped();
    }
    function Ll(n) {
      Rt !== null && typeof Rt.markComponentLayoutEffectUnmountStarted == "function" && Rt.markComponentLayoutEffectUnmountStarted(n);
    }
    function qr() {
      Rt !== null && typeof Rt.markComponentLayoutEffectUnmountStopped == "function" && Rt.markComponentLayoutEffectUnmountStopped();
    }
    function kc(n, a, c) {
      Rt !== null && typeof Rt.markComponentErrored == "function" && Rt.markComponentErrored(n, a, c);
    }
    function Ol(n, a, c) {
      Rt !== null && typeof Rt.markComponentSuspended == "function" && Rt.markComponentSuspended(n, a, c);
    }
    function Hd(n) {
      Rt !== null && typeof Rt.markLayoutEffectsStarted == "function" && Rt.markLayoutEffectsStarted(n);
    }
    function uh() {
      Rt !== null && typeof Rt.markLayoutEffectsStopped == "function" && Rt.markLayoutEffectsStopped();
    }
    function Cc(n) {
      Rt !== null && typeof Rt.markPassiveEffectsStarted == "function" && Rt.markPassiveEffectsStarted(n);
    }
    function yi() {
      Rt !== null && typeof Rt.markPassiveEffectsStopped == "function" && Rt.markPassiveEffectsStopped();
    }
    function Gd(n) {
      Rt !== null && typeof Rt.markRenderStarted == "function" && Rt.markRenderStarted(n);
    }
    function ch() {
      Rt !== null && typeof Rt.markRenderYielded == "function" && Rt.markRenderYielded();
    }
    function Fo() {
      Rt !== null && typeof Rt.markRenderStopped == "function" && Rt.markRenderStopped();
    }
    function Su(n) {
      Rt !== null && typeof Rt.markRenderScheduled == "function" && Rt.markRenderScheduled(n);
    }
    function Vd(n, a) {
      Rt !== null && typeof Rt.markForceUpdateScheduled == "function" && Rt.markForceUpdateScheduled(n, a);
    }
    function Ec(n, a) {
      Rt !== null && typeof Rt.markStateUpdateScheduled == "function" && Rt.markStateUpdateScheduled(n, a);
    }
    function qs(n, a) {
      return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
    }
    var Ha = typeof Object.is == "function" ? Object.is : qs, Ga = null, wu = !1, Fl = !1;
    function qd(n) {
      Ga === null ? Ga = [n] : Ga.push(n);
    }
    function Wd(n) {
      wu = !0, qd(n);
    }
    function Rc() {
      wu && br();
    }
    function br() {
      if (!Fl && Ga !== null) {
        Fl = !0;
        var n = 0, a = $a();
        try {
          var c = !0, p = Ga;
          for (Mr(Ct); n < p.length; n++) {
            var b = p[n];
            do
              b = b(c);
            while (b !== null);
          }
          Ga = null, wu = !1;
        } catch (N) {
          throw Ga !== null && (Ga = Ga.slice(n + 1)), zd(wc, br), N;
        } finally {
          Mr(a), Fl = !1;
        }
      }
      return null;
    }
    function hs(n) {
      var a = n.current.memoizedState;
      return a.isDehydrated;
    }
    var Ta = [], ea = 0, Tc = null, xu = 0, bi = [], Qi = 0, _i = null, zo = 1, Bo = "";
    function dh(n) {
      return Ul(), (n.flags & en) !== gt;
    }
    function zl(n) {
      return Ul(), xu;
    }
    function Pm() {
      var n = Bo, a = zo, c = a & ~rv(a);
      return c.toString(32) + n;
    }
    function Ws(n, a) {
      Ul(), Ta[ea++] = xu, Ta[ea++] = Tc, Tc = n, xu = a;
    }
    function Kd(n, a, c) {
      Ul(), bi[Qi++] = zo, bi[Qi++] = Bo, bi[Qi++] = _i, _i = n;
      var p = zo, b = Bo, N = jd(p) - 1, G = p & ~(1 << N), Y = c + 1, $ = jd(a) + N;
      if ($ > 30) {
        var se = N - N % 5, he = (1 << se) - 1, Ae = (G & he).toString(32), He = G >> se, Ze = N - se, at = jd(a) + Ze, $e = Y << Ze, Bt = $e | He, nn = Ae + b;
        zo = 1 << at | Bt, Bo = nn;
      } else {
        var Zt = Y << N, ur = Zt | G, In = b;
        zo = 1 << $ | ur, Bo = In;
      }
    }
    function ku(n) {
      Ul();
      var a = n.return;
      if (a !== null) {
        var c = 1, p = 0;
        Ws(n, c), Kd(n, c, p);
      }
    }
    function jd(n) {
      return 32 - xa(n);
    }
    function rv(n) {
      return 1 << jd(n) - 1;
    }
    function Yd(n) {
      for (; n === Tc; )
        Tc = Ta[--ea], Ta[ea] = null, xu = Ta[--ea], Ta[ea] = null;
      for (; n === _i; )
        _i = bi[--Qi], bi[Qi] = null, Bo = bi[--Qi], bi[Qi] = null, zo = bi[--Qi], bi[Qi] = null;
    }
    function Dm() {
      return Ul(), _i !== null ? {
        id: zo,
        overflow: Bo
      } : null;
    }
    function Bl(n, a) {
      Ul(), bi[Qi++] = zo, bi[Qi++] = Bo, bi[Qi++] = _i, zo = a.id, Bo = a.overflow, _i = n;
    }
    function Ul() {
      s() || h("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var xr = null, Fi = null, Bn = !1, Ks = !1, ps = null;
    function av() {
      Bn && h("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function Lm() {
      Ks = !0;
    }
    function Om() {
      return Ks;
    }
    function Fm(n) {
      if (!sa)
        return !1;
      var a = n.stateNode.containerInfo;
      return Fi = _l(a), xr = n, Bn = !0, ps = null, Ks = !1, !0;
    }
    function iv(n, a, c) {
      return sa ? (Fi = _a(a), xr = n, Bn = !0, ps = null, Ks = !1, c !== null && Bl(n, c), !0) : !1;
    }
    function zi(n, a) {
      switch (n.tag) {
        case I: {
          hi(n.stateNode.containerInfo, a);
          break;
        }
        case F: {
          var c = (n.mode & ht) !== De;
          hc(
            n.type,
            n.memoizedProps,
            n.stateNode,
            a,
            // TODO: Delete this argument when we remove the legacy root API.
            c
          );
          break;
        }
        case j: {
          var p = n.memoizedState;
          p.dehydrated !== null && Sl(p.dehydrated, a);
          break;
        }
      }
    }
    function Zd(n, a) {
      zi(n, a);
      var c = T9();
      c.stateNode = a, c.return = n;
      var p = n.deletions;
      p === null ? (n.deletions = [c], n.flags |= Ue) : p.push(c);
    }
    function fh(n, a) {
      {
        if (Ks)
          return;
        switch (n.tag) {
          case I: {
            var c = n.stateNode.containerInfo;
            switch (a.tag) {
              case F:
                var p = a.type, b = a.pendingProps;
                us(c, p, b);
                break;
              case Z:
                var N = a.pendingProps;
                pc(c, N);
                break;
              case j:
                Os(c);
                break;
            }
            break;
          }
          case F: {
            var G = n.type, Y = n.memoizedProps, $ = n.stateNode;
            switch (a.tag) {
              case F: {
                var se = a.type, he = a.pendingProps, Ae = (n.mode & ht) !== De;
                Fs(
                  G,
                  Y,
                  $,
                  se,
                  he,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ae
                );
                break;
              }
              case Z: {
                var He = a.pendingProps, Ze = (n.mode & ht) !== De;
                lu(
                  G,
                  Y,
                  $,
                  He,
                  // TODO: Delete this argument when we remove the legacy root API.
                  Ze
                );
                break;
              }
              case j: {
                zs(G, Y, $);
                break;
              }
            }
            break;
          }
          case j: {
            var at = n.memoizedState, $e = at.dehydrated;
            if ($e !== null) switch (a.tag) {
              case F:
                var Bt = a.type, nn = a.pendingProps;
                ou($e, Bt, nn);
                break;
              case Z:
                var Zt = a.pendingProps;
                su($e, Zt);
                break;
              case j:
                wl($e);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function ms(n, a) {
      a.flags = a.flags & ~Xr | Tn, fh(n, a);
    }
    function Nc(n, a) {
      switch (n.tag) {
        case F: {
          var c = n.type, p = n.pendingProps, b = Ps(a, c, p);
          return b !== null ? (n.stateNode = b, xr = n, Fi = ss(b), !0) : !1;
        }
        case Z: {
          var N = n.pendingProps, G = Za(a, N);
          return G !== null ? (n.stateNode = G, xr = n, Fi = null, !0) : !1;
        }
        case j: {
          var Y = ba(a);
          if (Y !== null) {
            var $ = {
              dehydrated: Y,
              treeContext: Dm(),
              retryLane: mi
            };
            n.memoizedState = $;
            var se = N9(Y);
            return se.return = n, n.child = se, xr = n, Fi = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function gs(n) {
      return (n.mode & ht) !== De && (n.flags & xt) === gt;
    }
    function Cu(n) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function Ac(n) {
      if (Bn) {
        var a = Fi;
        if (!a) {
          gs(n) && (fh(xr, n), Cu()), ms(xr, n), Bn = !1, xr = n;
          return;
        }
        var c = a;
        if (!Nc(n, a)) {
          gs(n) && (fh(xr, n), Cu()), a = Yi(c);
          var p = xr;
          if (!a || !Nc(n, a)) {
            ms(xr, n), Bn = !1, xr = n;
            return;
          }
          Zd(p, c);
        }
      }
    }
    function hh(n, a, c) {
      if (!sa)
        throw new Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var p = n.stateNode, b = !Ks, N = za(p, n.type, n.memoizedProps, a, c, n, b);
      return n.updateQueue = N, N !== null;
    }
    function ov(n) {
      if (!sa)
        throw new Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var a = n.stateNode, c = n.memoizedProps, p = !Ks, b = sr(a, c, n, p);
      if (b) {
        var N = xr;
        if (N !== null)
          switch (N.tag) {
            case I: {
              var G = N.stateNode.containerInfo, Y = (N.mode & ht) !== De;
              ls(
                G,
                a,
                c,
                // TODO: Delete this argument when we remove the legacy root API.
                Y
              );
              break;
            }
            case F: {
              var $ = N.type, se = N.memoizedProps, he = N.stateNode, Ae = (N.mode & ht) !== De;
              iu(
                $,
                se,
                he,
                a,
                c,
                // TODO: Delete this argument when we remove the legacy root API.
                Ae
              );
              break;
            }
          }
      }
      return b;
    }
    function zm(n) {
      if (!sa)
        throw new Error("Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var a = n.memoizedState, c = a !== null ? a.dehydrated : null;
      if (!c)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      Cr(c, n);
    }
    function Bm(n) {
      if (!sa)
        throw new Error("Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
      var a = n.memoizedState, c = a !== null ? a.dehydrated : null;
      if (!c)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return Sa(c);
    }
    function ph(n) {
      for (var a = n.return; a !== null && a.tag !== F && a.tag !== I && a.tag !== j; )
        a = a.return;
      xr = a;
    }
    function Mc(n) {
      if (!sa || n !== xr)
        return !1;
      if (!Bn)
        return ph(n), Bn = !0, !1;
      if (n.tag !== I && (n.tag !== F || fc(n.type) && !Wn(n.type, n.memoizedProps))) {
        var a = Fi;
        if (a)
          if (gs(n))
            Um(n), Cu();
          else
            for (; a; )
              Zd(n, a), a = Yi(a);
      }
      return ph(n), n.tag === j ? Fi = Bm(n) : Fi = xr ? Yi(n.stateNode) : null, !0;
    }
    function Xd() {
      return Bn && Fi !== null;
    }
    function Um(n) {
      for (var a = Fi; a; )
        zi(n, a), a = Yi(a);
    }
    function Eu() {
      sa && (xr = null, Fi = null, Bn = !1, Ks = !1);
    }
    function i() {
      ps !== null && (k5(ps), ps = null);
    }
    function s() {
      return Bn;
    }
    function y(n) {
      ps === null ? ps = [n] : ps.push(n);
    }
    var C = u.ReactCurrentBatchConfig, A = null;
    function H() {
      return C.transition;
    }
    function ne(n, a) {
      if (Ha(n, a))
        return !0;
      if (typeof n != "object" || n === null || typeof a != "object" || a === null)
        return !1;
      var c = Object.keys(n), p = Object.keys(a);
      if (c.length !== p.length)
        return !1;
      for (var b = 0; b < c.length; b++) {
        var N = c[b];
        if (!Ir.call(a, N) || !Ha(n[N], a[N]))
          return !1;
      }
      return !0;
    }
    function Ce(n) {
      switch (n._debugOwner && n._debugOwner.type, n._debugSource, n.tag) {
        case F:
          return Ur(n.type);
        case oe:
          return Ur("Lazy");
        case j:
          return Ur("Suspense");
        case Me:
          return Ur("SuspenseList");
        case B:
        case X:
        case Q:
          return cs(n.type);
        case ze:
          return cs(n.type.render);
        case q:
          return hu(n.type);
        default:
          return "";
      }
    }
    function Ie(n) {
      try {
        var a = "", c = n;
        do
          a += Ce(c), c = c.return;
        while (c);
        return a;
      } catch (p) {
        return `
Error generating stack: ` + p.message + `
` + p.stack;
      }
    }
    var ut = u.ReactDebugCurrentFrame, St = null, rn = !1;
    function Nt() {
      {
        if (St === null)
          return null;
        var n = St._debugOwner;
        if (n !== null && typeof n < "u")
          return qe(n);
      }
      return null;
    }
    function _r() {
      return St === null ? "" : Ie(St);
    }
    function mn() {
      ut.getCurrentStack = null, St = null, rn = !1;
    }
    function Un(n) {
      ut.getCurrentStack = n === null ? null : _r, St = n, rn = !1;
    }
    function vs() {
      return St;
    }
    function Le(n) {
      rn = n;
    }
    var xe = {
      recordUnsafeLifecycleWarnings: function(n, a) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(n, a) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var Ve = function(n) {
        for (var a = null, c = n; c !== null; )
          c.mode & Ot && (a = c), c = c.return;
        return a;
      }, wt = function(n) {
        var a = [];
        return n.forEach(function(c) {
          a.push(c);
        }), a.sort().join(", ");
      }, Yt = [], dn = [], an = [], Nn = [], Er = [], An = [], Si = /* @__PURE__ */ new Set();
      xe.recordUnsafeLifecycleWarnings = function(n, a) {
        Si.has(n.type) || (typeof a.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        a.componentWillMount.__suppressDeprecationWarning !== !0 && Yt.push(n), n.mode & Ot && typeof a.UNSAFE_componentWillMount == "function" && dn.push(n), typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && an.push(n), n.mode & Ot && typeof a.UNSAFE_componentWillReceiveProps == "function" && Nn.push(n), typeof a.componentWillUpdate == "function" && a.componentWillUpdate.__suppressDeprecationWarning !== !0 && Er.push(n), n.mode & Ot && typeof a.UNSAFE_componentWillUpdate == "function" && An.push(n));
      }, xe.flushPendingUnsafeLifecycleWarnings = function() {
        var n = /* @__PURE__ */ new Set();
        Yt.length > 0 && (Yt.forEach(function(He) {
          n.add(qe(He) || "Component"), Si.add(He.type);
        }), Yt = []);
        var a = /* @__PURE__ */ new Set();
        dn.length > 0 && (dn.forEach(function(He) {
          a.add(qe(He) || "Component"), Si.add(He.type);
        }), dn = []);
        var c = /* @__PURE__ */ new Set();
        an.length > 0 && (an.forEach(function(He) {
          c.add(qe(He) || "Component"), Si.add(He.type);
        }), an = []);
        var p = /* @__PURE__ */ new Set();
        Nn.length > 0 && (Nn.forEach(function(He) {
          p.add(qe(He) || "Component"), Si.add(He.type);
        }), Nn = []);
        var b = /* @__PURE__ */ new Set();
        Er.length > 0 && (Er.forEach(function(He) {
          b.add(qe(He) || "Component"), Si.add(He.type);
        }), Er = []);
        var N = /* @__PURE__ */ new Set();
        if (An.length > 0 && (An.forEach(function(He) {
          N.add(qe(He) || "Component"), Si.add(He.type);
        }), An = []), a.size > 0) {
          var G = wt(a);
          h(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, G);
        }
        if (p.size > 0) {
          var Y = wt(p);
          h(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, Y);
        }
        if (N.size > 0) {
          var $ = wt(N);
          h(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, $);
        }
        if (n.size > 0) {
          var se = wt(n);
          g(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, se);
        }
        if (c.size > 0) {
          var he = wt(c);
          g(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, he);
        }
        if (b.size > 0) {
          var Ae = wt(b);
          g(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Ae);
        }
      };
      var Qd = /* @__PURE__ */ new Map(), Nb = /* @__PURE__ */ new Set();
      xe.recordLegacyContextWarning = function(n, a) {
        var c = Ve(n);
        if (c === null) {
          h("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!Nb.has(n.type)) {
          var p = Qd.get(c);
          (n.type.contextTypes != null || n.type.childContextTypes != null || a !== null && typeof a.getChildContext == "function") && (p === void 0 && (p = [], Qd.set(c, p)), p.push(n));
        }
      }, xe.flushLegacyContextWarning = function() {
        Qd.forEach(function(n, a) {
          if (n.length !== 0) {
            var c = n[0], p = /* @__PURE__ */ new Set();
            n.forEach(function(N) {
              p.add(qe(N) || "Component"), Nb.add(N.type);
            });
            var b = wt(p);
            try {
              Un(c), h(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b);
            } finally {
              mn();
            }
          }
        });
      }, xe.discardPendingWarnings = function() {
        Yt = [], dn = [], an = [], Nn = [], Er = [], An = [], Qd = /* @__PURE__ */ new Map();
      };
    }
    function Ab(n) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, c = a && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return c;
      }
    }
    function Mb(n) {
      try {
        return sv(n), !1;
      } catch {
        return !0;
      }
    }
    function sv(n) {
      return "" + n;
    }
    function m8(n) {
      if (Mb(n))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ab(n)), sv(n);
    }
    function g8(n, a) {
      if (Mb(n))
        return h("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", a, Ab(n)), sv(n);
    }
    var lv, uv, cv, dv, fv, Pb = function(n, a) {
    };
    lv = !1, uv = !1, cv = {}, dv = {}, fv = {}, Pb = function(n, a) {
      if (!(n === null || typeof n != "object") && !(!n._store || n._store.validated || n.key != null)) {
        if (typeof n._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        n._store.validated = !0;
        var c = qe(a) || "Component";
        dv[c] || (dv[c] = !0, h('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function v8(n) {
      return n.prototype && n.prototype.isReactComponent;
    }
    function mh(n, a, c) {
      var p = c.ref;
      if (p !== null && typeof p != "function" && typeof p != "object") {
        if ((n.mode & Ot || L) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(c._owner && c._self && c._owner.stateNode !== c._self) && // Will already throw with "Function components cannot have string refs"
        !(c._owner && c._owner.tag !== q) && // Will already warn with "Function components cannot be given refs"
        !(typeof c.type == "function" && !v8(c.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        c._owner) {
          var b = qe(n) || "Component";
          cv[b] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', b, p), cv[b] = !0);
        }
        if (c._owner) {
          var N = c._owner, G;
          if (N) {
            var Y = N;
            if (Y.tag !== q)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            G = Y.stateNode;
          }
          if (!G)
            throw new Error("Missing owner for string ref " + p + ". This error is likely caused by a bug in React. Please file an issue.");
          var $ = G;
          g8(p, "ref");
          var se = "" + p;
          if (a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === se)
            return a.ref;
          var he = function(Ae) {
            var He = $.refs;
            Ae === null ? delete He[se] : He[se] = Ae;
          };
          return he._stringRef = se, he;
        } else {
          if (typeof p != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!c._owner)
            throw new Error("Element ref was specified as a string (" + p + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return p;
    }
    function Im(n, a) {
      var c = Object.prototype.toString.call(a);
      throw new Error("Objects are not valid as a React child (found: " + (c === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : c) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Hm(n) {
      {
        var a = qe(n) || "Component";
        if (fv[a])
          return;
        fv[a] = !0, h("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function Db(n) {
      var a = n._payload, c = n._init;
      return c(a);
    }
    function Lb(n) {
      function a(Fe, je) {
        if (n) {
          var Oe = Fe.deletions;
          Oe === null ? (Fe.deletions = [je], Fe.flags |= Ue) : Oe.push(je);
        }
      }
      function c(Fe, je) {
        if (!n)
          return null;
        for (var Oe = je; Oe !== null; )
          a(Fe, Oe), Oe = Oe.sibling;
        return null;
      }
      function p(Fe, je) {
        for (var Oe = /* @__PURE__ */ new Map(), dt = je; dt !== null; )
          dt.key !== null ? Oe.set(dt.key, dt) : Oe.set(dt.index, dt), dt = dt.sibling;
        return Oe;
      }
      function b(Fe, je) {
        var Oe = Ic(Fe, je);
        return Oe.index = 0, Oe.sibling = null, Oe;
      }
      function N(Fe, je, Oe) {
        if (Fe.index = Oe, !n)
          return Fe.flags |= en, je;
        var dt = Fe.alternate;
        if (dt !== null) {
          var Ht = dt.index;
          return Ht < je ? (Fe.flags |= Tn, je) : Ht;
        } else
          return Fe.flags |= Tn, je;
      }
      function G(Fe) {
        return n && Fe.alternate === null && (Fe.flags |= Tn), Fe;
      }
      function Y(Fe, je, Oe, dt) {
        if (je === null || je.tag !== Z) {
          var Ht = ly(Oe, Fe.mode, dt);
          return Ht.return = Fe, Ht;
        } else {
          var Pt = b(je, Oe);
          return Pt.return = Fe, Pt;
        }
      }
      function $(Fe, je, Oe, dt) {
        var Ht = Oe.type;
        if (Ht === st)
          return he(Fe, je, Oe.props.children, dt, Oe.key);
        if (je !== null && (je.elementType === Ht || // Keep this check inline so it only runs on the false path:
        U5(je, Oe) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ht == "object" && Ht !== null && Ht.$$typeof === gn && Db(Ht) === je.type)) {
          var Pt = b(je, Oe.props);
          return Pt.ref = mh(Fe, je, Oe), Pt.return = Fe, Pt._debugSource = Oe._source, Pt._debugOwner = Oe._owner, Pt;
        }
        var Ln = sy(Oe, Fe.mode, dt);
        return Ln.ref = mh(Fe, je, Oe), Ln.return = Fe, Ln;
      }
      function se(Fe, je, Oe, dt) {
        if (je === null || je.tag !== U || je.stateNode.containerInfo !== Oe.containerInfo || je.stateNode.implementation !== Oe.implementation) {
          var Ht = uy(Oe, Fe.mode, dt);
          return Ht.return = Fe, Ht;
        } else {
          var Pt = b(je, Oe.children || []);
          return Pt.return = Fe, Pt;
        }
      }
      function he(Fe, je, Oe, dt, Ht) {
        if (je === null || je.tag !== te) {
          var Pt = Fu(Oe, Fe.mode, dt, Ht);
          return Pt.return = Fe, Pt;
        } else {
          var Ln = b(je, Oe);
          return Ln.return = Fe, Ln;
        }
      }
      function Ae(Fe, je, Oe) {
        if (typeof je == "string" && je !== "" || typeof je == "number") {
          var dt = ly("" + je, Fe.mode, Oe);
          return dt.return = Fe, dt;
        }
        if (typeof je == "object" && je !== null) {
          switch (je.$$typeof) {
            case Pe: {
              var Ht = sy(je, Fe.mode, Oe);
              return Ht.ref = mh(Fe, null, je), Ht.return = Fe, Ht;
            }
            case rt: {
              var Pt = uy(je, Fe.mode, Oe);
              return Pt.return = Fe, Pt;
            }
            case gn: {
              var Ln = je._payload, on = je._init;
              return Ae(Fe, on(Ln), Oe);
            }
          }
          if (wr(je) || ot(je)) {
            var Kn = Fu(je, Fe.mode, Oe, null);
            return Kn.return = Fe, Kn;
          }
          Im(Fe, je);
        }
        return typeof je == "function" && Hm(Fe), null;
      }
      function He(Fe, je, Oe, dt) {
        var Ht = je !== null ? je.key : null;
        if (typeof Oe == "string" && Oe !== "" || typeof Oe == "number")
          return Ht !== null ? null : Y(Fe, je, "" + Oe, dt);
        if (typeof Oe == "object" && Oe !== null) {
          switch (Oe.$$typeof) {
            case Pe:
              return Oe.key === Ht ? $(Fe, je, Oe, dt) : null;
            case rt:
              return Oe.key === Ht ? se(Fe, je, Oe, dt) : null;
            case gn: {
              var Pt = Oe._payload, Ln = Oe._init;
              return He(Fe, je, Ln(Pt), dt);
            }
          }
          if (wr(Oe) || ot(Oe))
            return Ht !== null ? null : he(Fe, je, Oe, dt, null);
          Im(Fe, Oe);
        }
        return typeof Oe == "function" && Hm(Fe), null;
      }
      function Ze(Fe, je, Oe, dt, Ht) {
        if (typeof dt == "string" && dt !== "" || typeof dt == "number") {
          var Pt = Fe.get(Oe) || null;
          return Y(je, Pt, "" + dt, Ht);
        }
        if (typeof dt == "object" && dt !== null) {
          switch (dt.$$typeof) {
            case Pe: {
              var Ln = Fe.get(dt.key === null ? Oe : dt.key) || null;
              return $(je, Ln, dt, Ht);
            }
            case rt: {
              var on = Fe.get(dt.key === null ? Oe : dt.key) || null;
              return se(je, on, dt, Ht);
            }
            case gn:
              var Kn = dt._payload, Cn = dt._init;
              return Ze(Fe, je, Oe, Cn(Kn), Ht);
          }
          if (wr(dt) || ot(dt)) {
            var Sr = Fe.get(Oe) || null;
            return he(je, Sr, dt, Ht, null);
          }
          Im(je, dt);
        }
        return typeof dt == "function" && Hm(je), null;
      }
      function at(Fe, je, Oe) {
        {
          if (typeof Fe != "object" || Fe === null)
            return je;
          switch (Fe.$$typeof) {
            case Pe:
            case rt:
              Pb(Fe, Oe);
              var dt = Fe.key;
              if (typeof dt != "string")
                break;
              if (je === null) {
                je = /* @__PURE__ */ new Set(), je.add(dt);
                break;
              }
              if (!je.has(dt)) {
                je.add(dt);
                break;
              }
              h("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", dt);
              break;
            case gn:
              var Ht = Fe._payload, Pt = Fe._init;
              at(Pt(Ht), je, Oe);
              break;
          }
        }
        return je;
      }
      function $e(Fe, je, Oe, dt) {
        for (var Ht = null, Pt = 0; Pt < Oe.length; Pt++) {
          var Ln = Oe[Pt];
          Ht = at(Ln, Ht, Fe);
        }
        for (var on = null, Kn = null, Cn = je, Sr = 0, Qt = 0, Wr = null; Cn !== null && Qt < Oe.length; Qt++) {
          Cn.index > Qt ? (Wr = Cn, Cn = null) : Wr = Cn.sibling;
          var ki = He(Fe, Cn, Oe[Qt], dt);
          if (ki === null) {
            Cn === null && (Cn = Wr);
            break;
          }
          n && Cn && ki.alternate === null && a(Fe, Cn), Sr = N(ki, Sr, Qt), Kn === null ? on = ki : Kn.sibling = ki, Kn = ki, Cn = Wr;
        }
        if (Qt === Oe.length) {
          if (c(Fe, Cn), s()) {
            var ii = Qt;
            Ws(Fe, ii);
          }
          return on;
        }
        if (Cn === null) {
          for (; Qt < Oe.length; Qt++) {
            var bo = Ae(Fe, Oe[Qt], dt);
            bo !== null && (Sr = N(bo, Sr, Qt), Kn === null ? on = bo : Kn.sibling = bo, Kn = bo);
          }
          if (s()) {
            var Hi = Qt;
            Ws(Fe, Hi);
          }
          return on;
        }
        for (var Gi = p(Fe, Cn); Qt < Oe.length; Qt++) {
          var Ci = Ze(Gi, Fe, Qt, Oe[Qt], dt);
          Ci !== null && (n && Ci.alternate !== null && Gi.delete(Ci.key === null ? Qt : Ci.key), Sr = N(Ci, Sr, Qt), Kn === null ? on = Ci : Kn.sibling = Ci, Kn = Ci);
        }
        if (n && Gi.forEach(function(vf) {
          return a(Fe, vf);
        }), s()) {
          var ql = Qt;
          Ws(Fe, ql);
        }
        return on;
      }
      function Bt(Fe, je, Oe, dt) {
        var Ht = ot(Oe);
        if (typeof Ht != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          Oe[Symbol.toStringTag] === "Generator" && (uv || h("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), uv = !0), Oe.entries === Ht && (lv || h("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), lv = !0);
          var Pt = Ht.call(Oe);
          if (Pt)
            for (var Ln = null, on = Pt.next(); !on.done; on = Pt.next()) {
              var Kn = on.value;
              Ln = at(Kn, Ln, Fe);
            }
        }
        var Cn = Ht.call(Oe);
        if (Cn == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Sr = null, Qt = null, Wr = je, ki = 0, ii = 0, bo = null, Hi = Cn.next(); Wr !== null && !Hi.done; ii++, Hi = Cn.next()) {
          Wr.index > ii ? (bo = Wr, Wr = null) : bo = Wr.sibling;
          var Gi = He(Fe, Wr, Hi.value, dt);
          if (Gi === null) {
            Wr === null && (Wr = bo);
            break;
          }
          n && Wr && Gi.alternate === null && a(Fe, Wr), ki = N(Gi, ki, ii), Qt === null ? Sr = Gi : Qt.sibling = Gi, Qt = Gi, Wr = bo;
        }
        if (Hi.done) {
          if (c(Fe, Wr), s()) {
            var Ci = ii;
            Ws(Fe, Ci);
          }
          return Sr;
        }
        if (Wr === null) {
          for (; !Hi.done; ii++, Hi = Cn.next()) {
            var ql = Ae(Fe, Hi.value, dt);
            ql !== null && (ki = N(ql, ki, ii), Qt === null ? Sr = ql : Qt.sibling = ql, Qt = ql);
          }
          if (s()) {
            var vf = ii;
            Ws(Fe, vf);
          }
          return Sr;
        }
        for (var Zh = p(Fe, Wr); !Hi.done; ii++, Hi = Cn.next()) {
          var rl = Ze(Zh, Fe, ii, Hi.value, dt);
          rl !== null && (n && rl.alternate !== null && Zh.delete(rl.key === null ? ii : rl.key), ki = N(rl, ki, ii), Qt === null ? Sr = rl : Qt.sibling = rl, Qt = rl);
        }
        if (n && Zh.forEach(function(Y9) {
          return a(Fe, Y9);
        }), s()) {
          var j9 = ii;
          Ws(Fe, j9);
        }
        return Sr;
      }
      function nn(Fe, je, Oe, dt) {
        if (je !== null && je.tag === Z) {
          c(Fe, je.sibling);
          var Ht = b(je, Oe);
          return Ht.return = Fe, Ht;
        }
        c(Fe, je);
        var Pt = ly(Oe, Fe.mode, dt);
        return Pt.return = Fe, Pt;
      }
      function Zt(Fe, je, Oe, dt) {
        for (var Ht = Oe.key, Pt = je; Pt !== null; ) {
          if (Pt.key === Ht) {
            var Ln = Oe.type;
            if (Ln === st) {
              if (Pt.tag === te) {
                c(Fe, Pt.sibling);
                var on = b(Pt, Oe.props.children);
                return on.return = Fe, on._debugSource = Oe._source, on._debugOwner = Oe._owner, on;
              }
            } else if (Pt.elementType === Ln || // Keep this check inline so it only runs on the false path:
            U5(Pt, Oe) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof Ln == "object" && Ln !== null && Ln.$$typeof === gn && Db(Ln) === Pt.type) {
              c(Fe, Pt.sibling);
              var Kn = b(Pt, Oe.props);
              return Kn.ref = mh(Fe, Pt, Oe), Kn.return = Fe, Kn._debugSource = Oe._source, Kn._debugOwner = Oe._owner, Kn;
            }
            c(Fe, Pt);
            break;
          } else
            a(Fe, Pt);
          Pt = Pt.sibling;
        }
        if (Oe.type === st) {
          var Cn = Fu(Oe.props.children, Fe.mode, dt, Oe.key);
          return Cn.return = Fe, Cn;
        } else {
          var Sr = sy(Oe, Fe.mode, dt);
          return Sr.ref = mh(Fe, je, Oe), Sr.return = Fe, Sr;
        }
      }
      function ur(Fe, je, Oe, dt) {
        for (var Ht = Oe.key, Pt = je; Pt !== null; ) {
          if (Pt.key === Ht)
            if (Pt.tag === U && Pt.stateNode.containerInfo === Oe.containerInfo && Pt.stateNode.implementation === Oe.implementation) {
              c(Fe, Pt.sibling);
              var Ln = b(Pt, Oe.children || []);
              return Ln.return = Fe, Ln;
            } else {
              c(Fe, Pt);
              break;
            }
          else
            a(Fe, Pt);
          Pt = Pt.sibling;
        }
        var on = uy(Oe, Fe.mode, dt);
        return on.return = Fe, on;
      }
      function In(Fe, je, Oe, dt) {
        var Ht = typeof Oe == "object" && Oe !== null && Oe.type === st && Oe.key === null;
        if (Ht && (Oe = Oe.props.children), typeof Oe == "object" && Oe !== null) {
          switch (Oe.$$typeof) {
            case Pe:
              return G(Zt(Fe, je, Oe, dt));
            case rt:
              return G(ur(Fe, je, Oe, dt));
            case gn:
              var Pt = Oe._payload, Ln = Oe._init;
              return In(Fe, je, Ln(Pt), dt);
          }
          if (wr(Oe))
            return $e(Fe, je, Oe, dt);
          if (ot(Oe))
            return Bt(Fe, je, Oe, dt);
          Im(Fe, Oe);
        }
        return typeof Oe == "string" && Oe !== "" || typeof Oe == "number" ? G(nn(Fe, je, "" + Oe, dt)) : (typeof Oe == "function" && Hm(Fe), c(Fe, je));
      }
      return In;
    }
    var Jd = Lb(!0), Ob = Lb(!1);
    function y8(n, a) {
      if (n !== null && a.child !== n.child)
        throw new Error("Resuming work not yet implemented.");
      if (a.child !== null) {
        var c = a.child, p = Ic(c, c.pendingProps);
        for (a.child = p, p.return = a; c.sibling !== null; )
          c = c.sibling, p = p.sibling = Ic(c, c.pendingProps), p.return = a;
        p.sibling = null;
      }
    }
    function b8(n, a) {
      for (var c = n.child; c !== null; )
        x9(c, a), c = c.sibling;
    }
    var Gm = K(null), gh;
    gh = {};
    var Vm = null, $d = null, hv = null, qm = !1;
    function Wm() {
      Vm = null, $d = null, hv = null, qm = !1;
    }
    function Fb() {
      qm = !0;
    }
    function zb() {
      qm = !1;
    }
    function Bb(n, a, c) {
      oa ? (re(Gm, a._currentValue, n), a._currentValue = c, a._currentRenderer !== void 0 && a._currentRenderer !== null && a._currentRenderer !== gh && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer = gh) : (re(Gm, a._currentValue2, n), a._currentValue2 = c, a._currentRenderer2 !== void 0 && a._currentRenderer2 !== null && a._currentRenderer2 !== gh && h("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), a._currentRenderer2 = gh);
    }
    function pv(n, a) {
      var c = Gm.current;
      J(Gm, a), oa ? n._currentValue = c : n._currentValue2 = c;
    }
    function mv(n, a, c) {
      for (var p = n; p !== null; ) {
        var b = p.alternate;
        if (gi(p.childLanes, a) ? b !== null && !gi(b.childLanes, a) && (b.childLanes = fn(b.childLanes, a)) : (p.childLanes = fn(p.childLanes, a), b !== null && (b.childLanes = fn(b.childLanes, a))), p === c)
          break;
        p = p.return;
      }
      p !== c && h("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function _8(n, a, c) {
      S8(n, a, c);
    }
    function S8(n, a, c) {
      var p = n.child;
      for (p !== null && (p.return = n); p !== null; ) {
        var b = void 0, N = p.dependencies;
        if (N !== null) {
          b = p.child;
          for (var G = N.firstContext; G !== null; ) {
            if (G.context === a) {
              if (p.tag === q) {
                var Y = yu(c), $ = Il(fr, Y);
                $.tag = jm;
                var se = p.updateQueue;
                if (se !== null) {
                  var he = se.shared, Ae = he.pending;
                  Ae === null ? $.next = $ : ($.next = Ae.next, Ae.next = $), he.pending = $;
                }
              }
              p.lanes = fn(p.lanes, c);
              var He = p.alternate;
              He !== null && (He.lanes = fn(He.lanes, c)), mv(p.return, c, n), N.lanes = fn(N.lanes, c);
              break;
            }
            G = G.next;
          }
        } else if (p.tag === ce)
          b = p.type === n.type ? null : p.child;
        else if (p.tag === pe) {
          var Ze = p.return;
          if (Ze === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Ze.lanes = fn(Ze.lanes, c);
          var at = Ze.alternate;
          at !== null && (at.lanes = fn(at.lanes, c)), mv(Ze, c, n), b = p.sibling;
        } else
          b = p.child;
        if (b !== null)
          b.return = p;
        else
          for (b = p; b !== null; ) {
            if (b === n) {
              b = null;
              break;
            }
            var $e = b.sibling;
            if ($e !== null) {
              $e.return = b.return, b = $e;
              break;
            }
            b = b.return;
          }
        p = b;
      }
    }
    function ef(n, a) {
      Vm = n, $d = null, hv = null;
      var c = n.dependencies;
      if (c !== null) {
        var p = c.firstContext;
        p !== null && (Ua(c.lanes, a) && Ph(), c.firstContext = null);
      }
    }
    function da(n) {
      qm && h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var a = oa ? n._currentValue : n._currentValue2;
      if (hv !== n) {
        var c = {
          context: n,
          memoizedValue: a,
          next: null
        };
        if ($d === null) {
          if (Vm === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          $d = c, Vm.dependencies = {
            lanes: Ke,
            firstContext: c
          };
        } else
          $d = $d.next = c;
      }
      return a;
    }
    var Pc = null;
    function gv(n) {
      Pc === null ? Pc = [n] : Pc.push(n);
    }
    function w8() {
      if (Pc !== null) {
        for (var n = 0; n < Pc.length; n++) {
          var a = Pc[n], c = a.interleaved;
          if (c !== null) {
            a.interleaved = null;
            var p = c.next, b = a.pending;
            if (b !== null) {
              var N = b.next;
              b.next = p, c.next = N;
            }
            a.pending = c;
          }
        }
        Pc = null;
      }
    }
    function Ub(n, a, c, p) {
      var b = a.interleaved;
      return b === null ? (c.next = c, gv(a)) : (c.next = b.next, b.next = c), a.interleaved = c, Km(n, p);
    }
    function x8(n, a, c, p) {
      var b = a.interleaved;
      b === null ? (c.next = c, gv(a)) : (c.next = b.next, b.next = c), a.interleaved = c;
    }
    function k8(n, a, c, p) {
      var b = a.interleaved;
      return b === null ? (c.next = c, gv(a)) : (c.next = b.next, b.next = c), a.interleaved = c, Km(n, p);
    }
    function Bi(n, a) {
      return Km(n, a);
    }
    var C8 = Km;
    function Km(n, a) {
      n.lanes = fn(n.lanes, a);
      var c = n.alternate;
      c !== null && (c.lanes = fn(c.lanes, a)), c === null && (n.flags & (Tn | Xr)) !== gt && O5(n);
      for (var p = n, b = n.return; b !== null; )
        b.childLanes = fn(b.childLanes, a), c = b.alternate, c !== null ? c.childLanes = fn(c.childLanes, a) : (b.flags & (Tn | Xr)) !== gt && O5(n), p = b, b = b.return;
      if (p.tag === I) {
        var N = p.stateNode;
        return N;
      } else
        return null;
    }
    var Ib = 0, Hb = 1, jm = 2, vv = 3, Ym = !1, yv, Zm;
    yv = !1, Zm = null;
    function bv(n) {
      var a = {
        baseState: n.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: Ke
        },
        effects: null
      };
      n.updateQueue = a;
    }
    function Gb(n, a) {
      var c = a.updateQueue, p = n.updateQueue;
      if (c === p) {
        var b = {
          baseState: p.baseState,
          firstBaseUpdate: p.firstBaseUpdate,
          lastBaseUpdate: p.lastBaseUpdate,
          shared: p.shared,
          effects: p.effects
        };
        a.updateQueue = b;
      }
    }
    function Il(n, a) {
      var c = {
        eventTime: n,
        lane: a,
        tag: Ib,
        payload: null,
        callback: null,
        next: null
      };
      return c;
    }
    function Ru(n, a, c) {
      var p = n.updateQueue;
      if (p === null)
        return null;
      var b = p.shared;
      if (Zm === b && !yv && (h("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), yv = !0), FC()) {
        var N = b.pending;
        return N === null ? a.next = a : (a.next = N.next, N.next = a), b.pending = a, C8(n, c);
      } else
        return k8(n, b, a, c);
    }
    function Xm(n, a, c) {
      var p = a.updateQueue;
      if (p !== null) {
        var b = p.shared;
        if (th(c)) {
          var N = b.lanes;
          N = nh(N, n.pendingLanes);
          var G = fn(N, c);
          b.lanes = G, rh(n, G);
        }
      }
    }
    function _v(n, a) {
      var c = n.updateQueue, p = n.alternate;
      if (p !== null) {
        var b = p.updateQueue;
        if (c === b) {
          var N = null, G = null, Y = c.firstBaseUpdate;
          if (Y !== null) {
            var $ = Y;
            do {
              var se = {
                eventTime: $.eventTime,
                lane: $.lane,
                tag: $.tag,
                payload: $.payload,
                callback: $.callback,
                next: null
              };
              G === null ? N = G = se : (G.next = se, G = se), $ = $.next;
            } while ($ !== null);
            G === null ? N = G = a : (G.next = a, G = a);
          } else
            N = G = a;
          c = {
            baseState: b.baseState,
            firstBaseUpdate: N,
            lastBaseUpdate: G,
            shared: b.shared,
            effects: b.effects
          }, n.updateQueue = c;
          return;
        }
      }
      var he = c.lastBaseUpdate;
      he === null ? c.firstBaseUpdate = a : he.next = a, c.lastBaseUpdate = a;
    }
    function E8(n, a, c, p, b, N) {
      switch (c.tag) {
        case Hb: {
          var G = c.payload;
          if (typeof G == "function") {
            Fb();
            var Y = G.call(N, p, b);
            {
              if (n.mode & Ot) {
                Gr(!0);
                try {
                  G.call(N, p, b);
                } finally {
                  Gr(!1);
                }
              }
              zb();
            }
            return Y;
          }
          return G;
        }
        case vv:
          n.flags = n.flags & ~Et | xt;
        // Intentional fallthrough
        case Ib: {
          var $ = c.payload, se;
          if (typeof $ == "function") {
            Fb(), se = $.call(N, p, b);
            {
              if (n.mode & Ot) {
                Gr(!0);
                try {
                  $.call(N, p, b);
                } finally {
                  Gr(!1);
                }
              }
              zb();
            }
          } else
            se = $;
          return se == null ? p : E({}, p, se);
        }
        case jm:
          return Ym = !0, p;
      }
      return p;
    }
    function Qm(n, a, c, p) {
      var b = n.updateQueue;
      Ym = !1, Zm = b.shared;
      var N = b.firstBaseUpdate, G = b.lastBaseUpdate, Y = b.shared.pending;
      if (Y !== null) {
        b.shared.pending = null;
        var $ = Y, se = $.next;
        $.next = null, G === null ? N = se : G.next = se, G = $;
        var he = n.alternate;
        if (he !== null) {
          var Ae = he.updateQueue, He = Ae.lastBaseUpdate;
          He !== G && (He === null ? Ae.firstBaseUpdate = se : He.next = se, Ae.lastBaseUpdate = $);
        }
      }
      if (N !== null) {
        var Ze = b.baseState, at = Ke, $e = null, Bt = null, nn = null, Zt = N;
        do {
          var ur = Zt.lane, In = Zt.eventTime;
          if (gi(p, ur)) {
            if (nn !== null) {
              var je = {
                eventTime: In,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: rr,
                tag: Zt.tag,
                payload: Zt.payload,
                callback: Zt.callback,
                next: null
              };
              nn = nn.next = je;
            }
            Ze = E8(n, b, Zt, Ze, a, c);
            var Oe = Zt.callback;
            if (Oe !== null && // If the update was already committed, we should not queue its
            // callback again.
            Zt.lane !== rr) {
              n.flags |= or;
              var dt = b.effects;
              dt === null ? b.effects = [Zt] : dt.push(Zt);
            }
          } else {
            var Fe = {
              eventTime: In,
              lane: ur,
              tag: Zt.tag,
              payload: Zt.payload,
              callback: Zt.callback,
              next: null
            };
            nn === null ? (Bt = nn = Fe, $e = Ze) : nn = nn.next = Fe, at = fn(at, ur);
          }
          if (Zt = Zt.next, Zt === null) {
            if (Y = b.shared.pending, Y === null)
              break;
            var Ht = Y, Pt = Ht.next;
            Ht.next = null, Zt = Pt, b.lastBaseUpdate = Ht, b.shared.pending = null;
          }
        } while (!0);
        nn === null && ($e = Ze), b.baseState = $e, b.firstBaseUpdate = Bt, b.lastBaseUpdate = nn;
        var Ln = b.shared.interleaved;
        if (Ln !== null) {
          var on = Ln;
          do
            at = fn(at, on.lane), on = on.next;
          while (on !== Ln);
        } else N === null && (b.shared.lanes = Ke);
        Kh(at), n.lanes = at, n.memoizedState = Ze;
      }
      Zm = null;
    }
    function R8(n, a) {
      if (typeof n != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + n));
      n.call(a);
    }
    function Vb() {
      Ym = !1;
    }
    function Jm() {
      return Ym;
    }
    function qb(n, a, c) {
      var p = a.effects;
      if (a.effects = null, p !== null)
        for (var b = 0; b < p.length; b++) {
          var N = p[b], G = N.callback;
          G !== null && (N.callback = null, R8(G, c));
        }
    }
    var vh = {}, Tu = K(vh), yh = K(vh), $m = K(vh);
    function eg(n) {
      if (n === vh)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return n;
    }
    function Sv() {
      var n = eg($m.current);
      return n;
    }
    function wv(n, a) {
      re($m, a, n), re(yh, n, n), re(Tu, vh, n);
      var c = It(a);
      J(Tu, n), re(Tu, c, n);
    }
    function tf(n) {
      J(Tu, n), J(yh, n), J($m, n);
    }
    function bh() {
      var n = eg(Tu.current);
      return n;
    }
    function Wb(n) {
      var a = eg($m.current), c = eg(Tu.current), p = nr(c, n.type, a);
      c !== p && (re(yh, n, n), re(Tu, p, n));
    }
    function xv(n) {
      yh.current === n && (J(Tu, n), J(yh, n));
    }
    var T8 = 0, Kb = 1, jb = 1, _h = 2, ys = K(T8);
    function kv(n, a) {
      return (n & a) !== 0;
    }
    function nf(n) {
      return n & Kb;
    }
    function Cv(n, a) {
      return n & Kb | a;
    }
    function N8(n, a) {
      return n | a;
    }
    function Nu(n, a) {
      re(ys, a, n);
    }
    function rf(n) {
      J(ys, n);
    }
    function A8(n, a) {
      var c = n.memoizedState;
      return c !== null ? c.dehydrated !== null : (n.memoizedProps, !0);
    }
    function tg(n) {
      for (var a = n; a !== null; ) {
        if (a.tag === j) {
          var c = a.memoizedState;
          if (c !== null) {
            var p = c.dehydrated;
            if (p === null || Ai(p) || Fa(p))
              return a;
          }
        } else if (a.tag === Me && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        a.memoizedProps.revealOrder !== void 0) {
          var b = (a.flags & xt) !== gt;
          if (b)
            return a;
        } else if (a.child !== null) {
          a.child.return = a, a = a.child;
          continue;
        }
        if (a === n)
          return null;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n)
            return null;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return null;
    }
    var Ji = (
      /*   */
      0
    ), Na = (
      /* */
      1
    ), js = (
      /*  */
      2
    ), Aa = (
      /*    */
      4
    ), ei = (
      /*   */
      8
    ), Ev = [];
    function Rv() {
      for (var n = 0; n < Ev.length; n++) {
        var a = Ev[n];
        oa ? a._workInProgressVersionPrimary = null : a._workInProgressVersionSecondary = null;
      }
      Ev.length = 0;
    }
    function M8(n, a) {
      var c = a._getVersion, p = c(a._source);
      n.mutableSourceEagerHydrationData == null ? n.mutableSourceEagerHydrationData = [a, p] : n.mutableSourceEagerHydrationData.push(a, p);
    }
    var At = u.ReactCurrentDispatcher, Sh = u.ReactCurrentBatchConfig, Tv, af;
    Tv = /* @__PURE__ */ new Set();
    var Dc = Ke, lr = null, Ma = null, Pa = null, ng = !1, wh = !1, xh = 0, P8 = 0, D8 = 25, Ye = null, Uo = null, Au = -1, Nv = !1;
    function Qn() {
      {
        var n = Ye;
        Uo === null ? Uo = [n] : Uo.push(n);
      }
    }
    function vt() {
      {
        var n = Ye;
        Uo !== null && (Au++, Uo[Au] !== n && L8(n));
      }
    }
    function of(n) {
      n != null && !wr(n) && h("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Ye, typeof n);
    }
    function L8(n) {
      {
        var a = qe(lr);
        if (!Tv.has(a) && (Tv.add(a), Uo !== null)) {
          for (var c = "", p = 30, b = 0; b <= Au; b++) {
            for (var N = Uo[b], G = b === Au ? n : N, Y = b + 1 + ". " + N; Y.length < p; )
              Y += " ";
            Y += G + `
`, c += Y;
          }
          h(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, a, c);
        }
      }
    }
    function wi() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function Av(n, a) {
      if (Nv)
        return !1;
      if (a === null)
        return h("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Ye), !1;
      n.length !== a.length && h(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Ye, "[" + a.join(", ") + "]", "[" + n.join(", ") + "]");
      for (var c = 0; c < a.length && c < n.length; c++)
        if (!Ha(n[c], a[c]))
          return !1;
      return !0;
    }
    function sf(n, a, c, p, b, N) {
      Dc = N, lr = a, Uo = n !== null ? n._debugHookTypes : null, Au = -1, Nv = n !== null && n.type !== a.type, a.memoizedState = null, a.updateQueue = null, a.lanes = Ke, n !== null && n.memoizedState !== null ? At.current = m_ : Uo !== null ? At.current = p_ : At.current = h_;
      var G = c(p, b);
      if (wh) {
        var Y = 0;
        do {
          if (wh = !1, xh = 0, Y >= D8)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          Y += 1, Nv = !1, Ma = null, Pa = null, a.updateQueue = null, Au = -1, At.current = g_, G = c(p, b);
        } while (wh);
      }
      At.current = mg, a._debugHookTypes = Uo;
      var $ = Ma !== null && Ma.next !== null;
      if (Dc = Ke, lr = null, Ma = null, Pa = null, Ye = null, Uo = null, Au = -1, n !== null && (n.flags & Qr) !== (a.flags & Qr) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (n.mode & ht) !== De && h("Internal React error: Expected static flag was missing. Please notify the React team."), ng = !1, $)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return G;
    }
    function lf() {
      var n = xh !== 0;
      return xh = 0, n;
    }
    function Yb(n, a, c) {
      a.updateQueue = n.updateQueue, (a.mode & tn) !== De ? a.flags &= -50333701 : a.flags &= -2053, n.lanes = Di(n.lanes, c);
    }
    function Zb() {
      if (At.current = mg, ng) {
        for (var n = lr.memoizedState; n !== null; ) {
          var a = n.queue;
          a !== null && (a.pending = null), n = n.next;
        }
        ng = !1;
      }
      Dc = Ke, lr = null, Ma = null, Pa = null, Uo = null, Au = -1, Ye = null, l_ = !1, wh = !1, xh = 0;
    }
    function Ys() {
      var n = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return Pa === null ? lr.memoizedState = Pa = n : Pa = Pa.next = n, Pa;
    }
    function Io() {
      var n;
      if (Ma === null) {
        var a = lr.alternate;
        a !== null ? n = a.memoizedState : n = null;
      } else
        n = Ma.next;
      var c;
      if (Pa === null ? c = lr.memoizedState : c = Pa.next, c !== null)
        Pa = c, c = Pa.next, Ma = n;
      else {
        if (n === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Ma = n;
        var p = {
          memoizedState: Ma.memoizedState,
          baseState: Ma.baseState,
          baseQueue: Ma.baseQueue,
          queue: Ma.queue,
          next: null
        };
        Pa === null ? lr.memoizedState = Pa = p : Pa = Pa.next = p;
      }
      return Pa;
    }
    function Xb() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function Mv(n, a) {
      return typeof a == "function" ? a(n) : a;
    }
    function Pv(n, a, c) {
      var p = Ys(), b;
      c !== void 0 ? b = c(a) : b = a, p.memoizedState = p.baseState = b;
      var N = {
        pending: null,
        interleaved: null,
        lanes: Ke,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: b
      };
      p.queue = N;
      var G = N.dispatch = B8.bind(null, lr, N);
      return [p.memoizedState, G];
    }
    function Dv(n, a, c) {
      var p = Io(), b = p.queue;
      if (b === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var N = Ma, G = N.baseQueue, Y = b.pending;
      if (Y !== null) {
        if (G !== null) {
          var $ = G.next, se = Y.next;
          G.next = se, Y.next = $;
        }
        N.baseQueue !== G && h("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), N.baseQueue = G = Y, b.pending = null;
      }
      if (G !== null) {
        var he = G.next, Ae = N.baseState, He = null, Ze = null, at = null, $e = he;
        do {
          var Bt = $e.lane;
          if (gi(Dc, Bt)) {
            if (at !== null) {
              var Zt = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: rr,
                action: $e.action,
                hasEagerState: $e.hasEagerState,
                eagerState: $e.eagerState,
                next: null
              };
              at = at.next = Zt;
            }
            if ($e.hasEagerState)
              Ae = $e.eagerState;
            else {
              var ur = $e.action;
              Ae = n(Ae, ur);
            }
          } else {
            var nn = {
              lane: Bt,
              action: $e.action,
              hasEagerState: $e.hasEagerState,
              eagerState: $e.eagerState,
              next: null
            };
            at === null ? (Ze = at = nn, He = Ae) : at = at.next = nn, lr.lanes = fn(lr.lanes, Bt), Kh(Bt);
          }
          $e = $e.next;
        } while ($e !== null && $e !== he);
        at === null ? He = Ae : at.next = Ze, Ha(Ae, p.memoizedState) || Ph(), p.memoizedState = Ae, p.baseState = He, p.baseQueue = at, b.lastRenderedState = Ae;
      }
      var In = b.interleaved;
      if (In !== null) {
        var Fe = In;
        do {
          var je = Fe.lane;
          lr.lanes = fn(lr.lanes, je), Kh(je), Fe = Fe.next;
        } while (Fe !== In);
      } else G === null && (b.lanes = Ke);
      var Oe = b.dispatch;
      return [p.memoizedState, Oe];
    }
    function Lv(n, a, c) {
      var p = Io(), b = p.queue;
      if (b === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      b.lastRenderedReducer = n;
      var N = b.dispatch, G = b.pending, Y = p.memoizedState;
      if (G !== null) {
        b.pending = null;
        var $ = G.next, se = $;
        do {
          var he = se.action;
          Y = n(Y, he), se = se.next;
        } while (se !== $);
        Ha(Y, p.memoizedState) || Ph(), p.memoizedState = Y, p.baseQueue === null && (p.baseState = Y), b.lastRenderedState = Y;
      }
      return [Y, N];
    }
    function EL(n, a, c) {
    }
    function RL(n, a, c) {
    }
    function Ov(n, a, c) {
      var p = lr, b = Ys(), N, G = s();
      if (G) {
        if (c === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        N = c(), af || N !== c() && (h("The result of getServerSnapshot should be cached to avoid an infinite loop"), af = !0);
      } else {
        if (N = a(), !af) {
          var Y = a();
          Ha(N, Y) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), af = !0);
        }
        var $ = qg();
        if ($ === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        vu($, Dc) || Qb(p, a, N);
      }
      b.memoizedState = N;
      var se = {
        value: N,
        getSnapshot: a
      };
      return b.queue = se, sg($b.bind(null, p, se, n), [n]), p.flags |= mr, kh(Na | ei, Jb.bind(null, p, se, N, a), void 0, null), N;
    }
    function rg(n, a, c) {
      var p = lr, b = Io(), N = a();
      if (!af) {
        var G = a();
        Ha(N, G) || (h("The result of getSnapshot should be cached to avoid an infinite loop"), af = !0);
      }
      var Y = b.memoizedState, $ = !Ha(Y, N);
      $ && (b.memoizedState = N, Ph());
      var se = b.queue;
      if (Eh($b.bind(null, p, se, n), [n]), se.getSnapshot !== a || $ || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      Pa !== null && Pa.memoizedState.tag & Na) {
        p.flags |= mr, kh(Na | ei, Jb.bind(null, p, se, N, a), void 0, null);
        var he = qg();
        if (he === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        vu(he, Dc) || Qb(p, a, N);
      }
      return N;
    }
    function Qb(n, a, c) {
      n.flags |= et;
      var p = {
        getSnapshot: a,
        value: c
      }, b = lr.updateQueue;
      if (b === null)
        b = Xb(), lr.updateQueue = b, b.stores = [p];
      else {
        var N = b.stores;
        N === null ? b.stores = [p] : N.push(p);
      }
    }
    function Jb(n, a, c, p) {
      a.value = c, a.getSnapshot = p, e_(a) && t_(n);
    }
    function $b(n, a, c) {
      var p = function() {
        e_(a) && t_(n);
      };
      return c(p);
    }
    function e_(n) {
      var a = n.getSnapshot, c = n.value;
      try {
        var p = a();
        return !Ha(c, p);
      } catch {
        return !0;
      }
    }
    function t_(n) {
      var a = Bi(n, jt);
      a !== null && ha(a, n, jt, fr);
    }
    function ag(n) {
      var a = Ys();
      typeof n == "function" && (n = n()), a.memoizedState = a.baseState = n;
      var c = {
        pending: null,
        interleaved: null,
        lanes: Ke,
        dispatch: null,
        lastRenderedReducer: Mv,
        lastRenderedState: n
      };
      a.queue = c;
      var p = c.dispatch = U8.bind(null, lr, c);
      return [a.memoizedState, p];
    }
    function Fv(n) {
      return Dv(Mv);
    }
    function zv(n) {
      return Lv(Mv);
    }
    function kh(n, a, c, p) {
      var b = {
        tag: n,
        create: a,
        destroy: c,
        deps: p,
        // Circular
        next: null
      }, N = lr.updateQueue;
      if (N === null)
        N = Xb(), lr.updateQueue = N, N.lastEffect = b.next = b;
      else {
        var G = N.lastEffect;
        if (G === null)
          N.lastEffect = b.next = b;
        else {
          var Y = G.next;
          G.next = b, b.next = Y, N.lastEffect = b;
        }
      }
      return b;
    }
    function Bv(n) {
      var a = Ys();
      {
        var c = {
          current: n
        };
        return a.memoizedState = c, c;
      }
    }
    function ig(n) {
      var a = Io();
      return a.memoizedState;
    }
    function Ch(n, a, c, p) {
      var b = Ys(), N = p === void 0 ? null : p;
      lr.flags |= n, b.memoizedState = kh(Na | a, c, void 0, N);
    }
    function og(n, a, c, p) {
      var b = Io(), N = p === void 0 ? null : p, G = void 0;
      if (Ma !== null) {
        var Y = Ma.memoizedState;
        if (G = Y.destroy, N !== null) {
          var $ = Y.deps;
          if (Av(N, $)) {
            b.memoizedState = kh(a, c, G, N);
            return;
          }
        }
      }
      lr.flags |= n, b.memoizedState = kh(Na | a, c, G, N);
    }
    function sg(n, a) {
      return (lr.mode & tn) !== De ? Ch(vr | mr | Tr, ei, n, a) : Ch(mr | Tr, ei, n, a);
    }
    function Eh(n, a) {
      return og(mr, ei, n, a);
    }
    function Uv(n, a) {
      return Ch(Xe, js, n, a);
    }
    function lg(n, a) {
      return og(Xe, js, n, a);
    }
    function Iv(n, a) {
      var c = Xe;
      return c |= yn, (lr.mode & tn) !== De && (c |= Nr), Ch(c, Aa, n, a);
    }
    function ug(n, a) {
      return og(Xe, Aa, n, a);
    }
    function n_(n, a) {
      if (typeof a == "function") {
        var c = a, p = n();
        return c(p), function() {
          c(null);
        };
      } else if (a != null) {
        var b = a;
        b.hasOwnProperty("current") || h("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(b).join(", ") + "}");
        var N = n();
        return b.current = N, function() {
          b.current = null;
        };
      }
    }
    function Hv(n, a, c) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var p = c != null ? c.concat([n]) : null, b = Xe;
      return b |= yn, (lr.mode & tn) !== De && (b |= Nr), Ch(b, Aa, n_.bind(null, a, n), p);
    }
    function cg(n, a, c) {
      typeof a != "function" && h("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", a !== null ? typeof a : "null");
      var p = c != null ? c.concat([n]) : null;
      return og(Xe, Aa, n_.bind(null, a, n), p);
    }
    function O8(n, a) {
    }
    var dg = O8;
    function Gv(n, a) {
      var c = Ys(), p = a === void 0 ? null : a;
      return c.memoizedState = [n, p], n;
    }
    function fg(n, a) {
      var c = Io(), p = a === void 0 ? null : a, b = c.memoizedState;
      if (b !== null && p !== null) {
        var N = b[1];
        if (Av(p, N))
          return b[0];
      }
      return c.memoizedState = [n, p], n;
    }
    function Vv(n, a) {
      var c = Ys(), p = a === void 0 ? null : a, b = n();
      return c.memoizedState = [b, p], b;
    }
    function hg(n, a) {
      var c = Io(), p = a === void 0 ? null : a, b = c.memoizedState;
      if (b !== null && p !== null) {
        var N = b[1];
        if (Av(p, N))
          return b[0];
      }
      var G = n();
      return c.memoizedState = [G, p], G;
    }
    function qv(n) {
      var a = Ys();
      return a.memoizedState = n, n;
    }
    function r_(n) {
      var a = Io(), c = Ma, p = c.memoizedState;
      return i_(a, p, n);
    }
    function a_(n) {
      var a = Io();
      if (Ma === null)
        return a.memoizedState = n, n;
      var c = Ma.memoizedState;
      return i_(a, c, n);
    }
    function i_(n, a, c) {
      var p = !xm(Dc);
      if (p) {
        if (!Ha(c, a)) {
          var b = Md();
          lr.lanes = fn(lr.lanes, b), Kh(b), n.baseState = !0;
        }
        return a;
      } else
        return n.baseState && (n.baseState = !1, Ph()), n.memoizedState = c, c;
    }
    function F8(n, a, c) {
      var p = $a();
      Mr(Rm(p, Lo)), n(!0);
      var b = Sh.transition;
      Sh.transition = {};
      var N = Sh.transition;
      Sh.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        n(!1), a();
      } finally {
        if (Mr(p), Sh.transition = b, b === null && N._updatedFibers) {
          var G = N._updatedFibers.size;
          G > 10 && g("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), N._updatedFibers.clear();
        }
      }
    }
    function Wv() {
      var n = ag(!1), a = n[0], c = n[1], p = F8.bind(null, c), b = Ys();
      return b.memoizedState = p, [a, p];
    }
    function o_() {
      var n = Fv(), a = n[0], c = Io(), p = c.memoizedState;
      return [a, p];
    }
    function s_() {
      var n = zv(), a = n[0], c = Io(), p = c.memoizedState;
      return [a, p];
    }
    var l_ = !1;
    function z8() {
      return l_;
    }
    function Kv() {
      var n = Ys(), a = qg(), c = a.identifierPrefix, p;
      if (s()) {
        var b = Pm();
        p = ":" + c + "R" + b;
        var N = xh++;
        N > 0 && (p += "H" + N.toString(32)), p += ":";
      } else {
        var G = P8++;
        p = ":" + c + "r" + G.toString(32) + ":";
      }
      return n.memoizedState = p, p;
    }
    function pg() {
      var n = Io(), a = n.memoizedState;
      return a;
    }
    function B8(n, a, c) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var p = Lu(n), b = {
        lane: p,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (u_(n))
        c_(a, b);
      else {
        var N = Ub(n, a, b, p);
        if (N !== null) {
          var G = xi();
          ha(N, n, p, G), d_(N, a, p);
        }
      }
      f_(n, p);
    }
    function U8(n, a, c) {
      typeof arguments[3] == "function" && h("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var p = Lu(n), b = {
        lane: p,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (u_(n))
        c_(a, b);
      else {
        var N = n.alternate;
        if (n.lanes === Ke && (N === null || N.lanes === Ke)) {
          var G = a.lastRenderedReducer;
          if (G !== null) {
            var Y;
            Y = At.current, At.current = bs;
            try {
              var $ = a.lastRenderedState, se = G($, c);
              if (b.hasEagerState = !0, b.eagerState = se, Ha(se, $)) {
                x8(n, a, b, p);
                return;
              }
            } catch {
            } finally {
              At.current = Y;
            }
          }
        }
        var he = Ub(n, a, b, p);
        if (he !== null) {
          var Ae = xi();
          ha(he, n, p, Ae), d_(he, a, p);
        }
      }
      f_(n, p);
    }
    function u_(n) {
      var a = n.alternate;
      return n === lr || a !== null && a === lr;
    }
    function c_(n, a) {
      wh = ng = !0;
      var c = n.pending;
      c === null ? a.next = a : (a.next = c.next, c.next = a), n.pending = a;
    }
    function d_(n, a, c) {
      if (th(c)) {
        var p = a.lanes;
        p = nh(p, n.pendingLanes);
        var b = fn(p, c);
        a.lanes = b, rh(n, b);
      }
    }
    function f_(n, a, c) {
      Ec(n, a);
    }
    var mg = {
      readContext: da,
      useCallback: wi,
      useContext: wi,
      useEffect: wi,
      useImperativeHandle: wi,
      useInsertionEffect: wi,
      useLayoutEffect: wi,
      useMemo: wi,
      useReducer: wi,
      useRef: wi,
      useState: wi,
      useDebugValue: wi,
      useDeferredValue: wi,
      useTransition: wi,
      useMutableSource: wi,
      useSyncExternalStore: wi,
      useId: wi,
      unstable_isNewReconciler: T
    }, h_ = null, p_ = null, m_ = null, g_ = null, Zs = null, bs = null, gg = null;
    {
      var jv = function() {
        h("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, cn = function() {
        h("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      h_ = {
        readContext: function(n) {
          return da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", Qn(), of(a), Gv(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", Qn(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", Qn(), of(a), sg(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", Qn(), of(c), Hv(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", Qn(), of(a), Uv(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", Qn(), of(a), Iv(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", Qn(), of(a);
          var c = At.current;
          At.current = Zs;
          try {
            return Vv(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", Qn();
          var p = At.current;
          At.current = Zs;
          try {
            return Pv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", Qn(), Bv(n);
        },
        useState: function(n) {
          Ye = "useState", Qn();
          var a = At.current;
          At.current = Zs;
          try {
            return ag(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", Qn(), void 0;
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", Qn(), qv(n);
        },
        useTransition: function() {
          return Ye = "useTransition", Qn(), Wv();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", Qn(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", Qn(), Ov(n, a, c);
        },
        useId: function() {
          return Ye = "useId", Qn(), Kv();
        },
        unstable_isNewReconciler: T
      }, p_ = {
        readContext: function(n) {
          return da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", vt(), Gv(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", vt(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", vt(), sg(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", vt(), Hv(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", vt(), Uv(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", vt(), Iv(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", vt();
          var c = At.current;
          At.current = Zs;
          try {
            return Vv(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", vt();
          var p = At.current;
          At.current = Zs;
          try {
            return Pv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", vt(), Bv(n);
        },
        useState: function(n) {
          Ye = "useState", vt();
          var a = At.current;
          At.current = Zs;
          try {
            return ag(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", vt(), void 0;
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", vt(), qv(n);
        },
        useTransition: function() {
          return Ye = "useTransition", vt(), Wv();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", vt(), Ov(n, a, c);
        },
        useId: function() {
          return Ye = "useId", vt(), Kv();
        },
        unstable_isNewReconciler: T
      }, m_ = {
        readContext: function(n) {
          return da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", vt(), fg(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", vt(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", vt(), Eh(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", vt(), cg(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", vt(), lg(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", vt(), ug(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", vt();
          var c = At.current;
          At.current = bs;
          try {
            return hg(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", vt();
          var p = At.current;
          At.current = bs;
          try {
            return Dv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", vt(), ig();
        },
        useState: function(n) {
          Ye = "useState", vt();
          var a = At.current;
          At.current = bs;
          try {
            return Fv(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", vt(), dg();
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", vt(), r_(n);
        },
        useTransition: function() {
          return Ye = "useTransition", vt(), o_();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", vt(), rg(n, a);
        },
        useId: function() {
          return Ye = "useId", vt(), pg();
        },
        unstable_isNewReconciler: T
      }, g_ = {
        readContext: function(n) {
          return da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", vt(), fg(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", vt(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", vt(), Eh(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", vt(), cg(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", vt(), lg(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", vt(), ug(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", vt();
          var c = At.current;
          At.current = gg;
          try {
            return hg(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", vt();
          var p = At.current;
          At.current = gg;
          try {
            return Lv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", vt(), ig();
        },
        useState: function(n) {
          Ye = "useState", vt();
          var a = At.current;
          At.current = gg;
          try {
            return zv(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", vt(), dg();
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", vt(), a_(n);
        },
        useTransition: function() {
          return Ye = "useTransition", vt(), s_();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", vt(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", vt(), rg(n, a);
        },
        useId: function() {
          return Ye = "useId", vt(), pg();
        },
        unstable_isNewReconciler: T
      }, Zs = {
        readContext: function(n) {
          return jv(), da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", cn(), Qn(), Gv(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", cn(), Qn(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", cn(), Qn(), sg(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", cn(), Qn(), Hv(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", cn(), Qn(), Uv(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", cn(), Qn(), Iv(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", cn(), Qn();
          var c = At.current;
          At.current = Zs;
          try {
            return Vv(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", cn(), Qn();
          var p = At.current;
          At.current = Zs;
          try {
            return Pv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", cn(), Qn(), Bv(n);
        },
        useState: function(n) {
          Ye = "useState", cn(), Qn();
          var a = At.current;
          At.current = Zs;
          try {
            return ag(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", cn(), Qn(), void 0;
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", cn(), Qn(), qv(n);
        },
        useTransition: function() {
          return Ye = "useTransition", cn(), Qn(), Wv();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", cn(), Qn(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", cn(), Qn(), Ov(n, a, c);
        },
        useId: function() {
          return Ye = "useId", cn(), Qn(), Kv();
        },
        unstable_isNewReconciler: T
      }, bs = {
        readContext: function(n) {
          return jv(), da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", cn(), vt(), fg(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", cn(), vt(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", cn(), vt(), Eh(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", cn(), vt(), cg(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", cn(), vt(), lg(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", cn(), vt(), ug(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", cn(), vt();
          var c = At.current;
          At.current = bs;
          try {
            return hg(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", cn(), vt();
          var p = At.current;
          At.current = bs;
          try {
            return Dv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", cn(), vt(), ig();
        },
        useState: function(n) {
          Ye = "useState", cn(), vt();
          var a = At.current;
          At.current = bs;
          try {
            return Fv(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", cn(), vt(), dg();
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", cn(), vt(), r_(n);
        },
        useTransition: function() {
          return Ye = "useTransition", cn(), vt(), o_();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", cn(), vt(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", cn(), vt(), rg(n, a);
        },
        useId: function() {
          return Ye = "useId", cn(), vt(), pg();
        },
        unstable_isNewReconciler: T
      }, gg = {
        readContext: function(n) {
          return jv(), da(n);
        },
        useCallback: function(n, a) {
          return Ye = "useCallback", cn(), vt(), fg(n, a);
        },
        useContext: function(n) {
          return Ye = "useContext", cn(), vt(), da(n);
        },
        useEffect: function(n, a) {
          return Ye = "useEffect", cn(), vt(), Eh(n, a);
        },
        useImperativeHandle: function(n, a, c) {
          return Ye = "useImperativeHandle", cn(), vt(), cg(n, a, c);
        },
        useInsertionEffect: function(n, a) {
          return Ye = "useInsertionEffect", cn(), vt(), lg(n, a);
        },
        useLayoutEffect: function(n, a) {
          return Ye = "useLayoutEffect", cn(), vt(), ug(n, a);
        },
        useMemo: function(n, a) {
          Ye = "useMemo", cn(), vt();
          var c = At.current;
          At.current = bs;
          try {
            return hg(n, a);
          } finally {
            At.current = c;
          }
        },
        useReducer: function(n, a, c) {
          Ye = "useReducer", cn(), vt();
          var p = At.current;
          At.current = bs;
          try {
            return Lv(n, a, c);
          } finally {
            At.current = p;
          }
        },
        useRef: function(n) {
          return Ye = "useRef", cn(), vt(), ig();
        },
        useState: function(n) {
          Ye = "useState", cn(), vt();
          var a = At.current;
          At.current = bs;
          try {
            return zv(n);
          } finally {
            At.current = a;
          }
        },
        useDebugValue: function(n, a) {
          return Ye = "useDebugValue", cn(), vt(), dg();
        },
        useDeferredValue: function(n) {
          return Ye = "useDeferredValue", cn(), vt(), a_(n);
        },
        useTransition: function() {
          return Ye = "useTransition", cn(), vt(), s_();
        },
        useMutableSource: function(n, a, c) {
          return Ye = "useMutableSource", cn(), vt(), void 0;
        },
        useSyncExternalStore: function(n, a, c) {
          return Ye = "useSyncExternalStore", cn(), vt(), rg(n, a);
        },
        useId: function() {
          return Ye = "useId", cn(), vt(), pg();
        },
        unstable_isNewReconciler: T
      };
    }
    var Mu = l.unstable_now, v_ = 0, vg = -1, Rh = -1, yg = -1, Yv = !1, bg = !1;
    function y_() {
      return Yv;
    }
    function I8() {
      bg = !0;
    }
    function H8() {
      Yv = !1, bg = !1;
    }
    function G8() {
      Yv = bg, bg = !1;
    }
    function b_() {
      return v_;
    }
    function __() {
      v_ = Mu();
    }
    function Zv(n) {
      Rh = Mu(), n.actualStartTime < 0 && (n.actualStartTime = Mu());
    }
    function S_(n) {
      Rh = -1;
    }
    function _g(n, a) {
      if (Rh >= 0) {
        var c = Mu() - Rh;
        n.actualDuration += c, a && (n.selfBaseDuration = c), Rh = -1;
      }
    }
    function Xs(n) {
      if (vg >= 0) {
        var a = Mu() - vg;
        vg = -1;
        for (var c = n.return; c !== null; ) {
          switch (c.tag) {
            case I:
              var p = c.stateNode;
              p.effectDuration += a;
              return;
            case W:
              var b = c.stateNode;
              b.effectDuration += a;
              return;
          }
          c = c.return;
        }
      }
    }
    function Xv(n) {
      if (yg >= 0) {
        var a = Mu() - yg;
        yg = -1;
        for (var c = n.return; c !== null; ) {
          switch (c.tag) {
            case I:
              var p = c.stateNode;
              p !== null && (p.passiveEffectDuration += a);
              return;
            case W:
              var b = c.stateNode;
              b !== null && (b.passiveEffectDuration += a);
              return;
          }
          c = c.return;
        }
      }
    }
    function Qs() {
      vg = Mu();
    }
    function Qv() {
      yg = Mu();
    }
    function Jv(n) {
      for (var a = n.child; a; )
        n.actualDuration += a.actualDuration, a = a.sibling;
    }
    function _s(n, a) {
      if (n && n.defaultProps) {
        var c = E({}, a), p = n.defaultProps;
        for (var b in p)
          c[b] === void 0 && (c[b] = p[b]);
        return c;
      }
      return a;
    }
    var $v = {}, e1, t1, n1, r1, a1, w_, Sg, i1, o1, s1, Th;
    {
      e1 = /* @__PURE__ */ new Set(), t1 = /* @__PURE__ */ new Set(), n1 = /* @__PURE__ */ new Set(), r1 = /* @__PURE__ */ new Set(), i1 = /* @__PURE__ */ new Set(), a1 = /* @__PURE__ */ new Set(), o1 = /* @__PURE__ */ new Set(), s1 = /* @__PURE__ */ new Set(), Th = /* @__PURE__ */ new Set();
      var x_ = /* @__PURE__ */ new Set();
      Sg = function(n, a) {
        if (!(n === null || typeof n == "function")) {
          var c = a + "_" + n;
          x_.has(c) || (x_.add(c), h("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", a, n));
        }
      }, w_ = function(n, a) {
        if (a === void 0) {
          var c = Ft(n) || "Component";
          a1.has(c) || (a1.add(c), h("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", c));
        }
      }, Object.defineProperty($v, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze($v);
    }
    function l1(n, a, c, p) {
      var b = n.memoizedState, N = c(p, b);
      {
        if (n.mode & Ot) {
          Gr(!0);
          try {
            N = c(p, b);
          } finally {
            Gr(!1);
          }
        }
        w_(a, N);
      }
      var G = N == null ? b : E({}, b, N);
      if (n.memoizedState = G, n.lanes === Ke) {
        var Y = n.updateQueue;
        Y.baseState = G;
      }
    }
    var u1 = {
      isMounted: oo,
      enqueueSetState: function(n, a, c) {
        var p = S(n), b = xi(), N = Lu(p), G = Il(b, N);
        G.payload = a, c != null && (Sg(c, "setState"), G.callback = c);
        var Y = Ru(p, G, N);
        Y !== null && (ha(Y, p, N, b), Xm(Y, p, N)), Ec(p, N);
      },
      enqueueReplaceState: function(n, a, c) {
        var p = S(n), b = xi(), N = Lu(p), G = Il(b, N);
        G.tag = Hb, G.payload = a, c != null && (Sg(c, "replaceState"), G.callback = c);
        var Y = Ru(p, G, N);
        Y !== null && (ha(Y, p, N, b), Xm(Y, p, N)), Ec(p, N);
      },
      enqueueForceUpdate: function(n, a) {
        var c = S(n), p = xi(), b = Lu(c), N = Il(p, b);
        N.tag = jm, a != null && (Sg(a, "forceUpdate"), N.callback = a);
        var G = Ru(c, N, b);
        G !== null && (ha(G, c, b, p), Xm(G, c, b)), Vd(c, b);
      }
    };
    function k_(n, a, c, p, b, N, G) {
      var Y = n.stateNode;
      if (typeof Y.shouldComponentUpdate == "function") {
        var $ = Y.shouldComponentUpdate(p, N, G);
        {
          if (n.mode & Ot) {
            Gr(!0);
            try {
              $ = Y.shouldComponentUpdate(p, N, G);
            } finally {
              Gr(!1);
            }
          }
          $ === void 0 && h("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", Ft(a) || "Component");
        }
        return $;
      }
      return a.prototype && a.prototype.isPureReactComponent ? !ne(c, p) || !ne(b, N) : !0;
    }
    function V8(n, a, c) {
      var p = n.stateNode;
      {
        var b = Ft(a) || "Component", N = p.render;
        N || (a.prototype && typeof a.prototype.render == "function" ? h("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", b) : h("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", b)), p.getInitialState && !p.getInitialState.isReactClassApproved && !p.state && h("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", b), p.getDefaultProps && !p.getDefaultProps.isReactClassApproved && h("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", b), p.propTypes && h("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", b), p.contextType && h("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", b), a.childContextTypes && !Th.has(a) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & Ot) === De && (Th.add(a), h(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, b)), a.contextTypes && !Th.has(a) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (n.mode & Ot) === De && (Th.add(a), h(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, b)), p.contextTypes && h("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", b), a.contextType && a.contextTypes && !o1.has(a) && (o1.add(a), h("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", b)), typeof p.componentShouldUpdate == "function" && h("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", b), a.prototype && a.prototype.isPureReactComponent && typeof p.shouldComponentUpdate < "u" && h("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", Ft(a) || "A pure component"), typeof p.componentDidUnmount == "function" && h("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", b), typeof p.componentDidReceiveProps == "function" && h("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", b), typeof p.componentWillRecieveProps == "function" && h("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", b), typeof p.UNSAFE_componentWillRecieveProps == "function" && h("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", b);
        var G = p.props !== c;
        p.props !== void 0 && G && h("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", b, b), p.defaultProps && h("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", b, b), typeof p.getSnapshotBeforeUpdate == "function" && typeof p.componentDidUpdate != "function" && !n1.has(a) && (n1.add(a), h("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", Ft(a))), typeof p.getDerivedStateFromProps == "function" && h("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof p.getDerivedStateFromError == "function" && h("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", b), typeof a.getSnapshotBeforeUpdate == "function" && h("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", b);
        var Y = p.state;
        Y && (typeof Y != "object" || wr(Y)) && h("%s.state: must be set to an object or null", b), typeof p.getChildContext == "function" && typeof a.childContextTypes != "object" && h("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", b);
      }
    }
    function C_(n, a) {
      a.updater = u1, n.stateNode = a, w(a, n), a._reactInternalInstance = $v;
    }
    function E_(n, a, c) {
      var p = !1, b = ke, N = ke, G = a.contextType;
      if ("contextType" in a) {
        var Y = (
          // Allow null for conditional declaration
          G === null || G !== void 0 && G.$$typeof === qn && G._context === void 0
        );
        if (!Y && !s1.has(a)) {
          s1.add(a);
          var $ = "";
          G === void 0 ? $ = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof G != "object" ? $ = " However, it is set to a " + typeof G + "." : G.$$typeof === Lt ? $ = " Did you accidentally pass the Context.Provider instead?" : G._context !== void 0 ? $ = " Did you accidentally pass the Context.Consumer instead?" : $ = " However, it is set to an object with keys {" + Object.keys(G).join(", ") + "}.", h("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", Ft(a) || "Component", $);
        }
      }
      if (typeof G == "object" && G !== null)
        N = da(G);
      else {
        b = ve(n, a, !0);
        var se = a.contextTypes;
        p = se != null, N = p ? Se(n, b) : ke;
      }
      var he = new a(c, N);
      if (n.mode & Ot) {
        Gr(!0);
        try {
          he = new a(c, N);
        } finally {
          Gr(!1);
        }
      }
      var Ae = n.memoizedState = he.state !== null && he.state !== void 0 ? he.state : null;
      C_(n, he);
      {
        if (typeof a.getDerivedStateFromProps == "function" && Ae === null) {
          var He = Ft(a) || "Component";
          t1.has(He) || (t1.add(He), h("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", He, he.state === null ? "null" : "undefined", He));
        }
        if (typeof a.getDerivedStateFromProps == "function" || typeof he.getSnapshotBeforeUpdate == "function") {
          var Ze = null, at = null, $e = null;
          if (typeof he.componentWillMount == "function" && he.componentWillMount.__suppressDeprecationWarning !== !0 ? Ze = "componentWillMount" : typeof he.UNSAFE_componentWillMount == "function" && (Ze = "UNSAFE_componentWillMount"), typeof he.componentWillReceiveProps == "function" && he.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? at = "componentWillReceiveProps" : typeof he.UNSAFE_componentWillReceiveProps == "function" && (at = "UNSAFE_componentWillReceiveProps"), typeof he.componentWillUpdate == "function" && he.componentWillUpdate.__suppressDeprecationWarning !== !0 ? $e = "componentWillUpdate" : typeof he.UNSAFE_componentWillUpdate == "function" && ($e = "UNSAFE_componentWillUpdate"), Ze !== null || at !== null || $e !== null) {
            var Bt = Ft(a) || "Component", nn = typeof a.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            r1.has(Bt) || (r1.add(Bt), h(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Bt, nn, Ze !== null ? `
  ` + Ze : "", at !== null ? `
  ` + at : "", $e !== null ? `
  ` + $e : ""));
          }
        }
      }
      return p && ge(n, b, N), he;
    }
    function q8(n, a) {
      var c = a.state;
      typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), c !== a.state && (h("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", qe(n) || "Component"), u1.enqueueReplaceState(a, a.state, null));
    }
    function R_(n, a, c, p) {
      var b = a.state;
      if (typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(c, p), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(c, p), a.state !== b) {
        {
          var N = qe(n) || "Component";
          e1.has(N) || (e1.add(N), h("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", N));
        }
        u1.enqueueReplaceState(a, a.state, null);
      }
    }
    function c1(n, a, c, p) {
      V8(n, a, c);
      var b = n.stateNode;
      b.props = c, b.state = n.memoizedState, b.refs = {}, bv(n);
      var N = a.contextType;
      if (typeof N == "object" && N !== null)
        b.context = da(N);
      else {
        var G = ve(n, a, !0);
        b.context = Se(n, G);
      }
      {
        if (b.state === c) {
          var Y = Ft(a) || "Component";
          i1.has(Y) || (i1.add(Y), h("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", Y));
        }
        n.mode & Ot && xe.recordLegacyContextWarning(n, b), xe.recordUnsafeLifecycleWarnings(n, b);
      }
      b.state = n.memoizedState;
      var $ = a.getDerivedStateFromProps;
      if (typeof $ == "function" && (l1(n, a, $, c), b.state = n.memoizedState), typeof a.getDerivedStateFromProps != "function" && typeof b.getSnapshotBeforeUpdate != "function" && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (q8(n, b), Qm(n, c, b, p), b.state = n.memoizedState), typeof b.componentDidMount == "function") {
        var se = Xe;
        se |= yn, (n.mode & tn) !== De && (se |= Nr), n.flags |= se;
      }
    }
    function W8(n, a, c, p) {
      var b = n.stateNode, N = n.memoizedProps;
      b.props = N;
      var G = b.context, Y = a.contextType, $ = ke;
      if (typeof Y == "object" && Y !== null)
        $ = da(Y);
      else {
        var se = ve(n, a, !0);
        $ = Se(n, se);
      }
      var he = a.getDerivedStateFromProps, Ae = typeof he == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      !Ae && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (N !== c || G !== $) && R_(n, b, c, $), Vb();
      var He = n.memoizedState, Ze = b.state = He;
      if (Qm(n, c, b, p), Ze = n.memoizedState, N === c && He === Ze && !we() && !Jm()) {
        if (typeof b.componentDidMount == "function") {
          var at = Xe;
          at |= yn, (n.mode & tn) !== De && (at |= Nr), n.flags |= at;
        }
        return !1;
      }
      typeof he == "function" && (l1(n, a, he, c), Ze = n.memoizedState);
      var $e = Jm() || k_(n, a, N, c, He, Ze, $);
      if ($e) {
        if (!Ae && (typeof b.UNSAFE_componentWillMount == "function" || typeof b.componentWillMount == "function") && (typeof b.componentWillMount == "function" && b.componentWillMount(), typeof b.UNSAFE_componentWillMount == "function" && b.UNSAFE_componentWillMount()), typeof b.componentDidMount == "function") {
          var Bt = Xe;
          Bt |= yn, (n.mode & tn) !== De && (Bt |= Nr), n.flags |= Bt;
        }
      } else {
        if (typeof b.componentDidMount == "function") {
          var nn = Xe;
          nn |= yn, (n.mode & tn) !== De && (nn |= Nr), n.flags |= nn;
        }
        n.memoizedProps = c, n.memoizedState = Ze;
      }
      return b.props = c, b.state = Ze, b.context = $, $e;
    }
    function K8(n, a, c, p, b) {
      var N = a.stateNode;
      Gb(n, a);
      var G = a.memoizedProps, Y = a.type === a.elementType ? G : _s(a.type, G);
      N.props = Y;
      var $ = a.pendingProps, se = N.context, he = c.contextType, Ae = ke;
      if (typeof he == "object" && he !== null)
        Ae = da(he);
      else {
        var He = ve(a, c, !0);
        Ae = Se(a, He);
      }
      var Ze = c.getDerivedStateFromProps, at = typeof Ze == "function" || typeof N.getSnapshotBeforeUpdate == "function";
      !at && (typeof N.UNSAFE_componentWillReceiveProps == "function" || typeof N.componentWillReceiveProps == "function") && (G !== $ || se !== Ae) && R_(a, N, p, Ae), Vb();
      var $e = a.memoizedState, Bt = N.state = $e;
      if (Qm(a, p, N, b), Bt = a.memoizedState, G === $ && $e === Bt && !we() && !Jm() && !P)
        return typeof N.componentDidUpdate == "function" && (G !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= Xe), typeof N.getSnapshotBeforeUpdate == "function" && (G !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= Zr), !1;
      typeof Ze == "function" && (l1(a, c, Ze, p), Bt = a.memoizedState);
      var nn = Jm() || k_(a, c, Y, p, $e, Bt, Ae) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      P;
      return nn ? (!at && (typeof N.UNSAFE_componentWillUpdate == "function" || typeof N.componentWillUpdate == "function") && (typeof N.componentWillUpdate == "function" && N.componentWillUpdate(p, Bt, Ae), typeof N.UNSAFE_componentWillUpdate == "function" && N.UNSAFE_componentWillUpdate(p, Bt, Ae)), typeof N.componentDidUpdate == "function" && (a.flags |= Xe), typeof N.getSnapshotBeforeUpdate == "function" && (a.flags |= Zr)) : (typeof N.componentDidUpdate == "function" && (G !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= Xe), typeof N.getSnapshotBeforeUpdate == "function" && (G !== n.memoizedProps || $e !== n.memoizedState) && (a.flags |= Zr), a.memoizedProps = p, a.memoizedState = Bt), N.props = p, N.state = Bt, N.context = Ae, nn;
    }
    function Lc(n, a) {
      return {
        value: n,
        source: a,
        stack: Ie(a),
        digest: null
      };
    }
    function d1(n, a, c) {
      return {
        value: n,
        source: null,
        stack: c ?? null,
        digest: a ?? null
      };
    }
    function j8(n, a) {
      return !0;
    }
    function f1(n, a) {
      try {
        var c = j8(n, a);
        if (c === !1)
          return;
        var p = a.value, b = a.source, N = a.stack, G = N !== null ? N : "";
        if (p != null && p._suppressLogging) {
          if (n.tag === q)
            return;
          console.error(p);
        }
        var Y = b ? qe(b) : null, $ = Y ? "The above error occurred in the <" + Y + "> component:" : "The above error occurred in one of your React components:", se;
        if (n.tag === I)
          se = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var he = qe(n) || "Anonymous";
          se = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + he + ".");
        }
        var Ae = $ + `
` + G + `

` + ("" + se);
        console.error(Ae);
      } catch (He) {
        setTimeout(function() {
          throw He;
        });
      }
    }
    var Y8 = typeof WeakMap == "function" ? WeakMap : Map;
    function T_(n, a, c) {
      var p = Il(fr, c);
      p.tag = vv, p.payload = {
        element: null
      };
      var b = a.value;
      return p.callback = function() {
        r9(b), f1(n, a);
      }, p;
    }
    function h1(n, a, c) {
      var p = Il(fr, c);
      p.tag = vv;
      var b = n.type.getDerivedStateFromError;
      if (typeof b == "function") {
        var N = a.value;
        p.payload = function() {
          return b(N);
        }, p.callback = function() {
          I5(n), f1(n, a);
        };
      }
      var G = n.stateNode;
      return G !== null && typeof G.componentDidCatch == "function" && (p.callback = function() {
        I5(n), f1(n, a), typeof b != "function" && t9(this);
        var $ = a.value, se = a.stack;
        this.componentDidCatch($, {
          componentStack: se !== null ? se : ""
        }), typeof b != "function" && (Ua(n.lanes, jt) || h("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", qe(n) || "Unknown"));
      }), p;
    }
    function N_(n, a, c) {
      var p = n.pingCache, b;
      if (p === null ? (p = n.pingCache = new Y8(), b = /* @__PURE__ */ new Set(), p.set(a, b)) : (b = p.get(a), b === void 0 && (b = /* @__PURE__ */ new Set(), p.set(a, b))), !b.has(c)) {
        b.add(c);
        var N = a9.bind(null, n, a, c);
        vi && jh(n, c), a.then(N, N);
      }
    }
    function Z8(n, a, c, p) {
      var b = n.updateQueue;
      if (b === null) {
        var N = /* @__PURE__ */ new Set();
        N.add(c), n.updateQueue = N;
      } else
        b.add(c);
    }
    function X8(n, a) {
      var c = n.tag;
      if ((n.mode & ht) === De && (c === B || c === ze || c === Q)) {
        var p = n.alternate;
        p ? (n.updateQueue = p.updateQueue, n.memoizedState = p.memoizedState, n.lanes = p.lanes) : (n.updateQueue = null, n.memoizedState = null);
      }
    }
    function A_(n) {
      var a = n;
      do {
        if (a.tag === j && A8(a))
          return a;
        a = a.return;
      } while (a !== null);
      return null;
    }
    function M_(n, a, c, p, b) {
      if ((n.mode & ht) === De) {
        if (n === a)
          n.flags |= Et;
        else {
          if (n.flags |= xt, c.flags |= Xn, c.flags &= -52805, c.tag === q) {
            var N = c.alternate;
            if (N === null)
              c.tag = ye;
            else {
              var G = Il(fr, jt);
              G.tag = jm, Ru(c, G, jt);
            }
          }
          c.lanes = fn(c.lanes, jt);
        }
        return n;
      }
      return n.flags |= Et, n.lanes = b, n;
    }
    function Q8(n, a, c, p, b) {
      if (c.flags |= kt, vi && jh(n, b), p !== null && typeof p == "object" && typeof p.then == "function") {
        var N = p;
        X8(c), s() && c.mode & ht && Lm();
        var G = A_(a);
        if (G !== null) {
          G.flags &= ~zn, M_(G, a, c, n, b), G.mode & ht && N_(n, N, b), Z8(G, n, N);
          return;
        } else {
          if (!$f(b)) {
            N_(n, N, b), X1();
            return;
          }
          var Y = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          p = Y;
        }
      } else if (s() && c.mode & ht) {
        Lm();
        var $ = A_(a);
        if ($ !== null) {
          ($.flags & Et) === gt && ($.flags |= zn), M_($, a, c, n, b), y(Lc(p, c));
          return;
        }
      }
      p = Lc(p, c), jC(p);
      var se = a;
      do {
        switch (se.tag) {
          case I: {
            var he = p;
            se.flags |= Et;
            var Ae = yu(b);
            se.lanes = fn(se.lanes, Ae);
            var He = T_(se, he, Ae);
            _v(se, He);
            return;
          }
          case q:
            var Ze = p, at = se.type, $e = se.stateNode;
            if ((se.flags & xt) === gt && (typeof at.getDerivedStateFromError == "function" || $e !== null && typeof $e.componentDidCatch == "function" && !M5($e))) {
              se.flags |= Et;
              var Bt = yu(b);
              se.lanes = fn(se.lanes, Bt);
              var nn = h1(se, Ze, Bt);
              _v(se, nn);
              return;
            }
            break;
        }
        se = se.return;
      } while (se !== null);
    }
    function J8() {
      return null;
    }
    var Nh = u.ReactCurrentOwner, Ss = !1, p1, Ah, m1, g1, v1, Oc, y1, wg, Mh;
    p1 = {}, Ah = {}, m1 = {}, g1 = {}, v1 = {}, Oc = !1, y1 = {}, wg = {}, Mh = {};
    function Ui(n, a, c, p) {
      n === null ? a.child = Ob(a, null, c, p) : a.child = Jd(a, n.child, c, p);
    }
    function $8(n, a, c, p) {
      a.child = Jd(a, n.child, null, p), a.child = Jd(a, null, c, p);
    }
    function P_(n, a, c, p, b) {
      if (a.type !== a.elementType) {
        var N = c.propTypes;
        N && _(
          N,
          p,
          // Resolved props
          "prop",
          Ft(c)
        );
      }
      var G = c.render, Y = a.ref, $, se;
      ef(a, b), Gs(a);
      {
        if (Nh.current = a, Le(!0), $ = sf(n, a, G, p, Y, b), se = lf(), a.mode & Ot) {
          Gr(!0);
          try {
            $ = sf(n, a, G, p, Y, b), se = lf();
          } finally {
            Gr(!1);
          }
        }
        Le(!1);
      }
      return Vs(), n !== null && !Ss ? (Yb(n, a, b), Hl(n, a, b)) : (s() && se && ku(a), a.flags |= Dn, Ui(n, a, $, b), a.child);
    }
    function D_(n, a, c, p, b) {
      if (n === null) {
        var N = c.type;
        if (S9(N) && c.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        c.defaultProps === void 0) {
          var G = N;
          return G = gf(N), a.tag = Q, a.type = G, S1(a, N), L_(n, a, G, p, b);
        }
        {
          var Y = N.propTypes;
          if (Y && _(
            Y,
            p,
            // Resolved props
            "prop",
            Ft(N)
          ), c.defaultProps !== void 0) {
            var $ = Ft(N) || "Unknown";
            Mh[$] || (h("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", $), Mh[$] = !0);
          }
        }
        var se = oy(c.type, null, p, a, a.mode, b);
        return se.ref = a.ref, se.return = a, a.child = se, se;
      }
      {
        var he = c.type, Ae = he.propTypes;
        Ae && _(
          Ae,
          p,
          // Resolved props
          "prop",
          Ft(he)
        );
      }
      var He = n.child, Ze = R1(n, b);
      if (!Ze) {
        var at = He.memoizedProps, $e = c.compare;
        if ($e = $e !== null ? $e : ne, $e(at, p) && n.ref === a.ref)
          return Hl(n, a, b);
      }
      a.flags |= Dn;
      var Bt = Ic(He, p);
      return Bt.ref = a.ref, Bt.return = a, a.child = Bt, Bt;
    }
    function L_(n, a, c, p, b) {
      if (a.type !== a.elementType) {
        var N = a.elementType;
        if (N.$$typeof === gn) {
          var G = N, Y = G._payload, $ = G._init;
          try {
            N = $(Y);
          } catch {
            N = null;
          }
          var se = N && N.propTypes;
          se && _(
            se,
            p,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            Ft(N)
          );
        }
      }
      if (n !== null) {
        var he = n.memoizedProps;
        if (ne(he, p) && n.ref === a.ref && // Prevent bailout if the implementation changed due to hot reload.
        a.type === n.type)
          if (Ss = !1, a.pendingProps = p = he, R1(n, b))
            (n.flags & Xn) !== gt && (Ss = !0);
          else return a.lanes = n.lanes, Hl(n, a, b);
      }
      return b1(n, a, c, p, b);
    }
    function O_(n, a, c) {
      var p = a.pendingProps, b = p.children, N = n !== null ? n.memoizedState : null;
      if (p.mode === "hidden" || z)
        if ((a.mode & ht) === De) {
          var G = {
            baseLanes: Ke,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = G, Kg(a, c);
        } else if (Ua(c, mi)) {
          var Ae = {
            baseLanes: Ke,
            cachePool: null,
            transitions: null
          };
          a.memoizedState = Ae;
          var He = N !== null ? N.baseLanes : c;
          Kg(a, He);
        } else {
          var Y = null, $;
          if (N !== null) {
            var se = N.baseLanes;
            $ = fn(se, c);
          } else
            $ = c;
          a.lanes = a.childLanes = mi;
          var he = {
            baseLanes: $,
            cachePool: Y,
            transitions: null
          };
          return a.memoizedState = he, a.updateQueue = null, Kg(a, $), null;
        }
      else {
        var Ze;
        N !== null ? (Ze = fn(N.baseLanes, c), a.memoizedState = null) : Ze = c, Kg(a, Ze);
      }
      return Ui(n, a, b, c), a.child;
    }
    function ek(n, a, c) {
      var p = a.pendingProps;
      return Ui(n, a, p, c), a.child;
    }
    function tk(n, a, c) {
      var p = a.pendingProps.children;
      return Ui(n, a, p, c), a.child;
    }
    function nk(n, a, c) {
      {
        a.flags |= Xe;
        {
          var p = a.stateNode;
          p.effectDuration = 0, p.passiveEffectDuration = 0;
        }
      }
      var b = a.pendingProps, N = b.children;
      return Ui(n, a, N, c), a.child;
    }
    function F_(n, a) {
      var c = a.ref;
      (n === null && c !== null || n !== null && n.ref !== c) && (a.flags |= aa, a.flags |= Vt);
    }
    function b1(n, a, c, p, b) {
      if (a.type !== a.elementType) {
        var N = c.propTypes;
        N && _(
          N,
          p,
          // Resolved props
          "prop",
          Ft(c)
        );
      }
      var G;
      {
        var Y = ve(a, c, !0);
        G = Se(a, Y);
      }
      var $, se;
      ef(a, b), Gs(a);
      {
        if (Nh.current = a, Le(!0), $ = sf(n, a, c, p, G, b), se = lf(), a.mode & Ot) {
          Gr(!0);
          try {
            $ = sf(n, a, c, p, G, b), se = lf();
          } finally {
            Gr(!1);
          }
        }
        Le(!1);
      }
      return Vs(), n !== null && !Ss ? (Yb(n, a, b), Hl(n, a, b)) : (s() && se && ku(a), a.flags |= Dn, Ui(n, a, $, b), a.child);
    }
    function z_(n, a, c, p, b) {
      {
        switch (Z5(a)) {
          case !1: {
            var N = a.stateNode, G = a.type, Y = new G(a.memoizedProps, N.context), $ = Y.state;
            N.updater.enqueueSetState(N, $, null);
            break;
          }
          case !0: {
            a.flags |= xt, a.flags |= Et;
            var se = new Error("Simulated error coming from DevTools"), he = yu(b);
            a.lanes = fn(a.lanes, he);
            var Ae = h1(a, Lc(se, a), he);
            _v(a, Ae);
            break;
          }
        }
        if (a.type !== a.elementType) {
          var He = c.propTypes;
          He && _(
            He,
            p,
            // Resolved props
            "prop",
            Ft(c)
          );
        }
      }
      var Ze;
      Te(c) ? (Ze = !0, lt(a)) : Ze = !1, ef(a, b);
      var at = a.stateNode, $e;
      at === null ? (kg(n, a), E_(a, c, p), c1(a, c, p, b), $e = !0) : n === null ? $e = W8(a, c, p, b) : $e = K8(n, a, c, p, b);
      var Bt = _1(n, a, c, $e, Ze, b);
      {
        var nn = a.stateNode;
        $e && nn.props !== p && (Oc || h("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", qe(a) || "a component"), Oc = !0);
      }
      return Bt;
    }
    function _1(n, a, c, p, b, N) {
      F_(n, a);
      var G = (a.flags & xt) !== gt;
      if (!p && !G)
        return b && tt(a, c, !1), Hl(n, a, N);
      var Y = a.stateNode;
      Nh.current = a;
      var $;
      if (G && typeof c.getDerivedStateFromError != "function")
        $ = null, S_();
      else {
        Gs(a);
        {
          if (Le(!0), $ = Y.render(), a.mode & Ot) {
            Gr(!0);
            try {
              Y.render();
            } finally {
              Gr(!1);
            }
          }
          Le(!1);
        }
        Vs();
      }
      return a.flags |= Dn, n !== null && G ? $8(n, a, $, N) : Ui(n, a, $, N), a.memoizedState = Y.state, b && tt(a, c, !0), a.child;
    }
    function B_(n) {
      var a = n.stateNode;
      a.pendingContext ? Je(n, a.pendingContext, a.pendingContext !== a.context) : a.context && Je(n, a.context, !1), wv(n, a.containerInfo);
    }
    function rk(n, a, c) {
      if (B_(a), n === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var p = a.pendingProps, b = a.memoizedState, N = b.element;
      Gb(n, a), Qm(a, p, null, c);
      var G = a.memoizedState;
      a.stateNode;
      var Y = G.element;
      if (sa && b.isDehydrated) {
        var $ = {
          element: Y,
          isDehydrated: !1,
          cache: G.cache,
          pendingSuspenseBoundaries: G.pendingSuspenseBoundaries,
          transitions: G.transitions
        }, se = a.updateQueue;
        if (se.baseState = $, a.memoizedState = $, a.flags & zn) {
          var he = Lc(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), a);
          return U_(n, a, Y, c, he);
        } else if (Y !== N) {
          var Ae = Lc(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), a);
          return U_(n, a, Y, c, Ae);
        } else {
          Fm(a);
          var He = Ob(a, null, Y, c);
          a.child = He;
          for (var Ze = He; Ze; )
            Ze.flags = Ze.flags & ~Tn | Xr, Ze = Ze.sibling;
        }
      } else {
        if (Eu(), Y === N)
          return Hl(n, a, c);
        Ui(n, a, Y, c);
      }
      return a.child;
    }
    function U_(n, a, c, p, b) {
      return Eu(), y(b), a.flags |= zn, Ui(n, a, c, p), a.child;
    }
    function ak(n, a, c) {
      Wb(a), n === null && Ac(a);
      var p = a.type, b = a.pendingProps, N = n !== null ? n.memoizedProps : null, G = b.children, Y = Wn(p, b);
      return Y ? G = null : N !== null && Wn(p, N) && (a.flags |= _t), F_(n, a), Ui(n, a, G, c), a.child;
    }
    function ik(n, a) {
      return n === null && Ac(a), null;
    }
    function ok(n, a, c, p) {
      kg(n, a);
      var b = a.pendingProps, N = c, G = N._payload, Y = N._init, $ = Y(G);
      a.type = $;
      var se = a.tag = w9($), he = _s($, b), Ae;
      switch (se) {
        case B:
          return S1(a, $), a.type = $ = gf($), Ae = b1(null, a, $, he, p), Ae;
        case q:
          return a.type = $ = ey($), Ae = z_(null, a, $, he, p), Ae;
        case ze:
          return a.type = $ = ty($), Ae = P_(null, a, $, he, p), Ae;
        case ee: {
          if (a.type !== a.elementType) {
            var He = $.propTypes;
            He && _(
              He,
              he,
              // Resolved for outer only
              "prop",
              Ft($)
            );
          }
          return Ae = D_(
            null,
            a,
            $,
            _s($.type, he),
            // The inner type can have defaults too
            p
          ), Ae;
        }
      }
      var Ze = "";
      throw $ !== null && typeof $ == "object" && $.$$typeof === gn && (Ze = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + $ + ". " + ("Lazy element type must resolve to a class or function." + Ze));
    }
    function sk(n, a, c, p, b) {
      kg(n, a), a.tag = q;
      var N;
      return Te(c) ? (N = !0, lt(a)) : N = !1, ef(a, b), E_(a, c, p), c1(a, c, p, b), _1(null, a, c, !0, N, b);
    }
    function lk(n, a, c, p) {
      kg(n, a);
      var b = a.pendingProps, N;
      {
        var G = ve(a, c, !1);
        N = Se(a, G);
      }
      ef(a, p);
      var Y, $;
      Gs(a);
      {
        if (c.prototype && typeof c.prototype.render == "function") {
          var se = Ft(c) || "Unknown";
          p1[se] || (h("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", se, se), p1[se] = !0);
        }
        a.mode & Ot && xe.recordLegacyContextWarning(a, null), Le(!0), Nh.current = a, Y = sf(null, a, c, b, N, p), $ = lf(), Le(!1);
      }
      if (Vs(), a.flags |= Dn, typeof Y == "object" && Y !== null && typeof Y.render == "function" && Y.$$typeof === void 0) {
        var he = Ft(c) || "Unknown";
        Ah[he] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", he, he, he), Ah[he] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof Y == "object" && Y !== null && typeof Y.render == "function" && Y.$$typeof === void 0
      ) {
        {
          var Ae = Ft(c) || "Unknown";
          Ah[Ae] || (h("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Ae, Ae, Ae), Ah[Ae] = !0);
        }
        a.tag = q, a.memoizedState = null, a.updateQueue = null;
        var He = !1;
        return Te(c) ? (He = !0, lt(a)) : He = !1, a.memoizedState = Y.state !== null && Y.state !== void 0 ? Y.state : null, bv(a), C_(a, Y), c1(a, c, b, p), _1(null, a, c, !0, He, p);
      } else {
        if (a.tag = B, a.mode & Ot) {
          Gr(!0);
          try {
            Y = sf(null, a, c, b, N, p), $ = lf();
          } finally {
            Gr(!1);
          }
        }
        return s() && $ && ku(a), Ui(null, a, Y, p), S1(a, c), a.child;
      }
    }
    function S1(n, a) {
      {
        if (a && a.childContextTypes && h("%s(...): childContextTypes cannot be defined on a function component.", a.displayName || a.name || "Component"), n.ref !== null) {
          var c = "", p = Nt();
          p && (c += `

Check the render method of \`` + p + "`.");
          var b = p || "", N = n._debugSource;
          N && (b = N.fileName + ":" + N.lineNumber), v1[b] || (v1[b] = !0, h("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", c));
        }
        if (a.defaultProps !== void 0) {
          var G = Ft(a) || "Unknown";
          Mh[G] || (h("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", G), Mh[G] = !0);
        }
        if (typeof a.getDerivedStateFromProps == "function") {
          var Y = Ft(a) || "Unknown";
          g1[Y] || (h("%s: Function components do not support getDerivedStateFromProps.", Y), g1[Y] = !0);
        }
        if (typeof a.contextType == "object" && a.contextType !== null) {
          var $ = Ft(a) || "Unknown";
          m1[$] || (h("%s: Function components do not support contextType.", $), m1[$] = !0);
        }
      }
    }
    var w1 = {
      dehydrated: null,
      treeContext: null,
      retryLane: rr
    };
    function x1(n) {
      return {
        baseLanes: n,
        cachePool: J8(),
        transitions: null
      };
    }
    function uk(n, a) {
      var c = null;
      return {
        baseLanes: fn(n.baseLanes, a),
        cachePool: c,
        transitions: n.transitions
      };
    }
    function ck(n, a, c, p) {
      if (a !== null) {
        var b = a.memoizedState;
        if (b === null)
          return !1;
      }
      return kv(n, _h);
    }
    function dk(n, a) {
      return Di(n.childLanes, a);
    }
    function I_(n, a, c) {
      var p = a.pendingProps;
      Q5(a) && (a.flags |= xt);
      var b = ys.current, N = !1, G = (a.flags & xt) !== gt;
      if (G || ck(b, n) ? (N = !0, a.flags &= ~xt) : (n === null || n.memoizedState !== null) && (b = N8(b, jb)), b = nf(b), Nu(a, b), n === null) {
        Ac(a);
        var Y = a.memoizedState;
        if (Y !== null) {
          var $ = Y.dehydrated;
          if ($ !== null)
            return gk(a, $);
        }
        var se = p.children, he = p.fallback;
        if (N) {
          var Ae = fk(a, se, he, c), He = a.child;
          return He.memoizedState = x1(c), a.memoizedState = w1, Ae;
        } else
          return k1(a, se);
      } else {
        var Ze = n.memoizedState;
        if (Ze !== null) {
          var at = Ze.dehydrated;
          if (at !== null)
            return vk(n, a, G, p, at, Ze, c);
        }
        if (N) {
          var $e = p.fallback, Bt = p.children, nn = pk(n, a, Bt, $e, c), Zt = a.child, ur = n.child.memoizedState;
          return Zt.memoizedState = ur === null ? x1(c) : uk(ur, c), Zt.childLanes = dk(n, c), a.memoizedState = w1, nn;
        } else {
          var In = p.children, Fe = hk(n, a, In, c);
          return a.memoizedState = null, Fe;
        }
      }
    }
    function k1(n, a, c) {
      var p = n.mode, b = {
        mode: "visible",
        children: a
      }, N = C1(b, p);
      return N.return = n, n.child = N, N;
    }
    function fk(n, a, c, p) {
      var b = n.mode, N = n.child, G = {
        mode: "hidden",
        children: a
      }, Y, $;
      return (b & ht) === De && N !== null ? (Y = N, Y.childLanes = Ke, Y.pendingProps = G, n.mode & mt && (Y.actualDuration = 0, Y.actualStartTime = -1, Y.selfBaseDuration = 0, Y.treeBaseDuration = 0), $ = Fu(c, b, p, null)) : (Y = C1(G, b), $ = Fu(c, b, p, null)), Y.return = n, $.return = n, Y.sibling = $, n.child = Y, $;
    }
    function C1(n, a, c) {
      return G5(n, a, Ke, null);
    }
    function H_(n, a) {
      return Ic(n, a);
    }
    function hk(n, a, c, p) {
      var b = n.child, N = b.sibling, G = H_(b, {
        mode: "visible",
        children: c
      });
      if ((a.mode & ht) === De && (G.lanes = p), G.return = a, G.sibling = null, N !== null) {
        var Y = a.deletions;
        Y === null ? (a.deletions = [N], a.flags |= Ue) : Y.push(N);
      }
      return a.child = G, G;
    }
    function pk(n, a, c, p, b) {
      var N = a.mode, G = n.child, Y = G.sibling, $ = {
        mode: "hidden",
        children: c
      }, se;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (N & ht) === De && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        a.child !== G
      ) {
        var he = a.child;
        se = he, se.childLanes = Ke, se.pendingProps = $, a.mode & mt && (se.actualDuration = 0, se.actualStartTime = -1, se.selfBaseDuration = G.selfBaseDuration, se.treeBaseDuration = G.treeBaseDuration), a.deletions = null;
      } else
        se = H_(G, $), se.subtreeFlags = G.subtreeFlags & Qr;
      var Ae;
      return Y !== null ? Ae = Ic(Y, p) : (Ae = Fu(p, N, b, null), Ae.flags |= Tn), Ae.return = a, se.return = a, se.sibling = Ae, a.child = se, Ae;
    }
    function xg(n, a, c, p) {
      p !== null && y(p), Jd(a, n.child, null, c);
      var b = a.pendingProps, N = b.children, G = k1(a, N);
      return G.flags |= Tn, a.memoizedState = null, G;
    }
    function mk(n, a, c, p, b) {
      var N = a.mode, G = {
        mode: "visible",
        children: c
      }, Y = C1(G, N), $ = Fu(p, N, b, null);
      return $.flags |= Tn, Y.return = a, $.return = a, Y.sibling = $, a.child = Y, (a.mode & ht) !== De && Jd(a, n.child, null, b), $;
    }
    function gk(n, a, c) {
      return (n.mode & ht) === De ? (h("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), n.lanes = jt) : Fa(a) ? n.lanes = Us : n.lanes = mi, null;
    }
    function vk(n, a, c, p, b, N, G) {
      if (c)
        if (a.flags & zn) {
          a.flags &= ~zn;
          var Fe = d1(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return xg(n, a, G, Fe);
        } else {
          if (a.memoizedState !== null)
            return a.child = n.child, a.flags |= xt, null;
          var je = p.children, Oe = p.fallback, dt = mk(n, a, je, Oe, G), Ht = a.child;
          return Ht.memoizedState = x1(G), a.memoizedState = w1, dt;
        }
      else {
        if (av(), (a.mode & ht) === De)
          return xg(
            n,
            a,
            G,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (Fa(b)) {
          var Y, $, se;
          {
            var he = ji(b);
            Y = he.digest, $ = he.message, se = he.stack;
          }
          var Ae;
          $ ? Ae = new Error($) : Ae = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var He = d1(Ae, Y, se);
          return xg(n, a, G, He);
        }
        var Ze = Ua(G, n.childLanes);
        if (Ss || Ze) {
          var at = qg();
          if (at !== null) {
            var $e = tv(at, G);
            if ($e !== rr && $e !== N.retryLane) {
              N.retryLane = $e;
              var Bt = fr;
              Bi(n, $e), ha(at, n, $e, Bt);
            }
          }
          X1();
          var nn = d1(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return xg(n, a, G, nn);
        } else if (Ai(b)) {
          a.flags |= xt, a.child = n.child;
          var Zt = i9.bind(null, n);
          return os(b, Zt), null;
        } else {
          iv(a, b, N.treeContext);
          var ur = p.children, In = k1(a, ur);
          return In.flags |= Xr, In;
        }
      }
    }
    function G_(n, a, c) {
      n.lanes = fn(n.lanes, a);
      var p = n.alternate;
      p !== null && (p.lanes = fn(p.lanes, a)), mv(n.return, a, c);
    }
    function yk(n, a, c) {
      for (var p = a; p !== null; ) {
        if (p.tag === j) {
          var b = p.memoizedState;
          b !== null && G_(p, c, n);
        } else if (p.tag === Me)
          G_(p, c, n);
        else if (p.child !== null) {
          p.child.return = p, p = p.child;
          continue;
        }
        if (p === n)
          return;
        for (; p.sibling === null; ) {
          if (p.return === null || p.return === n)
            return;
          p = p.return;
        }
        p.sibling.return = p.return, p = p.sibling;
      }
    }
    function bk(n) {
      for (var a = n, c = null; a !== null; ) {
        var p = a.alternate;
        p !== null && tg(p) === null && (c = a), a = a.sibling;
      }
      return c;
    }
    function _k(n) {
      if (n !== void 0 && n !== "forwards" && n !== "backwards" && n !== "together" && !y1[n])
        if (y1[n] = !0, typeof n == "string")
          switch (n.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              h('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', n, n.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              h('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', n, n.toLowerCase());
              break;
            }
            default:
              h('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
              break;
          }
        else
          h('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', n);
    }
    function Sk(n, a) {
      n !== void 0 && !wg[n] && (n !== "collapsed" && n !== "hidden" ? (wg[n] = !0, h('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', n)) : a !== "forwards" && a !== "backwards" && (wg[n] = !0, h('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', n)));
    }
    function V_(n, a) {
      {
        var c = wr(n), p = !c && typeof ot(n) == "function";
        if (c || p) {
          var b = c ? "array" : "iterable";
          return h("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", b, a, b), !1;
        }
      }
      return !0;
    }
    function wk(n, a) {
      if ((a === "forwards" || a === "backwards") && n !== void 0 && n !== null && n !== !1)
        if (wr(n)) {
          for (var c = 0; c < n.length; c++)
            if (!V_(n[c], c))
              return;
        } else {
          var p = ot(n);
          if (typeof p == "function") {
            var b = p.call(n);
            if (b)
              for (var N = b.next(), G = 0; !N.done; N = b.next()) {
                if (!V_(N.value, G))
                  return;
                G++;
              }
          } else
            h('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', a);
        }
    }
    function E1(n, a, c, p, b) {
      var N = n.memoizedState;
      N === null ? n.memoizedState = {
        isBackwards: a,
        rendering: null,
        renderingStartTime: 0,
        last: p,
        tail: c,
        tailMode: b
      } : (N.isBackwards = a, N.rendering = null, N.renderingStartTime = 0, N.last = p, N.tail = c, N.tailMode = b);
    }
    function q_(n, a, c) {
      var p = a.pendingProps, b = p.revealOrder, N = p.tail, G = p.children;
      _k(b), Sk(N, b), wk(G, b), Ui(n, a, G, c);
      var Y = ys.current, $ = kv(Y, _h);
      if ($)
        Y = Cv(Y, _h), a.flags |= xt;
      else {
        var se = n !== null && (n.flags & xt) !== gt;
        se && yk(a, a.child, c), Y = nf(Y);
      }
      if (Nu(a, Y), (a.mode & ht) === De)
        a.memoizedState = null;
      else
        switch (b) {
          case "forwards": {
            var he = bk(a.child), Ae;
            he === null ? (Ae = a.child, a.child = null) : (Ae = he.sibling, he.sibling = null), E1(
              a,
              !1,
              // isBackwards
              Ae,
              he,
              N
            );
            break;
          }
          case "backwards": {
            var He = null, Ze = a.child;
            for (a.child = null; Ze !== null; ) {
              var at = Ze.alternate;
              if (at !== null && tg(at) === null) {
                a.child = Ze;
                break;
              }
              var $e = Ze.sibling;
              Ze.sibling = He, He = Ze, Ze = $e;
            }
            E1(
              a,
              !0,
              // isBackwards
              He,
              null,
              // last
              N
            );
            break;
          }
          case "together": {
            E1(
              a,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            a.memoizedState = null;
        }
      return a.child;
    }
    function xk(n, a, c) {
      wv(a, a.stateNode.containerInfo);
      var p = a.pendingProps;
      return n === null ? a.child = Jd(a, null, p, c) : Ui(n, a, p, c), a.child;
    }
    var W_ = !1;
    function kk(n, a, c) {
      var p = a.type, b = p._context, N = a.pendingProps, G = a.memoizedProps, Y = N.value;
      {
        "value" in N || W_ || (W_ = !0, h("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var $ = a.type.propTypes;
        $ && _($, N, "prop", "Context.Provider");
      }
      if (Bb(a, b, Y), G !== null) {
        var se = G.value;
        if (Ha(se, Y)) {
          if (G.children === N.children && !we())
            return Hl(n, a, c);
        } else
          _8(a, b, c);
      }
      var he = N.children;
      return Ui(n, a, he, c), a.child;
    }
    var K_ = !1;
    function Ck(n, a, c) {
      var p = a.type;
      p._context === void 0 ? p !== p.Consumer && (K_ || (K_ = !0, h("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : p = p._context;
      var b = a.pendingProps, N = b.children;
      typeof N != "function" && h("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), ef(a, c);
      var G = da(p);
      Gs(a);
      var Y;
      return Nh.current = a, Le(!0), Y = N(G), Le(!1), Vs(), a.flags |= Dn, Ui(n, a, Y, c), a.child;
    }
    function Ph() {
      Ss = !0;
    }
    function kg(n, a) {
      (a.mode & ht) === De && n !== null && (n.alternate = null, a.alternate = null, a.flags |= Tn);
    }
    function Hl(n, a, c) {
      return n !== null && (a.dependencies = n.dependencies), S_(), Kh(a.lanes), Ua(c, a.childLanes) ? (y8(n, a), a.child) : null;
    }
    function Ek(n, a, c) {
      {
        var p = a.return;
        if (p === null)
          throw new Error("Cannot swap the root fiber.");
        if (n.alternate = null, a.alternate = null, c.index = a.index, c.sibling = a.sibling, c.return = a.return, c.ref = a.ref, a === p.child)
          p.child = c;
        else {
          var b = p.child;
          if (b === null)
            throw new Error("Expected parent to have a child.");
          for (; b.sibling !== a; )
            if (b = b.sibling, b === null)
              throw new Error("Expected to find the previous sibling.");
          b.sibling = c;
        }
        var N = p.deletions;
        return N === null ? (p.deletions = [n], p.flags |= Ue) : N.push(n), c.flags |= Tn, c;
      }
    }
    function R1(n, a) {
      var c = n.lanes;
      return !!Ua(c, a);
    }
    function Rk(n, a, c) {
      switch (a.tag) {
        case I:
          B_(a), a.stateNode, Eu();
          break;
        case F:
          Wb(a);
          break;
        case q: {
          var p = a.type;
          Te(p) && lt(a);
          break;
        }
        case U:
          wv(a, a.stateNode.containerInfo);
          break;
        case ce: {
          var b = a.memoizedProps.value, N = a.type._context;
          Bb(a, N, b);
          break;
        }
        case W:
          {
            var G = Ua(c, a.childLanes);
            G && (a.flags |= Xe);
            {
              var Y = a.stateNode;
              Y.effectDuration = 0, Y.passiveEffectDuration = 0;
            }
          }
          break;
        case j: {
          var $ = a.memoizedState;
          if ($ !== null) {
            if ($.dehydrated !== null)
              return Nu(a, nf(ys.current)), a.flags |= xt, null;
            var se = a.child, he = se.childLanes;
            if (Ua(c, he))
              return I_(n, a, c);
            Nu(a, nf(ys.current));
            var Ae = Hl(n, a, c);
            return Ae !== null ? Ae.sibling : null;
          } else
            Nu(a, nf(ys.current));
          break;
        }
        case Me: {
          var He = (n.flags & xt) !== gt, Ze = Ua(c, a.childLanes);
          if (He) {
            if (Ze)
              return q_(n, a, c);
            a.flags |= xt;
          }
          var at = a.memoizedState;
          if (at !== null && (at.rendering = null, at.tail = null, at.lastEffect = null), Nu(a, ys.current), Ze)
            break;
          return null;
        }
        case Ee:
        case ae:
          return a.lanes = Ke, O_(n, a, c);
      }
      return Hl(n, a, c);
    }
    function j_(n, a, c) {
      if (a._debugNeedsRemount && n !== null)
        return Ek(n, a, oy(a.type, a.key, a.pendingProps, a._debugOwner || null, a.mode, a.lanes));
      if (n !== null) {
        var p = n.memoizedProps, b = a.pendingProps;
        if (p !== b || we() || // Force a re-render if the implementation changed due to hot reload:
        a.type !== n.type)
          Ss = !0;
        else {
          var N = R1(n, c);
          if (!N && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (a.flags & xt) === gt)
            return Ss = !1, Rk(n, a, c);
          (n.flags & Xn) !== gt ? Ss = !0 : Ss = !1;
        }
      } else if (Ss = !1, s() && dh(a)) {
        var G = a.index, Y = zl();
        Kd(a, Y, G);
      }
      switch (a.lanes = Ke, a.tag) {
        case X:
          return lk(n, a, a.type, c);
        case oe: {
          var $ = a.elementType;
          return ok(n, a, $, c);
        }
        case B: {
          var se = a.type, he = a.pendingProps, Ae = a.elementType === se ? he : _s(se, he);
          return b1(n, a, se, Ae, c);
        }
        case q: {
          var He = a.type, Ze = a.pendingProps, at = a.elementType === He ? Ze : _s(He, Ze);
          return z_(n, a, He, at, c);
        }
        case I:
          return rk(n, a, c);
        case F:
          return ak(n, a, c);
        case Z:
          return ik(n, a);
        case j:
          return I_(n, a, c);
        case U:
          return xk(n, a, c);
        case ze: {
          var $e = a.type, Bt = a.pendingProps, nn = a.elementType === $e ? Bt : _s($e, Bt);
          return P_(n, a, $e, nn, c);
        }
        case te:
          return ek(n, a, c);
        case ie:
          return tk(n, a, c);
        case W:
          return nk(n, a, c);
        case ce:
          return kk(n, a, c);
        case ue:
          return Ck(n, a, c);
        case ee: {
          var Zt = a.type, ur = a.pendingProps, In = _s(Zt, ur);
          if (a.type !== a.elementType) {
            var Fe = Zt.propTypes;
            Fe && _(
              Fe,
              In,
              // Resolved for outer only
              "prop",
              Ft(Zt)
            );
          }
          return In = _s(Zt.type, In), D_(n, a, Zt, In, c);
        }
        case Q:
          return L_(n, a, a.type, a.pendingProps, c);
        case ye: {
          var je = a.type, Oe = a.pendingProps, dt = a.elementType === je ? Oe : _s(je, Oe);
          return sk(n, a, je, dt, c);
        }
        case Me:
          return q_(n, a, c);
        case We:
          break;
        case Ee:
          return O_(n, a, c);
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Js(n) {
      n.flags |= Xe;
    }
    function Y_(n) {
      n.flags |= aa, n.flags |= Vt;
    }
    function Z_(n, a) {
      var c = n !== null && n.child === a.child;
      if (c)
        return !0;
      if ((a.flags & Ue) !== gt)
        return !1;
      for (var p = a.child; p !== null; ) {
        if ((p.flags & Qo) !== gt || (p.subtreeFlags & Qo) !== gt)
          return !1;
        p = p.sibling;
      }
      return !0;
    }
    var Dh, Lh, Cg, Eg;
    if (Oa)
      Dh = function(n, a, c, p) {
        for (var b = a.child; b !== null; ) {
          if (b.tag === F || b.tag === Z)
            Wi(n, b.stateNode);
          else if (b.tag !== U) {
            if (b.child !== null) {
              b.child.return = b, b = b.child;
              continue;
            }
          }
          if (b === a)
            return;
          for (; b.sibling === null; ) {
            if (b.return === null || b.return === a)
              return;
            b = b.return;
          }
          b.sibling.return = b.return, b = b.sibling;
        }
      }, Lh = function(n, a) {
      }, Cg = function(n, a, c, p, b) {
        var N = n.memoizedProps;
        if (N !== p) {
          var G = a.stateNode, Y = bh(), $ = ia(G, c, N, p, b, Y);
          a.updateQueue = $, $ && Js(a);
        }
      }, Eg = function(n, a, c, p) {
        c !== p && Js(a);
      };
    else if (ns) {
      Dh = function(n, a, c, p) {
        for (var b = a.child; b !== null; ) {
          if (b.tag === F) {
            var N = b.stateNode;
            if (c && p) {
              var G = b.memoizedProps, Y = b.type;
              N = as(N, Y, G, b);
            }
            Wi(n, N);
          } else if (b.tag === Z) {
            var $ = b.stateNode;
            if (c && p) {
              var se = b.memoizedProps;
              $ = is($, se, b);
            }
            Wi(n, $);
          } else if (b.tag !== U) {
            if (b.tag === Ee && b.memoizedState !== null) {
              var he = b.child;
              he !== null && (he.return = b), Dh(n, b, !0, !0);
            } else if (b.child !== null) {
              b.child.return = b, b = b.child;
              continue;
            }
          }
          if (b = b, b === a)
            return;
          for (; b.sibling === null; ) {
            if (b.return === null || b.return === a)
              return;
            b = b.return;
          }
          b.sibling.return = b.return, b = b.sibling;
        }
      };
      var X_ = function(n, a, c, p) {
        for (var b = a.child; b !== null; ) {
          if (b.tag === F) {
            var N = b.stateNode;
            if (c && p) {
              var G = b.memoizedProps, Y = b.type;
              N = as(N, Y, G, b);
            }
            ru(n, N);
          } else if (b.tag === Z) {
            var $ = b.stateNode;
            if (c && p) {
              var se = b.memoizedProps;
              $ = is($, se, b);
            }
            ru(n, $);
          } else if (b.tag !== U) {
            if (b.tag === Ee && b.memoizedState !== null) {
              var he = b.child;
              he !== null && (he.return = b), X_(n, b, !0, !0);
            } else if (b.child !== null) {
              b.child.return = b, b = b.child;
              continue;
            }
          }
          if (b = b, b === a)
            return;
          for (; b.sibling === null; ) {
            if (b.return === null || b.return === a)
              return;
            b = b.return;
          }
          b.sibling.return = b.return, b = b.sibling;
        }
      };
      Lh = function(n, a) {
        var c = a.stateNode, p = Z_(n, a);
        if (!p) {
          var b = c.containerInfo, N = Ms(b);
          X_(N, a, !1, !1), c.pendingChildren = N, Js(a), Ki(b, N);
        }
      }, Cg = function(n, a, c, p, b) {
        var N = n.stateNode, G = n.memoizedProps, Y = Z_(n, a);
        if (Y && G === p) {
          a.stateNode = N;
          return;
        }
        var $ = a.stateNode, se = bh(), he = null;
        if (G !== p && (he = ia($, c, G, p, b, se)), Y && he === null) {
          a.stateNode = N;
          return;
        }
        var Ae = As(N, he, c, G, p, a, Y, $);
        Ro(Ae, c, p, b, se) && Js(a), a.stateNode = Ae, Y ? Js(a) : Dh(Ae, a, !1, !1);
      }, Eg = function(n, a, c, p) {
        if (c !== p) {
          var b = Sv(), N = bh();
          a.stateNode = es(p, b, N, a), Js(a);
        } else
          a.stateNode = n.stateNode;
      };
    } else
      Lh = function(n, a) {
      }, Cg = function(n, a, c, p, b) {
      }, Eg = function(n, a, c, p) {
      };
    function Oh(n, a) {
      if (!s())
        switch (n.tailMode) {
          case "hidden": {
            for (var c = n.tail, p = null; c !== null; )
              c.alternate !== null && (p = c), c = c.sibling;
            p === null ? n.tail = null : p.sibling = null;
            break;
          }
          case "collapsed": {
            for (var b = n.tail, N = null; b !== null; )
              b.alternate !== null && (N = b), b = b.sibling;
            N === null ? !a && n.tail !== null ? n.tail.sibling = null : n.tail = null : N.sibling = null;
            break;
          }
        }
    }
    function ti(n) {
      var a = n.alternate !== null && n.alternate.child === n.child, c = Ke, p = gt;
      if (a) {
        if ((n.mode & mt) !== De) {
          for (var $ = n.selfBaseDuration, se = n.child; se !== null; )
            c = fn(c, fn(se.lanes, se.childLanes)), p |= se.subtreeFlags & Qr, p |= se.flags & Qr, $ += se.treeBaseDuration, se = se.sibling;
          n.treeBaseDuration = $;
        } else
          for (var he = n.child; he !== null; )
            c = fn(c, fn(he.lanes, he.childLanes)), p |= he.subtreeFlags & Qr, p |= he.flags & Qr, he.return = n, he = he.sibling;
        n.subtreeFlags |= p;
      } else {
        if ((n.mode & mt) !== De) {
          for (var b = n.actualDuration, N = n.selfBaseDuration, G = n.child; G !== null; )
            c = fn(c, fn(G.lanes, G.childLanes)), p |= G.subtreeFlags, p |= G.flags, b += G.actualDuration, N += G.treeBaseDuration, G = G.sibling;
          n.actualDuration = b, n.treeBaseDuration = N;
        } else
          for (var Y = n.child; Y !== null; )
            c = fn(c, fn(Y.lanes, Y.childLanes)), p |= Y.subtreeFlags, p |= Y.flags, Y.return = n, Y = Y.sibling;
        n.subtreeFlags |= p;
      }
      return n.childLanes = c, a;
    }
    function Tk(n, a, c) {
      if (Xd() && (a.mode & ht) !== De && (a.flags & xt) === gt)
        return Um(a), Eu(), a.flags |= zn | kt | Et, !1;
      var p = Mc(a);
      if (c !== null && c.dehydrated !== null)
        if (n === null) {
          if (!p)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (zm(a), ti(a), (a.mode & mt) !== De) {
            var b = c !== null;
            if (b) {
              var N = a.child;
              N !== null && (a.treeBaseDuration -= N.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Eu(), (a.flags & xt) === gt && (a.memoizedState = null), a.flags |= Xe, ti(a), (a.mode & mt) !== De) {
            var G = c !== null;
            if (G) {
              var Y = a.child;
              Y !== null && (a.treeBaseDuration -= Y.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return i(), !0;
    }
    function Q_(n, a, c) {
      var p = a.pendingProps;
      switch (Yd(a), a.tag) {
        case X:
        case oe:
        case Q:
        case B:
        case ze:
        case te:
        case ie:
        case W:
        case ue:
        case ee:
          return ti(a), null;
        case q: {
          var b = a.type;
          return Te(b) && Ne(a), ti(a), null;
        }
        case I: {
          var N = a.stateNode;
          if (tf(a), Be(a), Rv(), N.pendingContext && (N.context = N.pendingContext, N.pendingContext = null), n === null || n.child === null) {
            var G = Mc(a);
            if (G)
              Js(a);
            else if (n !== null) {
              var Y = n.memoizedState;
              // Check if this is a client root
              (!Y.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (a.flags & zn) !== gt) && (a.flags |= Zr, i());
            }
          }
          return Lh(n, a), ti(a), null;
        }
        case F: {
          xv(a);
          var $ = Sv(), se = a.type;
          if (n !== null && a.stateNode != null)
            Cg(n, a, se, p, $), n.ref !== a.ref && Y_(a);
          else {
            if (!p) {
              if (a.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return ti(a), null;
            }
            var he = bh(), Ae = Mc(a);
            if (Ae)
              hh(a, $, he) && Js(a);
            else {
              var He = zr(se, p, $, he, a);
              Dh(He, a, !1, !1), a.stateNode = He, Ro(He, se, p, $, he) && Js(a);
            }
            a.ref !== null && Y_(a);
          }
          return ti(a), null;
        }
        case Z: {
          var Ze = p;
          if (n && a.stateNode != null) {
            var at = n.memoizedProps;
            Eg(n, a, at, Ze);
          } else {
            if (typeof Ze != "string" && a.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var $e = Sv(), Bt = bh(), nn = Mc(a);
            nn ? ov(a) && Js(a) : a.stateNode = es(Ze, $e, Bt, a);
          }
          return ti(a), null;
        }
        case j: {
          rf(a);
          var Zt = a.memoizedState;
          if (n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
            var ur = Tk(n, a, Zt);
            if (!ur)
              return a.flags & Et ? a : null;
          }
          if ((a.flags & xt) !== gt)
            return a.lanes = c, (a.mode & mt) !== De && Jv(a), a;
          var In = Zt !== null, Fe = n !== null && n.memoizedState !== null;
          if (In !== Fe && In) {
            var je = a.child;
            if (je.flags |= de, (a.mode & ht) !== De) {
              var Oe = n === null && (a.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              Oe || kv(ys.current, jb) ? KC() : X1();
            }
          }
          var dt = a.updateQueue;
          if (dt !== null && (a.flags |= Xe), ti(a), (a.mode & mt) !== De && In) {
            var Ht = a.child;
            Ht !== null && (a.treeBaseDuration -= Ht.treeBaseDuration);
          }
          return null;
        }
        case U:
          return tf(a), Lh(n, a), n === null && wn(a.stateNode.containerInfo), ti(a), null;
        case ce:
          var Pt = a.type._context;
          return pv(Pt, a), ti(a), null;
        case ye: {
          var Ln = a.type;
          return Te(Ln) && Ne(a), ti(a), null;
        }
        case Me: {
          rf(a);
          var on = a.memoizedState;
          if (on === null)
            return ti(a), null;
          var Kn = (a.flags & xt) !== gt, Cn = on.rendering;
          if (Cn === null)
            if (Kn)
              Oh(on, !1);
            else {
              var Sr = YC() && (n === null || (n.flags & xt) === gt);
              if (!Sr)
                for (var Qt = a.child; Qt !== null; ) {
                  var Wr = tg(Qt);
                  if (Wr !== null) {
                    Kn = !0, a.flags |= xt, Oh(on, !1);
                    var ki = Wr.updateQueue;
                    return ki !== null && (a.updateQueue = ki, a.flags |= Xe), a.subtreeFlags = gt, b8(a, c), Nu(a, Cv(ys.current, _h)), a.child;
                  }
                  Qt = Qt.sibling;
                }
              on.tail !== null && Hr() > S5() && (a.flags |= xt, Kn = !0, Oh(on, !1), a.lanes = Tl);
            }
          else {
            if (!Kn) {
              var ii = tg(Cn);
              if (ii !== null) {
                a.flags |= xt, Kn = !0;
                var bo = ii.updateQueue;
                if (bo !== null && (a.updateQueue = bo, a.flags |= Xe), Oh(on, !0), on.tail === null && on.tailMode === "hidden" && !Cn.alternate && !s())
                  return ti(a), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Hr() * 2 - on.renderingStartTime > S5() && c !== mi && (a.flags |= xt, Kn = !0, Oh(on, !1), a.lanes = Tl);
            }
            if (on.isBackwards)
              Cn.sibling = a.child, a.child = Cn;
            else {
              var Hi = on.last;
              Hi !== null ? Hi.sibling = Cn : a.child = Cn, on.last = Cn;
            }
          }
          if (on.tail !== null) {
            var Gi = on.tail;
            on.rendering = Gi, on.tail = Gi.sibling, on.renderingStartTime = Hr(), Gi.sibling = null;
            var Ci = ys.current;
            return Kn ? Ci = Cv(Ci, _h) : Ci = nf(Ci), Nu(a, Ci), Gi;
          }
          return ti(a), null;
        }
        case We:
          break;
        case Ee:
        case ae: {
          Z1(a);
          var ql = a.memoizedState, vf = ql !== null;
          if (n !== null) {
            var Zh = n.memoizedState, rl = Zh !== null;
            rl !== vf && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !z && (a.flags |= de);
          }
          return !vf || (a.mode & ht) === De ? ti(a) : Ua(tl, mi) && (ti(a), Oa && a.subtreeFlags & (Tn | Xe) && (a.flags |= de)), null;
        }
        case Re:
          return null;
        case Qe:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + a.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Nk(n, a, c) {
      switch (Yd(a), a.tag) {
        case q: {
          var p = a.type;
          Te(p) && Ne(a);
          var b = a.flags;
          return b & Et ? (a.flags = b & ~Et | xt, (a.mode & mt) !== De && Jv(a), a) : null;
        }
        case I: {
          a.stateNode, tf(a), Be(a), Rv();
          var N = a.flags;
          return (N & Et) !== gt && (N & xt) === gt ? (a.flags = N & ~Et | xt, a) : null;
        }
        case F:
          return xv(a), null;
        case j: {
          rf(a);
          var G = a.memoizedState;
          if (G !== null && G.dehydrated !== null) {
            if (a.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Eu();
          }
          var Y = a.flags;
          return Y & Et ? (a.flags = Y & ~Et | xt, (a.mode & mt) !== De && Jv(a), a) : null;
        }
        case Me:
          return rf(a), null;
        case U:
          return tf(a), null;
        case ce:
          var $ = a.type._context;
          return pv($, a), null;
        case Ee:
        case ae:
          return Z1(a), null;
        case Re:
          return null;
        default:
          return null;
      }
    }
    function J_(n, a, c) {
      switch (Yd(a), a.tag) {
        case q: {
          var p = a.type.childContextTypes;
          p != null && Ne(a);
          break;
        }
        case I: {
          a.stateNode, tf(a), Be(a), Rv();
          break;
        }
        case F: {
          xv(a);
          break;
        }
        case U:
          tf(a);
          break;
        case j:
          rf(a);
          break;
        case Me:
          rf(a);
          break;
        case ce:
          var b = a.type._context;
          pv(b, a);
          break;
        case Ee:
        case ae:
          Z1(a);
          break;
      }
    }
    function $_(n, a, c, p, b, N, G, Y, $) {
      var se = Array.prototype.slice.call(arguments, 3);
      try {
        a.apply(c, se);
      } catch (he) {
        this.onError(he);
      }
    }
    var e5 = $_;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var T1 = document.createElement("react");
      e5 = function(a, c, p, b, N, G, Y, $, se) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var he = document.createEvent("Event"), Ae = !1, He = !0, Ze = window.event, at = Object.getOwnPropertyDescriptor(window, "event");
        function $e() {
          T1.removeEventListener(je, nn, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Ze);
        }
        var Bt = Array.prototype.slice.call(arguments, 3);
        function nn() {
          Ae = !0, $e(), c.apply(p, Bt), He = !1;
        }
        var Zt, ur = !1, In = !1;
        function Fe(Oe) {
          if (Zt = Oe.error, ur = !0, Zt === null && Oe.colno === 0 && Oe.lineno === 0 && (In = !0), Oe.defaultPrevented && Zt != null && typeof Zt == "object")
            try {
              Zt._suppressLogging = !0;
            } catch {
            }
        }
        var je = "react-" + (a || "invokeguardedcallback");
        if (window.addEventListener("error", Fe), T1.addEventListener(je, nn, !1), he.initEvent(je, !1, !1), T1.dispatchEvent(he), at && Object.defineProperty(window, "event", at), Ae && He && (ur ? In && (Zt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Zt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Zt)), window.removeEventListener("error", Fe), !Ae)
          return $e(), $_.apply(this, arguments);
      };
    }
    var Ak = e5, Fh = !1, Rg = null, Mk = {
      onError: function(n) {
        Fh = !0, Rg = n;
      }
    };
    function t5(n, a, c, p, b, N, G, Y, $) {
      Fh = !1, Rg = null, Ak.apply(Mk, arguments);
    }
    function Pk() {
      return Fh;
    }
    function n5() {
      if (Fh) {
        var n = Rg;
        return Fh = !1, Rg = null, n;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var r5 = null;
    r5 = /* @__PURE__ */ new Set();
    var Tg = !1, ni = !1, Dk = typeof WeakSet == "function" ? WeakSet : Set, zt = null, uf = null, cf = null;
    function Lk(n) {
      t5(null, function() {
        throw n;
      }), n5();
    }
    var Ok = function(n, a) {
      if (a.props = n.memoizedProps, a.state = n.memoizedState, n.mode & mt)
        try {
          Qs(), a.componentWillUnmount();
        } finally {
          Xs(n);
        }
      else
        a.componentWillUnmount();
    };
    function a5(n, a) {
      try {
        Pu(Aa, n);
      } catch (c) {
        hr(n, a, c);
      }
    }
    function N1(n, a, c) {
      try {
        Ok(n, c);
      } catch (p) {
        hr(n, a, p);
      }
    }
    function Fk(n, a, c) {
      try {
        c.componentDidMount();
      } catch (p) {
        hr(n, a, p);
      }
    }
    function i5(n, a) {
      try {
        s5(n);
      } catch (c) {
        hr(n, a, c);
      }
    }
    function df(n, a) {
      var c = n.ref;
      if (c !== null)
        if (typeof c == "function") {
          var p;
          try {
            if (k && R && n.mode & mt)
              try {
                Qs(), p = c(null);
              } finally {
                Xs(n);
              }
            else
              p = c(null);
          } catch (b) {
            hr(n, a, b);
          }
          typeof p == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", qe(n));
        } else
          c.current = null;
    }
    function Ng(n, a, c) {
      try {
        c();
      } catch (p) {
        hr(n, a, p);
      }
    }
    var o5 = !1;
    function zk(n, a) {
      so(n.containerInfo), zt = a, Bk();
      var c = o5;
      return o5 = !1, c;
    }
    function Bk() {
      for (; zt !== null; ) {
        var n = zt, a = n.child;
        (n.subtreeFlags & Ti) !== gt && a !== null ? (a.return = n, zt = a) : Uk();
      }
    }
    function Uk() {
      for (; zt !== null; ) {
        var n = zt;
        Un(n);
        try {
          Ik(n);
        } catch (c) {
          hr(n, n.return, c);
        }
        mn();
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, zt = a;
          return;
        }
        zt = n.return;
      }
    }
    function Ik(n) {
      var a = n.alternate, c = n.flags;
      if ((c & Zr) !== gt) {
        switch (Un(n), n.tag) {
          case B:
          case ze:
          case Q:
            break;
          case q: {
            if (a !== null) {
              var p = a.memoizedProps, b = a.memoizedState, N = n.stateNode;
              n.type === n.elementType && !Oc && (N.props !== n.memoizedProps && h("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", qe(n) || "instance"), N.state !== n.memoizedState && h("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", qe(n) || "instance"));
              var G = N.getSnapshotBeforeUpdate(n.elementType === n.type ? p : _s(n.type, p), b);
              {
                var Y = r5;
                G === void 0 && !Y.has(n.type) && (Y.add(n.type), h("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", qe(n)));
              }
              N.__reactInternalSnapshotBeforeUpdate = G;
            }
            break;
          }
          case I: {
            if (Oa) {
              var $ = n.stateNode;
              nu($.containerInfo);
            }
            break;
          }
          case F:
          case Z:
          case U:
          case ye:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        mn();
      }
    }
    function ws(n, a, c) {
      var p = a.updateQueue, b = p !== null ? p.lastEffect : null;
      if (b !== null) {
        var N = b.next, G = N;
        do {
          if ((G.tag & n) === n) {
            var Y = G.destroy;
            G.destroy = void 0, Y !== void 0 && ((n & ei) !== Ji ? ca(a) : (n & Aa) !== Ji && Ll(a), (n & js) !== Ji && Yh(!0), Ng(a, c, Y), (n & js) !== Ji && Yh(!1), (n & ei) !== Ji ? Vr() : (n & Aa) !== Ji && qr());
          }
          G = G.next;
        } while (G !== N);
      }
    }
    function Pu(n, a) {
      var c = a.updateQueue, p = c !== null ? c.lastEffect : null;
      if (p !== null) {
        var b = p.next, N = b;
        do {
          if ((N.tag & n) === n) {
            (n & ei) !== Ji ? Pr(a) : (n & Aa) !== Ji && Ra(a);
            var G = N.create;
            (n & js) !== Ji && Yh(!0), N.destroy = G(), (n & js) !== Ji && Yh(!1), (n & ei) !== Ji ? xn() : (n & Aa) !== Ji && Oi();
            {
              var Y = N.destroy;
              if (Y !== void 0 && typeof Y != "function") {
                var $ = void 0;
                (N.tag & Aa) !== gt ? $ = "useLayoutEffect" : (N.tag & js) !== gt ? $ = "useInsertionEffect" : $ = "useEffect";
                var se = void 0;
                Y === null ? se = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof Y.then == "function" ? se = `

It looks like you wrote ` + $ + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + $ + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : se = " You returned: " + Y, h("%s must not return anything besides a function, which is used for clean-up.%s", $, se);
              }
            }
          }
          N = N.next;
        } while (N !== b);
      }
    }
    function Hk(n, a) {
      if ((a.flags & Xe) !== gt)
        switch (a.tag) {
          case W: {
            var c = a.stateNode.passiveEffectDuration, p = a.memoizedProps, b = p.id, N = p.onPostCommit, G = b_(), Y = a.alternate === null ? "mount" : "update";
            y_() && (Y = "nested-update"), typeof N == "function" && N(b, Y, c, G);
            var $ = a.return;
            e: for (; $ !== null; ) {
              switch ($.tag) {
                case I:
                  var se = $.stateNode;
                  se.passiveEffectDuration += c;
                  break e;
                case W:
                  var he = $.stateNode;
                  he.passiveEffectDuration += c;
                  break e;
              }
              $ = $.return;
            }
            break;
          }
        }
    }
    function Gk(n, a, c, p) {
      if ((c.flags & ma) !== gt)
        switch (c.tag) {
          case B:
          case ze:
          case Q: {
            if (!ni)
              if (c.mode & mt)
                try {
                  Qs(), Pu(Aa | Na, c);
                } finally {
                  Xs(c);
                }
              else
                Pu(Aa | Na, c);
            break;
          }
          case q: {
            var b = c.stateNode;
            if (c.flags & Xe && !ni)
              if (a === null)
                if (c.type === c.elementType && !Oc && (b.props !== c.memoizedProps && h("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", qe(c) || "instance"), b.state !== c.memoizedState && h("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", qe(c) || "instance")), c.mode & mt)
                  try {
                    Qs(), b.componentDidMount();
                  } finally {
                    Xs(c);
                  }
                else
                  b.componentDidMount();
              else {
                var N = c.elementType === c.type ? a.memoizedProps : _s(c.type, a.memoizedProps), G = a.memoizedState;
                if (c.type === c.elementType && !Oc && (b.props !== c.memoizedProps && h("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", qe(c) || "instance"), b.state !== c.memoizedState && h("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", qe(c) || "instance")), c.mode & mt)
                  try {
                    Qs(), b.componentDidUpdate(N, G, b.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Xs(c);
                  }
                else
                  b.componentDidUpdate(N, G, b.__reactInternalSnapshotBeforeUpdate);
              }
            var Y = c.updateQueue;
            Y !== null && (c.type === c.elementType && !Oc && (b.props !== c.memoizedProps && h("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", qe(c) || "instance"), b.state !== c.memoizedState && h("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", qe(c) || "instance")), qb(c, Y, b));
            break;
          }
          case I: {
            var $ = c.updateQueue;
            if ($ !== null) {
              var se = null;
              if (c.child !== null)
                switch (c.child.tag) {
                  case F:
                    se = Ni(c.child.stateNode);
                    break;
                  case q:
                    se = c.child.stateNode;
                    break;
                }
              qb(c, $, se);
            }
            break;
          }
          case F: {
            var he = c.stateNode;
            if (a === null && c.flags & Xe) {
              var Ae = c.type, He = c.memoizedProps;
              Br(he, Ae, He, c);
            }
            break;
          }
          case Z:
            break;
          case U:
            break;
          case W: {
            {
              var Ze = c.memoizedProps, at = Ze.onCommit, $e = Ze.onRender, Bt = c.stateNode.effectDuration, nn = b_(), Zt = a === null ? "mount" : "update";
              y_() && (Zt = "nested-update"), typeof $e == "function" && $e(c.memoizedProps.id, Zt, c.actualDuration, c.treeBaseDuration, c.actualStartTime, nn);
              {
                typeof at == "function" && at(c.memoizedProps.id, Zt, Bt, nn), $C(c);
                var ur = c.return;
                e: for (; ur !== null; ) {
                  switch (ur.tag) {
                    case I:
                      var In = ur.stateNode;
                      In.effectDuration += Bt;
                      break e;
                    case W:
                      var Fe = ur.stateNode;
                      Fe.effectDuration += Bt;
                      break e;
                  }
                  ur = ur.return;
                }
              }
            }
            break;
          }
          case j: {
            Qk(n, c);
            break;
          }
          case Me:
          case ye:
          case We:
          case Ee:
          case ae:
          case Qe:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      ni || c.flags & aa && s5(c);
    }
    function Vk(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          if (n.mode & mt)
            try {
              Qs(), a5(n, n.return);
            } finally {
              Xs(n);
            }
          else
            a5(n, n.return);
          break;
        }
        case q: {
          var a = n.stateNode;
          typeof a.componentDidMount == "function" && Fk(n, n.return, a), i5(n, n.return);
          break;
        }
        case F: {
          i5(n, n.return);
          break;
        }
      }
    }
    function qk(n, a) {
      var c = null;
      if (Oa)
        for (var p = n; ; ) {
          if (p.tag === F) {
            if (c === null) {
              c = p;
              try {
                var b = p.stateNode;
                a ? pd(b) : ya(p.stateNode, p.memoizedProps);
              } catch (G) {
                hr(n, n.return, G);
              }
            }
          } else if (p.tag === Z) {
            if (c === null)
              try {
                var N = p.stateNode;
                a ? Kf(N) : uo(N, p.memoizedProps);
              } catch (G) {
                hr(n, n.return, G);
              }
          } else if (!((p.tag === Ee || p.tag === ae) && p.memoizedState !== null && p !== n)) {
            if (p.child !== null) {
              p.child.return = p, p = p.child;
              continue;
            }
          }
          if (p === n)
            return;
          for (; p.sibling === null; ) {
            if (p.return === null || p.return === n)
              return;
            c === p && (c = null), p = p.return;
          }
          c === p && (c = null), p.sibling.return = p.return, p = p.sibling;
        }
    }
    function s5(n) {
      var a = n.ref;
      if (a !== null) {
        var c = n.stateNode, p;
        switch (n.tag) {
          case F:
            p = Ni(c);
            break;
          default:
            p = c;
        }
        if (typeof a == "function") {
          var b;
          if (n.mode & mt)
            try {
              Qs(), b = a(p);
            } finally {
              Xs(n);
            }
          else
            b = a(p);
          typeof b == "function" && h("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", qe(n));
        } else
          a.hasOwnProperty("current") || h("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", qe(n)), a.current = p;
      }
    }
    function Wk(n) {
      var a = n.alternate;
      a !== null && (a.return = null), n.return = null;
    }
    function l5(n) {
      var a = n.alternate;
      a !== null && (n.alternate = null, l5(a));
      {
        if (n.child = null, n.deletions = null, n.sibling = null, n.tag === F) {
          var c = n.stateNode;
          c !== null && qf(c);
        }
        n.stateNode = null, n._debugOwner = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
      }
    }
    function Kk(n) {
      if (ns) {
        var a = n.stateNode, c = a.containerInfo, p = Ms(c);
        Mo(c, p);
      }
    }
    function jk(n) {
      for (var a = n.return; a !== null; ) {
        if (u5(a))
          return a;
        a = a.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function u5(n) {
      return n.tag === F || n.tag === I || n.tag === U;
    }
    function c5(n) {
      var a = n;
      e: for (; ; ) {
        for (; a.sibling === null; ) {
          if (a.return === null || u5(a.return))
            return null;
          a = a.return;
        }
        for (a.sibling.return = a.return, a = a.sibling; a.tag !== F && a.tag !== Z && a.tag !== pe; ) {
          if (a.flags & Tn || a.child === null || a.tag === U)
            continue e;
          a.child.return = a, a = a.child;
        }
        if (!(a.flags & Tn))
          return a.stateNode;
      }
    }
    function Yk(n) {
      if (Oa) {
        var a = jk(n);
        switch (a.tag) {
          case F: {
            var c = a.stateNode;
            a.flags & _t && (Ya(c), a.flags &= ~_t);
            var p = c5(n);
            M1(n, p, c);
            break;
          }
          case I:
          case U: {
            var b = a.stateNode.containerInfo, N = c5(n);
            A1(n, N, b);
            break;
          }
          // eslint-disable-next-line-no-fallthrough
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
    }
    function A1(n, a, c) {
      var p = n.tag, b = p === F || p === Z;
      if (b) {
        var N = n.stateNode;
        a ? tu(c, N, a) : lc(c, N);
      } else if (p !== U) {
        var G = n.child;
        if (G !== null) {
          A1(G, a, c);
          for (var Y = G.sibling; Y !== null; )
            A1(Y, a, c), Y = Y.sibling;
        }
      }
    }
    function M1(n, a, c) {
      var p = n.tag, b = p === F || p === Z;
      if (b) {
        var N = n.stateNode;
        a ? uc(c, N, a) : bl(c, N);
      } else if (p !== U) {
        var G = n.child;
        if (G !== null) {
          M1(G, a, c);
          for (var Y = G.sibling; Y !== null; )
            M1(Y, a, c), Y = Y.sibling;
        }
      }
    }
    var ri = null, xs = !1;
    function Zk(n, a, c) {
      if (Oa) {
        var p = a;
        e: for (; p !== null; ) {
          switch (p.tag) {
            case F: {
              ri = p.stateNode, xs = !1;
              break e;
            }
            case I: {
              ri = p.stateNode.containerInfo, xs = !0;
              break e;
            }
            case U: {
              ri = p.stateNode.containerInfo, xs = !0;
              break e;
            }
          }
          p = p.return;
        }
        if (ri === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        P1(n, a, c), ri = null, xs = !1;
      } else
        P1(n, a, c);
      Wk(c);
    }
    function $s(n, a, c) {
      for (var p = c.child; p !== null; )
        P1(n, a, p), p = p.sibling;
    }
    function P1(n, a, c) {
      switch (oh(c), c.tag) {
        case F:
          ni || df(c, a);
        // eslint-disable-next-line-no-fallthrough
        case Z: {
          if (Oa) {
            var p = ri, b = xs;
            ri = null, $s(n, a, c), ri = p, xs = b, ri !== null && (xs ? Ao(ri, c.stateNode) : cc(ri, c.stateNode));
          } else
            $s(n, a, c);
          return;
        }
        case pe: {
          Oa && ri !== null && (xs ? au(ri, c.stateNode) : Ls(ri, c.stateNode));
          return;
        }
        case U: {
          if (Oa) {
            var N = ri, G = xs;
            ri = c.stateNode.containerInfo, xs = !0, $s(n, a, c), ri = N, xs = G;
          } else
            Kk(c), $s(n, a, c);
          return;
        }
        case B:
        case ze:
        case ee:
        case Q: {
          if (!ni) {
            var Y = c.updateQueue;
            if (Y !== null) {
              var $ = Y.lastEffect;
              if ($ !== null) {
                var se = $.next, he = se;
                do {
                  var Ae = he, He = Ae.destroy, Ze = Ae.tag;
                  He !== void 0 && ((Ze & js) !== Ji ? Ng(c, a, He) : (Ze & Aa) !== Ji && (Ll(c), c.mode & mt ? (Qs(), Ng(c, a, He), Xs(c)) : Ng(c, a, He), qr())), he = he.next;
                } while (he !== se);
              }
            }
          }
          $s(n, a, c);
          return;
        }
        case q: {
          if (!ni) {
            df(c, a);
            var at = c.stateNode;
            typeof at.componentWillUnmount == "function" && N1(c, a, at);
          }
          $s(n, a, c);
          return;
        }
        case We: {
          $s(n, a, c);
          return;
        }
        case Ee: {
          if (
            // TODO: Remove this dead flag
            c.mode & ht
          ) {
            var $e = ni;
            ni = $e || c.memoizedState !== null, $s(n, a, c), ni = $e;
          } else
            $s(n, a, c);
          break;
        }
        default: {
          $s(n, a, c);
          return;
        }
      }
    }
    function Xk(n) {
      n.memoizedState;
    }
    function Qk(n, a) {
      if (sa) {
        var c = a.memoizedState;
        if (c === null) {
          var p = a.alternate;
          if (p !== null) {
            var b = p.memoizedState;
            if (b !== null) {
              var N = b.dehydrated;
              N !== null && dc(N);
            }
          }
        }
      }
    }
    function d5(n) {
      var a = n.updateQueue;
      if (a !== null) {
        n.updateQueue = null;
        var c = n.stateNode;
        c === null && (c = n.stateNode = new Dk()), a.forEach(function(p) {
          var b = o9.bind(null, n, p);
          if (!c.has(p)) {
            if (c.add(p), vi)
              if (uf !== null && cf !== null)
                jh(cf, uf);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            p.then(b, b);
          }
        });
      }
    }
    function Jk(n, a, c) {
      uf = c, cf = n, Un(a), f5(a, n), Un(a), uf = null, cf = null;
    }
    function ks(n, a, c) {
      var p = a.deletions;
      if (p !== null)
        for (var b = 0; b < p.length; b++) {
          var N = p[b];
          try {
            Zk(n, a, N);
          } catch ($) {
            hr(N, a, $);
          }
        }
      var G = vs();
      if (a.subtreeFlags & Qo)
        for (var Y = a.child; Y !== null; )
          Un(Y), f5(Y, n), Y = Y.sibling;
      Un(G);
    }
    function f5(n, a, c) {
      var p = n.alternate, b = n.flags;
      switch (n.tag) {
        case B:
        case ze:
        case ee:
        case Q: {
          if (ks(a, n), el(n), b & Xe) {
            try {
              ws(js | Na, n, n.return), Pu(js | Na, n);
            } catch (Qt) {
              hr(n, n.return, Qt);
            }
            if (n.mode & mt) {
              try {
                Qs(), ws(Aa | Na, n, n.return);
              } catch (Qt) {
                hr(n, n.return, Qt);
              }
              Xs(n);
            } else
              try {
                ws(Aa | Na, n, n.return);
              } catch (Qt) {
                hr(n, n.return, Qt);
              }
          }
          return;
        }
        case q: {
          ks(a, n), el(n), b & aa && p !== null && df(p, p.return);
          return;
        }
        case F: {
          if (ks(a, n), el(n), b & aa && p !== null && df(p, p.return), Oa) {
            if (n.flags & _t) {
              var N = n.stateNode;
              try {
                Ya(N);
              } catch (Qt) {
                hr(n, n.return, Qt);
              }
            }
            if (b & Xe) {
              var G = n.stateNode;
              if (G != null) {
                var Y = n.memoizedProps, $ = p !== null ? p.memoizedProps : Y, se = n.type, he = n.updateQueue;
                if (n.updateQueue = null, he !== null)
                  try {
                    fi(G, he, se, $, Y, n);
                  } catch (Qt) {
                    hr(n, n.return, Qt);
                  }
              }
            }
          }
          return;
        }
        case Z: {
          if (ks(a, n), el(n), b & Xe && Oa) {
            if (n.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var Ae = n.stateNode, He = n.memoizedProps, Ze = p !== null ? p.memoizedProps : He;
            try {
              No(Ae, Ze, He);
            } catch (Qt) {
              hr(n, n.return, Qt);
            }
          }
          return;
        }
        case I: {
          if (ks(a, n), el(n), b & Xe) {
            if (Oa && sa && p !== null) {
              var at = p.memoizedState;
              if (at.isDehydrated)
                try {
                  Ds(a.containerInfo);
                } catch (Qt) {
                  hr(n, n.return, Qt);
                }
            }
            if (ns) {
              var $e = a.containerInfo, Bt = a.pendingChildren;
              try {
                Mo($e, Bt);
              } catch (Qt) {
                hr(n, n.return, Qt);
              }
            }
          }
          return;
        }
        case U: {
          if (ks(a, n), el(n), b & Xe && ns) {
            var nn = n.stateNode, Zt = nn.containerInfo, ur = nn.pendingChildren;
            try {
              Mo(Zt, ur);
            } catch (Qt) {
              hr(n, n.return, Qt);
            }
          }
          return;
        }
        case j: {
          ks(a, n), el(n);
          var In = n.child;
          if (In.flags & de) {
            var Fe = In.stateNode, je = In.memoizedState, Oe = je !== null;
            if (Fe.isHidden = Oe, Oe) {
              var dt = In.alternate !== null && In.alternate.memoizedState !== null;
              dt || WC();
            }
          }
          if (b & Xe) {
            try {
              Xk(n);
            } catch (Qt) {
              hr(n, n.return, Qt);
            }
            d5(n);
          }
          return;
        }
        case Ee: {
          var Ht = p !== null && p.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            n.mode & ht
          ) {
            var Pt = ni;
            ni = Pt || Ht, ks(a, n), ni = Pt;
          } else
            ks(a, n);
          if (el(n), b & de) {
            var Ln = n.stateNode, on = n.memoizedState, Kn = on !== null, Cn = n;
            if (Ln.isHidden = Kn, Kn && !Ht && (Cn.mode & ht) !== De) {
              zt = Cn;
              for (var Sr = Cn.child; Sr !== null; )
                zt = Sr, eC(Sr), Sr = Sr.sibling;
            }
            Oa && qk(Cn, Kn);
          }
          return;
        }
        case Me: {
          ks(a, n), el(n), b & Xe && d5(n);
          return;
        }
        case We:
          return;
        default: {
          ks(a, n), el(n);
          return;
        }
      }
    }
    function el(n) {
      var a = n.flags;
      if (a & Tn) {
        try {
          Yk(n);
        } catch (c) {
          hr(n, n.return, c);
        }
        n.flags &= ~Tn;
      }
      a & Xr && (n.flags &= ~Xr);
    }
    function $k(n, a, c) {
      uf = c, cf = a, zt = n, h5(n, a, c), uf = null, cf = null;
    }
    function h5(n, a, c) {
      for (var p = (n.mode & ht) !== De; zt !== null; ) {
        var b = zt, N = b.child;
        if (b.tag === Ee && p) {
          var G = b.memoizedState !== null, Y = G || Tg;
          if (Y) {
            D1(n, a, c);
            continue;
          } else {
            var $ = b.alternate, se = $ !== null && $.memoizedState !== null, he = se || ni, Ae = Tg, He = ni;
            Tg = Y, ni = he, ni && !He && (zt = b, tC(b));
            for (var Ze = N; Ze !== null; )
              zt = Ze, h5(
                Ze,
                // New root; bubble back up to here and stop.
                a,
                c
              ), Ze = Ze.sibling;
            zt = b, Tg = Ae, ni = He, D1(n, a, c);
            continue;
          }
        }
        (b.subtreeFlags & ma) !== gt && N !== null ? (N.return = b, zt = N) : D1(n, a, c);
      }
    }
    function D1(n, a, c) {
      for (; zt !== null; ) {
        var p = zt;
        if ((p.flags & ma) !== gt) {
          var b = p.alternate;
          Un(p);
          try {
            Gk(a, b, p, c);
          } catch (G) {
            hr(p, p.return, G);
          }
          mn();
        }
        if (p === n) {
          zt = null;
          return;
        }
        var N = p.sibling;
        if (N !== null) {
          N.return = p.return, zt = N;
          return;
        }
        zt = p.return;
      }
    }
    function eC(n) {
      for (; zt !== null; ) {
        var a = zt, c = a.child;
        switch (a.tag) {
          case B:
          case ze:
          case ee:
          case Q: {
            if (a.mode & mt)
              try {
                Qs(), ws(Aa, a, a.return);
              } finally {
                Xs(a);
              }
            else
              ws(Aa, a, a.return);
            break;
          }
          case q: {
            df(a, a.return);
            var p = a.stateNode;
            typeof p.componentWillUnmount == "function" && N1(a, a.return, p);
            break;
          }
          case F: {
            df(a, a.return);
            break;
          }
          case Ee: {
            var b = a.memoizedState !== null;
            if (b) {
              p5(n);
              continue;
            }
            break;
          }
        }
        c !== null ? (c.return = a, zt = c) : p5(n);
      }
    }
    function p5(n) {
      for (; zt !== null; ) {
        var a = zt;
        if (a === n) {
          zt = null;
          return;
        }
        var c = a.sibling;
        if (c !== null) {
          c.return = a.return, zt = c;
          return;
        }
        zt = a.return;
      }
    }
    function tC(n) {
      for (; zt !== null; ) {
        var a = zt, c = a.child;
        if (a.tag === Ee) {
          var p = a.memoizedState !== null;
          if (p) {
            m5(n);
            continue;
          }
        }
        c !== null ? (c.return = a, zt = c) : m5(n);
      }
    }
    function m5(n) {
      for (; zt !== null; ) {
        var a = zt;
        Un(a);
        try {
          Vk(a);
        } catch (p) {
          hr(a, a.return, p);
        }
        if (mn(), a === n) {
          zt = null;
          return;
        }
        var c = a.sibling;
        if (c !== null) {
          c.return = a.return, zt = c;
          return;
        }
        zt = a.return;
      }
    }
    function nC(n, a, c, p) {
      zt = a, rC(a, n, c, p);
    }
    function rC(n, a, c, p) {
      for (; zt !== null; ) {
        var b = zt, N = b.child;
        (b.subtreeFlags & ga) !== gt && N !== null ? (N.return = b, zt = N) : aC(n, a, c, p);
      }
    }
    function aC(n, a, c, p) {
      for (; zt !== null; ) {
        var b = zt;
        if ((b.flags & mr) !== gt) {
          Un(b);
          try {
            iC(a, b, c, p);
          } catch (G) {
            hr(b, b.return, G);
          }
          mn();
        }
        if (b === n) {
          zt = null;
          return;
        }
        var N = b.sibling;
        if (N !== null) {
          N.return = b.return, zt = N;
          return;
        }
        zt = b.return;
      }
    }
    function iC(n, a, c, p) {
      switch (a.tag) {
        case B:
        case ze:
        case Q: {
          if (a.mode & mt) {
            Qv();
            try {
              Pu(ei | Na, a);
            } finally {
              Xv(a);
            }
          } else
            Pu(ei | Na, a);
          break;
        }
      }
    }
    function oC(n) {
      zt = n, sC();
    }
    function sC() {
      for (; zt !== null; ) {
        var n = zt, a = n.child;
        if ((zt.flags & Ue) !== gt) {
          var c = n.deletions;
          if (c !== null) {
            for (var p = 0; p < c.length; p++) {
              var b = c[p];
              zt = b, cC(b, n);
            }
            {
              var N = n.alternate;
              if (N !== null) {
                var G = N.child;
                if (G !== null) {
                  N.child = null;
                  do {
                    var Y = G.sibling;
                    G.sibling = null, G = Y;
                  } while (G !== null);
                }
              }
            }
            zt = n;
          }
        }
        (n.subtreeFlags & ga) !== gt && a !== null ? (a.return = n, zt = a) : lC();
      }
    }
    function lC() {
      for (; zt !== null; ) {
        var n = zt;
        (n.flags & mr) !== gt && (Un(n), uC(n), mn());
        var a = n.sibling;
        if (a !== null) {
          a.return = n.return, zt = a;
          return;
        }
        zt = n.return;
      }
    }
    function uC(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          n.mode & mt ? (Qv(), ws(ei | Na, n, n.return), Xv(n)) : ws(ei | Na, n, n.return);
          break;
        }
      }
    }
    function cC(n, a) {
      for (; zt !== null; ) {
        var c = zt;
        Un(c), fC(c, a), mn();
        var p = c.child;
        p !== null ? (p.return = c, zt = p) : dC(n);
      }
    }
    function dC(n) {
      for (; zt !== null; ) {
        var a = zt, c = a.sibling, p = a.return;
        if (l5(a), a === n) {
          zt = null;
          return;
        }
        if (c !== null) {
          c.return = p, zt = c;
          return;
        }
        zt = p;
      }
    }
    function fC(n, a) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          n.mode & mt ? (Qv(), ws(ei, n, a), Xv(n)) : ws(ei, n, a);
          break;
        }
      }
    }
    function hC(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          try {
            Pu(Aa | Na, n);
          } catch (c) {
            hr(n, n.return, c);
          }
          break;
        }
        case q: {
          var a = n.stateNode;
          try {
            a.componentDidMount();
          } catch (c) {
            hr(n, n.return, c);
          }
          break;
        }
      }
    }
    function pC(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          try {
            Pu(ei | Na, n);
          } catch (a) {
            hr(n, n.return, a);
          }
          break;
        }
      }
    }
    function mC(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q: {
          try {
            ws(Aa | Na, n, n.return);
          } catch (c) {
            hr(n, n.return, c);
          }
          break;
        }
        case q: {
          var a = n.stateNode;
          typeof a.componentWillUnmount == "function" && N1(n, n.return, a);
          break;
        }
      }
    }
    function gC(n) {
      switch (n.tag) {
        case B:
        case ze:
        case Q:
          try {
            ws(ei | Na, n, n.return);
          } catch (a) {
            hr(n, n.return, a);
          }
      }
    }
    var Ag = 0, Mg = 1, Pg = 2, Dg = 3, Lg = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var zh = Symbol.for;
      Ag = zh("selector.component"), Mg = zh("selector.has_pseudo_class"), Pg = zh("selector.role"), Dg = zh("selector.test_id"), Lg = zh("selector.text");
    }
    function vC(n) {
      return {
        $$typeof: Ag,
        value: n
      };
    }
    function yC(n) {
      return {
        $$typeof: Mg,
        value: n
      };
    }
    function bC(n) {
      return {
        $$typeof: Pg,
        value: n
      };
    }
    function _C(n) {
      return {
        $$typeof: Lg,
        value: n
      };
    }
    function SC(n) {
      return {
        $$typeof: Dg,
        value: n
      };
    }
    function L1(n) {
      var a = eu(n);
      if (a != null) {
        if (typeof a.memoizedProps["data-testname"] != "string")
          throw new Error("Invalid host root specified. Should be either a React container or a node with a testname attribute.");
        return a;
      } else {
        var c = Ns(n);
        if (c === null)
          throw new Error("Could not find React container within specified host subtree.");
        return c.stateNode.current;
      }
    }
    function O1(n, a) {
      switch (a.$$typeof) {
        case Ag:
          if (n.type === a.value)
            return !0;
          break;
        case Mg:
          return wC(n, a.value);
        case Pg:
          if (n.tag === F) {
            var c = n.stateNode;
            if (Jt(c, a.value))
              return !0;
          }
          break;
        case Lg:
          if (n.tag === F || n.tag === Z) {
            var p = hd(n);
            if (p !== null && p.indexOf(a.value) >= 0)
              return !0;
          }
          break;
        case Dg:
          if (n.tag === F) {
            var b = n.memoizedProps["data-testname"];
            if (typeof b == "string" && b.toLowerCase() === a.value.toLowerCase())
              return !0;
          }
          break;
        default:
          throw new Error("Invalid selector type specified.");
      }
      return !1;
    }
    function F1(n) {
      switch (n.$$typeof) {
        case Ag:
          var a = Ft(n.value) || "Unknown";
          return "<" + a + ">";
        case Mg:
          return ":has(" + (F1(n) || "") + ")";
        case Pg:
          return '[role="' + n.value + '"]';
        case Lg:
          return '"' + n.value + '"';
        case Dg:
          return '[data-testname="' + n.value + '"]';
        default:
          throw new Error("Invalid selector type specified.");
      }
    }
    function g5(n, a) {
      for (var c = [], p = [n, 0], b = 0; b < p.length; ) {
        var N = p[b++], G = p[b++], Y = a[G];
        if (!(N.tag === F && To(N))) {
          for (; Y != null && O1(N, Y); )
            G++, Y = a[G];
          if (G === a.length)
            c.push(N);
          else
            for (var $ = N.child; $ !== null; )
              p.push($, G), $ = $.sibling;
        }
      }
      return c;
    }
    function wC(n, a) {
      for (var c = [n, 0], p = 0; p < c.length; ) {
        var b = c[p++], N = c[p++], G = a[N];
        if (!(b.tag === F && To(b))) {
          for (; G != null && O1(b, G); )
            N++, G = a[N];
          if (N === a.length)
            return !0;
          for (var Y = b.child; Y !== null; )
            c.push(Y, N), Y = Y.sibling;
        }
      }
      return !1;
    }
    function Og(n, a) {
      if (!ui)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var c = L1(n), p = g5(c, a), b = [], N = Array.from(p), G = 0; G < N.length; ) {
        var Y = N[G++];
        if (Y.tag === F) {
          if (To(Y))
            continue;
          b.push(Y.stateNode);
        } else
          for (var $ = Y.child; $ !== null; )
            N.push($), $ = $.sibling;
      }
      return b;
    }
    function xC(n, a) {
      if (!ui)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var c = L1(n), p = 0, b = [], N = [c, 0], G = 0; G < N.length; ) {
        var Y = N[G++], $ = N[G++], se = a[$];
        if (!(Y.tag === F && To(Y)) && (O1(Y, se) && (b.push(F1(se)), $++, $ > p && (p = $)), $ < a.length))
          for (var he = Y.child; he !== null; )
            N.push(he, $), he = he.sibling;
      }
      if (p < a.length) {
        for (var Ae = [], He = p; He < a.length; He++)
          Ae.push(F1(a[He]));
        return `findAllNodes was able to match part of the selector:
` + ("  " + b.join(" > ") + `

`) + `No matching component was found for:
` + ("  " + Ae.join(" > "));
      }
      return null;
    }
    function kC(n, a) {
      if (!ui)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var c = Og(n, a), p = [], b = 0; b < c.length; b++)
        p.push(ci(c[b]));
      for (var N = p.length - 1; N > 0; N--)
        for (var G = p[N], Y = G.x, $ = Y + G.width, se = G.y, he = se + G.height, Ae = N - 1; Ae >= 0; Ae--)
          if (N !== Ae) {
            var He = p[Ae], Ze = He.x, at = Ze + He.width, $e = He.y, Bt = $e + He.height;
            if (Y >= Ze && se >= $e && $ <= at && he <= Bt) {
              p.splice(N, 1);
              break;
            } else if (Y === Ze && G.width === He.width && !(Bt < se) && !($e > he)) {
              $e > se && (He.height += $e - se, He.y = se), Bt < he && (He.height = he - $e), p.splice(N, 1);
              break;
            } else if (se === $e && G.height === He.height && !(at < Y) && !(Ze > $)) {
              Ze > Y && (He.width += Ze - Y, He.x = Y), at < $ && (He.width = $ - Ze), p.splice(N, 1);
              break;
            }
          }
      return p;
    }
    function CC(n, a) {
      if (!ui)
        throw new Error("Test selector API is not supported by this renderer.");
      for (var c = L1(n), p = g5(c, a), b = Array.from(p), N = 0; N < b.length; ) {
        var G = b[N++];
        if (!To(G)) {
          if (G.tag === F) {
            var Y = G.stateNode;
            if (di(Y))
              return !0;
          }
          for (var $ = G.child; $ !== null; )
            b.push($), $ = $.sibling;
        }
      }
      return !1;
    }
    var Fg = [];
    function EC() {
      ui && Fg.forEach(function(n) {
        return n();
      });
    }
    function RC(n, a, c, p) {
      if (!ui)
        throw new Error("Test selector API is not supported by this renderer.");
      var b = Og(n, a), N = rs(b, c, p), G = N.disconnect, Y = N.observe, $ = N.unobserve, se = function() {
        var he = Og(n, a);
        b.forEach(function(Ae) {
          he.indexOf(Ae) < 0 && $(Ae);
        }), he.forEach(function(Ae) {
          b.indexOf(Ae) < 0 && Y(Ae);
        });
      };
      return Fg.push(se), {
        disconnect: function() {
          var he = Fg.indexOf(se);
          he >= 0 && Fg.splice(he, 1), G();
        }
      };
    }
    var TC = u.ReactCurrentActQueue;
    function NC(n) {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), c = typeof jest < "u";
        return $l && c && a !== !1;
      }
    }
    function v5() {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !n && TC.current !== null && h("The current testing environment is not configured to support act(...)"), n;
      }
    }
    var AC = Math.ceil, z1 = u.ReactCurrentDispatcher, B1 = u.ReactCurrentOwner, Dr = u.ReactCurrentBatchConfig, Cs = u.ReactCurrentActQueue, fa = (
      /*             */
      0
    ), U1 = (
      /*               */
      1
    ), ai = (
      /*                */
      2
    ), Ho = (
      /*                */
      4
    ), Gl = 0, Bh = 1, Fc = 2, zg = 3, Uh = 4, y5 = 5, I1 = 6, Sn = fa, Ii = null, Lr = null, Da = Ke, tl = Ke, H1 = K(Ke), La = Gl, Ih = null, Bg = Ke, Hh = Ke, Ug = Ke, Gh = null, $i = null, G1 = 0, b5 = 500, _5 = 1 / 0, MC = 500, Vl = null;
    function ff() {
      _5 = Hr() + MC;
    }
    function S5() {
      return _5;
    }
    var Ig = !1, V1 = null, hf = null, zc = !1, Du = null, Vh = Ke, q1 = [], W1 = null, PC = 50, qh = 0, K1 = null, j1 = !1, Hg = !1, DC = 50, pf = 0, Gg = null, Wh = fr, Vg = Ke, w5 = !1;
    function qg() {
      return Ii;
    }
    function xi() {
      return (Sn & (ai | Ho)) !== fa ? Hr() : (Wh !== fr || (Wh = Hr()), Wh);
    }
    function Lu(n) {
      var a = n.mode;
      if ((a & ht) === De)
        return jt;
      if ((Sn & ai) !== fa && Da !== Ke)
        return yu(Da);
      var c = H() !== A;
      if (c) {
        if (Dr.transition !== null) {
          var p = Dr.transition;
          p._updatedFibers || (p._updatedFibers = /* @__PURE__ */ new Set()), p._updatedFibers.add(n);
        }
        return Vg === rr && (Vg = Md()), Vg;
      }
      var b = $a();
      if (b !== rr)
        return b;
      var N = yl();
      return N;
    }
    function LC(n) {
      var a = n.mode;
      return (a & ht) === De ? jt : Pd();
    }
    function ha(n, a, c, p) {
      l9(), w5 && h("useInsertionEffect must not schedule updates."), j1 && (Hg = !0), Hs(n, c, p), (Sn & ai) !== Ke && n === Ii ? d9(a) : (vi && _c(n, a, c), f9(a), n === Ii && ((Sn & ai) === fa && (Hh = fn(Hh, c)), La === Uh && Ou(n, Da)), eo(n, p), c === jt && Sn === fa && (a.mode & ht) === De && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Cs.isBatchingLegacy && (ff(), Rc()));
    }
    function OC(n, a, c) {
      var p = n.current;
      p.lanes = a, Hs(n, a, c), eo(n, c);
    }
    function FC(n) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Sn & ai) !== fa
      );
    }
    function eo(n, a) {
      var c = n.callbackNode;
      Sm(n, a);
      var p = ua(n, n === Ii ? Da : Ke);
      if (p === Ke) {
        c !== null && z5(c), n.callbackNode = null, n.callbackPriority = rr;
        return;
      }
      var b = Al(p), N = n.callbackPriority;
      if (N === b && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Cs.current !== null && c !== $1)) {
        c == null && N !== jt && h("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      c != null && z5(c);
      var G;
      if (b === jt)
        n.tag === it ? (Cs.isBatchingLegacy !== null && (Cs.didScheduleLegacyUpdate = !0), Wd(C5.bind(null, n))) : qd(C5.bind(null, n)), Wf ? Cs.current !== null ? Cs.current.push(br) : va(function() {
          (Sn & (ai | Ho)) === fa && br();
        }) : Xg(wc, br), G = null;
      else {
        var Y;
        switch (Fd(p)) {
          case Ct:
            Y = wc;
            break;
          case Lo:
            Y = Xi;
            break;
          case Ml:
            Y = Pl;
            break;
          case Od:
            Y = vo;
            break;
          default:
            Y = Pl;
            break;
        }
        G = Xg(Y, x5.bind(null, n));
      }
      n.callbackPriority = b, n.callbackNode = G;
    }
    function x5(n, a) {
      if (H8(), Wh = fr, Vg = Ke, (Sn & (ai | Ho)) !== fa)
        throw new Error("Should not already be working.");
      var c = n.callbackNode, p = nl();
      if (p && n.callbackNode !== c)
        return null;
      var b = ua(n, n === Ii ? Da : Ke);
      if (b === Ke)
        return null;
      var N = !vu(n, b) && !eh(n, b) && !a, G = N ? XC(n, b) : jg(n, b);
      if (G !== Gl) {
        if (G === Fc) {
          var Y = Td(n);
          Y !== Ke && (b = Y, G = Y1(n, Y));
        }
        if (G === Bh) {
          var $ = Ih;
          throw Bc(n, Ke), Ou(n, b), eo(n, Hr()), $;
        }
        if (G === I1)
          Ou(n, b);
        else {
          var se = !vu(n, b), he = n.current.alternate;
          if (se && !BC(he)) {
            if (G = jg(n, b), G === Fc) {
              var Ae = Td(n);
              Ae !== Ke && (b = Ae, G = Y1(n, Ae));
            }
            if (G === Bh) {
              var He = Ih;
              throw Bc(n, Ke), Ou(n, b), eo(n, Hr()), He;
            }
          }
          n.finishedWork = he, n.finishedLanes = b, zC(n, G, b);
        }
      }
      return eo(n, Hr()), n.callbackNode === c ? x5.bind(null, n) : null;
    }
    function Y1(n, a) {
      var c = Gh;
      if (hs(n)) {
        var p = Bc(n, a);
        p.flags |= zn, uu(n.containerInfo);
      }
      var b = jg(n, a);
      if (b !== Fc) {
        var N = $i;
        $i = c, N !== null && k5(N);
      }
      return b;
    }
    function k5(n) {
      $i === null ? $i = n : $i.push.apply($i, n);
    }
    function zC(n, a, c) {
      switch (a) {
        case Gl:
        case Bh:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Fc: {
          Uc(n, $i, Vl);
          break;
        }
        case zg: {
          if (Ou(n, c), Ad(c) && // do not delay if we're inside an act() scope
          !B5()) {
            var p = G1 + b5 - Hr();
            if (p > 10) {
              var b = ua(n, Ke);
              if (b !== Ke)
                break;
              var N = n.suspendedLanes;
              if (!gi(N, c)) {
                xi(), _u(n, N);
                break;
              }
              n.timeoutHandle = ts(Uc.bind(null, n, $i, Vl), p);
              break;
            }
          }
          Uc(n, $i, Vl);
          break;
        }
        case Uh: {
          if (Ou(n, c), km(c))
            break;
          if (!B5()) {
            var G = bm(n, c), Y = G, $ = Hr() - Y, se = s9($) - $;
            if (se > 10) {
              n.timeoutHandle = ts(Uc.bind(null, n, $i, Vl), se);
              break;
            }
          }
          Uc(n, $i, Vl);
          break;
        }
        case y5: {
          Uc(n, $i, Vl);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function BC(n) {
      for (var a = n; ; ) {
        if (a.flags & et) {
          var c = a.updateQueue;
          if (c !== null) {
            var p = c.stores;
            if (p !== null)
              for (var b = 0; b < p.length; b++) {
                var N = p[b], G = N.getSnapshot, Y = N.value;
                try {
                  if (!Ha(G(), Y))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var $ = a.child;
        if (a.subtreeFlags & et && $ !== null) {
          $.return = a, a = $;
          continue;
        }
        if (a === n)
          return !0;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n)
            return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
      return !0;
    }
    function Ou(n, a) {
      a = Di(a, Ug), a = Di(a, Hh), Cm(n, a);
    }
    function C5(n) {
      if (G8(), (Sn & (ai | Ho)) !== fa)
        throw new Error("Should not already be working.");
      nl();
      var a = ua(n, Ke);
      if (!Ua(a, jt))
        return eo(n, Hr()), null;
      var c = jg(n, a);
      if (n.tag !== it && c === Fc) {
        var p = Td(n);
        p !== Ke && (a = p, c = Y1(n, p));
      }
      if (c === Bh) {
        var b = Ih;
        throw Bc(n, Ke), Ou(n, a), eo(n, Hr()), b;
      }
      if (c === I1)
        throw new Error("Root did not complete. This is a bug in React.");
      var N = n.current.alternate;
      return n.finishedWork = N, n.finishedLanes = a, Uc(n, $i, Vl), eo(n, Hr()), null;
    }
    function UC(n, a) {
      a !== Ke && (rh(n, fn(a, jt)), eo(n, Hr()), (Sn & (ai | Ho)) === fa && (ff(), br()));
    }
    function IC(n) {
      var a = $a(), c = Dr.transition;
      try {
        return Dr.transition = null, Mr(Ml), n();
      } finally {
        Mr(a), Dr.transition = c;
      }
    }
    function HC(n, a) {
      var c = Sn;
      Sn |= U1;
      try {
        return n(a);
      } finally {
        Sn = c, Sn === fa && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Cs.isBatchingLegacy && (ff(), Rc());
      }
    }
    function GC(n, a, c, p, b) {
      var N = $a(), G = Dr.transition;
      try {
        return Dr.transition = null, Mr(Ct), n(a, c, p, b);
      } finally {
        Mr(N), Dr.transition = G, Sn === fa && ff();
      }
    }
    function Wg(n) {
      Du !== null && Du.tag === it && (Sn & (ai | Ho)) === fa && nl();
      var a = Sn;
      Sn |= U1;
      var c = Dr.transition, p = $a();
      try {
        return Dr.transition = null, Mr(Ct), n ? n() : void 0;
      } finally {
        Mr(p), Dr.transition = c, Sn = a, (Sn & (ai | Ho)) === fa && br();
      }
    }
    function VC() {
      return (Sn & (ai | Ho)) !== fa;
    }
    function qC(n) {
      var a = Sn;
      Sn |= U1;
      var c = Dr.transition, p = $a();
      try {
        Dr.transition = null, Mr(Ct), n();
      } finally {
        Mr(p), Dr.transition = c, Sn = a, Sn === fa && (ff(), br());
      }
    }
    function Kg(n, a) {
      re(H1, tl, n), tl = fn(tl, a);
    }
    function Z1(n) {
      tl = H1.current, J(H1, n);
    }
    function Bc(n, a) {
      n.finishedWork = null, n.finishedLanes = Ke;
      var c = n.timeoutHandle;
      if (c !== Ts && (n.timeoutHandle = Ts, lo(c)), Lr !== null)
        for (var p = Lr.return; p !== null; ) {
          var b = p.alternate;
          J_(b, p), p = p.return;
        }
      Ii = n;
      var N = Ic(n.current, null);
      return Lr = N, Da = tl = a, La = Gl, Ih = null, Bg = Ke, Hh = Ke, Ug = Ke, Gh = null, $i = null, w8(), xe.discardPendingWarnings(), N;
    }
    function E5(n, a) {
      do {
        var c = Lr;
        try {
          if (Wm(), Zb(), mn(), B1.current = null, c === null || c.return === null) {
            La = Bh, Ih = a, Lr = null;
            return;
          }
          if (k && c.mode & mt && _g(c, !0), x)
            if (Vs(), a !== null && typeof a == "object" && typeof a.then == "function") {
              var p = a;
              Ol(c, p, Da);
            } else
              kc(c, a, Da);
          Q8(n, c.return, c, a, Da), A5(c);
        } catch (b) {
          a = b, Lr === c && c !== null ? (c = c.return, Lr = c) : c = Lr;
          continue;
        }
        return;
      } while (!0);
    }
    function R5() {
      var n = z1.current;
      return z1.current = mg, n === null ? mg : n;
    }
    function T5(n) {
      z1.current = n;
    }
    function WC() {
      G1 = Hr();
    }
    function Kh(n) {
      Bg = fn(n, Bg);
    }
    function KC() {
      La === Gl && (La = zg);
    }
    function X1() {
      (La === Gl || La === zg || La === Fc) && (La = Uh), Ii !== null && (Nd(Bg) || Nd(Hh)) && Ou(Ii, Da);
    }
    function jC(n) {
      La !== Uh && (La = Fc), Gh === null ? Gh = [n] : Gh.push(n);
    }
    function YC() {
      return La === Gl;
    }
    function jg(n, a) {
      var c = Sn;
      Sn |= ai;
      var p = R5();
      if (Ii !== n || Da !== a) {
        if (vi) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (jh(n, Da), b.clear()), ka(n, a);
        }
        Vl = Em(), Bc(n, a);
      }
      Gd(a);
      do
        try {
          ZC();
          break;
        } catch (N) {
          E5(n, N);
        }
      while (!0);
      if (Wm(), Sn = c, T5(p), Lr !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Fo(), Ii = null, Da = Ke, La;
    }
    function ZC() {
      for (; Lr !== null; )
        N5(Lr);
    }
    function XC(n, a) {
      var c = Sn;
      Sn |= ai;
      var p = R5();
      if (Ii !== n || Da !== a) {
        if (vi) {
          var b = n.memoizedUpdaters;
          b.size > 0 && (jh(n, Da), b.clear()), ka(n, a);
        }
        Vl = Em(), ff(), Bc(n, a);
      }
      Gd(a);
      do
        try {
          QC();
          break;
        } catch (N) {
          E5(n, N);
        }
      while (!0);
      return Wm(), T5(p), Sn = c, Lr !== null ? (ch(), Gl) : (Fo(), Ii = null, Da = Ke, La);
    }
    function QC() {
      for (; Lr !== null && !go(); )
        N5(Lr);
    }
    function N5(n) {
      var a = n.alternate;
      Un(n);
      var c;
      (n.mode & mt) !== De ? (Zv(n), c = Q1(a, n, tl), _g(n, !0)) : c = Q1(a, n, tl), mn(), n.memoizedProps = n.pendingProps, c === null ? A5(n) : Lr = c, B1.current = null;
    }
    function A5(n) {
      var a = n;
      do {
        var c = a.alternate, p = a.return;
        if ((a.flags & kt) === gt) {
          Un(a);
          var b = void 0;
          if ((a.mode & mt) === De ? b = Q_(c, a, tl) : (Zv(a), b = Q_(c, a, tl), _g(a, !1)), mn(), b !== null) {
            Lr = b;
            return;
          }
        } else {
          var N = Nk(c, a);
          if (N !== null) {
            N.flags &= Ge, Lr = N;
            return;
          }
          if ((a.mode & mt) !== De) {
            _g(a, !1);
            for (var G = a.actualDuration, Y = a.child; Y !== null; )
              G += Y.actualDuration, Y = Y.sibling;
            a.actualDuration = G;
          }
          if (p !== null)
            p.flags |= kt, p.subtreeFlags = gt, p.deletions = null;
          else {
            La = I1, Lr = null;
            return;
          }
        }
        var $ = a.sibling;
        if ($ !== null) {
          Lr = $;
          return;
        }
        a = p, Lr = a;
      } while (a !== null);
      La === Gl && (La = y5);
    }
    function Uc(n, a, c) {
      var p = $a(), b = Dr.transition;
      try {
        Dr.transition = null, Mr(Ct), JC(n, a, c, p);
      } finally {
        Dr.transition = b, Mr(p);
      }
      return null;
    }
    function JC(n, a, c, p) {
      do
        nl();
      while (Du !== null);
      if (u9(), (Sn & (ai | Ho)) !== fa)
        throw new Error("Should not already be working.");
      var b = n.finishedWork, N = n.finishedLanes;
      if (lh(N), b === null)
        return Mm(), null;
      if (N === Ke && h("root.finishedLanes should not be empty during a commit. This is a bug in React."), n.finishedWork = null, n.finishedLanes = Ke, b === n.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      n.callbackNode = null, n.callbackPriority = rr;
      var G = fn(b.lanes, b.childLanes);
      Ia(n, G), n === Ii && (Ii = null, Lr = null, Da = Ke), ((b.subtreeFlags & ga) !== gt || (b.flags & ga) !== gt) && (zc || (zc = !0, W1 = c, Xg(Pl, function() {
        return nl(), null;
      })));
      var Y = (b.subtreeFlags & (Ti | Qo | ma | ga)) !== gt, $ = (b.flags & (Ti | Qo | ma | ga)) !== gt;
      if (Y || $) {
        var se = Dr.transition;
        Dr.transition = null;
        var he = $a();
        Mr(Ct);
        var Ae = Sn;
        Sn |= Ho, B1.current = null, zk(n, b), __(), Jk(n, b, N), Ar(n.containerInfo), n.current = b, Hd(N), $k(b, n, N), uh(), Oo(), Sn = Ae, Mr(he), Dr.transition = se;
      } else
        n.current = b, __();
      var He = zc;
      if (zc ? (zc = !1, Du = n, Vh = N) : (pf = 0, Gg = null), G = n.pendingLanes, G === Ke && (hf = null), He || L5(n.current, !1), Id(b.stateNode, p), vi && n.memoizedUpdaters.clear(), EC(), eo(n, Hr()), a !== null)
        for (var Ze = n.onRecoverableError, at = 0; at < a.length; at++) {
          var $e = a[at], Bt = $e.stack, nn = $e.digest;
          Ze($e.value, {
            componentStack: Bt,
            digest: nn
          });
        }
      if (Ig) {
        Ig = !1;
        var Zt = V1;
        throw V1 = null, Zt;
      }
      return Ua(Vh, jt) && n.tag !== it && nl(), G = n.pendingLanes, Ua(G, jt) ? (I8(), n === K1 ? qh++ : (qh = 0, K1 = n)) : qh = 0, br(), Mm(), null;
    }
    function nl() {
      if (Du !== null) {
        var n = Fd(Vh), a = Tm(Ml, n), c = Dr.transition, p = $a();
        try {
          return Dr.transition = null, Mr(a), e9();
        } finally {
          Mr(p), Dr.transition = c;
        }
      }
      return !1;
    }
    function $C(n) {
      q1.push(n), zc || (zc = !0, Xg(Pl, function() {
        return nl(), null;
      }));
    }
    function e9() {
      if (Du === null)
        return !1;
      var n = W1;
      W1 = null;
      var a = Du, c = Vh;
      if (Du = null, Vh = Ke, (Sn & (ai | Ho)) !== fa)
        throw new Error("Cannot flush passive effects while already rendering.");
      j1 = !0, Hg = !1, Cc(c);
      var p = Sn;
      Sn |= Ho, oC(a.current), nC(a, a.current, c, n);
      {
        var b = q1;
        q1 = [];
        for (var N = 0; N < b.length; N++) {
          var G = b[N];
          Hk(a, G);
        }
      }
      yi(), L5(a.current, !0), Sn = p, br(), Hg ? a === Gg ? pf++ : (pf = 0, Gg = a) : pf = 0, j1 = !1, Hg = !1, xc(a);
      {
        var Y = a.current.stateNode;
        Y.effectDuration = 0, Y.passiveEffectDuration = 0;
      }
      return !0;
    }
    function M5(n) {
      return hf !== null && hf.has(n);
    }
    function t9(n) {
      hf === null ? hf = /* @__PURE__ */ new Set([n]) : hf.add(n);
    }
    function n9(n) {
      Ig || (Ig = !0, V1 = n);
    }
    var r9 = n9;
    function P5(n, a, c) {
      var p = Lc(c, a), b = T_(n, p, jt), N = Ru(n, b, jt), G = xi();
      N !== null && (Hs(N, jt, G), eo(N, G));
    }
    function hr(n, a, c) {
      if (Lk(c), Yh(!1), n.tag === I) {
        P5(n, n, c);
        return;
      }
      var p = null;
      for (p = a; p !== null; ) {
        if (p.tag === I) {
          P5(p, n, c);
          return;
        } else if (p.tag === q) {
          var b = p.type, N = p.stateNode;
          if (typeof b.getDerivedStateFromError == "function" || typeof N.componentDidCatch == "function" && !M5(N)) {
            var G = Lc(c, n), Y = h1(p, G, jt), $ = Ru(p, Y, jt), se = xi();
            $ !== null && (Hs($, jt, se), eo($, se));
            return;
          }
        }
        p = p.return;
      }
      h(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, c);
    }
    function a9(n, a, c) {
      var p = n.pingCache;
      p !== null && p.delete(a);
      var b = xi();
      _u(n, c), h9(n), Ii === n && gi(Da, c) && (La === Uh || La === zg && Ad(Da) && Hr() - G1 < b5 ? Bc(n, Ke) : Ug = fn(Ug, c)), eo(n, b);
    }
    function D5(n, a) {
      a === rr && (a = LC(n));
      var c = xi(), p = Bi(n, a);
      p !== null && (Hs(p, a, c), eo(p, c));
    }
    function i9(n) {
      var a = n.memoizedState, c = rr;
      a !== null && (c = a.retryLane), D5(n, c);
    }
    function o9(n, a) {
      var c = rr, p;
      switch (n.tag) {
        case j:
          p = n.stateNode;
          var b = n.memoizedState;
          b !== null && (c = b.retryLane);
          break;
        case Me:
          p = n.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      p !== null && p.delete(a), D5(n, c);
    }
    function s9(n) {
      return n < 120 ? 120 : n < 480 ? 480 : n < 1080 ? 1080 : n < 1920 ? 1920 : n < 3e3 ? 3e3 : n < 4320 ? 4320 : AC(n / 1960) * 1960;
    }
    function l9() {
      if (qh > PC)
        throw qh = 0, K1 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      pf > DC && (pf = 0, Gg = null, h("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function u9() {
      xe.flushLegacyContextWarning(), xe.flushPendingUnsafeLifecycleWarnings();
    }
    function L5(n, a) {
      Un(n), Yg(n, Nr, mC), a && Yg(n, vr, gC), Yg(n, Nr, hC), a && Yg(n, vr, pC), mn();
    }
    function Yg(n, a, c) {
      for (var p = n, b = null; p !== null; ) {
        var N = p.subtreeFlags & a;
        p !== b && p.child !== null && N !== gt ? p = p.child : ((p.flags & a) !== gt && c(p), p.sibling !== null ? p = p.sibling : p = b = p.return);
      }
    }
    var Zg = null;
    function O5(n) {
      {
        if ((Sn & ai) !== fa || !(n.mode & ht))
          return;
        var a = n.tag;
        if (a !== X && a !== I && a !== q && a !== B && a !== ze && a !== ee && a !== Q)
          return;
        var c = qe(n) || "ReactComponent";
        if (Zg !== null) {
          if (Zg.has(c))
            return;
          Zg.add(c);
        } else
          Zg = /* @__PURE__ */ new Set([c]);
        var p = St;
        try {
          Un(n), h("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          p ? Un(n) : mn();
        }
      }
    }
    var Q1;
    {
      var c9 = null;
      Q1 = function(n, a, c) {
        var p = V5(c9, a);
        try {
          return j_(n, a, c);
        } catch (N) {
          if (Om() || N !== null && typeof N == "object" && typeof N.then == "function")
            throw N;
          if (Wm(), Zb(), J_(n, a), V5(a, p), a.mode & mt && Zv(a), t5(null, j_, null, n, a, c), Pk()) {
            var b = n5();
            typeof b == "object" && b !== null && b._suppressLogging && typeof N == "object" && N !== null && !N._suppressLogging && (N._suppressLogging = !0);
          }
          throw N;
        }
      };
    }
    var F5 = !1, J1;
    J1 = /* @__PURE__ */ new Set();
    function d9(n) {
      if (rn && !z8())
        switch (n.tag) {
          case B:
          case ze:
          case Q: {
            var a = Lr && qe(Lr) || "Unknown", c = a;
            if (!J1.has(c)) {
              J1.add(c);
              var p = qe(n) || "Unknown";
              h("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", p, a, a);
            }
            break;
          }
          case q: {
            F5 || (h("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), F5 = !0);
            break;
          }
        }
    }
    function jh(n, a) {
      if (vi) {
        var c = n.memoizedUpdaters;
        c.forEach(function(p) {
          _c(n, p, a);
        });
      }
    }
    var $1 = {};
    function Xg(n, a) {
      {
        var c = Cs.current;
        return c !== null ? (c.push(a), $1) : zd(n, a);
      }
    }
    function z5(n) {
      if (n !== $1)
        return Ca(n);
    }
    function B5() {
      return Cs.current !== null;
    }
    function f9(n) {
      {
        if (n.mode & ht) {
          if (!v5())
            return;
        } else if (!NC() || Sn !== fa || n.tag !== B && n.tag !== ze && n.tag !== Q)
          return;
        if (Cs.current === null) {
          var a = St;
          try {
            Un(n), h(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, qe(n));
          } finally {
            a ? Un(n) : mn();
          }
        }
      }
    }
    function h9(n) {
      n.tag !== it && v5() && Cs.current === null && h(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function Yh(n) {
      w5 = n;
    }
    var Go = null, mf = null, p9 = function(n) {
      Go = n;
    };
    function gf(n) {
      {
        if (Go === null)
          return n;
        var a = Go(n);
        return a === void 0 ? n : a.current;
      }
    }
    function ey(n) {
      return gf(n);
    }
    function ty(n) {
      {
        if (Go === null)
          return n;
        var a = Go(n);
        if (a === void 0) {
          if (n != null && typeof n.render == "function") {
            var c = gf(n.render);
            if (n.render !== c) {
              var p = {
                $$typeof: Wt,
                render: c
              };
              return n.displayName !== void 0 && (p.displayName = n.displayName), p;
            }
          }
          return n;
        }
        return a.current;
      }
    }
    function U5(n, a) {
      {
        if (Go === null)
          return !1;
        var c = n.elementType, p = a.type, b = !1, N = typeof p == "object" && p !== null ? p.$$typeof : null;
        switch (n.tag) {
          case q: {
            typeof p == "function" && (b = !0);
            break;
          }
          case B: {
            (typeof p == "function" || N === gn) && (b = !0);
            break;
          }
          case ze: {
            (N === Wt || N === gn) && (b = !0);
            break;
          }
          case ee:
          case Q: {
            (N === Pn || N === gn) && (b = !0);
            break;
          }
          default:
            return !1;
        }
        if (b) {
          var G = Go(c);
          if (G !== void 0 && G === Go(p))
            return !0;
        }
        return !1;
      }
    }
    function I5(n) {
      {
        if (Go === null || typeof WeakSet != "function")
          return;
        mf === null && (mf = /* @__PURE__ */ new WeakSet()), mf.add(n);
      }
    }
    var m9 = function(n, a) {
      {
        if (Go === null)
          return;
        var c = a.staleFamilies, p = a.updatedFamilies;
        nl(), Wg(function() {
          ny(n.current, p, c);
        });
      }
    }, g9 = function(n, a) {
      {
        if (n.context !== ke)
          return;
        nl(), Wg(function() {
          K5(a, n, null, null);
        });
      }
    };
    function ny(n, a, c) {
      {
        var p = n.alternate, b = n.child, N = n.sibling, G = n.tag, Y = n.type, $ = null;
        switch (G) {
          case B:
          case Q:
          case q:
            $ = Y;
            break;
          case ze:
            $ = Y.render;
            break;
        }
        if (Go === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var se = !1, he = !1;
        if ($ !== null) {
          var Ae = Go($);
          Ae !== void 0 && (c.has(Ae) ? he = !0 : a.has(Ae) && (G === q ? he = !0 : se = !0));
        }
        if (mf !== null && (mf.has(n) || p !== null && mf.has(p)) && (he = !0), he && (n._debugNeedsRemount = !0), he || se) {
          var He = Bi(n, jt);
          He !== null && ha(He, n, jt, fr);
        }
        b !== null && !he && ny(b, a, c), N !== null && ny(N, a, c);
      }
    }
    var v9 = function(n, a) {
      {
        var c = /* @__PURE__ */ new Set(), p = new Set(a.map(function(b) {
          return b.current;
        }));
        return ry(n.current, p, c), c;
      }
    };
    function ry(n, a, c) {
      {
        var p = n.child, b = n.sibling, N = n.tag, G = n.type, Y = null;
        switch (N) {
          case B:
          case Q:
          case q:
            Y = G;
            break;
          case ze:
            Y = G.render;
            break;
        }
        var $ = !1;
        Y !== null && a.has(Y) && ($ = !0), $ ? y9(n, c) : p !== null && ry(p, a, c), b !== null && ry(b, a, c);
      }
    }
    function y9(n, a) {
      {
        var c = b9(n, a);
        if (c)
          return;
        for (var p = n; ; ) {
          switch (p.tag) {
            case F:
              a.add(p.stateNode);
              return;
            case U:
              a.add(p.stateNode.containerInfo);
              return;
            case I:
              a.add(p.stateNode.containerInfo);
              return;
          }
          if (p.return === null)
            throw new Error("Expected to reach root first.");
          p = p.return;
        }
      }
    }
    function b9(n, a) {
      for (var c = n, p = !1; ; ) {
        if (c.tag === F)
          p = !0, a.add(c.stateNode);
        else if (c.child !== null) {
          c.child.return = c, c = c.child;
          continue;
        }
        if (c === n)
          return p;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === n)
            return p;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
      return !1;
    }
    var ay;
    {
      ay = !1;
      try {
        var H5 = Object.preventExtensions({});
      } catch {
        ay = !0;
      }
    }
    function _9(n, a, c, p) {
      this.tag = n, this.key = c, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = a, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = p, this.flags = gt, this.subtreeFlags = gt, this.deletions = null, this.lanes = Ke, this.childLanes = Ke, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !ay && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var yo = function(n, a, c, p) {
      return new _9(n, a, c, p);
    };
    function iy(n) {
      var a = n.prototype;
      return !!(a && a.isReactComponent);
    }
    function S9(n) {
      return typeof n == "function" && !iy(n) && n.defaultProps === void 0;
    }
    function w9(n) {
      if (typeof n == "function")
        return iy(n) ? q : B;
      if (n != null) {
        var a = n.$$typeof;
        if (a === Wt)
          return ze;
        if (a === Pn)
          return ee;
      }
      return X;
    }
    function Ic(n, a) {
      var c = n.alternate;
      c === null ? (c = yo(n.tag, a, n.key, n.mode), c.elementType = n.elementType, c.type = n.type, c.stateNode = n.stateNode, c._debugSource = n._debugSource, c._debugOwner = n._debugOwner, c._debugHookTypes = n._debugHookTypes, c.alternate = n, n.alternate = c) : (c.pendingProps = a, c.type = n.type, c.flags = gt, c.subtreeFlags = gt, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1), c.flags = n.flags & Qr, c.childLanes = n.childLanes, c.lanes = n.lanes, c.child = n.child, c.memoizedProps = n.memoizedProps, c.memoizedState = n.memoizedState, c.updateQueue = n.updateQueue;
      var p = n.dependencies;
      switch (c.dependencies = p === null ? null : {
        lanes: p.lanes,
        firstContext: p.firstContext
      }, c.sibling = n.sibling, c.index = n.index, c.ref = n.ref, c.selfBaseDuration = n.selfBaseDuration, c.treeBaseDuration = n.treeBaseDuration, c._debugNeedsRemount = n._debugNeedsRemount, c.tag) {
        case X:
        case B:
        case Q:
          c.type = gf(n.type);
          break;
        case q:
          c.type = ey(n.type);
          break;
        case ze:
          c.type = ty(n.type);
          break;
      }
      return c;
    }
    function x9(n, a) {
      n.flags &= Qr | Tn;
      var c = n.alternate;
      if (c === null)
        n.childLanes = Ke, n.lanes = a, n.child = null, n.subtreeFlags = gt, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null, n.selfBaseDuration = 0, n.treeBaseDuration = 0;
      else {
        n.childLanes = c.childLanes, n.lanes = c.lanes, n.child = c.child, n.subtreeFlags = gt, n.deletions = null, n.memoizedProps = c.memoizedProps, n.memoizedState = c.memoizedState, n.updateQueue = c.updateQueue, n.type = c.type;
        var p = c.dependencies;
        n.dependencies = p === null ? null : {
          lanes: p.lanes,
          firstContext: p.firstContext
        }, n.selfBaseDuration = c.selfBaseDuration, n.treeBaseDuration = c.treeBaseDuration;
      }
      return n;
    }
    function k9(n, a, c) {
      var p;
      return n === Mt ? (p = ht, a === !0 && (p |= Ot, p |= tn)) : p = De, vi && (p |= mt), yo(I, null, null, p);
    }
    function oy(n, a, c, p, b, N) {
      var G = X, Y = n;
      if (typeof n == "function")
        iy(n) ? (G = q, Y = ey(Y)) : Y = gf(Y);
      else if (typeof n == "string")
        G = F;
      else
        e: switch (n) {
          case st:
            return Fu(c.children, b, N, a);
          case bt:
            G = ie, b |= Ot, (b & ht) !== De && (b |= tn);
            break;
          case Xt:
            return C9(c, b, N, a);
          case bn:
            return E9(c, b, N, a);
          case Yr:
            return R9(c, b, N, a);
          case cr:
            return G5(c, b, N, a);
          case er:
          // eslint-disable-next-line no-fallthrough
          case vn:
          // eslint-disable-next-line no-fallthrough
          case ln:
          // eslint-disable-next-line no-fallthrough
          case dr:
          // eslint-disable-next-line no-fallthrough
          case ir:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof n == "object" && n !== null)
              switch (n.$$typeof) {
                case Lt:
                  G = ce;
                  break e;
                case qn:
                  G = ue;
                  break e;
                case Wt:
                  G = ze, Y = ty(Y);
                  break e;
                case Pn:
                  G = ee;
                  break e;
                case gn:
                  G = oe, Y = null;
                  break e;
              }
            var $ = "";
            {
              (n === void 0 || typeof n == "object" && n !== null && Object.keys(n).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var se = p ? qe(p) : null;
              se && ($ += `

Check the render method of \`` + se + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (n == null ? n : typeof n) + "." + $));
          }
        }
      var he = yo(G, c, a, b);
      return he.elementType = n, he.type = Y, he.lanes = N, he._debugOwner = p, he;
    }
    function sy(n, a, c) {
      var p = null;
      p = n._owner;
      var b = n.type, N = n.key, G = n.props, Y = oy(b, N, G, p, a, c);
      return Y._debugSource = n._source, Y._debugOwner = n._owner, Y;
    }
    function Fu(n, a, c, p) {
      var b = yo(te, n, p, a);
      return b.lanes = c, b;
    }
    function C9(n, a, c, p) {
      typeof n.id != "string" && h('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof n.id);
      var b = yo(W, n, p, a | mt);
      return b.elementType = Xt, b.lanes = c, b.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, b;
    }
    function E9(n, a, c, p) {
      var b = yo(j, n, p, a);
      return b.elementType = bn, b.lanes = c, b;
    }
    function R9(n, a, c, p) {
      var b = yo(Me, n, p, a);
      return b.elementType = Yr, b.lanes = c, b;
    }
    function G5(n, a, c, p) {
      var b = yo(Ee, n, p, a);
      b.elementType = cr, b.lanes = c;
      var N = {
        isHidden: !1
      };
      return b.stateNode = N, b;
    }
    function ly(n, a, c) {
      var p = yo(Z, n, null, a);
      return p.lanes = c, p;
    }
    function T9() {
      var n = yo(F, null, null, De);
      return n.elementType = "DELETED", n;
    }
    function N9(n) {
      var a = yo(pe, null, null, De);
      return a.stateNode = n, a;
    }
    function uy(n, a, c) {
      var p = n.children !== null ? n.children : [], b = yo(U, p, n.key, a);
      return b.lanes = c, b.stateNode = {
        containerInfo: n.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: n.implementation
      }, b;
    }
    function V5(n, a) {
      return n === null && (n = yo(X, null, null, De)), n.tag = a.tag, n.key = a.key, n.elementType = a.elementType, n.type = a.type, n.stateNode = a.stateNode, n.return = a.return, n.child = a.child, n.sibling = a.sibling, n.index = a.index, n.ref = a.ref, n.pendingProps = a.pendingProps, n.memoizedProps = a.memoizedProps, n.updateQueue = a.updateQueue, n.memoizedState = a.memoizedState, n.dependencies = a.dependencies, n.mode = a.mode, n.flags = a.flags, n.subtreeFlags = a.subtreeFlags, n.deletions = a.deletions, n.lanes = a.lanes, n.childLanes = a.childLanes, n.alternate = a.alternate, n.actualDuration = a.actualDuration, n.actualStartTime = a.actualStartTime, n.selfBaseDuration = a.selfBaseDuration, n.treeBaseDuration = a.treeBaseDuration, n._debugSource = a._debugSource, n._debugOwner = a._debugOwner, n._debugNeedsRemount = a._debugNeedsRemount, n._debugHookTypes = a._debugHookTypes, n;
    }
    function A9(n, a, c, p, b) {
      this.tag = a, this.containerInfo = n, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Ts, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = rr, this.eventTimes = bu(Ke), this.expirationTimes = bu(fr), this.pendingLanes = Ke, this.suspendedLanes = Ke, this.pingedLanes = Ke, this.expiredLanes = Ke, this.mutableReadLanes = Ke, this.finishedLanes = Ke, this.entangledLanes = Ke, this.entanglements = bu(Ke), this.identifierPrefix = p, this.onRecoverableError = b, sa && (this.mutableSourceEagerHydrationData = null), this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var N = this.pendingUpdatersLaneMap = [], G = 0; G < Zi; G++)
          N.push(/* @__PURE__ */ new Set());
      }
      switch (a) {
        case Mt:
          this._debugRootType = c ? "hydrateRoot()" : "createRoot()";
          break;
        case it:
          this._debugRootType = c ? "hydrate()" : "render()";
          break;
      }
    }
    function q5(n, a, c, p, b, N, G, Y, $, se) {
      var he = new A9(n, a, c, Y, $), Ae = k9(a, N);
      he.current = Ae, Ae.stateNode = he;
      {
        var He = {
          element: p,
          isDehydrated: c,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        Ae.memoizedState = He;
      }
      return bv(Ae), he;
    }
    var M9 = "18.3.1";
    function P9(n, a, c) {
      var p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return m8(p), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: rt,
        key: p == null ? null : "" + p,
        children: n,
        containerInfo: a,
        implementation: c
      };
    }
    var cy, dy;
    cy = !1, dy = {};
    function W5(n) {
      if (!n)
        return ke;
      var a = S(n), c = pt(a);
      if (a.tag === q) {
        var p = a.type;
        if (Te(p))
          return nt(a, p, c);
      }
      return c;
    }
    function D9(n) {
      var a = S(n);
      if (a === void 0) {
        if (typeof n.render == "function")
          throw new Error("Unable to find node on an unmounted component.");
        var c = Object.keys(n).join(",");
        throw new Error("Argument appears to not be a ReactComponent. Keys: " + c);
      }
      var p = qi(a);
      return p === null ? null : p.stateNode;
    }
    function L9(n, a) {
      {
        var c = S(n);
        if (c === void 0) {
          if (typeof n.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var p = Object.keys(n).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + p);
        }
        var b = qi(c);
        if (b === null)
          return null;
        if (b.mode & Ot) {
          var N = qe(c) || "Component";
          if (!dy[N]) {
            dy[N] = !0;
            var G = St;
            try {
              Un(b), c.mode & Ot ? h("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, N) : h("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", a, a, N);
            } finally {
              G ? Un(G) : mn();
            }
          }
        }
        return b.stateNode;
      }
    }
    function O9(n, a, c, p, b, N, G, Y) {
      var $ = !1, se = null;
      return q5(n, a, $, se, c, p, b, N, G);
    }
    function F9(n, a, c, p, b, N, G, Y, $, se) {
      var he = !0, Ae = q5(c, p, he, n, b, N, G, Y, $);
      Ae.context = W5(null);
      var He = Ae.current, Ze = xi(), at = Lu(He), $e = Il(Ze, at);
      return $e.callback = a ?? null, Ru(He, $e, at), OC(Ae, at, Ze), Ae;
    }
    function K5(n, a, c, p) {
      Ud(a, n);
      var b = a.current, N = xi(), G = Lu(b);
      Su(G);
      var Y = W5(c);
      a.context === null ? a.context = Y : a.pendingContext = Y, rn && St !== null && !cy && (cy = !0, h(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, qe(St) || "Unknown"));
      var $ = Il(N, G);
      $.payload = {
        element: n
      }, p = p === void 0 ? null : p, p !== null && (typeof p != "function" && h("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", p), $.callback = p);
      var se = Ru(b, $, G);
      return se !== null && (ha(se, b, G, N), Xm(se, b, G)), G;
    }
    function z9(n) {
      var a = n.current;
      if (!a.child)
        return null;
      switch (a.child.tag) {
        case F:
          return Ni(a.child.stateNode);
        default:
          return a.child.stateNode;
      }
    }
    function B9(n) {
      switch (n.tag) {
        case I: {
          var a = n.stateNode;
          if (hs(a)) {
            var c = wm(a);
            UC(a, c);
          }
          break;
        }
        case j: {
          Wg(function() {
            var b = Bi(n, jt);
            if (b !== null) {
              var N = xi();
              ha(b, n, jt, N);
            }
          });
          var p = jt;
          Qg(n, p);
          break;
        }
      }
    }
    function j5(n, a) {
      var c = n.memoizedState;
      c !== null && c.dehydrated !== null && (c.retryLane = bc(c.retryLane, a));
    }
    function Qg(n, a) {
      j5(n, a);
      var c = n.alternate;
      c && j5(c, a);
    }
    function U9(n) {
      if (n.tag === j) {
        var a = jt, c = Bi(n, a);
        if (c !== null) {
          var p = xi();
          ha(c, n, a, p);
        }
        Qg(n, a);
      }
    }
    function I9(n) {
      if (n.tag === j) {
        var a = Nl, c = Bi(n, a);
        if (c !== null) {
          var p = xi();
          ha(c, n, a, p);
        }
        Qg(n, a);
      }
    }
    function H9(n) {
      if (n.tag === j) {
        var a = Lu(n), c = Bi(n, a);
        if (c !== null) {
          var p = xi();
          ha(c, n, a, p);
        }
        Qg(n, a);
      }
    }
    function G9(n) {
      var a = vl(n);
      return a === null ? null : a.stateNode;
    }
    var Y5 = function(n) {
      return null;
    };
    function Z5(n) {
      return Y5(n);
    }
    var X5 = function(n) {
      return !1;
    };
    function Q5(n) {
      return X5(n);
    }
    var J5 = null, $5 = null, eS = null, tS = null, nS = null, rS = null, aS = null, iS = null, oS = null;
    {
      var sS = function(n, a, c) {
        var p = a[c], b = wr(n) ? n.slice() : E({}, n);
        return c + 1 === a.length ? (wr(b) ? b.splice(p, 1) : delete b[p], b) : (b[p] = sS(n[p], a, c + 1), b);
      }, lS = function(n, a) {
        return sS(n, a, 0);
      }, uS = function(n, a, c, p) {
        var b = a[p], N = wr(n) ? n.slice() : E({}, n);
        if (p + 1 === a.length) {
          var G = c[p];
          N[G] = N[b], wr(N) ? N.splice(b, 1) : delete N[b];
        } else
          N[b] = uS(
            // $FlowFixMe number or string is fine here
            n[b],
            a,
            c,
            p + 1
          );
        return N;
      }, cS = function(n, a, c) {
        if (a.length !== c.length) {
          g("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var p = 0; p < c.length - 1; p++)
            if (a[p] !== c[p]) {
              g("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return uS(n, a, c, 0);
      }, dS = function(n, a, c, p) {
        if (c >= a.length)
          return p;
        var b = a[c], N = wr(n) ? n.slice() : E({}, n);
        return N[b] = dS(n[b], a, c + 1, p), N;
      }, fS = function(n, a, c) {
        return dS(n, a, 0, c);
      }, fy = function(n, a) {
        for (var c = n.memoizedState; c !== null && a > 0; )
          c = c.next, a--;
        return c;
      };
      J5 = function(n, a, c, p) {
        var b = fy(n, a);
        if (b !== null) {
          var N = fS(b.memoizedState, c, p);
          b.memoizedState = N, b.baseState = N, n.memoizedProps = E({}, n.memoizedProps);
          var G = Bi(n, jt);
          G !== null && ha(G, n, jt, fr);
        }
      }, $5 = function(n, a, c) {
        var p = fy(n, a);
        if (p !== null) {
          var b = lS(p.memoizedState, c);
          p.memoizedState = b, p.baseState = b, n.memoizedProps = E({}, n.memoizedProps);
          var N = Bi(n, jt);
          N !== null && ha(N, n, jt, fr);
        }
      }, eS = function(n, a, c, p) {
        var b = fy(n, a);
        if (b !== null) {
          var N = cS(b.memoizedState, c, p);
          b.memoizedState = N, b.baseState = N, n.memoizedProps = E({}, n.memoizedProps);
          var G = Bi(n, jt);
          G !== null && ha(G, n, jt, fr);
        }
      }, tS = function(n, a, c) {
        n.pendingProps = fS(n.memoizedProps, a, c), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var p = Bi(n, jt);
        p !== null && ha(p, n, jt, fr);
      }, nS = function(n, a) {
        n.pendingProps = lS(n.memoizedProps, a), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var c = Bi(n, jt);
        c !== null && ha(c, n, jt, fr);
      }, rS = function(n, a, c) {
        n.pendingProps = cS(n.memoizedProps, a, c), n.alternate && (n.alternate.pendingProps = n.pendingProps);
        var p = Bi(n, jt);
        p !== null && ha(p, n, jt, fr);
      }, aS = function(n) {
        var a = Bi(n, jt);
        a !== null && ha(a, n, jt, fr);
      }, iS = function(n) {
        Y5 = n;
      }, oS = function(n) {
        X5 = n;
      };
    }
    function V9(n) {
      var a = qi(n);
      return a === null ? null : a.stateNode;
    }
    function q9(n) {
      return null;
    }
    function W9() {
      return St;
    }
    function K9(n) {
      var a = n.findFiberByHostInstance, c = u.ReactCurrentDispatcher;
      return Bd({
        bundleType: n.bundleType,
        version: n.version,
        rendererPackageName: n.rendererPackageName,
        rendererConfig: n.rendererConfig,
        overrideHookState: J5,
        overrideHookStateDeletePath: $5,
        overrideHookStateRenamePath: eS,
        overrideProps: tS,
        overridePropsDeletePath: nS,
        overridePropsRenamePath: rS,
        setErrorHandler: iS,
        setSuspenseHandler: oS,
        scheduleUpdate: aS,
        currentDispatcherRef: c,
        findHostInstanceByFiber: V9,
        findFiberByHostInstance: a || q9,
        // React Refresh
        findHostInstancesForRefresh: v9,
        scheduleRefresh: m9,
        scheduleRoot: g9,
        setRefreshHandler: p9,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: W9,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: M9
      });
    }
    return r.attemptContinuousHydration = I9, r.attemptDiscreteHydration = U9, r.attemptHydrationAtCurrentPriority = H9, r.attemptSynchronousHydration = B9, r.batchedUpdates = HC, r.createComponentSelector = vC, r.createContainer = O9, r.createHasPseudoClassSelector = yC, r.createHydrationContainer = F9, r.createPortal = P9, r.createRoleSelector = bC, r.createTestNameSelector = SC, r.createTextSelector = _C, r.deferredUpdates = IC, r.discreteUpdates = GC, r.findAllNodes = Og, r.findBoundingRects = kC, r.findHostInstance = D9, r.findHostInstanceWithNoPortals = G9, r.findHostInstanceWithWarning = L9, r.flushControlled = qC, r.flushPassiveEffects = nl, r.flushSync = Wg, r.focusWithin = CC, r.getCurrentUpdatePriority = $a, r.getFindAllNodesFailureDescription = xC, r.getPublicRootInstance = z9, r.injectIntoDevTools = K9, r.isAlreadyRendering = VC, r.observeVisibleRects = RC, r.registerMutableSourceForHydration = M8, r.runWithPriority = ah, r.shouldError = Z5, r.shouldSuspend = Q5, r.updateContainer = K5, r;
  })), Gy.exports;
}
var I4;
function QA() {
  return I4 || (I4 = 1, process.env.NODE_ENV === "production" ? s0.exports = ZA() : s0.exports = XA()), s0.exports;
}
var JA = QA();
const $A = /* @__PURE__ */ vm(JA);
var u0 = { exports: {} }, Bu = {};
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H4;
function eM() {
  return H4 || (H4 = 1, Bu.ConcurrentRoot = 1, Bu.ContinuousEventPriority = 4, Bu.DefaultEventPriority = 16, Bu.DiscreteEventPriority = 1, Bu.IdleEventPriority = 536870912, Bu.LegacyRoot = 0), Bu;
}
var Uu = {};
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var G4;
function tM() {
  return G4 || (G4 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = (
      /*                        */
      1
    ), t = (
      /*             */
      4
    ), r = (
      /*                     */
      16
    ), o = (
      /*                        */
      536870912
    ), l = e, u = t, d = r, f = o, g = 0, h = 1;
    Uu.ConcurrentRoot = h, Uu.ContinuousEventPriority = u, Uu.DefaultEventPriority = d, Uu.DiscreteEventPriority = l, Uu.IdleEventPriority = f, Uu.LegacyRoot = g;
  })()), Uu;
}
var V4;
function nM() {
  return V4 || (V4 = 1, process.env.NODE_ENV === "production" ? u0.exports = eM() : u0.exports = tM()), u0.exports;
}
var I6 = nM(), rM = Rn();
const q4 = {
  children: !0,
  ref: !0,
  key: !0,
  style: !0,
  forwardedRef: !0,
  unstable_applyCache: !0,
  unstable_applyDrawHitFromCache: !0
};
let W4 = !1, K4 = !1;
const kb = ".react-konva-event", aM = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`, iM = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`, oM = {};
function $0(e, t, r = oM) {
  if (!W4 && "zIndex" in t && (console.warn(iM), W4 = !0), !K4 && t.draggable) {
    var o = t.x !== void 0 || t.y !== void 0, l = t.onDragEnd || t.onDragMove;
    o && !l && (console.warn(aM), K4 = !0);
  }
  for (var u in r)
    if (!q4[u]) {
      var d = u.slice(0, 2) === "on", f = r[u] !== t[u];
      if (d && f) {
        var g = u.substr(2).toLowerCase();
        g.substr(0, 7) === "content" && (g = "content" + g.substr(7, 1).toUpperCase() + g.substr(8)), e.off(g, r[u]);
      }
      var h = !t.hasOwnProperty(u);
      h && e.setAttr(u, void 0);
    }
  var v = t._useStrictMode, E = {}, S = !1;
  const w = {};
  for (var u in t)
    if (!q4[u]) {
      var d = u.slice(0, 2) === "on", T = r[u] !== t[u];
      if (d && T) {
        var g = u.substr(2).toLowerCase();
        g.substr(0, 7) === "content" && (g = "content" + g.substr(7, 1).toUpperCase() + g.substr(8)), t[u] && (w[g] = t[u]);
      }
      !d && (t[u] !== r[u] || v && t[u] !== e.getAttr(u)) && (S = !0, E[u] = t[u]);
    }
  S && (e.setAttrs(E), oc(e));
  for (var g in w)
    e.on(g + kb, w[g]);
}
function oc(e) {
  if (!rM.Konva.autoDrawEnabled) {
    var t = e.getLayer() || e.getStage();
    t && t.batchDraw();
  }
}
var Vy = xb();
const H6 = {}, sM = {};
cm.Node.prototype._applyProps = $0;
function lM(e, t) {
  if (typeof t == "string") {
    console.error(`Do not use plain text as child of Konva.Node. You are using text: ${t}`);
    return;
  }
  e.add(t), oc(e);
}
function uM(e, t, r) {
  let o = cm[e];
  o || (console.error(`Konva has no node with the type ${e}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${e}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`), o = cm.Group);
  const l = {}, u = {};
  for (var d in t) {
    var f = d.slice(0, 2) === "on";
    f ? u[d] = t[d] : l[d] = t[d];
  }
  const g = new o(l);
  return $0(g, u), g;
}
function cM(e, t, r) {
  console.error(`Text components are not supported for now in ReactKonva. Your text is: "${e}"`);
}
function dM(e, t, r) {
  return !1;
}
function fM(e) {
  return e;
}
function hM() {
  return null;
}
function pM() {
  return null;
}
function mM(e, t, r, o) {
  return sM;
}
function gM() {
}
function vM(e) {
}
function yM(e, t) {
  return !1;
}
function bM() {
  return H6;
}
function _M() {
  return H6;
}
const SM = setTimeout, wM = clearTimeout, xM = -1;
function kM(e, t) {
  return !1;
}
const CM = !1, EM = !0, RM = !0;
function TM(e, t) {
  t.parent === e ? t.moveToTop() : e.add(t), oc(e);
}
function NM(e, t) {
  t.parent === e ? t.moveToTop() : e.add(t), oc(e);
}
function G6(e, t, r) {
  t._remove(), e.add(t), t.setZIndex(r.getZIndex()), oc(e);
}
function AM(e, t, r) {
  G6(e, t, r);
}
function MM(e, t) {
  t.destroy(), t.off(kb), oc(e);
}
function PM(e, t) {
  t.destroy(), t.off(kb), oc(e);
}
function DM(e, t, r) {
  console.error(`Text components are not yet supported in ReactKonva. You text is: "${r}"`);
}
function LM(e, t, r) {
}
function OM(e, t, r, o, l) {
  $0(e, l, o);
}
function FM(e) {
  e.hide(), oc(e);
}
function zM(e) {
}
function BM(e, t) {
  (t.visible == null || t.visible) && e.show();
}
function UM(e, t) {
}
function IM(e) {
}
function HM() {
}
const GM = () => I6.DefaultEventPriority, VM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  appendChild: TM,
  appendChildToContainer: NM,
  appendInitialChild: lM,
  cancelTimeout: wM,
  clearContainer: IM,
  commitMount: LM,
  commitTextUpdate: DM,
  commitUpdate: OM,
  createInstance: uM,
  createTextInstance: cM,
  detachDeletedInstance: HM,
  finalizeInitialChildren: dM,
  getChildHostContext: _M,
  getCurrentEventPriority: GM,
  getPublicInstance: fM,
  getRootHostContext: bM,
  hideInstance: FM,
  hideTextInstance: zM,
  idlePriority: Vy.unstable_IdlePriority,
  insertBefore: G6,
  insertInContainerBefore: AM,
  isPrimaryRenderer: CM,
  noTimeout: xM,
  now: Vy.unstable_now,
  prepareForCommit: hM,
  preparePortalMount: pM,
  prepareUpdate: mM,
  removeChild: MM,
  removeChildFromContainer: PM,
  resetAfterCommit: gM,
  resetTextContent: vM,
  run: Vy.unstable_runWithPriority,
  scheduleTimeout: SM,
  shouldDeprioritizeSubtree: yM,
  shouldSetTextContent: kM,
  supportsMutation: RM,
  unhideInstance: BM,
  unhideTextInstance: UM,
  warnsIfNotActing: EM
}, Symbol.toStringTag, { value: "Module" }));
var qM = Object.defineProperty, WM = Object.defineProperties, KM = Object.getOwnPropertyDescriptors, j4 = Object.getOwnPropertySymbols, jM = Object.prototype.hasOwnProperty, YM = Object.prototype.propertyIsEnumerable, Y4 = (e, t, r) => t in e ? qM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Z4 = (e, t) => {
  for (var r in t || (t = {}))
    jM.call(t, r) && Y4(e, r, t[r]);
  if (j4)
    for (var r of j4(t))
      YM.call(t, r) && Y4(e, r, t[r]);
  return e;
}, ZM = (e, t) => WM(e, KM(t)), X4, Q4;
typeof window < "u" && ((X4 = window.document) != null && X4.createElement || ((Q4 = window.navigator) == null ? void 0 : Q4.product) === "ReactNative") ? ao.useLayoutEffect : ao.useEffect;
function V6(e, t, r) {
  if (!e)
    return;
  if (r(e) === !0)
    return e;
  let o = e.child;
  for (; o; ) {
    const l = V6(o, t, r);
    if (l)
      return l;
    o = o.sibling;
  }
}
function q6(e) {
  try {
    return Object.defineProperties(e, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
        }
      }
    });
  } catch {
    return e;
  }
}
const J4 = console.error;
console.error = function() {
  const e = [...arguments].join("");
  if (e != null && e.startsWith("Warning:") && e.includes("useContext")) {
    console.error = J4;
    return;
  }
  return J4.apply(this, arguments);
};
const Cb = q6(ao.createContext(null));
class W6 extends ao.Component {
  render() {
    return /* @__PURE__ */ ao.createElement(Cb.Provider, {
      value: this._reactInternals
    }, this.props.children);
  }
}
function XM() {
  const e = ao.useContext(Cb);
  if (e === null)
    throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  const t = ao.useId();
  return ao.useMemo(() => {
    for (const o of [e, e == null ? void 0 : e.alternate]) {
      if (!o)
        continue;
      const l = V6(o, !1, (u) => {
        let d = u.memoizedState;
        for (; d; ) {
          if (d.memoizedState === t)
            return !0;
          d = d.next;
        }
      });
      if (l)
        return l;
    }
  }, [e, t]);
}
function QM() {
  const e = XM(), [t] = ao.useState(() => /* @__PURE__ */ new Map());
  t.clear();
  let r = e;
  for (; r; ) {
    if (r.type && typeof r.type == "object") {
      const l = r.type._context === void 0 && r.type.Provider === r.type ? r.type : r.type._context;
      l && l !== Cb && !t.has(l) && t.set(l, ao.useContext(q6(l)));
    }
    r = r.return;
  }
  return t;
}
function JM() {
  const e = QM();
  return ao.useMemo(
    () => Array.from(e.keys()).reduce(
      (t, r) => (o) => /* @__PURE__ */ ao.createElement(t, null, /* @__PURE__ */ ao.createElement(r.Provider, ZM(Z4({}, o), {
        value: e.get(r)
      }))),
      (t) => /* @__PURE__ */ ao.createElement(W6, Z4({}, t))
    ),
    [e]
  );
}
function $M(e) {
  const t = na.useRef({});
  return na.useLayoutEffect(() => {
    t.current = e;
  }), na.useLayoutEffect(() => () => {
    t.current = {};
  }, []), t.current;
}
const eP = (e) => {
  const t = na.useRef(null), r = na.useRef(null), o = na.useRef(null), l = $M(e), u = JM(), d = (f) => {
    const { forwardedRef: g } = e;
    g && (typeof g == "function" ? g(f) : g.current = f);
  };
  return na.useLayoutEffect(() => (r.current = new cm.Stage({
    width: e.width,
    height: e.height,
    container: t.current
  }), d(r.current), o.current = Wp.createContainer(r.current, I6.LegacyRoot, !1, null), Wp.updateContainer(na.createElement(u, {}, e.children), o.current), () => {
    cm.isBrowser && (d(null), Wp.updateContainer(null, o.current, null), r.current.destroy());
  }), []), na.useLayoutEffect(() => {
    d(r.current), $0(r.current, e, l), Wp.updateContainer(na.createElement(u, {}, e.children), o.current, null);
  }), na.createElement("div", {
    ref: t,
    id: e.id,
    accessKey: e.accessKey,
    className: e.className,
    role: e.role,
    style: e.style,
    tabIndex: e.tabIndex,
    title: e.title
  });
}, tP = "Layer", Yn = "Group", Kr = "Rect", Ei = "Circle", kr = "Line", ec = "Text", Vo = "Path", j2 = "Arrow", nP = "Shape", rP = "Transformer", Wp = $A(VM);
Wp.injectIntoDevTools({
  // @ts-ignore
  findHostInstanceByFiber: () => null,
  bundleType: process.env.NODE_ENV !== "production" ? 1 : 0,
  version: na.version,
  rendererPackageName: "react-konva"
});
const aP = na.forwardRef((e, t) => na.createElement(W6, {}, na.createElement(eP, { ...e, forwardedRef: t }))), K6 = (e) => e * Math.PI / 180, ed = (e, t) => {
  const r = K6(t), o = Math.cos(r), l = Math.sin(r);
  return {
    x: e.x * o - e.y * l,
    y: e.x * l + e.y * o
  };
}, Bf = (e, t) => {
  const r = K6(e);
  return { x: Math.sin(r) * t, y: Math.cos(r) * t };
}, iP = (e, t) => ((e + (t ? 180 : 0)) % 360 + 360) % 360, Rf = (e, t) => e.x * t.x + e.y * t.y;
function oP(e, t, r, o, l) {
  const u = Bf(r, 1), d = ed(u, o), f = ed({ x: -u.x, y: u.y }, o), g = (x, k) => ({
    x: x.x + k.x * l,
    y: x.y + k.y * l
  }), h = [g(e, d), g(e, f)], v = [g(t, d), g(t, f)], E = ed({ x: 1, y: 0 }, o), S = Rf(e, E) <= Rf(t, E), w = S ? e : t, T = S ? t : e, P = { x: T.x - w.x, y: T.y - w.y }, z = Rf(d, P) >= Rf(f, P) ? d : f;
  return {
    endsA: h,
    endsB: v,
    area: [
      w,
      T,
      g(T, z),
      g(w, z)
    ]
  };
}
function sP(e, t, r, o, l) {
  const u = Math.max(8, r), d = ed(Bf(o, 1), l), f = Bf(o, 1), g = ed({ x: -f.x, y: f.y }, l), h = Math.abs(d.x * g.y - d.y * g.x), v = h < 0.01 ? [d] : [d, g], E = u * h, S = E < 1 ? u : E, w = Math.hypot(e, t), T = [];
  for (const P of v) {
    const z = { x: -P.y, y: P.x }, L = Math.ceil(w / S);
    for (let x = -L; x <= L; x += 1) {
      const k = x * S, R = { x: z.x * k, y: z.y * k };
      T.push([
        R.x - P.x * w,
        R.y - P.y * w,
        R.x + P.x * w,
        R.y + P.y * w
      ]);
    }
  }
  return T;
}
function j6(e, t, r, o, l, u, d) {
  const f = Math.max(8, l), g = ed(Bf(u, 1), d), h = Bf(u, 1), v = ed({ x: -h.x, y: h.y }, d), E = Math.abs(g.x * v.y - g.y * v.x), S = E < 0.01 ? [g] : [g, v], w = f * E, T = w < 1 ? f : w, P = { x: e + r / 2, y: t + o / 2 }, z = Math.hypot(r, o), L = [];
  for (const x of S) {
    const k = { x: -x.y, y: x.x }, R = Rf(k, P), B = Rf(x, P), q = Math.floor((R - z) / T), X = Math.ceil((R + z) / T);
    for (let I = q; I <= X; I += 1) {
      const U = I * T, F = {
        x: k.x * U + x.x * B,
        y: k.y * U + x.y * B
      };
      L.push([
        F.x - x.x * z,
        F.y - x.y * z,
        F.x + x.x * z,
        F.y + x.y * z
      ]);
    }
  }
  return L;
}
const O0 = 48, m0 = 300, $p = 24, Y6 = (e, t) => {
  const r = Math.max(1, Math.floor((t - 112) / O0)), o = Math.min(r, e), u = Math.ceil(e / r) * m0 + 32, d = 64 + o * O0;
  return {
    width: u,
    height: d,
    x: $p,
    y: Math.max($p, t - d - $p)
  };
}, qy = (e, t, r) => {
  const o = e.rotation * Math.PI / 180, l = t * e.scaleX, u = r * e.scaleY;
  return {
    x: e.x + l * Math.cos(o) - u * Math.sin(o),
    y: e.y + l * Math.sin(o) + u * Math.cos(o)
  };
}, lP = (e, t) => {
  let r = 0, o = 0, l = e.canvas.width, u = e.canvas.height;
  const d = (f, g, h = 0) => {
    r = Math.min(r, f - h), o = Math.min(o, g - h), l = Math.max(l, f + h), u = Math.max(u, g + h);
  };
  for (const f of e.objects)
    if (f.visible) {
      if (f.type === "boat") {
        d(f.x, f.y, 180);
        continue;
      }
      if (f.type === "mark") {
        const g = e.environment.zonesVisible && f.zoneVisible ? f.zoneRadius * t : 0, h = e.environment.laylinesVisible && f.laylinesVisible ? 520 : 0;
        d(f.x, f.y, Math.max(72, g + 4, h));
        continue;
      }
      if (f.type === "gate" || f.type === "start-line" || f.type === "finish-line") {
        const g = f.type === "gate" && e.environment.zonesVisible && f.zoneVisible ? f.zoneRadius * t + 4 : f.type !== "gate" && (f.laylinesVisible || f.laylineAreaVisible) ? 520 : 72;
        d(f.x + f.endAX, f.y + f.endAY, g), d(f.x + f.endBX, f.y + f.endBY, g);
        continue;
      }
      if (f.type === "text") {
        const g = f.text.split(`
`), h = Math.max(16, ...g.map((E) => E.length * f.fontSize * 0.68)) + 16, v = Math.max(1, g.length) * f.fontSize * 1.25 + 16;
        for (const [E, S] of [
          [0, 0],
          [h, 0],
          [h, v],
          [0, v]
        ]) {
          const w = qy(f, E, S);
          d(w.x, w.y, 4);
        }
        continue;
      }
      if (f.type === "rectangle") {
        for (const [g, h] of [
          [0, 0],
          [f.width, 0],
          [f.width, f.height],
          [0, f.height]
        ]) {
          const v = qy(f, g, h);
          d(v.x, v.y, f.strokeWidth + 2);
        }
        continue;
      }
      if (f.type === "circle") {
        const g = Math.max(f.width, f.height) / 2 * Math.max(Math.abs(f.scaleX), Math.abs(f.scaleY));
        d(f.x, f.y, g + f.strokeWidth + 2);
        continue;
      }
      if ("points" in f)
        for (let g = 0; g + 1 < f.points.length; g += 2) {
          const h = qy(f, f.points[g], f.points[g + 1]);
          d(h.x, h.y, f.strokeWidth + (f.type === "arrow" ? 16 : 4));
        }
    }
  if (e.environment.windVisible) {
    const f = e.canvas.windIndicatorPosition ?? { x: 120, y: 130 };
    d(f.x, f.y, 120);
  }
  if (e.canvas.boatLegendVisible) {
    const f = new Set(
      e.objects.filter((g) => g.type === "boat" && g.visible).map((g) => g.sequenceId)
    ).size;
    if (f > 0) {
      const g = Y6(f, e.canvas.height), h = e.canvas.boatLegendPosition ?? { x: g.x, y: g.y };
      d(h.x, h.y, $p), d(h.x + g.width, h.y + g.height, $p);
    }
  }
  return {
    x: Math.floor(r),
    y: Math.floor(o),
    width: Math.max(1, Math.ceil(l) - Math.floor(r)),
    height: Math.max(1, Math.ceil(u) - Math.floor(o))
  };
}, Z6 = 50, uP = Z6 / 2;
function cP(e, t = ".rotation-bounds") {
  const r = e.getClientRect;
  return e.getClientRect = (o = {}) => {
    if (o.skipTransform) {
      const l = e.findOne(t);
      if (l)
        return l.getClientRect({
          relativeTo: e,
          skipShadow: o.skipShadow,
          skipStroke: o.skipStroke
        });
    }
    return r.call(e, o);
  }, () => {
    e.getClientRect = r;
  };
}
const dP = "#475569";
function X6(e) {
  return e === "committee-boat" || e === "committee-boat-reversed" ? {
    boatClass: "Committee boat",
    color: dP,
    reversed: e === "committee-boat-reversed"
  } : e === "coach-boat" || e === "coach-boat-reversed" ? {
    boatClass: "Coachboat",
    color: C0,
    reversed: e === "coach-boat-reversed"
  } : null;
}
function $4(e) {
  return X6(e) !== null;
}
function ew(e, t, r) {
  return e === "buoy" ? t : r;
}
const Q6 = 1500, J6 = (e, t, r) => Math.min(r, Math.max(t, e)), fP = (e, t, r) => {
  const o = ((t - e) % 360 + 540) % 360 - 180;
  return ((e + o * r) % 360 + 360) % 360;
}, hP = (e) => Math.max(
  1,
  ...e.filter((t) => t.type === "boat").map((t) => t.positionNumber)
), pP = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const r of e)
    r.type === "boat" && t.set(
      r.sequenceId,
      Math.max(t.get(r.sequenceId) ?? 0, r.positionNumber)
    );
  return [...t.values()].some((r) => r > 1);
}, $6 = (e, t) => {
  const r = /* @__PURE__ */ new Map();
  for (const o of e)
    o.type !== "boat" || !o.visible || r.set(o.sequenceId, [...r.get(o.sequenceId) ?? [], o]);
  return [...r.values()].map((o) => {
    var z, L;
    const l = o.sort((x, k) => x.positionNumber - k.positionNumber), u = ((z = l.at(-1)) == null ? void 0 : z.positionNumber) ?? 1, d = J6(t, ((L = l[0]) == null ? void 0 : L.positionNumber) ?? 1, u), f = [...l].reverse().find((x) => x.positionNumber <= d) ?? l[0], g = l.find((x) => x.positionNumber >= d) ?? l.at(-1), h = Math.max(1, g.positionNumber - f.positionNumber), v = f.id === g.id ? 0 : (d - f.positionNumber) / h, E = vb(f, g), S = C6(E, v), w = k6(E, S), T = jN(E, S), P = v <= 0 ? f.heading : v >= 1 ? g.heading : YN(
      T,
      fP(f.heading, g.heading, v)
    );
    return {
      ...v >= 1 ? g : f,
      id: l[0].id,
      x: w.x,
      y: w.y,
      heading: P,
      rotation: P,
      locked: !0,
      positionNumber: Math.min(u, Math.floor(d))
    };
  });
}, mP = (e, t) => [
  ...e.filter((r) => r.type !== "boat").map((r) => ({ ...r, locked: !0 })),
  ...$6(e, t)
].sort((r, o) => r.zIndex - o.zIndex), gP = (e, t) => {
  const r = new Map(
    $6(e, t).map((u) => [u.sequenceId, u])
  ), o = /* @__PURE__ */ new Map();
  for (const u of e)
    u.type !== "boat" || !u.visible || o.set(u.sequenceId, [...o.get(u.sequenceId) ?? [], u]);
  const l = (u) => ` C ${u.firstControl.x} ${u.firstControl.y} ${u.secondControl.x} ${u.secondControl.y} ${u.end.x} ${u.end.y}`;
  return [...o.entries()].map(([u, d]) => {
    var L, x, k;
    const f = [...d].sort(
      (R, B) => R.positionNumber - B.positionNumber
    ), g = ((L = f[0]) == null ? void 0 : L.positionNumber) ?? 1, h = ((x = f.at(-1)) == null ? void 0 : x.positionNumber) ?? g, v = J6(t, g, h), E = r.get(u), S = f.filter((R) => R.positionNumber <= v), w = ((k = S.at(-1)) == null ? void 0 : k.positionNumber) === v, T = E && !w ? [...S, E] : S;
    let P = f.length ? `M ${f[0].x} ${f[0].y}` : "", z = !1;
    for (let R = 1; R < f.length; R += 1) {
      const B = f[R - 1], q = f[R], X = vb(B, q);
      if (q.positionNumber <= v) {
        P += l(X), z = !0;
        continue;
      }
      if (B.positionNumber < v) {
        const I = (v - B.positionNumber) / (q.positionNumber - B.positionNumber), U = C6(X, I);
        P += l(KN(X, U)), z = !0;
      }
      break;
    }
    return { id: u, boats: T, path: z ? P : "" };
  });
}, F0 = (e) => 44 / Math.max(e, 0.01), tw = (e, t) => Math.max(t, 24 / Math.max(e, 0.01)), nw = (e) => e.trim().toLowerCase() !== "transparent", vP = [
  "gate",
  "start-line",
  "finish-line",
  "line",
  "arrow",
  "freehand",
  "rectangle",
  "circle"
], Wy = /* @__PURE__ */ new Set(["line", "arrow", "rectangle", "circle"]), qc = 3, yP = 12, bP = [
  "top-left",
  "top-center",
  "top-right",
  "middle-left",
  "middle-right",
  "bottom-left",
  "bottom-center",
  "bottom-right"
], _P = ["top-left", "top-right", "bottom-left", "bottom-right"], SP = /* @__PURE__ */ new Set([
  "boat",
  "mark",
  "gate",
  "start-line",
  "finish-line",
  "text",
  "circle"
]), tc = (e, t = 0.76) => {
  const r = /^#([0-9a-f]{6})$/i.exec(e);
  if (!r) return e;
  const o = Number.parseInt(r[1], 16);
  return `#${[o >> 16 & 255, o >> 8 & 255, o & 255].map(
    (u) => Math.round(u * t).toString(16).padStart(2, "0")
  ).join("")}`;
}, z0 = "#171717", dm = "#F5F5F5", wP = "#A3A3A3", jc = (e, t) => t === dm && e.toUpperCase() === z0.toUpperCase() ? t : e;
function xP({
  id: e,
  x: t = 0,
  y: r = 0,
  width: o,
  height: l,
  size: u,
  opacity: d,
  color: f,
  laylineAngle: g,
  windDirection: h,
  infinite: v = !1
}) {
  const E = ta(
    () => v ? j6(t, r, o, l, u, g, h) : sP(o, l, u, g, h),
    [l, v, g, u, o, h, t, r]
  );
  return /* @__PURE__ */ D(
    Yn,
    {
      id: e,
      clipX: t,
      clipY: r,
      clipWidth: o,
      clipHeight: l,
      opacity: d,
      listening: !1,
      children: /* @__PURE__ */ D(
        nP,
        {
          sceneFunc: (S, w) => {
            S.beginPath();
            for (const [T, P, z, L] of E)
              S.moveTo(T, P), S.lineTo(z, L);
            S.fillStrokeShape(w);
          },
          stroke: f,
          strokeWidth: 1.2,
          dash: [4, 7],
          perfectDrawEnabled: !1,
          listening: !1
        }
      )
    }
  );
}
function kP({
  entries: e,
  canvasHeight: t,
  dark: r,
  position: o,
  draggable: l = !1,
  onPositionChange: u
}) {
  const { t: d } = jn();
  if (!e.length) return null;
  const {
    width: f,
    height: g,
    x: h,
    y: v
  } = Y6(e.length, t), E = Math.max(1, Math.floor((t - 112) / O0)), S = (o == null ? void 0 : o.x) ?? h, w = (o == null ? void 0 : o.y) ?? v, T = r ? dm : z0, P = r ? "#C8D0D4" : "#5F6B70";
  return /* @__PURE__ */ le(
    Yn,
    {
      x: S,
      y: w,
      draggable: l,
      listening: l,
      onMouseDown: (z) => {
        l && (z.cancelBubble = !0);
      },
      onTouchStart: (z) => {
        l && (z.cancelBubble = !0);
      },
      onDragEnd: (z) => u == null ? void 0 : u({ x: z.target.x(), y: z.target.y() }),
      children: [
        /* @__PURE__ */ D(
          Kr,
          {
            width: f,
            height: g,
            fill: r ? "rgba(23,23,23,0.74)" : "rgba(255,255,255,0.68)",
            stroke: T,
            strokeWidth: 2,
            cornerRadius: 10,
            shadowColor: "rgba(23,23,23,0.18)",
            shadowBlur: 12,
            shadowOffsetY: 4
          }
        ),
        /* @__PURE__ */ D(
          ec,
          {
            x: 16,
            y: 15,
            text: d("BOAT LEGEND"),
            fill: T,
            fontSize: 17,
            fontStyle: "bold",
            letterSpacing: 1.2
          }
        ),
        /* @__PURE__ */ D(
          kr,
          {
            points: [16, 45, f - 16, 45],
            stroke: r ? "#59646A" : "#D7DEE1",
            strokeWidth: 1
          }
        ),
        e.map((z, L) => {
          const x = Math.floor(L / E), k = L % E, R = [z.sailNumber, z.name].filter(Boolean).join(" · "), B = R ? d(z.boatClass) : "";
          return /* @__PURE__ */ le(
            Yn,
            {
              x: 16 + x * m0,
              y: 56 + k * O0,
              children: [
                /* @__PURE__ */ D(
                  Kr,
                  {
                    x: 0,
                    y: 3,
                    width: 26,
                    height: 26,
                    fill: z.color,
                    stroke: T,
                    strokeWidth: 1.5,
                    cornerRadius: 4
                  }
                ),
                /* @__PURE__ */ D(
                  ec,
                  {
                    x: 38,
                    y: B ? 0 : 5,
                    width: m0 - 50,
                    height: B ? void 0 : 26,
                    verticalAlign: B ? "top" : "middle",
                    text: R || d(z.boatClass),
                    fill: T,
                    fontSize: 17,
                    fontStyle: "bold",
                    ellipsis: !0,
                    wrap: "none"
                  }
                ),
                B && /* @__PURE__ */ D(
                  ec,
                  {
                    x: 38,
                    y: 23,
                    width: m0 - 50,
                    text: B,
                    fill: P,
                    fontSize: 13,
                    ellipsis: !0,
                    wrap: "none"
                  }
                )
              ]
            },
            z.sequenceId
          );
        })
      ]
    }
  );
}
function e8({
  hullColor: e,
  hullStroke: t = "#0D639F"
}) {
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ D(
      Vo,
      {
        data: "M -3 -40 L 0 -40 C -1.4 -38.5 -2.8 -34 -4 -30 C -5.5 -24 -6 -17 -6 -8 L -6 37 Q -6 39.5 -8 39.5 L -9.5 39.5 Q -13 39.5 -13 36 L -13 -10 C -13 -18 -12 -24 -9.5 -29 C -7 -34 -4.5 -38.5 -3 -40 Z",
        fill: e,
        stroke: t,
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Vo,
      {
        data: "M 3 -40 L 0 -40 C 1.4 -38.5 2.8 -34 4 -30 C 5.5 -24 6 -17 6 -8 L 6 37 Q 6 39.5 8 39.5 L 9.5 39.5 Q 13 39.5 13 36 L 13 -10 C 13 -18 12 -24 9.5 -29 C 7 -34 4.5 -38.5 3 -40 Z",
        fill: e,
        stroke: t,
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Vo,
      {
        data: "M -3 -40 L 3 -40 C 3.2 -38 3.5 -35 3.8 -33 L -3.8 -33 C -3.5 -35 -3.2 -38 -3 -40 Z",
        fill: e,
        stroke: t,
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Vo,
      {
        data: "M -2.7 -34 L 2.7 -34 C 2.7 -30 4.8 -23 5.5 -17 L 5.5 34 L -5.5 34 L -5.5 -17 C -4.8 -23 -2.7 -30 -2.7 -34 Z",
        fill: "#737A82",
        stroke: "#565D63",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Kr,
      {
        x: -4,
        y: -5,
        width: 8,
        height: 13,
        cornerRadius: 1.5,
        fill: "#AEB3B8",
        stroke: "#343A40",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Kr,
      {
        x: -4.5,
        y: 13,
        width: 9,
        height: 7,
        cornerRadius: 1.5,
        fill: "#646B72",
        stroke: "#343A40",
        strokeWidth: 1
      }
    ),
    /* @__PURE__ */ D(
      Kr,
      {
        x: -3.25,
        y: 35,
        width: 6.5,
        height: 9,
        cornerRadius: 2,
        fill: "#343A40",
        stroke: "#202428",
        strokeWidth: 1
      }
    )
  ] });
}
const Wc = {
  red: "#D72638",
  yellow: "#FFD100",
  blue: "#168DDD",
  black: "#171717",
  green: "#00843D",
  white: "#FFFFFF"
};
function CP({
  signal: e,
  color: t,
  outlineColor: r
}) {
  const u = t ?? (e === "red" || e === "yellow" || e === "blue" || e === "black" ? Wc[e] : Wc.white);
  return /* @__PURE__ */ le(Yn, { children: [
    /* @__PURE__ */ le(Yn, { clipX: 0, clipY: 0, clipWidth: 30, clipHeight: 20, children: [
      /* @__PURE__ */ D(Kr, { width: 30, height: 20, fill: u }),
      e === "green-white" && /* @__PURE__ */ le(Fr, { children: [
        /* @__PURE__ */ D(Kr, { width: 30 / 2, height: 20 / 2, fill: Wc.green }),
        /* @__PURE__ */ D(
          Kr,
          {
            x: 30 / 2,
            y: 20 / 2,
            width: 30 / 2,
            height: 20 / 2,
            fill: Wc.green
          }
        )
      ] }),
      e === "protest" && /* @__PURE__ */ le(Fr, { children: [
        /* @__PURE__ */ D(Kr, { width: 30, height: 20, fill: Wc.yellow }),
        [-16, -4, 8, 20, 32].map((d) => /* @__PURE__ */ D(
          kr,
          {
            points: [d, 0, d + 20, 20],
            stroke: Wc.red,
            strokeWidth: 12 / (2 * Math.SQRT2)
          },
          d
        ))
      ] })
    ] }),
    /* @__PURE__ */ D(Kr, { width: 30, height: 20, stroke: r, strokeWidth: 1.5 })
  ] });
}
function EP({
  boatFlagColor: e,
  signal: t,
  inkColor: r,
  outlineColor: o
}) {
  const l = [
    ...e ? [{ id: "boat", color: e, side: -1 }] : [],
    ...t !== "none" ? [{ id: "signal", signal: t, side: 1 }] : []
  ];
  return /* @__PURE__ */ D(Yn, { name: "support-boat-flags", children: l.map((u) => /* @__PURE__ */ le(Yn, { x: u.side * 3.5, y: -18, rotation: u.side * 20, children: [
    /* @__PURE__ */ D(kr, { points: [0, 0, 0, -35], stroke: r, strokeWidth: 2 }),
    /* @__PURE__ */ D(Yn, { x: u.side < 0 ? -30 : 0, y: -35, children: /* @__PURE__ */ D(
      CP,
      {
        color: "color" in u ? u.color : void 0,
        signal: "signal" in u ? u.signal : void 0,
        outlineColor: o
      }
    ) })
  ] }, u.id)) });
}
function RP({
  mount: e,
  side: t,
  displayScale: r,
  inkColor: o,
  outlineColor: l
}) {
  const u = [-15.2, 11.4], d = [-5.6, 4.2], f = [-16.4, -10.2], g = [-26, -3];
  return /* @__PURE__ */ le(
    Yn,
    {
      name: "boat-protest-flag",
      x: e[0],
      y: e[1],
      scaleX: (t === "port" ? 1 : -1) / r,
      scaleY: 1 / r,
      children: [
        /* @__PURE__ */ D(kr, { points: [0, 0, ...u], stroke: o, strokeWidth: 2, lineCap: "round" }),
        /* @__PURE__ */ D(
          kr,
          {
            points: [...d, ...f, ...g, ...u],
            closed: !0,
            fill: Wc.red,
            stroke: l,
            strokeWidth: 1.5,
            lineJoin: "round"
          }
        ),
        /* @__PURE__ */ D(Ei, { radius: 1.8, fill: o })
      ]
    }
  );
}
function TP({
  object: e,
  selected: t,
  onSelect: r,
  onChange: o,
  onPreviewChange: l,
  windDirection: u,
  laylineAngle: d,
  boatNumbersVisible: f,
  inkColor: g,
  outlineColor: h
}) {
  if (e.type !== "boat") return null;
  const v = ml[e.boatClass], E = e.spinnakerVisible || e.gennakerVisible, S = R6(
    e.boatClass,
    e.heading,
    u,
    d,
    E ? v.mainsailSpinMaxAngle : v.mainsailMaxAngle,
    e.tack
  ), w = ju(
    e.sailMode === "automatic" ? S + e.mainsailTrim : e.sailAngle,
    e.heading,
    u,
    e.tack
  ), T = T6(
    e.boatClass,
    e.heading,
    u,
    d,
    E ? v.jibSpinMaxAngle : v.jibMaxAngle,
    e.tack
  ), P = ju(
    T + e.jibTrim,
    e.heading,
    u,
    e.tack
  ), z = ju(
    M6(e.heading, u, e.tack) + e.spinnakerTrim,
    e.heading,
    u,
    e.tack
  ), L = ju(
    A6(e.heading, u, e.tack) + e.gennakerTrim,
    e.heading,
    u,
    e.tack
  ), x = gl(e.heading, u), k = qu(e.heading, u, w), R = qu(e.heading, u, P), B = qu(e.heading, u, z), q = P6(e.heading, u, L), X = Qh(e.heading, u, z), I = jo(e.heading, u, e.tack), U = Math.abs(x - 180) < 1e-4, F = U && I === "starboard" ? 90 : U && I === "port" ? -90 : x > 90 && x < 180 ? 90 : x >= 180 && x < 270 ? -90 : x, Z = z - x + F, te = 180 - x + z, ie = t ? tc(e.color) : e.color, ue = (v.kind === "vsr" ? 40 : v.drawingLength / 2) * v.displayScale, ze = v.drawingLength * v.displayScale, W = e.overlapIndicator === "port" ? -1 : 1, j = 1.6 / v.displayScale, ee = 1.15 / v.displayScale, Q = g === dm ? "#FFFFFF" : "#F8FAFC", oe = g === dm ? "#E8EEF2" : "#E2E8EC";
  return /* @__PURE__ */ le(
    Yn,
    {
      id: `object-${e.id}`,
      x: e.x,
      y: e.y,
      rotation: e.heading,
      opacity: e.opacity,
      draggable: !e.locked,
      onClick: r,
      onTap: r,
      onDragMove: (ye) => l({ x: ye.target.x(), y: ye.target.y() }),
      onDragEnd: (ye) => o({ x: ye.target.x(), y: ye.target.y() }, "Moved boat"),
      onTransform: (ye) => {
        const pe = (ye.target.rotation() % 360 + 360) % 360;
        l({
          heading: pe,
          rotation: pe,
          tack: jo(pe, u, e.tack)
        });
      },
      onTransformEnd: (ye) => {
        const pe = ye.target, Me = (pe.rotation() % 360 + 360) % 360;
        o(
          {
            x: pe.x(),
            y: pe.y(),
            heading: Me,
            rotation: Me,
            tack: jo(Me, u, e.tack)
          },
          "Transformed boat"
        );
      },
      children: [
        /* @__PURE__ */ D(
          Kr,
          {
            name: "selection-bounds-ignore",
            x: -52,
            y: -62,
            width: 104,
            height: 128,
            fill: "transparent",
            listening: !1
          }
        ),
        /* @__PURE__ */ le(Yn, { scaleX: v.displayScale, scaleY: v.displayScale, children: [
          /* @__PURE__ */ D(
            Vo,
            {
              name: "rotation-bounds",
              data: v.hullPath,
              fill: v.kind === "vsr" ? "transparent" : ie,
              stroke: v.kind === "vsr" ? "transparent" : h,
              strokeWidth: 1.5 / v.displayScale,
              lineJoin: "round"
            }
          ),
          v.kind === "motor" && /* @__PURE__ */ le(Fr, { children: [
            /* @__PURE__ */ D(
              Kr,
              {
                x: -7,
                y: 2,
                width: 14,
                height: 18,
                cornerRadius: 2,
                fill: "#f5f5f5",
                stroke: h,
                strokeWidth: 1
              }
            ),
            /* @__PURE__ */ D(kr, { points: [-6, 8, 6, 8], stroke: "#737373", strokeWidth: 1 })
          ] }),
          v.kind === "vsr" && /* @__PURE__ */ D(
            e8,
            {
              hullColor: ie,
              hullStroke: e.boatClass === "Umpire boat" ? tc(E0) : void 0
            }
          ),
          (e.boatClass === "Coachboat" || e.boatClass === "Umpire boat") && /* @__PURE__ */ D(
            EP,
            {
              boatFlagColor: e.boatFlagColor,
              signal: e.umpireSignalFlag,
              inkColor: g,
              outlineColor: h
            }
          ),
          f && /* @__PURE__ */ le(
            Yn,
            {
              name: "boat-position-number",
              x: v.numberPos[0],
              y: v.numberPos[1],
              scaleX: 1 / v.displayScale,
              scaleY: 1 / v.displayScale,
              children: [
                /* @__PURE__ */ D(Ei, { radius: 11, fill: "#737373", stroke: g, strokeWidth: 1.5 }),
                /* @__PURE__ */ D(
                  ec,
                  {
                    text: String(e.positionNumber),
                    x: -11,
                    y: -6.5,
                    width: 22,
                    align: "center",
                    fill: "#ffffff",
                    fontSize: 16,
                    fontStyle: "bold"
                  }
                )
              ]
            }
          ),
          v.mast && e.mainsailVisible && v.mainsailSize > 0 && /* @__PURE__ */ le(Yn, { name: "boat-sail", x: v.mast[0], y: v.mast[1], rotation: -w, children: [
            /* @__PURE__ */ D(
              Vo,
              {
                data: L0(
                  v.mainsailSize,
                  Qh(e.heading, u, w),
                  k
                ),
                fill: Q,
                stroke: h,
                strokeWidth: j,
                opacity: 0.98,
                lineJoin: "round"
              }
            ),
            /* @__PURE__ */ D(
              kr,
              {
                points: [0, 0, 0, v.mainsailSize],
                stroke: h,
                strokeWidth: ee
              }
            )
          ] }),
          v.jibTack && e.jibVisible && v.jibSize > 0 && /* @__PURE__ */ D(
            Yn,
            {
              name: "boat-sail",
              x: v.jibTack[0],
              y: v.jibTack[1],
              rotation: -P,
              children: /* @__PURE__ */ D(
                Vo,
                {
                  data: L0(
                    v.jibSize,
                    Qh(e.heading, u, P),
                    R
                  ),
                  fill: oe,
                  stroke: h,
                  strokeWidth: j,
                  opacity: 0.98,
                  lineJoin: "round"
                }
              )
            }
          ),
          v.jibTack && e.genoaVisible && (v.genoaSize ?? 0) > 0 && /* @__PURE__ */ D(
            Yn,
            {
              name: "boat-sail",
              x: v.jibTack[0],
              y: v.jibTack[1],
              rotation: -P,
              children: /* @__PURE__ */ D(
                Vo,
                {
                  data: JN(
                    v.genoaSize ?? 0,
                    Qh(e.heading, u, P),
                    R
                  ),
                  fill: oe,
                  stroke: h,
                  strokeWidth: j,
                  opacity: 0.98,
                  lineJoin: "round"
                }
              )
            }
          ),
          v.mast && e.spinnakerVisible && v.spinnakerSize > 0 && /* @__PURE__ */ le(
            Yn,
            {
              name: "boat-sail",
              x: v.mast[0],
              y: v.mast[1],
              rotation: -z,
              children: [
                /* @__PURE__ */ D(
                  Vo,
                  {
                    data: B ? eA(
                      v.spinnakerSize,
                      Z,
                      te
                    ) : tA(v.spinnakerSize, X),
                    rotation: B ? 0 : Z - X * 90,
                    fill: Q,
                    stroke: h,
                    strokeWidth: j,
                    opacity: 0.98,
                    lineJoin: "round"
                  }
                ),
                /* @__PURE__ */ D(
                  kr,
                  {
                    points: [0, 0, 0, -v.spinnakerSize],
                    stroke: h,
                    strokeWidth: ee,
                    rotation: Z
                  }
                )
              ]
            }
          ),
          v.gennakerTack && e.gennakerVisible && v.gennakerSize > 0 && /* @__PURE__ */ le(Yn, { name: "boat-sail", x: v.gennakerTack[0], y: v.gennakerTack[1], children: [
            v.poleLength > 0 && /* @__PURE__ */ D(
              kr,
              {
                points: [0, 0, 0, v.poleLength],
                stroke: h,
                strokeWidth: ee
              }
            ),
            /* @__PURE__ */ D(
              Vo,
              {
                data: $N(
                  v.gennakerSize,
                  Qh(e.heading, u, L),
                  q
                ),
                fill: Q,
                stroke: h,
                strokeWidth: j,
                opacity: 0.98,
                lineJoin: "round",
                rotation: -L
              }
            )
          ] }),
          !Zl(e.boatClass) && e.protestFlagSide !== "none" && /* @__PURE__ */ D(
            RP,
            {
              mount: e.protestFlagSide === "port" ? v.sternPort : [-v.sternPort[0], v.sternPort[1]],
              side: e.protestFlagSide,
              displayScale: v.displayScale,
              inkColor: g,
              outlineColor: h
            }
          )
        ] }),
        e.overlapIndicator !== "none" && /* @__PURE__ */ D(
          kr,
          {
            points: [0, ue, W * ze, ue],
            stroke: g,
            strokeWidth: 2,
            dash: [2, 5],
            lineCap: "round",
            opacity: 0.78,
            listening: !1
          }
        )
      ]
    }
  );
}
function NP({
  object: e,
  selected: t,
  onSelect: r,
  onChange: o,
  onPreviewChange: l,
  inkColor: u,
  outlineColor: d,
  brandAccentColor: f
}) {
  if (e.type !== "mark") return null;
  const g = e.shape === "flag", h = e.shape === "pin", v = String(e.markNumber), E = g ? { x: 1, y: -49, width: 32, height: 20 } : h ? { x: -1, y: -28, width: 22, height: 20 } : e.shape === "round" ? { x: -18, y: -18, width: 36, height: 36 } : { x: -15, y: -24, width: 30, height: 48 }, S = Math.min(
    g ? 17 : h ? 16 : 18,
    v.length <= 2 ? 18 : v.length <= 4 ? 13 : 10
  ), w = t ? tc(e.color) : e.color, T = w.replace("#", ""), P = /^[0-9a-f]{6}$/i.test(T) ? Number.parseInt(T, 16) : Number.parseInt(f.slice(1), 16), z = P >> 16 & 255, L = P >> 8 & 255, x = P & 255, k = z * 0.299 + L * 0.587 + x * 0.114 > 150 ? "#171717" : "#ffffff";
  return /* @__PURE__ */ le(
    Yn,
    {
      id: `object-${e.id}`,
      x: e.x,
      y: e.y,
      opacity: e.opacity,
      draggable: !e.locked,
      onClick: r,
      onTap: r,
      onDragMove: (R) => l({ x: R.target.x(), y: R.target.y() }),
      onDragEnd: (R) => o({ x: R.target.x(), y: R.target.y() }, "Moved mark"),
      children: [
        e.shape === "round" ? /* @__PURE__ */ D(
          Ei,
          {
            radius: 18,
            fill: w,
            stroke: d,
            strokeWidth: 2,
            hitStrokeWidth: 28
          }
        ) : e.shape === "flag" ? /* @__PURE__ */ le(Fr, { children: [
          /* @__PURE__ */ D(kr, { points: [0, 0, 0, -50], stroke: u, strokeWidth: 3 }),
          /* @__PURE__ */ D(
            Kr,
            {
              x: 0,
              y: -50,
              width: 34,
              height: 22,
              cornerRadius: 1,
              fill: w,
              stroke: d,
              strokeWidth: 2
            }
          )
        ] }) : e.shape === "pin" ? /* @__PURE__ */ le(Fr, { children: [
          /* @__PURE__ */ D(kr, { points: [0, 20, 0, -28], stroke: u, strokeWidth: 3 }),
          /* @__PURE__ */ D(
            kr,
            {
              points: [0, -28, 28, -18, 0, -8],
              closed: !0,
              fill: w,
              stroke: d,
              strokeWidth: 2
            }
          )
        ] }) : /* @__PURE__ */ D(
          Kr,
          {
            x: -15,
            y: -24,
            width: 30,
            height: 48,
            cornerRadius: e.shape === "inflatable" ? 10 : 3,
            fill: w,
            stroke: d,
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ D(
          ec,
          {
            text: v,
            x: E.x,
            y: E.y,
            width: E.width,
            height: E.height,
            align: "center",
            verticalAlign: "middle",
            lineHeight: 1,
            fill: k,
            fontSize: S,
            fontStyle: "bold",
            listening: !1
          }
        )
      ]
    }
  );
}
function rw({
  type: e,
  windDirection: t,
  selected: r,
  accentColor: o,
  showSignalFlag: l,
  inkColor: u,
  outlineColor: d
}) {
  const f = r ? tc(o) : o;
  if (e === "buoy")
    return /* @__PURE__ */ D(
      Kr,
      {
        x: -15,
        y: -24,
        width: 30,
        height: 48,
        cornerRadius: 3,
        fill: f,
        stroke: d,
        strokeWidth: 2
      }
    );
  if (e === "flag")
    return /* @__PURE__ */ le(Yn, { children: [
      /* @__PURE__ */ D(kr, { points: [0, 0, 0, -50], stroke: u, strokeWidth: 3 }),
      /* @__PURE__ */ D(
        Kr,
        {
          x: 0,
          y: -50,
          width: 34,
          height: 22,
          cornerRadius: 1,
          fill: f,
          stroke: d,
          strokeWidth: 2
        }
      )
    ] });
  const g = X6(e);
  if (!g) return null;
  const h = ml[g.boatClass], v = t + (g.reversed ? 180 : 0);
  return /* @__PURE__ */ le(Yn, { rotation: v, scaleX: h.displayScale, scaleY: h.displayScale, children: [
    /* @__PURE__ */ D(
      Vo,
      {
        data: h.hullPath,
        fill: h.kind === "vsr" ? "transparent" : r ? tc(g.color) : g.color,
        stroke: h.kind === "vsr" ? "transparent" : d,
        strokeWidth: 1.5 / h.displayScale,
        lineJoin: "round"
      }
    ),
    h.kind === "vsr" && /* @__PURE__ */ D(e8, { hullColor: r ? tc(g.color) : g.color }),
    l && /* @__PURE__ */ le(Yn, { rotation: -v, children: [
      /* @__PURE__ */ D(kr, { points: [0, 0, 0, -34], stroke: u, strokeWidth: 2.5 }),
      /* @__PURE__ */ D(
        Kr,
        {
          x: 0,
          y: -34,
          width: 22,
          height: 14,
          cornerRadius: 1,
          fill: f,
          stroke: d,
          strokeWidth: 1.5
        }
      )
    ] })
  ] });
}
function AP({
  object: e,
  selected: t,
  onSelect: r,
  onChange: o,
  onPreviewChange: l,
  windDirection: u,
  laylineAngle: d,
  inkColor: f,
  outlineColor: g,
  interactionScale: h,
  configuredMarkColor: v
}) {
  const [E, S] = Gn(null);
  if (e.type !== "gate" && e.type !== "start-line" && e.type !== "finish-line")
    return null;
  const w = e.type === "gate" ? "#A3A3A3" : e.color, T = t ? tc(w) : w, P = e.type === "gate" ? null : oP(
    { x: e.endAX, y: e.endAY },
    { x: e.endBX, y: e.endBY },
    d,
    u,
    500
  ), z = (x, k, R) => {
    k.cancelBubble = !0;
    const B = x === "a" ? { endAX: k.target.x(), endAY: k.target.y() } : { endBX: k.target.x(), endBY: k.target.y() };
    R ? o(B, `Moved ${e.type} endpoint`) : l(B);
  }, L = (x) => ({
    onMouseDown: (k) => {
      S(x), r(k);
    },
    onTouchStart: (k) => {
      S(x), r(k);
    },
    onDragMove: (k) => z(x, k, !1),
    onDragEnd: (k) => z(x, k, !0)
  });
  return /* @__PURE__ */ le(
    Yn,
    {
      id: `object-${e.id}`,
      x: e.x,
      y: e.y,
      opacity: e.opacity,
      draggable: !e.locked,
      onClick: r,
      onTap: r,
      onDragMove: (x) => {
        x.target === x.currentTarget && l({ x: x.target.x(), y: x.target.y() });
      },
      onDragEnd: (x) => {
        x.target === x.currentTarget && o({ x: x.target.x(), y: x.target.y() }, `Moved ${e.type}`);
      },
      children: [
        e.type !== "gate" && e.laylineAreaVisible && P && /* @__PURE__ */ D(
          kr,
          {
            points: P.area.flatMap(({ x, y: k }) => [x, k]),
            closed: !0,
            fill: e.laylineAreaColor,
            opacity: 0.2,
            listening: !1
          }
        ),
        e.type !== "gate" && e.laylinesVisible && P && /* @__PURE__ */ le(Fr, { children: [
          P.endsA.map((x, k) => /* @__PURE__ */ D(
            kr,
            {
              points: [e.endAX, e.endAY, x.x, x.y],
              stroke: w,
              dash: [12, 10],
              strokeWidth: 2,
              opacity: 0.62,
              listening: !1
            },
            `layline-a-${k}`
          )),
          P.endsB.map((x, k) => /* @__PURE__ */ D(
            kr,
            {
              points: [e.endBX, e.endBY, x.x, x.y],
              stroke: w,
              dash: [12, 10],
              strokeWidth: 2,
              opacity: 0.62,
              listening: !1
            },
            `layline-b-${k}`
          ))
        ] }),
        /* @__PURE__ */ D(
          kr,
          {
            points: [e.endAX, e.endAY, e.endBX, e.endBY],
            stroke: T,
            strokeWidth: e.type === "gate" ? 2.5 : 4,
            dash: [16, 10],
            opacity: 0.72,
            hitStrokeWidth: F0(h)
          }
        ),
        e.type === "gate" ? /* @__PURE__ */ D(Fr, { children: ["a", "b"].map((x, k) => /* @__PURE__ */ le(
          Yn,
          {
            x: x === "a" ? e.endAX : e.endBX,
            y: x === "a" ? e.endAY : e.endBY,
            draggable: !e.locked,
            ...L(x),
            children: [
              /* @__PURE__ */ D(
                Kr,
                {
                  x: -15,
                  y: -24,
                  width: 30,
                  height: 48,
                  cornerRadius: 3,
                  fill: t && E === x ? tc(e.color) : e.color,
                  stroke: g,
                  strokeWidth: 2
                }
              ),
              /* @__PURE__ */ D(
                ec,
                {
                  text: `${e.markNumber}${k === 0 ? "a" : "b"}`,
                  x: -15,
                  y: -24,
                  width: 30,
                  height: 48,
                  align: "center",
                  verticalAlign: "middle",
                  fill: "#171717",
                  fontSize: 15,
                  fontStyle: "bold",
                  listening: !1
                }
              )
            ]
          },
          x
        )) }) : /* @__PURE__ */ le(Fr, { children: [
          /* @__PURE__ */ D(
            Yn,
            {
              x: e.endAX,
              y: e.endAY,
              draggable: !e.locked,
              ...L("a"),
              children: /* @__PURE__ */ D(
                rw,
                {
                  type: e.pinEndType,
                  windDirection: u,
                  selected: t && E === "a",
                  accentColor: ew(
                    e.pinEndType,
                    v,
                    e.pinEndFlagColor
                  ),
                  showSignalFlag: $4(e.pinEndType),
                  inkColor: f,
                  outlineColor: g
                }
              )
            }
          ),
          /* @__PURE__ */ D(
            Yn,
            {
              x: e.endBX,
              y: e.endBY,
              draggable: !e.locked,
              ...L("b"),
              children: /* @__PURE__ */ D(
                rw,
                {
                  type: e.startEndType,
                  windDirection: u,
                  selected: t && E === "b",
                  accentColor: ew(
                    e.startEndType,
                    v,
                    e.startEndFlagColor
                  ),
                  showSignalFlag: $4(e.startEndType),
                  inkColor: f,
                  outlineColor: g
                }
              )
            }
          )
        ] })
      ]
    }
  );
}
function MP({
  object: e,
  selected: t,
  onSelect: r,
  onChange: o,
  onPreviewChange: l,
  inkColor: u,
  brandAccentColor: d,
  interactionScale: f
}) {
  if (e.type !== "line" && e.type !== "arrow") return null;
  const g = [
    e.points[0] ?? 0,
    e.points[1] ?? 0,
    e.points.at(-2) ?? 0,
    e.points.at(-1) ?? 0
  ], h = e.type === "arrow" ? j2 : kr, v = (S, w, T) => {
    w.cancelBubble = !0;
    const P = [...g], z = S === "start" ? 0 : 2;
    P[z] = w.target.x(), P[z + 1] = w.target.y();
    const L = { points: P };
    T ? o(L, `Moved ${e.type} endpoint`) : l(L);
  }, E = (S) => ({
    onMouseDown: (w) => r(w),
    onTouchStart: (w) => r(w),
    onDragMove: (w) => v(S, w, !1),
    onDragEnd: (w) => v(S, w, !0)
  });
  return /* @__PURE__ */ le(
    Yn,
    {
      id: `object-${e.id}`,
      x: e.x,
      y: e.y,
      rotation: e.rotation,
      scaleX: e.scaleX,
      scaleY: e.scaleY,
      opacity: e.opacity,
      draggable: !e.locked,
      onClick: r,
      onTap: r,
      onDragMove: (S) => {
        S.target === S.currentTarget && l({ x: S.target.x(), y: S.target.y() });
      },
      onDragEnd: (S) => {
        S.target === S.currentTarget && o({ x: S.target.x(), y: S.target.y() }, `Moved ${e.type}`);
      },
      children: [
        /* @__PURE__ */ D(
          h,
          {
            points: g,
            stroke: jc(e.stroke, u),
            fill: jc(e.stroke, u),
            strokeWidth: e.strokeWidth,
            dash: e.dash,
            lineCap: "round",
            lineJoin: "round",
            pointerLength: e.type === "arrow" ? 14 : void 0,
            pointerWidth: e.type === "arrow" ? 12 : void 0,
            hitStrokeWidth: F0(f)
          }
        ),
        t && ["start", "end"].map((S, w) => /* @__PURE__ */ D(
          Ei,
          {
            x: g[w * 2],
            y: g[w * 2 + 1],
            radius: 8 / Math.max(f, 0.01),
            fill: d,
            stroke: u,
            strokeWidth: 2 / Math.max(f, 0.01),
            hitStrokeWidth: F0(f),
            draggable: !e.locked,
            ...E(S)
          },
          S
        ))
      ]
    }
  );
}
function PP(e) {
  const {
    object: t,
    selected: r,
    onSelect: o,
    onChange: l,
    onPreviewChange: u,
    inkColor: d,
    interactionScale: f,
    brandAccentColor: g
  } = e;
  if (t.type === "boat") return /* @__PURE__ */ D(TP, { ...e });
  if (t.type === "mark") return /* @__PURE__ */ D(NP, { ...e });
  if (t.type === "gate" || t.type === "start-line" || t.type === "finish-line")
    return /* @__PURE__ */ D(AP, { ...e });
  if (t.type === "line" || t.type === "arrow") return /* @__PURE__ */ D(MP, { ...e });
  if (t.type === "text")
    return /* @__PURE__ */ D(
      ec,
      {
        id: `object-${t.id}`,
        x: t.x,
        y: t.y,
        text: t.text,
        fill: jc(t.color, d),
        fontSize: t.fontSize,
        fontStyle: t.fontWeight,
        align: t.align,
        rotation: t.rotation,
        opacity: t.opacity,
        padding: 8,
        draggable: !t.locked,
        stroke: r ? d : void 0,
        strokeWidth: r ? 0.5 : 0,
        onClick: o,
        onTap: o,
        onDragMove: (h) => u({ x: h.target.x(), y: h.target.y() }),
        onDragEnd: (h) => l({ x: h.target.x(), y: h.target.y() }, "Moved text"),
        onTransformEnd: (h) => l(
          {
            x: h.target.x(),
            y: h.target.y(),
            rotation: h.target.rotation()
          },
          "Transformed text"
        )
      }
    );
  if (t.type === "rectangle") {
    const h = nw(t.fill);
    return /* @__PURE__ */ D(
      Kr,
      {
        id: `object-${t.id}`,
        x: t.x,
        y: t.y,
        width: t.width,
        height: t.height,
        fill: h ? t.fill : void 0,
        fillEnabled: h,
        stroke: jc(t.stroke, d),
        strokeWidth: t.strokeWidth,
        hitStrokeWidth: tw(f, t.strokeWidth),
        hitFunc: h ? void 0 : (v, E) => {
          v.beginPath(), v.rect(0, 0, t.width, t.height), v.closePath(), v.strokeShape(E);
        },
        rotation: t.rotation,
        scaleX: t.scaleX,
        scaleY: t.scaleY,
        opacity: t.opacity,
        draggable: !t.locked,
        onClick: o,
        onTap: o,
        onDragMove: (v) => u({ x: v.target.x(), y: v.target.y() }),
        onDragEnd: (v) => l({ x: v.target.x(), y: v.target.y() }, "Moved rectangle"),
        onTransformEnd: (v) => {
          const E = v.target, S = t.width * Math.abs(E.scaleX()), w = t.height * Math.abs(E.scaleY());
          E.scale({ x: 1, y: 1 }), l(
            {
              x: E.x(),
              y: E.y(),
              width: Math.max(8, S),
              height: Math.max(8, w),
              scaleX: 1,
              scaleY: 1
            },
            "Resized rectangle"
          );
        }
      }
    );
  }
  if (t.type === "circle") {
    const h = Math.max(t.width, t.height) / 2 * Math.max(Math.abs(t.scaleX), Math.abs(t.scaleY)), v = nw(t.fill), E = (S, w) => {
      S.cancelBubble = !0;
      const T = Math.max(
        4,
        Math.hypot(S.target.x() - t.x, S.target.y() - t.y)
      );
      S.target.position({ x: t.x, y: t.y - T });
      const P = {
        width: T * 2,
        height: T * 2,
        scaleX: 1,
        scaleY: 1
      };
      w ? l(P, "Resized circle") : u(P);
    };
    return /* @__PURE__ */ le(Fr, { children: [
      /* @__PURE__ */ D(
        Ei,
        {
          id: `object-${t.id}`,
          x: t.x,
          y: t.y,
          radius: h,
          fill: v ? t.fill : void 0,
          fillEnabled: v,
          stroke: jc(t.stroke, d),
          strokeWidth: t.strokeWidth,
          hitStrokeWidth: tw(f, t.strokeWidth),
          hitFunc: v ? void 0 : (S, w) => {
            S.beginPath(), S.arc(0, 0, h, 0, Math.PI * 2, !1), S.closePath(), S.strokeShape(w);
          },
          rotation: t.rotation,
          opacity: t.opacity,
          draggable: !t.locked,
          onClick: o,
          onTap: o,
          onDragMove: (S) => u({ x: S.target.x(), y: S.target.y() }),
          onDragEnd: (S) => l({ x: S.target.x(), y: S.target.y() }, "Moved circle")
        }
      ),
      r && !t.locked && /* @__PURE__ */ D(
        Ei,
        {
          x: t.x,
          y: t.y - h,
          radius: 8 / Math.max(f, 0.01),
          fill: g,
          stroke: d,
          strokeWidth: 2 / Math.max(f, 0.01),
          hitStrokeWidth: F0(f),
          draggable: !0,
          onMouseDown: (S) => {
            S.cancelBubble = !0;
          },
          onTouchStart: (S) => {
            S.cancelBubble = !0;
          },
          onDragMove: (S) => E(S, !1),
          onDragEnd: (S) => E(S, !0)
        }
      )
    ] });
  }
  return "points" in t ? /* @__PURE__ */ D(
    kr,
    {
      id: `object-${t.id}`,
      x: t.x,
      y: t.y,
      points: t.points,
      stroke: jc(t.stroke, d),
      fill: jc(t.stroke, d),
      strokeWidth: t.strokeWidth,
      dash: t.dash,
      lineCap: "round",
      lineJoin: "round",
      tension: t.type === "freehand" ? 0.35 : 0,
      hitStrokeWidth: 24,
      rotation: t.rotation,
      scaleX: t.scaleX,
      scaleY: t.scaleY,
      opacity: t.opacity,
      draggable: !t.locked,
      onClick: o,
      onTap: o,
      onDragMove: (h) => u({ x: h.target.x(), y: h.target.y() }),
      onDragEnd: (h) => l({ x: h.target.x(), y: h.target.y() }, `Moved ${t.type}`)
    }
  ) : null;
}
const DP = 341.55, LP = 273.24, aw = 72 / 32, OP = 32 / 72, c0 = 12, Va = 6, FP = eb(function({ branding: t, topRightOverlay: r, playbackPosition: o, playbackTailsVisible: l = !0 }, u) {
  const { t: d } = jn(), f = Wa(null), g = Wa(null), h = Wa(null), v = Wa(null), [E, S] = Gn({ width: 800, height: 600 }), [w, T] = Gn(0), [P, z] = Gn({ x: 0, y: 0, scale: 1 }), [L, x] = Gn(null), k = Wa(null), R = Wa(null), B = Wa(!1), [q, X] = Gn(!1), I = Wa(null), U = yt((de) => de.scenario), F = yt((de) => de.dragPreview), Z = yt((de) => de.selectedIds), te = yt((de) => de.activeTool), ie = yt((de) => de.addAt), ue = yt((de) => de.addObject), ce = yt((de) => de.select), ze = yt((de) => de.updateObject), W = yt((de) => de.updateCanvas), j = yt((de) => de.setTool), ee = yt((de) => de.setDragPreview), Q = yt((de) => de.brandAccentColor), oe = yt((de) => de.markColor), ye = yt((de) => de.startLineFlagColor), pe = Qu(U.canvas.background), Me = U.canvas.infinite, We = pe ? dm : z0, Ee = pe ? wP : z0, ae = pe ? "#71808A" : "#BCCDD3", Re = Math.max(
    0.01,
    Math.min(E.width / U.canvas.width, E.height / U.canvas.height)
  ), Qe = Math.max(0, (E.width - U.canvas.width * Re) / 2), Pe = Math.max(0, (E.height - U.canvas.height * Re) / 2), rt = Re * P.scale, st = {
    x: -P.x / rt,
    y: -P.y / rt,
    width: E.width / rt,
    height: E.height / rt
  }, bt = Math.max(st.width, st.height) * 0.5, Xt = Me ? {
    x: st.x - bt,
    y: st.y - bt,
    width: st.width + bt * 2,
    height: st.height + bt * 2
  } : { x: 0, y: 0, width: U.canvas.width, height: U.canvas.height }, Lt = Math.max(
    1,
    Math.min(
      E.width <= 640 ? LP : DP,
      E.width - Va * 2,
      (E.height - Va * 2) * aw
    )
  ), qn = w || Lt / aw, Wt = Lt * OP, bn = P.x + U.canvas.width * rt, Yr = P.y, Pn = P.y + U.canvas.height * rt, gn = Me ? Va : Math.min(
    Math.max(
      Va,
      E.width - bn + c0
    ),
    Math.max(
      Va,
      E.width - Lt - Va
    )
  ), vn = Me ? Va : Math.min(
    Math.max(
      Va,
      E.height - Pn + c0
    ),
    Math.max(
      Va,
      E.height - qn - Va
    )
  ), ir = Me ? Va : Math.min(
    Math.max(
      Va,
      E.width - bn + c0
    ),
    Math.max(
      Va,
      E.width - Wt - Va
    )
  ), cr = Me ? Va : Math.min(
    Math.max(Va, Yr + c0),
    Math.max(
      Va,
      E.height - Wt - Va
    )
  ), er = Bf(U.environment.laylineAngle, 500), ln = ta(
    () => X0(U.objects, U.environment.measurementBoatClass).length,
    [U.environment.measurementBoatClass, U.objects]
  ), dr = ln, kn = o !== void 0, tr = Me && !kn, ot = Me && U.canvas.windIndicatorPosition ? U.canvas.windIndicatorPosition : { x: 120, y: 130 }, Tt = ta(
    () => Z.length > 0 && Z.every((de) => {
      const et = U.objects.find((Ge) => Ge.id === de);
      return et ? !SP.has(et.type) : !1;
    }),
    [U.objects, Z]
  ), Ut = ta(
    () => Z.length === 1 && U.objects.some(
      (de) => de.id === Z[0] && de.type !== "mark" && de.type !== "gate" && de.type !== "start-line" && de.type !== "finish-line" && de.type !== "line" && de.type !== "arrow" && de.type !== "rectangle" && de.type !== "circle"
    ),
    [U.objects, Z]
  ), Ft = ta(
    () => Z.length === 1 && U.objects.some((de) => de.id === Z[0] && de.type === "boat"),
    [U.objects, Z]
  ), Fn = ta(
    () => Z.length === 1 && U.objects.some(
      (de) => de.id === Z[0] && de.type === "rectangle"
    ),
    [U.objects, Z]
  ), _n = ta(
    () => [...U.objects].sort((de, et) => de.zIndex - et.zIndex),
    [U.objects]
  ), qe = ta(
    () => _n.map(
      (de) => (F == null ? void 0 : F.id) === de.id ? { ...de, ...F.patch } : de
    ),
    [F, _n]
  ), gt = ta(
    () => kn ? mP(_n, o) : qe,
    [qe, kn, _n, o]
  ), Dn = ta(() => {
    if (kn)
      return l ? gP(_n, o).filter(
        ({ path: et }) => et
      ) : [];
    const de = /* @__PURE__ */ new Map();
    for (const et of gt)
      et.type !== "boat" || !et.visible || de.set(et.sequenceId, [...de.get(et.sequenceId) ?? [], et]);
    return [...de.entries()].map(([et, Ge]) => ({ id: et, boats: Ge, path: rA(Ge) })).filter(({ path: et }) => et);
  }, [gt, kn, _n, o, l]), Tn = ta(() => {
    const de = /* @__PURE__ */ new Map();
    for (const et of _n) {
      if (et.type !== "boat" || !et.visible) continue;
      const Ge = de.get(et.sequenceId);
      (!Ge || et.positionNumber < Ge.positionNumber) && de.set(et.sequenceId, et);
    }
    return [...de.values()].map(
      ({ sequenceId: et, boatClass: Ge, color: kt, name: Et, sailNumber: Xn }) => ({
        sequenceId: et,
        boatClass: Ge,
        color: kt,
        name: Et,
        sailNumber: Xn
      })
    );
  }, [_n]), Xe = () => {
    const de = {
      x: Qe,
      y: Pe,
      scale: 1
    };
    z(de), W({ view: de });
  };
  Q9(u, () => ({
    fitToScreen: Xe,
    resetView: () => {
      const de = {
        x: Qe,
        y: Pe,
        scale: 1
      };
      z(de), W({ view: de });
    },
    exportPng: (de = !1, et = 2) => {
      const Ge = h.current;
      if (!Ge) return "";
      const kt = v.current, Et = Ge.findOne("#canvas-background"), Xn = Ge.findOne("#canvas-grid"), en = {
        x: Ge.x(),
        y: Ge.y(),
        scaleX: Ge.scaleX(),
        scaleY: Ge.scaleY(),
        width: Ge.width(),
        height: Ge.height(),
        background: Et ? {
          x: Et.x(),
          y: Et.y(),
          width: Et.width(),
          height: Et.height(),
          visible: Et.visible()
        } : null
      };
      if (kt == null || kt.hide(), de && (Et == null || Et.hide()), Me) {
        const yn = lP(U, ln), Tr = 8192, vr = Math.min(
          et,
          Tr / yn.width,
          Tr / yn.height,
          Math.sqrt(32e6 / (yn.width * yn.height))
        ), Ti = Math.max(1, Math.ceil(yn.width * vr)), Qo = Math.max(1, Math.ceil(yn.height * vr)), ma = Et == null ? void 0 : Et.getLayer(), ga = U.canvas.grid.visible ? new D4.Group({
          clipX: yn.x,
          clipY: yn.y,
          clipWidth: yn.width,
          clipHeight: yn.height,
          opacity: U.canvas.grid.opacity,
          listening: !1
        }) : null;
        try {
          if (Xn == null || Xn.hide(), Et == null || Et.setAttrs(yn), ga && ma) {
            const Qr = j6(
              yn.x,
              yn.y,
              yn.width,
              yn.height,
              dr,
              U.environment.laylineAngle,
              U.environment.windDirection
            );
            ga.add(
              new D4.Shape({
                sceneFunc: (Jo, Co) => {
                  Jo.beginPath();
                  for (const [yr, oo, li, $o] of Qr)
                    Jo.moveTo(yr, oo), Jo.lineTo(li, $o);
                  Jo.fillStrokeShape(Co);
                },
                stroke: ae,
                strokeWidth: 1.2,
                dash: [4, 7],
                perfectDrawEnabled: !1,
                listening: !1
              })
            ), ma.add(ga), ga.moveToBottom(), Et == null || Et.moveToBottom();
          }
          return Ge.position({ x: -yn.x * vr, y: -yn.y * vr }), Ge.scale({ x: vr, y: vr }), Ge.size({ width: Ti, height: Qo }), Ge.draw(), Ge.toDataURL({ pixelRatio: 1, mimeType: "image/png" });
        } finally {
          ga == null || ga.destroy(), Xn == null || Xn.show(), Ge.position({ x: en.x, y: en.y }), Ge.scale({ x: en.scaleX, y: en.scaleY }), Ge.size({ width: en.width, height: en.height }), Et && en.background && Et.setAttrs(en.background), kt == null || kt.show(), Ge.draw();
        }
      }
      Ge.position({ x: 0, y: 0 }), Ge.scale({ x: 1, y: 1 }), Ge.size({ width: U.canvas.width, height: U.canvas.height });
      const Vt = Ge.toDataURL({ pixelRatio: et, mimeType: "image/png" });
      return Ge.position({ x: en.x, y: en.y }), Ge.scale({ x: en.scaleX, y: en.scaleY }), Ge.size({ width: en.width, height: en.height }), Et && en.background && Et.visible(en.background.visible), kt == null || kt.show(), Vt;
    }
  })), En(() => {
    if (!f.current) return;
    const de = new ResizeObserver(([et]) => {
      S({
        width: Math.max(1, et.contentRect.width),
        height: Math.max(1, et.contentRect.height)
      });
    });
    return de.observe(f.current), () => de.disconnect();
  }, []), En(() => {
    const de = g.current;
    if (!de) {
      T(0);
      return;
    }
    const et = new ResizeObserver(([Ge]) => {
      T(Ge.contentRect.height);
    });
    return et.observe(de), () => et.disconnect();
  }, [t]), En(() => {
    E.width && E.height && U.canvas.view.scale <= 1 ? Xe() : z(U.canvas.view);
  }, [
    U.metadata.id,
    U.canvas.width,
    U.canvas.height,
    U.canvas.infinite,
    E.width,
    E.height
  ]), En(() => {
    var Xn;
    const de = h.current, et = v.current;
    if (!de || !et) return;
    const Ge = (kn ? [] : Z).map((en) => {
      const Vt = U.objects.find((yn) => yn.id === en);
      return (Vt == null ? void 0 : Vt.type) === "mark" || (Vt == null ? void 0 : Vt.type) === "gate" || (Vt == null ? void 0 : Vt.type) === "start-line" || (Vt == null ? void 0 : Vt.type) === "finish-line" || (Vt == null ? void 0 : Vt.type) === "line" || (Vt == null ? void 0 : Vt.type) === "arrow" || (Vt == null ? void 0 : Vt.type) === "circle" ? null : de.findOne(`#object-${en}`);
    }).filter((en) => !!en), kt = Ge.flatMap((en) => {
      if (en.getType() !== "Group") return [];
      const Vt = en;
      return Vt.findOne(".rotation-bounds") ? [cP(Vt)] : [];
    });
    et.nodes(Ge), et.forceUpdate();
    const Et = et.findOne(".back");
    return Et == null || Et.visible(Ut), Et == null || Et.sceneFunc((en, Vt) => {
      if (!Ut) return;
      const yn = Vt.getParent();
      en.beginPath(), en.moveTo(Vt.width() / 2, 0), en.lineTo(Vt.width() / 2, -yn.rotateAnchorOffset()), en.strokeShape(Vt);
    }), (Xn = et.getLayer()) == null || Xn.batchDraw(), () => kt.forEach((en) => en());
  }, [kn, Z, U.objects, Ut]), En(() => {
    const de = (Ge) => Ge.code === "Space" && X(!0), et = (Ge) => Ge.code === "Space" && X(!1);
    return window.addEventListener("keydown", de), window.addEventListener("keyup", et), () => {
      window.removeEventListener("keydown", de), window.removeEventListener("keyup", et);
    };
  }, []), En(() => {
    x((de) => !de || de.tool === te ? de : (k.current = null, R.current = null, B.current = !1, null));
  }, [te]);
  const Ue = () => {
    var et;
    const de = (et = h.current) == null ? void 0 : et.getPointerPosition();
    return de ? { x: (de.x - P.x) / rt, y: (de.y - P.y) / rt } : null;
  }, _t = (de) => {
    if (kn) return;
    const et = de.target === de.target.getStage(), Ge = Ue();
    if (!Ge || te === "pan" || q) return;
    const kt = k.current;
    if (kt && kt.tool === te && Wy.has(te) && B.current) {
      const Et = {
        ...kt,
        points: [kt.start.x, kt.start.y, Ge.x, Ge.y]
      };
      Zr(Et);
      return;
    }
    if (et) {
      if (te === "select") {
        ce(null);
        return;
      }
      if (te === "boat" || te === "mark" || te === "downwind-mark") {
        ie(te, Ge.x, Ge.y);
        return;
      }
      if (te === "text") {
        ue(
          {
            id: Ka(),
            type: "text",
            x: Ge.x,
            y: Ge.y,
            rotation: 0,
            scaleX: 1,
            scaleY: 1,
            visible: !0,
            locked: !1,
            zIndex: _n.length + 1,
            opacity: 1,
            text: d("Annotation"),
            color: "#171717",
            fontSize: 28,
            fontWeight: "normal",
            align: "left",
            background: "transparent"
          },
          "Added text"
        ), j("select");
        return;
      }
      if (vP.includes(te)) {
        const Et = {
          tool: te,
          start: Ge,
          points: [Ge.x, Ge.y, Ge.x, Ge.y]
        };
        k.current = Et, R.current = Wy.has(te) ? { start: Ge } : null, B.current = !1, x(Et);
      }
    }
  }, or = () => {
    if (!k.current) return;
    const de = Ue();
    de && x((et) => {
      if (!et) return null;
      const Ge = {
        ...et,
        points: et.tool === "freehand" ? [...et.points, de.x, de.y] : [et.start.x, et.start.y, de.x, de.y]
      };
      return k.current = Ge, Ge;
    });
  }, xt = (de) => {
    var Et;
    if (de.evt.touches.length !== 2) {
      _t(de);
      return;
    }
    de.evt.preventDefault(), k.current = null, R.current = null, B.current = !1, x(null);
    const et = (Et = f.current) == null ? void 0 : Et.getBoundingClientRect(), [Ge, kt] = Array.from(de.evt.touches);
    !et || !Ge || !kt || (I.current = {
      distance: Math.hypot(kt.clientX - Ge.clientX, kt.clientY - Ge.clientY),
      center: {
        x: (Ge.clientX + kt.clientX) / 2 - et.left,
        y: (Ge.clientY + kt.clientY) / 2 - et.top
      }
    });
  }, zn = (de) => {
    var vr;
    if (de.evt.touches.length !== 2 || !I.current) {
      or();
      return;
    }
    de.evt.preventDefault();
    const et = (vr = f.current) == null ? void 0 : vr.getBoundingClientRect(), [Ge, kt] = Array.from(de.evt.touches);
    if (!et || !Ge || !kt) return;
    const Et = Math.hypot(kt.clientX - Ge.clientX, kt.clientY - Ge.clientY), Xn = {
      x: (Ge.clientX + kt.clientX) / 2 - et.left,
      y: (Ge.clientY + kt.clientY) / 2 - et.top
    }, Vt = Math.min(
      8,
      Math.max(Me ? 0.1 : 1, P.scale * (Et / Math.max(1, I.current.distance)))
    ), yn = {
      x: (I.current.center.x - P.x) / rt,
      y: (I.current.center.y - P.y) / rt
    }, Tr = Re * Vt, Nr = Vt === 1 && !Me ? {
      scale: Vt,
      x: Qe,
      y: Pe
    } : { scale: Vt, x: Xn.x - yn.x * Tr, y: Xn.y - yn.y * Tr };
    z(Nr), I.current = { distance: Et, center: Xn };
  }, aa = () => {
    if (I.current) {
      I.current = null, W({ view: P });
      return;
    }
    mr();
  };
  function Zr(de) {
    let [et, Ge, kt, Et] = de.points.length > 4 ? [
      de.points[0],
      de.points[1],
      de.points.at(-2),
      de.points.at(-1)
    ] : de.points;
    if ((de.tool === "gate" || de.tool === "start-line" || de.tool === "finish-line") && Math.hypot(kt - et, Et - Ge) < 32) {
      const Vt = dr * (de.tool === "gate" ? 3 : 5), yn = U.environment.windDirection * Math.PI / 180, Tr = et, Nr = Ge, vr = Math.cos(yn) * Vt, Ti = Math.sin(yn) * Vt;
      et = Tr - vr, Ge = Nr - Ti, kt = Tr + vr, Et = Nr + Ti;
    }
    const Xn = Math.max(0, ..._n.map(({ zIndex: Vt }) => Vt)) + 1, en = {
      id: Ka(),
      x: 0,
      y: 0,
      rotation: 0,
      scaleX: 1,
      scaleY: 1,
      visible: !0,
      locked: !1,
      zIndex: Xn,
      opacity: 1
    };
    if (de.tool === "gate")
      ue(
        t6(
          et,
          Ge,
          kt,
          Et,
          Xn,
          h0(U.objects),
          U.environment.zoneRadiusBoatLengths,
          oe
        ),
        "Added gate"
      );
    else if (de.tool === "start-line")
      ue(hb(et, Ge, kt, Et, Xn, ye), "Added start line");
    else if (de.tool === "finish-line")
      ue(n6(et, Ge, kt, Et, Xn), "Added finish line");
    else if (de.tool === "rectangle" || de.tool === "circle") {
      const Vt = Math.max(4, Math.hypot(kt - et, Et - Ge));
      ue(
        {
          ...en,
          type: de.tool,
          x: de.tool === "circle" ? et : Math.min(et, kt),
          y: de.tool === "circle" ? Ge : Math.min(Ge, Et),
          width: de.tool === "circle" ? Vt * 2 : Math.max(8, Math.abs(kt - et)),
          height: de.tool === "circle" ? Vt * 2 : Math.max(8, Math.abs(Et - Ge)),
          stroke: "#171717",
          strokeWidth: qc,
          fill: "transparent"
        },
        `Added ${de.tool}`
      );
    } else
      ue(
        {
          ...en,
          type: de.tool,
          points: de.points,
          stroke: "#171717",
          strokeWidth: qc,
          dash: []
        },
        `Added ${de.tool}`
      );
    k.current = null, R.current = null, B.current = !1, x(null), j("select");
  }
  const mr = () => {
    const de = k.current;
    if (de) {
      if (Wy.has(de.tool)) {
        const et = Ue(), Ge = et ? {
          ...de,
          points: [de.start.x, de.start.y, et.x, et.y]
        } : de, kt = R.current;
        if (R.current = null, (kt ? Math.hypot(
          Ge.points[2] - kt.start.x,
          Ge.points[3] - kt.start.y
        ) * rt : 0) >= yP) {
          Zr(Ge);
          return;
        }
        B.current = !0, k.current = Ge, x(Ge);
        return;
      }
      Zr(de);
    }
  }, Xr = (de) => {
    de.evt.preventDefault();
    const et = h.current, Ge = et == null ? void 0 : et.getPointerPosition();
    if (!et || !Ge) return;
    const kt = {
      x: (Ge.x - P.x) / rt,
      y: (Ge.y - P.y) / rt
    }, Et = de.evt.deltaY > 0 ? -1 : 1, en = Math.min(
      8,
      Math.max(Me ? 0.1 : 1, Et > 0 ? P.scale * 1.08 : P.scale / 1.08)
    ), Vt = Re * en, yn = en === 1 && !Me ? {
      scale: en,
      x: Qe,
      y: Pe
    } : {
      scale: en,
      x: Ge.x - kt.x * Vt,
      y: Ge.y - kt.y * Vt
    };
    z(yn), W({ view: yn });
  };
  return /* @__PURE__ */ le("div", { ref: f, className: "editor-canvas", "aria-label": d("Sailing plot canvas"), children: [
    /* @__PURE__ */ D(
      aP,
      {
        ref: h,
        width: E.width,
        height: E.height,
        x: P.x,
        y: P.y,
        scaleX: rt,
        scaleY: rt,
        draggable: !kn && (te === "pan" || q),
        onDragMove: (de) => {
          !Me || de.target !== h.current || z((et) => ({ ...et, x: de.target.x(), y: de.target.y() }));
        },
        onDragEnd: (de) => {
          if (de.target !== h.current) return;
          const et = P.scale === 1 && !Me ? {
            ...P,
            x: Qe,
            y: Pe
          } : { ...P, x: de.target.x(), y: de.target.y() };
          z(et), W({ view: et });
        },
        onWheel: Xr,
        onMouseDown: _t,
        onTouchStart: xt,
        onMouseMove: or,
        onTouchMove: zn,
        onMouseUp: mr,
        onTouchEnd: aa,
        children: /* @__PURE__ */ le(tP, { children: [
          /* @__PURE__ */ D(
            Kr,
            {
              id: "canvas-background",
              x: Xt.x,
              y: Xt.y,
              width: Xt.width,
              height: Xt.height,
              fill: U.canvas.background,
              listening: !1
            }
          ),
          U.canvas.grid.visible && /* @__PURE__ */ D(
            xP,
            {
              id: "canvas-grid",
              x: Xt.x,
              y: Xt.y,
              width: Xt.width,
              height: Xt.height,
              size: dr,
              opacity: U.canvas.grid.opacity,
              color: ae,
              laylineAngle: U.environment.laylineAngle,
              windDirection: U.environment.windDirection,
              infinite: Me
            }
          ),
          U.environment.zonesVisible && gt.flatMap((de) => de.type === "mark" && de.visible && de.zoneVisible ? [
            /* @__PURE__ */ D(
              Ei,
              {
                x: de.x,
                y: de.y,
                radius: de.zoneRadius * ln,
                fill: de.color,
                opacity: 0.07,
                stroke: de.color,
                dash: [10, 8],
                strokeWidth: 2,
                listening: !1
              },
              `zone-${de.id}`
            )
          ] : de.type === "gate" && de.visible && de.zoneVisible ? ["a", "b"].map((et) => /* @__PURE__ */ D(
            Ei,
            {
              x: de.x + (et === "a" ? de.endAX : de.endBX),
              y: de.y + (et === "a" ? de.endAY : de.endBY),
              radius: de.zoneRadius * ln,
              fill: de.color,
              opacity: 0.07,
              stroke: de.color,
              dash: [10, 8],
              strokeWidth: 2,
              listening: !1
            },
            `zone-${de.id}-${et}`
          )) : []),
          Dn.map(({ id: de, boats: et, path: Ge }) => /* @__PURE__ */ D(
            Vo,
            {
              data: Ge,
              stroke: et[0].color,
              strokeWidth: 3,
              opacity: kn ? 0.7 : 0.52,
              lineCap: "round",
              lineJoin: "round",
              listening: !1
            },
            `track-${de}`
          )),
          U.environment.laylinesVisible && gt.filter(
            (de) => de.type === "mark" && de.laylinesVisible
          ).map((de) => /* @__PURE__ */ le(
            Yn,
            {
              x: de.x,
              y: de.y,
              rotation: iP(U.environment.windDirection, de.downwind),
              listening: !1,
              children: [
                /* @__PURE__ */ D(
                  kr,
                  {
                    points: [0, 0, er.x, er.y],
                    stroke: de.color,
                    dash: [12, 10],
                    strokeWidth: 2,
                    opacity: 0.62
                  }
                ),
                /* @__PURE__ */ D(
                  kr,
                  {
                    points: [0, 0, -er.x, er.y],
                    stroke: de.color,
                    dash: [12, 10],
                    strokeWidth: 2,
                    opacity: 0.62
                  }
                )
              ]
            },
            `laylines-${de.id}`
          )),
          U.environment.windVisible && /* @__PURE__ */ le(
            Yn,
            {
              x: ot.x,
              y: ot.y,
              draggable: tr,
              listening: tr,
              onMouseDown: (de) => {
                tr && (de.cancelBubble = !0);
              },
              onTouchStart: (de) => {
                tr && (de.cancelBubble = !0);
              },
              onDragEnd: (de) => W({
                windIndicatorPosition: { x: de.target.x(), y: de.target.y() }
              }),
              children: [
                tr && /* @__PURE__ */ D(Kr, { x: -80, y: -116, width: 160, height: 204, fill: "rgba(0,0,0,0.001)" }),
                /* @__PURE__ */ le(Yn, { rotation: U.environment.windDirection, children: [
                  /* @__PURE__ */ D(
                    Ei,
                    {
                      x: 0,
                      y: -72,
                      radius: 6,
                      fill: Q,
                      stroke: Ee,
                      strokeWidth: 2
                    }
                  ),
                  /* @__PURE__ */ D(
                    j2,
                    {
                      points: [0, -62, 0, 72],
                      stroke: We,
                      fill: We,
                      strokeWidth: 5,
                      pointerLength: 18,
                      pointerWidth: 16
                    }
                  )
                ] }),
                /* @__PURE__ */ D(
                  ec,
                  {
                    text: `${d("WIND FROM")}${U.environment.windStrength ? ` · ${U.environment.windStrength}` : ""}`,
                    x: -70,
                    y: -104,
                    width: 140,
                    align: "center",
                    fill: We,
                    fontSize: 15,
                    fontStyle: "bold"
                  }
                )
              ]
            }
          ),
          gt.filter((de) => de.visible).map((de) => {
            const et = de.type === "mark" && !U.environment.zonesVisible ? { ...de, zoneVisible: !1 } : de;
            return /* @__PURE__ */ D(
              PP,
              {
                object: et,
                selected: !kn && Z.includes(de.id),
                onSelect: (Ge) => {
                  kn || (Ge.cancelBubble = !0, !(te === "select" || te === "boat" && de.type === "boat")) || ce(
                    de.id,
                    te === "select" && "shiftKey" in Ge.evt && Ge.evt.shiftKey
                  );
                },
                onChange: (Ge, kt) => {
                  ze(de.id, Ge, kt), (F == null ? void 0 : F.id) === de.id && ee(null);
                },
                onPreviewChange: (Ge) => ee({ id: de.id, patch: Ge }),
                windDirection: U.environment.windDirection,
                laylineAngle: U.environment.laylineAngle,
                zoneBoatLength: ln,
                boatNumbersVisible: !kn && U.canvas.boatNumbersVisible,
                inkColor: We,
                outlineColor: Ee,
                interactionScale: rt,
                brandAccentColor: Q,
                configuredMarkColor: oe
              },
              de.id
            );
          }),
          U.canvas.boatLegendVisible && /* @__PURE__ */ D(
            kP,
            {
              entries: Tn,
              canvasHeight: U.canvas.height,
              dark: pe,
              position: Me ? U.canvas.boatLegendPosition : null,
              draggable: tr,
              onPositionChange: (de) => W({ boatLegendPosition: de })
            }
          ),
          !kn && L && (L.tool === "rectangle" ? /* @__PURE__ */ le(Yn, { listening: !1, children: [
            /* @__PURE__ */ D(
              Kr,
              {
                x: Math.min(L.points[0], L.points[2]),
                y: Math.min(L.points[1], L.points[3]),
                width: Math.abs(L.points[2] - L.points[0]),
                height: Math.abs(L.points[3] - L.points[1]),
                stroke: We,
                strokeWidth: qc,
                dash: [8, 6]
              }
            ),
            /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[0],
                y: L.points[1],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              }
            ),
            /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[2],
                y: L.points[3],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              }
            )
          ] }) : L.tool === "circle" ? /* @__PURE__ */ le(Yn, { listening: !1, children: [
            /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[0],
                y: L.points[1],
                radius: Math.hypot(
                  L.points[2] - L.points[0],
                  L.points[3] - L.points[1]
                ),
                stroke: We,
                strokeWidth: qc,
                dash: [8, 6]
              }
            ),
            /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[0],
                y: L.points[1],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              }
            ),
            /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[2],
                y: L.points[3],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              }
            )
          ] }) : L.tool === "arrow" ? /* @__PURE__ */ le(Yn, { listening: !1, children: [
            /* @__PURE__ */ D(
              j2,
              {
                points: L.points,
                stroke: We,
                fill: We,
                strokeWidth: qc,
                pointerLength: 14,
                pointerWidth: 12
              }
            ),
            [0, 1].map((de) => /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[de * 2],
                y: L.points[de * 2 + 1],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              },
              de
            ))
          ] }) : L.tool === "line" ? /* @__PURE__ */ le(Yn, { listening: !1, children: [
            /* @__PURE__ */ D(
              kr,
              {
                points: L.points,
                stroke: We,
                strokeWidth: qc,
                lineCap: "round",
                lineJoin: "round"
              }
            ),
            [0, 1].map((de) => /* @__PURE__ */ D(
              Ei,
              {
                x: L.points[de * 2],
                y: L.points[de * 2 + 1],
                radius: 6,
                fill: Q,
                stroke: We,
                strokeWidth: 2
              },
              de
            ))
          ] }) : /* @__PURE__ */ D(
            kr,
            {
              points: L.points,
              stroke: We,
              strokeWidth: qc,
              dash: L.tool === "gate" || L.tool === "start-line" || L.tool === "finish-line" ? [16, 10] : void 0,
              lineCap: "round",
              lineJoin: "round",
              tension: L.tool === "freehand" ? 0.35 : 0,
              listening: !1
            }
          )),
          /* @__PURE__ */ D(
            rP,
            {
              ref: v,
              rotateEnabled: Ut,
              rotateLineVisible: Ut,
              rotateAnchorOffset: Ut ? Ft ? uP : Z6 : 0,
              borderEnabled: Ut,
              resizeEnabled: Tt,
              enabledAnchors: Fn ? _P : bP,
              keepRatio: !Fn,
              anchorSize: 18,
              borderStroke: We,
              borderStrokeWidth: 2,
              anchorFill: Q,
              anchorStroke: We,
              anchorCornerRadius: 4
            }
          )
        ] })
      }
    ),
    t && /* @__PURE__ */ D(
      "div",
      {
        ref: g,
        className: "canvas-branding-anchor",
        style: { width: Lt, right: gn, bottom: vn },
        children: t
      }
    ),
    r && /* @__PURE__ */ D(
      "div",
      {
        className: "canvas-top-right-overlay",
        style: {
          width: Wt,
          height: Wt,
          top: cr,
          right: ir
        },
        children: r
      }
    )
  ] });
});
function zP(e) {
  return /* @__PURE__ */ le(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "data-icon": "sailing-gate",
      ...e,
      children: [
        /* @__PURE__ */ D("path", { d: "M3.5 7.5c0-1 4.5-1 4.5 0v9c0 1-4.5 1-4.5 0Z" }),
        /* @__PURE__ */ D("path", { d: "M3.5 7.5c0 1 4.5 1 4.5 0" }),
        /* @__PURE__ */ D("path", { d: "M16 7.5c0-1 4.5-1 4.5 0v9c0 1-4.5 1-4.5 0Z" }),
        /* @__PURE__ */ D("path", { d: "M16 7.5c0 1 4.5 1 4.5 0" }),
        /* @__PURE__ */ D("path", { d: "M8 12h8", strokeDasharray: "2 2" })
      ]
    }
  );
}
const iw = [
  { id: "select", label: "Select", icon: y7 },
  { id: "pan", label: "Pan", icon: _7 },
  { id: "boat", label: "Boat", icon: k7 },
  { id: "mark", label: "Mark", icon: pS },
  { id: "downwind-mark", label: "Lee mark", icon: pS },
  { id: "gate", label: "Gate", icon: zP },
  { id: "start-line", label: "Start line", icon: d7 },
  { id: "finish-line", label: "Finish line", icon: f7 },
  { id: "line", label: "Line", icon: v7 },
  { id: "arrow", label: "Arrow", icon: a7 },
  { id: "freehand", label: "Freehand", icon: w7 },
  { id: "text", label: "Text", icon: N7 },
  { id: "rectangle", label: "Rectangle", icon: T7 },
  { id: "circle", label: "Circle", icon: u7 }
];
function ow({ compact: e = !1 }) {
  const { t } = jn(), r = yt((u) => u.activeTool), o = yt((u) => u.setTool), l = e ? iw.filter(({ id: u }) => u !== "downwind-mark") : iw;
  return /* @__PURE__ */ D(
    "nav",
    {
      className: e ? "tool-grid tool-grid--compact" : "tool-grid",
      "aria-label": t("Editor tools"),
      children: l.map(({ id: u, label: d, icon: f }) => /* @__PURE__ */ D(
        pr,
        {
          icon: /* @__PURE__ */ D(f, { "aria-hidden": "true" }),
          label: t(d),
          compact: e,
          active: r === u,
          onClick: () => o(u)
        },
        u
      ))
    }
  );
}
const BP = [
  { name: "Starting-line orange", value: "#FF5E00" },
  { name: "Finishing-line blue", value: "#168DDD" },
  { name: "Signal red", value: "#D72638" },
  { name: "Signal yellow", value: "#FFD100" },
  { name: "Signal green", value: "#00843D" },
  { name: "Signal black", value: "#171717" },
  { name: "Signal white", value: "#FFFFFF" }
], UP = 6, IP = (e) => {
  const t = e.trim().toUpperCase();
  return /^#[0-9A-F]{6}$/.test(t) ? t : null;
}, Eb = (e, t = [], r = UP) => {
  const o = [];
  for (const l of [...e, ...t]) {
    const u = IP(l);
    if (u && !o.includes(u) && o.push(u), o.length === r) break;
  }
  return o;
}, HP = "sailing-scenario-editor:recent-colors", g0 = [], v0 = /* @__PURE__ */ new Map(), Y2 = /* @__PURE__ */ new Map(), t8 = (e) => {
  const t = v0.get(e);
  if (t) return t;
  if (typeof window > "u") return g0;
  try {
    const r = JSON.parse(window.localStorage.getItem(e) ?? "[]"), o = Eb([], Array.isArray(r) ? r : []);
    return v0.set(e, o), o;
  } catch {
    return v0.set(e, g0), g0;
  }
}, GP = (e, t) => {
  const r = Y2.get(e) ?? /* @__PURE__ */ new Set();
  return r.add(t), Y2.set(e, r), () => r.delete(t);
}, VP = (e, ...t) => {
  var o;
  const r = Eb(t, t8(e));
  v0.set(e, r);
  try {
    window.localStorage.setItem(e, JSON.stringify(r));
  } catch {
  }
  (o = Y2.get(e)) == null || o.forEach((l) => l());
};
function sw({
  color: e,
  name: t,
  source: r,
  selected: o,
  onClick: l
}) {
  const { t: u } = jn(), d = t ? `${u(t)} ${e}` : e;
  return /* @__PURE__ */ D(
    "button",
    {
      type: "button",
      className: "color-swatch",
      "aria-label": u("Use {source} color {description}", {
        source: u(r),
        description: d
      }),
      "aria-pressed": o,
      title: d,
      onClick: l,
      children: /* @__PURE__ */ D("span", { style: { backgroundColor: e } })
    }
  );
}
function qP({
  label: e,
  value: t,
  onChange: r,
  palette: o = db,
  paletteLabel: l = "Heisel sailing palette",
  allowTransparent: u = !1
}) {
  const { t: d } = jn(), { storageNamespace: f } = Zo(), g = Uf(f, HP), h = b0(
    (x) => GP(g, x),
    [g]
  ), v = b0(() => t8(g), [g]), E = t.toLowerCase() === "transparent", S = J9(h, v, () => g0), w = Eb([t], S), [T, P] = Gn(!1), z = Wa(null);
  En(() => {
    if (!T) return;
    const x = (R) => {
      var B;
      (B = z.current) != null && B.contains(R.target) || P(!1);
    }, k = (R) => {
      R.key === "Escape" && P(!1);
    };
    return document.addEventListener("pointerdown", x), document.addEventListener("keydown", k), () => {
      document.removeEventListener("pointerdown", x), document.removeEventListener("keydown", k);
    };
  }, [T]);
  const L = (x) => {
    VP(g, x, t), r(x.toLowerCase()), P(!1);
  };
  return /* @__PURE__ */ le("div", { className: "recent-color-picker", ref: z, children: [
    /* @__PURE__ */ le(
      "button",
      {
        type: "button",
        className: "color-picker-trigger",
        "aria-label": d("Open {label} selector", { label: e }),
        "aria-haspopup": "dialog",
        "aria-expanded": T,
        onClick: () => P((x) => !x),
        children: [
          /* @__PURE__ */ D(
            "span",
            {
              className: `color-picker-preview${E ? " is-transparent" : ""}`,
              style: { backgroundColor: E ? void 0 : t }
            }
          ),
          /* @__PURE__ */ D("span", { className: "color-picker-value", children: E ? d("No fill") : t.toUpperCase() }),
          /* @__PURE__ */ D(ax, { "aria-hidden": "true" })
        ]
      }
    ),
    T && /* @__PURE__ */ le(
      "div",
      {
        className: "color-picker-popover",
        role: "dialog",
        "aria-label": d("{label} colors", { label: e }),
        children: [
          u && /* @__PURE__ */ le(
            "button",
            {
              type: "button",
              className: "transparent-color-option",
              "aria-pressed": E,
              onClick: () => L("transparent"),
              children: [
                /* @__PURE__ */ D("span", { className: "color-picker-preview is-transparent", "aria-hidden": "true" }),
                d("No fill")
              ]
            }
          ),
          /* @__PURE__ */ le("div", { className: "color-options", children: [
            /* @__PURE__ */ D("span", { className: "color-options-label", children: d("Palette") }),
            /* @__PURE__ */ D("div", { className: "color-swatches", "aria-label": d(l), children: o.map((x) => /* @__PURE__ */ D(
              sw,
              {
                color: x.value,
                name: x.name,
                source: "palette",
                selected: x.value.toLowerCase() === t.toLowerCase(),
                onClick: () => L(x.value)
              },
              x.value
            )) })
          ] }),
          /* @__PURE__ */ le("div", { className: "color-options", children: [
            /* @__PURE__ */ D("span", { className: "color-options-label", children: d("Recent") }),
            /* @__PURE__ */ D("div", { className: "color-swatches", "aria-label": d("Recently used colors"), children: w.map((x) => /* @__PURE__ */ D(
              sw,
              {
                color: x,
                source: "recent",
                selected: x.toLowerCase() === t.toLowerCase(),
                onClick: () => L(x)
              },
              x
            )) })
          ] }),
          /* @__PURE__ */ le("label", { className: "color-picker-custom", children: [
            /* @__PURE__ */ D("span", { children: d("Custom color") }),
            /* @__PURE__ */ D(
              "input",
              {
                type: "color",
                value: /^#[0-9a-f]{6}$/i.test(t) ? t : fl,
                "aria-label": d("{label} custom color", { label: e }),
                onChange: (x) => L(x.target.value)
              }
            )
          ] })
        ]
      }
    )
  ] });
}
const WP = (e) => e.type === "gate" || e.type === "start-line" || e.type === "finish-line", lw = (e, t, r, o, l) => {
  const u = r * Math.PI / 180, d = e * o, f = t * l;
  return {
    x: d * Math.cos(u) - f * Math.sin(u),
    y: d * Math.sin(u) + f * Math.cos(u)
  };
};
function KP(e, t, r) {
  const o = WP(e) ? [e.endAX, e.endAY, e.endBX, e.endBY] : e.type === "line" || e.type === "arrow" || e.type === "freehand" ? e.points : null;
  if (!o || o.length < 4 || r <= 0) return null;
  let l = 0;
  for (let v = 0; v <= o.length - 4; v += 2) {
    const E = lw(
      o[v + 2] - o[v],
      o[v + 3] - o[v + 1],
      e.rotation,
      e.scaleX,
      e.scaleY
    );
    l += Math.hypot(E.x, E.y);
  }
  const u = lw(
    o.at(-2) - o[0],
    o.at(-1) - o[1],
    e.rotation,
    e.scaleX,
    e.scaleY
  );
  if (Math.hypot(u.x, u.y) < Number.EPSILON) return null;
  const f = ((Math.atan2(u.x, -u.y) * 180 / Math.PI + 360) % 360 - t + 540) % 360 - 180, h = 90 - Math.min(Math.abs(f), 180 - Math.abs(f));
  return {
    lengthBoatLengths: l / r,
    angleToWind: h
  };
}
const jP = j0.flatMap(
  (e) => e === "Coachboat" ? [e, "Umpire boat"] : e === "Umpire boat" ? [] : [e]
), YP = [
  { value: "none", label: "No flag" },
  { value: "protest", label: "Protest flag (Y)" },
  { value: "red", label: "Red (penalty)" },
  { value: "green-white", label: "Green and white (no penalty)" },
  { value: "yellow", label: "Yellow" },
  { value: "blue", label: "Blue" },
  { value: "black", label: "Black (DSQ)" }
];
function si({ label: e, children: t }) {
  return /* @__PURE__ */ le("label", { className: "field", children: [
    /* @__PURE__ */ D("span", { children: e }),
    t
  ] });
}
function nc({
  label: e,
  value: t,
  onChange: r,
  palette: o,
  paletteLabel: l,
  allowTransparent: u
}) {
  return /* @__PURE__ */ le("div", { className: "field", children: [
    /* @__PURE__ */ D("span", { children: e }),
    /* @__PURE__ */ D(
      qP,
      {
        label: e,
        value: t,
        onChange: r,
        palette: o,
        paletteLabel: l,
        allowTransparent: u
      }
    )
  ] });
}
function B0({
  label: e,
  checked: t,
  checkedLabel: r,
  uncheckedLabel: o,
  onChange: l
}) {
  return /* @__PURE__ */ le("div", { className: "field", children: [
    /* @__PURE__ */ D("span", { children: e }),
    /* @__PURE__ */ le("div", { className: "property-segmented-control", role: "group", "aria-label": e, children: [
      /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          className: t ? "is-active" : "",
          "aria-pressed": t,
          onClick: () => l(!0),
          children: r
        }
      ),
      /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          className: t ? "" : "is-active",
          "aria-pressed": !t,
          onClick: () => l(!1),
          children: o
        }
      )
    ] })
  ] });
}
function ZP({
  value: e,
  onChange: t
}) {
  const { t: r } = jn(), o = [
    { value: "port", label: "Port" },
    { value: "none", label: "None" },
    { value: "starboard", label: "Starboard" }
  ];
  return /* @__PURE__ */ le("div", { className: "field", children: [
    /* @__PURE__ */ D("span", { children: r("Overlap line") }),
    /* @__PURE__ */ D(
      "div",
      {
        className: "property-segmented-control property-segmented-control--three",
        role: "group",
        "aria-label": r("Overlap line"),
        children: o.map((l) => /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: e === l.value ? "is-active" : "",
            "aria-pressed": e === l.value,
            onClick: () => t(l.value),
            children: r(l.label)
          },
          l.value
        ))
      }
    )
  ] });
}
function XP({
  value: e,
  onChange: t
}) {
  const { t: r } = jn(), o = [
    { value: "port", label: "Yes left" },
    { value: "none", label: "No" },
    { value: "starboard", label: "Yes right" }
  ];
  return /* @__PURE__ */ le("div", { className: "field", children: [
    /* @__PURE__ */ D("span", { children: r("Red protest flag") }),
    /* @__PURE__ */ D(
      "div",
      {
        className: "property-segmented-control property-segmented-control--three",
        role: "group",
        "aria-label": r("Red protest flag"),
        children: o.map((l) => /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: e === l.value ? "is-active" : "",
            "aria-pressed": e === l.value,
            onClick: () => t(l.value),
            children: r(l.label)
          },
          l.value
        ))
      }
    )
  ] });
}
function uw({
  onForward: e,
  onBackward: t
}) {
  const { t: r } = jn();
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ D("h3", { className: "action-grid__heading", children: r("Layer order") }),
    /* @__PURE__ */ le("div", { className: "action-grid__layer", children: [
      /* @__PURE__ */ D(pr, { icon: /* @__PURE__ */ D(i7, {}), label: r("Forward"), onClick: e }),
      /* @__PURE__ */ D(pr, { icon: /* @__PURE__ */ D(n7, {}), label: r("Backward"), onClick: t })
    ] })
  ] });
}
const td = (e, t = 0) => Number.isFinite(Number(e)) ? Number(e) : t, cw = (e, t, r) => Math.min(r, Math.max(t, td(e))), Kc = (e) => Math.round(e * 10) / 10;
function xf({
  label: e,
  value: t,
  min: r,
  max: o,
  luffing: l,
  onChange: u
}) {
  const { t: d } = jn();
  return /* @__PURE__ */ D(
    si,
    {
      label: /* @__PURE__ */ le("span", { className: "sail-angle-label", children: [
        /* @__PURE__ */ D("span", { children: e }),
        l && /* @__PURE__ */ D("span", { className: "sail-status", children: d("Luffing") })
      ] }),
      children: /* @__PURE__ */ le("div", { className: "angle-control", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "range",
            min: r,
            max: o,
            step: "1",
            value: t,
            "aria-label": d("{label} slider", { label: e }),
            onChange: (f) => u(cw(f.target.value, r, o))
          }
        ),
        /* @__PURE__ */ D(
          "input",
          {
            type: "number",
            min: r,
            max: o,
            step: "1",
            value: Kc(t),
            "aria-label": d("{label} degrees", { label: e }),
            onChange: (f) => u(cw(f.target.value, r, o))
          }
        )
      ] })
    }
  );
}
function QP({
  object: e,
  update: t
}) {
  const { t: r } = jn(), o = yt((F) => F.scenario.environment), l = yt((F) => F.scenario.objects), u = yt((F) => F.scenario.canvas.background), d = yt((F) => F.brandAccentColor), f = Df(u, d), g = ml[e.boatClass], h = !!(g.mast && g.mainsailSize), v = !!(g.jibTack && g.jibSize), E = !!(g.jibTack && g.genoaSize), S = !!(g.mast && g.spinnakerSize), w = !!(g.gennakerTack && g.gennakerSize), T = e.boatClass === "Coachboat" || e.boatClass === "Umpire boat", P = /* @__PURE__ */ new Map();
  for (const F of l) {
    if (F.type !== "boat" || Zl(F.boatClass)) continue;
    const Z = F.color.toUpperCase(), te = [r(F.boatClass), F.sailNumber || F.name].filter(Boolean).join(" · "), ie = P.get(Z);
    ie ? ie.labels.add(te) : P.set(Z, { color: F.color, labels: /* @__PURE__ */ new Set([te]) });
  }
  e.boatFlagColor && !P.has(e.boatFlagColor.toUpperCase()) && P.set(e.boatFlagColor.toUpperCase(), {
    color: e.boatFlagColor,
    labels: /* @__PURE__ */ new Set([r("Stored boat color")])
  });
  const z = e.spinnakerVisible || e.gennakerVisible, L = E6(e.heading, o.windDirection, e.tack), x = R6(
    e.boatClass,
    e.heading,
    o.windDirection,
    o.laylineAngle,
    z ? g.mainsailSpinMaxAngle : g.mainsailMaxAngle,
    e.tack
  ), k = T6(
    e.boatClass,
    e.heading,
    o.windDirection,
    o.laylineAngle,
    z ? g.jibSpinMaxAngle : g.jibMaxAngle,
    e.tack
  ), R = M6(
    e.heading,
    o.windDirection,
    e.tack
  ), B = A6(
    e.heading,
    o.windDirection,
    e.tack
  ), q = ju(
    e.sailMode === "automatic" ? x + e.mainsailTrim : e.sailAngle,
    e.heading,
    o.windDirection,
    e.tack
  ), X = ju(
    k + e.jibTrim,
    e.heading,
    o.windDirection,
    e.tack
  ), I = ju(
    R + e.spinnakerTrim,
    e.heading,
    o.windDirection,
    e.tack
  ), U = ju(
    B + e.gennakerTrim,
    e.heading,
    o.windDirection,
    e.tack
  );
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ D(si, { label: r("Boat class"), children: /* @__PURE__ */ D(
      "select",
      {
        value: e.boatClass,
        onChange: (F) => t({ boatClass: F.target.value }),
        children: jP.map((F) => /* @__PURE__ */ D("option", { value: F, children: r(F) }, F))
      }
    ) }),
    /* @__PURE__ */ le("div", { className: "field-row", children: [
      /* @__PURE__ */ D(si, { label: r("Name"), children: /* @__PURE__ */ D("input", { value: e.name, onChange: (F) => t({ name: F.target.value }) }) }),
      /* @__PURE__ */ D(si, { label: r("Sail no."), children: /* @__PURE__ */ D(
        "input",
        {
          value: e.sailNumber,
          onChange: (F) => t({ sailNumber: F.target.value })
        }
      ) })
    ] }),
    /* @__PURE__ */ D(si, { label: `${r("Heading")} · ${Math.round(e.heading)}°`, children: /* @__PURE__ */ D(
      "input",
      {
        type: "range",
        min: "0",
        max: "359",
        step: "1",
        value: e.heading,
        "aria-label": r("Heading slider"),
        onChange: (F) => {
          const Z = e6(td(F.target.value));
          t({
            heading: Z,
            rotation: Z,
            tack: jo(Z, o.windDirection, e.tack)
          });
        }
      }
    ) }),
    /* @__PURE__ */ D(
      ZP,
      {
        value: e.overlapIndicator,
        onChange: (F) => t({ overlapIndicator: F })
      }
    ),
    !Zl(e.boatClass) && /* @__PURE__ */ D(
      XP,
      {
        value: e.protestFlagSide,
        onChange: (F) => t({ protestFlagSide: F })
      }
    ),
    e.boatClass === "Coachboat" || e.boatClass === "Umpire boat" ? /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("span", { children: r("Hull color") }),
      /* @__PURE__ */ le("div", { className: "fixed-color-display", "aria-label": r("Fixed support boat hull color"), children: [
        /* @__PURE__ */ D(
          "span",
          {
            className: "color-picker-preview",
            style: {
              backgroundColor: e.boatClass === "Coachboat" ? C0 : E0
            }
          }
        ),
        /* @__PURE__ */ D("span", { className: "color-picker-value", children: e.boatClass === "Coachboat" ? C0 : E0 }),
        /* @__PURE__ */ D("span", { className: "fixed-color-note", children: r("Fixed") })
      ] })
    ] }) : /* @__PURE__ */ D(
      nc,
      {
        label: r("Hull color"),
        value: e.color,
        onChange: (F) => t({ color: F }),
        palette: f,
        paletteLabel: Qu(u) ? "Heisel dark sailing palette" : "Heisel sailing palette"
      }
    ),
    T && /* @__PURE__ */ le("section", { className: "property-section", "aria-labelledby": `umpire-flags-${e.id}`, children: [
      /* @__PURE__ */ D("h3", { id: `umpire-flags-${e.id}`, className: "property-section-title", children: r("Umpire flags") }),
      /* @__PURE__ */ D(si, { label: r("Boat identification flag"), children: /* @__PURE__ */ le(
        "select",
        {
          value: e.boatFlagColor ?? "",
          onChange: (F) => t({ boatFlagColor: F.target.value || null }),
          children: [
            /* @__PURE__ */ D("option", { value: "", children: r("No flag") }),
            [...P.values()].map(({ color: F, labels: Z }) => /* @__PURE__ */ le("option", { value: F, children: [
              [...Z].join(" / "),
              " · ",
              F.toUpperCase()
            ] }, F.toUpperCase()))
          ]
        }
      ) }),
      /* @__PURE__ */ D(si, { label: r("Umpire signal"), children: /* @__PURE__ */ D(
        "select",
        {
          value: e.umpireSignalFlag,
          onChange: (F) => t({ umpireSignalFlag: F.target.value }),
          children: YP.map((F) => /* @__PURE__ */ D("option", { value: F.value, children: r(F.label) }, F.value))
        }
      ) })
    ] }),
    /* @__PURE__ */ le("section", { className: "property-section", "aria-labelledby": `sails-${e.id}`, children: [
      /* @__PURE__ */ D("h3", { id: `sails-${e.id}`, className: "property-section-title", children: r("Sails") }),
      /* @__PURE__ */ le("div", { className: "check-grid sail-toggle-grid", children: [
        h && /* @__PURE__ */ le("label", { children: [
          /* @__PURE__ */ D(
            "input",
            {
              type: "checkbox",
              checked: e.mainsailVisible,
              onChange: (F) => t({ mainsailVisible: F.target.checked })
            }
          ),
          " ",
          r("Mainsail")
        ] }),
        v && /* @__PURE__ */ le("label", { children: [
          /* @__PURE__ */ D(
            "input",
            {
              type: "checkbox",
              checked: e.jibVisible,
              onChange: (F) => t({
                jibVisible: F.target.checked,
                genoaVisible: F.target.checked ? !1 : e.genoaVisible
              })
            }
          ),
          " ",
          r("Jib")
        ] }),
        E && /* @__PURE__ */ le("label", { children: [
          /* @__PURE__ */ D(
            "input",
            {
              type: "checkbox",
              checked: e.genoaVisible,
              onChange: (F) => t({
                genoaVisible: F.target.checked,
                jibVisible: F.target.checked ? !1 : e.jibVisible
              })
            }
          ),
          " ",
          r("Genoa")
        ] }),
        S && /* @__PURE__ */ le("label", { children: [
          /* @__PURE__ */ D(
            "input",
            {
              type: "checkbox",
              checked: e.spinnakerVisible,
              onChange: (F) => t({
                spinnakerVisible: F.target.checked,
                gennakerVisible: F.target.checked ? !1 : e.gennakerVisible
              })
            }
          ),
          " ",
          r("Spinnaker")
        ] }),
        w && /* @__PURE__ */ le("label", { children: [
          /* @__PURE__ */ D(
            "input",
            {
              type: "checkbox",
              checked: e.gennakerVisible,
              onChange: (F) => t({
                gennakerVisible: F.target.checked,
                spinnakerVisible: F.target.checked ? !1 : e.spinnakerVisible
              })
            }
          ),
          " ",
          r("Gennaker")
        ] })
      ] }),
      !h && !v && !E && !S && !w && /* @__PURE__ */ D("p", { className: "inline-empty", children: r("No sails for this boat class.") }),
      h && /* @__PURE__ */ D(si, { label: r("Positioning"), children: /* @__PURE__ */ le(
        "select",
        {
          value: e.sailMode,
          onChange: (F) => {
            const Z = F.target.value;
            t(
              Z === "manual" ? { sailMode: Z, sailAngle: q, mainsailTrim: 0 } : { sailMode: Z, mainsailTrim: 0 }
            );
          },
          children: [
            /* @__PURE__ */ D("option", { value: "automatic", children: r("Automatic with trim") }),
            /* @__PURE__ */ D("option", { value: "manual", children: r("Manual primary sail angle") })
          ]
        }
      ) }),
      e.mainsailVisible && h && (e.sailMode === "manual" ? /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Mainsail")} · ${Kc(q)}°`,
          value: q,
          min: L.min,
          max: L.max,
          luffing: qu(e.heading, o.windDirection, q),
          onChange: (F) => t({ sailAngle: F })
        }
      ) : /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Mainsail")} · ${Kc(q)}°`,
          value: q,
          min: L.min,
          max: L.max,
          luffing: qu(e.heading, o.windDirection, q),
          onChange: (F) => t({ mainsailTrim: F - x })
        }
      )),
      e.jibVisible && v && /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Jib")} · ${Kc(X)}°`,
          value: X,
          min: L.min,
          max: L.max,
          luffing: qu(e.heading, o.windDirection, X),
          onChange: (F) => t({ jibTrim: F - k })
        }
      ),
      e.genoaVisible && E && /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Genoa")} · ${Kc(X)}°`,
          value: X,
          min: L.min,
          max: L.max,
          luffing: qu(e.heading, o.windDirection, X),
          onChange: (F) => t({ jibTrim: F - k })
        }
      ),
      e.spinnakerVisible && S && /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Spinnaker")} · ${Kc(I)}°`,
          value: I,
          min: L.min,
          max: L.max,
          luffing: qu(e.heading, o.windDirection, I),
          onChange: (F) => t({ spinnakerTrim: F - R })
        }
      ),
      e.gennakerVisible && w && /* @__PURE__ */ D(
        xf,
        {
          label: `${r("Gennaker")} · ${Kc(U)}°`,
          value: U,
          min: L.min,
          max: L.max,
          luffing: P6(e.heading, o.windDirection, U),
          onChange: (F) => t({ gennakerTrim: F - B })
        }
      )
    ] })
  ] });
}
function JP({
  object: e,
  update: t
}) {
  const { t: r, language: o } = jn(), l = yt((h) => h.scenario), u = X0(
    l.objects,
    l.environment.measurementBoatClass
  ), d = new Intl.NumberFormat(o === "de" ? "de-CH" : "en", {
    maximumFractionDigits: 2
  }), f = e.laylinesVisible ? e.downwind ? "leeward" : "windward" : "neutral", g = [
    { value: "windward", label: r("Windward") },
    { value: "neutral", label: r("Neutral") },
    { value: "leeward", label: r("Leeward") }
  ];
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("span", { children: r("Mark orientation") }),
      /* @__PURE__ */ D(
        "div",
        {
          className: "property-segmented-control property-segmented-control--three",
          role: "group",
          "aria-label": r("Mark orientation"),
          children: g.map((h) => /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              className: f === h.value ? "is-active" : "",
              "aria-pressed": f === h.value,
              "aria-label": h.value === "neutral" ? r("Neutral without laylines") : h.label,
              onClick: () => t(
                h.value === "neutral" ? { downwind: !1, laylinesVisible: !1 } : {
                  downwind: h.value === "leeward",
                  laylinesVisible: !0
                }
              ),
              children: h.label
            },
            h.value
          ))
        }
      )
    ] }),
    /* @__PURE__ */ D(
      B0,
      {
        label: r("Zone"),
        checked: e.zoneVisible,
        checkedLabel: r("Show zone"),
        uncheckedLabel: r("Hide zone"),
        onChange: (h) => t({ zoneVisible: h })
      }
    ),
    /* @__PURE__ */ D(si, { label: r("Mark number"), children: /* @__PURE__ */ D(
      "input",
      {
        type: "text",
        inputMode: "text",
        autoCapitalize: "none",
        autoCorrect: "off",
        maxLength: 6,
        pattern: "[1-9][0-9]*[A-Za-z]?",
        value: e.markNumber,
        onChange: (h) => {
          const v = h.target.value.trim().toLowerCase();
          /^[1-9]\d*[a-z]?$/.test(v) && t({ markNumber: v });
        }
      }
    ) }),
    /* @__PURE__ */ D(si, { label: r("Shape"), children: /* @__PURE__ */ le(
      "select",
      {
        value: e.shape,
        onChange: (h) => t({ shape: h.target.value }),
        children: [
          /* @__PURE__ */ D("option", { value: "round", children: r("Round buoy") }),
          /* @__PURE__ */ D("option", { value: "cylindrical", children: r("Cylindrical buoy") }),
          /* @__PURE__ */ D("option", { value: "inflatable", children: r("Inflatable buoy") }),
          /* @__PURE__ */ D("option", { value: "flag", children: r("Flag buoy") }),
          /* @__PURE__ */ D("option", { value: "gate", children: r("Gate mark") })
        ]
      }
    ) }),
    /* @__PURE__ */ le("div", { className: "field-row", children: [
      /* @__PURE__ */ D(si, { label: r("Zone radius"), children: /* @__PURE__ */ le("div", { className: "input-with-unit", children: [
        /* @__PURE__ */ D(
          "input",
          {
            "aria-label": r("Zone radius in boat lengths"),
            type: "number",
            min: "0.5",
            max: "20",
            step: "0.5",
            value: e.zoneRadius,
            onChange: (h) => t({
              zoneRadius: td(h.target.value, 3),
              zoneRadiusUnit: "boat-lengths"
            })
          }
        ),
        /* @__PURE__ */ D("span", { "aria-hidden": "true", children: "BL" })
      ] }) }),
      /* @__PURE__ */ D(
        nc,
        {
          label: r("Mark color"),
          value: e.color,
          onChange: (h) => t({ color: h })
        }
      )
    ] }),
    /* @__PURE__ */ le("p", { className: "field-help", children: [
      r(
        l.environment.measurementBoatClass ? "Selected basis" : u.usesDefault ? "Default basis" : "Longest class"
      ),
      ": ",
      r(u.boatClass),
      " (",
      d.format(u.hullLength / 10),
      " m)."
    ] })
  ] });
}
const $P = [
  { value: "committee-boat", label: "Committee boat" },
  { value: "committee-boat-reversed", label: "Committee boat (reversed)" },
  { value: "buoy", label: "Buoy" },
  { value: "flag", label: "Flag" },
  { value: "coach-boat", label: "Coachboat" },
  { value: "coach-boat-reversed", label: "Coachboat (reversed)" }
];
function eD({
  object: e,
  update: t
}) {
  const { t: r } = jn();
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ le("div", { className: "field-row", children: [
      /* @__PURE__ */ D(si, { label: r("Zone radius"), children: /* @__PURE__ */ le("div", { className: "input-with-unit", children: [
        /* @__PURE__ */ D(
          "input",
          {
            "aria-label": r("Zone radius in boat lengths"),
            type: "number",
            min: "0.5",
            max: "20",
            step: "0.5",
            value: e.zoneRadius,
            onChange: (o) => t({
              zoneRadius: td(o.target.value, 3),
              zoneRadiusUnit: "boat-lengths"
            })
          }
        ),
        /* @__PURE__ */ D("span", { "aria-hidden": "true", children: "BL" })
      ] }) }),
      /* @__PURE__ */ D(
        nc,
        {
          label: r("Mark color"),
          value: e.color,
          onChange: (o) => t({ color: o })
        }
      )
    ] }),
    /* @__PURE__ */ D(
      B0,
      {
        label: r("Zone"),
        checked: e.zoneVisible,
        checkedLabel: r("Show zone"),
        uncheckedLabel: r("Hide zone"),
        onChange: (o) => t({ zoneVisible: o })
      }
    )
  ] });
}
function dw({
  object: e,
  update: t
}) {
  const { t: r } = jn(), o = e.type === "finish-line", l = (u, d, f, g, h) => /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ D(si, { label: r(u), children: /* @__PURE__ */ D(
      "select",
      {
        value: d,
        onChange: (v) => t({ [f]: v.target.value }),
        children: $P.map((v) => /* @__PURE__ */ D("option", { value: v.value, children: r(v.label) }, v.value))
      }
    ) }),
    d === "flag" && /* @__PURE__ */ D(
      nc,
      {
        label: r("{label} flag color", { label: r(u) }),
        value: g,
        onChange: (v) => t({ [h]: v }),
        palette: BP,
        paletteLabel: "Sailing signal flag palette"
      }
    )
  ] });
  return /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ D(
      B0,
      {
        label: r("Laylines"),
        checked: e.laylinesVisible,
        checkedLabel: r("On"),
        uncheckedLabel: r("Off"),
        onChange: (u) => t({ laylinesVisible: u })
      }
    ),
    /* @__PURE__ */ D(
      B0,
      {
        label: r("Layline area"),
        checked: e.laylineAreaVisible,
        checkedLabel: r("On"),
        uncheckedLabel: r("Off"),
        onChange: (u) => t({ laylineAreaVisible: u })
      }
    ),
    e.laylineAreaVisible && /* @__PURE__ */ D(
      nc,
      {
        label: r("Layline area color"),
        value: e.laylineAreaColor,
        onChange: (u) => t({ laylineAreaColor: u })
      }
    ),
    l(
      o ? "Finish-boat end" : "Start-boat end",
      e.startEndType,
      "startEndType",
      e.startEndFlagColor,
      "startEndFlagColor"
    ),
    l(
      o ? "Outer end" : "Pin end",
      e.pinEndType,
      "pinEndType",
      e.pinEndFlagColor,
      "pinEndFlagColor"
    )
  ] });
}
function n8({ emptyContent: e } = {}) {
  const { language: t, t: r } = jn(), o = yt((x) => x.scenario), l = yt((x) => x.dragPreview), u = yt((x) => x.selectedIds), d = yt((x) => x.updateObject), f = yt((x) => x.updateObjects), g = yt((x) => x.duplicateSelected), h = yt((x) => x.deleteSelected), v = yt((x) => x.setLayer), E = yt((x) => x.brandAccentColor), S = o.objects.filter((x) => u.includes(x.id)).map(
    (x) => (l == null ? void 0 : l.id) === x.id ? { ...x, ...l.patch } : x
  );
  if (!S.length)
    return /* @__PURE__ */ le("div", { className: `empty-state${e ? " empty-state--with-content" : ""}`, children: [
      /* @__PURE__ */ le("div", { className: "empty-state-message", children: [
        /* @__PURE__ */ D(tD, {}),
        /* @__PURE__ */ D("h2", { children: r("No selection") }),
        /* @__PURE__ */ D("p", { children: r("Select an object on the canvas to edit its properties.") })
      ] }),
      e && /* @__PURE__ */ D("div", { className: "empty-state-extension", children: e })
    ] });
  if (S.length > 1) {
    const x = S.every((k) => k.locked);
    return /* @__PURE__ */ le("div", { className: "properties-content", children: [
      /* @__PURE__ */ D("div", { className: "panel-heading", children: /* @__PURE__ */ le("div", { children: [
        /* @__PURE__ */ D("span", { className: "eyebrow", children: r("Selection") }),
        /* @__PURE__ */ D("h2", { children: r("{count} objects", { count: S.length }) })
      ] }) }),
      /* @__PURE__ */ D("p", { className: "muted", children: r("Move, duplicate, layer, lock or remove the selection together.") }),
      /* @__PURE__ */ le("div", { className: "action-grid", children: [
        /* @__PURE__ */ D(pr, { icon: /* @__PURE__ */ D(hS, {}), label: r("Duplicate"), onClick: g }),
        /* @__PURE__ */ D(
          pr,
          {
            icon: x ? /* @__PURE__ */ D(gS, {}) : /* @__PURE__ */ D(vS, {}),
            label: r(x ? "Unlock" : "Lock"),
            onClick: () => f(
              S.map(({ id: k }) => ({ id: k, patch: { locked: !x } })),
              x ? "Unlocked selection" : "Locked selection"
            )
          }
        ),
        /* @__PURE__ */ D(
          pr,
          {
            icon: /* @__PURE__ */ D(S0, {}),
            label: r("Delete"),
            className: "danger action-grid__wide",
            onClick: h
          }
        ),
        /* @__PURE__ */ D(
          uw,
          {
            onForward: () => v("forward"),
            onBackward: () => v("backward")
          }
        )
      ] })
    ] });
  }
  const w = S[0], T = {
    boat: "Boat",
    mark: "Mark",
    gate: "Gate",
    "start-line": "Start line",
    "finish-line": "Finish line",
    line: "Line",
    arrow: "Arrow",
    freehand: "Freehand",
    text: "Text",
    rectangle: "Rectangle",
    circle: "Circle"
  }[w.type], P = (x) => d(w.id, x, `Updated ${w.type}`), z = KP(
    w,
    o.environment.windDirection,
    X0(o.objects, o.environment.measurementBoatClass).length
  ), L = new Intl.NumberFormat(t === "de" ? "de-CH" : "en", {
    maximumFractionDigits: 1
  });
  return /* @__PURE__ */ le("div", { className: "properties-content", children: [
    /* @__PURE__ */ le("div", { className: "panel-heading", children: [
      /* @__PURE__ */ le("div", { children: [
        /* @__PURE__ */ D("span", { className: "eyebrow", children: r("Properties") }),
        /* @__PURE__ */ D("h2", { children: w.type === "boat" ? r("Boat") : w.type === "mark" ? r("Mark {number}", { number: w.markNumber }) : r(T) })
      ] }),
      /* @__PURE__ */ D("span", { className: "badge", children: t === "en" ? w.type : r(T) })
    ] }),
    /* @__PURE__ */ le("div", { className: "object-meta", "aria-label": r("Object information"), children: [
      /* @__PURE__ */ le("div", { children: [
        /* @__PURE__ */ D("span", { children: "X" }),
        /* @__PURE__ */ D("strong", { children: Math.round(w.x) })
      ] }),
      /* @__PURE__ */ le("div", { children: [
        /* @__PURE__ */ D("span", { children: "Y" }),
        /* @__PURE__ */ D("strong", { children: Math.round(w.y) })
      ] }),
      w.type === "boat" && /* @__PURE__ */ le(Fr, { children: [
        /* @__PURE__ */ le("div", { children: [
          /* @__PURE__ */ D("span", { children: r("Position") }),
          /* @__PURE__ */ D("strong", { children: w.positionNumber })
        ] }),
        /* @__PURE__ */ le("div", { children: [
          /* @__PURE__ */ D("span", { children: r("Tack") }),
          /* @__PURE__ */ D("strong", { children: jo(w.heading, o.environment.windDirection, w.tack) === "port" ? r("Port") : r("Starboard") })
        ] })
      ] }),
      z && /* @__PURE__ */ le(Fr, { children: [
        /* @__PURE__ */ le("div", { children: [
          /* @__PURE__ */ D("span", { children: r("Length") }),
          /* @__PURE__ */ le("strong", { children: [
            L.format(z.lengthBoatLengths),
            " BL"
          ] })
        ] }),
        /* @__PURE__ */ le("div", { children: [
          /* @__PURE__ */ D("span", { children: r("Angle to wind") }),
          /* @__PURE__ */ le("strong", { children: [
            Math.round(z.angleToWind),
            "°"
          ] })
        ] })
      ] })
    ] }),
    w.type === "boat" && /* @__PURE__ */ D(QP, { object: w, update: (x) => P(x) }),
    w.type === "mark" && /* @__PURE__ */ D(JP, { object: w, update: (x) => P(x) }),
    w.type === "gate" && /* @__PURE__ */ D(eD, { object: w, update: (x) => P(x) }),
    w.type === "start-line" && /* @__PURE__ */ D(
      dw,
      {
        object: w,
        update: (x) => P(x)
      }
    ),
    w.type === "finish-line" && /* @__PURE__ */ D(
      dw,
      {
        object: w,
        update: (x) => P(x)
      }
    ),
    w.type === "text" && /* @__PURE__ */ le(Fr, { children: [
      /* @__PURE__ */ D(si, { label: r("Text"), children: /* @__PURE__ */ D(
        "textarea",
        {
          value: w.text,
          onChange: (x) => P({ text: x.target.value })
        }
      ) }),
      /* @__PURE__ */ le("div", { className: "field-row", children: [
        /* @__PURE__ */ D(si, { label: r("Font size"), children: /* @__PURE__ */ D(
          "input",
          {
            type: "number",
            min: "8",
            value: w.fontSize,
            onChange: (x) => P({ fontSize: td(x.target.value, 14) })
          }
        ) }),
        /* @__PURE__ */ D(
          nc,
          {
            label: r("Text color"),
            value: w.color,
            onChange: (x) => P({ color: x })
          }
        )
      ] })
    ] }),
    (w.type === "line" || w.type === "arrow" || w.type === "freehand" || w.type === "rectangle" || w.type === "circle") && /* @__PURE__ */ le("div", { className: "field-row", children: [
      /* @__PURE__ */ D(si, { label: r("Stroke width"), children: /* @__PURE__ */ D(
        "input",
        {
          type: "number",
          min: "1",
          max: "20",
          value: w.strokeWidth,
          onChange: (x) => P({ strokeWidth: td(x.target.value, 1) })
        }
      ) }),
      /* @__PURE__ */ D(
        nc,
        {
          label: r("Stroke color"),
          value: w.stroke,
          onChange: (x) => P({ stroke: x })
        }
      )
    ] }),
    (w.type === "rectangle" || w.type === "circle") && /* @__PURE__ */ D(
      nc,
      {
        label: r("Fill color"),
        value: w.fill,
        onChange: (x) => P({ fill: x }),
        palette: Df(o.canvas.background, E),
        paletteLabel: Qu(o.canvas.background) ? "Heisel dark sailing palette" : "Heisel sailing palette",
        allowTransparent: !0
      }
    ),
    /* @__PURE__ */ D(si, { label: r("Opacity"), children: /* @__PURE__ */ D(
      "input",
      {
        type: "range",
        min: "0.1",
        max: "1",
        step: "0.05",
        value: w.opacity,
        onChange: (x) => P({ opacity: td(x.target.value, 1) })
      }
    ) }),
    /* @__PURE__ */ le("div", { className: "action-grid", children: [
      /* @__PURE__ */ D(pr, { icon: /* @__PURE__ */ D(hS, {}), label: r("Duplicate"), onClick: g }),
      /* @__PURE__ */ D(
        pr,
        {
          icon: w.locked ? /* @__PURE__ */ D(gS, {}) : /* @__PURE__ */ D(vS, {}),
          label: r(w.locked ? "Unlock" : "Lock"),
          onClick: () => P({ locked: !w.locked })
        }
      ),
      /* @__PURE__ */ D(
        pr,
        {
          icon: /* @__PURE__ */ D(S0, {}),
          label: r("Delete"),
          className: "danger action-grid__wide",
          onClick: h
        }
      ),
      /* @__PURE__ */ D(
        uw,
        {
          onForward: () => v("forward"),
          onBackward: () => v("backward")
        }
      )
    ] })
  ] });
}
function tD() {
  return /* @__PURE__ */ D("div", { className: "empty-illustration", "aria-hidden": "true", children: /* @__PURE__ */ D("span", {}) });
}
function nD() {
  const e = Ql("Windward mark rounding");
  e.metadata.description = "A static visual example for discussing a mark-rounding situation.", e.metadata.ruleReferences = ["RRS 18"];
  const t = fb(960, 380, 1);
  t.markNumber = "1", t.laylinesVisible = !0;
  const r = Ko(790, 650, 2);
  r.label = "Alpine blue", r.color = "#2F5D78", r.heading = 330, r.rotation = 330, r.sequenceId = "blue-sequence", r.positionNumber = 1;
  const o = Ko(910, 560, 3);
  o.label = "Alpine blue", o.color = "#2F5D78", o.heading = 350, o.rotation = 350, o.sequenceId = "blue-sequence", o.positionNumber = 2, r.opacity = 0.42;
  const l = Ko(1050, 650, 4);
  return l.label = "Burgundy", l.color = "#884454", l.heading = 15, l.rotation = 15, e.objects = [t, r, o, l], e;
}
function rD() {
  const e = Ql("Start-line situation");
  e.metadata.description = "Static positions approaching a start line. No rule decision is implied.";
  const t = hb(540, 420, 1380, 420, 1), r = Ko(860, 700, 2);
  return r.heading = 0, e.objects = [t, r], e;
}
function aD() {
  const e = Ql("Port–starboard crossing");
  e.metadata.description = "Two boats on opposite tacks approaching a crossing situation.", e.metadata.ruleReferences = ["RRS 10"];
  const t = Ko(760, 700, 1);
  t.heading = 45, t.rotation = 45, t.color = "#2F5D78", t.label = "Alpine blue";
  const r = Ko(1160, 700, 2);
  return r.heading = 315, r.rotation = 315, r.tack = "port", r.color = "#884454", r.label = "Burgundy", e.objects = [t, r], e;
}
function iD() {
  const e = Ql("Windward–leeward overlap");
  e.metadata.description = "Two overlapped boats on the same tack.", e.metadata.ruleReferences = ["RRS 11"];
  const t = Ko(850, 620, 1);
  t.heading = 35, t.rotation = 35, t.color = "#2F5D78", t.label = "Alpine blue";
  const r = Ko(1040, 570, 2);
  return r.heading = 35, r.rotation = 35, r.color = "#884454", r.label = "Burgundy", e.objects = [t, r], e;
}
function oD() {
  const e = Ql("Clear ahead and clear astern");
  e.metadata.description = "Two boats on the same tack, one clear ahead of the other.", e.metadata.ruleReferences = ["RRS 12"];
  const t = Ko(960, 450, 1);
  t.color = "#2F5D78", t.label = "Alpine blue";
  const r = Ko(960, 750, 2);
  return r.color = "#884454", r.label = "Burgundy", e.objects = [t, r], e;
}
var y0 = { exports: {} }, sD = y0.exports, fw;
function lD() {
  return fw || (fw = 1, (function(e, t) {
    ((r, o) => {
      e.exports = o();
    })(sD, function() {
      var r = function(m, _) {
        return (r = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? function(M, O) {
          M.__proto__ = O;
        } : function(M, O) {
          for (var V in O) Object.prototype.hasOwnProperty.call(O, V) && (M[V] = O[V]);
        }))(m, _);
      }, o = function() {
        return (o = Object.assign || function(m) {
          for (var _, M = 1, O = arguments.length; M < O; M++) for (var V in _ = arguments[M]) Object.prototype.hasOwnProperty.call(_, V) && (m[V] = _[V]);
          return m;
        }).apply(this, arguments);
      };
      function l(m, _, M) {
        for (var O, V = 0, K = _.length; V < K; V++) !O && V in _ || ((O = O || Array.prototype.slice.call(_, 0, V))[V] = _[V]);
        return m.concat(O || Array.prototype.slice.call(_));
      }
      var u = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : q2, d = Object.keys, f = Array.isArray;
      function g(m, _) {
        return typeof _ == "object" && d(_).forEach(function(M) {
          m[M] = _[M];
        }), m;
      }
      typeof Promise > "u" || u.Promise || (u.Promise = Promise);
      var h = Object.getPrototypeOf, v = {}.hasOwnProperty;
      function E(m, _) {
        return v.call(m, _);
      }
      function S(m, _) {
        typeof _ == "function" && (_ = _(h(m))), (typeof Reflect > "u" ? d : Reflect.ownKeys)(_).forEach(function(M) {
          T(m, M, _[M]);
        });
      }
      var w = Object.defineProperty;
      function T(m, _, M, O) {
        w(m, _, g(M && E(M, "get") && typeof M.get == "function" ? { get: M.get, set: M.set, configurable: !0 } : { value: M, configurable: !0, writable: !0 }, O));
      }
      function P(m) {
        return { from: function(_) {
          return m.prototype = Object.create(_.prototype), T(m.prototype, "constructor", m), { extend: S.bind(null, m.prototype) };
        } };
      }
      var z = Object.getOwnPropertyDescriptor, L = [].slice;
      function x(m, _, M) {
        return L.call(m, _, M);
      }
      function k(m, _) {
        return _(m);
      }
      function R(m) {
        if (!m) throw new Error("Assertion Failed");
      }
      function B(m) {
        u.setImmediate ? setImmediate(m) : setTimeout(m, 0);
      }
      function q(m, _) {
        if (typeof _ == "string" && E(m, _)) return m[_];
        if (!_) return m;
        if (typeof _ != "string") {
          for (var M = [], O = 0, V = _.length; O < V; ++O) {
            var K = q(m, _[O]);
            M.push(K);
          }
          return M;
        }
        var J, re = _.indexOf(".");
        return re === -1 || (J = m[_.substr(0, re)]) == null ? void 0 : q(J, _.substr(re + 1));
      }
      function X(m, _, M) {
        if (m && _ !== void 0 && !("isFrozen" in Object && Object.isFrozen(m))) if (typeof _ != "string" && "length" in _) {
          R(typeof M != "string" && "length" in M);
          for (var O = 0, V = _.length; O < V; ++O) X(m, _[O], M[O]);
        } else {
          var K = _.indexOf(".");
          if (K !== -1) {
            var J = _.substr(0, K), K = _.substr(K + 1);
            if (K === "") M === void 0 ? f(m) && !isNaN(parseInt(J)) ? m.splice(J, 1) : delete m[J] : m[J] = M;
            else {
              var re = m[J];
              if (!re || !E(m, J)) {
                if (M === void 0) return;
                re = m[J] = {};
              }
              X(re, K, M);
            }
          } else M === void 0 ? f(m) && !isNaN(parseInt(_)) ? m.splice(_, 1) : delete m[_] : m[_] = M;
        }
      }
      function I(m) {
        var _, M = {};
        for (_ in m) E(m, _) && (M[_] = m[_]);
        return M;
      }
      var U = [].concat;
      function F(m) {
        return U.apply([], m);
      }
      var ye = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(F([8, 16, 32, 64].map(function(m) {
        return ["Int", "Uint", "Float"].map(function(_) {
          return _ + m + "Array";
        });
      }))).filter(function(m) {
        return u[m];
      }), Z = new Set(ye.map(function(m) {
        return u[m];
      })), te = null;
      function ie(m) {
        return te = /* @__PURE__ */ new WeakMap(), m = (function _(M) {
          if (!M || typeof M != "object") return M;
          var O = te.get(M);
          if (O) return O;
          if (f(M)) {
            O = [], te.set(M, O);
            for (var V = 0, K = M.length; V < K; ++V) O.push(_(M[V]));
          } else if (Z.has(M.constructor)) O = M;
          else {
            var J, re = h(M);
            for (J in O = re === Object.prototype ? {} : Object.create(re), te.set(M, O), M) E(M, J) && (O[J] = _(M[J]));
          }
          return O;
        })(m), te = null, m;
      }
      var ue = {}.toString;
      function ce(m) {
        return ue.call(m).slice(8, -1);
      }
      var ze = typeof Symbol < "u" ? Symbol.iterator : "@@iterator", W = typeof ze == "symbol" ? function(m) {
        var _;
        return m != null && (_ = m[ze]) && _.apply(m);
      } : function() {
        return null;
      };
      function j(m, _) {
        _ = m.indexOf(_), 0 <= _ && m.splice(_, 1);
      }
      var ee = {};
      function Q(m) {
        var _, M, O, V;
        if (arguments.length === 1) {
          if (f(m)) return m.slice();
          if (this === ee && typeof m == "string") return [m];
          if (V = W(m)) for (M = []; !(O = V.next()).done; ) M.push(O.value);
          else {
            if (m == null) return [m];
            if (typeof (_ = m.length) != "number") return [m];
            for (M = new Array(_); _--; ) M[_] = m[_];
          }
        } else for (_ = arguments.length, M = new Array(_); _--; ) M[_] = arguments[_];
        return M;
      }
      var oe = typeof Symbol < "u" ? function(m) {
        return m[Symbol.toStringTag] === "AsyncFunction";
      } : function() {
        return !1;
      }, ye = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"], ln = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"].concat(ye), pe = { VersionChanged: "Database version changed by other database connection", DatabaseClosed: "Database has been closed", Abort: "Transaction aborted", TransactionInactive: "Transaction has already completed or failed", MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb" };
      function Me(m, _) {
        this.name = m, this.message = _;
      }
      function We(m, _) {
        return m + ". Errors: " + Object.keys(_).map(function(M) {
          return _[M].toString();
        }).filter(function(M, O, V) {
          return V.indexOf(M) === O;
        }).join(`
`);
      }
      function Ee(m, _, M, O) {
        this.failures = _, this.failedKeys = O, this.successCount = M, this.message = We(m, _);
      }
      function ae(m, _) {
        this.name = "BulkError", this.failures = Object.keys(_).map(function(M) {
          return _[M];
        }), this.failuresByPos = _, this.message = We(m, this.failures);
      }
      P(Me).from(Error).extend({ toString: function() {
        return this.name + ": " + this.message;
      } }), P(Ee).from(Me), P(ae).from(Me);
      var Re = ln.reduce(function(m, _) {
        return m[_] = _ + "Error", m;
      }, {}), Qe = Me, Pe = ln.reduce(function(m, _) {
        var M = _ + "Error";
        function O(V, K) {
          this.name = M, V ? typeof V == "string" ? (this.message = "".concat(V).concat(K ? `
 ` + K : ""), this.inner = K || null) : typeof V == "object" && (this.message = "".concat(V.name, " ").concat(V.message), this.inner = V) : (this.message = pe[_] || M, this.inner = null);
        }
        return P(O).from(Qe), m[_] = O, m;
      }, {}), rt = (Pe.Syntax = SyntaxError, Pe.Type = TypeError, Pe.Range = RangeError, ye.reduce(function(m, _) {
        return m[_ + "Error"] = Pe[_], m;
      }, {}));
      ye = ln.reduce(function(m, _) {
        return ["Syntax", "Type", "Range"].indexOf(_) === -1 && (m[_ + "Error"] = Pe[_]), m;
      }, {});
      function st() {
      }
      function bt(m) {
        return m;
      }
      function Xt(m, _) {
        return m == null || m === bt ? _ : function(M) {
          return _(m(M));
        };
      }
      function Lt(m, _) {
        return function() {
          m.apply(this, arguments), _.apply(this, arguments);
        };
      }
      function qn(m, _) {
        return m === st ? _ : function() {
          var M = m.apply(this, arguments), O = (M !== void 0 && (arguments[0] = M), this.onsuccess), V = this.onerror, K = (this.onsuccess = null, this.onerror = null, _.apply(this, arguments));
          return O && (this.onsuccess = this.onsuccess ? Lt(O, this.onsuccess) : O), V && (this.onerror = this.onerror ? Lt(V, this.onerror) : V), K !== void 0 ? K : M;
        };
      }
      function Wt(m, _) {
        return m === st ? _ : function() {
          m.apply(this, arguments);
          var M = this.onsuccess, O = this.onerror;
          this.onsuccess = this.onerror = null, _.apply(this, arguments), M && (this.onsuccess = this.onsuccess ? Lt(M, this.onsuccess) : M), O && (this.onerror = this.onerror ? Lt(O, this.onerror) : O);
        };
      }
      function bn(m, _) {
        return m === st ? _ : function(V) {
          var O = m.apply(this, arguments), V = (g(V, O), this.onsuccess), K = this.onerror, J = (this.onsuccess = null, this.onerror = null, _.apply(this, arguments));
          return V && (this.onsuccess = this.onsuccess ? Lt(V, this.onsuccess) : V), K && (this.onerror = this.onerror ? Lt(K, this.onerror) : K), O === void 0 ? J === void 0 ? void 0 : J : g(O, J);
        };
      }
      function Yr(m, _) {
        return m === st ? _ : function() {
          return _.apply(this, arguments) !== !1 && m.apply(this, arguments);
        };
      }
      function Pn(m, _) {
        return m === st ? _ : function() {
          var M = m.apply(this, arguments);
          if (M && typeof M.then == "function") {
            for (var O = this, V = arguments.length, K = new Array(V); V--; ) K[V] = arguments[V];
            return M.then(function() {
              return _.apply(O, K);
            });
          }
          return _.apply(this, arguments);
        };
      }
      ye.ModifyError = Ee, ye.DexieError = Me, ye.BulkError = ae;
      var gn = typeof location < "u" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
      function vn(m) {
        gn = m;
      }
      var ir = {}, cr = 100, er = typeof Promise > "u" ? [] : (ln = Promise.resolve(), typeof crypto < "u" && crypto.subtle ? [er = crypto.subtle.digest("SHA-512", new Uint8Array([0])), h(er), ln] : [ln, h(ln), ln]), ln = er[0], Qa = er[1], Qa = Qa && Qa.then, dr = ln && ln.constructor, kn = !!er[2], tr = function(m, _) {
        gt.push([m, _]), Tt && (queueMicrotask(Zr), Tt = !1);
      }, ot = !0, Tt = !0, Ut = [], Ft = [], Fn = bt, _n = { id: "global", global: !0, ref: 0, unhandleds: [], onunhandled: st, pgp: !1, env: {}, finalize: st }, qe = _n, gt = [], Dn = 0, Tn = [];
      function Xe(m) {
        if (typeof this != "object") throw new TypeError("Promises must be constructed via new");
        this._listeners = [], this._lib = !1;
        var _ = this._PSD = qe;
        if (typeof m != "function") {
          if (m !== ir) throw new TypeError("Not a function");
          this._state = arguments[1], this._value = arguments[2], this._state === !1 && or(this, this._value);
        } else this._state = null, this._value = null, ++_.ref, (function M(O, V) {
          try {
            V(function(K) {
              if (O._state === null) {
                if (K === O) throw new TypeError("A promise cannot be resolved with itself.");
                var J = O._lib && mr();
                K && typeof K.then == "function" ? M(O, function(re, be) {
                  K instanceof Xe ? K._then(re, be) : K.then(re, be);
                }) : (O._state = !0, O._value = K, xt(O)), J && Xr();
              }
            }, or.bind(null, O));
          } catch (K) {
            or(O, K);
          }
        })(this, m);
      }
      var Ue = { get: function() {
        var m = qe, _ = Vt;
        function M(O, V) {
          var K = this, J = !m.global && (m !== qe || _ !== Vt), re = J && !vr(), be = new Xe(function(ke, _e) {
            zn(K, new _t(Jo(O, m, J, re), Jo(V, m, J, re), ke, _e, m));
          });
          return this._consoleTask && (be._consoleTask = this._consoleTask), be;
        }
        return M.prototype = ir, M;
      }, set: function(m) {
        T(this, "then", m && m.prototype === ir ? Ue : { get: function() {
          return m;
        }, set: Ue.set });
      } };
      function _t(m, _, M, O, V) {
        this.onFulfilled = typeof m == "function" ? m : null, this.onRejected = typeof _ == "function" ? _ : null, this.resolve = M, this.reject = O, this.psd = V;
      }
      function or(m, _) {
        var M, O;
        Ft.push(_), m._state === null && (M = m._lib && mr(), _ = Fn(_), m._state = !1, m._value = _, O = m, Ut.some(function(V) {
          return V._value === O._value;
        }) || Ut.push(O), xt(m), M) && Xr();
      }
      function xt(m) {
        var _ = m._listeners;
        m._listeners = [];
        for (var M = 0, O = _.length; M < O; ++M) zn(m, _[M]);
        var V = m._PSD;
        --V.ref || V.finalize(), Dn === 0 && (++Dn, tr(function() {
          --Dn == 0 && de();
        }, []));
      }
      function zn(m, _) {
        if (m._state === null) m._listeners.push(_);
        else {
          var M = m._state ? _.onFulfilled : _.onRejected;
          if (M === null) return (m._state ? _.resolve : _.reject)(m._value);
          ++_.psd.ref, ++Dn, tr(aa, [M, m, _]);
        }
      }
      function aa(m, _, M) {
        try {
          var O, V = _._value;
          !_._state && Ft.length && (Ft = []), O = gn && _._consoleTask ? _._consoleTask.run(function() {
            return m(V);
          }) : m(V), _._state || Ft.indexOf(V) !== -1 || ((K) => {
            for (var J = Ut.length; J; ) if (Ut[--J]._value === K._value) return Ut.splice(J, 1);
          })(_), M.resolve(O);
        } catch (K) {
          M.reject(K);
        } finally {
          --Dn == 0 && de(), --M.psd.ref || M.psd.finalize();
        }
      }
      function Zr() {
        Qr(_n, function() {
          mr() && Xr();
        });
      }
      function mr() {
        var m = ot;
        return Tt = ot = !1, m;
      }
      function Xr() {
        var m, _, M;
        do
          for (; 0 < gt.length; ) for (m = gt, gt = [], M = m.length, _ = 0; _ < M; ++_) {
            var O = m[_];
            O[0].apply(null, O[1]);
          }
        while (0 < gt.length);
        Tt = ot = !0;
      }
      function de() {
        for (var m = Ut, _ = (Ut = [], m.forEach(function(O) {
          O._PSD.onunhandled.call(null, O._value, O);
        }), Tn.slice(0)), M = _.length; M; ) _[--M]();
      }
      function et(m) {
        return new Xe(ir, !1, m);
      }
      function Ge(m, _) {
        var M = qe;
        return function() {
          var O = mr(), V = qe;
          try {
            return ma(M, !0), m.apply(this, arguments);
          } catch (K) {
            _ && _(K);
          } finally {
            ma(V, !1), O && Xr();
          }
        };
      }
      S(Xe.prototype, { then: Ue, _then: function(m, _) {
        zn(this, new _t(null, null, m, _, qe));
      }, catch: function(m) {
        var _, M;
        return arguments.length === 1 ? this.then(null, m) : (_ = m, M = arguments[1], typeof _ == "function" ? this.then(null, function(O) {
          return (O instanceof _ ? M : et)(O);
        }) : this.then(null, function(O) {
          return (O && O.name === _ ? M : et)(O);
        }));
      }, finally: function(m) {
        return this.then(function(_) {
          return Xe.resolve(m()).then(function() {
            return _;
          });
        }, function(_) {
          return Xe.resolve(m()).then(function() {
            return et(_);
          });
        });
      }, timeout: function(m, _) {
        var M = this;
        return m < 1 / 0 ? new Xe(function(O, V) {
          var K = setTimeout(function() {
            return V(new Pe.Timeout(_));
          }, m);
          M.then(O, V).finally(clearTimeout.bind(null, K));
        }) : this;
      } }), typeof Symbol < "u" && Symbol.toStringTag && T(Xe.prototype, Symbol.toStringTag, "Dexie.Promise"), _n.env = ga(), S(Xe, { all: function() {
        var m = Q.apply(null, arguments).map(Ti);
        return new Xe(function(_, M) {
          m.length === 0 && _([]);
          var O = m.length;
          m.forEach(function(V, K) {
            return Xe.resolve(V).then(function(J) {
              m[K] = J, --O || _(m);
            }, M);
          });
        });
      }, resolve: function(m) {
        return m instanceof Xe ? m : m && typeof m.then == "function" ? new Xe(function(_, M) {
          m.then(_, M);
        }) : new Xe(ir, !0, m);
      }, reject: et, race: function() {
        var m = Q.apply(null, arguments).map(Ti);
        return new Xe(function(_, M) {
          m.map(function(O) {
            return Xe.resolve(O).then(_, M);
          });
        });
      }, PSD: { get: function() {
        return qe;
      }, set: function(m) {
        return qe = m;
      } }, totalEchoes: { get: function() {
        return Vt;
      } }, newPSD: Tr, usePSD: Qr, scheduler: { get: function() {
        return tr;
      }, set: function(m) {
        tr = m;
      } }, rejectionMapper: { get: function() {
        return Fn;
      }, set: function(m) {
        Fn = m;
      } }, follow: function(m, _) {
        return new Xe(function(M, O) {
          return Tr(function(V, K) {
            var J = qe;
            J.unhandleds = [], J.onunhandled = K, J.finalize = Lt(function() {
              var re, be = this;
              re = function() {
                be.unhandleds.length === 0 ? V() : K(be.unhandleds[0]);
              }, Tn.push(function ke() {
                re(), Tn.splice(Tn.indexOf(ke), 1);
              }), ++Dn, tr(function() {
                --Dn == 0 && de();
              }, []);
            }, J.finalize), m();
          }, _, M, O);
        });
      } }), dr && (dr.allSettled && T(Xe, "allSettled", function() {
        var m = Q.apply(null, arguments).map(Ti);
        return new Xe(function(_) {
          m.length === 0 && _([]);
          var M = m.length, O = new Array(M);
          m.forEach(function(V, K) {
            return Xe.resolve(V).then(function(J) {
              return O[K] = { status: "fulfilled", value: J };
            }, function(J) {
              return O[K] = { status: "rejected", reason: J };
            }).then(function() {
              return --M || _(O);
            });
          });
        });
      }), dr.any && typeof AggregateError < "u" && T(Xe, "any", function() {
        var m = Q.apply(null, arguments).map(Ti);
        return new Xe(function(_, M) {
          m.length === 0 && M(new AggregateError([]));
          var O = m.length, V = new Array(O);
          m.forEach(function(K, J) {
            return Xe.resolve(K).then(function(re) {
              return _(re);
            }, function(re) {
              V[J] = re, --O || M(new AggregateError(V));
            });
          });
        });
      }), dr.withResolvers) && (Xe.withResolvers = dr.withResolvers);
      var kt = { awaits: 0, echoes: 0, id: 0 }, Et = 0, Xn = [], en = 0, Vt = 0, yn = 0;
      function Tr(m, J, M, O) {
        var V = qe, K = Object.create(V), J = (K.parent = V, K.ref = 0, K.global = !1, K.id = ++yn, _n.env, K.env = kn ? { Promise: Xe, PromiseProp: { value: Xe, configurable: !0, writable: !0 }, all: Xe.all, race: Xe.race, allSettled: Xe.allSettled, any: Xe.any, resolve: Xe.resolve, reject: Xe.reject } : {}, J && g(K, J), ++V.ref, K.finalize = function() {
          --this.parent.ref || this.parent.finalize();
        }, Qr(K, m, M, O));
        return K.ref === 0 && K.finalize(), J;
      }
      function Nr() {
        return kt.id || (kt.id = ++Et), ++kt.awaits, kt.echoes += cr, kt.id;
      }
      function vr() {
        return !!kt.awaits && (--kt.awaits == 0 && (kt.id = 0), kt.echoes = kt.awaits * cr, !0);
      }
      function Ti(m) {
        return kt.echoes && m && m.constructor === dr ? (Nr(), m.then(function(_) {
          return vr(), _;
        }, function(_) {
          return vr(), yr(_);
        })) : m;
      }
      function Qo() {
        var m = Xn[Xn.length - 1];
        Xn.pop(), ma(m, !1);
      }
      function ma(m, _) {
        var M, O, V = qe;
        (_ ? !kt.echoes || en++ && m === qe : !en || --en && m === qe) || queueMicrotask(_ ? (function(K) {
          ++Vt, kt.echoes && --kt.echoes != 0 || (kt.echoes = kt.awaits = kt.id = 0), Xn.push(qe), ma(K, !0);
        }).bind(null, m) : Qo), m !== qe && (qe = m, V === _n && (_n.env = ga()), kn) && (M = _n.env.Promise, O = m.env, V.global || m.global) && (Object.defineProperty(u, "Promise", O.PromiseProp), M.all = O.all, M.race = O.race, M.resolve = O.resolve, M.reject = O.reject, O.allSettled && (M.allSettled = O.allSettled), O.any) && (M.any = O.any);
      }
      function ga() {
        var m = u.Promise;
        return kn ? { Promise: m, PromiseProp: Object.getOwnPropertyDescriptor(u, "Promise"), all: m.all, race: m.race, allSettled: m.allSettled, any: m.any, resolve: m.resolve, reject: m.reject } : {};
      }
      function Qr(m, _, M, O, V) {
        var K = qe;
        try {
          return ma(m, !0), _(M, O, V);
        } finally {
          ma(K, !1);
        }
      }
      function Jo(m, _, M, O) {
        return typeof m != "function" ? m : function() {
          var V = qe;
          M && Nr(), ma(_, !0);
          try {
            return m.apply(this, arguments);
          } finally {
            ma(V, !1), O && queueMicrotask(vr);
          }
        };
      }
      function Co(m) {
        Promise === dr && kt.echoes === 0 ? en === 0 ? m() : enqueueNativeMicroTask(m) : setTimeout(m, 0);
      }
      ("" + Qa).indexOf("[native code]") === -1 && (Nr = vr = st);
      var yr = Xe.reject, oo = "￿", li = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.", $o = "String expected.", qi = "__dbnames", Rs = "readonly", vl = "readwrite";
      function Eo(m, _) {
        return m ? _ ? function() {
          return m.apply(this, arguments) && _.apply(this, arguments);
        } : m : _;
      }
      var Jl = { type: 3, lower: -1 / 0, lowerOpen: !1, upper: [[]], upperOpen: !1 };
      function wr(m) {
        return typeof m != "string" || /\./.test(m) ? function(_) {
          return _;
        } : function(_) {
          return _[m] === void 0 && m in _ && delete (_ = ie(_))[m], _;
        };
      }
      function Ni() {
        throw Pe.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
      }
      function It(m, _) {
        try {
          var M = nr(m), O = nr(_);
          if (M !== O) return M === "Array" ? 1 : O === "Array" ? -1 : M === "binary" ? 1 : O === "binary" ? -1 : M === "string" ? 1 : O === "string" ? -1 : M === "Date" ? 1 : O !== "Date" ? NaN : -1;
          switch (M) {
            case "number":
            case "Date":
            case "string":
              return _ < m ? 1 : m < _ ? -1 : 0;
            case "binary":
              for (var V = so(m), K = so(_), J = V.length, re = K.length, be = J < re ? J : re, ke = 0; ke < be; ++ke) if (V[ke] !== K[ke]) return V[ke] < K[ke] ? -1 : 1;
              return J === re ? 0 : J < re ? -1 : 1;
            case "Array":
              for (var _e = m, me = _, fe = _e.length, ve = me.length, ge = fe < ve ? fe : ve, Se = 0; Se < ge; ++Se) {
                var we = It(_e[Se], me[Se]);
                if (we !== 0) return we;
              }
              return fe === ve ? 0 : fe < ve ? -1 : 1;
          }
        } catch {
        }
        return NaN;
      }
      function nr(m) {
        var _ = typeof m;
        return _ == "object" && (ArrayBuffer.isView(m) || (_ = ce(m)) === "ArrayBuffer") ? "binary" : _;
      }
      function so(m) {
        return m instanceof Uint8Array ? m : ArrayBuffer.isView(m) ? new Uint8Array(m.buffer, m.byteOffset, m.byteLength) : new Uint8Array(m);
      }
      function Ar(m, _, M) {
        var O = m.schema.yProps;
        return O ? (_ && 0 < M.numFailures && (_ = _.filter(function(V, K) {
          return !M.failures[K];
        })), Promise.all(O.map(function(V) {
          return V = V.updatesTable, _ ? m.db.table(V).where("k").anyOf(_).delete() : m.db.table(V).clear();
        })).then(function() {
          return M;
        })) : M;
      }
      Wi.prototype.execute = function(m) {
        var _ = this["@@propmod"];
        if (_.add !== void 0) {
          var M = _.add;
          if (f(M)) return l(l([], f(m) ? m : [], !0), M).sort();
          if (typeof M == "number") return (Number(m) || 0) + M;
          if (typeof M == "bigint") try {
            return BigInt(m) + M;
          } catch {
            return BigInt(0) + M;
          }
          throw new TypeError("Invalid term ".concat(M));
        }
        if (_.remove !== void 0) {
          var O = _.remove;
          if (f(O)) return f(m) ? m.filter(function(V) {
            return !O.includes(V);
          }).sort() : [];
          if (typeof O == "number") return Number(m) - O;
          if (typeof O == "bigint") try {
            return BigInt(m) - O;
          } catch {
            return BigInt(0) - O;
          }
          throw new TypeError("Invalid subtrahend ".concat(O));
        }
        return M = (M = _.replacePrefix) == null ? void 0 : M[0], M && typeof m == "string" && m.startsWith(M) ? _.replacePrefix[1] + m.substring(M.length) : m;
      };
      var zr = Wi;
      function Wi(m) {
        this["@@propmod"] = m;
      }
      function Ro(m, _) {
        for (var M = d(_), O = M.length, V = !1, K = 0; K < O; ++K) {
          var J = M[K], re = _[J], be = q(m, J);
          re instanceof zr ? (X(m, J, re.execute(be)), V = !0) : be !== re && (X(m, J, re), V = !0);
        }
        return V;
      }
      Wn.prototype._trans = function(m, _, M) {
        var O = this._tx || qe.trans, V = this.name, K = gn && typeof console < "u" && console.createTask && console.createTask("Dexie: ".concat(m === "readonly" ? "read" : "write", " ").concat(this.name));
        function J(ke, _e, me) {
          if (me.schema[V]) return _(me.idbtrans, me);
          throw new Pe.NotFound("Table " + V + " not part of transaction");
        }
        var re = mr();
        try {
          var be = O && O.db._novip === this.db._novip ? O === qe.trans ? O._promise(m, J, M) : Tr(function() {
            return O._promise(m, J, M);
          }, { trans: O, transless: qe.transless || qe }) : (function ke(_e, me, fe, ve) {
            if (_e.idbdb && (_e._state.openComplete || qe.letThrough || _e._vip)) {
              var ge = _e._createTransaction(me, fe, _e._dbSchema);
              try {
                ge.create(), _e._state.PR1398_maxLoop = 3;
              } catch (Se) {
                return Se.name === Re.InvalidState && _e.isOpen() && 0 < --_e._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), _e.close({ disableAutoOpen: !1 }), _e.open().then(function() {
                  return ke(_e, me, fe, ve);
                })) : yr(Se);
              }
              return ge._promise(me, function(Se, we) {
                return Tr(function() {
                  return qe.trans = ge, ve(Se, we, ge);
                });
              }).then(function(Se) {
                if (me === "readwrite") try {
                  ge.idbtrans.commit();
                } catch {
                }
                return me === "readonly" ? Se : ge._completion.then(function() {
                  return Se;
                });
              });
            }
            if (_e._state.openComplete) return yr(new Pe.DatabaseClosed(_e._state.dbOpenError));
            if (!_e._state.isBeingOpened) {
              if (!_e._state.autoOpen) return yr(new Pe.DatabaseClosed());
              _e.open().catch(st);
            }
            return _e._state.dbReadyPromise.then(function() {
              return ke(_e, me, fe, ve);
            });
          })(this.db, m, [this.name], J);
          return K && (be._consoleTask = K, be = be.catch(function(ke) {
            return console.trace(ke), yr(ke);
          })), be;
        } finally {
          re && Xr();
        }
      }, Wn.prototype.get = function(m, _) {
        var M = this;
        return m && m.constructor === Object ? this.where(m).first(_) : m == null ? yr(new Pe.Type("Invalid argument to Table.get()")) : this._trans("readonly", function(O) {
          return M.core.get({ trans: O, key: m }).then(function(V) {
            return M.hook.reading.fire(V);
          });
        }).then(_);
      }, Wn.prototype.where = function(m) {
        if (typeof m == "string") return new this.db.WhereClause(this, m);
        if (f(m)) return new this.db.WhereClause(this, "[".concat(m.join("+"), "]"));
        var _ = d(m);
        if (_.length === 1) return this.where(_[0]).equals(m[_[0]]);
        var M = this.schema.indexes.concat(this.schema.primKey).filter(function(re) {
          if (re.compound && _.every(function(ke) {
            return 0 <= re.keyPath.indexOf(ke);
          })) {
            for (var be = 0; be < _.length; ++be) if (_.indexOf(re.keyPath[be]) === -1) return !1;
            return !0;
          }
          return !1;
        }).sort(function(re, be) {
          return re.keyPath.length - be.keyPath.length;
        })[0];
        if (M && this.db._maxKey !== oo) return J = M.keyPath.slice(0, _.length), this.where(J).equals(J.map(function(re) {
          return m[re];
        }));
        !M && gn && console.warn("The query ".concat(JSON.stringify(m), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(_.join("+"), "]"));
        var O = this.schema.idxByName;
        function V(re, be) {
          return It(re, be) === 0;
        }
        var J = _.reduce(function(_e, be) {
          var ke = _e[0], _e = _e[1], me = O[be], fe = m[be];
          return [ke || me, ke || !me ? Eo(_e, me && me.multi ? function(ve) {
            return ve = q(ve, be), f(ve) && ve.some(function(ge) {
              return V(fe, ge);
            });
          } : function(ve) {
            return V(fe, q(ve, be));
          }) : _e];
        }, [null, null]), K = J[0], J = J[1];
        return K ? this.where(K.name).equals(m[K.keyPath]).filter(J) : M ? this.filter(J) : this.where(_).equals("");
      }, Wn.prototype.filter = function(m) {
        return this.toCollection().and(m);
      }, Wn.prototype.count = function(m) {
        return this.toCollection().count(m);
      }, Wn.prototype.offset = function(m) {
        return this.toCollection().offset(m);
      }, Wn.prototype.limit = function(m) {
        return this.toCollection().limit(m);
      }, Wn.prototype.each = function(m) {
        return this.toCollection().each(m);
      }, Wn.prototype.toArray = function(m) {
        return this.toCollection().toArray(m);
      }, Wn.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
      }, Wn.prototype.orderBy = function(m) {
        return new this.db.Collection(new this.db.WhereClause(this, f(m) ? "[".concat(m.join("+"), "]") : m));
      }, Wn.prototype.reverse = function() {
        return this.toCollection().reverse();
      }, Wn.prototype.mapToClass = function(m) {
        for (var _ = this.db, M = this.name, O = ((this.schema.mappedClass = m).prototype instanceof Ni && (m = ((J) => {
          var re = _e, be = J;
          if (typeof be != "function" && be !== null) throw new TypeError("Class extends value " + String(be) + " is not a constructor or null");
          function ke() {
            this.constructor = re;
          }
          function _e() {
            return J !== null && J.apply(this, arguments) || this;
          }
          return r(re, be), re.prototype = be === null ? Object.create(be) : (ke.prototype = be.prototype, new ke()), Object.defineProperty(_e.prototype, "db", { get: function() {
            return _;
          }, enumerable: !1, configurable: !0 }), _e.prototype.table = function() {
            return M;
          }, _e;
        })(m)), /* @__PURE__ */ new Set()), V = m.prototype; V; V = h(V)) Object.getOwnPropertyNames(V).forEach(function(J) {
          return O.add(J);
        });
        function K(J) {
          if (!J) return J;
          var re, be = Object.create(m.prototype);
          for (re in J) if (!O.has(re)) try {
            be[re] = J[re];
          } catch {
          }
          return be;
        }
        return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = K, this.hook("reading", K), m;
      }, Wn.prototype.defineClass = function() {
        return this.mapToClass(function(m) {
          g(this, m);
        });
      }, Wn.prototype.add = function(m, _) {
        var M = this, O = this.schema.primKey, V = O.auto, K = O.keyPath, J = m;
        return K && V && (J = wr(K)(m)), this._trans("readwrite", function(re) {
          return M.core.mutate({ trans: re, type: "add", keys: _ != null ? [_] : null, values: [J] });
        }).then(function(re) {
          return re.numFailures ? Xe.reject(re.failures[0]) : re.lastResult;
        }).then(function(re) {
          if (K) try {
            X(m, K, re);
          } catch {
          }
          return re;
        });
      }, Wn.prototype.upsert = function(m, _) {
        var M = this, O = this.schema.primKey.keyPath;
        return this._trans("readwrite", function(V) {
          return M.core.get({ trans: V, key: m }).then(function(K) {
            var J = K ?? {};
            return Ro(J, _), O && X(J, O, m), M.core.mutate({ trans: V, type: "put", values: [J], keys: [m], upsert: !0, updates: { keys: [m], changeSpecs: [_] } }).then(function(re) {
              return re.numFailures ? Xe.reject(re.failures[0]) : !!K;
            });
          });
        });
      }, Wn.prototype.update = function(m, _) {
        return typeof m != "object" || f(m) ? this.where(":id").equals(m).modify(_) : (m = q(m, this.schema.primKey.keyPath)) === void 0 ? yr(new Pe.InvalidArgument("Given object does not contain its primary key")) : this.where(":id").equals(m).modify(_);
      }, Wn.prototype.put = function(m, _) {
        var M = this, O = this.schema.primKey, V = O.auto, K = O.keyPath, J = m;
        return K && V && (J = wr(K)(m)), this._trans("readwrite", function(re) {
          return M.core.mutate({ trans: re, type: "put", values: [J], keys: _ != null ? [_] : null });
        }).then(function(re) {
          return re.numFailures ? Xe.reject(re.failures[0]) : re.lastResult;
        }).then(function(re) {
          if (K) try {
            X(m, K, re);
          } catch {
          }
          return re;
        });
      }, Wn.prototype.delete = function(m) {
        var _ = this;
        return this._trans("readwrite", function(M) {
          return _.core.mutate({ trans: M, type: "delete", keys: [m] }).then(function(O) {
            return Ar(_, [m], O);
          }).then(function(O) {
            return O.numFailures ? Xe.reject(O.failures[0]) : void 0;
          });
        });
      }, Wn.prototype.clear = function() {
        var m = this;
        return this._trans("readwrite", function(_) {
          return m.core.mutate({ trans: _, type: "deleteRange", range: Jl }).then(function(M) {
            return Ar(m, null, M);
          });
        }).then(function(_) {
          return _.numFailures ? Xe.reject(_.failures[0]) : void 0;
        });
      }, Wn.prototype.bulkGet = function(m) {
        var _ = this;
        return this._trans("readonly", function(M) {
          return _.core.getMany({ keys: m, trans: M }).then(function(O) {
            return O.map(function(V) {
              return _.hook.reading.fire(V);
            });
          });
        });
      }, Wn.prototype.bulkAdd = function(m, _, M) {
        var O = this, V = Array.isArray(_) ? _ : void 0, K = (M = M || (V ? void 0 : _)) ? M.allKeys : void 0;
        return this._trans("readwrite", function(J) {
          var re = O.schema.primKey, ke = re.auto, re = re.keyPath;
          if (re && V) throw new Pe.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
          if (V && V.length !== m.length) throw new Pe.InvalidArgument("Arguments objects and keys must have the same length");
          var be = m.length, ke = re && ke ? m.map(wr(re)) : m;
          return O.core.mutate({ trans: J, type: "add", keys: V, values: ke, wantResults: K }).then(function(_e) {
            var me = _e.numFailures, fe = _e.failures;
            if (me === 0) return K ? _e.results : _e.lastResult;
            throw new ae("".concat(O.name, ".bulkAdd(): ").concat(me, " of ").concat(be, " operations failed"), fe);
          });
        });
      }, Wn.prototype.bulkPut = function(m, _, M) {
        var O = this, V = Array.isArray(_) ? _ : void 0, K = (M = M || (V ? void 0 : _)) ? M.allKeys : void 0;
        return this._trans("readwrite", function(J) {
          var re = O.schema.primKey, ke = re.auto, re = re.keyPath;
          if (re && V) throw new Pe.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
          if (V && V.length !== m.length) throw new Pe.InvalidArgument("Arguments objects and keys must have the same length");
          var be = m.length, ke = re && ke ? m.map(wr(re)) : m;
          return O.core.mutate({ trans: J, type: "put", keys: V, values: ke, wantResults: K }).then(function(_e) {
            var me = _e.numFailures, fe = _e.failures;
            if (me === 0) return K ? _e.results : _e.lastResult;
            throw new ae("".concat(O.name, ".bulkPut(): ").concat(me, " of ").concat(be, " operations failed"), fe);
          });
        });
      }, Wn.prototype.bulkUpdate = function(m) {
        var _ = this, M = this.core, O = m.map(function(J) {
          return J.key;
        }), V = m.map(function(J) {
          return J.changes;
        }), K = [];
        return this._trans("readwrite", function(J) {
          return M.getMany({ trans: J, keys: O, cache: "clone" }).then(function(re) {
            var be = [], ke = [], _e = (m.forEach(function(me, fe) {
              var ve = me.key, ge = me.changes, Se = re[fe];
              if (Se) {
                for (var we = 0, Te = Object.keys(ge); we < Te.length; we++) {
                  var Ne = Te[we], Be = ge[Ne];
                  if (Ne === _.schema.primKey.keyPath) {
                    if (It(Be, ve) !== 0) throw new Pe.Constraint("Cannot update primary key in bulkUpdate()");
                  } else X(Se, Ne, Be);
                }
                K.push(fe), be.push(ve), ke.push(Se);
              }
            }), be.length);
            return M.mutate({ trans: J, type: "put", keys: be, values: ke, updates: { keys: O, changeSpecs: V } }).then(function(me) {
              var fe = me.numFailures, ve = me.failures;
              if (fe === 0) return _e;
              for (var ge = 0, Se = Object.keys(ve); ge < Se.length; ge++) {
                var we, Te = Se[ge], Ne = K[Number(Te)];
                Ne != null && (we = ve[Te], delete ve[Te], ve[Ne] = we);
              }
              throw new ae("".concat(_.name, ".bulkUpdate(): ").concat(fe, " of ").concat(_e, " operations failed"), ve);
            });
          });
        });
      }, Wn.prototype.bulkDelete = function(m) {
        var _ = this, M = m.length;
        return this._trans("readwrite", function(O) {
          return _.core.mutate({ trans: O, type: "delete", keys: m }).then(function(V) {
            return Ar(_, m, V);
          });
        }).then(function(O) {
          var V = O.numFailures, K = O.failures;
          if (V === 0) return O.lastResult;
          throw new ae("".concat(_.name, ".bulkDelete(): ").concat(V, " of ").concat(M, " operations failed"), K);
        });
      };
      var ia = Wn;
      function Wn() {
      }
      function es(m) {
        function _(J, re) {
          if (re) {
            for (var be = arguments.length, ke = new Array(be - 1); --be; ) ke[be - 1] = arguments[be];
            return M[J].subscribe.apply(null, ke), m;
          }
          if (typeof J == "string") return M[J];
        }
        var M = {};
        _.addEventType = K;
        for (var O = 1, V = arguments.length; O < V; ++O) K(arguments[O]);
        return _;
        function K(J, re, be) {
          var ke, _e;
          if (typeof J != "object") return re = re || Yr, _e = { subscribers: [], fire: be = be || st, subscribe: function(me) {
            _e.subscribers.indexOf(me) === -1 && (_e.subscribers.push(me), _e.fire = re(_e.fire, me));
          }, unsubscribe: function(me) {
            _e.subscribers = _e.subscribers.filter(function(fe) {
              return fe !== me;
            }), _e.fire = _e.subscribers.reduce(re, be);
          } }, M[J] = _[J] = _e;
          d(ke = J).forEach(function(me) {
            var fe = ke[me];
            if (f(fe)) K(me, ke[me][0], ke[me][1]);
            else {
              if (fe !== "asap") throw new Pe.InvalidArgument("Invalid event config");
              var ve = K(me, bt, function() {
                for (var ge = arguments.length, Se = new Array(ge); ge--; ) Se[ge] = arguments[ge];
                ve.subscribers.forEach(function(we) {
                  B(function() {
                    we.apply(null, Se);
                  });
                });
              });
            }
          });
        }
      }
      function ts(m, _) {
        return P(_).from({ prototype: m }), _;
      }
      function lo(m, _) {
        return !(m.filter || m.algorithm || m.or) && (_ ? m.justLimit : !m.replayFilter);
      }
      function Ts(m, _) {
        m.filter = Eo(m.filter, _);
      }
      function oa(m, _, M) {
        var O = m.replayFilter;
        m.replayFilter = O ? function() {
          return Eo(O(), _());
        } : _, m.justLimit = M && !O;
      }
      function $l(m, _) {
        if (m.isPrimKey) return _.primaryKey;
        var M = _.getIndexByKeyPath(m.index);
        if (M) return M;
        throw new Pe.Schema("KeyPath " + m.index + " on object store " + _.name + " is not indexed");
      }
      function Oa(m, _, M) {
        var O = $l(m, _.schema);
        return _.openCursor({ trans: M, values: !m.keysOnly, reverse: m.dir === "prev", unique: !!m.unique, query: { index: O, range: m.range } });
      }
      function ns(m, _, M, O) {
        var V, K, J = m.replayFilter ? Eo(m.filter, m.replayFilter()) : m.filter;
        return m.or ? (V = {}, K = function(re, be, ke) {
          var _e, me;
          J && !J(be, ke, function(fe) {
            return be.stop(fe);
          }, function(fe) {
            return be.fail(fe);
          }) || ((me = "" + (_e = be.primaryKey)) == "[object ArrayBuffer]" && (me = "" + new Uint8Array(_e)), E(V, me)) || (V[me] = !0, _(re, be, ke));
        }, Promise.all([m.or._iterate(K, M), sa(Oa(m, O, M), m.algorithm, K, !m.keysOnly && m.valueMapper)])) : sa(Oa(m, O, M), Eo(m.algorithm, J), _, !m.keysOnly && m.valueMapper);
      }
      function sa(m, _, M, O) {
        var V = Ge(O ? function(K, J, re) {
          return M(O(K), J, re);
        } : M);
        return m.then(function(K) {
          if (K) return K.start(function() {
            var J = function() {
              return K.continue();
            };
            _ && !_(K, function(re) {
              return J = re;
            }, function(re) {
              K.stop(re), J = st;
            }, function(re) {
              K.fail(re), J = st;
            }) || V(K.value, K, function(re) {
              return J = re;
            }), J();
          });
        });
      }
      wn.prototype._read = function(m, _) {
        var M = this._ctx;
        return M.error ? M.table._trans(null, yr.bind(null, M.error)) : M.table._trans("readonly", m).then(_);
      }, wn.prototype._write = function(m) {
        var _ = this._ctx;
        return _.error ? _.table._trans(null, yr.bind(null, _.error)) : _.table._trans("readwrite", m, "locked");
      }, wn.prototype._addAlgorithm = function(m) {
        var _ = this._ctx;
        _.algorithm = Eo(_.algorithm, m);
      }, wn.prototype._iterate = function(m, _) {
        return ns(this._ctx, m, _, this._ctx.table.core);
      }, wn.prototype.clone = function(m) {
        var _ = Object.create(this.constructor.prototype), M = Object.create(this._ctx);
        return m && g(M, m), _._ctx = M, _;
      }, wn.prototype.raw = function() {
        return this._ctx.valueMapper = null, this;
      }, wn.prototype.each = function(m) {
        var _ = this._ctx;
        return this._read(function(M) {
          return ns(_, m, M, _.table.core);
        });
      }, wn.prototype.count = function(m) {
        var _ = this;
        return this._read(function(M) {
          var O, V = _._ctx, K = V.table.core;
          return lo(V, !0) ? K.count({ trans: M, query: { index: $l(V, K.schema), range: V.range } }).then(function(J) {
            return Math.min(J, V.limit);
          }) : (O = 0, ns(V, function() {
            return ++O, !1;
          }, M, K).then(function() {
            return O;
          }));
        }).then(m);
      }, wn.prototype.sortBy = function(m, _) {
        var M = m.split(".").reverse(), O = M[0], V = M.length - 1;
        function K(be, ke) {
          return ke ? K(be[M[ke]], ke - 1) : be[O];
        }
        var J = this._ctx.dir === "next" ? 1 : -1;
        function re(be, ke) {
          return It(K(be, V), K(ke, V)) * J;
        }
        return this.toArray(function(be) {
          return be.slice().sort(re);
        }).then(_);
      }, wn.prototype.toArray = function(m) {
        var _ = this;
        return this._read(function(M) {
          var O, V, K, J = _._ctx;
          return lo(J, !0) && 0 < J.limit ? (O = J.valueMapper, V = $l(J, J.table.core.schema), J.table.core.query({ trans: M, limit: J.limit, values: !0, direction: J.dir === "prev" ? "prev" : void 0, query: { index: V, range: J.range } }).then(function(re) {
            return re = re.result, O ? re.map(O) : re;
          })) : (K = [], ns(J, function(re) {
            return K.push(re);
          }, M, J.table.core).then(function() {
            return K;
          }));
        }, m);
      }, wn.prototype.offset = function(m) {
        var _ = this._ctx;
        return m <= 0 || (_.offset += m, lo(_) ? oa(_, function() {
          var M = m;
          return function(O, V) {
            return M === 0 || (M === 1 ? --M : V(function() {
              O.advance(M), M = 0;
            }), !1);
          };
        }) : oa(_, function() {
          var M = m;
          return function() {
            return --M < 0;
          };
        })), this;
      }, wn.prototype.limit = function(m) {
        return this._ctx.limit = Math.min(this._ctx.limit, m), oa(this._ctx, function() {
          var _ = m;
          return function(M, O, V) {
            return --_ <= 0 && O(V), 0 <= _;
          };
        }, !0), this;
      }, wn.prototype.until = function(m, _) {
        return Ts(this._ctx, function(M, O, V) {
          return !m(M.value) || (O(V), _);
        }), this;
      }, wn.prototype.first = function(m) {
        return this.limit(1).toArray(function(_) {
          return _[0];
        }).then(m);
      }, wn.prototype.last = function(m) {
        return this.reverse().first(m);
      }, wn.prototype.filter = function(m) {
        var _;
        return Ts(this._ctx, function(M) {
          return m(M.value);
        }), (_ = this._ctx).isMatch = Eo(_.isMatch, m), this;
      }, wn.prototype.and = function(m) {
        return this.filter(m);
      }, wn.prototype.or = function(m) {
        return new this.db.WhereClause(this._ctx.table, m, this);
      }, wn.prototype.reverse = function() {
        return this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
      }, wn.prototype.desc = function() {
        return this.reverse();
      }, wn.prototype.eachKey = function(m) {
        var _ = this._ctx;
        return _.keysOnly = !_.isMatch, this.each(function(M, O) {
          m(O.key, O);
        });
      }, wn.prototype.eachUniqueKey = function(m) {
        return this._ctx.unique = "unique", this.eachKey(m);
      }, wn.prototype.eachPrimaryKey = function(m) {
        var _ = this._ctx;
        return _.keysOnly = !_.isMatch, this.each(function(M, O) {
          m(O.primaryKey, O);
        });
      }, wn.prototype.keys = function(m) {
        var _ = this._ctx, M = (_.keysOnly = !_.isMatch, []);
        return this.each(function(O, V) {
          M.push(V.key);
        }).then(function() {
          return M;
        }).then(m);
      }, wn.prototype.primaryKeys = function(m) {
        var _ = this._ctx;
        if (lo(_, !0) && 0 < _.limit) return this._read(function(O) {
          var V = $l(_, _.table.core.schema);
          return _.table.core.query({ trans: O, values: !1, limit: _.limit, direction: _.dir === "prev" ? "prev" : void 0, query: { index: V, range: _.range } });
        }).then(function(O) {
          return O.result;
        }).then(m);
        _.keysOnly = !_.isMatch;
        var M = [];
        return this.each(function(O, V) {
          M.push(V.primaryKey);
        }).then(function() {
          return M;
        }).then(m);
      }, wn.prototype.uniqueKeys = function(m) {
        return this._ctx.unique = "unique", this.keys(m);
      }, wn.prototype.firstKey = function(m) {
        return this.limit(1).keys(function(_) {
          return _[0];
        }).then(m);
      }, wn.prototype.lastKey = function(m) {
        return this.reverse().firstKey(m);
      }, wn.prototype.distinct = function() {
        var m, _ = this._ctx, _ = _.index && _.table.schema.idxByName[_.index];
        return _ && _.multi && (m = {}, Ts(this._ctx, function(O) {
          var O = O.primaryKey.toString(), V = E(m, O);
          return m[O] = !0, !V;
        })), this;
      }, wn.prototype.modify = function(m) {
        var _ = this, M = this._ctx;
        return this._write(function(O) {
          function V(Se, we) {
            var Te = we.failures;
            fe += Se - we.numFailures;
            for (var Ne = 0, Be = d(Te); Ne < Be.length; Ne++) {
              var Je = Be[Ne];
              me.push(Te[Je]);
            }
          }
          var K = typeof m == "function" ? m : function(Se) {
            return Ro(Se, m);
          }, J = M.table.core, _e = J.schema.primaryKey, re = _e.outbound, be = _e.extractKey, ke = 200, _e = _.db._options.modifyChunkSize, me = (_e && (ke = typeof _e == "object" ? _e[J.name] || _e["*"] || 200 : _e), []), fe = 0, ve = [], ge = m === yl;
          return _.clone().primaryKeys().then(function(Se) {
            function we(Ne) {
              var Be = Math.min(ke, Se.length - Ne), Je = Se.slice(Ne, Ne + Be);
              return (ge ? Promise.resolve([]) : J.getMany({ trans: O, keys: Je, cache: "immutable" })).then(function(nt) {
                var lt = [], tt = [], pt = re ? [] : null, it = ge ? Je : [];
                if (!ge) for (var Mt = 0; Mt < Be; ++Mt) {
                  var De = nt[Mt], ht = { value: ie(De), primKey: Se[Ne + Mt] };
                  K.call(ht, ht.value, ht) !== !1 && (ht.value == null ? it.push(Se[Ne + Mt]) : re || It(be(De), be(ht.value)) === 0 ? (tt.push(ht.value), re && pt.push(Se[Ne + Mt])) : (it.push(Se[Ne + Mt]), lt.push(ht.value)));
                }
                return Promise.resolve(0 < lt.length && J.mutate({ trans: O, type: "add", values: lt }).then(function(mt) {
                  for (var Ot in mt.failures) it.splice(parseInt(Ot), 1);
                  V(lt.length, mt);
                })).then(function() {
                  return (0 < tt.length || Te && typeof m == "object") && J.mutate({ trans: O, type: "put", keys: pt, values: tt, criteria: Te, changeSpec: typeof m != "function" && m, isAdditionalChunk: 0 < Ne }).then(function(mt) {
                    return V(tt.length, mt);
                  });
                }).then(function() {
                  return (0 < it.length || Te && ge) && J.mutate({ trans: O, type: "delete", keys: it, criteria: Te, isAdditionalChunk: 0 < Ne }).then(function(mt) {
                    return Ar(M.table, it, mt);
                  }).then(function(mt) {
                    return V(it.length, mt);
                  });
                }).then(function() {
                  return Se.length > Ne + Be && we(Ne + ke);
                });
              });
            }
            var Te = lo(M) && M.limit === 1 / 0 && (typeof m != "function" || ge) && { index: M.index, range: M.range };
            return we(0).then(function() {
              if (0 < me.length) throw new Ee("Error modifying one or more objects", me, fe, ve);
              return Se.length;
            });
          });
        });
      }, wn.prototype.delete = function() {
        var m = this._ctx, _ = m.range;
        return !lo(m) || m.table.schema.yProps || !m.isPrimKey && _.type !== 3 ? this.modify(yl) : this._write(function(M) {
          var O = m.table.core.schema.primaryKey, V = _;
          return m.table.core.count({ trans: M, query: { index: O, range: V } }).then(function(K) {
            return m.table.core.mutate({ trans: M, type: "deleteRange", range: V }).then(function(be) {
              var re = be.failures, be = be.numFailures;
              if (be) throw new Ee("Could not delete some values", Object.keys(re).map(function(ke) {
                return re[ke];
              }), K - be);
              return K - be;
            });
          });
        });
      };
      var eu = wn;
      function wn() {
      }
      var yl = function(m, _) {
        return _.value = null;
      };
      function qf(m, _) {
        return m < _ ? -1 : m === _ ? 0 : 1;
      }
      function Wf(m, _) {
        return _ < m ? -1 : m === _ ? 0 : 1;
      }
      function va(m, _, M) {
        return m = m instanceof To ? new m.Collection(m) : m, m._ctx.error = new (M || TypeError)(_), m;
      }
      function ui(m) {
        return new m.Collection(m, function() {
          return hd("");
        }).limit(0);
      }
      function Ns(ve, _, M, O) {
        var V, K, J, re, be, ke, _e, me = M.length;
        if (!M.every(function(Se) {
          return typeof Se == "string";
        })) return va(ve, $o);
        function fe(Se) {
          V = Se === "next" ? function(Te) {
            return Te.toUpperCase();
          } : function(Te) {
            return Te.toLowerCase();
          }, K = Se === "next" ? function(Te) {
            return Te.toLowerCase();
          } : function(Te) {
            return Te.toUpperCase();
          }, J = Se === "next" ? qf : Wf;
          var we = M.map(function(Te) {
            return { lower: K(Te), upper: V(Te) };
          }).sort(function(Te, Ne) {
            return J(Te.lower, Ne.lower);
          });
          re = we.map(function(Te) {
            return Te.upper;
          }), be = we.map(function(Te) {
            return Te.lower;
          }), _e = (ke = Se) === "next" ? "" : O;
        }
        fe("next");
        var ve = new ve.Collection(ve, function() {
          return ci(re[0], be[me - 1] + O);
        }), ge = (ve._ondirectionchange = function(Se) {
          fe(Se);
        }, 0);
        return ve._addAlgorithm(function(Se, we, Te) {
          var Ne = Se.key;
          if (typeof Ne == "string") {
            var Be = K(Ne);
            if (_(Be, be, ge)) return !0;
            for (var Je = null, nt = ge; nt < me; ++nt) {
              var lt = ((tt, pt, it, Mt, De, ht) => {
                for (var mt = Math.min(tt.length, Mt.length), Ot = -1, tn = 0; tn < mt; ++tn) {
                  var xa = pt[tn];
                  if (xa !== Mt[tn]) return De(tt[tn], it[tn]) < 0 ? tt.substr(0, tn) + it[tn] + it.substr(tn + 1) : De(tt[tn], Mt[tn]) < 0 ? tt.substr(0, tn) + Mt[tn] + it.substr(tn + 1) : 0 <= Ot ? tt.substr(0, Ot) + pt[Ot] + it.substr(Ot + 1) : null;
                  De(tt[tn], xa) < 0 && (Ot = tn);
                }
                return mt < Mt.length && ht === "next" ? tt + it.substr(tt.length) : mt < tt.length && ht === "prev" ? tt.substr(0, it.length) : Ot < 0 ? null : tt.substr(0, Ot) + Mt[Ot] + it.substr(Ot + 1);
              })(Ne, Be, re[nt], be[nt], J, ke);
              lt === null && Je === null ? ge = nt + 1 : (Je === null || 0 < J(Je, lt)) && (Je = lt);
            }
            we(Je !== null ? function() {
              Se.continue(Je + _e);
            } : Te);
          }
          return !1;
        }), ve;
      }
      function ci(m, _, M, O) {
        return { type: 2, lower: m, upper: _, lowerOpen: M, upperOpen: O };
      }
      function hd(m) {
        return { type: 1, lower: m, upper: m };
      }
      Object.defineProperty(Jt.prototype, "Collection", { get: function() {
        return this._ctx.table.db.Collection;
      }, enumerable: !1, configurable: !0 }), Jt.prototype.between = function(m, _, M, O) {
        M = M !== !1, O = O === !0;
        try {
          return 0 < this._cmp(m, _) || this._cmp(m, _) === 0 && (M || O) && (!M || !O) ? ui(this) : new this.Collection(this, function() {
            return ci(m, _, !M, !O);
          });
        } catch {
          return va(this, li);
        }
      }, Jt.prototype.equals = function(m) {
        return m == null ? va(this, li) : new this.Collection(this, function() {
          return hd(m);
        });
      }, Jt.prototype.above = function(m) {
        return m == null ? va(this, li) : new this.Collection(this, function() {
          return ci(m, void 0, !0);
        });
      }, Jt.prototype.aboveOrEqual = function(m) {
        return m == null ? va(this, li) : new this.Collection(this, function() {
          return ci(m, void 0, !1);
        });
      }, Jt.prototype.below = function(m) {
        return m == null ? va(this, li) : new this.Collection(this, function() {
          return ci(void 0, m, !1, !0);
        });
      }, Jt.prototype.belowOrEqual = function(m) {
        return m == null ? va(this, li) : new this.Collection(this, function() {
          return ci(void 0, m);
        });
      }, Jt.prototype.startsWith = function(m) {
        return typeof m != "string" ? va(this, $o) : this.between(m, m + oo, !0, !0);
      }, Jt.prototype.startsWithIgnoreCase = function(m) {
        return m === "" ? this.startsWith(m) : Ns(this, function(_, M) {
          return _.indexOf(M[0]) === 0;
        }, [m], oo);
      }, Jt.prototype.equalsIgnoreCase = function(m) {
        return Ns(this, function(_, M) {
          return _ === M[0];
        }, [m], "");
      }, Jt.prototype.anyOfIgnoreCase = function() {
        var m = Q.apply(ee, arguments);
        return m.length === 0 ? ui(this) : Ns(this, function(_, M) {
          return M.indexOf(_) !== -1;
        }, m, "");
      }, Jt.prototype.startsWithAnyOfIgnoreCase = function() {
        var m = Q.apply(ee, arguments);
        return m.length === 0 ? ui(this) : Ns(this, function(_, M) {
          return M.some(function(O) {
            return _.indexOf(O) === 0;
          });
        }, m, oo);
      }, Jt.prototype.anyOf = function() {
        var m, _, M = this, O = Q.apply(ee, arguments), V = this._cmp;
        try {
          O.sort(V);
        } catch {
          return va(this, li);
        }
        return O.length === 0 ? ui(this) : ((m = new this.Collection(this, function() {
          return ci(O[0], O[O.length - 1]);
        }))._ondirectionchange = function(K) {
          V = K === "next" ? M._ascending : M._descending, O.sort(V);
        }, _ = 0, m._addAlgorithm(function(K, J, re) {
          for (var be = K.key; 0 < V(be, O[_]); ) if (++_ === O.length) return J(re), !1;
          return V(be, O[_]) === 0 || (J(function() {
            K.continue(O[_]);
          }), !1);
        }), m);
      }, Jt.prototype.notEqual = function(m) {
        return this.inAnyRange([[-1 / 0, m], [m, this.db._maxKey]], { includeLowers: !1, includeUppers: !1 });
      }, Jt.prototype.noneOf = function() {
        var m = Q.apply(ee, arguments);
        if (m.length === 0) return new this.Collection(this);
        try {
          m.sort(this._ascending);
        } catch {
          return va(this, li);
        }
        var _ = m.reduce(function(M, O) {
          return M ? M.concat([[M[M.length - 1][1], O]]) : [[-1 / 0, O]];
        }, null);
        return _.push([m[m.length - 1], this.db._maxKey]), this.inAnyRange(_, { includeLowers: !1, includeUppers: !1 });
      }, Jt.prototype.inAnyRange = function(m, Te) {
        var M = this, O = this._cmp, V = this._ascending, K = this._descending, J = this._min, re = this._max;
        if (m.length === 0) return ui(this);
        if (!m.every(function(Ne) {
          return Ne[0] !== void 0 && Ne[1] !== void 0 && V(Ne[0], Ne[1]) <= 0;
        })) return va(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", Pe.InvalidArgument);
        var be = !Te || Te.includeLowers !== !1, ke = Te && Te.includeUppers === !0, _e, me = V;
        function fe(Ne, Be) {
          return me(Ne[0], Be[0]);
        }
        try {
          (_e = m.reduce(function(Ne, Be) {
            for (var Je = 0, nt = Ne.length; Je < nt; ++Je) {
              var lt = Ne[Je];
              if (O(Be[0], lt[1]) < 0 && 0 < O(Be[1], lt[0])) {
                lt[0] = J(lt[0], Be[0]), lt[1] = re(lt[1], Be[1]);
                break;
              }
            }
            return Je === nt && Ne.push(Be), Ne;
          }, [])).sort(fe);
        } catch {
          return va(this, li);
        }
        var ve = 0, ge = ke ? function(Ne) {
          return 0 < V(Ne, _e[ve][1]);
        } : function(Ne) {
          return 0 <= V(Ne, _e[ve][1]);
        }, Se = be ? function(Ne) {
          return 0 < K(Ne, _e[ve][0]);
        } : function(Ne) {
          return 0 <= K(Ne, _e[ve][0]);
        }, we = ge, Te = new this.Collection(this, function() {
          return ci(_e[0][0], _e[_e.length - 1][1], !be, !ke);
        });
        return Te._ondirectionchange = function(Ne) {
          me = Ne === "next" ? (we = ge, V) : (we = Se, K), _e.sort(fe);
        }, Te._addAlgorithm(function(Ne, Be, Je) {
          for (var nt, lt = Ne.key; we(lt); ) if (++ve === _e.length) return Be(Je), !1;
          return !ge(nt = lt) && !Se(nt) || (M._cmp(lt, _e[ve][1]) === 0 || M._cmp(lt, _e[ve][0]) === 0 || Be(function() {
            me === V ? Ne.continue(_e[ve][0]) : Ne.continue(_e[ve][1]);
          }), !1);
        }), Te;
      }, Jt.prototype.startsWithAnyOf = function() {
        var m = Q.apply(ee, arguments);
        return m.every(function(_) {
          return typeof _ == "string";
        }) ? m.length === 0 ? ui(this) : this.inAnyRange(m.map(function(_) {
          return [_, _ + oo];
        })) : va(this, "startsWithAnyOf() only works with strings");
      };
      var To = Jt;
      function Jt() {
      }
      function di(m) {
        return Ge(function(_) {
          return rs(_), m(_.target.error), !1;
        });
      }
      function rs(m) {
        m.stopPropagation && m.stopPropagation(), m.preventDefault && m.preventDefault();
      }
      var bl = "storagemutated", lc = "x-storagemutated-1", No = es(null, bl), Br = (fi.prototype._lock = function() {
        return R(!qe.global), ++this._reculock, this._reculock !== 1 || qe.global || (qe.lockOwnerFor = this), this;
      }, fi.prototype._unlock = function() {
        if (R(!qe.global), --this._reculock == 0) for (qe.global || (qe.lockOwnerFor = null); 0 < this._blockedFuncs.length && !this._locked(); ) {
          var m = this._blockedFuncs.shift();
          try {
            Qr(m[1], m[0]);
          } catch {
          }
        }
        return this;
      }, fi.prototype._locked = function() {
        return this._reculock && qe.lockOwnerFor !== this;
      }, fi.prototype.create = function(m) {
        var _ = this;
        if (this.mode) {
          var M = this.db.idbdb, O = this.db._state.dbOpenError;
          if (R(!this.idbtrans), !m && !M) switch (O && O.name) {
            case "DatabaseClosedError":
              throw new Pe.DatabaseClosed(O);
            case "MissingAPIError":
              throw new Pe.MissingAPI(O.message, O);
            default:
              throw new Pe.OpenFailed(O);
          }
          if (!this.active) throw new Pe.TransactionInactive();
          R(this._completion._state === null), (m = this.idbtrans = m || (this.db.core || M).transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability })).onerror = Ge(function(V) {
            rs(V), _._reject(m.error);
          }), m.onabort = Ge(function(V) {
            rs(V), _.active && _._reject(new Pe.Abort(m.error)), _.active = !1, _.on("abort").fire(V);
          }), m.oncomplete = Ge(function() {
            _.active = !1, _._resolve(), "mutatedParts" in m && No.storagemutated.fire(m.mutatedParts);
          });
        }
        return this;
      }, fi.prototype._promise = function(m, _, M) {
        var O, V = this;
        return m === "readwrite" && this.mode !== "readwrite" ? yr(new Pe.ReadOnly("Transaction is readonly")) : this.active ? this._locked() ? new Xe(function(K, J) {
          V._blockedFuncs.push([function() {
            V._promise(m, _, M).then(K, J);
          }, qe]);
        }) : M ? Tr(function() {
          var K = new Xe(function(J, re) {
            V._lock();
            var be = _(J, re, V);
            be && be.then && be.then(J, re);
          });
          return K.finally(function() {
            return V._unlock();
          }), K._lib = !0, K;
        }) : ((O = new Xe(function(K, J) {
          var re = _(K, J, V);
          re && re.then && re.then(K, J);
        }))._lib = !0, O) : yr(new Pe.TransactionInactive());
      }, fi.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
      }, fi.prototype.waitFor = function(m) {
        var _, M = this._root(), O = Xe.resolve(m), V = (M._waitingFor ? M._waitingFor = M._waitingFor.then(function() {
          return O;
        }) : (M._waitingFor = O, M._waitingQueue = [], _ = M.idbtrans.objectStore(M.storeNames[0]), (function K() {
          for (++M._spinCount; M._waitingQueue.length; ) M._waitingQueue.shift()();
          M._waitingFor && (_.get(-1 / 0).onsuccess = K);
        })()), M._waitingFor);
        return new Xe(function(K, J) {
          O.then(function(re) {
            return M._waitingQueue.push(Ge(K.bind(null, re)));
          }, function(re) {
            return M._waitingQueue.push(Ge(J.bind(null, re)));
          }).finally(function() {
            M._waitingFor === V && (M._waitingFor = null);
          });
        });
      }, fi.prototype.abort = function() {
        this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new Pe.Abort()));
      }, fi.prototype.table = function(m) {
        var _ = this._memoizedTables || (this._memoizedTables = {});
        if (E(_, m)) return _[m];
        var M = this.schema[m];
        if (M) return (M = new this.db.Table(m, M, this)).core = this.db.core.table(m), _[m] = M;
        throw new Pe.NotFound("Table " + m + " not part of transaction");
      }, fi);
      function fi() {
      }
      function uc(m, _, M, O, V, K, J, re) {
        return { name: m, keyPath: _, unique: M, multi: O, auto: V, compound: K, src: (M && !J ? "&" : "") + (O ? "*" : "") + (V ? "++" : "") + tu(_), type: re };
      }
      function tu(m) {
        return typeof m == "string" ? m : m ? "[" + [].join.call(m, "+") + "]" : "";
      }
      function cc(m, _, M) {
        return { name: m, primKey: _, indexes: M, mappedClass: null, idxByName: (O = function(V) {
          return [V.name, V];
        }, M.reduce(function(V, K, J) {
          return K = O(K, J), K && (V[K[0]] = K[1]), V;
        }, {})) };
        var O;
      }
      var Ao = function(m) {
        try {
          return m.only([[]]), Ao = function() {
            return [[]];
          }, [[]];
        } catch {
          return Ao = function() {
            return oo;
          }, oo;
        }
      };
      function Ya(m) {
        return m == null ? function() {
        } : typeof m == "string" ? (_ = m).split(".").length === 1 ? function(M) {
          return M[_];
        } : function(M) {
          return q(M, _);
        } : function(M) {
          return q(M, m);
        };
        var _;
      }
      function pd(m) {
        return [].slice.call(m);
      }
      var Kf = 0;
      function ya(m) {
        return m == null ? ":id" : typeof m == "string" ? m : "[".concat(m.join("+"), "]");
      }
      function uo(m, _, J) {
        function O(we) {
          if (we.type === 3) return null;
          if (we.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
          var ve = we.lower, ge = we.upper, Se = we.lowerOpen, we = we.upperOpen;
          return ve === void 0 ? ge === void 0 ? null : _.upperBound(ge, !!we) : ge === void 0 ? _.lowerBound(ve, !!Se) : _.bound(ve, ge, !!Se, !!we);
        }
        function V(fe) {
          var ve, ge, Se = fe.name;
          return { name: Se, schema: fe, mutate: function(we) {
            var Te = we.trans, Ne = we.type, Be = we.keys, Je = we.values, nt = we.range;
            return new Promise(function(lt, tt) {
              lt = Ge(lt);
              var pt = Te.objectStore(Se), it = pt.keyPath == null, Mt = Ne === "put" || Ne === "add";
              if (!Mt && Ne !== "delete" && Ne !== "deleteRange") throw new Error("Invalid operation type: " + Ne);
              var De, ht = (Be || Je || { length: 1 }).length;
              if (Be && Je && Be.length !== Je.length) throw new Error("Given keys array must have same length as given values array.");
              if (ht === 0) return lt({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });
              function mt(Ke) {
                ++xa, rs(Ke);
              }
              var Ot = [], tn = [], xa = 0;
              if (Ne === "deleteRange") {
                if (nt.type === 4) return lt({ numFailures: xa, failures: tn, results: [], lastResult: void 0 });
                nt.type === 3 ? Ot.push(De = pt.clear()) : Ot.push(De = pt.delete(O(nt)));
              } else {
                var it = Mt ? it ? [Je, Be] : [Je, null] : [Be, null], un = it[0], Jr = it[1];
                if (Mt) for (var $r = 0; $r < ht; ++$r) Ot.push(De = Jr && Jr[$r] !== void 0 ? pt[Ne](un[$r], Jr[$r]) : pt[Ne](un[$r])), De.onerror = mt;
                else for ($r = 0; $r < ht; ++$r) Ot.push(De = pt[Ne](un[$r])), De.onerror = mt;
              }
              function Zi(Ke) {
                Ke = Ke.target.result, Ot.forEach(function(rr, jt) {
                  return rr.error != null && (tn[jt] = rr.error);
                }), lt({ numFailures: xa, failures: tn, results: Ne === "delete" ? Be : Ot.map(function(rr) {
                  return rr.result;
                }), lastResult: Ke });
              }
              De.onerror = function(Ke) {
                mt(Ke), Zi(Ke);
              }, De.onsuccess = Zi;
            });
          }, getMany: function(we) {
            var Te = we.trans, Ne = we.keys;
            return new Promise(function(Be, Je) {
              Be = Ge(Be);
              for (var nt, lt = Te.objectStore(Se), tt = Ne.length, pt = new Array(tt), it = 0, Mt = 0, De = function(Ot) {
                Ot = Ot.target, pt[Ot._pos] = Ot.result, ++Mt === it && Be(pt);
              }, ht = di(Je), mt = 0; mt < tt; ++mt) Ne[mt] != null && ((nt = lt.get(Ne[mt]))._pos = mt, nt.onsuccess = De, nt.onerror = ht, ++it);
              it === 0 && Be(pt);
            });
          }, get: function(we) {
            var Te = we.trans, Ne = we.key;
            return new Promise(function(Be, Je) {
              Be = Ge(Be);
              var nt = Te.objectStore(Se).get(Ne);
              nt.onsuccess = function(lt) {
                return Be(lt.target.result);
              }, nt.onerror = di(Je);
            });
          }, query: (ve = be, ge = ke, function(we) {
            return new Promise(function(Te, Ne) {
              Te = Ge(Te);
              var Be, Je, nt, lt, ht = we.trans, tt = we.values, pt = we.limit, De = we.query, it = (it = we.direction) != null ? it : "next", Mt = pt === 1 / 0 ? void 0 : pt, mt = De.index, De = De.range, ht = ht.objectStore(Se), ht = mt.isPrimaryKey ? ht : ht.index(mt.name), mt = O(De);
              if (pt === 0) return Te({ result: [] });
              ge ? (De = { query: mt, count: Mt, direction: it }, (Be = tt ? ht.getAll(De) : ht.getAllKeys(De)).onsuccess = function(Ot) {
                return Te({ result: Ot.target.result });
              }, Be.onerror = di(Ne)) : ve && it === "next" ? ((Be = tt ? ht.getAll(mt, Mt) : ht.getAllKeys(mt, Mt)).onsuccess = function(Ot) {
                return Te({ result: Ot.target.result });
              }, Be.onerror = di(Ne)) : (Je = 0, nt = !tt && "openKeyCursor" in ht ? ht.openKeyCursor(mt, it) : ht.openCursor(mt, it), lt = [], nt.onsuccess = function() {
                var Ot = nt.result;
                return !Ot || (lt.push(tt ? Ot.value : Ot.primaryKey), ++Je === pt) ? Te({ result: lt }) : void Ot.continue();
              }, nt.onerror = di(Ne));
            });
          }), openCursor: function(we) {
            var Te = we.trans, Ne = we.values, Be = we.query, Je = we.reverse, nt = we.unique;
            return new Promise(function(lt, tt) {
              lt = Ge(lt);
              var Mt = Be.index, pt = Be.range, it = Te.objectStore(Se), it = Mt.isPrimaryKey ? it : it.index(Mt.name), Mt = Je ? nt ? "prevunique" : "prev" : nt ? "nextunique" : "next", De = !Ne && "openKeyCursor" in it ? it.openKeyCursor(O(pt), Mt) : it.openCursor(O(pt), Mt);
              De.onerror = di(tt), De.onsuccess = Ge(function(ht) {
                var mt, Ot, tn, xa, un = De.result;
                un ? (un.___id = ++Kf, un.done = !1, mt = un.continue.bind(un), Ot = (Ot = un.continuePrimaryKey) && Ot.bind(un), tn = un.advance.bind(un), xa = function() {
                  throw new Error("Cursor not stopped");
                }, un.trans = Te, un.stop = un.continue = un.continuePrimaryKey = un.advance = function() {
                  throw new Error("Cursor not started");
                }, un.fail = Ge(tt), un.next = function() {
                  var Jr = this, $r = 1;
                  return this.start(function() {
                    return $r-- ? Jr.continue() : Jr.stop();
                  }).then(function() {
                    return Jr;
                  });
                }, un.start = function(Jr) {
                  function $r() {
                    if (De.result) try {
                      Jr();
                    } catch (Ke) {
                      un.fail(Ke);
                    }
                    else un.done = !0, un.start = function() {
                      throw new Error("Cursor behind last entry");
                    }, un.stop();
                  }
                  var Zi = new Promise(function(Ke, rr) {
                    Ke = Ge(Ke), De.onerror = di(rr), un.fail = rr, un.stop = function(jt) {
                      un.stop = un.continue = un.continuePrimaryKey = un.advance = xa, Ke(jt);
                    };
                  });
                  return De.onsuccess = Ge(function(Ke) {
                    De.onsuccess = $r, $r();
                  }), un.continue = mt, un.continuePrimaryKey = Ot, un.advance = tn, $r(), Zi;
                }, lt(un)) : lt(null);
              }, tt);
            });
          }, count: function(we) {
            var Te = we.query, Ne = we.trans, Be = Te.index, Je = Te.range;
            return new Promise(function(nt, lt) {
              var tt = Ne.objectStore(Se), tt = Be.isPrimaryKey ? tt : tt.index(Be.name), pt = O(Je), pt = pt ? tt.count(pt) : tt.count();
              pt.onsuccess = Ge(function(it) {
                return nt(it.target.result);
              }), pt.onerror = di(lt);
            });
          } };
        }
        K = J, re = pd((J = m).objectStoreNames), _e = 0 < re.length ? K.objectStore(re[0]) : {};
        var K, J = { schema: { name: J.name, tables: re.map(function(fe) {
          return K.objectStore(fe);
        }).map(function(fe) {
          var ve = fe.keyPath, ge = fe.autoIncrement, we = f(ve), Se = {}, we = { name: fe.name, primaryKey: { name: null, isPrimaryKey: !0, outbound: ve == null, compound: we, keyPath: ve, autoIncrement: ge, unique: !0, extractKey: Ya(ve) }, indexes: pd(fe.indexNames).map(function(Te) {
            return fe.index(Te);
          }).map(function(Je) {
            var nt = Je.name, Ne = Je.unique, Be = Je.multiEntry, Je = Je.keyPath, nt = { name: nt, compound: f(Je), keyPath: Je, unique: Ne, multiEntry: Be, extractKey: Ya(Je) };
            return Se[ya(Je)] = nt;
          }), getIndexByKeyPath: function(Te) {
            return Se[ya(Te)];
          } };
          return Se[":id"] = we.primaryKey, ve != null && (Se[ya(ve)] = we.primaryKey), we;
        }) }, hasGetAll: 0 < re.length && "getAll" in _e && !(typeof navigator < "u" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604), hasIdb3Features: "getAllRecords" in _e }, re = J.schema, be = J.hasGetAll, ke = J.hasIdb3Features, _e = re.tables.map(V), me = {};
        return _e.forEach(function(fe) {
          return me[fe.name] = fe;
        }), { stack: "dbcore", transaction: m.transaction.bind(m), table: function(fe) {
          if (me[fe]) return me[fe];
          throw new Error("Table '".concat(fe, "' not found"));
        }, MIN_KEY: -1 / 0, MAX_KEY: Ao(_), schema: re };
      }
      function nu(m, _, M, O) {
        return M = M.IDBKeyRange, _ = uo(_, M, O), { dbcore: m.dbcore.reduce(function(V, K) {
          return K = K.create, o(o({}, V), K(V));
        }, _) };
      }
      function As(m, _) {
        var M = _.db, M = nu(m._middlewares, M, m._deps, _);
        m.core = M.dbcore, m.tables.forEach(function(O) {
          var V = O.name;
          m.core.schema.tables.some(function(K) {
            return K.name === V;
          }) && (O.core = m.core.table(V), m[V] instanceof m.Table) && (m[V].core = O.core);
        });
      }
      function Ms(m, _, M, O) {
        M.forEach(function(V) {
          var K = O[V];
          _.forEach(function(J) {
            var re = (function be(ke, _e) {
              return z(ke, _e) || (ke = h(ke)) && be(ke, _e);
            })(J, V);
            (!re || "value" in re && re.value === void 0) && (J === m.Transaction.prototype || J instanceof m.Transaction ? T(J, V, { get: function() {
              return this.table(V);
            }, set: function(be) {
              w(this, V, { value: be, writable: !0, configurable: !0, enumerable: !0 });
            } }) : J[V] = new m.Table(V, K));
          });
        });
      }
      function ru(m, _) {
        _.forEach(function(M) {
          for (var O in M) M[O] instanceof m.Table && delete M[O];
        });
      }
      function Ki(m, _) {
        return m._cfg.version - _._cfg.version;
      }
      function Mo(m, _, M, O) {
        var V = m._dbSchema, K = (M.objectStoreNames.contains("$meta") && !V.$meta && (V.$meta = cc("$meta", ji("")[0], []), m._storeNames.push("$meta")), m._createTransaction("readwrite", m._storeNames, V)), J = (K.create(M), K._completion.catch(O), K._reject.bind(K)), re = qe.transless || qe;
        Tr(function() {
          if (qe.trans = K, qe.transless = re, _ !== 0) return As(m, M), ke = _, ((be = K).storeNames.includes("$meta") ? be.table("$meta").get("version").then(function(_e) {
            return _e ?? ke;
          }) : Xe.resolve(ke)).then(function(we) {
            var me = m, fe = we, ve = K, ge = M, Se = [], we = me._versions, Te = me._dbSchema = Ai(0, me.idbdb, ge);
            return (we = we.filter(function(Ne) {
              return Ne._cfg.version >= fe;
            })).length === 0 ? Xe.resolve() : (we.forEach(function(Ne) {
              Se.push(function() {
                var Be, Je, nt, lt = Te, tt = Ne._cfg.dbschema, pt = (Fa(me, lt, ge), Fa(me, tt, ge), Te = me._dbSchema = tt, is(lt, tt)), it = (pt.add.forEach(function(Mt) {
                  Ps(ge, Mt[0], Mt[1].primKey, Mt[1].indexes);
                }), pt.change.forEach(function(Mt) {
                  if (Mt.recreate) throw new Pe.Upgrade("Not yet support for changing primary key");
                  var De = ge.objectStore(Mt.name);
                  Mt.add.forEach(function(ht) {
                    return ba(De, ht);
                  }), Mt.change.forEach(function(ht) {
                    De.deleteIndex(ht.name), ba(De, ht);
                  }), Mt.del.forEach(function(ht) {
                    return De.deleteIndex(ht);
                  });
                }), Ne._cfg.contentUpgrade);
                if (it && Ne._cfg.version > fe) return As(me, ge), ve._memoizedTables = {}, Be = I(tt), pt.del.forEach(function(Mt) {
                  Be[Mt] = lt[Mt];
                }), ru(me, [me.Transaction.prototype]), Ms(me, [me.Transaction.prototype], d(Be), Be), ve.schema = Be, (Je = oe(it)) && Nr(), tt = Xe.follow(function() {
                  var Mt;
                  (nt = it(ve)) && Je && (Mt = vr.bind(null, null), nt.then(Mt, Mt));
                }), nt && typeof nt.then == "function" ? Xe.resolve(nt) : tt.then(function() {
                  return nt;
                });
              }), Se.push(function(Be) {
                var Je, nt, lt = Ne._cfg.dbschema;
                Je = lt, nt = Be, [].slice.call(nt.db.objectStoreNames).forEach(function(tt) {
                  return Je[tt] == null && nt.db.deleteObjectStore(tt);
                }), ru(me, [me.Transaction.prototype]), Ms(me, [me.Transaction.prototype], me._storeNames, me._dbSchema), ve.schema = me._dbSchema;
              }), Se.push(function(Be) {
                me.idbdb.objectStoreNames.contains("$meta") && (Math.ceil(me.idbdb.version / 10) === Ne._cfg.version ? (me.idbdb.deleteObjectStore("$meta"), delete me._dbSchema.$meta, me._storeNames = me._storeNames.filter(function(Je) {
                  return Je !== "$meta";
                })) : Be.objectStore("$meta").put(Ne._cfg.version, "version"));
              });
            }), (function Ne() {
              return Se.length ? Xe.resolve(Se.shift()(ve.idbtrans)).then(Ne) : Xe.resolve();
            })().then(function() {
              Za(Te, ge);
            }));
          }).catch(J);
          var be, ke;
          d(V).forEach(function(_e) {
            Ps(M, _e, V[_e].primKey, V[_e].indexes);
          }), As(m, M), Xe.follow(function() {
            return m.on.populate.fire(K);
          }).catch(J);
        });
      }
      function as(m, _) {
        Za(m._dbSchema, _), _.db.version % 10 != 0 || _.objectStoreNames.contains("$meta") || _.db.createObjectStore("$meta").add(Math.ceil(_.db.version / 10 - 1), "version");
        var M = Ai(0, m.idbdb, _);
        Fa(m, m._dbSchema, _);
        for (var O = 0, V = is(M, m._dbSchema).change; O < V.length; O++) {
          var K = ((J) => {
            if (J.change.length || J.recreate) return console.warn("Unable to patch indexes of table ".concat(J.name, " because it has changes on the type of index or primary key.")), { value: void 0 };
            var re = _.objectStore(J.name);
            J.add.forEach(function(be) {
              gn && console.debug("Dexie upgrade patch: Creating missing index ".concat(J.name, ".").concat(be.src)), ba(re, be);
            });
          })(V[O]);
          if (typeof K == "object") return K.value;
        }
      }
      function is(m, _) {
        var M, O = { del: [], add: [], change: [] };
        for (M in m) _[M] || O.del.push(M);
        for (M in _) {
          var V = m[M], K = _[M];
          if (V) {
            var J = { name: M, def: K, recreate: !1, del: [], add: [], change: [] };
            if ("" + (V.primKey.keyPath || "") != "" + (K.primKey.keyPath || "") || V.primKey.auto !== K.primKey.auto) J.recreate = !0, O.change.push(J);
            else {
              var re = V.idxByName, be = K.idxByName, ke = void 0;
              for (ke in re) be[ke] || J.del.push(ke);
              for (ke in be) {
                var _e = re[ke], me = be[ke];
                _e ? _e.src !== me.src && J.change.push(me) : J.add.push(me);
              }
              (0 < J.del.length || 0 < J.add.length || 0 < J.change.length) && O.change.push(J);
            }
          } else O.add.push([M, K]);
        }
        return O;
      }
      function Ps(m, _, M, O) {
        var V = m.db.createObjectStore(_, M.keyPath ? { keyPath: M.keyPath, autoIncrement: M.auto } : { autoIncrement: M.auto });
        O.forEach(function(K) {
          return ba(V, K);
        });
      }
      function Za(m, _) {
        d(m).forEach(function(M) {
          _.db.objectStoreNames.contains(M) || (gn && console.debug("Dexie: Creating missing table", M), Ps(_, M, m[M].primKey, m[M].indexes));
        });
      }
      function ba(m, _) {
        m.createIndex(_.name, _.keyPath, { unique: _.unique, multiEntry: _.multi });
      }
      function Ai(m, _, M) {
        var O = {};
        return x(_.objectStoreNames, 0).forEach(function(V) {
          for (var K = M.objectStore(V), J = uc(tu(ke = K.keyPath), ke || "", !0, !1, !!K.autoIncrement, ke && typeof ke != "string", !0), re = [], be = 0; be < K.indexNames.length; ++be) {
            var _e = K.index(K.indexNames[be]), ke = _e.keyPath, _e = uc(_e.name, ke, !!_e.unique, !!_e.multiEntry, !1, ke && typeof ke != "string", !1);
            re.push(_e);
          }
          O[V] = cc(V, J, re);
        }), O;
      }
      function Fa(m, _, M) {
        for (var O = M.db.objectStoreNames, V = 0; V < O.length; ++V) {
          var K = O[V], J = M.objectStore(K);
          m._hasGetAll = "getAll" in J;
          for (var re = 0; re < J.indexNames.length; ++re) {
            var be, ke = J.indexNames[re], _e = J.index(ke).keyPath, _e = typeof _e == "string" ? _e : "[" + x(_e).join("+") + "]";
            _[K] && (be = _[K].idxByName[_e]) && (be.name = ke, delete _[K].idxByName[_e], _[K].idxByName[ke] = be);
          }
        }
        typeof navigator < "u" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && u.WorkerGlobalScope && u instanceof u.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (m._hasGetAll = !1);
      }
      function ji(m) {
        return m.split(",").map(function(_, M) {
          var V = _.split(":"), O = (O = V[1]) == null ? void 0 : O.trim(), V = (_ = V[0].trim()).replace(/([&*]|\+\+)/g, ""), K = /^\[/.test(V) ? V.match(/^\[(.*)\]$/)[1].split("+") : V;
          return uc(V, K || null, /\&/.test(_), /\*/.test(_), /\+\+/.test(_), f(K), M === 0, O);
        });
      }
      Yi.prototype._createTableSchema = cc, Yi.prototype._parseIndexSyntax = ji, Yi.prototype._parseStoresSpec = function(m, _) {
        var M = this;
        d(m).forEach(function(O) {
          if (m[O] !== null) {
            var V = M._parseIndexSyntax(m[O]), K = V.shift();
            if (!K) throw new Pe.Schema("Invalid schema for table " + O + ": " + m[O]);
            if (K.unique = !0, K.multi) throw new Pe.Schema("Primary key cannot be multiEntry*");
            V.forEach(function(J) {
              if (J.auto) throw new Pe.Schema("Only primary key can be marked as autoIncrement (++)");
              if (!J.keyPath) throw new Pe.Schema("Index must have a name and cannot be an empty string");
            }), K = M._createTableSchema(O, K, V), _[O] = K;
          }
        });
      }, Yi.prototype.stores = function(M) {
        var _ = this.db, M = (this._cfg.storesSource = this._cfg.storesSource ? g(this._cfg.storesSource, M) : M, _._versions), O = {}, V = {};
        return M.forEach(function(K) {
          g(O, K._cfg.storesSource), V = K._cfg.dbschema = {}, K._parseStoresSpec(O, V);
        }), _._dbSchema = V, ru(_, [_._allTables, _, _.Transaction.prototype]), Ms(_, [_._allTables, _, _.Transaction.prototype, this._cfg.tables], d(V), V), _._storeNames = d(V), this;
      }, Yi.prototype.upgrade = function(m) {
        return this._cfg.contentUpgrade = Pn(this._cfg.contentUpgrade || st, m), this;
      };
      var os = Yi;
      function Yi() {
      }
      var ss = (() => {
        var m, _, M;
        return typeof FinalizationRegistry < "u" && typeof WeakRef < "u" ? (m = /* @__PURE__ */ new Set(), _ = new FinalizationRegistry(function(O) {
          m.delete(O);
        }), { toArray: function() {
          return Array.from(m).map(function(O) {
            return O.deref();
          }).filter(function(O) {
            return O !== void 0;
          });
        }, add: function(O) {
          var V = new WeakRef(O._novip);
          m.add(V), _.register(O._novip, V, V), m.size > O._options.maxConnections && (V = m.values().next().value, m.delete(V), _.unregister(V));
        }, remove: function(O) {
          if (O) for (var V = m.values(), K = V.next(); !K.done; ) {
            var J = K.value;
            if (J.deref() === O._novip) return m.delete(J), void _.unregister(J);
            K = V.next();
          }
        } }) : (M = [], { toArray: function() {
          return M;
        }, add: function(O) {
          M.push(O._novip);
        }, remove: function(O) {
          O && (O = M.indexOf(O._novip)) !== -1 && M.splice(O, 1);
        } });
      })();
      function _l(m, _) {
        var M = m._dbNamesDB;
        return M || (M = m._dbNamesDB = new Ur(qi, { addons: [], indexedDB: m, IDBKeyRange: _ })).version(1).stores({ dbnames: "name" }), M.table("dbnames");
      }
      function _a(m) {
        return m && typeof m.databases == "function";
      }
      function za(m) {
        return Tr(function() {
          return qe.letThrough = !0, m();
        });
      }
      function sr(m) {
        return !("from" in m);
      }
      var Cr = function(m, _) {
        var M;
        if (!this) return M = new Cr(), m && "d" in m && g(M, m), M;
        g(this, arguments.length ? { d: 1, from: m, to: 1 < arguments.length ? _ : m } : { d: 0 });
      };
      function Sa(m, _, M) {
        var O = It(_, M);
        if (!isNaN(O)) {
          if (0 < O) throw RangeError();
          if (sr(m)) return g(m, { from: _, to: M, d: 1 });
          var O = m.l, V = m.r;
          if (It(M, m.from) < 0) return O ? Sa(O, _, M) : m.l = { from: _, to: M, d: 1, l: null, r: null }, au(m);
          if (0 < It(_, m.to)) return V ? Sa(V, _, M) : m.r = { from: _, to: M, d: 1, l: null, r: null }, au(m);
          It(_, m.from) < 0 && (m.from = _, m.l = null, m.d = V ? V.d + 1 : 1), 0 < It(M, m.to) && (m.to = M, m.r = null, m.d = m.l ? m.l.d + 1 : 1), _ = !m.r, O && !m.l && Ds(m, O), V && _ && Ds(m, V);
        }
      }
      function Ds(m, _) {
        sr(_) || (function M(O, V) {
          var K = V.from, J = V.l, re = V.r;
          Sa(O, K, V.to), J && M(O, J), re && M(O, re);
        })(m, _);
      }
      function dc(m, _) {
        var M = Ls(_), O = M.next();
        if (!O.done) for (var V = O.value, K = Ls(m), J = K.next(V.from), re = J.value; !O.done && !J.done; ) {
          if (It(re.from, V.to) <= 0 && 0 <= It(re.to, V.from)) return !0;
          It(V.from, re.from) < 0 ? V = (O = M.next(re.from)).value : re = (J = K.next(V.from)).value;
        }
        return !1;
      }
      function Ls(m) {
        var _ = sr(m) ? null : { s: 0, n: m };
        return { next: function(M) {
          for (var O = 0 < arguments.length; _; ) switch (_.s) {
            case 0:
              if (_.s = 1, O) for (; _.n.l && It(M, _.n.from) < 0; ) _ = { up: _, n: _.n.l, s: 1 };
              else for (; _.n.l; ) _ = { up: _, n: _.n.l, s: 1 };
            case 1:
              if (_.s = 2, !O || It(M, _.n.to) <= 0) return { value: _.n, done: !1 };
            case 2:
              if (_.n.r) {
                _.s = 3, _ = { up: _, n: _.n.r, s: 0 };
                continue;
              }
            case 3:
              _ = _.up;
          }
          return { done: !0 };
        } };
      }
      function au(m) {
        var _, M, O, V = (((V = m.r) == null ? void 0 : V.d) || 0) - (((V = m.l) == null ? void 0 : V.d) || 0), V = 1 < V ? "r" : V < -1 ? "l" : "";
        V && (_ = V == "r" ? "l" : "r", M = o({}, m), O = m[V], m.from = O.from, m.to = O.to, m[V] = O[V], M[V] = O[_], (m[_] = M).d = fc(M)), m.d = fc(m);
      }
      function fc(M) {
        var _ = M.r, M = M.l;
        return (_ ? M ? Math.max(_.d, M.d) : _.d : M ? M.d : 0) + 1;
      }
      function ls(m, _) {
        return d(_).forEach(function(M) {
          m[M] ? Ds(m[M], _[M]) : m[M] = (function O(V) {
            var K, J, re = {};
            for (K in V) E(V, K) && (J = V[K], re[K] = !J || typeof J != "object" || Z.has(J.constructor) ? J : O(J));
            return re;
          })(_[M]);
        }), m;
      }
      function iu(m, _) {
        return m.all || _.all || Object.keys(m).some(function(M) {
          return _[M] && dc(_[M], m[M]);
        });
      }
      S(Cr.prototype, ((ln = { add: function(m) {
        return Ds(this, m), this;
      }, addKey: function(m) {
        return Sa(this, m, m), this;
      }, addKeys: function(m) {
        var _ = this;
        return m.forEach(function(M) {
          return Sa(_, M, M);
        }), this;
      }, hasKey: function(m) {
        var _ = Ls(this).next(m).value;
        return _ && It(_.from, m) <= 0 && 0 <= It(_.to, m);
      } })[ze] = function() {
        return Ls(this);
      }, ln));
      var hi = {}, Sl = {}, hc = !1;
      function us(m) {
        ls(Sl, m), hc || (hc = !0, setTimeout(function() {
          hc = !1, pc(Sl, !(Sl = {}));
        }, 0));
      }
      function pc(m, _) {
        _ === void 0 && (_ = !1);
        var M = /* @__PURE__ */ new Set();
        if (m.all) for (var O = 0, V = Object.values(hi); O < V.length; O++) Os(re = V[O], m, M, _);
        else for (var K in m) {
          var J, re, K = /^idb\:\/\/(.*)\/(.*)\//.exec(K);
          K && (J = K[1], K = K[2], re = hi["idb://".concat(J, "/").concat(K)]) && Os(re, m, M, _);
        }
        M.forEach(function(be) {
          return be();
        });
      }
      function Os(m, _, M, O) {
        for (var V = [], K = 0, J = Object.entries(m.queries.query); K < J.length; K++) {
          for (var re = J[K], be = re[0], ke = [], _e = 0, me = re[1]; _e < me.length; _e++) {
            var fe = me[_e];
            iu(_, fe.obsSet) ? fe.subscribers.forEach(function(we) {
              return M.add(we);
            }) : O && ke.push(fe);
          }
          O && V.push([be, ke]);
        }
        if (O) for (var ve = 0, ge = V; ve < ge.length; ve++) {
          var Se = ge[ve], be = Se[0], ke = Se[1];
          m.queries.query[be] = ke;
        }
      }
      function ou(m) {
        var _ = m._state, M = m._deps.indexedDB;
        if (_.isBeingOpened || m.idbdb) return _.dbReadyPromise.then(function() {
          return _.dbOpenError ? yr(_.dbOpenError) : m;
        });
        _.isBeingOpened = !0, _.dbOpenError = null, _.openComplete = !1;
        var O = _.openCanceller, V = Math.round(10 * m.verno), K = !1;
        function J() {
          if (_.openCanceller !== O) throw new Pe.DatabaseClosed("db.open() was cancelled");
        }
        function re() {
          return new Xe(function(fe, ve) {
            if (J(), !M) throw new Pe.MissingAPI();
            var ge = m.name, Se = _.autoSchema || !V ? M.open(ge) : M.open(ge, V);
            if (!Se) throw new Pe.MissingAPI();
            Se.onerror = di(ve), Se.onblocked = Ge(m._fireOnBlocked), Se.onupgradeneeded = Ge(function(we) {
              var Te;
              _e = Se.transaction, _.autoSchema && !m._options.allowEmptyDB ? (Se.onerror = rs, _e.abort(), Se.result.close(), (Te = M.deleteDatabase(ge)).onsuccess = Te.onerror = Ge(function() {
                ve(new Pe.NoSuchDatabase("Database ".concat(ge, " doesnt exist")));
              })) : (_e.onerror = di(ve), Te = we.oldVersion > Math.pow(2, 62) ? 0 : we.oldVersion, me = Te < 1, m.idbdb = Se.result, K && as(m, _e), Mo(m, Te / 10, _e, ve));
            }, ve), Se.onsuccess = Ge(function() {
              _e = null;
              var we, Te, Ne, Be, Je, nt, lt = m.idbdb = Se.result, tt = x(lt.objectStoreNames);
              if (0 < tt.length) try {
                var pt = lt.transaction((Je = tt).length === 1 ? Je[0] : Je, "readonly");
                if (_.autoSchema) nt = lt, Be = pt, (Ne = m).verno = nt.version / 10, Be = Ne._dbSchema = Ai(0, nt, Be), Ne._storeNames = x(nt.objectStoreNames, 0), Ms(Ne, [Ne._allTables], d(Be), Be);
                else if (Fa(m, m._dbSchema, pt), Te = pt, ((Te = is(Ai(0, (we = m).idbdb, Te), we._dbSchema)).add.length || Te.change.some(function(it) {
                  return it.add.length || it.change.length;
                })) && !K) return console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this."), lt.close(), V = lt.version + 1, K = !0, fe(re());
                As(m, pt);
              } catch {
              }
              ss.add(m), lt.onversionchange = Ge(function(it) {
                _.vcFired = !0, m.on("versionchange").fire(it);
              }), lt.onclose = Ge(function() {
                m.close({ disableAutoOpen: !1 });
              }), me && (tt = m._deps, Je = ge, _a(nt = tt.indexedDB) || Je === qi || _l(nt, tt.IDBKeyRange).put({ name: Je }).catch(st)), fe();
            }, ve);
          }).catch(function(fe) {
            switch (fe == null ? void 0 : fe.name) {
              case "UnknownError":
                if (0 < _.PR1398_maxLoop) return _.PR1398_maxLoop--, console.warn("Dexie: Workaround for Chrome UnknownError on open()"), re();
                break;
              case "VersionError":
                if (0 < V) return V = 0, re();
            }
            return Xe.reject(fe);
          });
        }
        var be, ke = _.dbReadyResolve, _e = null, me = !1;
        return Xe.race([O, (typeof navigator > "u" ? Xe.resolve() : !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function(fe) {
          function ve() {
            return indexedDB.databases().finally(fe);
          }
          be = setInterval(ve, 100), ve();
        }).finally(function() {
          return clearInterval(be);
        }) : Promise.resolve()).then(re)]).then(function() {
          return J(), _.onReadyBeingFired = [], Xe.resolve(za(function() {
            return m.on.ready.fire(m.vip);
          })).then(function fe() {
            var ve;
            if (0 < _.onReadyBeingFired.length) return ve = _.onReadyBeingFired.reduce(Pn, st), _.onReadyBeingFired = [], Xe.resolve(za(function() {
              return ve(m.vip);
            })).then(fe);
          });
        }).finally(function() {
          _.openCanceller === O && (_.onReadyBeingFired = null, _.isBeingOpened = !1);
        }).catch(function(fe) {
          _.dbOpenError = fe;
          try {
            _e && _e.abort();
          } catch {
          }
          return O === _.openCanceller && m._close(), yr(fe);
        }).finally(function() {
          _.openComplete = !0, ke();
        }).then(function() {
          var fe;
          return me && (fe = {}, m.tables.forEach(function(ve) {
            ve.schema.indexes.forEach(function(ge) {
              ge.name && (fe["idb://".concat(m.name, "/").concat(ve.name, "/").concat(ge.name)] = new Cr(-1 / 0, [[[]]]));
            }), fe["idb://".concat(m.name, "/").concat(ve.name, "/")] = fe["idb://".concat(m.name, "/").concat(ve.name, "/:dels")] = new Cr(-1 / 0, [[[]]]);
          }), No(bl).fire(fe), pc(fe, !0)), m;
        });
      }
      function su(m) {
        function _(K) {
          return m.next(K);
        }
        var M = V(_), O = V(function(K) {
          return m.throw(K);
        });
        function V(K) {
          return function(re) {
            var re = K(re), be = re.value;
            return re.done ? be : be && typeof be.then == "function" ? be.then(M, O) : f(be) ? Promise.all(be).then(M, O) : M(be);
          };
        }
        return V(_)();
      }
      function wl(m, _, M) {
        for (var O = f(m) ? m.slice() : [m], V = 0; V < M; ++V) O.push(_);
        return O;
      }
      var Fs = { stack: "dbcore", name: "VirtualIndexMiddleware", level: 1, create: function(m) {
        return o(o({}, m), { table: function(O) {
          var M = m.table(O), O = M.schema, V = {}, K = [];
          function J(fe, ve, ge) {
            var Ne = ya(fe), Se = V[Ne] = V[Ne] || [], we = fe == null ? 0 : typeof fe == "string" ? 1 : fe.length, Te = 0 < ve, Ne = o(o({}, ge), { name: Te ? "".concat(Ne, "(virtual-from:").concat(ge.name, ")") : ge.name, lowLevelIndex: ge, isVirtual: Te, keyTail: ve, keyLength: we, extractKey: Ya(fe), unique: !Te && ge.unique });
            return Se.push(Ne), Ne.isPrimaryKey || K.push(Ne), 1 < we && J(we === 2 ? fe[0] : fe.slice(0, we - 1), ve + 1, ge), Se.sort(function(Be, Je) {
              return Be.keyTail - Je.keyTail;
            }), Ne;
          }
          var re = J(O.primaryKey.keyPath, 0, O.primaryKey);
          V[":id"] = [re];
          for (var be = 0, ke = O.indexes; be < ke.length; be++) {
            var _e = ke[be];
            J(_e.keyPath, 0, _e);
          }
          function me(fe) {
            var ve, ge = fe.query.index;
            return ge.isVirtual ? o(o({}, fe), { query: { index: ge.lowLevelIndex, range: (ve = fe.query.range, ge = ge.keyTail, { type: ve.type === 1 ? 2 : ve.type, lower: wl(ve.lower, ve.lowerOpen ? m.MAX_KEY : m.MIN_KEY, ge), lowerOpen: !0, upper: wl(ve.upper, ve.upperOpen ? m.MIN_KEY : m.MAX_KEY, ge), upperOpen: !0 }) } }) : fe;
          }
          return o(o({}, M), { schema: o(o({}, O), { primaryKey: re, indexes: K, getIndexByKeyPath: function(fe) {
            return (fe = V[ya(fe)]) && fe[0];
          } }), count: function(fe) {
            return M.count(me(fe));
          }, query: function(fe) {
            return M.query(me(fe));
          }, openCursor: function(fe) {
            var ve = fe.query.index, ge = ve.keyTail, Se = ve.keyLength;
            return ve.isVirtual ? M.openCursor(me(fe)).then(function(Te) {
              return Te && we(Te);
            }) : M.openCursor(fe);
            function we(Te) {
              return Object.create(Te, { continue: { value: function(Ne) {
                Ne != null ? Te.continue(wl(Ne, fe.reverse ? m.MAX_KEY : m.MIN_KEY, ge)) : fe.unique ? Te.continue(Te.key.slice(0, Se).concat(fe.reverse ? m.MIN_KEY : m.MAX_KEY, ge)) : Te.continue();
              } }, continuePrimaryKey: { value: function(Ne, Be) {
                Te.continuePrimaryKey(wl(Ne, m.MAX_KEY, ge), Be);
              } }, primaryKey: { get: function() {
                return Te.primaryKey;
              } }, key: { get: function() {
                var Ne = Te.key;
                return Se === 1 ? Ne[0] : Ne.slice(0, Se);
              } }, value: { get: function() {
                return Te.value;
              } } });
            }
          } });
        } });
      } };
      function lu(m, _, M, O) {
        return M = M || {}, O = O || "", d(m).forEach(function(V) {
          var K, J, re;
          E(_, V) ? (K = m[V], J = _[V], typeof K == "object" && typeof J == "object" && K && J ? (re = ce(K)) !== ce(J) ? M[O + V] = _[V] : re === "Object" ? lu(K, J, M, O + V + ".") : K !== J && (M[O + V] = _[V]) : K !== J && (M[O + V] = _[V])) : M[O + V] = void 0;
        }), d(_).forEach(function(V) {
          E(m, V) || (M[O + V] = _[V]);
        }), M;
      }
      function zs(m, _) {
        return _.type === "delete" ? _.keys : _.keys || _.values.map(m.extractKey);
      }
      var uu = { stack: "dbcore", name: "HooksMiddleware", level: 2, create: function(m) {
        return o(o({}, m), { table: function(_) {
          var M = m.table(_), O = M.schema.primaryKey;
          return o(o({}, M), { mutate: function(V) {
            var K = qe.trans, J = K.table(_).hook, re = J.deleting, be = J.creating, ke = J.updating;
            switch (V.type) {
              case "add":
                if (be.fire === st) break;
                return K._promise("readwrite", function() {
                  return _e(V);
                }, !0);
              case "put":
                if (be.fire === st && ke.fire === st) break;
                return K._promise("readwrite", function() {
                  return _e(V);
                }, !0);
              case "delete":
                if (re.fire === st) break;
                return K._promise("readwrite", function() {
                  return _e(V);
                }, !0);
              case "deleteRange":
                if (re.fire === st) break;
                return K._promise("readwrite", function() {
                  return (function me(fe, ve, ge) {
                    return M.query({ trans: fe, values: !1, query: { index: O, range: ve }, limit: ge }).then(function(Se) {
                      var we = Se.result;
                      return _e({ type: "delete", keys: we, trans: fe }).then(function(Te) {
                        return 0 < Te.numFailures ? Promise.reject(Te.failures[0]) : we.length < ge ? { failures: [], numFailures: 0, lastResult: void 0 } : me(fe, o(o({}, ve), { lower: we[we.length - 1], lowerOpen: !0 }), ge);
                      });
                    });
                  })(V.trans, V.range, 1e4);
                }, !0);
            }
            return M.mutate(V);
            function _e(me) {
              var fe, ve, ge, Se = qe.trans, we = me.keys || zs(O, me);
              if (we) return (me = me.type === "add" || me.type === "put" ? o(o({}, me), { keys: we }) : o({}, me)).type !== "delete" && (me.values = l([], me.values)), me.keys && (me.keys = l([], me.keys)), fe = M, ge = we, ((ve = me).type === "add" ? Promise.resolve([]) : fe.getMany({ trans: ve.trans, keys: ge, cache: "immutable" })).then(function(Te) {
                var Ne = we.map(function(Be, Je) {
                  var nt, lt, tt, pt = Te[Je], it = { onerror: null, onsuccess: null };
                  return me.type === "delete" ? re.fire.call(it, Be, pt, Se) : me.type === "add" || pt === void 0 ? (nt = be.fire.call(it, Be, me.values[Je], Se), Be == null && nt != null && (me.keys[Je] = Be = nt, O.outbound || X(me.values[Je], O.keyPath, Be))) : (nt = lu(pt, me.values[Je]), (lt = ke.fire.call(it, nt, Be, pt, Se)) && (tt = me.values[Je], Object.keys(lt).forEach(function(Mt) {
                    E(tt, Mt) ? tt[Mt] = lt[Mt] : X(tt, Mt, lt[Mt]);
                  }))), it;
                });
                return M.mutate(me).then(function(Be) {
                  for (var Je = Be.failures, nt = Be.results, lt = Be.numFailures, Be = Be.lastResult, tt = 0; tt < we.length; ++tt) {
                    var pt = (nt || we)[tt], it = Ne[tt];
                    pt == null ? it.onerror && it.onerror(Je[tt]) : it.onsuccess && it.onsuccess(me.type === "put" && Te[tt] ? me.values[tt] : pt);
                  }
                  return { failures: Je, results: nt, numFailures: lt, lastResult: Be };
                }).catch(function(Be) {
                  return Ne.forEach(function(Je) {
                    return Je.onerror && Je.onerror(Be);
                  }), Promise.reject(Be);
                });
              });
              throw new Error("Keys missing");
            }
          } });
        } });
      } };
      function Mi(m, _, M) {
        try {
          if (!_ || _.keys.length < m.length) return null;
          for (var O = [], V = 0, K = 0; V < _.keys.length && K < m.length; ++V) It(_.keys[V], m[K]) === 0 && (O.push(M ? ie(_.values[V]) : _.values[V]), ++K);
          return O.length === m.length ? O : null;
        } catch {
          return null;
        }
      }
      var cu = { stack: "dbcore", level: -1, create: function(m) {
        return { table: function(_) {
          var M = m.table(_);
          return o(o({}, M), { getMany: function(O) {
            var V;
            return O.cache ? (V = Mi(O.keys, O.trans._cache, O.cache === "clone")) ? Xe.resolve(V) : M.getMany(O).then(function(K) {
              return O.trans._cache = { keys: O.keys, values: O.cache === "clone" ? ie(K) : K }, K;
            }) : M.getMany(O);
          }, mutate: function(O) {
            return O.type !== "add" && (O.trans._cache = null), M.mutate(O);
          } });
        } };
      } };
      function xl(m, _) {
        return m.trans.mode === "readonly" && !!m.subscr && !m.trans.explicit && m.trans.db._options.cache !== "disabled" && !_.schema.primaryKey.outbound;
      }
      function du(m, _) {
        switch (m) {
          case "query":
            return _.values && !_.unique;
          case "get":
          case "getMany":
          case "count":
          case "openCursor":
            return !1;
        }
      }
      var fu = { stack: "dbcore", level: 0, name: "Observability", create: function(m) {
        var _ = m.schema.name, M = new Cr(m.MIN_KEY, m.MAX_KEY);
        return o(o({}, m), { transaction: function(O, V, K) {
          if (qe.subscr && V !== "readonly") throw new Pe.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(qe.querier));
          return m.transaction(O, V, K);
        }, table: function(O) {
          function V(we) {
            var Se, we = we.query;
            return [Se = we.index, new Cr((Se = (we = we.range).lower) != null ? Se : m.MIN_KEY, (Se = we.upper) != null ? Se : m.MAX_KEY)];
          }
          var K = m.table(O), J = K.schema, re = J.primaryKey, be = J.indexes, ke = re.extractKey, _e = re.outbound, me = re.autoIncrement && be.filter(function(ge) {
            return ge.compound && ge.keyPath.includes(re.keyPath);
          }), fe = o(o({}, K), { mutate: function(ge) {
            function Se(De) {
              return De = "idb://".concat(_, "/").concat(O, "/").concat(De), Je[De] || (Je[De] = new Cr());
            }
            var we, Te, Ne, Be = ge.trans, Je = ge.mutatedParts || (ge.mutatedParts = {}), nt = Se(""), lt = Se(":dels"), tt = ge.type, it = ge.type === "deleteRange" ? [ge.range] : ge.type === "delete" ? [ge.keys] : ge.values.length < 50 ? [zs(re, ge).filter(function(De) {
              return De;
            }), ge.values] : [], pt = it[0], it = it[1], Mt = ge.trans._cache;
            return f(pt) ? (nt.addKeys(pt), (tt = tt === "delete" || pt.length === it.length ? Mi(pt, Mt) : null) || lt.addKeys(pt), (tt || it) && (we = Se, Te = tt, Ne = it, J.indexes.forEach(function(De) {
              var ht = we(De.name || "");
              function mt(tn) {
                return tn != null ? De.extractKey(tn) : null;
              }
              function Ot(tn) {
                De.multiEntry && f(tn) ? tn.forEach(function(xa) {
                  return ht.addKey(xa);
                }) : ht.addKey(tn);
              }
              (Te || Ne).forEach(function(tn, Jr) {
                var un = Te && mt(Te[Jr]), Jr = Ne && mt(Ne[Jr]);
                It(un, Jr) !== 0 && (un != null && Ot(un), Jr != null) && Ot(Jr);
              });
            }))) : pt ? (it = { from: (Mt = pt.lower) != null ? Mt : m.MIN_KEY, to: (tt = pt.upper) != null ? tt : m.MAX_KEY }, lt.add(it), nt.add(it)) : (nt.add(M), lt.add(M), J.indexes.forEach(function(De) {
              return Se(De.name).add(M);
            })), K.mutate(ge).then(function(De) {
              return !pt || ge.type !== "add" && ge.type !== "put" || (nt.addKeys(De.results), me && me.forEach(function(ht) {
                for (var mt = ge.values.map(function(un) {
                  return ht.extractKey(un);
                }), Ot = ht.keyPath.findIndex(function(un) {
                  return un === re.keyPath;
                }), tn = 0, xa = De.results.length; tn < xa; ++tn) mt[tn][Ot] = De.results[tn];
                Se(ht.name).addKeys(mt);
              })), Be.mutatedParts = ls(Be.mutatedParts || {}, Je), De;
            });
          } }), ve = { get: function(ge) {
            return [re, new Cr(ge.key)];
          }, getMany: function(ge) {
            return [re, new Cr().addKeys(ge.keys)];
          }, count: V, query: V, openCursor: V };
          return d(ve).forEach(function(ge) {
            fe[ge] = function(Se) {
              var we = qe.subscr, Te = !!we, Ne = xl(qe, K) && du(ge, Se) ? Se.obsSet = {} : we;
              if (Te) {
                var Be, we = function(it) {
                  return it = "idb://".concat(_, "/").concat(O, "/").concat(it), Ne[it] || (Ne[it] = new Cr());
                }, Je = we(""), nt = we(":dels"), Te = ve[ge](Se), lt = Te[0], Te = Te[1];
                if ((ge === "query" && lt.isPrimaryKey && !Se.values ? nt : we(lt.name || "")).add(Te), !lt.isPrimaryKey) {
                  if (ge !== "count") return Be = ge === "query" && _e && Se.values && K.query(o(o({}, Se), { values: !1 })), K[ge].apply(this, arguments).then(function(it) {
                    if (ge === "query") {
                      if (_e && Se.values) return Be.then(function(mt) {
                        return mt = mt.result, Je.addKeys(mt), it;
                      });
                      var Mt = Se.values ? it.result.map(ke) : it.result;
                      (Se.values ? Je : nt).addKeys(Mt);
                    } else {
                      var De, ht;
                      if (ge === "openCursor") return ht = Se.values, (De = it) && Object.create(De, { key: { get: function() {
                        return nt.addKey(De.primaryKey), De.key;
                      } }, primaryKey: { get: function() {
                        var mt = De.primaryKey;
                        return nt.addKey(mt), mt;
                      } }, value: { get: function() {
                        return ht && Je.addKey(De.primaryKey), De.value;
                      } } });
                    }
                    return it;
                  });
                  nt.add(M);
                }
              }
              return K[ge].apply(this, arguments);
            };
          }), fe;
        } });
      } };
      function kl(m, _, M) {
        var O;
        return M.numFailures === 0 ? _ : _.type === "deleteRange" || (O = _.keys ? _.keys.length : "values" in _ && _.values ? _.values.length : 1, M.numFailures === O) ? null : (O = o({}, _), f(O.keys) && (O.keys = O.keys.filter(function(V, K) {
          return !(K in M.failures);
        })), "values" in O && f(O.values) && (O.values = O.values.filter(function(V, K) {
          return !(K in M.failures);
        })), O);
      }
      function co(m, _) {
        return M = m, ((O = _).lower === void 0 || (O.lowerOpen ? 0 < It(M, O.lower) : 0 <= It(M, O.lower))) && (M = m, (O = _).upper === void 0 || (O.upperOpen ? It(M, O.upper) < 0 : It(M, O.upper) <= 0));
        var M, O;
      }
      function Ba(m, _, M, O, V, K) {
        var J, re, be, ke, _e, me, fe;
        return !M || M.length === 0 || (J = _.query.index, re = J.multiEntry, be = _.query.range, ke = O.schema.primaryKey.extractKey, _e = J.extractKey, me = (J.lowLevelIndex || J).extractKey, (O = M.reduce(function(ve, ge) {
          var Se = ve, we = [];
          if (ge.type === "add" || ge.type === "put") for (var Te = new Cr(), Ne = ge.values.length - 1; 0 <= Ne; --Ne) {
            var Be, Je = ge.values[Ne], nt = ke(Je);
            !Te.hasKey(nt) && (Be = _e(Je), re && f(Be) ? Be.some(function(Mt) {
              return co(Mt, be);
            }) : co(Be, be)) && (Te.addKey(nt), we.push(Je));
          }
          switch (ge.type) {
            case "add":
              var lt = new Cr().addKeys(_.values ? ve.map(function(De) {
                return ke(De);
              }) : ve), Se = ve.concat(_.values ? we.filter(function(De) {
                return De = ke(De), !lt.hasKey(De) && (lt.addKey(De), !0);
              }) : we.map(function(De) {
                return ke(De);
              }).filter(function(De) {
                return !lt.hasKey(De) && (lt.addKey(De), !0);
              }));
              break;
            case "put":
              var tt = new Cr().addKeys(ge.values.map(function(De) {
                return ke(De);
              }));
              Se = ve.filter(function(De) {
                return !tt.hasKey(_.values ? ke(De) : De);
              }).concat(_.values ? we : we.map(function(De) {
                return ke(De);
              }));
              break;
            case "delete":
              var pt = new Cr().addKeys(ge.keys);
              Se = ve.filter(function(De) {
                return !pt.hasKey(_.values ? ke(De) : De);
              });
              break;
            case "deleteRange":
              var it = ge.range;
              Se = ve.filter(function(De) {
                return !co(ke(De), it);
              });
          }
          return Se;
        }, m)) === m) ? m : (fe = function(ve, ge) {
          return It(me(ve), me(ge)) || It(ke(ve), ke(ge));
        }, O.sort(_.direction === "prev" || _.direction === "prevunique" ? function(ve, ge) {
          return fe(ge, ve);
        } : fe), _.limit && _.limit < 1 / 0 && (O.length > _.limit ? O.length = _.limit : m.length === _.limit && O.length < _.limit && (V.dirty = !0)), K ? Object.freeze(O) : O);
      }
      function fo(m, _) {
        return It(m.lower, _.lower) === 0 && It(m.upper, _.upper) === 0 && !!m.lowerOpen == !!_.lowerOpen && !!m.upperOpen == !!_.upperOpen;
      }
      function mc(m, _) {
        return ((M, O, V, K) => {
          if (M === void 0) return O !== void 0 ? -1 : 0;
          if (O === void 0) return 1;
          if ((M = It(M, O)) === 0) {
            if (V && K) return 0;
            if (V) return 1;
            if (K) return -1;
          }
          return M;
        })(m.lower, _.lower, m.lowerOpen, _.lowerOpen) <= 0 && 0 <= ((M, O, V, K) => {
          if (M === void 0) return O !== void 0 ? 1 : 0;
          if (O === void 0) return -1;
          if ((M = It(M, O)) === 0) {
            if (V && K) return 0;
            if (V) return -1;
            if (K) return 1;
          }
          return M;
        })(m.upper, _.upper, m.upperOpen, _.upperOpen);
      }
      function md(m, _, M, O) {
        m.subscribers.add(M), O.addEventListener("abort", function() {
          var V, K;
          m.subscribers.delete(M), m.subscribers.size === 0 && (V = m, K = _, setTimeout(function() {
            V.subscribers.size === 0 && j(K, V);
          }, 3e3));
        });
      }
      var pi = { stack: "dbcore", level: 0, name: "Cache", create: function(m) {
        var _ = m.schema.name;
        return o(o({}, m), { transaction: function(M, O, V) {
          var K, J, re = m.transaction(M, O, V);
          return O === "readwrite" && (V = (K = new AbortController()).signal, re.addEventListener("abort", (J = function(be) {
            return function() {
              if (K.abort(), O === "readwrite") {
                for (var ke = /* @__PURE__ */ new Set(), _e = 0, me = M; _e < me.length; _e++) {
                  var fe = me[_e], ve = hi["idb://".concat(_, "/").concat(fe)];
                  if (ve) {
                    var ge = m.table(fe), Se = ve.optimisticOps.filter(function(De) {
                      return De.trans === re;
                    });
                    if (re._explicit && be && re.mutatedParts) for (var we = 0, Te = Object.values(ve.queries.query); we < Te.length; we++) for (var Ne = 0, Be = (lt = Te[we]).slice(); Ne < Be.length; Ne++) iu((tt = Be[Ne]).obsSet, re.mutatedParts) && (j(lt, tt), tt.subscribers.forEach(function(De) {
                      return ke.add(De);
                    }));
                    else if (0 < Se.length) {
                      ve.optimisticOps = ve.optimisticOps.filter(function(De) {
                        return De.trans !== re;
                      });
                      for (var Je = 0, nt = Object.values(ve.queries.query); Je < nt.length; Je++) for (var lt, tt, pt, it = 0, Mt = (lt = nt[Je]).slice(); it < Mt.length; it++) (tt = Mt[it]).res != null && re.mutatedParts && (be && !tt.dirty ? (pt = Object.isFrozen(tt.res), pt = Ba(tt.res, tt.req, Se, ge, tt, pt), tt.dirty ? (j(lt, tt), tt.subscribers.forEach(function(De) {
                        return ke.add(De);
                      })) : pt !== tt.res && (tt.res = pt, tt.promise = Xe.resolve({ result: pt }))) : (tt.dirty && j(lt, tt), tt.subscribers.forEach(function(De) {
                        return ke.add(De);
                      })));
                    }
                  }
                }
                ke.forEach(function(De) {
                  return De();
                });
              }
            };
          })(!1), { signal: V }), re.addEventListener("error", J(!1), { signal: V }), re.addEventListener("complete", J(!0), { signal: V })), re;
        }, table: function(M) {
          var O = m.table(M), V = O.schema.primaryKey;
          return o(o({}, O), { mutate: function(K) {
            var J, re = qe.trans;
            return !V.outbound && re.db._options.cache !== "disabled" && !re.explicit && re.idbtrans.mode === "readwrite" && (J = hi["idb://".concat(_, "/").concat(M)]) ? (re = O.mutate(K), K.type !== "add" && K.type !== "put" || !(50 <= K.values.length || zs(V, K).some(function(be) {
              return be == null;
            })) ? (J.optimisticOps.push(K), K.mutatedParts && us(K.mutatedParts), re.then(function(be) {
              0 < be.numFailures && (j(J.optimisticOps, K), (be = kl(0, K, be)) && J.optimisticOps.push(be), K.mutatedParts) && us(K.mutatedParts);
            }), re.catch(function() {
              j(J.optimisticOps, K), K.mutatedParts && us(K.mutatedParts);
            })) : re.then(function(be) {
              var ke = kl(0, o(o({}, K), { values: K.values.map(function(_e, me) {
                var fe;
                return be.failures[me] ? _e : (X(fe = (fe = V.keyPath) != null && fe.includes(".") ? ie(_e) : o({}, _e), V.keyPath, be.results[me]), fe);
              }) }), be);
              J.optimisticOps.push(ke), queueMicrotask(function() {
                return K.mutatedParts && us(K.mutatedParts);
              });
            }), re) : O.mutate(K);
          }, query: function(K) {
            var J, re, be, ke, _e, me, fe;
            return xl(qe, O) && du("query", K) ? (J = ((be = qe.trans) == null ? void 0 : be.db._options.cache) === "immutable", re = (be = qe).requery, be = be.signal, me = ((ve, ge, Se, we) => {
              var Te = hi["idb://".concat(ve, "/").concat(ge)];
              if (!Te) return [];
              if (!(ve = Te.queries[Se])) return [null, !1, Te, null];
              var Ne = ve[(we.query ? we.query.index.name : null) || ""];
              if (!Ne) return [null, !1, Te, null];
              switch (Se) {
                case "query":
                  var Be = (Je = we.direction) != null ? Je : "next", Je = Ne.find(function(nt) {
                    var lt;
                    return nt.req.limit === we.limit && nt.req.values === we.values && ((lt = nt.req.direction) != null ? lt : "next") === Be && fo(nt.req.query.range, we.query.range);
                  });
                  return Je ? [Je, !0, Te, Ne] : [Ne.find(function(nt) {
                    var lt;
                    return ("limit" in nt.req ? nt.req.limit : 1 / 0) >= we.limit && ((lt = nt.req.direction) != null ? lt : "next") === Be && (!we.values || nt.req.values) && mc(nt.req.query.range, we.query.range);
                  }), !1, Te, Ne];
                case "count":
                  return Je = Ne.find(function(nt) {
                    return fo(nt.req.query.range, we.query.range);
                  }), [Je, !!Je, Te, Ne];
              }
            })(_, M, "query", K), fe = me[0], ke = me[2], _e = me[3], fe && me[1] ? fe.obsSet = K.obsSet : (me = O.query(K).then(function(ve) {
              var ge = ve.result;
              if (fe && (fe.res = ge), J) {
                for (var Se = 0, we = ge.length; Se < we; ++Se) Object.freeze(ge[Se]);
                Object.freeze(ge);
              }
              return ve;
            }).catch(function(ve) {
              return _e && fe && j(_e, fe), Promise.reject(ve);
            }), fe = { obsSet: K.obsSet, promise: me, subscribers: /* @__PURE__ */ new Set(), type: "query", req: K, dirty: !1 }, _e ? _e.push(fe) : (_e = [fe], (ke = ke || (hi["idb://".concat(_, "/").concat(M)] = { queries: { query: {}, count: {} }, objs: /* @__PURE__ */ new Map(), optimisticOps: [], unsignaledParts: {} })).queries.query[K.query.index.name || ""] = _e)), md(fe, _e, re, be), fe.promise.then(function(ve) {
              return ve = Ba(ve.result, K, ke == null ? void 0 : ke.optimisticOps, O, fe, J), { result: J ? ve : ie(ve) };
            })) : O.query(K);
          } });
        } });
      } };
      function Xa(m, _) {
        return new Proxy(m, { get: function(M, O, V) {
          return O === "db" ? _ : Reflect.get(M, O, V);
        } });
      }
      gr.prototype.version = function(m) {
        if (isNaN(m) || m < 0.1) throw new Pe.Type("Given version is not a positive number");
        if (m = Math.round(10 * m) / 10, this.idbdb || this._state.isBeingOpened) throw new Pe.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, m);
        var _ = this._versions, M = _.filter(function(O) {
          return O._cfg.version === m;
        })[0];
        return M || (M = new this.Version(m), _.push(M), _.sort(Ki), M.stores({}), this._state.autoSchema = !1), M;
      }, gr.prototype._whenReady = function(m) {
        var _ = this;
        return this.idbdb && (this._state.openComplete || qe.letThrough || this._vip) ? m() : new Xe(function(M, O) {
          if (_._state.openComplete) return O(new Pe.DatabaseClosed(_._state.dbOpenError));
          if (!_._state.isBeingOpened) {
            if (!_._state.autoOpen) return void O(new Pe.DatabaseClosed());
            _.open().catch(st);
          }
          _._state.dbReadyPromise.then(M, O);
        }).then(m);
      }, gr.prototype.use = function(V) {
        var _ = V.stack, M = V.create, O = V.level, V = V.name, K = (V && this.unuse({ stack: _, name: V }), this._middlewares[_] || (this._middlewares[_] = []));
        return K.push({ stack: _, create: M, level: O ?? 10, name: V }), K.sort(function(J, re) {
          return J.level - re.level;
        }), this;
      }, gr.prototype.unuse = function(m) {
        var _ = m.stack, M = m.name, O = m.create;
        return _ && this._middlewares[_] && (this._middlewares[_] = this._middlewares[_].filter(function(V) {
          return O ? V.create !== O : !!M && V.name !== M;
        })), this;
      }, gr.prototype.open = function() {
        var m = this;
        return Qr(_n, function() {
          return ou(m);
        });
      }, gr.prototype._close = function() {
        this.on.close.fire(new CustomEvent("close"));
        var m = this._state;
        if (ss.remove(this), this.idbdb) {
          try {
            this.idbdb.close();
          } catch {
          }
          this.idbdb = null;
        }
        m.isBeingOpened || (m.dbReadyPromise = new Xe(function(_) {
          m.dbReadyResolve = _;
        }), m.openCanceller = new Xe(function(_, M) {
          m.cancelOpen = M;
        }));
      }, gr.prototype.close = function(_) {
        var _ = (_ === void 0 ? { disableAutoOpen: !0 } : _).disableAutoOpen, M = this._state;
        _ ? (M.isBeingOpened && M.cancelOpen(new Pe.DatabaseClosed()), this._close(), M.autoOpen = !1, M.dbOpenError = new Pe.DatabaseClosed()) : (this._close(), M.autoOpen = this._options.autoOpen || M.isBeingOpened, M.openComplete = !1, M.dbOpenError = null);
      }, gr.prototype.delete = function(m) {
        var _ = this, M = (m === void 0 && (m = { disableAutoOpen: !0 }), 0 < arguments.length && typeof arguments[0] != "object"), O = this._state;
        return new Xe(function(V, K) {
          function J() {
            _.close(m);
            var re = _._deps.indexedDB.deleteDatabase(_.name);
            re.onsuccess = Ge(function() {
              var be, ke, _e;
              be = _._deps, ke = _.name, _a(_e = be.indexedDB) || ke === qi || _l(_e, be.IDBKeyRange).delete(ke).catch(st), V();
            }), re.onerror = di(K), re.onblocked = _._fireOnBlocked;
          }
          if (M) throw new Pe.InvalidArgument("Invalid closeOptions argument to db.delete()");
          O.isBeingOpened ? O.dbReadyPromise.then(J) : J();
        });
      }, gr.prototype.backendDB = function() {
        return this.idbdb;
      }, gr.prototype.isOpen = function() {
        return this.idbdb !== null;
      }, gr.prototype.hasBeenClosed = function() {
        var m = this._state.dbOpenError;
        return m && m.name === "DatabaseClosed";
      }, gr.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
      }, gr.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
      }, Object.defineProperty(gr.prototype, "tables", { get: function() {
        var m = this;
        return d(this._allTables).map(function(_) {
          return m._allTables[_];
        });
      }, enumerable: !1, configurable: !0 }), gr.prototype.transaction = function() {
        var m = (function(_, M, O) {
          var V = arguments.length;
          if (V < 2) throw new Pe.InvalidArgument("Too few arguments");
          for (var K = new Array(V - 1); --V; ) K[V - 1] = arguments[V];
          return O = K.pop(), [_, F(K), O];
        }).apply(this, arguments);
        return this._transaction.apply(this, m);
      }, gr.prototype._transaction = function(m, _, M) {
        var O, V, K = this, J = qe.trans, re = (J && J.db === this && m.indexOf("!") === -1 || (J = null), m.indexOf("?") !== -1);
        m = m.replace("!", "").replace("?", "");
        try {
          if (V = _.map(function(ke) {
            if (ke = ke instanceof K.Table ? ke.name : ke, typeof ke != "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
            return ke;
          }), m == "r" || m === Rs) O = Rs;
          else {
            if (m != "rw" && m != vl) throw new Pe.InvalidArgument("Invalid transaction mode: " + m);
            O = vl;
          }
          if (J) {
            if (J.mode === Rs && O === vl) {
              if (!re) throw new Pe.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
              J = null;
            }
            J && V.forEach(function(ke) {
              if (J && J.storeNames.indexOf(ke) === -1) {
                if (!re) throw new Pe.SubTransaction("Table " + ke + " not included in parent transaction.");
                J = null;
              }
            }), re && J && !J.active && (J = null);
          }
        } catch (ke) {
          return J ? J._promise(null, function(_e, me) {
            me(ke);
          }) : yr(ke);
        }
        var be = (function ke(_e, me, fe, ve, ge) {
          return Xe.resolve().then(function() {
            var Ne = qe.transless || qe, Se = _e._createTransaction(me, fe, _e._dbSchema, ve), Ne = (Se.explicit = !0, { trans: Se, transless: Ne });
            if (ve) Se.idbtrans = ve.idbtrans;
            else try {
              Se.create(), Se.idbtrans._explicit = !0, _e._state.PR1398_maxLoop = 3;
            } catch (Be) {
              return Be.name === Re.InvalidState && _e.isOpen() && 0 < --_e._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), _e.close({ disableAutoOpen: !1 }), _e.open().then(function() {
                return ke(_e, me, fe, null, ge);
              })) : yr(Be);
            }
            var we, Te = oe(ge), Ne = (Te && Nr(), Xe.follow(function() {
              var Be;
              (we = ge.call(Se, Se)) && (Te ? (Be = vr.bind(null, null), we.then(Be, Be)) : typeof we.next == "function" && typeof we.throw == "function" && (we = su(we)));
            }, Ne));
            return (we && typeof we.then == "function" ? Xe.resolve(we).then(function(Be) {
              return Se.active ? Be : yr(new Pe.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
            }) : Ne.then(function() {
              return we;
            })).then(function(Be) {
              return ve && Se._resolve(), Se._completion.then(function() {
                return Be;
              });
            }).catch(function(Be) {
              return Se._reject(Be), yr(Be);
            });
          });
        }).bind(null, this, O, V, J, M);
        return J ? J._promise(O, be, "lock") : qe.trans ? Qr(qe.transless, function() {
          return K._whenReady(be);
        }) : this._whenReady(be);
      }, gr.prototype.table = function(m) {
        if (E(this._allTables, m)) return this._allTables[m];
        throw new Pe.InvalidTable("Table ".concat(m, " does not exist"));
      };
      var Ur = gr;
      function gr(m, _) {
        var M, O, V, K, J, re = this, be = (this._middlewares = {}, this.verno = 0, gr.dependencies), be = (this._options = _ = o({ addons: gr.addons, autoOpen: !0, indexedDB: be.indexedDB, IDBKeyRange: be.IDBKeyRange, cache: "cloned", maxConnections: 1e3 }, _), this._deps = { indexedDB: _.indexedDB, IDBKeyRange: _.IDBKeyRange }, _.addons), ke = (this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this, { dbOpenError: null, isBeingOpened: !1, onReadyBeingFired: null, openComplete: !1, dbReadyResolve: st, dbReadyPromise: null, cancelOpen: st, openCanceller: null, autoSchema: !0, PR1398_maxLoop: 3, autoOpen: _.autoOpen }), _e = (ke.dbReadyPromise = new Xe(function(me) {
          ke.dbReadyResolve = me;
        }), ke.openCanceller = new Xe(function(me, fe) {
          ke.cancelOpen = fe;
        }), this._state = ke, this.name = m, this.on = es(this, "populate", "blocked", "versionchange", "close", { ready: [Pn, st] }), this.once = function(me, fe) {
          var ve = function() {
            for (var ge = [], Se = 0; Se < arguments.length; Se++) ge[Se] = arguments[Se];
            re.on(me).unsubscribe(ve), fe.apply(re, ge);
          };
          return re.on(me, ve);
        }, this.on.ready.subscribe = k(this.on.ready.subscribe, function(me) {
          return function(fe, ve) {
            gr.vip(function() {
              var ge, Se = re._state;
              Se.openComplete ? (Se.dbOpenError || Xe.resolve().then(fe), ve && me(fe)) : Se.onReadyBeingFired ? (Se.onReadyBeingFired.push(fe), ve && me(fe)) : (me(fe), ge = re, ve || me(function we() {
                ge.on.ready.unsubscribe(fe), ge.on.ready.unsubscribe(we);
              }));
            });
          };
        }), this.Collection = (M = this, ts(eu.prototype, function(we, Se) {
          this.db = M;
          var ve = Jl, ge = null;
          if (Se) try {
            ve = Se();
          } catch (Ne) {
            ge = Ne;
          }
          var Se = we._ctx, we = Se.table, Te = we.hook.reading.fire;
          this._ctx = { table: we, index: Se.index, isPrimKey: !Se.index || we.schema.primKey.keyPath && Se.index === we.schema.primKey.name, range: ve, keysOnly: !1, dir: "next", unique: "", algorithm: null, filter: null, replayFilter: null, justLimit: !0, isMatch: null, offset: 0, limit: 1 / 0, error: ge, or: Se.or, valueMapper: Te !== bt ? Te : null };
        })), this.Table = (O = this, ts(ia.prototype, function(me, fe, ve) {
          this.db = O, this._tx = ve, this.name = me, this.schema = fe, this.hook = O._allTables[me] ? O._allTables[me].hook : es(null, { creating: [qn, st], reading: [Xt, bt], updating: [bn, st], deleting: [Wt, st] });
        })), this.Transaction = (V = this, ts(Br.prototype, function(me, fe, ve, ge, Se) {
          var we = this;
          me !== "readonly" && fe.forEach(function(Te) {
            Te = (Te = ve[Te]) == null ? void 0 : Te.yProps, Te && (fe = fe.concat(Te.map(function(Ne) {
              return Ne.updatesTable;
            })));
          }), this.db = V, this.mode = me, this.storeNames = fe, this.schema = ve, this.chromeTransactionDurability = ge, this.idbtrans = null, this.on = es(this, "complete", "error", "abort"), this.parent = Se || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new Xe(function(Te, Ne) {
            we._resolve = Te, we._reject = Ne;
          }), this._completion.then(function() {
            we.active = !1, we.on.complete.fire();
          }, function(Te) {
            var Ne = we.active;
            return we.active = !1, we.on.error.fire(Te), we.parent ? we.parent._reject(Te) : Ne && we.idbtrans && we.idbtrans.abort(), yr(Te);
          });
        })), this.Version = (K = this, ts(os.prototype, function(me) {
          this.db = K, this._cfg = { version: me, storesSource: null, dbschema: {}, tables: {}, contentUpgrade: null };
        })), this.WhereClause = (J = this, ts(To.prototype, function(me, fe, ve) {
          if (this.db = J, this._ctx = { table: me, index: fe === ":id" ? null : fe, or: ve }, this._cmp = this._ascending = It, this._descending = function(ge, Se) {
            return It(Se, ge);
          }, this._max = function(ge, Se) {
            return 0 < It(ge, Se) ? ge : Se;
          }, this._min = function(ge, Se) {
            return It(ge, Se) < 0 ? ge : Se;
          }, this._IDBKeyRange = J._deps.IDBKeyRange, !this._IDBKeyRange) throw new Pe.MissingAPI();
        })), this.on("versionchange", function(me) {
          0 < me.newVersion ? console.warn("Another connection wants to upgrade database '".concat(re.name, "'. Closing db now to resume the upgrade.")) : console.warn("Another connection wants to delete database '".concat(re.name, "'. Closing db now to resume the delete request.")), re.close({ disableAutoOpen: !1 });
        }), this.on("blocked", function(me) {
          !me.newVersion || me.newVersion < me.oldVersion ? console.warn("Dexie.delete('".concat(re.name, "') was blocked")) : console.warn("Upgrade '".concat(re.name, "' blocked by other connection holding version ").concat(me.oldVersion / 10));
        }), this._maxKey = Ao(_.IDBKeyRange), this._createTransaction = function(me, fe, ve, ge) {
          return new re.Transaction(me, fe, ve, re._options.chromeTransactionDurability, ge);
        }, this._fireOnBlocked = function(me) {
          re.on("blocked").fire(me), ss.toArray().filter(function(fe) {
            return fe.name === re.name && fe !== re && !fe._state.vcFired;
          }).map(function(fe) {
            return fe.on("versionchange").fire(me);
          });
        }, this.use(cu), this.use(pi), this.use(fu), this.use(Fs), this.use(uu), new Proxy(this, { get: function(me, fe, ve) {
          var ge;
          return fe === "_vip" || (fe === "table" ? function(Se) {
            return Xa(re.table(Se), _e);
          } : (ge = Reflect.get(me, fe, ve)) instanceof ia ? Xa(ge, _e) : fe === "tables" ? ge.map(function(Se) {
            return Xa(Se, _e);
          }) : fe === "_createTransaction" ? function() {
            return Xa(ge.apply(this, arguments), _e);
          } : ge);
        } }));
        this.vip = _e, be.forEach(function(me) {
          return me(re);
        });
      }
      var wa, Qa = typeof Symbol < "u" && "observable" in Symbol ? Symbol.observable : "@@observable", Bs = (hu.prototype.subscribe = function(m, _, M) {
        return this._subscribe(m && typeof m != "function" ? m : { next: m, error: _, complete: M });
      }, hu.prototype[Qa] = function() {
        return this;
      }, hu);
      function hu(m) {
        this._subscribe = m;
      }
      try {
        wa = { indexedDB: u.indexedDB || u.mozIndexedDB || u.webkitIndexedDB || u.msIndexedDB, IDBKeyRange: u.IDBKeyRange || u.webkitIDBKeyRange };
      } catch {
        wa = { indexedDB: null, IDBKeyRange: null };
      }
      function cs(m) {
        var _, M = !1, O = new Bs(function(V) {
          var K = oe(m), J, re = !1, be = {}, ke = {}, _e = { get closed() {
            return re;
          }, unsubscribe: function() {
            re || (re = !0, J && J.abort(), me && No.storagemutated.unsubscribe(ge));
          } }, me = (V.start && V.start(_e), !1), fe = function() {
            return Co(Se);
          };
          function ve() {
            return iu(ke, be);
          }
          var ge = function(we) {
            ls(be, we), ve() && fe();
          }, Se = function() {
            var we, Te, Ne;
            !re && wa.indexedDB && (be = {}, we = {}, J && J.abort(), J = new AbortController(), Ne = ((Be) => {
              var Je = mr();
              try {
                K && Nr();
                var nt = Tr(m, Be);
                return nt = K ? nt.finally(vr) : nt;
              } finally {
                Je && Xr();
              }
            })(Te = { subscr: we, signal: J.signal, requery: fe, querier: m, trans: null }), me || (No.storagemutated.subscribe(ge), me = !0), Promise.resolve(Ne).then(function(Be) {
              M = !0, _ = Be, re || Te.signal.aborted || (ve() || (ke = we, ve()) ? fe() : (be = {}, Co(function() {
                return !re && V.next && V.next(Be);
              })));
            }, function(Be) {
              M = !1, ["DatabaseClosedError", "AbortError"].includes(Be == null ? void 0 : Be.name) || re || Co(function() {
                re || V.error && V.error(Be);
              });
            }));
          };
          return setTimeout(fe, 0), _e;
        });
        return O.hasValue = function() {
          return M;
        }, O.getValue = function() {
          return _;
        }, O;
      }
      var Po = Ur;
      function ho(m) {
        var _ = Ja;
        try {
          Ja = !0, No.storagemutated.fire(m), pc(m, !0);
        } finally {
          Ja = _;
        }
      }
      S(Po, o(o({}, ye), { delete: function(m) {
        return new Po(m, { addons: [] }).delete();
      }, exists: function(m) {
        return new Po(m, { addons: [] }).open().then(function(_) {
          return _.close(), !0;
        }).catch("NoSuchDatabaseError", function() {
          return !1;
        });
      }, getDatabaseNames: function(m) {
        try {
          return _ = Po.dependencies, M = _.indexedDB, _ = _.IDBKeyRange, (_a(M) ? Promise.resolve(M.databases()).then(function(O) {
            return O.map(function(V) {
              return V.name;
            }).filter(function(V) {
              return V !== qi;
            });
          }) : _l(M, _).toCollection().primaryKeys()).then(m);
        } catch {
          return yr(new Pe.MissingAPI());
        }
        var _, M;
      }, defineClass: function() {
        return function(m) {
          g(this, m);
        };
      }, ignoreTransaction: function(m) {
        return qe.trans ? Qr(qe.transless || _n, m) : m();
      }, vip: za, async: function(m) {
        return function() {
          try {
            var _ = su(m.apply(this, arguments));
            return _ && typeof _.then == "function" ? _ : Xe.resolve(_);
          } catch (M) {
            return yr(M);
          }
        };
      }, spawn: function(m, _, M) {
        try {
          var O = su(m.apply(M, _ || []));
          return O && typeof O.then == "function" ? O : Xe.resolve(O);
        } catch (V) {
          return yr(V);
        }
      }, currentTransaction: { get: function() {
        return qe.trans || null;
      } }, waitFor: function(m, _) {
        return m = Xe.resolve(typeof m == "function" ? Po.ignoreTransaction(m) : m).timeout(_ || 6e4), qe.trans ? qe.trans.waitFor(m) : m;
      }, Promise: Xe, debug: { get: function() {
        return gn;
      }, set: function(m) {
        vn(m);
      } }, derive: P, extend: g, props: S, override: k, Events: es, on: No, liveQuery: cs, extendObservabilitySet: ls, getByKeyPath: q, setByKeyPath: X, delByKeyPath: function(m, _) {
        typeof _ == "string" ? X(m, _, void 0) : "length" in _ && [].map.call(_, function(M) {
          X(m, M, void 0);
        });
      }, shallowClone: I, deepClone: ie, getObjectDiff: lu, cmp: It, asap: B, minKey: -1 / 0, addons: [], connections: { get: ss.toArray }, errnames: Re, dependencies: wa, cache: hi, semVer: "4.4.4", version: "4.4.4".split(".").map(function(m) {
        return parseInt(m);
      }).reduce(function(m, _, M) {
        return m + _ / Math.pow(10, 2 * M);
      }) })), Po.maxKey = Ao(Po.dependencies.IDBKeyRange), typeof dispatchEvent < "u" && typeof addEventListener < "u" && (No(bl, function(m) {
        Ja || (m = new CustomEvent(lc, { detail: m }), Ja = !0, dispatchEvent(m), Ja = !1);
      }), addEventListener(lc, function(m) {
        m = m.detail, Ja || ho(m);
      }));
      var Ir, Ja = !1, Do = function() {
      };
      return typeof BroadcastChannel < "u" && ((Do = function() {
        (Ir = new BroadcastChannel(lc)).onmessage = function(m) {
          return m.data && ho(m.data);
        };
      })(), typeof Ir.unref == "function" && Ir.unref(), No(bl, function(m) {
        Ja || Ir.postMessage(m);
      })), typeof addEventListener < "u" && (addEventListener("pagehide", function(m) {
        if (!Ur.disableBfCache && m.persisted) {
          gn && console.debug("Dexie: handling persisted pagehide"), Ir != null && Ir.close();
          for (var _ = 0, M = ss.toArray(); _ < M.length; _++) M[_].close({ disableAutoOpen: !1 });
        }
      }), addEventListener("pageshow", function(m) {
        !Ur.disableBfCache && m.persisted && (gn && console.debug("Dexie: handling persisted pageshow"), Do(), ho({ all: new Cr(-1 / 0, [[]]) }));
      })), Xe.rejectionMapper = function(m, _) {
        return !m || m instanceof Me || m instanceof TypeError || m instanceof SyntaxError || !m.name || !rt[m.name] ? m : (_ = new rt[m.name](_ || m.message, m), "stack" in m && T(_, "stack", { get: function() {
          return this.inner.stack;
        } }), _);
      }, vn(gn), o(Ur, Object.freeze({ __proto__: null, DEFAULT_MAX_CONNECTIONS: 1e3, Dexie: Ur, Entity: Ni, PropModification: zr, RangeSet: Cr, add: function(m) {
        return new zr({ add: m });
      }, cmp: It, default: Ur, liveQuery: cs, mergeRanges: Ds, rangesOverlap: dc, remove: function(m) {
        return new zr({ remove: m });
      }, replacePrefix: function(m, _) {
        return new zr({ replacePrefix: [m, _] });
      } }), { default: Ur }), Ur;
    });
  })(y0)), y0.exports;
}
var uD = lD();
const Z2 = /* @__PURE__ */ vm(uD), hw = Symbol.for("Dexie"), U0 = globalThis[hw] || (globalThis[hw] = Z2);
if (Z2.semVer !== U0.semVer)
  throw new Error(`Two different versions of Dexie loaded in the same app: ${Z2.semVer} and ${U0.semVer}`);
const {
  liveQuery: KL,
  mergeRanges: jL,
  rangesOverlap: YL,
  RangeSet: ZL,
  cmp: XL,
  Entity: QL,
  PropModification: JL,
  replacePrefix: $L,
  add: eO,
  remove: tO,
  DexieYProvider: nO
} = U0;
class cD extends U0 {
  constructor(r) {
    super(r);
    Jg(this, "projects");
    Jg(this, "preferences");
    this.version(1).stores({ projects: "id, title, updatedAt", preferences: "key" });
  }
}
const pw = /* @__PURE__ */ new Map();
function sc(e = "") {
  const t = Uf(e, "sailing-scenario-editor"), r = pw.get(t);
  if (r) return r;
  const o = new cD(t);
  return pw.set(t, o), o;
}
sc();
async function r8(e, t = "") {
  const r = sc(t);
  await r.projects.put({
    id: e.metadata.id,
    title: e.metadata.title,
    updatedAt: e.metadata.updatedAt,
    scenario: structuredClone(e)
  }), await r.preferences.put({ key: "lastProjectId", value: e.metadata.id });
}
async function X2(e = "") {
  return sc(e).projects.orderBy("updatedAt").reverse().toArray();
}
async function dD(e = "") {
  var o;
  const t = sc(e), r = await t.preferences.get("lastProjectId");
  return r ? ((o = await t.projects.get(r.value)) == null ? void 0 : o.scenario) ?? null : null;
}
async function fD(e, t = "") {
  await sc(t).projects.delete(e);
}
async function hD(e = "") {
  const t = sc(e);
  await t.transaction("rw", t.projects, t.preferences, async () => {
    await t.projects.clear(), await t.preferences.delete("lastProjectId");
  });
}
async function pD(e, t = "") {
  await sc(t).preferences.put({ key: "layoutPreference", value: e });
}
async function mD(e = "") {
  var r;
  const t = (r = await sc(e).preferences.get("layoutPreference")) == null ? void 0 : r.value;
  return t === "compact" || t === "desktop" ? t : "auto";
}
function gD() {
  const { storageNamespace: e } = Zo(), t = yt((v) => v.scenario), r = yt((v) => v.layoutPreference), o = yt((v) => v.hydrated), l = yt((v) => v.setScenario), u = yt((v) => v.setHydrated), d = yt((v) => v.setStatus), f = yt((v) => v.setDocumentStatus), g = yt((v) => v.setLayoutPreference), h = Wa(t.metadata.id);
  En(() => {
    Promise.all([dD(e), mD(e)]).then(([v, E]) => {
      v && yt.getState().scenario.metadata.id === h.current && (l(v, "Restored local work"), f("browser")), g(E);
    }).catch(() => d("Local storage is unavailable; work remains in this tab.")).finally(() => u(!0));
  }, [
    f,
    u,
    g,
    l,
    d,
    e
  ]), En(() => {
    if (!o) return;
    const v = window.setTimeout(() => {
      r8(t, e).then(() => {
        const E = yt.getState();
        E.scenario === t && E.documentStatus !== "downloaded" && f("browser"), d("Saved locally");
      }).catch(() => {
        yt.getState().scenario === t && f("unsaved"), d("Could not autosave locally");
      });
    }, 3e3);
    return () => window.clearTimeout(v);
  }, [o, t, f, d, e]), En(() => {
    o && pD(r, e);
  }, [o, r, e]);
}
const vD = /^(\d+(?:\.\d+)*)(?:\(([a-z])\))?(?:\((\d+)\))?$/i, yD = /^(\d+(?:\.\d+)*)([a-z])$/i, bD = /^([a-z]\d+(?:\.\d+)*)(?:\(([a-z])\))?(?:\((\d+)\))?$/i;
function Ky(e, t, r) {
  return `${e.toUpperCase()}${t ? `(${t.toLowerCase()})` : ""}${r ? `(${r})` : ""}`;
}
function mw(e) {
  const t = e.trim();
  if (!t) return "";
  const o = (/^(?:RRS|RSS)\b/i.test(t) ? t.replace(/^(?:RRS|RSS)\b\s*/i, "") : t).replace(
    /\s+/g,
    ""
  ), l = o.match(yD), u = o.match(vD), d = o.match(bD), f = l ? Ky(l[1], l[2]) : u ? Ky(u[1], u[2], u[3]) : d ? Ky(d[1], d[2], d[3]) : null;
  return f ? `RRS ${f}` : t;
}
var kf = {}, jy, gw;
function _D() {
  return gw || (gw = 1, jy = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), jy;
}
var Yy = {}, Iu = {}, vw;
function cd() {
  if (vw) return Iu;
  vw = 1;
  let e;
  const t = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return Iu.getSymbolSize = function(o) {
    if (!o) throw new Error('"version" cannot be null or undefined');
    if (o < 1 || o > 40) throw new Error('"version" should be in range from 1 to 40');
    return o * 4 + 17;
  }, Iu.getSymbolTotalCodewords = function(o) {
    return t[o];
  }, Iu.getBCHDigit = function(r) {
    let o = 0;
    for (; r !== 0; )
      o++, r >>>= 1;
    return o;
  }, Iu.setToSJISFunction = function(o) {
    if (typeof o != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = o;
  }, Iu.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, Iu.toSJIS = function(o) {
    return e(o);
  }, Iu;
}
var Zy = {}, yw;
function Rb() {
  return yw || (yw = 1, (function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function t(r) {
      if (typeof r != "string")
        throw new Error("Param is not a string");
      switch (r.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + r);
      }
    }
    e.isValid = function(o) {
      return o && typeof o.bit < "u" && o.bit >= 0 && o.bit < 4;
    }, e.from = function(o, l) {
      if (e.isValid(o))
        return o;
      try {
        return t(o);
      } catch {
        return l;
      }
    };
  })(Zy)), Zy;
}
var Xy, bw;
function SD() {
  if (bw) return Xy;
  bw = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(t) {
      const r = Math.floor(t / 8);
      return (this.buffer[r] >>> 7 - t % 8 & 1) === 1;
    },
    put: function(t, r) {
      for (let o = 0; o < r; o++)
        this.putBit((t >>> r - o - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(t) {
      const r = Math.floor(this.length / 8);
      this.buffer.length <= r && this.buffer.push(0), t && (this.buffer[r] |= 128 >>> this.length % 8), this.length++;
    }
  }, Xy = e, Xy;
}
var Qy, _w;
function wD() {
  if (_w) return Qy;
  _w = 1;
  function e(t) {
    if (!t || t < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
  }
  return e.prototype.set = function(t, r, o, l) {
    const u = t * this.size + r;
    this.data[u] = o, l && (this.reservedBit[u] = !0);
  }, e.prototype.get = function(t, r) {
    return this.data[t * this.size + r];
  }, e.prototype.xor = function(t, r, o) {
    this.data[t * this.size + r] ^= o;
  }, e.prototype.isReserved = function(t, r) {
    return this.reservedBit[t * this.size + r];
  }, Qy = e, Qy;
}
var Jy = {}, Sw;
function xD() {
  return Sw || (Sw = 1, (function(e) {
    const t = cd().getSymbolSize;
    e.getRowColCoords = function(o) {
      if (o === 1) return [];
      const l = Math.floor(o / 7) + 2, u = t(o), d = u === 145 ? 26 : Math.ceil((u - 13) / (2 * l - 2)) * 2, f = [u - 7];
      for (let g = 1; g < l - 1; g++)
        f[g] = f[g - 1] - d;
      return f.push(6), f.reverse();
    }, e.getPositions = function(o) {
      const l = [], u = e.getRowColCoords(o), d = u.length;
      for (let f = 0; f < d; f++)
        for (let g = 0; g < d; g++)
          f === 0 && g === 0 || // top-left
          f === 0 && g === d - 1 || // bottom-left
          f === d - 1 && g === 0 || l.push([u[f], u[g]]);
      return l;
    };
  })(Jy)), Jy;
}
var $y = {}, ww;
function kD() {
  if (ww) return $y;
  ww = 1;
  const e = cd().getSymbolSize, t = 7;
  return $y.getPositions = function(o) {
    const l = e(o);
    return [
      // top-left
      [0, 0],
      // top-right
      [l - t, 0],
      // bottom-left
      [0, l - t]
    ];
  }, $y;
}
var e2 = {}, xw;
function CD() {
  return xw || (xw = 1, (function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const t = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(l) {
      return l != null && l !== "" && !isNaN(l) && l >= 0 && l <= 7;
    }, e.from = function(l) {
      return e.isValid(l) ? parseInt(l, 10) : void 0;
    }, e.getPenaltyN1 = function(l) {
      const u = l.size;
      let d = 0, f = 0, g = 0, h = null, v = null;
      for (let E = 0; E < u; E++) {
        f = g = 0, h = v = null;
        for (let S = 0; S < u; S++) {
          let w = l.get(E, S);
          w === h ? f++ : (f >= 5 && (d += t.N1 + (f - 5)), h = w, f = 1), w = l.get(S, E), w === v ? g++ : (g >= 5 && (d += t.N1 + (g - 5)), v = w, g = 1);
        }
        f >= 5 && (d += t.N1 + (f - 5)), g >= 5 && (d += t.N1 + (g - 5));
      }
      return d;
    }, e.getPenaltyN2 = function(l) {
      const u = l.size;
      let d = 0;
      for (let f = 0; f < u - 1; f++)
        for (let g = 0; g < u - 1; g++) {
          const h = l.get(f, g) + l.get(f, g + 1) + l.get(f + 1, g) + l.get(f + 1, g + 1);
          (h === 4 || h === 0) && d++;
        }
      return d * t.N2;
    }, e.getPenaltyN3 = function(l) {
      const u = l.size;
      let d = 0, f = 0, g = 0;
      for (let h = 0; h < u; h++) {
        f = g = 0;
        for (let v = 0; v < u; v++)
          f = f << 1 & 2047 | l.get(h, v), v >= 10 && (f === 1488 || f === 93) && d++, g = g << 1 & 2047 | l.get(v, h), v >= 10 && (g === 1488 || g === 93) && d++;
      }
      return d * t.N3;
    }, e.getPenaltyN4 = function(l) {
      let u = 0;
      const d = l.data.length;
      for (let g = 0; g < d; g++) u += l.data[g];
      return Math.abs(Math.ceil(u * 100 / d / 5) - 10) * t.N4;
    };
    function r(o, l, u) {
      switch (o) {
        case e.Patterns.PATTERN000:
          return (l + u) % 2 === 0;
        case e.Patterns.PATTERN001:
          return l % 2 === 0;
        case e.Patterns.PATTERN010:
          return u % 3 === 0;
        case e.Patterns.PATTERN011:
          return (l + u) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(l / 2) + Math.floor(u / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return l * u % 2 + l * u % 3 === 0;
        case e.Patterns.PATTERN110:
          return (l * u % 2 + l * u % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (l * u % 3 + (l + u) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + o);
      }
    }
    e.applyMask = function(l, u) {
      const d = u.size;
      for (let f = 0; f < d; f++)
        for (let g = 0; g < d; g++)
          u.isReserved(g, f) || u.xor(g, f, r(l, g, f));
    }, e.getBestMask = function(l, u) {
      const d = Object.keys(e.Patterns).length;
      let f = 0, g = 1 / 0;
      for (let h = 0; h < d; h++) {
        u(h), e.applyMask(h, l);
        const v = e.getPenaltyN1(l) + e.getPenaltyN2(l) + e.getPenaltyN3(l) + e.getPenaltyN4(l);
        e.applyMask(h, l), v < g && (g = v, f = h);
      }
      return f;
    };
  })(e2)), e2;
}
var d0 = {}, kw;
function a8() {
  if (kw) return d0;
  kw = 1;
  const e = Rb(), t = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], r = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return d0.getBlocksCount = function(l, u) {
    switch (u) {
      case e.L:
        return t[(l - 1) * 4 + 0];
      case e.M:
        return t[(l - 1) * 4 + 1];
      case e.Q:
        return t[(l - 1) * 4 + 2];
      case e.H:
        return t[(l - 1) * 4 + 3];
      default:
        return;
    }
  }, d0.getTotalCodewordsCount = function(l, u) {
    switch (u) {
      case e.L:
        return r[(l - 1) * 4 + 0];
      case e.M:
        return r[(l - 1) * 4 + 1];
      case e.Q:
        return r[(l - 1) * 4 + 2];
      case e.H:
        return r[(l - 1) * 4 + 3];
      default:
        return;
    }
  }, d0;
}
var t2 = {}, Up = {}, Cw;
function ED() {
  if (Cw) return Up;
  Cw = 1;
  const e = new Uint8Array(512), t = new Uint8Array(256);
  return (function() {
    let o = 1;
    for (let l = 0; l < 255; l++)
      e[l] = o, t[o] = l, o <<= 1, o & 256 && (o ^= 285);
    for (let l = 255; l < 512; l++)
      e[l] = e[l - 255];
  })(), Up.log = function(o) {
    if (o < 1) throw new Error("log(" + o + ")");
    return t[o];
  }, Up.exp = function(o) {
    return e[o];
  }, Up.mul = function(o, l) {
    return o === 0 || l === 0 ? 0 : e[t[o] + t[l]];
  }, Up;
}
var Ew;
function RD() {
  return Ew || (Ew = 1, (function(e) {
    const t = ED();
    e.mul = function(o, l) {
      const u = new Uint8Array(o.length + l.length - 1);
      for (let d = 0; d < o.length; d++)
        for (let f = 0; f < l.length; f++)
          u[d + f] ^= t.mul(o[d], l[f]);
      return u;
    }, e.mod = function(o, l) {
      let u = new Uint8Array(o);
      for (; u.length - l.length >= 0; ) {
        const d = u[0];
        for (let g = 0; g < l.length; g++)
          u[g] ^= t.mul(l[g], d);
        let f = 0;
        for (; f < u.length && u[f] === 0; ) f++;
        u = u.slice(f);
      }
      return u;
    }, e.generateECPolynomial = function(o) {
      let l = new Uint8Array([1]);
      for (let u = 0; u < o; u++)
        l = e.mul(l, new Uint8Array([1, t.exp(u)]));
      return l;
    };
  })(t2)), t2;
}
var n2, Rw;
function TD() {
  if (Rw) return n2;
  Rw = 1;
  const e = RD();
  function t(r) {
    this.genPoly = void 0, this.degree = r, this.degree && this.initialize(this.degree);
  }
  return t.prototype.initialize = function(o) {
    this.degree = o, this.genPoly = e.generateECPolynomial(this.degree);
  }, t.prototype.encode = function(o) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const l = new Uint8Array(o.length + this.degree);
    l.set(o);
    const u = e.mod(l, this.genPoly), d = this.degree - u.length;
    if (d > 0) {
      const f = new Uint8Array(this.degree);
      return f.set(u, d), f;
    }
    return u;
  }, n2 = t, n2;
}
var r2 = {}, a2 = {}, i2 = {}, Tw;
function i8() {
  return Tw || (Tw = 1, i2.isValid = function(t) {
    return !isNaN(t) && t >= 1 && t <= 40;
  }), i2;
}
var il = {}, Nw;
function o8() {
  if (Nw) return il;
  Nw = 1;
  const e = "[0-9]+", t = "[A-Z $%*+\\-./:]+";
  let r = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  r = r.replace(/u/g, "\\u");
  const o = "(?:(?![A-Z0-9 $%*+\\-./:]|" + r + `)(?:.|[\r
]))+`;
  il.KANJI = new RegExp(r, "g"), il.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), il.BYTE = new RegExp(o, "g"), il.NUMERIC = new RegExp(e, "g"), il.ALPHANUMERIC = new RegExp(t, "g");
  const l = new RegExp("^" + r + "$"), u = new RegExp("^" + e + "$"), d = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return il.testKanji = function(g) {
    return l.test(g);
  }, il.testNumeric = function(g) {
    return u.test(g);
  }, il.testAlphanumeric = function(g) {
    return d.test(g);
  }, il;
}
var Aw;
function dd() {
  return Aw || (Aw = 1, (function(e) {
    const t = i8(), r = o8();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(u, d) {
      if (!u.ccBits) throw new Error("Invalid mode: " + u);
      if (!t.isValid(d))
        throw new Error("Invalid version: " + d);
      return d >= 1 && d < 10 ? u.ccBits[0] : d < 27 ? u.ccBits[1] : u.ccBits[2];
    }, e.getBestModeForData = function(u) {
      return r.testNumeric(u) ? e.NUMERIC : r.testAlphanumeric(u) ? e.ALPHANUMERIC : r.testKanji(u) ? e.KANJI : e.BYTE;
    }, e.toString = function(u) {
      if (u && u.id) return u.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(u) {
      return u && u.bit && u.ccBits;
    };
    function o(l) {
      if (typeof l != "string")
        throw new Error("Param is not a string");
      switch (l.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + l);
      }
    }
    e.from = function(u, d) {
      if (e.isValid(u))
        return u;
      try {
        return o(u);
      } catch {
        return d;
      }
    };
  })(a2)), a2;
}
var Mw;
function ND() {
  return Mw || (Mw = 1, (function(e) {
    const t = cd(), r = a8(), o = Rb(), l = dd(), u = i8(), d = 7973, f = t.getBCHDigit(d);
    function g(S, w, T) {
      for (let P = 1; P <= 40; P++)
        if (w <= e.getCapacity(P, T, S))
          return P;
    }
    function h(S, w) {
      return l.getCharCountIndicator(S, w) + 4;
    }
    function v(S, w) {
      let T = 0;
      return S.forEach(function(P) {
        const z = h(P.mode, w);
        T += z + P.getBitsLength();
      }), T;
    }
    function E(S, w) {
      for (let T = 1; T <= 40; T++)
        if (v(S, T) <= e.getCapacity(T, w, l.MIXED))
          return T;
    }
    e.from = function(w, T) {
      return u.isValid(w) ? parseInt(w, 10) : T;
    }, e.getCapacity = function(w, T, P) {
      if (!u.isValid(w))
        throw new Error("Invalid QR Code version");
      typeof P > "u" && (P = l.BYTE);
      const z = t.getSymbolTotalCodewords(w), L = r.getTotalCodewordsCount(w, T), x = (z - L) * 8;
      if (P === l.MIXED) return x;
      const k = x - h(P, w);
      switch (P) {
        case l.NUMERIC:
          return Math.floor(k / 10 * 3);
        case l.ALPHANUMERIC:
          return Math.floor(k / 11 * 2);
        case l.KANJI:
          return Math.floor(k / 13);
        case l.BYTE:
        default:
          return Math.floor(k / 8);
      }
    }, e.getBestVersionForData = function(w, T) {
      let P;
      const z = o.from(T, o.M);
      if (Array.isArray(w)) {
        if (w.length > 1)
          return E(w, z);
        if (w.length === 0)
          return 1;
        P = w[0];
      } else
        P = w;
      return g(P.mode, P.getLength(), z);
    }, e.getEncodedBits = function(w) {
      if (!u.isValid(w) || w < 7)
        throw new Error("Invalid QR Code version");
      let T = w << 12;
      for (; t.getBCHDigit(T) - f >= 0; )
        T ^= d << t.getBCHDigit(T) - f;
      return w << 12 | T;
    };
  })(r2)), r2;
}
var o2 = {}, Pw;
function AD() {
  if (Pw) return o2;
  Pw = 1;
  const e = cd(), t = 1335, r = 21522, o = e.getBCHDigit(t);
  return o2.getEncodedBits = function(u, d) {
    const f = u.bit << 3 | d;
    let g = f << 10;
    for (; e.getBCHDigit(g) - o >= 0; )
      g ^= t << e.getBCHDigit(g) - o;
    return (f << 10 | g) ^ r;
  }, o2;
}
var s2 = {}, l2, Dw;
function MD() {
  if (Dw) return l2;
  Dw = 1;
  const e = dd();
  function t(r) {
    this.mode = e.NUMERIC, this.data = r.toString();
  }
  return t.getBitsLength = function(o) {
    return 10 * Math.floor(o / 3) + (o % 3 ? o % 3 * 3 + 1 : 0);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(o) {
    let l, u, d;
    for (l = 0; l + 3 <= this.data.length; l += 3)
      u = this.data.substr(l, 3), d = parseInt(u, 10), o.put(d, 10);
    const f = this.data.length - l;
    f > 0 && (u = this.data.substr(l), d = parseInt(u, 10), o.put(d, f * 3 + 1));
  }, l2 = t, l2;
}
var u2, Lw;
function PD() {
  if (Lw) return u2;
  Lw = 1;
  const e = dd(), t = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function r(o) {
    this.mode = e.ALPHANUMERIC, this.data = o;
  }
  return r.getBitsLength = function(l) {
    return 11 * Math.floor(l / 2) + 6 * (l % 2);
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(l) {
    let u;
    for (u = 0; u + 2 <= this.data.length; u += 2) {
      let d = t.indexOf(this.data[u]) * 45;
      d += t.indexOf(this.data[u + 1]), l.put(d, 11);
    }
    this.data.length % 2 && l.put(t.indexOf(this.data[u]), 6);
  }, u2 = r, u2;
}
var c2, Ow;
function DD() {
  if (Ow) return c2;
  Ow = 1;
  const e = dd();
  function t(r) {
    this.mode = e.BYTE, typeof r == "string" ? this.data = new TextEncoder().encode(r) : this.data = new Uint8Array(r);
  }
  return t.getBitsLength = function(o) {
    return o * 8;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(r) {
    for (let o = 0, l = this.data.length; o < l; o++)
      r.put(this.data[o], 8);
  }, c2 = t, c2;
}
var d2, Fw;
function LD() {
  if (Fw) return d2;
  Fw = 1;
  const e = dd(), t = cd();
  function r(o) {
    this.mode = e.KANJI, this.data = o;
  }
  return r.getBitsLength = function(l) {
    return l * 13;
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(o) {
    let l;
    for (l = 0; l < this.data.length; l++) {
      let u = t.toSJIS(this.data[l]);
      if (u >= 33088 && u <= 40956)
        u -= 33088;
      else if (u >= 57408 && u <= 60351)
        u -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[l] + `
Make sure your charset is UTF-8`
        );
      u = (u >>> 8 & 255) * 192 + (u & 255), o.put(u, 13);
    }
  }, d2 = r, d2;
}
var f2 = { exports: {} }, zw;
function OD() {
  return zw || (zw = 1, (function(e) {
    var t = {
      single_source_shortest_paths: function(r, o, l) {
        var u = {}, d = {};
        d[o] = 0;
        var f = t.PriorityQueue.make();
        f.push(o, 0);
        for (var g, h, v, E, S, w, T, P, z; !f.empty(); ) {
          g = f.pop(), h = g.value, E = g.cost, S = r[h] || {};
          for (v in S)
            S.hasOwnProperty(v) && (w = S[v], T = E + w, P = d[v], z = typeof d[v] > "u", (z || P > T) && (d[v] = T, f.push(v, T), u[v] = h));
        }
        if (typeof l < "u" && typeof d[l] > "u") {
          var L = ["Could not find a path from ", o, " to ", l, "."].join("");
          throw new Error(L);
        }
        return u;
      },
      extract_shortest_path_from_predecessor_list: function(r, o) {
        for (var l = [], u = o; u; )
          l.push(u), r[u], u = r[u];
        return l.reverse(), l;
      },
      find_path: function(r, o, l) {
        var u = t.single_source_shortest_paths(r, o, l);
        return t.extract_shortest_path_from_predecessor_list(
          u,
          l
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(r) {
          var o = t.PriorityQueue, l = {}, u;
          r = r || {};
          for (u in o)
            o.hasOwnProperty(u) && (l[u] = o[u]);
          return l.queue = [], l.sorter = r.sorter || o.default_sorter, l;
        },
        default_sorter: function(r, o) {
          return r.cost - o.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(r, o) {
          var l = { value: r, cost: o };
          this.queue.push(l), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = t;
  })(f2)), f2.exports;
}
var Bw;
function FD() {
  return Bw || (Bw = 1, (function(e) {
    const t = dd(), r = MD(), o = PD(), l = DD(), u = LD(), d = o8(), f = cd(), g = OD();
    function h(L) {
      return unescape(encodeURIComponent(L)).length;
    }
    function v(L, x, k) {
      const R = [];
      let B;
      for (; (B = L.exec(k)) !== null; )
        R.push({
          data: B[0],
          index: B.index,
          mode: x,
          length: B[0].length
        });
      return R;
    }
    function E(L) {
      const x = v(d.NUMERIC, t.NUMERIC, L), k = v(d.ALPHANUMERIC, t.ALPHANUMERIC, L);
      let R, B;
      return f.isKanjiModeEnabled() ? (R = v(d.BYTE, t.BYTE, L), B = v(d.KANJI, t.KANJI, L)) : (R = v(d.BYTE_KANJI, t.BYTE, L), B = []), x.concat(k, R, B).sort(function(X, I) {
        return X.index - I.index;
      }).map(function(X) {
        return {
          data: X.data,
          mode: X.mode,
          length: X.length
        };
      });
    }
    function S(L, x) {
      switch (x) {
        case t.NUMERIC:
          return r.getBitsLength(L);
        case t.ALPHANUMERIC:
          return o.getBitsLength(L);
        case t.KANJI:
          return u.getBitsLength(L);
        case t.BYTE:
          return l.getBitsLength(L);
      }
    }
    function w(L) {
      return L.reduce(function(x, k) {
        const R = x.length - 1 >= 0 ? x[x.length - 1] : null;
        return R && R.mode === k.mode ? (x[x.length - 1].data += k.data, x) : (x.push(k), x);
      }, []);
    }
    function T(L) {
      const x = [];
      for (let k = 0; k < L.length; k++) {
        const R = L[k];
        switch (R.mode) {
          case t.NUMERIC:
            x.push([
              R,
              { data: R.data, mode: t.ALPHANUMERIC, length: R.length },
              { data: R.data, mode: t.BYTE, length: R.length }
            ]);
            break;
          case t.ALPHANUMERIC:
            x.push([
              R,
              { data: R.data, mode: t.BYTE, length: R.length }
            ]);
            break;
          case t.KANJI:
            x.push([
              R,
              { data: R.data, mode: t.BYTE, length: h(R.data) }
            ]);
            break;
          case t.BYTE:
            x.push([
              { data: R.data, mode: t.BYTE, length: h(R.data) }
            ]);
        }
      }
      return x;
    }
    function P(L, x) {
      const k = {}, R = { start: {} };
      let B = ["start"];
      for (let q = 0; q < L.length; q++) {
        const X = L[q], I = [];
        for (let U = 0; U < X.length; U++) {
          const F = X[U], Z = "" + q + U;
          I.push(Z), k[Z] = { node: F, lastCount: 0 }, R[Z] = {};
          for (let te = 0; te < B.length; te++) {
            const ie = B[te];
            k[ie] && k[ie].node.mode === F.mode ? (R[ie][Z] = S(k[ie].lastCount + F.length, F.mode) - S(k[ie].lastCount, F.mode), k[ie].lastCount += F.length) : (k[ie] && (k[ie].lastCount = F.length), R[ie][Z] = S(F.length, F.mode) + 4 + t.getCharCountIndicator(F.mode, x));
          }
        }
        B = I;
      }
      for (let q = 0; q < B.length; q++)
        R[B[q]].end = 0;
      return { map: R, table: k };
    }
    function z(L, x) {
      let k;
      const R = t.getBestModeForData(L);
      if (k = t.from(x, R), k !== t.BYTE && k.bit < R.bit)
        throw new Error('"' + L + '" cannot be encoded with mode ' + t.toString(k) + `.
 Suggested mode is: ` + t.toString(R));
      switch (k === t.KANJI && !f.isKanjiModeEnabled() && (k = t.BYTE), k) {
        case t.NUMERIC:
          return new r(L);
        case t.ALPHANUMERIC:
          return new o(L);
        case t.KANJI:
          return new u(L);
        case t.BYTE:
          return new l(L);
      }
    }
    e.fromArray = function(x) {
      return x.reduce(function(k, R) {
        return typeof R == "string" ? k.push(z(R, null)) : R.data && k.push(z(R.data, R.mode)), k;
      }, []);
    }, e.fromString = function(x, k) {
      const R = E(x, f.isKanjiModeEnabled()), B = T(R), q = P(B, k), X = g.find_path(q.map, "start", "end"), I = [];
      for (let U = 1; U < X.length - 1; U++)
        I.push(q.table[X[U]].node);
      return e.fromArray(w(I));
    }, e.rawSplit = function(x) {
      return e.fromArray(
        E(x, f.isKanjiModeEnabled())
      );
    };
  })(s2)), s2;
}
var Uw;
function zD() {
  if (Uw) return Yy;
  Uw = 1;
  const e = cd(), t = Rb(), r = SD(), o = wD(), l = xD(), u = kD(), d = CD(), f = a8(), g = TD(), h = ND(), v = AD(), E = dd(), S = FD();
  function w(q, X) {
    const I = q.size, U = u.getPositions(X);
    for (let F = 0; F < U.length; F++) {
      const Z = U[F][0], te = U[F][1];
      for (let ie = -1; ie <= 7; ie++)
        if (!(Z + ie <= -1 || I <= Z + ie))
          for (let ue = -1; ue <= 7; ue++)
            te + ue <= -1 || I <= te + ue || (ie >= 0 && ie <= 6 && (ue === 0 || ue === 6) || ue >= 0 && ue <= 6 && (ie === 0 || ie === 6) || ie >= 2 && ie <= 4 && ue >= 2 && ue <= 4 ? q.set(Z + ie, te + ue, !0, !0) : q.set(Z + ie, te + ue, !1, !0));
    }
  }
  function T(q) {
    const X = q.size;
    for (let I = 8; I < X - 8; I++) {
      const U = I % 2 === 0;
      q.set(I, 6, U, !0), q.set(6, I, U, !0);
    }
  }
  function P(q, X) {
    const I = l.getPositions(X);
    for (let U = 0; U < I.length; U++) {
      const F = I[U][0], Z = I[U][1];
      for (let te = -2; te <= 2; te++)
        for (let ie = -2; ie <= 2; ie++)
          te === -2 || te === 2 || ie === -2 || ie === 2 || te === 0 && ie === 0 ? q.set(F + te, Z + ie, !0, !0) : q.set(F + te, Z + ie, !1, !0);
    }
  }
  function z(q, X) {
    const I = q.size, U = h.getEncodedBits(X);
    let F, Z, te;
    for (let ie = 0; ie < 18; ie++)
      F = Math.floor(ie / 3), Z = ie % 3 + I - 8 - 3, te = (U >> ie & 1) === 1, q.set(F, Z, te, !0), q.set(Z, F, te, !0);
  }
  function L(q, X, I) {
    const U = q.size, F = v.getEncodedBits(X, I);
    let Z, te;
    for (Z = 0; Z < 15; Z++)
      te = (F >> Z & 1) === 1, Z < 6 ? q.set(Z, 8, te, !0) : Z < 8 ? q.set(Z + 1, 8, te, !0) : q.set(U - 15 + Z, 8, te, !0), Z < 8 ? q.set(8, U - Z - 1, te, !0) : Z < 9 ? q.set(8, 15 - Z - 1 + 1, te, !0) : q.set(8, 15 - Z - 1, te, !0);
    q.set(U - 8, 8, 1, !0);
  }
  function x(q, X) {
    const I = q.size;
    let U = -1, F = I - 1, Z = 7, te = 0;
    for (let ie = I - 1; ie > 0; ie -= 2)
      for (ie === 6 && ie--; ; ) {
        for (let ue = 0; ue < 2; ue++)
          if (!q.isReserved(F, ie - ue)) {
            let ce = !1;
            te < X.length && (ce = (X[te] >>> Z & 1) === 1), q.set(F, ie - ue, ce), Z--, Z === -1 && (te++, Z = 7);
          }
        if (F += U, F < 0 || I <= F) {
          F -= U, U = -U;
          break;
        }
      }
  }
  function k(q, X, I) {
    const U = new r();
    I.forEach(function(ue) {
      U.put(ue.mode.bit, 4), U.put(ue.getLength(), E.getCharCountIndicator(ue.mode, q)), ue.write(U);
    });
    const F = e.getSymbolTotalCodewords(q), Z = f.getTotalCodewordsCount(q, X), te = (F - Z) * 8;
    for (U.getLengthInBits() + 4 <= te && U.put(0, 4); U.getLengthInBits() % 8 !== 0; )
      U.putBit(0);
    const ie = (te - U.getLengthInBits()) / 8;
    for (let ue = 0; ue < ie; ue++)
      U.put(ue % 2 ? 17 : 236, 8);
    return R(U, q, X);
  }
  function R(q, X, I) {
    const U = e.getSymbolTotalCodewords(X), F = f.getTotalCodewordsCount(X, I), Z = U - F, te = f.getBlocksCount(X, I), ie = U % te, ue = te - ie, ce = Math.floor(U / te), ze = Math.floor(Z / te), W = ze + 1, j = ce - ze, ee = new g(j);
    let Q = 0;
    const oe = new Array(te), ye = new Array(te);
    let pe = 0;
    const Me = new Uint8Array(q.buffer);
    for (let Qe = 0; Qe < te; Qe++) {
      const Pe = Qe < ue ? ze : W;
      oe[Qe] = Me.slice(Q, Q + Pe), ye[Qe] = ee.encode(oe[Qe]), Q += Pe, pe = Math.max(pe, Pe);
    }
    const We = new Uint8Array(U);
    let Ee = 0, ae, Re;
    for (ae = 0; ae < pe; ae++)
      for (Re = 0; Re < te; Re++)
        ae < oe[Re].length && (We[Ee++] = oe[Re][ae]);
    for (ae = 0; ae < j; ae++)
      for (Re = 0; Re < te; Re++)
        We[Ee++] = ye[Re][ae];
    return We;
  }
  function B(q, X, I, U) {
    let F;
    if (Array.isArray(q))
      F = S.fromArray(q);
    else if (typeof q == "string") {
      let ce = X;
      if (!ce) {
        const ze = S.rawSplit(q);
        ce = h.getBestVersionForData(ze, I);
      }
      F = S.fromString(q, ce || 40);
    } else
      throw new Error("Invalid data");
    const Z = h.getBestVersionForData(F, I);
    if (!Z)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!X)
      X = Z;
    else if (X < Z)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + Z + `.
`
      );
    const te = k(X, I, F), ie = e.getSymbolSize(X), ue = new o(ie);
    return w(ue, X), T(ue), P(ue, X), L(ue, I, 0), X >= 7 && z(ue, X), x(ue, te), isNaN(U) && (U = d.getBestMask(
      ue,
      L.bind(null, ue, I)
    )), d.applyMask(U, ue), L(ue, I, U), {
      modules: ue,
      version: X,
      errorCorrectionLevel: I,
      maskPattern: U,
      segments: F
    };
  }
  return Yy.create = function(X, I) {
    if (typeof X > "u" || X === "")
      throw new Error("No input text");
    let U = t.M, F, Z;
    return typeof I < "u" && (U = t.from(I.errorCorrectionLevel, t.M), F = h.from(I.version), Z = d.from(I.maskPattern), I.toSJISFunc && e.setToSJISFunction(I.toSJISFunc)), B(X, F, U, Z);
  }, Yy;
}
var h2 = {}, p2 = {}, Iw;
function s8() {
  return Iw || (Iw = 1, (function(e) {
    function t(r) {
      if (typeof r == "number" && (r = r.toString()), typeof r != "string")
        throw new Error("Color should be defined as hex string");
      let o = r.slice().replace("#", "").split("");
      if (o.length < 3 || o.length === 5 || o.length > 8)
        throw new Error("Invalid hex color: " + r);
      (o.length === 3 || o.length === 4) && (o = Array.prototype.concat.apply([], o.map(function(u) {
        return [u, u];
      }))), o.length === 6 && o.push("F", "F");
      const l = parseInt(o.join(""), 16);
      return {
        r: l >> 24 & 255,
        g: l >> 16 & 255,
        b: l >> 8 & 255,
        a: l & 255,
        hex: "#" + o.slice(0, 6).join("")
      };
    }
    e.getOptions = function(o) {
      o || (o = {}), o.color || (o.color = {});
      const l = typeof o.margin > "u" || o.margin === null || o.margin < 0 ? 4 : o.margin, u = o.width && o.width >= 21 ? o.width : void 0, d = o.scale || 4;
      return {
        width: u,
        scale: u ? 4 : d,
        margin: l,
        color: {
          dark: t(o.color.dark || "#000000ff"),
          light: t(o.color.light || "#ffffffff")
        },
        type: o.type,
        rendererOpts: o.rendererOpts || {}
      };
    }, e.getScale = function(o, l) {
      return l.width && l.width >= o + l.margin * 2 ? l.width / (o + l.margin * 2) : l.scale;
    }, e.getImageWidth = function(o, l) {
      const u = e.getScale(o, l);
      return Math.floor((o + l.margin * 2) * u);
    }, e.qrToImageData = function(o, l, u) {
      const d = l.modules.size, f = l.modules.data, g = e.getScale(d, u), h = Math.floor((d + u.margin * 2) * g), v = u.margin * g, E = [u.color.light, u.color.dark];
      for (let S = 0; S < h; S++)
        for (let w = 0; w < h; w++) {
          let T = (S * h + w) * 4, P = u.color.light;
          if (S >= v && w >= v && S < h - v && w < h - v) {
            const z = Math.floor((S - v) / g), L = Math.floor((w - v) / g);
            P = E[f[z * d + L] ? 1 : 0];
          }
          o[T++] = P.r, o[T++] = P.g, o[T++] = P.b, o[T] = P.a;
        }
    };
  })(p2)), p2;
}
var Hw;
function BD() {
  return Hw || (Hw = 1, (function(e) {
    const t = s8();
    function r(l, u, d) {
      l.clearRect(0, 0, u.width, u.height), u.style || (u.style = {}), u.height = d, u.width = d, u.style.height = d + "px", u.style.width = d + "px";
    }
    function o() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(u, d, f) {
      let g = f, h = d;
      typeof g > "u" && (!d || !d.getContext) && (g = d, d = void 0), d || (h = o()), g = t.getOptions(g);
      const v = t.getImageWidth(u.modules.size, g), E = h.getContext("2d"), S = E.createImageData(v, v);
      return t.qrToImageData(S.data, u, g), r(E, h, v), E.putImageData(S, 0, 0), h;
    }, e.renderToDataURL = function(u, d, f) {
      let g = f;
      typeof g > "u" && (!d || !d.getContext) && (g = d, d = void 0), g || (g = {});
      const h = e.render(u, d, g), v = g.type || "image/png", E = g.rendererOpts || {};
      return h.toDataURL(v, E.quality);
    };
  })(h2)), h2;
}
var m2 = {}, Gw;
function UD() {
  if (Gw) return m2;
  Gw = 1;
  const e = s8();
  function t(l, u) {
    const d = l.a / 255, f = u + '="' + l.hex + '"';
    return d < 1 ? f + " " + u + '-opacity="' + d.toFixed(2).slice(1) + '"' : f;
  }
  function r(l, u, d) {
    let f = l + u;
    return typeof d < "u" && (f += " " + d), f;
  }
  function o(l, u, d) {
    let f = "", g = 0, h = !1, v = 0;
    for (let E = 0; E < l.length; E++) {
      const S = Math.floor(E % u), w = Math.floor(E / u);
      !S && !h && (h = !0), l[E] ? (v++, E > 0 && S > 0 && l[E - 1] || (f += h ? r("M", S + d, 0.5 + w + d) : r("m", g, 0), g = 0, h = !1), S + 1 < u && l[E + 1] || (f += r("h", v), v = 0)) : g++;
    }
    return f;
  }
  return m2.render = function(u, d, f) {
    const g = e.getOptions(d), h = u.modules.size, v = u.modules.data, E = h + g.margin * 2, S = g.color.light.a ? "<path " + t(g.color.light, "fill") + ' d="M0 0h' + E + "v" + E + 'H0z"/>' : "", w = "<path " + t(g.color.dark, "stroke") + ' d="' + o(v, h, g.margin) + '"/>', T = 'viewBox="0 0 ' + E + " " + E + '"', z = '<svg xmlns="http://www.w3.org/2000/svg" ' + (g.width ? 'width="' + g.width + '" height="' + g.width + '" ' : "") + T + ' shape-rendering="crispEdges">' + S + w + `</svg>
`;
    return typeof f == "function" && f(null, z), z;
  }, m2;
}
var Vw;
function ID() {
  if (Vw) return kf;
  Vw = 1;
  const e = _D(), t = zD(), r = BD(), o = UD();
  function l(u, d, f, g, h) {
    const v = [].slice.call(arguments, 1), E = v.length, S = typeof v[E - 1] == "function";
    if (!S && !e())
      throw new Error("Callback required as last argument");
    if (S) {
      if (E < 2)
        throw new Error("Too few arguments provided");
      E === 2 ? (h = f, f = d, d = g = void 0) : E === 3 && (d.getContext && typeof h > "u" ? (h = g, g = void 0) : (h = g, g = f, f = d, d = void 0));
    } else {
      if (E < 1)
        throw new Error("Too few arguments provided");
      return E === 1 ? (f = d, d = g = void 0) : E === 2 && !d.getContext && (g = f, f = d, d = void 0), new Promise(function(w, T) {
        try {
          const P = t.create(f, g);
          w(u(P, d, g));
        } catch (P) {
          T(P);
        }
      });
    }
    try {
      const w = t.create(f, g);
      h(null, u(w, d, g));
    } catch (w) {
      h(w);
    }
  }
  return kf.create = t.create, kf.toCanvas = l.bind(null, r.render), kf.toDataURL = l.bind(null, r.renderToDataURL), kf.toString = l.bind(null, function(u, d, f) {
    return o.render(u, f);
  }), kf;
}
var HD = ID();
const GD = /* @__PURE__ */ vm(HD), Ip = 4, Gu = 7, qw = "#171717", VD = (e) => e.replace(/[&<>"']/g, (t) => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&apos;"
})[t]), qD = (e, t, r) => e < Gu && t < Gu || e < Gu && t >= r - Gu || e >= r - Gu && t < Gu;
function ev(e, t) {
  if (!e) throw new Error("Could not create a QR code without a plot link.");
  let r;
  try {
    r = GD.create(e, { errorCorrectionLevel: "L" });
  } catch {
    throw new Error("This plot link is too long for a QR code. Use the JSON export instead.");
  }
  const o = r.modules.size, l = o + Ip * 2, u = [];
  for (let h = 0; h < o; h += 1)
    for (let v = 0; v < o; v += 1)
      !r.modules.get(h, v) || qD(h, v, o) || u.push(
        `<rect x="${v + Ip + 0.08}" y="${h + Ip + 0.08}" width="0.84" height="0.84" rx="0.22"/>`
      );
  const d = VD(t), f = (h, v) => {
    const E = h + Ip, S = v + Ip;
    return [
      `<rect x="${E}" y="${S}" width="7" height="7" rx="1.35" fill="${qw}"/>`,
      `<rect x="${E + 1}" y="${S + 1}" width="5" height="5" rx="0.9" fill="#fff"/>`,
      `<rect data-finder-centre="true" x="${E + 2}" y="${S + 2}" width="3" height="3" rx="0.7" fill="${d}"/>`
    ].join("");
  }, g = [
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${l} ${l}" shape-rendering="geometricPrecision">`,
    `<rect width="${l}" height="${l}" rx="2" fill="#fff"/>`,
    `<g fill="${qw}">${u.join("")}</g>`,
    f(0, 0),
    f(o - Gu, 0),
    f(0, o - Gu),
    "</svg>"
  ].join("");
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(g)}`;
}
const Yu = (e) => new Promise((t, r) => {
  const o = new Image();
  o.decoding = "async", o.onload = () => t(o), o.onerror = () => r(new Error(`Could not load export image: ${e}`)), o.src = e;
}), g2 = 297, l8 = 210, Q2 = 40.48, J2 = 50.6, Ww = 31.625, v2 = 5, WD = 40 / 25, KD = J2 / Q2;
function jD(e, t) {
  const r = Math.max(88, Math.round(Math.min(e * 0.13, t * 0.22))), o = Math.round(r * 1.265), l = Math.round(o * KD), u = Math.round(l / WD), d = Math.max(16, Math.round(o * 0.09)), f = Math.max(5, Math.round(o * 0.033));
  return {
    branding: {
      x: e - l - d,
      y: t - u - d,
      width: l,
      height: u
    },
    qrCode: {
      x: e - o - d,
      y: d,
      width: o,
      height: o
    },
    radius: f
  };
}
function YD(e, t = 5) {
  const r = Math.min(
    1,
    e.width / (J2 + v2 * 2),
    e.height / (Q2 + Ww + v2 * 3)
  ), o = v2 * r, l = J2 * r, u = Ww * r, d = Q2 * r, f = e.x + e.width, g = e.y + e.height, h = l8 - Math.max(5, t), v = Math.min(g - o, h);
  return {
    branding: {
      x: f - o - l,
      y: Math.max(e.y + o, v - u),
      width: l,
      height: u
    },
    qrCode: {
      x: f - o - d,
      y: e.y + o,
      width: d,
      height: d
    }
  };
}
function Kw(e, t, r, o, l, u, d = "center") {
  const f = Math.min(l / t.naturalWidth, u / t.naturalHeight), g = t.naturalWidth * f, h = t.naturalHeight * f, v = r + (l - g) / 2, E = d === "start" ? o : d === "end" ? o + u - h : o + (u - h) / 2;
  return e.drawImage(t, v, E, g, h), { x: v, y: E, width: g, height: h };
}
function u8(e, t, r, o, l, u, d, f) {
  const g = d / 2, h = u * 0.05, v = u * (4 / 200), E = u * (3 / 200), S = h + v, w = h + v, T = h, P = h, z = d * 0.025, L = Math.max(8, Math.round(d * 0.064)), x = d / 100;
  e.strokeStyle = "rgba(23, 23, 23, 0.18)", e.lineWidth = Math.max(1, d * 6e-3), e.beginPath(), e.moveTo(o, l + g), e.lineTo(o + u, l + g), e.stroke();
  const k = !!f.trim(), R = o + S - (k ? x : 0), B = u - S - w, q = k ? B * 0.28 : 0, X = k ? B * 0.04 : 0, I = k ? R + q + X + x : o + h + E, U = k ? B - q - X : u - h * 2 - E;
  e.fillStyle = "#171717", e.font = `600 ${L}px Arial, sans-serif`, e.textAlign = "left";
  const F = Kw(
    e,
    t,
    I,
    l + z,
    U,
    g - z * 2,
    "center"
  );
  if (k) {
    e.textBaseline = "bottom";
    const Z = F.y + F.height;
    e.fillText(f, R, Z);
  }
  Kw(
    e,
    r,
    o + T,
    l + g + z,
    u - T - P,
    g - z * 2,
    "center"
  );
}
function I0(e, t, r, o, l, u = !1) {
  e.save(), u && (e.shadowColor = "rgba(23, 23, 23, 0.12)", e.shadowBlur = Math.max(4, r * 0.8), e.shadowOffsetY = Math.max(1, r * 0.2)), e.fillStyle = o, e.beginPath(), e.roundRect(t.x, t.y, t.width, t.height, r), e.fill(), e.shadowColor = "transparent", e.beginPath(), e.roundRect(t.x, t.y, t.width, t.height, r), e.clip(), l(), e.restore();
}
function ZD(e, t, r) {
  const o = document.createElement("canvas");
  o.width = 1012, o.height = 633;
  const l = o.getContext("2d");
  if (!l) throw new Error("Could not prepare the PDF branding");
  const u = { x: 0, y: 0, width: o.width, height: o.height };
  return I0(l, u, 26, "rgba(255, 255, 255, 0.86)", () => {
    u8(
      l,
      e,
      t,
      0,
      0,
      o.width,
      o.height,
      r
    );
  }), o.toDataURL("image/png");
}
function XD(e) {
  const t = document.createElement("canvas");
  t.width = 810, t.height = 810;
  const r = t.getContext("2d");
  if (!r) throw new Error("Could not prepare the PDF QR code");
  const o = { x: 0, y: 0, width: t.width, height: t.height };
  return I0(r, o, 27, "#fff", () => {
    r.drawImage(e, 0, 0, t.width, t.height);
  }), t.toDataURL("image/png");
}
async function QD(e, t) {
  const r = ev(t.plotUrl, t.primaryColor), [{ jsPDF: o }, l, u, d, f] = await Promise.all([
    import("./jspdf.es.min-D4BLQNl9.js").then((w) => w.j),
    Yu(e),
    Yu(r),
    Yu(t.analyticsLogoUrl),
    Yu(t.productLogoUrl)
  ]), g = new o({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
    compress: !0
  }), h = g2 * (l.naturalHeight / l.naturalWidth), v = (l8 - h) / 2, S = YD({
    x: 0,
    y: v,
    width: g2,
    height: h
  }, t.watermarkBottomMm);
  return g.setProperties({ title: t.title }), g.addImage(
    e,
    "PNG",
    0,
    v,
    g2,
    h,
    void 0,
    "FAST"
  ), g.addImage(
    ZD(d, f, t.partnerLabel),
    "PNG",
    S.branding.x,
    S.branding.y,
    S.branding.width,
    S.branding.height,
    void 0,
    "FAST"
  ), g.addImage(
    XD(u),
    "PNG",
    S.qrCode.x,
    S.qrCode.y,
    S.qrCode.width,
    S.qrCode.height,
    void 0,
    "FAST"
  ), t.productUrl && g.link(
    S.branding.x,
    S.branding.y + S.branding.height / 2,
    S.branding.width,
    S.branding.height / 2,
    {
      url: t.productUrl
    }
  ), t.analyticsUrl && g.link(
    S.branding.x,
    S.branding.y,
    S.branding.width,
    S.branding.height / 2,
    { url: t.analyticsUrl }
  ), g.link(S.qrCode.x, S.qrCode.y, S.qrCode.width, S.qrCode.height, {
    url: t.plotUrl
  }), g.output("blob");
}
async function jw(e, t) {
  const r = ev(t.plotUrl, t.primaryColor), [o, l, u, d] = await Promise.all([
    Yu(e),
    Yu(r),
    Yu(t.analyticsLogoUrl),
    Yu(t.productLogoUrl)
  ]), f = document.createElement("canvas");
  f.width = o.naturalWidth, f.height = o.naturalHeight;
  const g = f.getContext("2d");
  if (!g) throw new Error("Could not prepare the watermarked export image");
  g.drawImage(o, 0, 0);
  const h = jD(f.width, f.height);
  return I0(
    g,
    h.branding,
    h.radius,
    "rgba(255, 255, 255, 0.86)",
    () => {
      u8(
        g,
        u,
        d,
        h.branding.x,
        h.branding.y,
        h.branding.width,
        h.branding.height,
        t.partnerLabel
      );
    },
    !0
  ), I0(
    g,
    h.qrCode,
    h.radius,
    "#fff",
    () => {
      g.drawImage(
        l,
        h.qrCode.x,
        h.qrCode.y,
        h.qrCode.width,
        h.qrCode.height
      );
    },
    !0
  ), f.toDataURL("image/png");
}
const Yw = 30, y2 = 30, JD = 1200, $D = 1600, c8 = (e, t, r = 1) => {
  if (e <= 1) return [1];
  const o = Q6 / 1e3, l = Math.max(Number.EPSILON, r), u = Math.max(
    1,
    Math.round((e - 1) * o * t / l)
  );
  return Array.from(
    { length: u + 1 },
    (d, f) => 1 + (e - 1) * f / u
  );
}, eL = (e) => 1 / e, tL = (e, t) => {
  const r = Math.round(t * 100 / e), o = Math.round((t + 1) * 100 / e);
  return Math.max(1, o - r) * 10;
}, d8 = (e) => new Promise((t, r) => {
  const o = new Image();
  o.onload = () => t(o), o.onerror = () => r(new Error("Could not render an animation frame")), o.src = e;
}), nL = (e, t, r, o = !1) => {
  const l = Math.min(1, r / e);
  let u = Math.max(1, Math.round(e * l)), d = Math.max(1, Math.round(t * l));
  return o && (u += u % 2, d += d % 2), { width: u, height: d };
}, f8 = async (e, t, r = !1) => {
  const o = await d8(e), { width: l, height: u } = nL(
    o.naturalWidth,
    o.naturalHeight,
    t,
    r
  ), d = document.createElement("canvas");
  d.width = l, d.height = u;
  const f = d.getContext("2d", { alpha: !0 });
  if (!f) throw new Error("Could not prepare the animation export");
  return { canvas: d, context: f, firstImage: o };
}, Tb = (e, t, r) => {
  e.clearRect(0, 0, t.width, t.height), e.drawImage(r, 0, 0, t.width, t.height);
}, rL = () => new Promise((e) => window.setTimeout(e, 0)), h8 = async (e, t, r) => {
  const o = await d8(e);
  Tb(r, t, o);
};
async function aL(e) {
  var v;
  const t = c8(
    e.lastPosition,
    Yw,
    e.speed
  ), r = await e.renderFrame(t[0], e.transparent), { canvas: o, context: l, firstImage: u } = await f8(r, JD), { GIFEncoder: d, applyPalette: f, quantize: g } = await import("./gifenc.esm-48qFK9lH.js"), h = d();
  for (let E = 0; E < t.length; E += 1) {
    if (E === 0) Tb(l, o, u);
    else {
      const L = await e.renderFrame(t[E], e.transparent);
      await h8(L, o, l);
    }
    const S = l.getImageData(0, 0, o.width, o.height), w = e.transparent ? "rgba4444" : "rgb565", T = g(S.data, 256, {
      format: w,
      oneBitAlpha: e.transparent
    }), P = f(S.data, T, w), z = e.transparent ? T.findIndex((L) => L[3] === 0) : -1;
    if (z >= 0)
      for (let L = 0; L < P.length; L += 1)
        S.data[L * 4 + 3] <= 127 && (P[L] = z);
    h.writeFrame(P, o.width, o.height, {
      palette: T,
      delay: tL(Yw, E),
      repeat: 0,
      transparent: z >= 0,
      transparentIndex: Math.max(0, z),
      dispose: e.transparent ? 2 : -1
    }), (v = e.onProgress) == null || v.call(e, (E + 1) / t.length), E % 4 === 3 && await rL();
  }
  return h.finish(), new Blob([h.bytes()], { type: "image/gif" });
}
async function iL(e) {
  var L;
  const t = c8(
    e.lastPosition,
    y2,
    e.speed
  ), r = await e.renderFrame(t[0], !1), { canvas: o, context: l, firstImage: u } = await f8(r, $D, !0), { BufferTarget: d, CanvasSource: f, Mp4OutputFormat: g, Output: h, Quality: v, canEncodeVideo: E } = await import("./index-D1RKuNTe.js");
  if (!await E("avc", {
    width: o.width,
    height: o.height,
    quality: new v("high")
  }))
    throw new Error("MP4 export is not supported by this browser");
  const w = new h({
    format: new g({ fastStart: "in-memory" }),
    target: new d()
  }), T = new f(o, {
    codec: "avc",
    quality: new v("high"),
    keyFrameInterval: 2
  });
  w.addVideoTrack(T), await w.start();
  const P = eL(y2);
  try {
    for (let x = 0; x < t.length; x += 1) {
      if (x === 0) Tb(l, o, u);
      else {
        const k = await e.renderFrame(t[x], !1);
        await h8(k, o, l);
      }
      await T.add(x * P, P, {
        keyFrame: x % (y2 * 2) === 0
      }), (L = e.onProgress) == null || L.call(e, (x + 1) / t.length);
    }
    await w.finalize();
  } catch (x) {
    throw w.state !== "finalized" && await w.cancel(), x;
  }
  const z = w.target.buffer;
  if (!z) throw new Error("Could not finalize the MP4 export");
  return new Blob([z], { type: "video/mp4" });
}
function oL(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    throw new Error("This file does not contain valid JSON.");
  }
  const r = t == null ? void 0 : t.version;
  if (typeof r == "number" && r > 1)
    throw new Error(`Format version ${r} is not supported by this app.`);
  const o = u6.safeParse(t);
  if (!o.success) {
    const l = o.error.issues[0];
    throw new Error(`Invalid plot at ${l.path.join(".") || "root"}: ${l.message}`);
  }
  return mb(t);
}
const sL = (e) => JSON.stringify(e, null, 2), p8 = (e, t) => {
  const r = document.createElement("a");
  r.hidden = !0, r.rel = "noopener", r.href = e, r.download = t, document.body.append(r), r.click(), r.remove();
}, $2 = (e, t, r) => {
  const o = e instanceof Blob && e.type === r ? e : new Blob([e], { type: r }), l = URL.createObjectURL(o);
  p8(l, t), window.setTimeout(() => URL.revokeObjectURL(l), 3e4);
}, lL = () => new Promise((e) => {
  window.requestAnimationFrame(() => window.requestAnimationFrame(() => e()));
}), uL = async (e, t) => {
  if (window.isSecureContext) {
    $2(e, t, "application/pdf");
    return;
  }
  const r = await new Promise((o, l) => {
    const u = new FileReader();
    u.onload = () => typeof u.result == "string" ? o(u.result) : l(new Error("Could not prepare the PDF download")), u.onerror = () => l(u.error ?? new Error("Could not prepare the PDF download")), u.readAsDataURL(e);
  });
  p8(r, t);
};
function Yc({ label: e, children: t }) {
  return /* @__PURE__ */ le("span", { className: "export-info", children: [
    /* @__PURE__ */ D("button", { type: "button", "aria-label": e, className: "export-info-button", children: /* @__PURE__ */ D(_0, { "aria-hidden": "true" }) }),
    /* @__PURE__ */ D("span", { className: "export-info-tooltip", role: "tooltip", children: t })
  ] });
}
function Zw({
  label: e,
  min: t,
  max: r,
  value: o,
  unit: l,
  centered: u = !1,
  onChange: d
}) {
  const { t: f } = jn(), g = (h) => {
    const v = Number(h);
    d(Math.min(r, Math.max(t, Number.isFinite(v) ? v : t)));
  };
  return /* @__PURE__ */ le("label", { className: "field scene-range-field", children: [
    /* @__PURE__ */ D("span", { children: e }),
    /* @__PURE__ */ le("div", { className: "scene-range-control", children: [
      /* @__PURE__ */ le("div", { className: "input-with-unit", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "number",
            min: t,
            max: r,
            step: "1",
            value: o,
            "aria-label": f("{label} value", { label: e }),
            onChange: (h) => g(h.target.value)
          }
        ),
        /* @__PURE__ */ D("span", { children: l })
      ] }),
      u ? /* @__PURE__ */ le("div", { className: "scene-range-slider scene-range-slider--centered", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "range",
            min: t,
            max: r,
            step: "1",
            value: o,
            "aria-label": f("{label} slider", { label: e }),
            onChange: (h) => g(h.target.value)
          }
        ),
        /* @__PURE__ */ le("span", { className: "scene-range-scale", "aria-hidden": "true", children: [
          /* @__PURE__ */ D("span", { children: "−180°" }),
          /* @__PURE__ */ D("span", { children: "0°" }),
          /* @__PURE__ */ D("span", { children: "+180°" })
        ] })
      ] }) : /* @__PURE__ */ D(
        "input",
        {
          type: "range",
          min: t,
          max: r,
          step: "1",
          value: o,
          "aria-label": f("{label} slider", { label: e }),
          onChange: (h) => g(h.target.value)
        }
      )
    ] })
  ] });
}
function Xw({
  embedded: e = !1,
  onResetView: t
}) {
  const { t: r } = jn(), [o, l] = Gn(!1), [u, d] = Gn(!1), f = e ? "compact-endless-plot-info" : "endless-plot-info", g = e ? "compact-boat-length-basis" : "boat-length-basis", h = `${g}-info`, v = yt((L) => L.scenario), E = yt((L) => L.updateCanvas), S = yt((L) => L.patchScenario), w = yt((L) => L.updateEnvironment), T = X0(
    v.objects,
    v.environment.measurementBoatClass
  ), P = Qu(v.canvas.background), z = (L) => {
    const x = TT(
      v.canvas.grid.opacity,
      v.canvas.background,
      L
    );
    if (L === v.canvas.background && x === v.canvas.grid.opacity)
      return;
    const k = L === v.canvas.background ? v.objects : v.objects.map(
      (R) => R.type === "boat" && P2.includes(R.boatClass) ? {
        ...R,
        color: Ju(
          R.boatClass,
          MT(
            R.color,
            v.canvas.background,
            L
          )
        )
      } : R
    );
    S({
      canvas: {
        ...v.canvas,
        background: L,
        grid: { ...v.canvas.grid, opacity: x }
      },
      objects: k
    });
  };
  return /* @__PURE__ */ le("section", { className: `scene-settings ${e ? "scene-settings--embedded" : ""}`, children: [
    !e && /* @__PURE__ */ le("div", { className: "section-title", children: [
      /* @__PURE__ */ D(sx, { "aria-hidden": "true" }),
      /* @__PURE__ */ D("span", { children: r("Scene") })
    ] }),
    /* @__PURE__ */ le("div", { className: "scene-toggle-grid", children: [
      /* @__PURE__ */ le("label", { className: "check-row", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "checkbox",
            checked: v.canvas.grid.visible,
            onChange: (L) => E({
              grid: { ...v.canvas.grid, visible: L.target.checked }
            })
          }
        ),
        " ",
        r("Show grid")
      ] }),
      /* @__PURE__ */ le("label", { className: "check-row", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "checkbox",
            checked: v.environment.laylinesVisible,
            onChange: (L) => w({ laylinesVisible: L.target.checked })
          }
        ),
        " ",
        r("Show laylines")
      ] }),
      /* @__PURE__ */ le("label", { className: "check-row", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "checkbox",
            checked: v.environment.windVisible,
            onChange: (L) => w({ windVisible: L.target.checked })
          }
        ),
        " ",
        r("Show wind")
      ] }),
      /* @__PURE__ */ le("label", { className: "check-row", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "checkbox",
            checked: v.environment.zonesVisible,
            onChange: (L) => w({ zonesVisible: L.target.checked })
          }
        ),
        r("Show zones")
      ] }),
      /* @__PURE__ */ le("label", { className: "check-row", children: [
        /* @__PURE__ */ D(
          "input",
          {
            type: "checkbox",
            checked: v.canvas.boatNumbersVisible,
            onChange: (L) => E({ boatNumbersVisible: L.target.checked })
          }
        ),
        r("Show boat numbers")
      ] })
    ] }),
    /* @__PURE__ */ le("div", { className: "field endless-plot-field", children: [
      /* @__PURE__ */ le("div", { className: "field-label-row", children: [
        /* @__PURE__ */ D("span", { children: r("Endless plot") }),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: "field-info-button",
            "aria-label": r("About Endless plot"),
            "aria-expanded": o,
            "aria-controls": f,
            title: r("About Endless plot"),
            onClick: () => l((L) => !L),
            children: /* @__PURE__ */ D(_0, { "aria-hidden": "true" })
          }
        )
      ] }),
      /* @__PURE__ */ le("div", { className: "endless-plot-control", children: [
        /* @__PURE__ */ le(
          "div",
          {
            className: "plot-background-switch endless-plot-switch",
            role: "group",
            "aria-label": r("Endless plot"),
            children: [
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  "aria-pressed": v.canvas.infinite,
                  className: v.canvas.infinite ? "is-active" : "",
                  onClick: () => E({ infinite: !0 }),
                  children: r("On")
                }
              ),
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  "aria-pressed": !v.canvas.infinite,
                  className: v.canvas.infinite ? "" : "is-active",
                  onClick: () => E({ infinite: !1 }),
                  children: r("Off")
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ D(
          pr,
          {
            compact: !0,
            className: "endless-plot-home-button",
            icon: /* @__PURE__ */ D(p7, { "aria-hidden": "true" }),
            label: r("Return to the central plot position"),
            onClick: t
          }
        )
      ] }),
      o && /* @__PURE__ */ D("p", { id: f, className: "field-info", role: "status", children: r(
        "Removes fixed plot edges. When enabled, the wind indicator and boat legend can be moved freely."
      ) })
    ] }),
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("span", { children: r("Plot background") }),
      /* @__PURE__ */ le("div", { className: "plot-background-switch", role: "group", "aria-label": r("Plot background"), children: [
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            "aria-pressed": !P,
            className: P ? "" : "is-active",
            onClick: () => z(od.light),
            children: r("Light")
          }
        ),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            "aria-pressed": P,
            className: P ? "is-active" : "",
            onClick: () => z(od.dark),
            children: r("Dark")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("span", { children: r("Boat legend") }),
      /* @__PURE__ */ le("div", { className: "plot-background-switch", role: "group", "aria-label": r("Boat legend"), children: [
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            "aria-pressed": v.canvas.boatLegendVisible,
            className: v.canvas.boatLegendVisible ? "is-active" : "",
            onClick: () => E({ boatLegendVisible: !0 }),
            children: r("On")
          }
        ),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            "aria-pressed": !v.canvas.boatLegendVisible,
            className: v.canvas.boatLegendVisible ? "" : "is-active",
            onClick: () => E({ boatLegendVisible: !1 }),
            children: r("Off")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ le("div", { className: "field-label-row", children: [
        /* @__PURE__ */ le("label", { htmlFor: g, children: [
          "BL · ",
          r("Boat-length basis")
        ] }),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: "field-info-button",
            "aria-label": r("How BL is calculated"),
            "aria-expanded": u,
            "aria-controls": h,
            title: r("How BL is calculated"),
            onClick: () => d((L) => !L),
            children: /* @__PURE__ */ D(_0, { "aria-hidden": "true" })
          }
        )
      ] }),
      /* @__PURE__ */ le(
        "select",
        {
          id: g,
          "aria-label": r("Boat-length basis"),
          value: v.environment.measurementBoatClass ?? "",
          onChange: (L) => w({
            measurementBoatClass: L.target.value || null
          }),
          children: [
            /* @__PURE__ */ le("option", { value: "", children: [
              r("Default"),
              " - ",
              r(T.boatClass)
            ] }),
            P2.map((L) => /* @__PURE__ */ D("option", { value: L, children: r(L) }, L))
          ]
        }
      ),
      u && /* @__PURE__ */ D("p", { id: h, className: "field-info", role: "status", children: r(
        "Default uses the longest sailing boat class in the plot. Committee, umpire and coach boats are excluded. Current basis: {boatClass}.",
        { boatClass: r(T.boatClass) }
      ) })
    ] }),
    /* @__PURE__ */ le("div", { className: "field grid-spacing-field", children: [
      /* @__PURE__ */ D("span", { children: r("Grid spacing") }),
      /* @__PURE__ */ D("strong", { children: r("1 BL · {boatClass}", { boatClass: r(T.boatClass) }) })
    ] }),
    /* @__PURE__ */ D(
      Zw,
      {
        label: r("Wind direction"),
        min: -180,
        max: 180,
        value: PT(v.environment.windDirection),
        unit: "°",
        centered: !0,
        onChange: (L) => w({ windDirection: L })
      }
    ),
    /* @__PURE__ */ D(
      Zw,
      {
        label: r("Grid visibility"),
        min: 0,
        max: 100,
        value: Math.round(v.canvas.grid.opacity * 100),
        unit: "%",
        onChange: (L) => E({ grid: { ...v.canvas.grid, opacity: L / 100 } })
      }
    )
  ] });
}
function Qw({
  compact: e = !1,
  playing: t,
  position: r,
  lastPosition: o,
  speed: l,
  tailsVisible: u,
  onPlayingChange: d,
  onPositionChange: f,
  onSpeedChange: g,
  onTailsVisibleChange: h,
  onExport: v,
  onExit: E
}) {
  const { t: S } = jn(), w = Math.max(1, Math.floor(r)), T = Math.min(o, Math.ceil(r)), P = w === T ? S("Position {position} of {count}", { position: w, count: o }) : S("Position {from} → {to} of {count}", { from: w, to: T, count: o }), z = () => {
    !t && r >= o && f(1), d(!t);
  };
  return /* @__PURE__ */ le(
    "section",
    {
      className: `playback-controls ${e ? "playback-controls--compact" : ""}`,
      "aria-label": S("Player controls"),
      children: [
        !e && /* @__PURE__ */ le("div", { className: "panel-header panel-header--tools playback-panel-header", children: [
          /* @__PURE__ */ le("div", { children: [
            /* @__PURE__ */ D("span", { className: "eyebrow", children: S("View") }),
            /* @__PURE__ */ D("h2", { children: S("Player") })
          ] }),
          /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              className: "tool-cancel-button playback-close-button",
              icon: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" }),
              label: S("Back to editor"),
              onClick: E
            }
          )
        ] }),
        /* @__PURE__ */ le("div", { className: "playback-transport", role: "group", "aria-label": S("Playback controls"), children: [
          /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              icon: /* @__PURE__ */ D(E7, { "aria-hidden": "true" }),
              label: S("Previous position"),
              disabled: r <= 1,
              onClick: () => {
                d(!1), f(Math.max(1, Math.ceil(r) - 1));
              }
            }
          ),
          /* @__PURE__ */ D(
            pr,
            {
              className: "playback-primary-button",
              compact: !0,
              icon: t ? /* @__PURE__ */ D(S7, { "aria-hidden": "true" }) : /* @__PURE__ */ D(H0, { "aria-hidden": "true" }),
              label: S(t ? "Pause" : "Play"),
              onClick: z
            }
          ),
          /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              icon: /* @__PURE__ */ D(R7, { "aria-hidden": "true" }),
              label: S("Next position"),
              disabled: r >= o,
              onClick: () => {
                d(!1), f(Math.min(o, Math.floor(r) + 1));
              }
            }
          )
        ] }),
        /* @__PURE__ */ le("label", { className: "playback-timeline", children: [
          /* @__PURE__ */ D("span", { children: P }),
          /* @__PURE__ */ D(
            "input",
            {
              type: "range",
              min: "1",
              max: o,
              step: "0.01",
              value: r,
              "aria-label": S("Playback timeline"),
              onChange: (L) => {
                d(!1), f(Number(L.target.value));
              }
            }
          )
        ] }),
        /* @__PURE__ */ le("div", { className: "playback-settings", children: [
          /* @__PURE__ */ le("div", { className: "field playback-speed-field", children: [
            /* @__PURE__ */ D("span", { children: S("Speed") }),
            /* @__PURE__ */ D("div", { className: "plot-background-switch", role: "group", "aria-label": S("Playback speed"), children: [0.5, 1, 2].map((L) => /* @__PURE__ */ le(
              "button",
              {
                type: "button",
                "aria-pressed": l === L,
                className: l === L ? "is-active" : "",
                onClick: () => g(L),
                children: [
                  L,
                  "×"
                ]
              },
              L
            )) })
          ] }),
          /* @__PURE__ */ le("div", { className: "field playback-tail-field", children: [
            /* @__PURE__ */ D("span", { children: S("Boat tails") }),
            /* @__PURE__ */ le("div", { className: "plot-background-switch", role: "group", "aria-label": S("Boat tails"), children: [
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  "aria-pressed": u,
                  className: u ? "is-active" : "",
                  onClick: () => h(!0),
                  children: S("On")
                }
              ),
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  "aria-pressed": !u,
                  className: u ? "" : "is-active",
                  onClick: () => h(!1),
                  children: S("Off")
                }
              )
            ] })
          ] })
        ] }),
        /* @__PURE__ */ le(
          "button",
          {
            type: "button",
            className: `secondary-button playback-export-button ${e ? "playback-export-button--compact" : ""}`,
            "aria-label": e ? S("Export animation") : void 0,
            title: e ? S("Export animation") : void 0,
            onClick: v,
            children: [
              /* @__PURE__ */ D(ix, { "aria-hidden": "true" }),
              !e && S("Export animation")
            ]
          }
        ),
        /* @__PURE__ */ le(
          "button",
          {
            type: "button",
            className: `secondary-button playback-exit-button ${e ? "tool-cancel-button playback-exit-button--compact" : ""}`,
            "aria-label": e ? S("Back to editor") : void 0,
            title: e ? S("Back to editor") : void 0,
            onClick: E,
            children: [
              /* @__PURE__ */ D(Jc, { "aria-hidden": "true" }),
              !e && S("Back to editor")
            ]
          }
        )
      ]
    }
  );
}
function cL({ hasSelection: e }) {
  const { t } = jn(), [r, o] = Gn(!1), l = yt((E) => E.scenario), u = yt((E) => E.selectedIds), d = l.objects.filter((E) => u.includes(E.id)), f = d[0], g = f ? {
    boat: "Boat",
    mark: "Mark",
    gate: "Gate",
    "start-line": "Start line",
    "finish-line": "Finish line",
    line: "Line",
    arrow: "Arrow",
    freehand: "Freehand",
    text: "Text",
    rectangle: "Rectangle",
    circle: "Circle"
  }[f.type] : "Properties", h = [t("Properties")];
  d.length > 1 ? h.push(t("{count} objects", { count: d.length })) : (f == null ? void 0 : f.type) === "boat" ? (h.push(t(f.boatClass)), f.sailNumber.trim() && h.push(f.sailNumber.trim()), f.name.trim() && h.push(f.name.trim())) : (f == null ? void 0 : f.type) === "mark" ? h.push(t("Mark {number}", { number: f.markNumber })) : f && h.push(t(g));
  const v = h.join(" – ");
  return /* @__PURE__ */ D("div", { className: "mobile-properties", "data-selected": e, "data-open": r, children: e && /* @__PURE__ */ le(Fr, { children: [
    /* @__PURE__ */ le(
      "button",
      {
        type: "button",
        className: "mobile-properties-toggle",
        "aria-label": t(r ? "Collapse properties" : "Expand properties"),
        "aria-expanded": r,
        "aria-controls": "mobile-properties-body",
        onClick: () => o((E) => !E),
        children: [
          /* @__PURE__ */ D("span", { className: "mobile-properties-title", title: v, children: v }),
          r ? /* @__PURE__ */ D(s7, { "aria-hidden": "true" }) : /* @__PURE__ */ D(ax, { "aria-hidden": "true" })
        ]
      }
    ),
    /* @__PURE__ */ D("div", { id: "mobile-properties-body", className: "mobile-properties-body", hidden: !r, children: /* @__PURE__ */ D(n8, {}) })
  ] }) });
}
function dL({
  onInfo: e,
  extensions: t,
  extensionContext: r
}) {
  const { t: o } = jn(), l = Zo(), [u, d] = Gn(!1), f = Wa(null), g = D6(l), h = g.length + (l.ui.help ? 1 : 0), v = h === 1 ? g[0] : void 0, E = h === 1 && l.ui.help, S = t.compactBrandingContent, w = `mobile-branding-partner${l.branding.partnerLabel ? "" : " mobile-branding-partner--logo-only"}`;
  return En(() => {
    if (!u) return;
    const T = (z) => {
      var L;
      (L = f.current) != null && L.contains(z.target) || d(!1);
    }, P = (z) => {
      z.key === "Escape" && d(!1);
    };
    return window.addEventListener("pointerdown", T), window.addEventListener("keydown", P), () => {
      window.removeEventListener("pointerdown", T), window.removeEventListener("keydown", P);
    };
  }, [u]), l.ui.footer ? /* @__PURE__ */ le("aside", { className: "mobile-branding-bar", "aria-label": l.texts.footerText, children: [
    /* @__PURE__ */ D("div", { className: "mobile-branding-product", children: /* @__PURE__ */ D("a", { href: l.links.app ?? void 0, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ D("img", { src: l.branding.exportProductLogo, alt: l.branding.logoAlt }) }) }),
    /* @__PURE__ */ D("div", { className: "mobile-branding-partner-column", children: /* @__PURE__ */ le(
      "div",
      {
        ref: f,
        className: `mobile-branding-partner-menu${l.branding.partnerLabel ? "" : " mobile-branding-partner-menu--logo-only"}`,
        children: [
          v ? /* @__PURE__ */ le(
            "a",
            {
              className: w,
              href: v.url,
              target: /^https?:/iu.test(v.url) ? "_blank" : void 0,
              rel: /^https?:/iu.test(v.url) ? "noopener noreferrer" : void 0,
              "aria-label": `${l.branding.partnerName}: ${o(v.label)}`,
              children: [
                l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
                /* @__PURE__ */ D("img", { src: l.branding.exportWatermarkLogo, alt: l.branding.partnerName })
              ]
            }
          ) : h > 0 ? /* @__PURE__ */ le(
            "button",
            {
              type: "button",
              className: w,
              "aria-label": `${l.branding.partnerName}: ${o(E ? "Information" : "Open menu")}`,
              "aria-haspopup": h > 1 ? "menu" : void 0,
              "aria-expanded": h > 1 ? u : void 0,
              onClick: () => {
                E ? e() : d((T) => !T);
              },
              children: [
                l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
                /* @__PURE__ */ D("img", { src: l.branding.exportWatermarkLogo, alt: l.branding.partnerName })
              ]
            }
          ) : /* @__PURE__ */ le("div", { className: w, children: [
            l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
            /* @__PURE__ */ D("img", { src: l.branding.exportWatermarkLogo, alt: l.branding.partnerName })
          ] }),
          u && /* @__PURE__ */ le("div", { className: "mobile-branding-menu-popover", role: "menu", children: [
            l.ui.help && /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                role: "menuitem",
                onClick: () => {
                  d(!1), e();
                },
                children: o("Information")
              }
            ),
            g.map((T) => /* @__PURE__ */ D(
              "a",
              {
                href: T.url,
                target: /^https?:/iu.test(T.url) ? "_blank" : void 0,
                rel: /^https?:/iu.test(T.url) ? "noopener noreferrer" : void 0,
                role: "menuitem",
                onClick: () => d(!1),
                children: o(T.label)
              },
              `${T.label}:${T.url}`
            ))
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ D("div", { className: "mobile-branding-spacer", children: S && /* @__PURE__ */ D(S, { ...r }) })
  ] }) : null;
}
function fL({ onOpen: e }) {
  const { t } = jn(), r = Zo(), o = rb(r), l = yt((f) => f.scenario), u = ta(
    () => r.links.qrCode ?? Qp(l),
    [r.links.qrCode, l]
  ), d = ta(() => {
    try {
      return ev(u, o);
    } catch {
      return null;
    }
  }, [u, o]);
  return d ? /* @__PURE__ */ D(
    "button",
    {
      type: "button",
      className: "canvas-plot-qr",
      "aria-label": t("Open this plot"),
      "aria-haspopup": "dialog",
      onClick: e,
      children: /* @__PURE__ */ D("img", { src: d, alt: t("QR code for this plot") })
    }
  ) : null;
}
function hL({
  onInfo: e,
  extensions: t,
  extensionContext: r
}) {
  var T;
  const { t: o } = jn(), l = Zo(), [u, d] = Gn(!1), f = Wa(null), g = D6(l), h = g.length + (l.ui.help ? 1 : 0), v = h === 1 ? g[0] : void 0, E = h === 1 && l.ui.help, S = `canvas-branding-partner${l.branding.partnerLabel ? "" : " canvas-branding-partner--logo-only"}`, w = t.footer;
  return En(() => {
    if (!u) return;
    const P = (L) => {
      var x;
      (x = f.current) != null && x.contains(L.target) || d(!1);
    }, z = (L) => {
      L.key === "Escape" && d(!1);
    };
    return window.addEventListener("pointerdown", P), window.addEventListener("keydown", z), () => {
      window.removeEventListener("pointerdown", P), window.removeEventListener("keydown", z);
    };
  }, [u]), l.ui.footer ? /* @__PURE__ */ le("aside", { className: "canvas-branding", "aria-label": l.texts.footerText, children: [
    w ? /* @__PURE__ */ D(w, { ...r }) : /* @__PURE__ */ D(Fr, { children: /* @__PURE__ */ D("div", { className: "canvas-branding-visual", children: /* @__PURE__ */ le("div", { className: "canvas-branding-logos", children: [
      /* @__PURE__ */ D(
        "a",
        {
          className: "canvas-branding-product",
          href: l.links.app ?? void 0,
          target: "_blank",
          rel: "noopener noreferrer",
          children: /* @__PURE__ */ D("img", { src: l.branding.exportProductLogo, alt: l.branding.logoAlt })
        }
      ),
      /* @__PURE__ */ le("div", { ref: f, className: "canvas-branding-partner-section", children: [
        v ? /* @__PURE__ */ le(
          "a",
          {
            className: S,
            href: v.url,
            target: /^https?:/iu.test(v.url) ? "_blank" : void 0,
            rel: /^https?:/iu.test(v.url) ? "noopener noreferrer" : void 0,
            "aria-label": `${l.branding.partnerName}: ${o(v.label)}`,
            children: [
              l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
              /* @__PURE__ */ D(
                "img",
                {
                  src: l.branding.exportWatermarkLogo,
                  alt: l.branding.partnerName
                }
              )
            ]
          }
        ) : h > 0 ? /* @__PURE__ */ le(
          "button",
          {
            type: "button",
            className: S,
            "aria-label": `${l.branding.partnerName}: ${o(E ? "Information" : "Open menu")}`,
            "aria-haspopup": h > 1 ? "menu" : void 0,
            "aria-expanded": h > 1 ? u : void 0,
            onClick: () => {
              E ? e() : d((P) => !P);
            },
            children: [
              l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
              /* @__PURE__ */ D(
                "img",
                {
                  src: l.branding.exportWatermarkLogo,
                  alt: l.branding.partnerName
                }
              )
            ]
          }
        ) : /* @__PURE__ */ le("div", { className: S, children: [
          l.branding.partnerLabel && /* @__PURE__ */ D("span", { children: l.branding.partnerLabel }),
          /* @__PURE__ */ D(
            "img",
            {
              src: l.branding.exportWatermarkLogo,
              alt: l.branding.partnerName
            }
          )
        ] }),
        u && /* @__PURE__ */ le("div", { className: "canvas-branding-menu-popover", role: "menu", children: [
          l.ui.help && /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              role: "menuitem",
              onClick: () => {
                d(!1), e();
              },
              children: o("Information")
            }
          ),
          g.map((P) => /* @__PURE__ */ D(
            "a",
            {
              href: P.url,
              target: /^https?:/iu.test(P.url) ? "_blank" : void 0,
              rel: /^https?:/iu.test(P.url) ? "noopener noreferrer" : void 0,
              role: "menuitem",
              onClick: () => d(!1),
              children: o(P.label)
            },
            `${P.label}:${P.url}`
          ))
        ] })
      ] })
    ] }) }) }),
    (T = t.footerExtensions) == null ? void 0 : T.map((P, z) => /* @__PURE__ */ D(P, { ...r }, z)),
    l.ui.poweredBySailPlot && /* @__PURE__ */ D("span", { className: "brand-credit-powered-by", children: l.texts.poweredByText })
  ] }) : null;
}
function fd({
  title: e,
  children: t,
  onClose: r,
  wide: o = !1
}) {
  const { t: l } = jn();
  return En(() => {
    const u = (d) => d.key === "Escape" && r();
    return window.addEventListener("keydown", u), () => window.removeEventListener("keydown", u);
  }, [r]), /* @__PURE__ */ D(
    "div",
    {
      className: "modal-backdrop",
      role: "presentation",
      onMouseDown: (u) => u.target === u.currentTarget && r(),
      children: /* @__PURE__ */ le(
        "section",
        {
          className: `modal ${o ? "modal--wide" : ""}`,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "modal-title",
          children: [
            /* @__PURE__ */ le("header", { children: [
              /* @__PURE__ */ D("h2", { id: "modal-title", children: e }),
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  className: "close-button",
                  onClick: r,
                  "aria-label": l("Close dialog"),
                  children: "×"
                }
              )
            ] }),
            /* @__PURE__ */ D("div", { className: "modal-body", children: t })
          ]
        }
      )
    }
  );
}
function pL({ onClose: e }) {
  const { t } = jn(), r = Zo(), o = rb(r), l = yt((g) => g.scenario), u = ta(
    () => r.links.qrCode ?? Qp(l),
    [r.links.qrCode, l]
  ), d = ta(
    () => ev(u, o),
    [u, o]
  ), f = () => {
    const g = window.open(u, "_blank", "noopener,noreferrer");
    g && (g.opener = null);
  };
  return /* @__PURE__ */ D(fd, { title: t("QR code for this plot"), onClose: e, children: /* @__PURE__ */ le("div", { className: "plot-qr-dialog", children: [
    /* @__PURE__ */ D("img", { className: "plot-qr-dialog-code", src: d, alt: t("QR code for this plot") }),
    /* @__PURE__ */ D("div", { className: "modal-actions", children: /* @__PURE__ */ D("button", { type: "button", className: "primary-button", onClick: f, children: t("Duplicate into new tab") }) })
  ] }) });
}
function mL({ onClose: e, onImport: t }) {
  const { t: r, locale: o, language: l } = jn(), { storageNamespace: u } = Zo(), [d, f] = Gn([]), g = yt((z) => z.setScenario), h = yt((z) => z.scenario), v = yt((z) => z.setDocumentStatus), E = b0(
    () => X2(u).then(f),
    [u]
  );
  En(() => {
    E();
  }, [E]);
  const S = (z) => {
    g(z.scenario), v("browser"), e();
  }, w = async (z) => {
    const L = structuredClone(z.scenario), x = sm();
    L.metadata = {
      ...L.metadata,
      id: Ka(),
      title: r("{title} copy", { title: L.metadata.title }),
      createdAt: x,
      updatedAt: x
    }, await r8(L, u), await E();
  }, T = async () => {
    await hD(u), f([]);
  }, P = async (z) => {
    const L = z === "empty" ? await X2(u).catch(() => d) : d, x = (() => {
      switch (z) {
        case "windward":
          return nD();
        case "start":
          return rD();
        case "port-starboard":
          return aD();
        case "windward-leeward":
          return iD();
        case "ahead-astern":
          return oD();
        default:
          return Ql(
            r6(r("Untitled plot"), [
              h.metadata.title,
              ...L.map((k) => k.title)
            ])
          );
      }
    })();
    if (l === "de" && z !== "empty") {
      const k = {
        windward: ["Windward mark rounding", "A static visual example for discussing Rule 18."],
        start: ["Start-line situation", "Static positions for discussing a start-line situation."],
        "port-starboard": [
          "Port–starboard crossing",
          "Two boats on opposite tacks approaching a crossing situation."
        ],
        "windward-leeward": ["Windward–leeward overlap", "Two overlapped boats on the same tack."],
        "ahead-astern": [
          "Clear ahead and clear astern",
          "Two boats on the same tack, one clear ahead of the other."
        ]
      }[z];
      x.metadata.title = r(k[0]), x.metadata.description = r(k[1]);
    }
    g(x, "Created plot"), e();
  };
  return /* @__PURE__ */ le(fd, { title: r("Projects & templates"), onClose: e, wide: !0, children: [
    /* @__PURE__ */ le("div", { className: "template-grid", children: [
      /* @__PURE__ */ le(
        "button",
        {
          type: "button",
          className: "template-card--primary",
          onClick: () => void P("empty"),
          children: [
            /* @__PURE__ */ D(nb, {}),
            /* @__PURE__ */ D("strong", { children: r("Empty plot") }),
            /* @__PURE__ */ D("span", { children: r("Start with a clean canvas.") })
          ]
        }
      ),
      /* @__PURE__ */ le("button", { type: "button", onClick: () => void P("windward"), children: [
        /* @__PURE__ */ D(M7, {}),
        /* @__PURE__ */ D("strong", { children: r("Windward mark") }),
        /* @__PURE__ */ D("span", { children: r("Static Rule 18 discussion example.") }),
        /* @__PURE__ */ D(Hp, { references: ["RRS 18"] })
      ] }),
      /* @__PURE__ */ le("button", { type: "button", onClick: () => void P("start"), children: [
        /* @__PURE__ */ D(m7, {}),
        /* @__PURE__ */ D("strong", { children: r("Start line") }),
        /* @__PURE__ */ D("span", { children: r("Boats approaching a start line.") })
      ] }),
      /* @__PURE__ */ le("button", { type: "button", onClick: () => void P("port-starboard"), children: [
        /* @__PURE__ */ D(r7, {}),
        /* @__PURE__ */ D("strong", { children: r("Port–starboard") }),
        /* @__PURE__ */ D("span", { children: r("Opposite-tack crossing under RRS 10.") }),
        /* @__PURE__ */ D(Hp, { references: ["RRS 10"] })
      ] }),
      /* @__PURE__ */ le("button", { type: "button", onClick: () => void P("windward-leeward"), children: [
        /* @__PURE__ */ D(x7, {}),
        /* @__PURE__ */ D("strong", { children: r("Windward–leeward") }),
        /* @__PURE__ */ D("span", { children: r("Same-tack overlap under RRS 11.") }),
        /* @__PURE__ */ D(Hp, { references: ["RRS 11"] })
      ] }),
      /* @__PURE__ */ le("button", { type: "button", onClick: () => void P("ahead-astern"), children: [
        /* @__PURE__ */ D(b7, {}),
        /* @__PURE__ */ D("strong", { children: r("Clear ahead/astern") }),
        /* @__PURE__ */ D("span", { children: r("Same-tack positions under RRS 12.") }),
        /* @__PURE__ */ D(Hp, { references: ["RRS 12"] })
      ] })
    ] }),
    /* @__PURE__ */ le("div", { className: "project-list-heading", children: [
      /* @__PURE__ */ D("h3", { children: r("Recent local projects") }),
      /* @__PURE__ */ le("div", { className: "project-list-actions", children: [
        /* @__PURE__ */ le("button", { type: "button", className: "secondary-button", onClick: t, children: [
          /* @__PURE__ */ D(tb, { "aria-hidden": "true" }),
          r("Import JSON")
        ] }),
        d.length > 0 && /* @__PURE__ */ le("button", { type: "button", className: "delete-all-projects", onClick: () => void T(), children: [
          /* @__PURE__ */ D(S0, { "aria-hidden": "true" }),
          r("Delete all")
        ] })
      ] })
    ] }),
    d.length === 0 ? /* @__PURE__ */ D("div", { className: "inline-empty", children: r("No saved projects yet. Create a plot above.") }) : /* @__PURE__ */ D("div", { className: "project-list", children: d.map((z) => /* @__PURE__ */ le("article", { children: [
      /* @__PURE__ */ le("button", { type: "button", className: "project-open", onClick: () => S(z), children: [
        /* @__PURE__ */ D("strong", { children: z.title }),
        /* @__PURE__ */ D("span", { children: new Date(z.updatedAt).toLocaleString(o) })
      ] }),
      /* @__PURE__ */ D(Hp, { references: z.scenario.metadata.ruleReferences }),
      /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          className: "project-action",
          onClick: () => void w(z),
          children: r("Duplicate")
        }
      ),
      /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          className: "danger-link",
          onClick: () => {
            window.confirm(
              r("Delete “{title}” from this browser?", { title: z.title })
            ) && fD(z.id, u).then(E);
          },
          children: r("Delete")
        }
      )
    ] }, z.id)) })
  ] });
}
function Hp({ references: e }) {
  const { t } = jn();
  if (!e.length) return null;
  const r = e.slice(0, 3), o = e.slice(r.length), l = o.length;
  return /* @__PURE__ */ le("span", { className: "rule-reference-bubbles", "aria-label": t("Rule references"), children: [
    r.map((u) => /* @__PURE__ */ D("span", { className: "rule-reference-bubble", children: u }, u)),
    l > 0 && /* @__PURE__ */ le(
      "span",
      {
        className: "rule-reference-bubble rule-reference-bubble--overflow",
        "aria-label": t("{count} more rule references", { count: l }),
        tabIndex: 0,
        children: [
          /* @__PURE__ */ D("span", { "aria-hidden": "true", children: "..." }),
          /* @__PURE__ */ D("span", { className: "rule-reference-overflow-popover", role: "tooltip", children: o.map((u) => /* @__PURE__ */ D("span", { className: "rule-reference-overflow-item", children: u }, u)) })
        ]
      }
    )
  ] });
}
function gL({ onClose: e }) {
  const { t } = jn(), r = yt((R) => R.scenario), o = yt((R) => R.updateMetadata), l = yt((R) => R.updateEnvironment), [u, d] = Gn(r.metadata.title), [f, g] = Gn(
    () => r.metadata.ruleReferences.map(mw)
  ), [h, v] = Gn(""), [E, S] = Gn(
    () => r.metadata.additionalInformation.map((R) => ({ ...R }))
  ), w = Wa(null), T = Wa(null), P = (R, B) => {
    const q = [...R];
    return B.map(mw).filter(Boolean).forEach((X) => {
      q.some((I) => I.toLocaleLowerCase() === X.toLocaleLowerCase()) || q.push(X);
    }), q;
  }, z = (R) => {
    g((B) => P(B, R));
  }, L = () => {
    h.trim() && (z(h.split(",")), v(""));
  }, x = () => {
    var U;
    const R = u.trim() || t("Untitled plot"), B = P(f, h.split(",")), q = E.map((F, Z) => ({
      ...F,
      name: F.name.trim() || (Z === 0 && F.value.trim() ? t("Wind strength") : ""),
      value: F.value.trim()
    })).filter((F) => F.name || F.value);
    (R !== r.metadata.title || JSON.stringify(B) !== JSON.stringify(r.metadata.ruleReferences) || JSON.stringify(q) !== JSON.stringify(r.metadata.additionalInformation)) && o({ title: R, ruleReferences: B, additionalInformation: q });
    const I = ((U = q.find((F) => {
      const Z = F.name.trim().toLocaleLowerCase();
      return [
        "wind strength",
        "wind strength (general)",
        "windstärke",
        "windstärke (allgemein)"
      ].includes(Z);
    })) == null ? void 0 : U.value) || null;
    I !== r.environment.windStrength && l({ windStrength: I }), e();
  }, k = (R, B) => S(
    (q) => q.map((X) => X.id === R ? { ...X, ...B } : X)
  );
  return /* @__PURE__ */ le(fd, { title: t("Plot details"), onClose: x, children: [
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("label", { htmlFor: "plot-title", children: t("Title") }),
      /* @__PURE__ */ le("div", { className: "clearable-input", children: [
        /* @__PURE__ */ D(
          "input",
          {
            ref: w,
            id: "plot-title",
            value: u,
            onChange: (R) => d(R.target.value)
          }
        ),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: "input-clear-button",
            "aria-label": t("Clear title"),
            title: t("Clear title"),
            disabled: !u,
            onClick: () => {
              var R;
              d(""), (R = w.current) == null || R.focus();
            },
            children: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ le("label", { className: "field", children: [
      /* @__PURE__ */ D("span", { children: t("Description") }),
      /* @__PURE__ */ D(
        "textarea",
        {
          value: r.metadata.description,
          onChange: (R) => o({ description: R.target.value })
        }
      )
    ] }),
    /* @__PURE__ */ le("div", { className: "field", children: [
      /* @__PURE__ */ D("label", { htmlFor: "rule-reference-input", children: t("Rule references") }),
      /* @__PURE__ */ le(
        "div",
        {
          className: "rule-reference-editor",
          onClick: () => {
            var R;
            return (R = T.current) == null ? void 0 : R.focus();
          },
          children: [
            /* @__PURE__ */ D("span", { className: "rule-reference-chips", role: "list", children: f.map((R) => /* @__PURE__ */ le("span", { className: "rule-reference-chip", role: "listitem", children: [
              /* @__PURE__ */ D("span", { children: R }),
              /* @__PURE__ */ D(
                "button",
                {
                  type: "button",
                  "aria-label": t("Remove rule reference {reference}", { reference: R }),
                  onClick: (B) => {
                    B.stopPropagation(), g(
                      (q) => q.filter((X) => X !== R)
                    );
                  },
                  children: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" })
                }
              )
            ] }, R)) }),
            /* @__PURE__ */ D(
              "input",
              {
                ref: T,
                id: "rule-reference-input",
                "aria-label": t("Rule references"),
                placeholder: t("For example 18 or 18.2(a)"),
                value: h,
                onChange: (R) => {
                  const B = R.target.value.split(",");
                  if (B.length === 1) {
                    v(R.target.value);
                    return;
                  }
                  z(B.slice(0, -1)), v(B.at(-1) ?? "");
                },
                onBlur: L,
                onKeyDown: (R) => {
                  (R.key === "Enter" || R.key === ",") && h.trim() ? (R.preventDefault(), L()) : R.key === "Backspace" && !h && f.length && g((B) => B.slice(0, -1));
                }
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ D("small", { children: t("Separate references with commas, for example “RRS 10, RRS 18”.") })
    ] }),
    /* @__PURE__ */ le("section", { className: "plot-additional-information", children: [
      /* @__PURE__ */ le("div", { className: "additional-information-heading", children: [
        /* @__PURE__ */ le("div", { className: "section-title section-title--subtle", children: [
          /* @__PURE__ */ D(_0, { "aria-hidden": "true" }),
          /* @__PURE__ */ D("span", { children: t("Additional information") })
        ] }),
        /* @__PURE__ */ D("span", { className: "additional-information-count", children: t("{count} of 10", { count: E.length }) })
      ] }),
      E.length > 0 ? /* @__PURE__ */ le(Fr, { children: [
        /* @__PURE__ */ le("div", { className: "additional-information-labels", "aria-hidden": "true", children: [
          /* @__PURE__ */ D("span", { children: t("Name") }),
          /* @__PURE__ */ D("span", { children: t("Value") })
        ] }),
        /* @__PURE__ */ D("div", { className: "additional-information-list", children: E.map((R, B) => /* @__PURE__ */ le("div", { className: "additional-information-row", children: [
          /* @__PURE__ */ le("label", { className: "field", children: [
            /* @__PURE__ */ D("span", { className: "visually-hidden", children: t("Information name {number}", { number: B + 1 }) }),
            /* @__PURE__ */ D(
              "input",
              {
                value: R.name,
                "aria-label": t("Information name {number}", { number: B + 1 }),
                placeholder: t(B === 0 ? "Wind strength" : "Name"),
                onChange: (q) => k(R.id, { name: q.target.value })
              }
            )
          ] }),
          /* @__PURE__ */ le("label", { className: "field", children: [
            /* @__PURE__ */ D("span", { className: "visually-hidden", children: t("Information value {number}", { number: B + 1 }) }),
            /* @__PURE__ */ D(
              "input",
              {
                value: R.value,
                "aria-label": t("Information value {number}", { number: B + 1 }),
                placeholder: t(B === 0 ? "Optional, e.g. 12 kn" : "Value"),
                onChange: (q) => k(R.id, { value: q.target.value })
              }
            )
          ] }),
          /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              className: "additional-information-remove",
              "aria-label": t("Remove information {number}", { number: B + 1 }),
              title: t("Remove information {number}", { number: B + 1 }),
              onClick: () => S(
                (q) => q.filter(({ id: X }) => X !== R.id)
              ),
              children: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" })
            }
          )
        ] }, R.id)) })
      ] }) : /* @__PURE__ */ D("p", { className: "additional-information-empty", children: t("No additional information.") }),
      /* @__PURE__ */ le(
        "button",
        {
          type: "button",
          className: "secondary-button additional-information-add",
          disabled: E.length >= 10,
          onClick: () => S((R) => [
            ...R,
            { id: Ka(), name: "", value: "" }
          ]),
          children: [
            /* @__PURE__ */ D(nb, { "aria-hidden": "true" }),
            t("Add information")
          ]
        }
      )
    ] }),
    /* @__PURE__ */ D("div", { className: "modal-actions", children: /* @__PURE__ */ D("button", { type: "button", className: "primary-button", onClick: x, children: t("Done") }) })
  ] });
}
function vL({
  onClose: e,
  extensions: t,
  extensionContext: r
}) {
  const { t: o } = jn(), l = Zo(), u = t.helpContent, [d, f] = Gn("help"), g = {
    help: "Help",
    privacy: "Privacy",
    about: "About",
    license: "License"
  };
  return /* @__PURE__ */ le(fd, { title: o("Help & information"), onClose: e, wide: !0, children: [
    /* @__PURE__ */ D("div", { className: "tabs", role: "tablist", children: ["help", "privacy", ...l.ui.about ? ["about"] : [], "license"].map((h) => /* @__PURE__ */ D(
      "button",
      {
        type: "button",
        role: "tab",
        "aria-selected": d === h,
        className: d === h ? "is-active" : "",
        onClick: () => f(h),
        children: o(g[h])
      },
      h
    )) }),
    d === "help" && /* @__PURE__ */ le("div", { className: "readable", children: [
      /* @__PURE__ */ D("h3", { children: o("Build a static sailing explanation") }),
      /* @__PURE__ */ D("p", { children: o(l.texts.helpText) }),
      /* @__PURE__ */ D("p", { children: o(
        "The Boat tool stays active: each tap adds the next numbered position to the current boat chain. To continue an existing chain, select one of its boats and then choose Boat. Choose Select or another tool when the chain is complete."
      ) }),
      u && /* @__PURE__ */ D(u, { ...r }),
      (l.links.support || l.links.documentation) && /* @__PURE__ */ le("p", { className: "configured-help-links", children: [
        l.links.support && /* @__PURE__ */ D("a", { href: l.links.support, target: "_blank", rel: "noopener noreferrer", children: o("Support") }),
        l.links.documentation && /* @__PURE__ */ D("a", { href: l.links.documentation, target: "_blank", rel: "noopener noreferrer", children: o("Documentation") })
      ] }),
      /* @__PURE__ */ D("h3", { children: o("Mouse and keyboard") }),
      /* @__PURE__ */ D("p", { children: o(
        "Scroll to zoom. Choose Pan or hold Space to move the view. Shift-click adds objects to a selection. Use Delete, arrow keys, ⌘/Ctrl+Z, ⌘/Ctrl+Shift+Z and ⌘/Ctrl+D."
      ) }),
      /* @__PURE__ */ D("h3", { children: o("Touch and stylus") }),
      /* @__PURE__ */ D("p", { children: o(
        "Tap to select and drag objects to move them. Drag drawing tools directly, or click twice to set start and end. Rectangle uses opposite corners; circle uses a centre and outer point. Drawing tools accept mouse, finger and stylus input."
      ) }),
      /* @__PURE__ */ D("h3", { children: o("Sharing") }),
      /* @__PURE__ */ D("p", { children: o(
        "Share links contain a compressed copy of the complete project in the URL fragment. For large projects, export a JSON file instead."
      ) })
    ] }),
    d === "privacy" && /* @__PURE__ */ le("div", { className: "readable", children: [
      /* @__PURE__ */ D("h3", { children: o("Local-first privacy") }),
      /* @__PURE__ */ D("p", { children: o(
        "Projects and preferences are stored locally in this browser using IndexedDB. JSON and image exports are created on your device. No project data is uploaded to a server."
      ) }),
      /* @__PURE__ */ D("p", { children: o(
        "A share link contains the project data itself. Anyone who receives that link can access the plot embedded in it."
      ) }),
      l.links.privacy && /* @__PURE__ */ D("p", { children: /* @__PURE__ */ D("a", { href: l.links.privacy, target: "_blank", rel: "noopener noreferrer", children: o("Privacy") }) })
    ] }),
    d === "about" && /* @__PURE__ */ le("div", { className: "readable", children: [
      /* @__PURE__ */ D("h3", { children: o(l.branding.appName) }),
      /* @__PURE__ */ D("p", { children: o(l.texts.aboutText) }),
      /* @__PURE__ */ D("p", { children: o(`${l.texts.footerText}.`) })
    ] }),
    d === "license" && /* @__PURE__ */ le("div", { className: "readable", children: [
      /* @__PURE__ */ D("h3", { children: o("GNU General Public License v3") }),
      /* @__PURE__ */ D("p", { children: o(
        "This project is free software distributed under the GNU GPL v3. See the repository’s LICENSE file for the complete terms."
      ) })
    ] })
  ] });
}
function yL({
  onClose: e,
  onJson: t,
  onPng: r,
  onOpenPlayerExports: o,
  onShare: l,
  onPdf: u,
  canAnimate: d
}) {
  const { t: f, locale: g } = jn(), h = Zo(), v = yt((L) => L.scenario), E = gb(v).length, [S, w] = Gn(!1), [T, P] = Gn(!1), z = async () => {
    P(!0);
    const L = await l();
    P(!1), w(L);
  };
  return /* @__PURE__ */ D(fd, { title: f("Export & share"), onClose: e, children: /* @__PURE__ */ le("div", { className: "export-list", children: [
    /* @__PURE__ */ le("section", { className: "export-option export-option--share", children: [
      /* @__PURE__ */ D(C7, { className: "export-option-icon", "aria-hidden": "true" }),
      /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
        /* @__PURE__ */ le("div", { className: "export-option-title", children: [
          /* @__PURE__ */ D("strong", { children: f("Share link") }),
          /* @__PURE__ */ D(Yc, { label: f("About Share link"), children: f("Copies a URL containing the complete editable plot. No upload is required.") })
        ] }),
        /* @__PURE__ */ D("small", { children: f("{count} characters · project stays in the URL", {
          count: E.toLocaleString(g)
        }) })
      ] }),
      /* @__PURE__ */ le(
        "button",
        {
          type: "button",
          className: `export-copy-button ${S ? "is-copied" : ""}`,
          disabled: T,
          onClick: () => void z(),
          children: [
            S && /* @__PURE__ */ D(o7, { "aria-hidden": "true" }),
            f(S ? "Copied" : "Copy URL with project")
          ]
        }
      )
    ] }),
    E > 4e3 && /* @__PURE__ */ D("p", { className: "warning", children: f(
      "This link is long and may not work in every app. Prefer JSON export for this project."
    ) }),
    /* @__PURE__ */ le("section", { className: "export-option", children: [
      /* @__PURE__ */ D(c7, { className: "export-option-icon", "aria-hidden": "true" }),
      /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
        /* @__PURE__ */ le("div", { className: "export-option-title", children: [
          /* @__PURE__ */ D("strong", { children: f("Plot JSON") }),
          /* @__PURE__ */ D(Yc, { label: f("About Plot JSON"), children: f("Best for editing later or transferring a plot between browsers.") })
        ] }),
        /* @__PURE__ */ D("small", { children: f("Editable, validated project file") })
      ] }),
      /* @__PURE__ */ D("button", { type: "button", className: "export-action-button", onClick: t, children: f("Download JSON") })
    ] }),
    /* @__PURE__ */ le("section", { className: "export-option", children: [
      /* @__PURE__ */ D(mS, { className: "export-option-icon", "aria-hidden": "true" }),
      /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
        /* @__PURE__ */ le("div", { className: "export-option-title", children: [
          /* @__PURE__ */ D("strong", { children: f("PNG image") }),
          /* @__PURE__ */ D(Yc, { label: f("About PNG image"), children: f(h.texts.exportPngDescription) })
        ] }),
        /* @__PURE__ */ D("small", { children: f("Static image without editor handles") })
      ] }),
      /* @__PURE__ */ D("button", { type: "button", className: "export-action-button", onClick: () => void r(), children: f("Download PNG") })
    ] }),
    /* @__PURE__ */ le("section", { className: "export-option", children: [
      /* @__PURE__ */ D(mS, { className: "export-option-icon", "aria-hidden": "true" }),
      /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
        /* @__PURE__ */ le("div", { className: "export-option-title", children: [
          /* @__PURE__ */ D("strong", { children: f("Transparent PNG") }),
          /* @__PURE__ */ D(Yc, { label: f("About Transparent PNG"), children: f(h.texts.exportTransparentPngDescription) })
        ] }),
        /* @__PURE__ */ D("small", { children: f("Canvas objects without a background") })
      ] }),
      /* @__PURE__ */ D("button", { type: "button", className: "export-action-button", onClick: () => void r(!0), children: f("Download transparent PNG") })
    ] }),
    /* @__PURE__ */ le("section", { className: "export-option export-option--dynamic", children: [
      /* @__PURE__ */ D(H0, { className: "export-option-icon", "aria-hidden": "true" }),
      /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
        /* @__PURE__ */ D("div", { className: "export-option-title", children: /* @__PURE__ */ D("strong", { children: f("Dynamic exports") }) }),
        /* @__PURE__ */ D("small", { children: f(
          d ? "GIF and MP4 use the speed and boat-tail setting from the Player." : "Add at least two positions to a boat first"
        ) })
      ] }),
      /* @__PURE__ */ D(
        "button",
        {
          type: "button",
          className: "export-action-button",
          disabled: !d,
          onClick: o,
          children: f("Open Player exports")
        }
      )
    ] }),
    /* @__PURE__ */ le(
      "section",
      {
        className: `export-option${v.canvas.infinite ? " export-option--disabled" : ""}`,
        children: [
          /* @__PURE__ */ D(tb, { className: "export-option-icon", "aria-hidden": "true" }),
          /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
            /* @__PURE__ */ le("div", { className: "export-option-title", children: [
              /* @__PURE__ */ D("strong", { children: f("PDF document") }),
              /* @__PURE__ */ D(Yc, { label: f("About PDF document"), children: f("Downloads the plot directly as an A4 landscape PDF.") })
            ] }),
            /* @__PURE__ */ D("small", { id: "pdf-export-availability", children: f(
              v.canvas.infinite ? "Unavailable with Endless plot. Turn it off in Scene settings to export an A4 PDF." : "A4 landscape with a clickable plot QR watermark"
            ) })
          ] }),
          /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              className: "export-action-button",
              disabled: v.canvas.infinite,
              "aria-describedby": "pdf-export-availability",
              onClick: () => void u(),
              children: f("Download PDF")
            }
          )
        ]
      }
    )
  ] }) });
}
function bL({
  onClose: e,
  onAnimation: t,
  speed: r,
  tailsVisible: o
}) {
  const { t: l } = jn(), [u, d] = Gn(null), [f, g] = Gn(0), h = async (E) => {
    d(E), g(0);
    try {
      await t(E, g);
    } finally {
      d(null), g(0);
    }
  }, v = l("Exporting {progress}%", {
    progress: Math.round(f * 100)
  });
  return /* @__PURE__ */ le(fd, { title: l("Player exports"), onClose: e, children: [
    /* @__PURE__ */ D("p", { className: "player-export-settings", children: l("Speed {speed}× · Boat tails {tails}", {
      speed: r,
      tails: l(o ? "On" : "Off")
    }) }),
    /* @__PURE__ */ le("div", { className: "export-list", children: [
      /* @__PURE__ */ le("section", { className: "export-option", children: [
        /* @__PURE__ */ D(H0, { className: "export-option-icon", "aria-hidden": "true" }),
        /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
          /* @__PURE__ */ le("div", { className: "export-option-title", children: [
            /* @__PURE__ */ D("strong", { children: l("Animated GIF") }),
            /* @__PURE__ */ D(Yc, { label: l("About animated GIF"), children: l(
              "Exports the complete Player sequence as a looping GIF. The transparent variant omits the plot background."
            ) })
          ] }),
          /* @__PURE__ */ D("small", { children: l("Looping animation · standard or transparent") })
        ] }),
        /* @__PURE__ */ le("div", { className: "export-format-actions", role: "group", "aria-label": l("GIF format"), children: [
          /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              disabled: u !== null,
              onClick: () => void h("gif"),
              children: u === "gif" ? v : l("Download GIF")
            }
          ),
          /* @__PURE__ */ D(
            "button",
            {
              type: "button",
              disabled: u !== null,
              onClick: () => void h("gif-transparent"),
              children: u === "gif-transparent" ? v : l("Transparent GIF")
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ le("section", { className: "export-option", children: [
        /* @__PURE__ */ D(tb, { className: "export-option-icon", "aria-hidden": "true" }),
        /* @__PURE__ */ le("div", { className: "export-option-copy", children: [
          /* @__PURE__ */ le("div", { className: "export-option-title", children: [
            /* @__PURE__ */ D("strong", { children: l("MP4 video") }),
            /* @__PURE__ */ D(Yc, { label: l("About MP4 video"), children: l("Exports the complete Player sequence as a high-quality MP4 video.") })
          ] }),
          /* @__PURE__ */ D("small", { children: l("Smooth video with plot background") })
        ] }),
        /* @__PURE__ */ D(
          "button",
          {
            type: "button",
            className: "export-action-button",
            disabled: u !== null,
            onClick: () => void h("mp4"),
            children: u === "mp4" ? v : l("Download MP4")
          }
        )
      ] })
    ] })
  ] });
}
function _L({ extensions: e, extensionContext: t }) {
  var Xe;
  gD();
  const r = Zo(), o = yt((Ue) => Ue.setBrandAccentColor), l = yt((Ue) => Ue.setObjectColors), u = W7(r), d = rb(r), f = qN(r), g = WN(r);
  En(() => o(u), [u, o]), En(
    () => l(f, g),
    [f, l, g]
  );
  const { language: h, setLanguage: v, t: E, status: S } = jn(), w = e.emptySelectionContent, T = Wa(null), P = Wa(null), [z, L] = Gn(null), [x, k] = Gn(!1), [R, B] = Gn(!1), [q, X] = Gn(1), [I, U] = Gn(1), [F, Z] = Gn(!0), [te, ie] = Gn(), [ue, ce] = Gn(
    () => window.matchMedia("(max-width: 980px)").matches
  ), ze = Uf(r.storageNamespace, "sailing-theme"), [W, j] = Gn(() => {
    if (r.theme.mode === "system")
      return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    const Ue = localStorage.getItem(ze);
    return Ue === "light" || Ue === "dark" ? Ue : r.theme.mode;
  }), ee = Wa(r.theme.mode), Q = yt((Ue) => Ue.scenario), oe = yt((Ue) => Ue.selectedIds), ye = ta(
    () => hP(Q.objects),
    [Q.objects]
  ), pe = ta(() => pP(Q.objects), [Q.objects]);
  En(() => {
    if (!r.theme.usePrimaryForBrandAccents) return;
    const Ue = Q.objects.find(
      (xt) => xt.type === "boat" && P2.includes(xt.boatClass)
    );
    if (!Ue) return;
    const _t = u.toUpperCase();
    Q.objects.filter(
      (xt) => xt.type === "boat" && xt.sequenceId === Ue.sequenceId
    ).every((xt) => xt.color.toUpperCase() === _t) || yt.getState().patchScenario({
      objects: Q.objects.map(
        (xt) => xt.type === "boat" && xt.sequenceId === Ue.sequenceId ? { ...xt, color: u } : xt
      )
    });
  }, [u, r.theme.usePrimaryForBrandAccents, Q.objects]);
  const Me = Q.canvas.boatLegendVisible && Q.objects.some((Ue) => Ue.type === "boat" && Ue.visible), We = 297 / Q.canvas.width, ae = (210 - Q.canvas.height * We) / 2, Re = Me ? Math.max(5, 210 - (ae + (Q.canvas.height - 24) * We)) : 5, Qe = yt((Ue) => Ue.activeTool), Pe = yt((Ue) => Ue.layoutPreference), rt = Pe === "compact" || Pe === "auto" && ue, st = yt((Ue) => Ue.status), bt = yt((Ue) => Ue.documentStatus), Xt = yt((Ue) => Ue.history), Lt = yt((Ue) => Ue.future), qn = yt((Ue) => Ue.setScenario), Wt = yt((Ue) => Ue.setStatus), bn = yt((Ue) => Ue.setDocumentStatus), Yr = yt((Ue) => Ue.setLayoutPreference), Pn = yt((Ue) => Ue.setTool), gn = yt((Ue) => Ue.select), vn = yt((Ue) => Ue.updateObjects), ir = yt((Ue) => Ue.deleteSelected), cr = yt((Ue) => Ue.duplicateSelected), er = yt((Ue) => Ue.undo), ln = yt((Ue) => Ue.redo), dr = oe.join("|");
  En(() => {
    X((Ue) => Math.min(ye, Math.max(1, Ue)));
  }, [ye]), En(() => {
    if (!x || !R || ye <= 1) return;
    let Ue = 0, _t;
    const or = (xt) => {
      _t === void 0 && (_t = xt);
      const zn = xt - _t;
      _t = xt, X(
        (aa) => Math.min(
          ye,
          aa + zn * I / Q6
        )
      ), Ue = window.requestAnimationFrame(or);
    };
    return Ue = window.requestAnimationFrame(or), () => window.cancelAnimationFrame(Ue);
  }, [ye, R, I, x]), En(() => {
    R && q >= ye && B(!1);
  }, [ye, R, q]), En(() => {
    document.documentElement.dataset.theme = W, localStorage.setItem(ze, W);
  }, [W, ze]), En(() => {
    const Ue = window.matchMedia("(max-width: 980px)"), _t = () => ce(Ue.matches);
    return _t(), Ue.addEventListener("change", _t), () => Ue.removeEventListener("change", _t);
  }, []), En(() => {
    if (r.theme.mode !== "system") return;
    const Ue = window.matchMedia("(prefers-color-scheme: dark)"), _t = () => j(Ue.matches ? "dark" : "light");
    return _t(), Ue.addEventListener("change", _t), () => Ue.removeEventListener("change", _t);
  }, [r.theme.mode]), En(() => {
    const Ue = ee.current;
    ee.current = r.theme.mode, Ue !== r.theme.mode && r.theme.mode !== "system" && j(r.theme.mode);
  }, [r.theme.mode]), En(() => {
    var Ue;
    (Ue = e.onEvent) == null || Ue.call(e, { type: "editor-ready", path: t.currentPath });
  }, []), En(() => {
    try {
      const Ue = zN(window.location.hash);
      Ue && qn(Ue, "Opened shared plot");
    } catch (Ue) {
      Wt(Ue instanceof Error ? Ue.message : "Could not open the shared plot");
    }
  }, []), En(() => {
    const Ue = (_t) => {
      if (_t.target.matches('input, textarea, select, [contenteditable="true"]')) return;
      if (x) {
        _t.code === "Space" ? (_t.preventDefault(), B((zn) => (!zn && q >= ye && X(1), !zn))) : _t.key === "ArrowLeft" ? (_t.preventDefault(), B(!1), X(Math.max(1, Math.ceil(q) - 1))) : _t.key === "ArrowRight" ? (_t.preventDefault(), B(!1), X(Math.min(ye, Math.floor(q) + 1))) : _t.key === "Escape" && (B(!1), k(!1));
        return;
      }
      const xt = _t.metaKey || _t.ctrlKey;
      if (xt && _t.key.toLowerCase() === "z") {
        _t.preventDefault(), _t.shiftKey ? ln() : er();
        return;
      }
      if (xt && _t.key.toLowerCase() === "y") {
        _t.preventDefault(), ln();
        return;
      }
      if (xt && _t.key.toLowerCase() === "d") {
        _t.preventDefault(), cr();
        return;
      }
      if (_t.key === "Delete" || _t.key === "Backspace") {
        _t.preventDefault(), ir();
        return;
      }
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(_t.key) && oe.length) {
        _t.preventDefault();
        const zn = _t.shiftKey ? 10 : 1, aa = _t.key === "ArrowLeft" ? -zn : _t.key === "ArrowRight" ? zn : 0, Zr = _t.key === "ArrowUp" ? -zn : _t.key === "ArrowDown" ? zn : 0;
        vn(
          Q.objects.filter((mr) => oe.includes(mr.id) && !mr.locked).map((mr) => ({ id: mr.id, patch: { x: mr.x + aa, y: mr.y + Zr } })),
          "Nudged selection"
        );
      }
    };
    return window.addEventListener("keydown", Ue), () => window.removeEventListener("keydown", Ue);
  }, [
    ir,
    cr,
    ye,
    q,
    x,
    ln,
    Q.objects,
    oe,
    er,
    vn
  ]);
  const kn = () => {
    $2(
      sL(Q),
      `${a0(Q.metadata.title)}.sailplot.json`,
      "application/json"
    ), bn("downloaded"), Wt("Exported plot JSON");
  }, tr = async (Ue = !1) => {
    var or;
    const _t = (or = T.current) == null ? void 0 : or.exportPng(Ue, 2);
    if (_t)
      try {
        const xt = await jw(_t, {
          plotUrl: r.links.qrCode ?? Qp(Q),
          primaryColor: d,
          analyticsLogoUrl: r.branding.exportWatermarkLogo,
          productLogoUrl: r.branding.exportProductLogo,
          partnerLabel: r.branding.partnerLabel
        }), zn = document.createElement("a");
        zn.href = xt, zn.download = `${a0(Q.metadata.title)}${Ue ? "-transparent" : ""}.png`, zn.click(), bn("downloaded"), Wt("Exported PNG image");
      } catch (xt) {
        Wt(xt instanceof Error ? xt.message : "Could not export PNG image");
      }
  }, ot = async (Ue, _t) => {
    const or = async (xt, zn) => {
      var Zr;
      ie(xt), await lL();
      const aa = (Zr = T.current) == null ? void 0 : Zr.exportPng(zn, 1);
      if (!aa) throw new Error("Could not render an animation frame");
      return jw(aa, {
        plotUrl: r.links.qrCode ?? Qp(Q),
        primaryColor: d,
        analyticsLogoUrl: r.branding.exportWatermarkLogo,
        productLogoUrl: r.branding.exportProductLogo,
        partnerLabel: r.branding.partnerLabel
      });
    };
    try {
      const xt = Ue === "mp4" ? await iL({
        lastPosition: ye,
        speed: I,
        renderFrame: or,
        onProgress: _t
      }) : await aL({
        lastPosition: ye,
        speed: I,
        renderFrame: or,
        onProgress: _t,
        transparent: Ue === "gif-transparent"
      }), zn = Ue === "gif-transparent" ? "-transparent.gif" : `.${Ue}`;
      $2(xt, `${a0(Q.metadata.title)}${zn}`, xt.type), bn("downloaded"), Wt(Ue === "mp4" ? "Exported MP4 video" : "Exported animated GIF");
    } catch (xt) {
      Wt(xt instanceof Error ? xt.message : "Could not export animation");
    } finally {
      ie(void 0);
    }
  }, Tt = async () => {
    const Ue = gb(Q);
    try {
      return await navigator.clipboard.writeText(Ue), Wt("Share link copied"), !0;
    } catch {
      return Wt("Could not share; copy the address from your browser."), !1;
    }
  }, Ut = async () => {
    var _t;
    if (Q.canvas.infinite) {
      Wt("PDF export is unavailable while Endless plot is enabled");
      return;
    }
    const Ue = (_t = T.current) == null ? void 0 : _t.exportPng(!1, 2);
    if (Ue)
      try {
        const or = await QD(Ue, {
          plotUrl: r.links.qrCode ?? Qp(Q),
          primaryColor: d,
          analyticsLogoUrl: r.branding.exportWatermarkLogo,
          productLogoUrl: r.branding.exportProductLogo,
          partnerLabel: r.branding.partnerLabel,
          productUrl: r.links.app,
          analyticsUrl: r.links.website,
          title: Q.metadata.title,
          watermarkBottomMm: Re
        });
        await uL(or, `${a0(Q.metadata.title)}.pdf`), bn("downloaded"), Wt("Downloaded PDF");
      } catch (or) {
        Wt(or instanceof Error ? or.message : "Could not export PDF");
      }
  }, Ft = async (Ue) => {
    if (Ue) {
      if (!Ue.name.endsWith(".json")) {
        Wt("Unsupported file type. Choose a plot JSON file.");
        return;
      }
      try {
        qn(oL(await Ue.text()), "Imported plot JSON");
      } catch (_t) {
        Wt(_t instanceof Error ? _t.message : "Could not import this file");
      }
      P.current && (P.current.value = "");
    }
  }, Fn = async () => {
    const Ue = await X2(r.storageNamespace).catch(() => []), _t = yt.getState().scenario.metadata.title, or = r6(E("Untitled plot"), [
      _t,
      ...Ue.map((xt) => xt.title)
    ]);
    qn(Ql(or), "Created plot"), Pn("select");
  }, _n = () => {
    const Ue = window.matchMedia("(max-width: 980px)").matches ? "compact" : "desktop", _t = Ue === "compact" ? "desktop" : "compact";
    Yr(Pe === "auto" ? _t : Pe === _t ? Ue : "auto");
  }, qe = E(
    Pe === "auto" ? "Auto layout" : Pe === "compact" ? "Compact layout" : "Desktop layout"
  ), gt = () => {
    pe && (Pn("select"), gn(null), L(null), B(!1), X(1), k(!0));
  }, Dn = () => {
    B(!1), k(!1);
  }, Tn = () => {
    pe && (x || gt(), B(!1), L("animation-export"));
  };
  return /* @__PURE__ */ le(
    "div",
    {
      className: "app-shell",
      "data-layout": Pe,
      "data-player-mode": x,
      style: gx(r.theme[W], r),
      children: [
        /* @__PURE__ */ le("header", { className: "topbar", children: [
          r.ui.headerLogo && /* @__PURE__ */ D("div", { className: "app-title", role: "img", "aria-label": r.branding.logoAlt, children: /* @__PURE__ */ le("span", { className: "app-symbol", children: [
            /* @__PURE__ */ D(
              "img",
              {
                className: "app-logo app-logo--on-light",
                src: r.branding.logo,
                alt: "",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ D(
              "img",
              {
                className: "app-logo app-logo--on-dark",
                src: r.branding.logoDark,
                alt: "",
                "aria-hidden": "true"
              }
            ),
            /* @__PURE__ */ D(
              "img",
              {
                className: "app-logo app-logo--compact",
                src: r.branding.compactLogo,
                alt: "",
                "aria-hidden": "true"
              }
            )
          ] }) }),
          /* @__PURE__ */ le("div", { className: "topbar-document", children: [
            /* @__PURE__ */ D("h1", { className: "topbar-document-title", children: /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                title: E("Rename plot"),
                "aria-label": E("Rename plot"),
                onClick: () => L("scenario"),
                children: Q.metadata.title
              }
            ) }),
            /* @__PURE__ */ le(
              "span",
              {
                className: "document-save-status",
                "data-state": bt,
                role: "status",
                "aria-live": "polite",
                title: E(
                  bt === "browser" ? "Saved in browser" : bt === "downloaded" ? "Downloaded" : "Not saved"
                ),
                children: [
                  /* @__PURE__ */ D("span", { className: "document-save-status-dot", "aria-hidden": "true" }),
                  /* @__PURE__ */ D("span", { className: "document-save-status-label", children: E(
                    bt === "browser" ? "Saved in browser" : bt === "downloaded" ? "Downloaded" : "Not saved"
                  ) })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ le("div", { className: "topbar-actions topbar-actions--file", children: [
            r.ui.newPlot && /* @__PURE__ */ D(
              pr,
              {
                className: "new-plot-button",
                icon: /* @__PURE__ */ D(nb, {}),
                label: E("New"),
                onClick: () => void Fn()
              }
            ),
            r.ui.openProjects && /* @__PURE__ */ D(
              pr,
              {
                icon: /* @__PURE__ */ D(h7, {}),
                label: E("Open projects & templates"),
                onClick: () => L("projects")
              }
            ),
            r.ui.export && /* @__PURE__ */ D(
              pr,
              {
                icon: /* @__PURE__ */ D(ix, {}),
                label: E("Export / Share"),
                onClick: () => L("export")
              }
            )
          ] }),
          /* @__PURE__ */ le("div", { className: "topbar-actions", children: [
            /* @__PURE__ */ le(
              "button",
              {
                type: "button",
                className: "player-mode-toggle",
                "aria-label": E(x ? "Back to editor" : "Player mode"),
                title: E(x ? "Back to editor" : "Player mode"),
                disabled: !x && !pe,
                onClick: x ? Dn : gt,
                children: [
                  x ? /* @__PURE__ */ D("span", { "aria-hidden": "true", children: "←" }) : /* @__PURE__ */ D(H0, { "aria-hidden": "true" }),
                  /* @__PURE__ */ D("span", { children: E(x ? "Back to editor" : "Player") })
                ]
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                className: "topbar-undo-button",
                icon: /* @__PURE__ */ D(bS, {}),
                label: E("Undo"),
                disabled: x || !Xt.length,
                onClick: er
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                className: "topbar-redo-button",
                icon: /* @__PURE__ */ D(yS, {}),
                label: E("Redo"),
                disabled: x || !Lt.length,
                onClick: ln
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: /* @__PURE__ */ D(P7, {}),
                label: E("Fit canvas"),
                onClick: () => {
                  var Ue;
                  return (Ue = T.current) == null ? void 0 : Ue.fitToScreen();
                }
              }
            ),
            r.ui.help && /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: /* @__PURE__ */ D(l7, {}),
                label: E("Help"),
                onClick: () => L("help")
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: W === "dark" ? /* @__PURE__ */ D(lx, {}) : /* @__PURE__ */ D(ox, {}),
                label: E(W === "dark" ? "Use light mode" : "Use dark mode"),
                onClick: () => j(W === "dark" ? "light" : "dark")
              }
            ),
            /* @__PURE__ */ D(
              "button",
              {
                className: "layout-cycle-button",
                type: "button",
                title: `${E("View")}: ${qe}`,
                "aria-label": `${E("View")}: ${qe}`,
                "data-layout-preference": Pe,
                onClick: _n,
                children: /* @__PURE__ */ D(A7, { "aria-hidden": "true" })
              }
            ),
            r.localization.languageMode === "both" && /* @__PURE__ */ D("div", { className: "language-switch", role: "group", "aria-label": E("Language"), children: ["de", "en"].map((Ue) => /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                className: h === Ue ? "is-active" : "",
                "aria-pressed": h === Ue,
                "aria-label": Ue === "de" ? "Deutsch" : "English",
                onClick: () => v(Ue),
                children: Ue.toUpperCase()
              },
              Ue
            )) }),
            /* @__PURE__ */ D(mx, { items: e.navigationItems ?? [], context: t }),
            (Xe = e.headerActions) == null ? void 0 : Xe.map((Ue, _t) => /* @__PURE__ */ D(Ue, { ...t }, _t))
          ] }),
          /* @__PURE__ */ D(
            "input",
            {
              ref: P,
              className: "visually-hidden",
              type: "file",
              accept: "application/json,.json",
              onChange: (Ue) => {
                var _t;
                return void Ft((_t = Ue.target.files) == null ? void 0 : _t[0]);
              }
            }
          )
        ] }),
        /* @__PURE__ */ D("aside", { className: "tools-panel", children: x ? /* @__PURE__ */ D(
          Qw,
          {
            playing: R,
            position: q,
            lastPosition: ye,
            speed: I,
            tailsVisible: F,
            onPlayingChange: B,
            onPositionChange: X,
            onSpeedChange: U,
            onTailsVisibleChange: Z,
            onExport: Tn,
            onExit: Dn
          }
        ) : /* @__PURE__ */ le(Fr, { children: [
          /* @__PURE__ */ le("div", { className: "panel-header panel-header--tools", children: [
            /* @__PURE__ */ le("div", { children: [
              /* @__PURE__ */ D("span", { className: "eyebrow", children: E("Create") }),
              /* @__PURE__ */ D("h2", { children: E("Tools") })
            ] }),
            Qe !== "select" && /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                className: "tool-cancel-button",
                icon: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" }),
                label: E("Return to Select"),
                onClick: () => Pn("select")
              }
            )
          ] }),
          /* @__PURE__ */ D(ow, {}),
          /* @__PURE__ */ D(Xw, { onResetView: () => {
            var Ue;
            return (Ue = T.current) == null ? void 0 : Ue.resetView();
          } })
        ] }) }),
        /* @__PURE__ */ D("main", { className: "canvas-area", children: /* @__PURE__ */ D(
          FP,
          {
            ref: T,
            branding: r.ui.footer && !rt ? /* @__PURE__ */ D(
              hL,
              {
                onInfo: () => L("help"),
                extensions: e,
                extensionContext: t
              }
            ) : void 0,
            topRightOverlay: r.ui.footer && !rt ? /* @__PURE__ */ D(fL, { onOpen: () => L("qr") }) : void 0,
            playbackPosition: te ?? (x ? q : void 0),
            playbackTailsVisible: F
          }
        ) }),
        !x && /* @__PURE__ */ D("aside", { className: "properties-panel", children: /* @__PURE__ */ D(
          n8,
          {
            emptyContent: w ? /* @__PURE__ */ D(w, { ...t }) : void 0
          }
        ) }),
        !x && /* @__PURE__ */ D(
          cL,
          {
            hasSelection: oe.length > 0
          },
          dr || "no-selection"
        ),
        rt && /* @__PURE__ */ D(
          dL,
          {
            onInfo: () => L("help"),
            extensions: e,
            extensionContext: t
          }
        ),
        /* @__PURE__ */ D("footer", { className: "mobile-toolbar", children: x ? /* @__PURE__ */ D(
          Qw,
          {
            compact: !0,
            playing: R,
            position: q,
            lastPosition: ye,
            speed: I,
            tailsVisible: F,
            onPlayingChange: B,
            onPositionChange: X,
            onSpeedChange: U,
            onTailsVisibleChange: Z,
            onExport: Tn,
            onExit: Dn
          }
        ) : /* @__PURE__ */ le("div", { className: "mobile-toolbar-inner", children: [
          Qe !== "select" && /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              className: "tool-cancel-button mobile-tool-action-button",
              icon: /* @__PURE__ */ D(Jc, { "aria-hidden": "true" }),
              label: E("Return to Select"),
              onClick: () => Pn("select")
            }
          ),
          oe.length > 0 && /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              className: "tool-cancel-button mobile-tool-action-button",
              icon: /* @__PURE__ */ D(S0, { "aria-hidden": "true" }),
              label: E("Delete selection"),
              onClick: ir
            }
          ),
          /* @__PURE__ */ D(
            pr,
            {
              compact: !0,
              className: "mobile-tool-action-button mobile-settings-button",
              icon: /* @__PURE__ */ D(sx, { "aria-hidden": "true" }),
              label: E("Scene settings"),
              onClick: () => L("settings")
            }
          ),
          /* @__PURE__ */ D("span", { className: "mobile-toolbar-divider", "aria-hidden": "true" }),
          /* @__PURE__ */ D(ow, { compact: !0 }),
          /* @__PURE__ */ le("div", { className: "mobile-history", "aria-label": E("History controls"), children: [
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: /* @__PURE__ */ D(bS, {}),
                label: E("Undo"),
                disabled: !Xt.length,
                onClick: er
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: /* @__PURE__ */ D(yS, {}),
                label: E("Redo"),
                disabled: !Lt.length,
                onClick: ln
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ le("div", { className: "statusbar", children: [
          /* @__PURE__ */ D("span", { "aria-live": "polite", children: S(st) }),
          /* @__PURE__ */ D("span", { children: E("{count} objects · {zoom}%", {
            count: Q.objects.length,
            zoom: Math.round(Q.canvas.view.scale * 100)
          }) })
        ] }),
        z === "projects" && /* @__PURE__ */ D(
          mL,
          {
            onClose: () => L(null),
            onImport: () => {
              var Ue;
              L(null), (Ue = P.current) == null || Ue.click();
            }
          }
        ),
        z === "scenario" && /* @__PURE__ */ D(gL, { onClose: () => L(null) }),
        z === "settings" && /* @__PURE__ */ D(fd, { title: E("Scene settings"), onClose: () => L(null), children: /* @__PURE__ */ D(Xw, { embedded: !0, onResetView: () => {
          var Ue;
          return (Ue = T.current) == null ? void 0 : Ue.resetView();
        } }) }),
        z === "help" && r.ui.help && /* @__PURE__ */ D(
          vL,
          {
            onClose: () => L(null),
            extensions: e,
            extensionContext: t
          }
        ),
        z === "export" && /* @__PURE__ */ D(
          yL,
          {
            onClose: () => L(null),
            onJson: kn,
            onPng: tr,
            onOpenPlayerExports: Tn,
            onShare: Tt,
            onPdf: Ut,
            canAnimate: pe
          }
        ),
        z === "animation-export" && /* @__PURE__ */ D(
          bL,
          {
            onClose: () => L(null),
            onAnimation: ot,
            speed: I,
            tailsVisible: F
          }
        ),
        z === "qr" && /* @__PURE__ */ D(pL, { onClose: () => L(null) })
      ]
    }
  );
}
const fm = (e) => `/${e}`.replace(/\/{2,}/gu, "/").replace(/\/$/u, "") || "/", SL = (e) => {
  const t = fm(e);
  return t === "/" ? "" : t;
}, Jw = (e, t) => {
  const r = fm(e);
  return t ? r === t ? "/" : r.startsWith(`${t}/`) ? fm(r.slice(t.length)) : r : r;
};
function wL(e) {
  return e.theme.mode !== "system" ? e.theme.mode : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function xL(e) {
  const t = Uf(e.storageNamespace, "sailing-theme"), [r, o] = Gn(() => {
    if (e.theme.mode === "system") return wL(e);
    const l = window.localStorage.getItem(t);
    return l === "light" || l === "dark" ? l : e.theme.mode;
  });
  return En(() => {
    if (e.theme.mode !== "system") return;
    const l = window.matchMedia("(prefers-color-scheme: dark)"), u = () => o(l.matches ? "dark" : "light");
    return l.addEventListener("change", u), () => l.removeEventListener("change", u);
  }, [e.theme.mode]), En(() => {
    e.theme.mode !== "system" && o(e.theme.mode);
  }, [e.theme.mode]), En(() => {
    document.documentElement.dataset.theme = r, window.localStorage.setItem(t, r);
  }, [t, r]), { theme: r, setTheme: o };
}
function kL({ context: e }) {
  const { config: t, navigate: r } = e, { t: o } = jn();
  return t.ui.headerLogo ? /* @__PURE__ */ le(
    "button",
    {
      type: "button",
      className: "extension-shell-logo",
      "aria-label": `${o("Back to editor")}: ${t.branding.shortName}`,
      onClick: () => r("/editor"),
      children: [
        /* @__PURE__ */ D("img", { src: t.branding.logo, alt: "", className: "app-logo--on-light", "aria-hidden": "true" }),
        /* @__PURE__ */ D("img", { src: t.branding.logoDark, alt: "", className: "app-logo--on-dark", "aria-hidden": "true" })
      ]
    }
  ) : null;
}
function $w({
  components: e = [],
  context: t
}) {
  return e.map((r, o) => /* @__PURE__ */ D(r, { ...t }, o));
}
function ex({
  children: e,
  context: t,
  extensions: r,
  showFooter: o = !0
}) {
  const l = r.pageFooter ?? r.footer, { theme: u, setTheme: d } = xL(t.config), { language: f, setLanguage: g, t: h } = jn(), v = u === "dark" ? "light" : "dark";
  return /* @__PURE__ */ le(
    "div",
    {
      className: "extension-page-shell",
      style: gx(t.config.theme[u], t.config),
      children: [
        /* @__PURE__ */ le("header", { className: "extension-page-header", children: [
          /* @__PURE__ */ D(kL, { context: t }),
          /* @__PURE__ */ le("div", { className: "extension-header-actions", children: [
            /* @__PURE__ */ le(
              "button",
              {
                type: "button",
                className: "extension-editor-back",
                "aria-label": h("Back to editor"),
                onClick: () => t.navigate("/editor"),
                children: [
                  /* @__PURE__ */ D("span", { "aria-hidden": "true", children: "←" }),
                  /* @__PURE__ */ D("span", { className: "extension-editor-back-label", children: h("Back to editor") })
                ]
              }
            ),
            /* @__PURE__ */ D(
              pr,
              {
                compact: !0,
                icon: u === "dark" ? /* @__PURE__ */ D(lx, {}) : /* @__PURE__ */ D(ox, {}),
                label: h(v === "light" ? "Use light mode" : "Use dark mode"),
                onClick: () => d(v)
              }
            ),
            /* @__PURE__ */ D($w, { components: r.headerActions, context: t }),
            t.config.localization.languageMode === "both" && /* @__PURE__ */ D("div", { className: "language-switch", role: "group", "aria-label": h("Language"), children: ["de", "en"].map((E) => /* @__PURE__ */ D(
              "button",
              {
                type: "button",
                className: f === E ? "is-active" : "",
                "aria-pressed": f === E,
                "aria-label": E === "de" ? "Deutsch" : "English",
                onClick: () => g(E),
                children: E.toUpperCase()
              },
              E
            )) })
          ] }),
          /* @__PURE__ */ D(mx, { items: r.navigationItems ?? [], context: t })
        ] }),
        /* @__PURE__ */ D("main", { className: "extension-page-content", children: e }),
        o && t.config.ui.footer && /* @__PURE__ */ le("footer", { className: "extension-page-footer", children: [
          l ? /* @__PURE__ */ D(l, { ...t }) : /* @__PURE__ */ D("span", { children: t.config.texts.footerText }),
          /* @__PURE__ */ D($w, { components: r.footerExtensions, context: t }),
          t.config.ui.poweredBySailPlot && /* @__PURE__ */ D("span", { children: t.config.texts.poweredByText })
        ] })
      ]
    }
  );
}
function CL({ extensions: e = {} }) {
  var S;
  const t = Zo(), { language: r } = jn(), o = SL(t.routerBasename), [l, u] = Gn(
    () => Jw(window.location.pathname, o)
  );
  En(() => {
    const w = () => u(Jw(window.location.pathname, o));
    return window.addEventListener("popstate", w), () => window.removeEventListener("popstate", w);
  }, [o]), En(() => {
    let w = document.querySelector('link[rel~="icon"]');
    w || (w = document.createElement("link"), w.rel = "icon", document.head.append(w)), w.setAttribute("href", t.branding.favicon);
  }, [t.branding.favicon]);
  const d = (S = e.routes) == null ? void 0 : S.find(
    (w) => fm(w.path) === l
  ), f = t.ui.home && (l === "/home" || l === "/" && t.defaults.startPage === "home"), g = l === "/editor" || l === "/" && t.defaults.startPage === "editor" || !d && !f, h = (w) => {
    var z;
    const T = fm(w), P = g && T !== "/editor" ? new URL(gb(yt.getState().scenario)).hash : window.location.hash;
    window.history.pushState({}, "", `${o}${T}${P}`), u(T), (z = e.onEvent) == null || z.call(e, { type: "navigation", path: T });
  }, v = ta(
    () => ({ config: t, currentPath: l, language: r, navigate: h }),
    // navigate intentionally follows the active basename and extensions for this render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o, t, l, e, r, g]
  );
  if (En(() => {
    var w;
    g || (w = e.onEvent) == null || w.call(e, { type: "route-view", path: l });
  }, [l, e, g]), En(() => {
    if (!(d != null && d.title)) return;
    const w = document.title;
    return document.title = d.title, () => {
      document.title = w;
    };
  }, [d == null ? void 0 : d.title]), g)
    return /* @__PURE__ */ D(_L, { extensions: e, extensionContext: v });
  if (d) {
    const w = d.component;
    return /* @__PURE__ */ D(
      ex,
      {
        context: v,
        extensions: e,
        showFooter: d.footer !== !1,
        children: /* @__PURE__ */ D(w, { ...v })
      }
    );
  }
  const E = e.homeContent;
  return /* @__PURE__ */ D(ex, { context: v, extensions: e, children: /* @__PURE__ */ le("section", { className: "sailplot-welcome", children: [
    /* @__PURE__ */ D("h1", { children: t.texts.welcomeTitle }),
    /* @__PURE__ */ D("p", { children: t.texts.welcomeText }),
    /* @__PURE__ */ D("button", { type: "button", className: "primary-button", onClick: () => h("/editor"), children: t.branding.appName }),
    E && /* @__PURE__ */ D(E, { ...v })
  ] }) });
}
function rO({ config: e, extensions: t }) {
  return /* @__PURE__ */ D(I7, { config: e, children: /* @__PURE__ */ D(q7, { children: /* @__PURE__ */ D(CL, { extensions: t }) }) });
}
export {
  ML as I,
  rO as S,
  I7 as a,
  mx as b,
  q2 as c,
  ux as d,
  vm as g,
  PL as i,
  F7 as m,
  Zo as u
};
